//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v10.9.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

import * as moment from 'moment';

export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');

@Injectable()
export class AccountServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    isTenantAvailable(body: IsTenantAvailableInput | undefined): Observable<IsTenantAvailableOutput> {
        let url_ = this.baseUrl + "/api/services/app/Account/IsTenantAvailable";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIsTenantAvailable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIsTenantAvailable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IsTenantAvailableOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IsTenantAvailableOutput>;
        }));
    }

    protected processIsTenantAvailable(response: HttpResponseBase): Observable<IsTenantAvailableOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IsTenantAvailableOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<IsTenantAvailableOutput>(null as any);
    }

    /**
     * @param storeName (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    isStoreAvailable(storeName: string | undefined, tenantId: number | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Account/IsStoreAvailable?";
        if (storeName === null)
            throw new Error("The parameter 'storeName' cannot be null.");
        else if (storeName !== undefined)
            url_ += "storeName=" + encodeURIComponent("" + storeName) + "&";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIsStoreAvailable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIsStoreAvailable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processIsStoreAvailable(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }
}

@Injectable()
export class AutoserviceServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param keyword (optional) 
     * @param tenantId (optional) 
     * @param storeId (optional) 
     * @return Success
     */
    getProductByVariant(keyword: string | undefined, tenantId: number | undefined, storeId: number | undefined): Observable<ProductInvoiceDto[]> {
        let url_ = this.baseUrl + "/api/Autoservice/GetProductByVariant?";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "keyword=" + encodeURIComponent("" + keyword) + "&";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (storeId === null)
            throw new Error("The parameter 'storeId' cannot be null.");
        else if (storeId !== undefined)
            url_ += "storeId=" + encodeURIComponent("" + storeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProductByVariant(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProductByVariant(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductInvoiceDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductInvoiceDto[]>;
        }));
    }

    protected processGetProductByVariant(response: HttpResponseBase): Observable<ProductInvoiceDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ProductInvoiceDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProductInvoiceDto[]>(null as any);
    }

    /**
     * @param productVariantId (optional) 
     * @param isVariant (optional) 
     * @param storeId (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    getProductWithVariant(productVariantId: number | undefined, isVariant: boolean | undefined, storeId: number | undefined, tenantId: number | undefined): Observable<ProductInvoiceDto> {
        let url_ = this.baseUrl + "/api/Autoservice/GetProductWithVariant?";
        if (productVariantId === null)
            throw new Error("The parameter 'productVariantId' cannot be null.");
        else if (productVariantId !== undefined)
            url_ += "productVariantId=" + encodeURIComponent("" + productVariantId) + "&";
        if (isVariant === null)
            throw new Error("The parameter 'isVariant' cannot be null.");
        else if (isVariant !== undefined)
            url_ += "isVariant=" + encodeURIComponent("" + isVariant) + "&";
        if (storeId === null)
            throw new Error("The parameter 'storeId' cannot be null.");
        else if (storeId !== undefined)
            url_ += "storeId=" + encodeURIComponent("" + storeId) + "&";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProductWithVariant(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProductWithVariant(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductInvoiceDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductInvoiceDto>;
        }));
    }

    protected processGetProductWithVariant(response: HttpResponseBase): Observable<ProductInvoiceDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProductInvoiceDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProductInvoiceDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createAutoserviceDraft(body: AutoserviceDto | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/Autoservice/CreateAutoserviceDraft";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateAutoserviceDraft(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateAutoserviceDraft(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processCreateAutoserviceDraft(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }
}

@Injectable()
export class BankServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: BankDto | undefined): Observable<BankDto> {
        let url_ = this.baseUrl + "/api/services/app/Bank/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BankDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BankDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<BankDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BankDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BankDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: BankDto | undefined): Observable<BankDto> {
        let url_ = this.baseUrl + "/api/services/app/Bank/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BankDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BankDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<BankDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BankDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BankDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Bank/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param keyword (optional) 
     * @param order (optional) 
     * @param orderColumn (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, order: string | undefined, orderColumn: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<BankDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Bank/GetAll?";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (order === null)
            throw new Error("The parameter 'order' cannot be null.");
        else if (order !== undefined)
            url_ += "Order=" + encodeURIComponent("" + order) + "&";
        if (orderColumn === null)
            throw new Error("The parameter 'orderColumn' cannot be null.");
        else if (orderColumn !== undefined)
            url_ += "OrderColumn=" + encodeURIComponent("" + orderColumn) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BankDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BankDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<BankDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BankDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BankDtoPagedResultDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<BankDto> {
        let url_ = this.baseUrl + "/api/services/app/Bank/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BankDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BankDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<BankDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BankDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BankDto>(null as any);
    }
}

@Injectable()
export class BankAccountServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: BankAccountDto | undefined): Observable<BankAccountDto> {
        let url_ = this.baseUrl + "/api/services/app/BankAccount/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BankAccountDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BankAccountDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<BankAccountDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BankAccountDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BankAccountDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: BankAccountDto | undefined): Observable<BankAccountDto> {
        let url_ = this.baseUrl + "/api/services/app/BankAccount/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BankAccountDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BankAccountDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<BankAccountDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BankAccountDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BankAccountDto>(null as any);
    }

    /**
     * @return Success
     */
    getAllPaywayBankAccounts(): Observable<BankAccountDto[]> {
        let url_ = this.baseUrl + "/api/services/app/BankAccount/GetAllPaywayBankAccounts";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllPaywayBankAccounts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllPaywayBankAccounts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BankAccountDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BankAccountDto[]>;
        }));
    }

    protected processGetAllPaywayBankAccounts(response: HttpResponseBase): Observable<BankAccountDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(BankAccountDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BankAccountDto[]>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<BankAccountDto> {
        let url_ = this.baseUrl + "/api/services/app/BankAccount/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BankAccountDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BankAccountDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<BankAccountDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BankAccountDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BankAccountDto>(null as any);
    }

    /**
     * @param keyword (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<BankAccountDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/BankAccount/GetAll?";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BankAccountDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BankAccountDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<BankAccountDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BankAccountDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BankAccountDtoPagedResultDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/BankAccount/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class BinesServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param keyword (optional) 
     * @param bankId (optional) 
     * @param companyId (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, bankId: number | undefined, companyId: number | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<BinDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Bines/GetAll?";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (bankId === null)
            throw new Error("The parameter 'bankId' cannot be null.");
        else if (bankId !== undefined)
            url_ += "BankId=" + encodeURIComponent("" + bankId) + "&";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "CompanyId=" + encodeURIComponent("" + companyId) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BinDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BinDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<BinDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BinDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BinDtoPagedResultDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: BinDto | undefined): Observable<BinDto> {
        let url_ = this.baseUrl + "/api/services/app/Bines/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BinDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BinDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<BinDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BinDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BinDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: BinDto | undefined): Observable<BinDto> {
        let url_ = this.baseUrl + "/api/services/app/Bines/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BinDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BinDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<BinDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BinDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BinDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Bines/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    getBanks(): Observable<BankDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Bines/GetBanks";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBanks(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBanks(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BankDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BankDto[]>;
        }));
    }

    protected processGetBanks(response: HttpResponseBase): Observable<BankDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(BankDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BankDto[]>(null as any);
    }

    /**
     * @return Success
     */
    getCompanies(): Observable<CompanyDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Bines/GetCompanies";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCompanies(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCompanies(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CompanyDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CompanyDto[]>;
        }));
    }

    protected processGetCompanies(response: HttpResponseBase): Observable<CompanyDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(CompanyDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CompanyDto[]>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<BinDto> {
        let url_ = this.baseUrl + "/api/services/app/Bines/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BinDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BinDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<BinDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BinDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BinDto>(null as any);
    }
}

@Injectable()
export class CashierServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateCashierInputDto | undefined): Observable<CashierDto> {
        let url_ = this.baseUrl + "/api/services/app/Cashier/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CashierDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CashierDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<CashierDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CashierDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CashierDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createFromApi(body: CreateCashierFromApiDto | undefined): Observable<CreateCashierFromApiDto> {
        let url_ = this.baseUrl + "/api/services/app/Cashier/CreateFromApi";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateFromApi(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateFromApi(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateCashierFromApiDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateCashierFromApiDto>;
        }));
    }

    protected processCreateFromApi(response: HttpResponseBase): Observable<CreateCashierFromApiDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateCashierFromApiDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CreateCashierFromApiDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateCashierInputDto | undefined): Observable<CashierDto> {
        let url_ = this.baseUrl + "/api/services/app/Cashier/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CashierDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CashierDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<CashierDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CashierDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CashierDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Cashier/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    getSalePoints(): Observable<SalePointInvoiceDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Cashier/GetSalePoints";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSalePoints(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSalePoints(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SalePointInvoiceDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SalePointInvoiceDto[]>;
        }));
    }

    protected processGetSalePoints(response: HttpResponseBase): Observable<SalePointInvoiceDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(SalePointInvoiceDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SalePointInvoiceDto[]>(null as any);
    }

    /**
     * @param keyword (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<CashierDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Cashier/GetAll?";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CashierDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CashierDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<CashierDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CashierDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CashierDtoPagedResultDto>(null as any);
    }

    /**
     * @param keyword (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllCashiersForList(keyword: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<CashierListDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Cashier/GetAllCashiersForList?";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllCashiersForList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllCashiersForList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CashierListDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CashierListDtoPagedResultDto>;
        }));
    }

    protected processGetAllCashiersForList(response: HttpResponseBase): Observable<CashierListDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CashierListDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CashierListDtoPagedResultDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<CashierDto> {
        let url_ = this.baseUrl + "/api/services/app/Cashier/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CashierDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CashierDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<CashierDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CashierDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CashierDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    inOut(body: TransactionInOutDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Cashier/InOut";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processInOut(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInOut(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processInOut(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    getAllCurrencies(): Observable<CurrencySelectDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Cashier/GetAllCurrencies";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllCurrencies(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllCurrencies(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CurrencySelectDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CurrencySelectDto[]>;
        }));
    }

    protected processGetAllCurrencies(response: HttpResponseBase): Observable<CurrencySelectDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(CurrencySelectDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CurrencySelectDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    returnBoxMainData(body: CashFilterDto | undefined): Observable<CashierInfoDto> {
        let url_ = this.baseUrl + "/api/services/app/Cashier/ReturnBoxMainData";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReturnBoxMainData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReturnBoxMainData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CashierInfoDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CashierInfoDto>;
        }));
    }

    protected processReturnBoxMainData(response: HttpResponseBase): Observable<CashierInfoDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CashierInfoDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CashierInfoDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    cashOpenClose(body: CashOpenDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Cashier/CashOpenClose";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCashOpenClose(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCashOpenClose(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCashOpenClose(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    getAllSupervisor(): Observable<UserSupervisorDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Cashier/GetAllSupervisor";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllSupervisor(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllSupervisor(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserSupervisorDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserSupervisorDto[]>;
        }));
    }

    protected processGetAllSupervisor(response: HttpResponseBase): Observable<UserSupervisorDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(UserSupervisorDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserSupervisorDto[]>(null as any);
    }

    /**
     * @param name (optional) 
     * @return Success
     */
    getProviderPayment(name: string | undefined): Observable<PPaymentsInvoiceDto> {
        let url_ = this.baseUrl + "/api/services/app/Cashier/GetProviderPayment?";
        if (name === null)
            throw new Error("The parameter 'name' cannot be null.");
        else if (name !== undefined)
            url_ += "name=" + encodeURIComponent("" + name) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProviderPayment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProviderPayment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PPaymentsInvoiceDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PPaymentsInvoiceDto>;
        }));
    }

    protected processGetProviderPayment(response: HttpResponseBase): Observable<PPaymentsInvoiceDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PPaymentsInvoiceDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PPaymentsInvoiceDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    cashTransactionInfo(body: CashFilterDto | undefined): Observable<CashTransactionInfoDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Cashier/CashTransactionInfo";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCashTransactionInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCashTransactionInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CashTransactionInfoDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CashTransactionInfoDto[]>;
        }));
    }

    protected processCashTransactionInfo(response: HttpResponseBase): Observable<CashTransactionInfoDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(CashTransactionInfoDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CashTransactionInfoDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    cashMovementsReport(body: CashReportFilterDto | undefined): Observable<CashReportDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Cashier/CashMovementsReport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCashMovementsReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCashMovementsReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CashReportDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CashReportDto[]>;
        }));
    }

    protected processCashMovementsReport(response: HttpResponseBase): Observable<CashReportDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(CashReportDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CashReportDto[]>(null as any);
    }

    /**
     * @param keyword (optional) 
     * @param storeId (optional) 
     * @param cashierId (optional) 
     * @param from (optional) 
     * @param to (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllCashMovements(keyword: string | undefined, storeId: number | undefined, cashierId: number | undefined, from: moment.Moment | undefined, to: moment.Moment | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<CashMovementDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Cashier/GetAllCashMovements?";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (storeId === null)
            throw new Error("The parameter 'storeId' cannot be null.");
        else if (storeId !== undefined)
            url_ += "StoreId=" + encodeURIComponent("" + storeId) + "&";
        if (cashierId === null)
            throw new Error("The parameter 'cashierId' cannot be null.");
        else if (cashierId !== undefined)
            url_ += "CashierId=" + encodeURIComponent("" + cashierId) + "&";
        if (from === null)
            throw new Error("The parameter 'from' cannot be null.");
        else if (from !== undefined)
            url_ += "From=" + encodeURIComponent(from ? "" + from.toISOString() : "") + "&";
        if (to === null)
            throw new Error("The parameter 'to' cannot be null.");
        else if (to !== undefined)
            url_ += "To=" + encodeURIComponent(to ? "" + to.toISOString() : "") + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllCashMovements(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllCashMovements(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CashMovementDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CashMovementDtoPagedResultDto>;
        }));
    }

    protected processGetAllCashMovements(response: HttpResponseBase): Observable<CashMovementDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CashMovementDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CashMovementDtoPagedResultDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    setProcessedTransactions(body: number[] | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Cashier/SetProcessedTransactions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetProcessedTransactions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetProcessedTransactions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSetProcessedTransactions(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class ClientServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: ClientDto | undefined): Observable<ClientDto> {
        let url_ = this.baseUrl + "/api/services/app/Client/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClientDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClientDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<ClientDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClientDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ClientDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: ClientDto | undefined): Observable<ClientDto> {
        let url_ = this.baseUrl + "/api/services/app/Client/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClientDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClientDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<ClientDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClientDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ClientDto>(null as any);
    }

    /**
     * @return Success
     */
    getTaxConditionTypes(): Observable<EnumDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Client/GetTaxConditionTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTaxConditionTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTaxConditionTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EnumDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EnumDto[]>;
        }));
    }

    protected processGetTaxConditionTypes(response: HttpResponseBase): Observable<EnumDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(EnumDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<EnumDto[]>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Client/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param keyword (optional) 
     * @param order (optional) 
     * @param orderColumn (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, order: string | undefined, orderColumn: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<ClientDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Client/GetAll?";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (order === null)
            throw new Error("The parameter 'order' cannot be null.");
        else if (order !== undefined)
            url_ += "Order=" + encodeURIComponent("" + order) + "&";
        if (orderColumn === null)
            throw new Error("The parameter 'orderColumn' cannot be null.");
        else if (orderColumn !== undefined)
            url_ += "OrderColumn=" + encodeURIComponent("" + orderColumn) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClientDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClientDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<ClientDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClientDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ClientDtoPagedResultDto>(null as any);
    }

    /**
     * @param keyword (optional) 
     * @param order (optional) 
     * @param orderColumn (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllClientsForList(keyword: string | undefined, order: string | undefined, orderColumn: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<ClientListDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Client/GetAllClientsForList?";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (order === null)
            throw new Error("The parameter 'order' cannot be null.");
        else if (order !== undefined)
            url_ += "Order=" + encodeURIComponent("" + order) + "&";
        if (orderColumn === null)
            throw new Error("The parameter 'orderColumn' cannot be null.");
        else if (orderColumn !== undefined)
            url_ += "OrderColumn=" + encodeURIComponent("" + orderColumn) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllClientsForList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllClientsForList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClientListDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClientListDtoPagedResultDto>;
        }));
    }

    protected processGetAllClientsForList(response: HttpResponseBase): Observable<ClientListDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClientListDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ClientListDtoPagedResultDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<ClientDto> {
        let url_ = this.baseUrl + "/api/services/app/Client/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClientDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClientDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ClientDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClientDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ClientDto>(null as any);
    }

    /**
     * @return Success
     */
    getAllLoyaltyCategories(): Observable<LoyaltyCategoryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Client/GetAllLoyaltyCategories";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllLoyaltyCategories(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllLoyaltyCategories(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LoyaltyCategoryDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LoyaltyCategoryDto[]>;
        }));
    }

    protected processGetAllLoyaltyCategories(response: HttpResponseBase): Observable<LoyaltyCategoryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(LoyaltyCategoryDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LoyaltyCategoryDto[]>(null as any);
    }

    /**
     * @return Success
     */
    getRelationshipType(): Observable<EnumDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Client/GetRelationshipType";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRelationshipType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRelationshipType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EnumDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EnumDto[]>;
        }));
    }

    protected processGetRelationshipType(response: HttpResponseBase): Observable<EnumDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(EnumDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<EnumDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createRelationship(body: RelationshipDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Client/CreateRelationship";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateRelationship(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateRelationship(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateRelationship(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    changeClientLoyaltyCategory(body: ChangeClientLoyaltyCategoryDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Client/ChangeClientLoyaltyCategory";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangeClientLoyaltyCategory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangeClientLoyaltyCategory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processChangeClientLoyaltyCategory(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class ColorServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: ColorDto | undefined): Observable<ColorDto> {
        let url_ = this.baseUrl + "/api/services/app/Color/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ColorDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ColorDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<ColorDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ColorDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ColorDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: ColorDto | undefined): Observable<ColorDto> {
        let url_ = this.baseUrl + "/api/services/app/Color/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ColorDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ColorDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<ColorDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ColorDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ColorDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Color/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param colorId (optional) 
     * @return Success
     */
    checkHowManyAssociatedVariants(colorId: number | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Color/CheckHowManyAssociatedVariants?";
        if (colorId === null)
            throw new Error("The parameter 'colorId' cannot be null.");
        else if (colorId !== undefined)
            url_ += "colorId=" + encodeURIComponent("" + colorId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckHowManyAssociatedVariants(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckHowManyAssociatedVariants(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCheckHowManyAssociatedVariants(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<ColorDto> {
        let url_ = this.baseUrl + "/api/services/app/Color/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ColorDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ColorDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ColorDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ColorDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ColorDto>(null as any);
    }

    /**
     * @param keyword (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<ColorDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Color/GetAll?";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ColorDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ColorDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<ColorDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ColorDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ColorDtoPagedResultDto>(null as any);
    }
}

@Injectable()
export class CompanyServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CompanyDto | undefined): Observable<CompanyDto> {
        let url_ = this.baseUrl + "/api/services/app/Company/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CompanyDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CompanyDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<CompanyDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CompanyDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CompanyDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: CompanyDto | undefined): Observable<CompanyDto> {
        let url_ = this.baseUrl + "/api/services/app/Company/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CompanyDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CompanyDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<CompanyDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CompanyDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CompanyDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Company/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    getAllStores(): Observable<StoreDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Company/GetAllStores";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllStores(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllStores(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StoreDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StoreDto[]>;
        }));
    }

    protected processGetAllStores(response: HttpResponseBase): Observable<StoreDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(StoreDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<StoreDto[]>(null as any);
    }

    /**
     * @return Success
     */
    getAllCompanies(): Observable<CompanyDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Company/GetAllCompanies";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllCompanies(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllCompanies(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CompanyDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CompanyDto[]>;
        }));
    }

    protected processGetAllCompanies(response: HttpResponseBase): Observable<CompanyDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(CompanyDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CompanyDto[]>(null as any);
    }

    /**
     * @param keyword (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllCompaniesForList(keyword: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<CompanyListDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Company/GetAllCompaniesForList?";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllCompaniesForList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllCompaniesForList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CompanyListDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CompanyListDtoPagedResultDto>;
        }));
    }

    protected processGetAllCompaniesForList(response: HttpResponseBase): Observable<CompanyListDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CompanyListDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CompanyListDtoPagedResultDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<CompanyDto> {
        let url_ = this.baseUrl + "/api/services/app/Company/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CompanyDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CompanyDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<CompanyDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CompanyDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CompanyDto>(null as any);
    }

    /**
     * @param keyword (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<CompanyDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Company/GetAll?";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CompanyDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CompanyDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<CompanyDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CompanyDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CompanyDtoPagedResultDto>(null as any);
    }
}

@Injectable()
export class ConfigurationServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    changeUiTheme(body: ChangeUiThemeInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Configuration/ChangeUiTheme";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangeUiTheme(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangeUiTheme(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processChangeUiTheme(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param newTenancyName (optional) 
     * @param body (optional) 
     * @return Success
     */
    update(newTenancyName: string | undefined, body: SettingValueDto[] | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Configuration/Update?";
        if (newTenancyName === null)
            throw new Error("The parameter 'newTenancyName' cannot be null.");
        else if (newTenancyName !== undefined)
            url_ += "newTenancyName=" + encodeURIComponent("" + newTenancyName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    get(input: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Configuration/Get?";
        if (input === null)
            throw new Error("The parameter 'input' cannot be null.");
        else if (input !== undefined)
            url_ += "input=" + encodeURIComponent("" + input) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    /**
     * @param inputs (optional) 
     * @return Success
     */
    getAll(inputs: string[] | undefined): Observable<{ [key: string]: string; }> {
        let url_ = this.baseUrl + "/api/services/app/Configuration/GetAll?";
        if (inputs === null)
            throw new Error("The parameter 'inputs' cannot be null.");
        else if (inputs !== undefined)
            inputs && inputs.forEach(item => { url_ += "inputs=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<{ [key: string]: string; }>;
                }
            } else
                return _observableThrow(response_) as any as Observable<{ [key: string]: string; }>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<{ [key: string]: string; }> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                result200 = {} as any;
                for (let key in resultData200) {
                    if (resultData200.hasOwnProperty(key))
                        (<any>result200)[key] = resultData200[key] !== undefined ? resultData200[key] : <any>null;
                }
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<{ [key: string]: string; }>(null as any);
    }

    /**
     * @return Success
     */
    getGroupAttributtesId(): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Configuration/GetGroupAttributtesId";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetGroupAttributtesId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGroupAttributtesId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGetGroupAttributtesId(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    /**
     * @return Success
     */
    getAllGroup(): Observable<ProductGroupDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Configuration/GetAllGroup";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllGroup(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllGroup(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductGroupDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductGroupDto[]>;
        }));
    }

    protected processGetAllGroup(response: HttpResponseBase): Observable<ProductGroupDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ProductGroupDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProductGroupDto[]>(null as any);
    }

    /**
     * @return Success
     */
    getTaxConditionTypes(): Observable<EnumDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Configuration/GetTaxConditionTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTaxConditionTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTaxConditionTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EnumDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EnumDto[]>;
        }));
    }

    protected processGetTaxConditionTypes(response: HttpResponseBase): Observable<EnumDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(EnumDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<EnumDto[]>(null as any);
    }

    /**
     * @return Success
     */
    getProductNameStyle(): Observable<EnumDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Configuration/GetProductNameStyle";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProductNameStyle(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProductNameStyle(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EnumDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EnumDto[]>;
        }));
    }

    protected processGetProductNameStyle(response: HttpResponseBase): Observable<EnumDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(EnumDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<EnumDto[]>(null as any);
    }

    /**
     * @return Success
     */
    getIrsaCredentials(): Observable<IrsaCredentialsDto> {
        let url_ = this.baseUrl + "/api/services/app/Configuration/GetIrsaCredentials";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetIrsaCredentials(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetIrsaCredentials(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IrsaCredentialsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IrsaCredentialsDto>;
        }));
    }

    protected processGetIrsaCredentials(response: HttpResponseBase): Observable<IrsaCredentialsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IrsaCredentialsDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<IrsaCredentialsDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    saveIrsaCredentials(body: IrsaCredentialsDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Configuration/SaveIrsaCredentials";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveIrsaCredentials(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveIrsaCredentials(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSaveIrsaCredentials(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class CurrencyServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CurrencyDto | undefined): Observable<CurrencyDto> {
        let url_ = this.baseUrl + "/api/services/app/Currency/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CurrencyDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CurrencyDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<CurrencyDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CurrencyDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CurrencyDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: CurrencyDto | undefined): Observable<CurrencyDto> {
        let url_ = this.baseUrl + "/api/services/app/Currency/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CurrencyDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CurrencyDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<CurrencyDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CurrencyDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CurrencyDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<CurrencyDto> {
        let url_ = this.baseUrl + "/api/services/app/Currency/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CurrencyDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CurrencyDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<CurrencyDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CurrencyDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CurrencyDto>(null as any);
    }

    /**
     * @param keyword (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<CurrencyDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Currency/GetAll?";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CurrencyDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CurrencyDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<CurrencyDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CurrencyDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CurrencyDtoPagedResultDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Currency/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class DiscountServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: DiscountDto | undefined): Observable<DiscountDto> {
        let url_ = this.baseUrl + "/api/services/app/Discount/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DiscountDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DiscountDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<DiscountDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DiscountDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DiscountDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Discount/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param keyword (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined): Observable<DiscountDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Discount/GetAll?";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DiscountDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DiscountDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<DiscountDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DiscountDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DiscountDtoPagedResultDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<DiscountDto> {
        let url_ = this.baseUrl + "/api/services/app/Discount/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DiscountDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DiscountDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<DiscountDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DiscountDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DiscountDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: DiscountDto | undefined): Observable<DiscountDto> {
        let url_ = this.baseUrl + "/api/services/app/Discount/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DiscountDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DiscountDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<DiscountDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DiscountDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DiscountDto>(null as any);
    }

    /**
     * @return Success
     */
    allDiscounts(): Observable<DiscountDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Discount/AllDiscounts";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAllDiscounts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAllDiscounts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DiscountDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DiscountDto[]>;
        }));
    }

    protected processAllDiscounts(response: HttpResponseBase): Observable<DiscountDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(DiscountDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DiscountDto[]>(null as any);
    }
}

@Injectable()
export class EcommerceServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getMercadoLibreConfiguration(): Observable<MercadoLibreConfigurationDto> {
        let url_ = this.baseUrl + "/api/services/app/Ecommerce/GetMercadoLibreConfiguration";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMercadoLibreConfiguration(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMercadoLibreConfiguration(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MercadoLibreConfigurationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MercadoLibreConfigurationDto>;
        }));
    }

    protected processGetMercadoLibreConfiguration(response: HttpResponseBase): Observable<MercadoLibreConfigurationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MercadoLibreConfigurationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MercadoLibreConfigurationDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateMercadoLibreConfiguration(body: MercadoLibreConfigurationDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Ecommerce/UpdateMercadoLibreConfiguration";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateMercadoLibreConfiguration(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateMercadoLibreConfiguration(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateMercadoLibreConfiguration(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    refreshMercadoLibreAccessToken(): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Ecommerce/RefreshMercadoLibreAccessToken";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRefreshMercadoLibreAccessToken(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRefreshMercadoLibreAccessToken(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processRefreshMercadoLibreAccessToken(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    /**
     * @param status (optional) 
     * @param dateFrom (optional) 
     * @param dateTo (optional) 
     * @param userId (optional) 
     * @param isDelivered (optional) 
     * @return Success
     */
    getMercadoLibreOrders(status: string | undefined, dateFrom: moment.Moment | undefined, dateTo: moment.Moment | undefined, userId: number | undefined, isDelivered: boolean | undefined): Observable<MercadoLibreOrderDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Ecommerce/GetMercadoLibreOrders?";
        if (status === null)
            throw new Error("The parameter 'status' cannot be null.");
        else if (status !== undefined)
            url_ += "Status=" + encodeURIComponent("" + status) + "&";
        if (dateFrom === null)
            throw new Error("The parameter 'dateFrom' cannot be null.");
        else if (dateFrom !== undefined)
            url_ += "DateFrom=" + encodeURIComponent(dateFrom ? "" + dateFrom.toISOString() : "") + "&";
        if (dateTo === null)
            throw new Error("The parameter 'dateTo' cannot be null.");
        else if (dateTo !== undefined)
            url_ += "DateTo=" + encodeURIComponent(dateTo ? "" + dateTo.toISOString() : "") + "&";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (isDelivered === null)
            throw new Error("The parameter 'isDelivered' cannot be null.");
        else if (isDelivered !== undefined)
            url_ += "IsDelivered=" + encodeURIComponent("" + isDelivered) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMercadoLibreOrders(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMercadoLibreOrders(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MercadoLibreOrderDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MercadoLibreOrderDto[]>;
        }));
    }

    protected processGetMercadoLibreOrders(response: HttpResponseBase): Observable<MercadoLibreOrderDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(MercadoLibreOrderDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MercadoLibreOrderDto[]>(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @param body (optional) 
     * @return Success
     */
    mapOrdersWithInvoiceData(tenantId: number | undefined, body: number[] | undefined): Observable<MercadoLibreOrderDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Ecommerce/MapOrdersWithInvoiceData?";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMapOrdersWithInvoiceData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMapOrdersWithInvoiceData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MercadoLibreOrderDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MercadoLibreOrderDto[]>;
        }));
    }

    protected processMapOrdersWithInvoiceData(response: HttpResponseBase): Observable<MercadoLibreOrderDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(MercadoLibreOrderDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MercadoLibreOrderDto[]>(null as any);
    }

    /**
     * @param orderId (optional) 
     * @return Success
     */
    markOrderAsDelivered(orderId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Ecommerce/MarkOrderAsDelivered?";
        if (orderId === null)
            throw new Error("The parameter 'orderId' cannot be null.");
        else if (orderId !== undefined)
            url_ += "orderId=" + encodeURIComponent("" + orderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMarkOrderAsDelivered(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMarkOrderAsDelivered(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processMarkOrderAsDelivered(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param status (optional) 
     * @param dateFrom (optional) 
     * @param dateTo (optional) 
     * @param userId (optional) 
     * @param isDelivered (optional) 
     * @return Success
     */
    getMappedMercadoLibreOrders(status: string | undefined, dateFrom: moment.Moment | undefined, dateTo: moment.Moment | undefined, userId: number | undefined, isDelivered: boolean | undefined): Observable<InvoiceDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Ecommerce/GetMappedMercadoLibreOrders?";
        if (status === null)
            throw new Error("The parameter 'status' cannot be null.");
        else if (status !== undefined)
            url_ += "Status=" + encodeURIComponent("" + status) + "&";
        if (dateFrom === null)
            throw new Error("The parameter 'dateFrom' cannot be null.");
        else if (dateFrom !== undefined)
            url_ += "DateFrom=" + encodeURIComponent(dateFrom ? "" + dateFrom.toISOString() : "") + "&";
        if (dateTo === null)
            throw new Error("The parameter 'dateTo' cannot be null.");
        else if (dateTo !== undefined)
            url_ += "DateTo=" + encodeURIComponent(dateTo ? "" + dateTo.toISOString() : "") + "&";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (isDelivered === null)
            throw new Error("The parameter 'isDelivered' cannot be null.");
        else if (isDelivered !== undefined)
            url_ += "IsDelivered=" + encodeURIComponent("" + isDelivered) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMappedMercadoLibreOrders(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMappedMercadoLibreOrders(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InvoiceDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InvoiceDto[]>;
        }));
    }

    protected processGetMappedMercadoLibreOrders(response: HttpResponseBase): Observable<InvoiceDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(InvoiceDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<InvoiceDto[]>(null as any);
    }

    /**
     * @param productId (optional) 
     * @param variantId (optional) 
     * @return Success
     */
    updateMercadoLibrePriceFromVariant(productId: number | undefined, variantId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Ecommerce/UpdateMercadoLibrePriceFromVariant?";
        if (productId === null)
            throw new Error("The parameter 'productId' cannot be null.");
        else if (productId !== undefined)
            url_ += "productId=" + encodeURIComponent("" + productId) + "&";
        if (variantId === null)
            throw new Error("The parameter 'variantId' cannot be null.");
        else if (variantId !== undefined)
            url_ += "variantId=" + encodeURIComponent("" + variantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateMercadoLibrePriceFromVariant(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateMercadoLibrePriceFromVariant(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateMercadoLibrePriceFromVariant(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    getMercadoLibrePublications(): Observable<MercadoLibrePublicationDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Ecommerce/GetMercadoLibrePublications";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMercadoLibrePublications(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMercadoLibrePublications(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MercadoLibrePublicationDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MercadoLibrePublicationDto[]>;
        }));
    }

    protected processGetMercadoLibrePublications(response: HttpResponseBase): Observable<MercadoLibrePublicationDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(MercadoLibrePublicationDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MercadoLibrePublicationDto[]>(null as any);
    }

    /**
     * @return Success
     */
    getMercadoLibreLinkedProducts(): Observable<MercadoLibreProductDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Ecommerce/GetMercadoLibreLinkedProducts";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMercadoLibreLinkedProducts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMercadoLibreLinkedProducts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MercadoLibreProductDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MercadoLibreProductDto[]>;
        }));
    }

    protected processGetMercadoLibreLinkedProducts(response: HttpResponseBase): Observable<MercadoLibreProductDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(MercadoLibreProductDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MercadoLibreProductDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    linkMercadoLibreProductBulk(body: LinkMercadoLibreProductInputDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Ecommerce/LinkMercadoLibreProductBulk";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLinkMercadoLibreProductBulk(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLinkMercadoLibreProductBulk(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processLinkMercadoLibreProductBulk(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param ecommerceProductId (optional) 
     * @return Success
     */
    unlinkMercadoLibreProduct(ecommerceProductId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Ecommerce/UnlinkMercadoLibreProduct?";
        if (ecommerceProductId === null)
            throw new Error("The parameter 'ecommerceProductId' cannot be null.");
        else if (ecommerceProductId !== undefined)
            url_ += "ecommerceProductId=" + encodeURIComponent("" + ecommerceProductId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUnlinkMercadoLibreProduct(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUnlinkMercadoLibreProduct(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUnlinkMercadoLibreProduct(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param productId (optional) 
     * @param variantId (optional) 
     * @return Success
     */
    updateMercadoLibreStockFromVariant(productId: number | undefined, variantId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Ecommerce/UpdateMercadoLibreStockFromVariant?";
        if (productId === null)
            throw new Error("The parameter 'productId' cannot be null.");
        else if (productId !== undefined)
            url_ += "productId=" + encodeURIComponent("" + productId) + "&";
        if (variantId === null)
            throw new Error("The parameter 'variantId' cannot be null.");
        else if (variantId !== undefined)
            url_ += "variantId=" + encodeURIComponent("" + variantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateMercadoLibreStockFromVariant(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateMercadoLibreStockFromVariant(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateMercadoLibreStockFromVariant(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    getMercadoLibrePromotions(): Observable<MercadoLibrePromotionDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Ecommerce/GetMercadoLibrePromotions";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMercadoLibrePromotions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMercadoLibrePromotions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MercadoLibrePromotionDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MercadoLibrePromotionDto[]>;
        }));
    }

    protected processGetMercadoLibrePromotions(response: HttpResponseBase): Observable<MercadoLibrePromotionDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(MercadoLibrePromotionDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MercadoLibrePromotionDto[]>(null as any);
    }

    /**
     * @param fromDate (optional) 
     * @param limit (optional) 
     * @param offset (optional) 
     * @param fetchAllPages (optional) 
     * @return Success
     */
    getMercadoLibrePaidOrders(fromDate: moment.Moment | undefined, limit: number | undefined, offset: number | undefined, fetchAllPages: boolean | undefined): Observable<MercadoLibreOrderDetailDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Ecommerce/GetMercadoLibrePaidOrders?";
        if (fromDate === null)
            throw new Error("The parameter 'fromDate' cannot be null.");
        else if (fromDate !== undefined)
            url_ += "fromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toISOString() : "") + "&";
        if (limit === null)
            throw new Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "limit=" + encodeURIComponent("" + limit) + "&";
        if (offset === null)
            throw new Error("The parameter 'offset' cannot be null.");
        else if (offset !== undefined)
            url_ += "offset=" + encodeURIComponent("" + offset) + "&";
        if (fetchAllPages === null)
            throw new Error("The parameter 'fetchAllPages' cannot be null.");
        else if (fetchAllPages !== undefined)
            url_ += "fetchAllPages=" + encodeURIComponent("" + fetchAllPages) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMercadoLibrePaidOrders(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMercadoLibrePaidOrders(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MercadoLibreOrderDetailDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MercadoLibreOrderDetailDto[]>;
        }));
    }

    protected processGetMercadoLibrePaidOrders(response: HttpResponseBase): Observable<MercadoLibreOrderDetailDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(MercadoLibreOrderDetailDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MercadoLibreOrderDetailDto[]>(null as any);
    }

    /**
     * @return Success
     */
    getMercadoLibrePendingOrders(): Observable<MercadoLibreOrderDetailDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Ecommerce/GetMercadoLibrePendingOrders";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMercadoLibrePendingOrders(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMercadoLibrePendingOrders(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MercadoLibreOrderDetailDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MercadoLibreOrderDetailDto[]>;
        }));
    }

    protected processGetMercadoLibrePendingOrders(response: HttpResponseBase): Observable<MercadoLibreOrderDetailDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(MercadoLibreOrderDetailDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MercadoLibreOrderDetailDto[]>(null as any);
    }

    /**
     * @param orderId (optional) 
     * @return Success
     */
    getMercadoLibreOrderById(orderId: number | undefined): Observable<MercadoLibreOrderDetailDto> {
        let url_ = this.baseUrl + "/api/services/app/Ecommerce/GetMercadoLibreOrderById?";
        if (orderId === null)
            throw new Error("The parameter 'orderId' cannot be null.");
        else if (orderId !== undefined)
            url_ += "orderId=" + encodeURIComponent("" + orderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMercadoLibreOrderById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMercadoLibreOrderById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MercadoLibreOrderDetailDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MercadoLibreOrderDetailDto>;
        }));
    }

    protected processGetMercadoLibreOrderById(response: HttpResponseBase): Observable<MercadoLibreOrderDetailDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MercadoLibreOrderDetailDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MercadoLibreOrderDetailDto>(null as any);
    }

    /**
     * @param packId (optional) 
     * @return Success
     */
    getMercadoLibreOrdersByPackId(packId: string | undefined): Observable<MercadoLibrePackDto> {
        let url_ = this.baseUrl + "/api/services/app/Ecommerce/GetMercadoLibreOrdersByPackId?";
        if (packId === null)
            throw new Error("The parameter 'packId' cannot be null.");
        else if (packId !== undefined)
            url_ += "packId=" + encodeURIComponent("" + packId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMercadoLibreOrdersByPackId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMercadoLibreOrdersByPackId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MercadoLibrePackDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MercadoLibrePackDto>;
        }));
    }

    protected processGetMercadoLibreOrdersByPackId(response: HttpResponseBase): Observable<MercadoLibrePackDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MercadoLibrePackDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MercadoLibrePackDto>(null as any);
    }

    /**
     * @param billingInfoId (optional) 
     * @param siteId (optional) 
     * @return Success
     */
    getMercadoLibreBillingInfo(billingInfoId: number | undefined, siteId: string | undefined): Observable<MercadoLibreBillingInfoDto> {
        let url_ = this.baseUrl + "/api/services/app/Ecommerce/GetMercadoLibreBillingInfo?";
        if (billingInfoId === null)
            throw new Error("The parameter 'billingInfoId' cannot be null.");
        else if (billingInfoId !== undefined)
            url_ += "billingInfoId=" + encodeURIComponent("" + billingInfoId) + "&";
        if (siteId === null)
            throw new Error("The parameter 'siteId' cannot be null.");
        else if (siteId !== undefined)
            url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMercadoLibreBillingInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMercadoLibreBillingInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MercadoLibreBillingInfoDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MercadoLibreBillingInfoDto>;
        }));
    }

    protected processGetMercadoLibreBillingInfo(response: HttpResponseBase): Observable<MercadoLibreBillingInfoDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MercadoLibreBillingInfoDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MercadoLibreBillingInfoDto>(null as any);
    }

    /**
     * @param mlOrderId (optional) 
     * @return Success
     */
    emitMercadoLibreInvoice(mlOrderId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Ecommerce/EmitMercadoLibreInvoice?";
        if (mlOrderId === null)
            throw new Error("The parameter 'mlOrderId' cannot be null.");
        else if (mlOrderId !== undefined)
            url_ += "mlOrderId=" + encodeURIComponent("" + mlOrderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEmitMercadoLibreInvoice(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEmitMercadoLibreInvoice(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processEmitMercadoLibreInvoice(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param mlOrderId (optional) 
     * @return Success
     */
    getInvoiceIdByMercadoLibreOrderId(mlOrderId: number | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Ecommerce/GetInvoiceIdByMercadoLibreOrderId?";
        if (mlOrderId === null)
            throw new Error("The parameter 'mlOrderId' cannot be null.");
        else if (mlOrderId !== undefined)
            url_ += "mlOrderId=" + encodeURIComponent("" + mlOrderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetInvoiceIdByMercadoLibreOrderId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetInvoiceIdByMercadoLibreOrderId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGetInvoiceIdByMercadoLibreOrderId(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    /**
     * @param productId (optional) 
     * @param variantId (optional) 
     * @return Success
     */
    getProductPriceAndStockInformation(productId: number | undefined, variantId: number | undefined): Observable<{ [key: string]: any; }> {
        let url_ = this.baseUrl + "/api/services/app/Ecommerce/GetProductPriceAndStockInformation?";
        if (productId === null)
            throw new Error("The parameter 'productId' cannot be null.");
        else if (productId !== undefined)
            url_ += "productId=" + encodeURIComponent("" + productId) + "&";
        if (variantId === null)
            throw new Error("The parameter 'variantId' cannot be null.");
        else if (variantId !== undefined)
            url_ += "variantId=" + encodeURIComponent("" + variantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProductPriceAndStockInformation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProductPriceAndStockInformation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<{ [key: string]: any; }>;
                }
            } else
                return _observableThrow(response_) as any as Observable<{ [key: string]: any; }>;
        }));
    }

    protected processGetProductPriceAndStockInformation(response: HttpResponseBase): Observable<{ [key: string]: any; }> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                result200 = {} as any;
                for (let key in resultData200) {
                    if (resultData200.hasOwnProperty(key))
                        (<any>result200)[key] = resultData200[key] !== undefined ? resultData200[key] : <any>null;
                }
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<{ [key: string]: any; }>(null as any);
    }

    /**
     * @return Success
     */
    getTiendaNubeLinkedProducts(): Observable<TiendaNubeLinkedProductDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Ecommerce/GetTiendaNubeLinkedProducts";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTiendaNubeLinkedProducts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTiendaNubeLinkedProducts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TiendaNubeLinkedProductDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TiendaNubeLinkedProductDto[]>;
        }));
    }

    protected processGetTiendaNubeLinkedProducts(response: HttpResponseBase): Observable<TiendaNubeLinkedProductDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(TiendaNubeLinkedProductDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TiendaNubeLinkedProductDto[]>(null as any);
    }

    /**
     * @param ecommerceProductId (optional) 
     * @return Success
     */
    getTiendaNubeLinkedProductDetails(ecommerceProductId: number | undefined): Observable<TiendaNubeLinkedProductDetailDto> {
        let url_ = this.baseUrl + "/api/services/app/Ecommerce/GetTiendaNubeLinkedProductDetails?";
        if (ecommerceProductId === null)
            throw new Error("The parameter 'ecommerceProductId' cannot be null.");
        else if (ecommerceProductId !== undefined)
            url_ += "ecommerceProductId=" + encodeURIComponent("" + ecommerceProductId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTiendaNubeLinkedProductDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTiendaNubeLinkedProductDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TiendaNubeLinkedProductDetailDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TiendaNubeLinkedProductDetailDto>;
        }));
    }

    protected processGetTiendaNubeLinkedProductDetails(response: HttpResponseBase): Observable<TiendaNubeLinkedProductDetailDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TiendaNubeLinkedProductDetailDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TiendaNubeLinkedProductDetailDto>(null as any);
    }

    /**
     * @param ecommerceProductId (optional) 
     * @return Success
     */
    unlinkTiendaNubeProduct(ecommerceProductId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Ecommerce/UnlinkTiendaNubeProduct?";
        if (ecommerceProductId === null)
            throw new Error("The parameter 'ecommerceProductId' cannot be null.");
        else if (ecommerceProductId !== undefined)
            url_ += "ecommerceProductId=" + encodeURIComponent("" + ecommerceProductId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUnlinkTiendaNubeProduct(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUnlinkTiendaNubeProduct(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUnlinkTiendaNubeProduct(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    getTiendaNubeConfiguration(): Observable<TiendaNubeStoreConfigurationDto> {
        let url_ = this.baseUrl + "/api/services/app/Ecommerce/GetTiendaNubeConfiguration";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTiendaNubeConfiguration(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTiendaNubeConfiguration(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TiendaNubeStoreConfigurationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TiendaNubeStoreConfigurationDto>;
        }));
    }

    protected processGetTiendaNubeConfiguration(response: HttpResponseBase): Observable<TiendaNubeStoreConfigurationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TiendaNubeStoreConfigurationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TiendaNubeStoreConfigurationDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateTiendaNubeConfiguration(body: TiendaNubeStoreConfigurationDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Ecommerce/UpdateTiendaNubeConfiguration";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateTiendaNubeConfiguration(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateTiendaNubeConfiguration(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateTiendaNubeConfiguration(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param orderStatus (optional) 
     * @param paymentStatus (optional) 
     * @param shippingType (optional) 
     * @param shippingStatus (optional) 
     * @param dateFrom (optional) 
     * @param dateTo (optional) 
     * @param page (optional) 
     * @param perPage (optional) 
     * @return Success
     */
    getTiendaNubeOrders(orderStatus: string | undefined, paymentStatus: string | undefined, shippingType: string | undefined, shippingStatus: string | undefined, dateFrom: moment.Moment | undefined, dateTo: moment.Moment | undefined, page: number | undefined, perPage: number | undefined): Observable<TiendaNubeOrderDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Ecommerce/GetTiendaNubeOrders?";
        if (orderStatus === null)
            throw new Error("The parameter 'orderStatus' cannot be null.");
        else if (orderStatus !== undefined)
            url_ += "OrderStatus=" + encodeURIComponent("" + orderStatus) + "&";
        if (paymentStatus === null)
            throw new Error("The parameter 'paymentStatus' cannot be null.");
        else if (paymentStatus !== undefined)
            url_ += "PaymentStatus=" + encodeURIComponent("" + paymentStatus) + "&";
        if (shippingType === null)
            throw new Error("The parameter 'shippingType' cannot be null.");
        else if (shippingType !== undefined)
            url_ += "ShippingType=" + encodeURIComponent("" + shippingType) + "&";
        if (shippingStatus === null)
            throw new Error("The parameter 'shippingStatus' cannot be null.");
        else if (shippingStatus !== undefined)
            url_ += "ShippingStatus=" + encodeURIComponent("" + shippingStatus) + "&";
        if (dateFrom === null)
            throw new Error("The parameter 'dateFrom' cannot be null.");
        else if (dateFrom !== undefined)
            url_ += "DateFrom=" + encodeURIComponent(dateFrom ? "" + dateFrom.toISOString() : "") + "&";
        if (dateTo === null)
            throw new Error("The parameter 'dateTo' cannot be null.");
        else if (dateTo !== undefined)
            url_ += "DateTo=" + encodeURIComponent(dateTo ? "" + dateTo.toISOString() : "") + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (perPage === null)
            throw new Error("The parameter 'perPage' cannot be null.");
        else if (perPage !== undefined)
            url_ += "PerPage=" + encodeURIComponent("" + perPage) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTiendaNubeOrders(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTiendaNubeOrders(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TiendaNubeOrderDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TiendaNubeOrderDto[]>;
        }));
    }

    protected processGetTiendaNubeOrders(response: HttpResponseBase): Observable<TiendaNubeOrderDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(TiendaNubeOrderDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TiendaNubeOrderDto[]>(null as any);
    }

    /**
     * @param orderStatus (optional) 
     * @param paymentStatus (optional) 
     * @param shippingType (optional) 
     * @param shippingStatus (optional) 
     * @param dateFrom (optional) 
     * @param dateTo (optional) 
     * @param page (optional) 
     * @param perPage (optional) 
     * @return Success
     */
    getMappedTiendaNubeOrders(orderStatus: string | undefined, paymentStatus: string | undefined, shippingType: string | undefined, shippingStatus: string | undefined, dateFrom: moment.Moment | undefined, dateTo: moment.Moment | undefined, page: number | undefined, perPage: number | undefined): Observable<InvoiceDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Ecommerce/GetMappedTiendaNubeOrders?";
        if (orderStatus === null)
            throw new Error("The parameter 'orderStatus' cannot be null.");
        else if (orderStatus !== undefined)
            url_ += "OrderStatus=" + encodeURIComponent("" + orderStatus) + "&";
        if (paymentStatus === null)
            throw new Error("The parameter 'paymentStatus' cannot be null.");
        else if (paymentStatus !== undefined)
            url_ += "PaymentStatus=" + encodeURIComponent("" + paymentStatus) + "&";
        if (shippingType === null)
            throw new Error("The parameter 'shippingType' cannot be null.");
        else if (shippingType !== undefined)
            url_ += "ShippingType=" + encodeURIComponent("" + shippingType) + "&";
        if (shippingStatus === null)
            throw new Error("The parameter 'shippingStatus' cannot be null.");
        else if (shippingStatus !== undefined)
            url_ += "ShippingStatus=" + encodeURIComponent("" + shippingStatus) + "&";
        if (dateFrom === null)
            throw new Error("The parameter 'dateFrom' cannot be null.");
        else if (dateFrom !== undefined)
            url_ += "DateFrom=" + encodeURIComponent(dateFrom ? "" + dateFrom.toISOString() : "") + "&";
        if (dateTo === null)
            throw new Error("The parameter 'dateTo' cannot be null.");
        else if (dateTo !== undefined)
            url_ += "DateTo=" + encodeURIComponent(dateTo ? "" + dateTo.toISOString() : "") + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (perPage === null)
            throw new Error("The parameter 'perPage' cannot be null.");
        else if (perPage !== undefined)
            url_ += "PerPage=" + encodeURIComponent("" + perPage) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMappedTiendaNubeOrders(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMappedTiendaNubeOrders(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InvoiceDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InvoiceDto[]>;
        }));
    }

    protected processGetMappedTiendaNubeOrders(response: HttpResponseBase): Observable<InvoiceDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(InvoiceDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<InvoiceDto[]>(null as any);
    }

    /**
     * @param page (optional) 
     * @param perPage (optional) 
     * @param updatedAtMin (optional) 
     * @return Success
     */
    getTiendaNubeProducts(page: number | undefined, perPage: number | undefined, updatedAtMin: moment.Moment | undefined): Observable<TiendaNubeProductDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Ecommerce/GetTiendaNubeProducts?";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (perPage === null)
            throw new Error("The parameter 'perPage' cannot be null.");
        else if (perPage !== undefined)
            url_ += "PerPage=" + encodeURIComponent("" + perPage) + "&";
        if (updatedAtMin === null)
            throw new Error("The parameter 'updatedAtMin' cannot be null.");
        else if (updatedAtMin !== undefined)
            url_ += "UpdatedAtMin=" + encodeURIComponent(updatedAtMin ? "" + updatedAtMin.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTiendaNubeProducts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTiendaNubeProducts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TiendaNubeProductDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TiendaNubeProductDto[]>;
        }));
    }

    protected processGetTiendaNubeProducts(response: HttpResponseBase): Observable<TiendaNubeProductDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(TiendaNubeProductDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TiendaNubeProductDto[]>(null as any);
    }

    /**
     * @return Success
     */
    linkAllProductsFromTn(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Ecommerce/LinkAllProductsFromTn";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLinkAllProductsFromTn(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLinkAllProductsFromTn(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processLinkAllProductsFromTn(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateStock(body: UpdateStockInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Ecommerce/UpdateStock";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateStock(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateStock(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateStock(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updatePrice(body: UpdatePriceInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Ecommerce/UpdatePrice";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdatePrice(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdatePrice(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdatePrice(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param tnOrderId (optional) 
     * @return Success
     */
    emitTiendaNubeInvoice(tnOrderId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Ecommerce/EmitTiendaNubeInvoice?";
        if (tnOrderId === null)
            throw new Error("The parameter 'tnOrderId' cannot be null.");
        else if (tnOrderId !== undefined)
            url_ += "tnOrderId=" + encodeURIComponent("" + tnOrderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEmitTiendaNubeInvoice(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEmitTiendaNubeInvoice(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processEmitTiendaNubeInvoice(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param tnOrderId (optional) 
     * @return Success
     */
    getInvoiceIdByTiendaNubeOrderId(tnOrderId: number | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Ecommerce/GetInvoiceIdByTiendaNubeOrderId?";
        if (tnOrderId === null)
            throw new Error("The parameter 'tnOrderId' cannot be null.");
        else if (tnOrderId !== undefined)
            url_ += "tnOrderId=" + encodeURIComponent("" + tnOrderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetInvoiceIdByTiendaNubeOrderId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetInvoiceIdByTiendaNubeOrderId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGetInvoiceIdByTiendaNubeOrderId(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    /**
     * @param tnOrderId (optional) 
     * @return Success
     */
    markTiendaNubeOrderAsDelivered(tnOrderId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Ecommerce/MarkTiendaNubeOrderAsDelivered?";
        if (tnOrderId === null)
            throw new Error("The parameter 'tnOrderId' cannot be null.");
        else if (tnOrderId !== undefined)
            url_ += "tnOrderId=" + encodeURIComponent("" + tnOrderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMarkTiendaNubeOrderAsDelivered(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMarkTiendaNubeOrderAsDelivered(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processMarkTiendaNubeOrderAsDelivered(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    createTiendaNubeWebhooks(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Ecommerce/CreateTiendaNubeWebhooks";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateTiendaNubeWebhooks(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateTiendaNubeWebhooks(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateTiendaNubeWebhooks(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    deleteTiendaNubeWebhooks(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Ecommerce/DeleteTiendaNubeWebhooks";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteTiendaNubeWebhooks(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteTiendaNubeWebhooks(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteTiendaNubeWebhooks(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class TiendanubeServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param tenantId (optional) 
     * @return Success
     */
    webhook(tenantId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/tiendanube/webhook/{tenantId}?";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processWebhook(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processWebhook(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processWebhook(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class MercadolibreServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param tenantId (optional) 
     * @return Success
     */
    webhook(tenantId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/mercadolibre/webhook/{tenantId}?";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processWebhook(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processWebhook(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processWebhook(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class EditionServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param keyword (optional) 
     * @return Success
     */
    getAllEditions(keyword: string | undefined): Observable<EditionDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Edition/GetAllEditions?";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllEditions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllEditions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EditionDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EditionDto[]>;
        }));
    }

    protected processGetAllEditions(response: HttpResponseBase): Observable<EditionDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(EditionDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<EditionDto[]>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<EditionDto> {
        let url_ = this.baseUrl + "/api/services/app/Edition/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EditionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EditionDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<EditionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EditionDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<EditionDto>(null as any);
    }

    /**
     * @param editionId (optional) 
     * @return Success
     */
    getAllEditionsFeatures(editionId: number | undefined): Observable<EditionFeatureDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Edition/GetAllEditionsFeatures?";
        if (editionId === null)
            throw new Error("The parameter 'editionId' cannot be null.");
        else if (editionId !== undefined)
            url_ += "editionId=" + encodeURIComponent("" + editionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllEditionsFeatures(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllEditionsFeatures(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EditionFeatureDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EditionFeatureDto[]>;
        }));
    }

    protected processGetAllEditionsFeatures(response: HttpResponseBase): Observable<EditionFeatureDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(EditionFeatureDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<EditionFeatureDto[]>(null as any);
    }

    /**
     * @param editionId (optional) 
     * @param body (optional) 
     * @return Success
     */
    updateEditionFeatures(editionId: number | undefined, body: EditionFeatureDto[] | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Edition/UpdateEditionFeatures?";
        if (editionId === null)
            throw new Error("The parameter 'editionId' cannot be null.");
        else if (editionId !== undefined)
            url_ += "editionId=" + encodeURIComponent("" + editionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateEditionFeatures(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateEditionFeatures(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateEditionFeatures(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class FeatureServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: FeatureDto | undefined): Observable<FeatureDto> {
        let url_ = this.baseUrl + "/api/services/app/Feature/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FeatureDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FeatureDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<FeatureDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FeatureDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FeatureDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: FeatureDto | undefined): Observable<FeatureDto> {
        let url_ = this.baseUrl + "/api/services/app/Feature/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FeatureDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FeatureDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<FeatureDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FeatureDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FeatureDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<FeatureDto> {
        let url_ = this.baseUrl + "/api/services/app/Feature/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FeatureDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FeatureDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<FeatureDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FeatureDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FeatureDto>(null as any);
    }

    /**
     * @param keyword (optional) 
     * @param isActive (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, isActive: boolean | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<FeatureDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Feature/GetAll?";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (isActive === null)
            throw new Error("The parameter 'isActive' cannot be null.");
        else if (isActive !== undefined)
            url_ += "IsActive=" + encodeURIComponent("" + isActive) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FeatureDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FeatureDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<FeatureDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FeatureDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FeatureDtoPagedResultDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Feature/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class GatewayPaymentServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param provider (optional) 
     * @param body (optional) 
     * @return Success
     */
    saveCredentials(provider: string | undefined, body: GatewayPaymentDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/GatewayPayment/SaveCredentials?";
        if (provider === null)
            throw new Error("The parameter 'provider' cannot be null.");
        else if (provider !== undefined)
            url_ += "provider=" + encodeURIComponent("" + provider) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveCredentials(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveCredentials(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSaveCredentials(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param provider (optional) 
     * @return Success
     */
    getPaywayCredentials(provider: string | undefined): Observable<GatewayPaymentDto> {
        let url_ = this.baseUrl + "/api/services/app/GatewayPayment/GetPaywayCredentials?";
        if (provider === null)
            throw new Error("The parameter 'provider' cannot be null.");
        else if (provider !== undefined)
            url_ += "provider=" + encodeURIComponent("" + provider) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPaywayCredentials(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPaywayCredentials(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GatewayPaymentDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GatewayPaymentDto>;
        }));
    }

    protected processGetPaywayCredentials(response: HttpResponseBase): Observable<GatewayPaymentDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GatewayPaymentDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GatewayPaymentDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    returnMercadoPagoCashs(body: PagedCashierResultRequestDto | undefined): Observable<GatewayPayInfoDto> {
        let url_ = this.baseUrl + "/api/services/app/GatewayPayment/ReturnMercadoPagoCashs";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReturnMercadoPagoCashs(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReturnMercadoPagoCashs(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GatewayPayInfoDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GatewayPayInfoDto>;
        }));
    }

    protected processReturnMercadoPagoCashs(response: HttpResponseBase): Observable<GatewayPayInfoDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GatewayPayInfoDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GatewayPayInfoDto>(null as any);
    }

    /**
     * @return Success
     */
    checkExistCredentialMp(): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/GatewayPayment/CheckExistCredentialMp";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckExistCredentialMp(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckExistCredentialMp(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processCheckExistCredentialMp(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @return Success
     */
    checkCredetinalExpire(): Observable<GatewayPayInfoDto> {
        let url_ = this.baseUrl + "/api/services/app/GatewayPayment/CheckCredetinalExpire";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckCredetinalExpire(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckCredetinalExpire(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GatewayPayInfoDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GatewayPayInfoDto>;
        }));
    }

    protected processCheckCredetinalExpire(response: HttpResponseBase): Observable<GatewayPayInfoDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GatewayPayInfoDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GatewayPayInfoDto>(null as any);
    }

    /**
     * @param cashId (optional) 
     * @return Success
     */
    linkCashToMercadoPago(cashId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/GatewayPayment/LinkCashToMercadoPago?";
        if (cashId === null)
            throw new Error("The parameter 'cashId' cannot be null.");
        else if (cashId !== undefined)
            url_ += "cashId=" + encodeURIComponent("" + cashId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLinkCashToMercadoPago(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLinkCashToMercadoPago(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processLinkCashToMercadoPago(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param storeId (optional) 
     * @return Success
     */
    createMercadoPagoStore(storeId: number | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/GatewayPayment/CreateMercadoPagoStore?";
        if (storeId === null)
            throw new Error("The parameter 'storeId' cannot be null.");
        else if (storeId !== undefined)
            url_ += "storeId=" + encodeURIComponent("" + storeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateMercadoPagoStore(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateMercadoPagoStore(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processCreateMercadoPagoStore(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @param storeId (optional) 
     * @return Success
     */
    deleteStore(storeId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/GatewayPayment/DeleteStore?";
        if (storeId === null)
            throw new Error("The parameter 'storeId' cannot be null.");
        else if (storeId !== undefined)
            url_ += "storeId=" + encodeURIComponent("" + storeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteStore(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteStore(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteStore(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param cashId (optional) 
     * @return Success
     */
    deleteCashMercadoPago(cashId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/GatewayPayment/DeleteCashMercadoPago?";
        if (cashId === null)
            throw new Error("The parameter 'cashId' cannot be null.");
        else if (cashId !== undefined)
            url_ += "cashId=" + encodeURIComponent("" + cashId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteCashMercadoPago(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteCashMercadoPago(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteCashMercadoPago(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param cashId (optional) 
     * @param isOrder (optional) 
     * @return Success
     */
    dowloadQr(cashId: number | undefined, isOrder: boolean | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/GatewayPayment/DowloadQr?";
        if (cashId === null)
            throw new Error("The parameter 'cashId' cannot be null.");
        else if (cashId !== undefined)
            url_ += "cashId=" + encodeURIComponent("" + cashId) + "&";
        if (isOrder === null)
            throw new Error("The parameter 'isOrder' cannot be null.");
        else if (isOrder !== undefined)
            url_ += "isOrder=" + encodeURIComponent("" + isOrder) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDowloadQr(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDowloadQr(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processDowloadQr(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    /**
     * @param cashId (optional) 
     * @param remain (optional) 
     * @param body (optional) 
     * @return Success
     */
    createOrderMercadoPago(cashId: number | undefined, remain: number | undefined, body: InvoiceDto | undefined): Observable<CreateOrderDto> {
        let url_ = this.baseUrl + "/api/services/app/GatewayPayment/CreateOrderMercadoPago?";
        if (cashId === null)
            throw new Error("The parameter 'cashId' cannot be null.");
        else if (cashId !== undefined)
            url_ += "cashId=" + encodeURIComponent("" + cashId) + "&";
        if (remain === null)
            throw new Error("The parameter 'remain' cannot be null.");
        else if (remain !== undefined)
            url_ += "remain=" + encodeURIComponent("" + remain) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrderMercadoPago(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrderMercadoPago(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateOrderDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateOrderDto>;
        }));
    }

    protected processCreateOrderMercadoPago(response: HttpResponseBase): Observable<CreateOrderDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateOrderDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CreateOrderDto>(null as any);
    }

    /**
     * @param cashId (optional) 
     * @return Success
     */
    deleteOrderMercadoPago(cashId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/GatewayPayment/DeleteOrderMercadoPago?";
        if (cashId === null)
            throw new Error("The parameter 'cashId' cannot be null.");
        else if (cashId !== undefined)
            url_ += "cashId=" + encodeURIComponent("" + cashId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteOrderMercadoPago(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteOrderMercadoPago(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteOrderMercadoPago(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param mercadoPagoCashId (optional) 
     * @param cashId (optional) 
     * @return Success
     */
    linkManualCash(mercadoPagoCashId: string | undefined, cashId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/GatewayPayment/LinkManualCash?";
        if (mercadoPagoCashId === null)
            throw new Error("The parameter 'mercadoPagoCashId' cannot be null.");
        else if (mercadoPagoCashId !== undefined)
            url_ += "mercadoPagoCashId=" + encodeURIComponent("" + mercadoPagoCashId) + "&";
        if (cashId === null)
            throw new Error("The parameter 'cashId' cannot be null.");
        else if (cashId !== undefined)
            url_ += "cashId=" + encodeURIComponent("" + cashId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLinkManualCash(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLinkManualCash(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processLinkManualCash(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param storeId (optional) 
     * @return Success
     */
    unlikMercadoPagoStore(storeId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/GatewayPayment/UnlikMercadoPagoStore?";
        if (storeId === null)
            throw new Error("The parameter 'storeId' cannot be null.");
        else if (storeId !== undefined)
            url_ += "storeId=" + encodeURIComponent("" + storeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUnlikMercadoPagoStore(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUnlikMercadoPagoStore(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUnlikMercadoPagoStore(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param keyword (optional) 
     * @param isActive (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllStores(keyword: string | undefined, isActive: boolean | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<StoreMpDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/GatewayPayment/GetAllStores?";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (isActive === null)
            throw new Error("The parameter 'isActive' cannot be null.");
        else if (isActive !== undefined)
            url_ += "IsActive=" + encodeURIComponent("" + isActive) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllStores(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllStores(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StoreMpDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StoreMpDtoPagedResultDto>;
        }));
    }

    protected processGetAllStores(response: HttpResponseBase): Observable<StoreMpDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StoreMpDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<StoreMpDtoPagedResultDto>(null as any);
    }

    /**
     * @param provider (optional) 
     * @return Success
     */
    deleteCredentialConfig(provider: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/GatewayPayment/DeleteCredentialConfig?";
        if (provider === null)
            throw new Error("The parameter 'provider' cannot be null.");
        else if (provider !== undefined)
            url_ += "provider=" + encodeURIComponent("" + provider) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteCredentialConfig(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteCredentialConfig(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteCredentialConfig(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param orderId (optional) 
     * @param remain (optional) 
     * @return Success
     */
    searchPaymentStatus(orderId: string | undefined, remain: number | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/GatewayPayment/SearchPaymentStatus?";
        if (orderId === null)
            throw new Error("The parameter 'orderId' cannot be null.");
        else if (orderId !== undefined)
            url_ += "orderId=" + encodeURIComponent("" + orderId) + "&";
        if (remain === null)
            throw new Error("The parameter 'remain' cannot be null.");
        else if (remain !== undefined)
            url_ += "remain=" + encodeURIComponent("" + remain) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchPaymentStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchPaymentStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processSearchPaymentStatus(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @return Success
     */
    createPaywayPaymentOrder(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/GatewayPayment/CreatePaywayPaymentOrder";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreatePaywayPaymentOrder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreatePaywayPaymentOrder(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreatePaywayPaymentOrder(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class InvoiceServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    voucherApply(body: InvoiceDto | undefined): Observable<InvoiceDto> {
        let url_ = this.baseUrl + "/api/services/app/Invoice/VoucherApply";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processVoucherApply(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processVoucherApply(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InvoiceDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InvoiceDto>;
        }));
    }

    protected processVoucherApply(response: HttpResponseBase): Observable<InvoiceDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InvoiceDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<InvoiceDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    invoicesReport(body: InvoiceReportFilterDto | undefined): Observable<InvoiceReportDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Invoice/InvoicesReport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processInvoicesReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInvoicesReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InvoiceReportDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InvoiceReportDto[]>;
        }));
    }

    protected processInvoicesReport(response: HttpResponseBase): Observable<InvoiceReportDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(InvoiceReportDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<InvoiceReportDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    setProcessedInvoices(body: number[] | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Invoice/SetProcessedInvoices";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetProcessedInvoices(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetProcessedInvoices(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSetProcessedInvoices(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    checkIfBankPromotionIsApplied(body: number[] | undefined): Observable<PromotionDto> {
        let url_ = this.baseUrl + "/api/services/app/Invoice/CheckIfBankPromotionIsApplied";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckIfBankPromotionIsApplied(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckIfBankPromotionIsApplied(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PromotionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PromotionDto>;
        }));
    }

    protected processCheckIfBankPromotionIsApplied(response: HttpResponseBase): Observable<PromotionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PromotionDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PromotionDto>(null as any);
    }

    /**
     * @param inputId (optional) 
     * @return Success
     */
    getInfoStockAjust(inputId: number | undefined): Observable<StockAjustDto> {
        let url_ = this.baseUrl + "/api/services/app/Invoice/GetInfoStockAjust?";
        if (inputId === null)
            throw new Error("The parameter 'inputId' cannot be null.");
        else if (inputId !== undefined)
            url_ += "inputId=" + encodeURIComponent("" + inputId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetInfoStockAjust(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetInfoStockAjust(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StockAjustDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StockAjustDto>;
        }));
    }

    protected processGetInfoStockAjust(response: HttpResponseBase): Observable<StockAjustDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StockAjustDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<StockAjustDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getBankById(id: number | undefined): Observable<BankDto> {
        let url_ = this.baseUrl + "/api/services/app/Invoice/GetBankById?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBankById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBankById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BankDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BankDto>;
        }));
    }

    protected processGetBankById(response: HttpResponseBase): Observable<BankDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BankDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BankDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getCompanyById(id: number | undefined): Observable<CompanyDto> {
        let url_ = this.baseUrl + "/api/services/app/Invoice/GetCompanyById?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCompanyById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCompanyById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CompanyDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CompanyDto>;
        }));
    }

    protected processGetCompanyById(response: HttpResponseBase): Observable<CompanyDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CompanyDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CompanyDto>(null as any);
    }

    /**
     * @param storeId (optional) 
     * @return Success
     */
    getTransitHeadersDeliveryNote(storeId: number | undefined): Observable<GetHeadersTransitApiListDto> {
        let url_ = this.baseUrl + "/api/services/app/Invoice/GetTransitHeadersDeliveryNote?";
        if (storeId === null)
            throw new Error("The parameter 'storeId' cannot be null.");
        else if (storeId !== undefined)
            url_ += "storeId=" + encodeURIComponent("" + storeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTransitHeadersDeliveryNote(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTransitHeadersDeliveryNote(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetHeadersTransitApiListDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetHeadersTransitApiListDto>;
        }));
    }

    protected processGetTransitHeadersDeliveryNote(response: HttpResponseBase): Observable<GetHeadersTransitApiListDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetHeadersTransitApiListDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetHeadersTransitApiListDto>(null as any);
    }

    /**
     * @param movementId (optional) 
     * @param date (optional) 
     * @param number (optional) 
     * @param warehouseId (optional) 
     * @param warehouseCode (optional) 
     * @param warehouseDescription (optional) 
     * @param quantityToReceive (optional) 
     * @param storeExternalId (optional) 
     * @return Success
     */
    getTransitDeliveryNoteDetails(movementId: number | undefined, date: moment.Moment | undefined, number: number | undefined, warehouseId: number | undefined, warehouseCode: string | undefined, warehouseDescription: string | undefined, quantityToReceive: number | undefined, storeExternalId: number | undefined): Observable<TransitDeliveryNoteDetailsDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Invoice/GetTransitDeliveryNoteDetails?";
        if (movementId === null)
            throw new Error("The parameter 'movementId' cannot be null.");
        else if (movementId !== undefined)
            url_ += "MovementId=" + encodeURIComponent("" + movementId) + "&";
        if (date === null)
            throw new Error("The parameter 'date' cannot be null.");
        else if (date !== undefined)
            url_ += "Date=" + encodeURIComponent(date ? "" + date.toISOString() : "") + "&";
        if (number === null)
            throw new Error("The parameter 'number' cannot be null.");
        else if (number !== undefined)
            url_ += "Number=" + encodeURIComponent("" + number) + "&";
        if (warehouseId === null)
            throw new Error("The parameter 'warehouseId' cannot be null.");
        else if (warehouseId !== undefined)
            url_ += "WarehouseId=" + encodeURIComponent("" + warehouseId) + "&";
        if (warehouseCode === null)
            throw new Error("The parameter 'warehouseCode' cannot be null.");
        else if (warehouseCode !== undefined)
            url_ += "WarehouseCode=" + encodeURIComponent("" + warehouseCode) + "&";
        if (warehouseDescription === null)
            throw new Error("The parameter 'warehouseDescription' cannot be null.");
        else if (warehouseDescription !== undefined)
            url_ += "WarehouseDescription=" + encodeURIComponent("" + warehouseDescription) + "&";
        if (quantityToReceive === null)
            throw new Error("The parameter 'quantityToReceive' cannot be null.");
        else if (quantityToReceive !== undefined)
            url_ += "QuantityToReceive=" + encodeURIComponent("" + quantityToReceive) + "&";
        if (storeExternalId === null)
            throw new Error("The parameter 'storeExternalId' cannot be null.");
        else if (storeExternalId !== undefined)
            url_ += "StoreExternalId=" + encodeURIComponent("" + storeExternalId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTransitDeliveryNoteDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTransitDeliveryNoteDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TransitDeliveryNoteDetailsDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TransitDeliveryNoteDetailsDto[]>;
        }));
    }

    protected processGetTransitDeliveryNoteDetails(response: HttpResponseBase): Observable<TransitDeliveryNoteDetailsDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(TransitDeliveryNoteDetailsDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TransitDeliveryNoteDetailsDto[]>(null as any);
    }

    /**
     * @param transitMovementId (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    releaseDeliveryNote(transitMovementId: number | undefined, tenantId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Invoice/ReleaseDeliveryNote?";
        if (transitMovementId === null)
            throw new Error("The parameter 'transitMovementId' cannot be null.");
        else if (transitMovementId !== undefined)
            url_ += "TransitMovementId=" + encodeURIComponent("" + transitMovementId) + "&";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReleaseDeliveryNote(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReleaseDeliveryNote(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processReleaseDeliveryNote(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createPaymentOrder(body: TransactionDto | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Invoice/CreatePaymentOrder";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreatePaymentOrder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreatePaymentOrder(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processCreatePaymentOrder(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    /**
     * @param paymentId (optional) 
     * @return Success
     */
    cancelPaymentOrder(paymentId: string | undefined): Observable<CancelPaymentOrderResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Invoice/CancelPaymentOrder?";
        if (paymentId === null)
            throw new Error("The parameter 'paymentId' cannot be null.");
        else if (paymentId !== undefined)
            url_ += "paymentId=" + encodeURIComponent("" + paymentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCancelPaymentOrder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCancelPaymentOrder(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CancelPaymentOrderResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CancelPaymentOrderResultDto>;
        }));
    }

    protected processCancelPaymentOrder(response: HttpResponseBase): Observable<CancelPaymentOrderResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CancelPaymentOrderResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CancelPaymentOrderResultDto>(null as any);
    }

    /**
     * @param cashierId (optional) 
     * @return Success
     */
    batchClose(cashierId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Invoice/BatchClose?";
        if (cashierId === null)
            throw new Error("The parameter 'cashierId' cannot be null.");
        else if (cashierId !== undefined)
            url_ += "cashierId=" + encodeURIComponent("" + cashierId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBatchClose(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBatchClose(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processBatchClose(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createReversalOrder(body: TransactionDto | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Invoice/CreateReversalOrder";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateReversalOrder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateReversalOrder(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processCreateReversalOrder(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    /**
     * @param paymentId (optional) 
     * @return Success
     */
    cancelReversalOrder(paymentId: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Invoice/CancelReversalOrder?";
        if (paymentId === null)
            throw new Error("The parameter 'paymentId' cannot be null.");
        else if (paymentId !== undefined)
            url_ += "paymentId=" + encodeURIComponent("" + paymentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCancelReversalOrder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCancelReversalOrder(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCancelReversalOrder(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param paymentId (optional) 
     * @return Success
     */
    getPaymentStatus(paymentId: string | undefined): Observable<GatewayPaymentDataDto> {
        let url_ = this.baseUrl + "/api/services/app/Invoice/GetPaymentStatus?";
        if (paymentId === null)
            throw new Error("The parameter 'paymentId' cannot be null.");
        else if (paymentId !== undefined)
            url_ += "paymentId=" + encodeURIComponent("" + paymentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPaymentStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPaymentStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GatewayPaymentDataDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GatewayPaymentDataDto>;
        }));
    }

    protected processGetPaymentStatus(response: HttpResponseBase): Observable<GatewayPaymentDataDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GatewayPaymentDataDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GatewayPaymentDataDto>(null as any);
    }

    /**
     * @param reversalId (optional) 
     * @param cashierId (optional) 
     * @return Success
     */
    checkReversalStatus(reversalId: string | undefined, cashierId: number | undefined): Observable<ReturnReversalDataDto> {
        let url_ = this.baseUrl + "/api/services/app/Invoice/CheckReversalStatus?";
        if (reversalId === null)
            throw new Error("The parameter 'reversalId' cannot be null.");
        else if (reversalId !== undefined)
            url_ += "reversalId=" + encodeURIComponent("" + reversalId) + "&";
        if (cashierId === null)
            throw new Error("The parameter 'cashierId' cannot be null.");
        else if (cashierId !== undefined)
            url_ += "cashierId=" + encodeURIComponent("" + cashierId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckReversalStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckReversalStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReturnReversalDataDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReturnReversalDataDto>;
        }));
    }

    protected processCheckReversalStatus(response: HttpResponseBase): Observable<ReturnReversalDataDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReturnReversalDataDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ReturnReversalDataDto>(null as any);
    }

    /**
     * @param invoiceId (optional) 
     * @return Success
     */
    deleteDraft(invoiceId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Invoice/DeleteDraft?";
        if (invoiceId === null)
            throw new Error("The parameter 'invoiceId' cannot be null.");
        else if (invoiceId !== undefined)
            url_ += "invoiceId=" + encodeURIComponent("" + invoiceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteDraft(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteDraft(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteDraft(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param letterType (optional) 
     * @param salePointId (optional) 
     * @param invoiceFormType (optional) 
     * @param from (optional) 
     * @param to (optional) 
     * @return Success
     */
    getArcaJumps(letterType: LetterType | undefined, salePointId: number | undefined, invoiceFormType: InvoiceFormType | undefined, from: moment.Moment | undefined, to: moment.Moment | undefined): Observable<InvoiceJumpDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Invoice/GetArcaJumps?";
        if (letterType === null)
            throw new Error("The parameter 'letterType' cannot be null.");
        else if (letterType !== undefined)
            url_ += "LetterType=" + encodeURIComponent("" + letterType) + "&";
        if (salePointId === null)
            throw new Error("The parameter 'salePointId' cannot be null.");
        else if (salePointId !== undefined)
            url_ += "SalePointId=" + encodeURIComponent("" + salePointId) + "&";
        if (invoiceFormType === null)
            throw new Error("The parameter 'invoiceFormType' cannot be null.");
        else if (invoiceFormType !== undefined)
            url_ += "InvoiceFormType=" + encodeURIComponent("" + invoiceFormType) + "&";
        if (from === null)
            throw new Error("The parameter 'from' cannot be null.");
        else if (from !== undefined)
            url_ += "From=" + encodeURIComponent(from ? "" + from.toISOString() : "") + "&";
        if (to === null)
            throw new Error("The parameter 'to' cannot be null.");
        else if (to !== undefined)
            url_ += "To=" + encodeURIComponent(to ? "" + to.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetArcaJumps(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetArcaJumps(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InvoiceJumpDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InvoiceJumpDto[]>;
        }));
    }

    protected processGetArcaJumps(response: HttpResponseBase): Observable<InvoiceJumpDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(InvoiceJumpDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<InvoiceJumpDto[]>(null as any);
    }

    /**
     * @return Success
     */
    getAllElectronicSalePoints(): Observable<SalePointInvoiceDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Invoice/GetAllElectronicSalePoints";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllElectronicSalePoints(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllElectronicSalePoints(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SalePointInvoiceDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SalePointInvoiceDto[]>;
        }));
    }

    protected processGetAllElectronicSalePoints(response: HttpResponseBase): Observable<SalePointInvoiceDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(SalePointInvoiceDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SalePointInvoiceDto[]>(null as any);
    }

    /**
     * @param letterType (optional) 
     * @param salePointId (optional) 
     * @param invoiceFormType (optional) 
     * @param number (optional) 
     * @return Success
     */
    getInvoiceByArca(letterType: LetterType | undefined, salePointId: number | undefined, invoiceFormType: InvoiceFormType | undefined, number: number | undefined): Observable<ArcaJumpInformationDto> {
        let url_ = this.baseUrl + "/api/services/app/Invoice/GetInvoiceByArca?";
        if (letterType === null)
            throw new Error("The parameter 'letterType' cannot be null.");
        else if (letterType !== undefined)
            url_ += "LetterType=" + encodeURIComponent("" + letterType) + "&";
        if (salePointId === null)
            throw new Error("The parameter 'salePointId' cannot be null.");
        else if (salePointId !== undefined)
            url_ += "SalePointId=" + encodeURIComponent("" + salePointId) + "&";
        if (invoiceFormType === null)
            throw new Error("The parameter 'invoiceFormType' cannot be null.");
        else if (invoiceFormType !== undefined)
            url_ += "InvoiceFormType=" + encodeURIComponent("" + invoiceFormType) + "&";
        if (number === null)
            throw new Error("The parameter 'number' cannot be null.");
        else if (number !== undefined)
            url_ += "Number=" + encodeURIComponent("" + number) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetInvoiceByArca(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetInvoiceByArca(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ArcaJumpInformationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ArcaJumpInformationDto>;
        }));
    }

    protected processGetInvoiceByArca(response: HttpResponseBase): Observable<ArcaJumpInformationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ArcaJumpInformationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ArcaJumpInformationDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    closeArcaJump(body: CloseArcaJumpDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Invoice/CloseArcaJump";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCloseArcaJump(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCloseArcaJump(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCloseArcaJump(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param orderId (optional) 
     * @return Success
     */
    getInvoiceIdByOrderId(orderId: number | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Invoice/GetInvoiceIdByOrderId?";
        if (orderId === null)
            throw new Error("The parameter 'orderId' cannot be null.");
        else if (orderId !== undefined)
            url_ += "orderId=" + encodeURIComponent("" + orderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetInvoiceIdByOrderId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetInvoiceIdByOrderId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGetInvoiceIdByOrderId(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    /**
     * @param number (optional) 
     * @param type (optional) 
     * @param salepointId (optional) 
     * @return Success
     */
    getDataInvoiceFromNumber(number: string | undefined, type: LetterType | undefined, salepointId: number | undefined): Observable<InvoiceDto> {
        let url_ = this.baseUrl + "/api/services/app/Invoice/GetDataInvoiceFromNumber?";
        if (number === null)
            throw new Error("The parameter 'number' cannot be null.");
        else if (number !== undefined)
            url_ += "number=" + encodeURIComponent("" + number) + "&";
        if (type === null)
            throw new Error("The parameter 'type' cannot be null.");
        else if (type !== undefined)
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        if (salepointId === null)
            throw new Error("The parameter 'salepointId' cannot be null.");
        else if (salepointId !== undefined)
            url_ += "salepointId=" + encodeURIComponent("" + salepointId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDataInvoiceFromNumber(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDataInvoiceFromNumber(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InvoiceDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InvoiceDto>;
        }));
    }

    protected processGetDataInvoiceFromNumber(response: HttpResponseBase): Observable<InvoiceDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InvoiceDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<InvoiceDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    verifyExistenceBankPromotion(body: InvoiceDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Invoice/VerifyExistenceBankPromotion";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processVerifyExistenceBankPromotion(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processVerifyExistenceBankPromotion(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processVerifyExistenceBankPromotion(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getDraftInvoice(id: number | undefined): Observable<InvoiceDto> {
        let url_ = this.baseUrl + "/api/services/app/Invoice/GetDraftInvoice?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDraftInvoice(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDraftInvoice(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InvoiceDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InvoiceDto>;
        }));
    }

    protected processGetDraftInvoice(response: HttpResponseBase): Observable<InvoiceDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InvoiceDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<InvoiceDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getInvoiceNoFiscal(id: number | undefined): Observable<InvoiceDto> {
        let url_ = this.baseUrl + "/api/services/app/Invoice/GetInvoiceNoFiscal?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetInvoiceNoFiscal(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetInvoiceNoFiscal(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InvoiceDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InvoiceDto>;
        }));
    }

    protected processGetInvoiceNoFiscal(response: HttpResponseBase): Observable<InvoiceDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InvoiceDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<InvoiceDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    emitDraftInvoiceCore(body: InvoiceDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Invoice/EmitDraftInvoiceCore";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEmitDraftInvoiceCore(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEmitDraftInvoiceCore(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processEmitDraftInvoiceCore(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: InvoiceDto | undefined): Observable<InvoiceDto> {
        let url_ = this.baseUrl + "/api/services/app/Invoice/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InvoiceDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InvoiceDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<InvoiceDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InvoiceDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<InvoiceDto>(null as any);
    }

    /**
     * @param from (optional) 
     * @param to (optional) 
     * @return Success
     */
    informToIRSA(from: moment.Moment | undefined, to: moment.Moment | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Invoice/InformToIRSA?";
        if (from === null)
            throw new Error("The parameter 'from' cannot be null.");
        else if (from !== undefined)
            url_ += "from=" + encodeURIComponent(from ? "" + from.toISOString() : "") + "&";
        if (to === null)
            throw new Error("The parameter 'to' cannot be null.");
        else if (to !== undefined)
            url_ += "to=" + encodeURIComponent(to ? "" + to.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processInformToIRSA(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInformToIRSA(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processInformToIRSA(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param invoiceId (optional) 
     * @return Success
     */
    informSingleInvoiceToIRSA(invoiceId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Invoice/InformSingleInvoiceToIRSA?";
        if (invoiceId === null)
            throw new Error("The parameter 'invoiceId' cannot be null.");
        else if (invoiceId !== undefined)
            url_ += "invoiceId=" + encodeURIComponent("" + invoiceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processInformSingleInvoiceToIRSA(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInformSingleInvoiceToIRSA(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processInformSingleInvoiceToIRSA(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param invoiceId (optional) 
     * @param targetEmail (optional) 
     * @return Success
     */
    resendInvoiceEmail(invoiceId: number | undefined, targetEmail: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Invoice/ResendInvoiceEmail?";
        if (invoiceId === null)
            throw new Error("The parameter 'invoiceId' cannot be null.");
        else if (invoiceId !== undefined)
            url_ += "invoiceId=" + encodeURIComponent("" + invoiceId) + "&";
        if (targetEmail === null)
            throw new Error("The parameter 'targetEmail' cannot be null.");
        else if (targetEmail !== undefined)
            url_ += "targetEmail=" + encodeURIComponent("" + targetEmail) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processResendInvoiceEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResendInvoiceEmail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processResendInvoiceEmail(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createAndSendTicketChangeForReservation(body: InvoiceDto | undefined): Observable<InvoiceDto> {
        let url_ = this.baseUrl + "/api/services/app/Invoice/CreateAndSendTicketChangeForReservation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateAndSendTicketChangeForReservation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateAndSendTicketChangeForReservation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InvoiceDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InvoiceDto>;
        }));
    }

    protected processCreateAndSendTicketChangeForReservation(response: HttpResponseBase): Observable<InvoiceDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InvoiceDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<InvoiceDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createInvoiceForReservation(body: InvoiceDto | undefined): Observable<InvoiceDto> {
        let url_ = this.baseUrl + "/api/services/app/Invoice/CreateInvoiceForReservation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateInvoiceForReservation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateInvoiceForReservation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InvoiceDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InvoiceDto>;
        }));
    }

    protected processCreateInvoiceForReservation(response: HttpResponseBase): Observable<InvoiceDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InvoiceDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<InvoiceDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createReservation(body: InvoiceDto | undefined): Observable<InvoiceDto> {
        let url_ = this.baseUrl + "/api/services/app/Invoice/CreateReservation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateReservation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateReservation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InvoiceDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InvoiceDto>;
        }));
    }

    protected processCreateReservation(response: HttpResponseBase): Observable<InvoiceDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InvoiceDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<InvoiceDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    cancelReservationByCash(body: InvoiceDto | undefined): Observable<InvoiceDto> {
        let url_ = this.baseUrl + "/api/services/app/Invoice/CancelReservationByCash";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCancelReservationByCash(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCancelReservationByCash(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InvoiceDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InvoiceDto>;
        }));
    }

    protected processCancelReservationByCash(response: HttpResponseBase): Observable<InvoiceDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InvoiceDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<InvoiceDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createCreditNote(body: InvoiceDto | undefined): Observable<InvoiceDto> {
        let url_ = this.baseUrl + "/api/services/app/Invoice/CreateCreditNote";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateCreditNote(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateCreditNote(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InvoiceDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InvoiceDto>;
        }));
    }

    protected processCreateCreditNote(response: HttpResponseBase): Observable<InvoiceDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InvoiceDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<InvoiceDto>(null as any);
    }

    /**
     * @param invoiceId (optional) 
     * @param body (optional) 
     * @return Success
     */
    validateProducts(invoiceId: number | undefined, body: InvoiceProduct[] | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Invoice/ValidateProducts?";
        if (invoiceId === null)
            throw new Error("The parameter 'invoiceId' cannot be null.");
        else if (invoiceId !== undefined)
            url_ += "invoiceId=" + encodeURIComponent("" + invoiceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processValidateProducts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processValidateProducts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processValidateProducts(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createDraft(body: InvoiceDto | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Invoice/CreateDraft";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateDraft(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateDraft(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreateDraft(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createDeliveryNote(body: DeliveryNoteDto | undefined): Observable<InvoiceDto> {
        let url_ = this.baseUrl + "/api/services/app/Invoice/CreateDeliveryNote";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateDeliveryNote(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateDeliveryNote(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InvoiceDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InvoiceDto>;
        }));
    }

    protected processCreateDeliveryNote(response: HttpResponseBase): Observable<InvoiceDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InvoiceDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<InvoiceDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createStockAjust(body: StockAjustDto | undefined): Observable<InvoiceDto> {
        let url_ = this.baseUrl + "/api/services/app/Invoice/CreateStockAjust";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateStockAjust(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateStockAjust(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InvoiceDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InvoiceDto>;
        }));
    }

    protected processCreateStockAjust(response: HttpResponseBase): Observable<InvoiceDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InvoiceDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<InvoiceDto>(null as any);
    }

    /**
     * @param keyword (optional) 
     * @param finalConsumer (optional) 
     * @return Success
     */
    getClients(keyword: string | undefined, finalConsumer: boolean | undefined): Observable<ClientInvoiceDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Invoice/GetClients?";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "keyword=" + encodeURIComponent("" + keyword) + "&";
        if (finalConsumer === null)
            throw new Error("The parameter 'finalConsumer' cannot be null.");
        else if (finalConsumer !== undefined)
            url_ += "finalConsumer=" + encodeURIComponent("" + finalConsumer) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetClients(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetClients(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClientInvoiceDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClientInvoiceDto[]>;
        }));
    }

    protected processGetClients(response: HttpResponseBase): Observable<ClientInvoiceDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ClientInvoiceDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ClientInvoiceDto[]>(null as any);
    }

    /**
     * @return Success
     */
    getClientFinalConsumer(): Observable<ClientInvoiceDto> {
        let url_ = this.baseUrl + "/api/services/app/Invoice/GetClientFinalConsumer";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetClientFinalConsumer(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetClientFinalConsumer(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClientInvoiceDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClientInvoiceDto>;
        }));
    }

    protected processGetClientFinalConsumer(response: HttpResponseBase): Observable<ClientInvoiceDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClientInvoiceDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ClientInvoiceDto>(null as any);
    }

    /**
     * @param keyword (optional) 
     * @return Success
     */
    getProducts(keyword: string | undefined): Observable<ProductInvoiceDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Invoice/GetProducts?";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "keyword=" + encodeURIComponent("" + keyword) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProducts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProducts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductInvoiceDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductInvoiceDto[]>;
        }));
    }

    protected processGetProducts(response: HttpResponseBase): Observable<ProductInvoiceDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ProductInvoiceDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProductInvoiceDto[]>(null as any);
    }

    /**
     * @param keyword (optional) 
     * @return Success
     */
    getProductsWithVariant(keyword: string | undefined): Observable<ProductInvoiceDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Invoice/GetProductsWithVariant?";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "keyword=" + encodeURIComponent("" + keyword) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProductsWithVariant(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProductsWithVariant(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductInvoiceDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductInvoiceDto[]>;
        }));
    }

    protected processGetProductsWithVariant(response: HttpResponseBase): Observable<ProductInvoiceDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ProductInvoiceDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProductInvoiceDto[]>(null as any);
    }

    /**
     * @param productVariantId (optional) 
     * @param isVariant (optional) 
     * @param priceListId (optional) 
     * @param storeId (optional) 
     * @return Success
     */
    getProductWithVariant(productVariantId: number | undefined, isVariant: boolean | undefined, priceListId: number | undefined, storeId: number | undefined): Observable<ProductInvoiceDto> {
        let url_ = this.baseUrl + "/api/services/app/Invoice/GetProductWithVariant?";
        if (productVariantId === null)
            throw new Error("The parameter 'productVariantId' cannot be null.");
        else if (productVariantId !== undefined)
            url_ += "productVariantId=" + encodeURIComponent("" + productVariantId) + "&";
        if (isVariant === null)
            throw new Error("The parameter 'isVariant' cannot be null.");
        else if (isVariant !== undefined)
            url_ += "isVariant=" + encodeURIComponent("" + isVariant) + "&";
        if (priceListId === null)
            throw new Error("The parameter 'priceListId' cannot be null.");
        else if (priceListId !== undefined)
            url_ += "priceListId=" + encodeURIComponent("" + priceListId) + "&";
        if (storeId === null)
            throw new Error("The parameter 'storeId' cannot be null.");
        else if (storeId !== undefined)
            url_ += "storeId=" + encodeURIComponent("" + storeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProductWithVariant(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProductWithVariant(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductInvoiceDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductInvoiceDto>;
        }));
    }

    protected processGetProductWithVariant(response: HttpResponseBase): Observable<ProductInvoiceDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProductInvoiceDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProductInvoiceDto>(null as any);
    }

    /**
     * @param keyword (optional) 
     * @param salePointId (optional) 
     * @param priceListId (optional) 
     * @return Success
     */
    getProductsWithVariantsToInvoice(keyword: string | undefined, salePointId: number | undefined, priceListId: number | undefined): Observable<ProductInvoiceDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Invoice/GetProductsWithVariantsToInvoice?";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "keyword=" + encodeURIComponent("" + keyword) + "&";
        if (salePointId === null)
            throw new Error("The parameter 'salePointId' cannot be null.");
        else if (salePointId !== undefined)
            url_ += "salePointId=" + encodeURIComponent("" + salePointId) + "&";
        if (priceListId === null)
            throw new Error("The parameter 'priceListId' cannot be null.");
        else if (priceListId !== undefined)
            url_ += "priceListId=" + encodeURIComponent("" + priceListId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProductsWithVariantsToInvoice(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProductsWithVariantsToInvoice(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductInvoiceDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductInvoiceDto[]>;
        }));
    }

    protected processGetProductsWithVariantsToInvoice(response: HttpResponseBase): Observable<ProductInvoiceDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ProductInvoiceDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProductInvoiceDto[]>(null as any);
    }

    /**
     * @param isForNC (optional) 
     * @return Success
     */
    getSalePoints(isForNC: boolean | undefined): Observable<SalePointInvoiceDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Invoice/GetSalePoints?";
        if (isForNC === null)
            throw new Error("The parameter 'isForNC' cannot be null.");
        else if (isForNC !== undefined)
            url_ += "isForNC=" + encodeURIComponent("" + isForNC) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSalePoints(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSalePoints(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SalePointInvoiceDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SalePointInvoiceDto[]>;
        }));
    }

    protected processGetSalePoints(response: HttpResponseBase): Observable<SalePointInvoiceDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(SalePointInvoiceDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SalePointInvoiceDto[]>(null as any);
    }

    /**
     * @param salePoint (optional) 
     * @param useNoFiscal (optional) 
     * @param usePayway (optional) 
     * @return Success
     */
    getProviderPayments(salePoint: number | undefined, useNoFiscal: boolean | undefined, usePayway: boolean | undefined): Observable<PPaymentsInvoiceDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Invoice/GetProviderPayments?";
        if (salePoint === null)
            throw new Error("The parameter 'salePoint' cannot be null.");
        else if (salePoint !== undefined)
            url_ += "salePoint=" + encodeURIComponent("" + salePoint) + "&";
        if (useNoFiscal === null)
            throw new Error("The parameter 'useNoFiscal' cannot be null.");
        else if (useNoFiscal !== undefined)
            url_ += "useNoFiscal=" + encodeURIComponent("" + useNoFiscal) + "&";
        if (usePayway === null)
            throw new Error("The parameter 'usePayway' cannot be null.");
        else if (usePayway !== undefined)
            url_ += "usePayway=" + encodeURIComponent("" + usePayway) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProviderPayments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProviderPayments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PPaymentsInvoiceDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PPaymentsInvoiceDto[]>;
        }));
    }

    protected processGetProviderPayments(response: HttpResponseBase): Observable<PPaymentsInvoiceDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(PPaymentsInvoiceDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PPaymentsInvoiceDto[]>(null as any);
    }

    /**
     * @param idClient (optional) 
     * @param salePointId (optional) 
     * @param useNofiscal (optional) 
     * @param invoiceFormType (optional) 
     * @return Success
     */
    getLetterInvoiceFromClient(idClient: number | undefined, salePointId: number | undefined, useNofiscal: boolean | undefined, invoiceFormType: InvoiceFormType | undefined): Observable<InvoiceLetterAndNumberDto> {
        let url_ = this.baseUrl + "/api/services/app/Invoice/GetLetterInvoiceFromClient?";
        if (idClient === null)
            throw new Error("The parameter 'idClient' cannot be null.");
        else if (idClient !== undefined)
            url_ += "idClient=" + encodeURIComponent("" + idClient) + "&";
        if (salePointId === null)
            throw new Error("The parameter 'salePointId' cannot be null.");
        else if (salePointId !== undefined)
            url_ += "salePointId=" + encodeURIComponent("" + salePointId) + "&";
        if (useNofiscal === null)
            throw new Error("The parameter 'useNofiscal' cannot be null.");
        else if (useNofiscal !== undefined)
            url_ += "useNofiscal=" + encodeURIComponent("" + useNofiscal) + "&";
        if (invoiceFormType === null)
            throw new Error("The parameter 'invoiceFormType' cannot be null.");
        else if (invoiceFormType !== undefined)
            url_ += "invoiceFormType=" + encodeURIComponent("" + invoiceFormType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLetterInvoiceFromClient(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLetterInvoiceFromClient(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InvoiceLetterAndNumberDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InvoiceLetterAndNumberDto>;
        }));
    }

    protected processGetLetterInvoiceFromClient(response: HttpResponseBase): Observable<InvoiceLetterAndNumberDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InvoiceLetterAndNumberDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<InvoiceLetterAndNumberDto>(null as any);
    }

    /**
     * @param keyword (optional) 
     * @param number (optional) 
     * @param from (optional) 
     * @param to (optional) 
     * @param invoiceType (optional) 
     * @param keyClient (optional) 
     * @param isActive (optional) 
     * @param hideDrafts (optional) 
     * @param salePointsIds (optional) 
     * @param orderColumn (optional) 
     * @param order (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllForList(keyword: string | undefined, number: string | undefined, from: moment.Moment | undefined, to: moment.Moment | undefined, invoiceType: InvoiceFormType | undefined, keyClient: string | undefined, isActive: boolean | undefined, hideDrafts: boolean | undefined, salePointsIds: number[] | undefined, orderColumn: string | undefined, order: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<InvoiceListDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Invoice/GetAllForList?";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (number === null)
            throw new Error("The parameter 'number' cannot be null.");
        else if (number !== undefined)
            url_ += "Number=" + encodeURIComponent("" + number) + "&";
        if (from === null)
            throw new Error("The parameter 'from' cannot be null.");
        else if (from !== undefined)
            url_ += "From=" + encodeURIComponent(from ? "" + from.toISOString() : "") + "&";
        if (to === null)
            throw new Error("The parameter 'to' cannot be null.");
        else if (to !== undefined)
            url_ += "To=" + encodeURIComponent(to ? "" + to.toISOString() : "") + "&";
        if (invoiceType === null)
            throw new Error("The parameter 'invoiceType' cannot be null.");
        else if (invoiceType !== undefined)
            url_ += "InvoiceType=" + encodeURIComponent("" + invoiceType) + "&";
        if (keyClient === null)
            throw new Error("The parameter 'keyClient' cannot be null.");
        else if (keyClient !== undefined)
            url_ += "KeyClient=" + encodeURIComponent("" + keyClient) + "&";
        if (isActive === null)
            throw new Error("The parameter 'isActive' cannot be null.");
        else if (isActive !== undefined)
            url_ += "IsActive=" + encodeURIComponent("" + isActive) + "&";
        if (hideDrafts === null)
            throw new Error("The parameter 'hideDrafts' cannot be null.");
        else if (hideDrafts !== undefined)
            url_ += "HideDrafts=" + encodeURIComponent("" + hideDrafts) + "&";
        if (salePointsIds === null)
            throw new Error("The parameter 'salePointsIds' cannot be null.");
        else if (salePointsIds !== undefined)
            salePointsIds && salePointsIds.forEach(item => { url_ += "SalePointsIds=" + encodeURIComponent("" + item) + "&"; });
        if (orderColumn === null)
            throw new Error("The parameter 'orderColumn' cannot be null.");
        else if (orderColumn !== undefined)
            url_ += "OrderColumn=" + encodeURIComponent("" + orderColumn) + "&";
        if (order === null)
            throw new Error("The parameter 'order' cannot be null.");
        else if (order !== undefined)
            url_ += "Order=" + encodeURIComponent("" + order) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllForList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllForList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InvoiceListDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InvoiceListDtoPagedResultDto>;
        }));
    }

    protected processGetAllForList(response: HttpResponseBase): Observable<InvoiceListDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InvoiceListDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<InvoiceListDtoPagedResultDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<InvoiceDto> {
        let url_ = this.baseUrl + "/api/services/app/Invoice/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InvoiceDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InvoiceDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<InvoiceDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InvoiceDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<InvoiceDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getInvoiceDto(id: number | undefined): Observable<InvoiceDto> {
        let url_ = this.baseUrl + "/api/services/app/Invoice/GetInvoiceDto?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetInvoiceDto(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetInvoiceDto(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InvoiceDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InvoiceDto>;
        }));
    }

    protected processGetInvoiceDto(response: HttpResponseBase): Observable<InvoiceDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InvoiceDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<InvoiceDto>(null as any);
    }

    /**
     * @return Success
     */
    getAllCurrencies(): Observable<CurrencySelectDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Invoice/GetAllCurrencies";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllCurrencies(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllCurrencies(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CurrencySelectDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CurrencySelectDto[]>;
        }));
    }

    protected processGetAllCurrencies(response: HttpResponseBase): Observable<CurrencySelectDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(CurrencySelectDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CurrencySelectDto[]>(null as any);
    }

    /**
     * @return Success
     */
    getAllBankAccount(): Observable<BankAccountSelectDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Invoice/GetAllBankAccount";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllBankAccount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllBankAccount(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BankAccountSelectDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BankAccountSelectDto[]>;
        }));
    }

    protected processGetAllBankAccount(response: HttpResponseBase): Observable<BankAccountSelectDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(BankAccountSelectDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BankAccountSelectDto[]>(null as any);
    }

    /**
     * @return Success
     */
    getAllCompanies(): Observable<CompanySelectDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Invoice/GetAllCompanies";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllCompanies(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllCompanies(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CompanySelectDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CompanySelectDto[]>;
        }));
    }

    protected processGetAllCompanies(response: HttpResponseBase): Observable<CompanySelectDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(CompanySelectDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CompanySelectDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    returnSummaryCards(body: CashFilterDto | undefined): Observable<CardsTransactionInfoDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Invoice/ReturnSummaryCards";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReturnSummaryCards(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReturnSummaryCards(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CardsTransactionInfoDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CardsTransactionInfoDto[]>;
        }));
    }

    protected processReturnSummaryCards(response: HttpResponseBase): Observable<CardsTransactionInfoDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(CardsTransactionInfoDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CardsTransactionInfoDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    returnCoupon(body: CashFilterDto | undefined): Observable<CouponTransactionInfoDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Invoice/ReturnCoupon";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReturnCoupon(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReturnCoupon(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CouponTransactionInfoDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CouponTransactionInfoDto[]>;
        }));
    }

    protected processReturnCoupon(response: HttpResponseBase): Observable<CouponTransactionInfoDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(CouponTransactionInfoDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CouponTransactionInfoDto[]>(null as any);
    }

    /**
     * @param amount (optional) 
     * @return Success
     */
    getCompanyQuoteInfo(amount: number | undefined): Observable<CompanyQuoteInfoDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Invoice/GetCompanyQuoteInfo?";
        if (amount === null)
            throw new Error("The parameter 'amount' cannot be null.");
        else if (amount !== undefined)
            url_ += "amount=" + encodeURIComponent("" + amount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCompanyQuoteInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCompanyQuoteInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CompanyQuoteInfoDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CompanyQuoteInfoDto[]>;
        }));
    }

    protected processGetCompanyQuoteInfo(response: HttpResponseBase): Observable<CompanyQuoteInfoDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(CompanyQuoteInfoDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CompanyQuoteInfoDto[]>(null as any);
    }

    /**
     * @return Success
     */
    getLetterTypes(): Observable<EnumDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Invoice/GetLetterTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLetterTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLetterTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EnumDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EnumDto[]>;
        }));
    }

    protected processGetLetterTypes(response: HttpResponseBase): Observable<EnumDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(EnumDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<EnumDto[]>(null as any);
    }

    /**
     * @return Success
     */
    getInvoiceTypes(): Observable<EnumDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Invoice/GetInvoiceTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetInvoiceTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetInvoiceTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EnumDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EnumDto[]>;
        }));
    }

    protected processGetInvoiceTypes(response: HttpResponseBase): Observable<EnumDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(EnumDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<EnumDto[]>(null as any);
    }

    /**
     * @return Success
     */
    allDiscounts(): Observable<DiscountDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Invoice/AllDiscounts";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAllDiscounts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAllDiscounts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DiscountDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DiscountDto[]>;
        }));
    }

    protected processAllDiscounts(response: HttpResponseBase): Observable<DiscountDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(DiscountDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DiscountDto[]>(null as any);
    }

    /**
     * @param invoiceId (optional) 
     * @return Success
     */
    generatePDFInvoice(invoiceId: number | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Invoice/GeneratePDFInvoice?";
        if (invoiceId === null)
            throw new Error("The parameter 'invoiceId' cannot be null.");
        else if (invoiceId !== undefined)
            url_ += "invoiceId=" + encodeURIComponent("" + invoiceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGeneratePDFInvoice(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGeneratePDFInvoice(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGeneratePDFInvoice(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    /**
     * @param invoiceId (optional) 
     * @return Success
     */
    generateHTMLInvoice(invoiceId: number | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Invoice/GenerateHTMLInvoice?";
        if (invoiceId === null)
            throw new Error("The parameter 'invoiceId' cannot be null.");
        else if (invoiceId !== undefined)
            url_ += "invoiceId=" + encodeURIComponent("" + invoiceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGenerateHTMLInvoice(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGenerateHTMLInvoice(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGenerateHTMLInvoice(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    /**
     * @param code (optional) 
     * @param salePointId (optional) 
     * @return Success
     */
    getByAutoserviceCode(code: string | undefined, salePointId: number | undefined): Observable<InvoiceDto> {
        let url_ = this.baseUrl + "/api/services/app/Invoice/GetByAutoserviceCode?";
        if (code === null)
            throw new Error("The parameter 'code' cannot be null.");
        else if (code !== undefined)
            url_ += "code=" + encodeURIComponent("" + code) + "&";
        if (salePointId === null)
            throw new Error("The parameter 'salePointId' cannot be null.");
        else if (salePointId !== undefined)
            url_ += "salePointId=" + encodeURIComponent("" + salePointId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByAutoserviceCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByAutoserviceCode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InvoiceDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InvoiceDto>;
        }));
    }

    protected processGetByAutoserviceCode(response: HttpResponseBase): Observable<InvoiceDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InvoiceDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<InvoiceDto>(null as any);
    }

    /**
     * @param code (optional) 
     * @return Success
     */
    getDataTicketFromCode(code: string | undefined): Observable<InvoiceDto> {
        let url_ = this.baseUrl + "/api/services/app/Invoice/GetDataTicketFromCode?";
        if (code === null)
            throw new Error("The parameter 'code' cannot be null.");
        else if (code !== undefined)
            url_ += "code=" + encodeURIComponent("" + code) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDataTicketFromCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDataTicketFromCode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InvoiceDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InvoiceDto>;
        }));
    }

    protected processGetDataTicketFromCode(response: HttpResponseBase): Observable<InvoiceDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InvoiceDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<InvoiceDto>(null as any);
    }

    /**
     * @param code (optional) 
     * @return Success
     */
    getByCode(code: string | undefined): Observable<VoucherDto> {
        let url_ = this.baseUrl + "/api/services/app/Invoice/GetByCode?";
        if (code === null)
            throw new Error("The parameter 'code' cannot be null.");
        else if (code !== undefined)
            url_ += "code=" + encodeURIComponent("" + code) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByCode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VoucherDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VoucherDto>;
        }));
    }

    protected processGetByCode(response: HttpResponseBase): Observable<VoucherDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VoucherDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<VoucherDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    invoiceFiscalController(body: InvoiceDto | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Invoice/InvoiceFiscalController";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processInvoiceFiscalController(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInvoiceFiscalController(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processInvoiceFiscalController(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    /**
     * @param invoiceId (optional) 
     * @param salePointId (optional) 
     * @return Success
     */
    reprintInvoice(invoiceId: number | undefined, salePointId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Invoice/ReprintInvoice?";
        if (invoiceId === null)
            throw new Error("The parameter 'invoiceId' cannot be null.");
        else if (invoiceId !== undefined)
            url_ += "invoiceId=" + encodeURIComponent("" + invoiceId) + "&";
        if (salePointId === null)
            throw new Error("The parameter 'salePointId' cannot be null.");
        else if (salePointId !== undefined)
            url_ += "salePointId=" + encodeURIComponent("" + salePointId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReprintInvoice(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReprintInvoice(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processReprintInvoice(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getAllPromotionsForTransaction(body: InvoiceDto | undefined): Observable<PromotionInvoiceDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Invoice/GetAllPromotionsForTransaction";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllPromotionsForTransaction(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllPromotionsForTransaction(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PromotionInvoiceDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PromotionInvoiceDto[]>;
        }));
    }

    protected processGetAllPromotionsForTransaction(response: HttpResponseBase): Observable<PromotionInvoiceDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(PromotionInvoiceDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PromotionInvoiceDto[]>(null as any);
    }

    /**
     * @param salePointId (optional) 
     * @param bin (optional) 
     * @return Success
     */
    getAllPromotions(salePointId: number | undefined, bin: number | undefined): Observable<PromotionInvoiceDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Invoice/GetAllPromotions?";
        if (salePointId === null)
            throw new Error("The parameter 'salePointId' cannot be null.");
        else if (salePointId !== undefined)
            url_ += "salePointId=" + encodeURIComponent("" + salePointId) + "&";
        if (bin === null)
            throw new Error("The parameter 'bin' cannot be null.");
        else if (bin !== undefined)
            url_ += "bin=" + encodeURIComponent("" + bin) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllPromotions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllPromotions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PromotionInvoiceDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PromotionInvoiceDto[]>;
        }));
    }

    protected processGetAllPromotions(response: HttpResponseBase): Observable<PromotionInvoiceDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(PromotionInvoiceDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PromotionInvoiceDto[]>(null as any);
    }

    /**
     * @param storeIds (optional) 
     * @param bin (optional) 
     * @return Success
     */
    getAllPromotionsInvoiceWidget(storeIds: number[] | undefined, bin: number | undefined): Observable<PromotionInvoiceWidget[]> {
        let url_ = this.baseUrl + "/api/services/app/Invoice/GetAllPromotionsInvoiceWidget?";
        if (storeIds === null)
            throw new Error("The parameter 'storeIds' cannot be null.");
        else if (storeIds !== undefined)
            storeIds && storeIds.forEach(item => { url_ += "storeIds=" + encodeURIComponent("" + item) + "&"; });
        if (bin === null)
            throw new Error("The parameter 'bin' cannot be null.");
        else if (bin !== undefined)
            url_ += "bin=" + encodeURIComponent("" + bin) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllPromotionsInvoiceWidget(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllPromotionsInvoiceWidget(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PromotionInvoiceWidget[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PromotionInvoiceWidget[]>;
        }));
    }

    protected processGetAllPromotionsInvoiceWidget(response: HttpResponseBase): Observable<PromotionInvoiceWidget[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(PromotionInvoiceWidget.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PromotionInvoiceWidget[]>(null as any);
    }

    /**
     * @param salePointId (optional) 
     * @return Success
     */
    getAndInsertNumber(salePointId: number | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Invoice/GetAndInsertNumber?";
        if (salePointId === null)
            throw new Error("The parameter 'salePointId' cannot be null.");
        else if (salePointId !== undefined)
            url_ += "salePointId=" + encodeURIComponent("" + salePointId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAndInsertNumber(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAndInsertNumber(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGetAndInsertNumber(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    /**
     * @param salePointId (optional) 
     * @return Success
     */
    getAndInsertNumberStockAjust(salePointId: number | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Invoice/GetAndInsertNumberStockAjust?";
        if (salePointId === null)
            throw new Error("The parameter 'salePointId' cannot be null.");
        else if (salePointId !== undefined)
            url_ += "salePointId=" + encodeURIComponent("" + salePointId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAndInsertNumberStockAjust(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAndInsertNumberStockAjust(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGetAndInsertNumberStockAjust(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    applyPromotionsBank(body: InvoiceDto | undefined): Observable<TransactionDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Invoice/ApplyPromotionsBank";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApplyPromotionsBank(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApplyPromotionsBank(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TransactionDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TransactionDto[]>;
        }));
    }

    protected processApplyPromotionsBank(response: HttpResponseBase): Observable<TransactionDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(TransactionDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TransactionDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createPromotionalCreditNoteOrInvoice(body: InvoiceDto | undefined): Observable<InvoiceDto> {
        let url_ = this.baseUrl + "/api/services/app/Invoice/CreatePromotionalCreditNoteOrInvoice";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreatePromotionalCreditNoteOrInvoice(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreatePromotionalCreditNoteOrInvoice(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InvoiceDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InvoiceDto>;
        }));
    }

    protected processCreatePromotionalCreditNoteOrInvoice(response: HttpResponseBase): Observable<InvoiceDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InvoiceDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<InvoiceDto>(null as any);
    }

    /**
     * @param keyword (optional) 
     * @return Success
     */
    getBanks(keyword: string | undefined): Observable<BankDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Invoice/GetBanks?";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "keyword=" + encodeURIComponent("" + keyword) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBanks(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBanks(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BankDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BankDto[]>;
        }));
    }

    protected processGetBanks(response: HttpResponseBase): Observable<BankDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(BankDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BankDto[]>(null as any);
    }

    /**
     * @param code (optional) 
     * @return Success
     */
    getBinWithBankAndCompany(code: number | undefined): Observable<BankAndCompanyDto> {
        let url_ = this.baseUrl + "/api/services/app/Invoice/GetBinWithBankAndCompany?";
        if (code === null)
            throw new Error("The parameter 'code' cannot be null.");
        else if (code !== undefined)
            url_ += "code=" + encodeURIComponent("" + code) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBinWithBankAndCompany(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBinWithBankAndCompany(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BankAndCompanyDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BankAndCompanyDto>;
        }));
    }

    protected processGetBinWithBankAndCompany(response: HttpResponseBase): Observable<BankAndCompanyDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BankAndCompanyDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BankAndCompanyDto>(null as any);
    }

    /**
     * @param keyword (optional) 
     * @return Success
     */
    getVendors(keyword: string | undefined): Observable<UserDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Invoice/GetVendors?";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "keyword=" + encodeURIComponent("" + keyword) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetVendors(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetVendors(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserDto[]>;
        }));
    }

    protected processGetVendors(response: HttpResponseBase): Observable<UserDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(UserDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserDto[]>(null as any);
    }

    /**
     * @param from (optional) 
     * @param to (optional) 
     * @param storeIds (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getSaleRankingProductsWidget(from: moment.Moment | undefined, to: moment.Moment | undefined, storeIds: number[] | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<SalesRankingWidgetDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Invoice/GetSaleRankingProductsWidget?";
        if (from === null)
            throw new Error("The parameter 'from' cannot be null.");
        else if (from !== undefined)
            url_ += "From=" + encodeURIComponent(from ? "" + from.toISOString() : "") + "&";
        if (to === null)
            throw new Error("The parameter 'to' cannot be null.");
        else if (to !== undefined)
            url_ += "To=" + encodeURIComponent(to ? "" + to.toISOString() : "") + "&";
        if (storeIds === null)
            throw new Error("The parameter 'storeIds' cannot be null.");
        else if (storeIds !== undefined)
            storeIds && storeIds.forEach(item => { url_ += "StoreIds=" + encodeURIComponent("" + item) + "&"; });
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSaleRankingProductsWidget(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSaleRankingProductsWidget(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SalesRankingWidgetDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SalesRankingWidgetDtoPagedResultDto>;
        }));
    }

    protected processGetSaleRankingProductsWidget(response: HttpResponseBase): Observable<SalesRankingWidgetDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SalesRankingWidgetDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SalesRankingWidgetDtoPagedResultDto>(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @param userId (optional) 
     * @param isOwner (optional) 
     * @param keyword (optional) 
     * @param from (optional) 
     * @param to (optional) 
     * @param storeIds (optional) 
     * @param productsIds (optional) 
     * @param variantsIds (optional) 
     * @param orderColumn (optional) 
     * @param order (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getSalesByProducts(tenantId: number | undefined, userId: number | undefined, isOwner: boolean | undefined, keyword: string | undefined, from: moment.Moment | undefined, to: moment.Moment | undefined, storeIds: number[] | undefined, productsIds: number[] | undefined, variantsIds: number[] | undefined, orderColumn: string | undefined, order: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<SalesRankingDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Invoice/GetSalesByProducts?";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (isOwner === null)
            throw new Error("The parameter 'isOwner' cannot be null.");
        else if (isOwner !== undefined)
            url_ += "IsOwner=" + encodeURIComponent("" + isOwner) + "&";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (from === null)
            throw new Error("The parameter 'from' cannot be null.");
        else if (from !== undefined)
            url_ += "From=" + encodeURIComponent(from ? "" + from.toISOString() : "") + "&";
        if (to === null)
            throw new Error("The parameter 'to' cannot be null.");
        else if (to !== undefined)
            url_ += "To=" + encodeURIComponent(to ? "" + to.toISOString() : "") + "&";
        if (storeIds === null)
            throw new Error("The parameter 'storeIds' cannot be null.");
        else if (storeIds !== undefined)
            storeIds && storeIds.forEach(item => { url_ += "StoreIds=" + encodeURIComponent("" + item) + "&"; });
        if (productsIds === null)
            throw new Error("The parameter 'productsIds' cannot be null.");
        else if (productsIds !== undefined)
            productsIds && productsIds.forEach(item => { url_ += "ProductsIds=" + encodeURIComponent("" + item) + "&"; });
        if (variantsIds === null)
            throw new Error("The parameter 'variantsIds' cannot be null.");
        else if (variantsIds !== undefined)
            variantsIds && variantsIds.forEach(item => { url_ += "VariantsIds=" + encodeURIComponent("" + item) + "&"; });
        if (orderColumn === null)
            throw new Error("The parameter 'orderColumn' cannot be null.");
        else if (orderColumn !== undefined)
            url_ += "OrderColumn=" + encodeURIComponent("" + orderColumn) + "&";
        if (order === null)
            throw new Error("The parameter 'order' cannot be null.");
        else if (order !== undefined)
            url_ += "Order=" + encodeURIComponent("" + order) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSalesByProducts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSalesByProducts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SalesRankingDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SalesRankingDtoPagedResultDto>;
        }));
    }

    protected processGetSalesByProducts(response: HttpResponseBase): Observable<SalesRankingDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SalesRankingDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SalesRankingDtoPagedResultDto>(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @param userId (optional) 
     * @param isOwner (optional) 
     * @param keyword (optional) 
     * @param from (optional) 
     * @param to (optional) 
     * @param storeIds (optional) 
     * @param productsIds (optional) 
     * @param variantsIds (optional) 
     * @param orderColumn (optional) 
     * @param order (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getSellersRanking(tenantId: number | undefined, userId: number | undefined, isOwner: boolean | undefined, keyword: string | undefined, from: moment.Moment | undefined, to: moment.Moment | undefined, storeIds: number[] | undefined, productsIds: number[] | undefined, variantsIds: number[] | undefined, orderColumn: string | undefined, order: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<SellersRankingDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Invoice/GetSellersRanking?";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (isOwner === null)
            throw new Error("The parameter 'isOwner' cannot be null.");
        else if (isOwner !== undefined)
            url_ += "IsOwner=" + encodeURIComponent("" + isOwner) + "&";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (from === null)
            throw new Error("The parameter 'from' cannot be null.");
        else if (from !== undefined)
            url_ += "From=" + encodeURIComponent(from ? "" + from.toISOString() : "") + "&";
        if (to === null)
            throw new Error("The parameter 'to' cannot be null.");
        else if (to !== undefined)
            url_ += "To=" + encodeURIComponent(to ? "" + to.toISOString() : "") + "&";
        if (storeIds === null)
            throw new Error("The parameter 'storeIds' cannot be null.");
        else if (storeIds !== undefined)
            storeIds && storeIds.forEach(item => { url_ += "StoreIds=" + encodeURIComponent("" + item) + "&"; });
        if (productsIds === null)
            throw new Error("The parameter 'productsIds' cannot be null.");
        else if (productsIds !== undefined)
            productsIds && productsIds.forEach(item => { url_ += "ProductsIds=" + encodeURIComponent("" + item) + "&"; });
        if (variantsIds === null)
            throw new Error("The parameter 'variantsIds' cannot be null.");
        else if (variantsIds !== undefined)
            variantsIds && variantsIds.forEach(item => { url_ += "VariantsIds=" + encodeURIComponent("" + item) + "&"; });
        if (orderColumn === null)
            throw new Error("The parameter 'orderColumn' cannot be null.");
        else if (orderColumn !== undefined)
            url_ += "OrderColumn=" + encodeURIComponent("" + orderColumn) + "&";
        if (order === null)
            throw new Error("The parameter 'order' cannot be null.");
        else if (order !== undefined)
            url_ += "Order=" + encodeURIComponent("" + order) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSellersRanking(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSellersRanking(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SellersRankingDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SellersRankingDto[]>;
        }));
    }

    protected processGetSellersRanking(response: HttpResponseBase): Observable<SellersRankingDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(SellersRankingDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SellersRankingDto[]>(null as any);
    }

    /**
     * @param from (optional) 
     * @param to (optional) 
     * @param productId (optional) 
     * @return Success
     */
    getSalesProductsVariants(from: moment.Moment | undefined, to: moment.Moment | undefined, productId: number | undefined): Observable<VariantsSoldProductsDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Invoice/GetSalesProductsVariants?";
        if (from === null)
            throw new Error("The parameter 'from' cannot be null.");
        else if (from !== undefined)
            url_ += "From=" + encodeURIComponent(from ? "" + from.toISOString() : "") + "&";
        if (to === null)
            throw new Error("The parameter 'to' cannot be null.");
        else if (to !== undefined)
            url_ += "To=" + encodeURIComponent(to ? "" + to.toISOString() : "") + "&";
        if (productId === null)
            throw new Error("The parameter 'productId' cannot be null.");
        else if (productId !== undefined)
            url_ += "ProductId=" + encodeURIComponent("" + productId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSalesProductsVariants(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSalesProductsVariants(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VariantsSoldProductsDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VariantsSoldProductsDto[]>;
        }));
    }

    protected processGetSalesProductsVariants(response: HttpResponseBase): Observable<VariantsSoldProductsDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(VariantsSoldProductsDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<VariantsSoldProductsDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    deletePromotionsCreditNote(body: InvoiceDto | undefined): Observable<InvoiceDto> {
        let url_ = this.baseUrl + "/api/services/app/Invoice/DeletePromotionsCreditNote";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeletePromotionsCreditNote(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeletePromotionsCreditNote(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InvoiceDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InvoiceDto>;
        }));
    }

    protected processDeletePromotionsCreditNote(response: HttpResponseBase): Observable<InvoiceDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InvoiceDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<InvoiceDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    applyPromotionsInvoice(body: InvoiceDto | undefined): Observable<InvoiceDto> {
        let url_ = this.baseUrl + "/api/services/app/Invoice/ApplyPromotionsInvoice";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApplyPromotionsInvoice(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApplyPromotionsInvoice(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InvoiceDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InvoiceDto>;
        }));
    }

    protected processApplyPromotionsInvoice(response: HttpResponseBase): Observable<InvoiceDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InvoiceDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<InvoiceDto>(null as any);
    }

    /**
     * @param storeId (optional) 
     * @param priceListId (optional) 
     * @param body (optional) 
     * @return Success
     */
    seachrProductsToApplyPromotions(storeId: number | undefined, priceListId: number | undefined, body: InvoiceProductDto[] | undefined): Observable<InvoiceProductDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Invoice/SeachrProductsToApplyPromotions?";
        if (storeId === null)
            throw new Error("The parameter 'storeId' cannot be null.");
        else if (storeId !== undefined)
            url_ += "storeId=" + encodeURIComponent("" + storeId) + "&";
        if (priceListId === null)
            throw new Error("The parameter 'priceListId' cannot be null.");
        else if (priceListId !== undefined)
            url_ += "priceListId=" + encodeURIComponent("" + priceListId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSeachrProductsToApplyPromotions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSeachrProductsToApplyPromotions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InvoiceProductDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InvoiceProductDto[]>;
        }));
    }

    protected processSeachrProductsToApplyPromotions(response: HttpResponseBase): Observable<InvoiceProductDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(InvoiceProductDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<InvoiceProductDto[]>(null as any);
    }

    /**
     * @return Success
     */
    checkPermissionToUseNoFiscal(): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Invoice/CheckPermissionToUseNoFiscal";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckPermissionToUseNoFiscal(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckPermissionToUseNoFiscal(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processCheckPermissionToUseNoFiscal(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    setNoFiscalToFiscalInvoice(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Invoice/SetNoFiscalToFiscalInvoice?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetNoFiscalToFiscalInvoice(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetNoFiscalToFiscalInvoice(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSetNoFiscalToFiscalInvoice(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param keyword (optional) 
     * @param number (optional) 
     * @param from (optional) 
     * @param to (optional) 
     * @param invoiceType (optional) 
     * @param keyClient (optional) 
     * @param isActive (optional) 
     * @param hideDrafts (optional) 
     * @param salePointsIds (optional) 
     * @param orderColumn (optional) 
     * @param order (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, number: string | undefined, from: moment.Moment | undefined, to: moment.Moment | undefined, invoiceType: InvoiceFormType | undefined, keyClient: string | undefined, isActive: boolean | undefined, hideDrafts: boolean | undefined, salePointsIds: number[] | undefined, orderColumn: string | undefined, order: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<InvoiceDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Invoice/GetAll?";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (number === null)
            throw new Error("The parameter 'number' cannot be null.");
        else if (number !== undefined)
            url_ += "Number=" + encodeURIComponent("" + number) + "&";
        if (from === null)
            throw new Error("The parameter 'from' cannot be null.");
        else if (from !== undefined)
            url_ += "From=" + encodeURIComponent(from ? "" + from.toISOString() : "") + "&";
        if (to === null)
            throw new Error("The parameter 'to' cannot be null.");
        else if (to !== undefined)
            url_ += "To=" + encodeURIComponent(to ? "" + to.toISOString() : "") + "&";
        if (invoiceType === null)
            throw new Error("The parameter 'invoiceType' cannot be null.");
        else if (invoiceType !== undefined)
            url_ += "InvoiceType=" + encodeURIComponent("" + invoiceType) + "&";
        if (keyClient === null)
            throw new Error("The parameter 'keyClient' cannot be null.");
        else if (keyClient !== undefined)
            url_ += "KeyClient=" + encodeURIComponent("" + keyClient) + "&";
        if (isActive === null)
            throw new Error("The parameter 'isActive' cannot be null.");
        else if (isActive !== undefined)
            url_ += "IsActive=" + encodeURIComponent("" + isActive) + "&";
        if (hideDrafts === null)
            throw new Error("The parameter 'hideDrafts' cannot be null.");
        else if (hideDrafts !== undefined)
            url_ += "HideDrafts=" + encodeURIComponent("" + hideDrafts) + "&";
        if (salePointsIds === null)
            throw new Error("The parameter 'salePointsIds' cannot be null.");
        else if (salePointsIds !== undefined)
            salePointsIds && salePointsIds.forEach(item => { url_ += "SalePointsIds=" + encodeURIComponent("" + item) + "&"; });
        if (orderColumn === null)
            throw new Error("The parameter 'orderColumn' cannot be null.");
        else if (orderColumn !== undefined)
            url_ += "OrderColumn=" + encodeURIComponent("" + orderColumn) + "&";
        if (order === null)
            throw new Error("The parameter 'order' cannot be null.");
        else if (order !== undefined)
            url_ += "Order=" + encodeURIComponent("" + order) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InvoiceDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InvoiceDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<InvoiceDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InvoiceDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<InvoiceDtoPagedResultDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: InvoiceDto | undefined): Observable<InvoiceDto> {
        let url_ = this.baseUrl + "/api/services/app/Invoice/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InvoiceDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InvoiceDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<InvoiceDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InvoiceDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<InvoiceDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Invoice/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class IrsaServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param sorting (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(sorting: string | undefined, startDate: moment.Moment | undefined, endDate: moment.Moment | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<IrsaProcessDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Irsa/GetAll?";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IrsaProcessDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IrsaProcessDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<IrsaProcessDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IrsaProcessDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<IrsaProcessDtoPagedResultDto>(null as any);
    }
}

@Injectable()
export class LogServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: AbpLogDto | undefined): Observable<AbpLogDto> {
        let url_ = this.baseUrl + "/api/services/app/Log/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AbpLogDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AbpLogDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<AbpLogDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AbpLogDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AbpLogDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Log/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: AbpLogDto | undefined): Observable<AbpLogDto> {
        let url_ = this.baseUrl + "/api/services/app/Log/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AbpLogDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AbpLogDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<AbpLogDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AbpLogDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AbpLogDto>(null as any);
    }

    /**
     * @param keyword (optional) 
     * @param from (optional) 
     * @param to (optional) 
     * @param order (optional) 
     * @param level (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, from: moment.Moment | undefined, to: moment.Moment | undefined, order: LogOrderModel | undefined, level: LogLevelModel | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<AbpLogDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Log/GetAll?";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (from === null)
            throw new Error("The parameter 'from' cannot be null.");
        else if (from !== undefined)
            url_ += "From=" + encodeURIComponent(from ? "" + from.toISOString() : "") + "&";
        if (to === null)
            throw new Error("The parameter 'to' cannot be null.");
        else if (to !== undefined)
            url_ += "To=" + encodeURIComponent(to ? "" + to.toISOString() : "") + "&";
        if (order === null)
            throw new Error("The parameter 'order' cannot be null.");
        else if (order !== undefined)
            url_ += "Order=" + encodeURIComponent("" + order) + "&";
        if (level === null)
            throw new Error("The parameter 'level' cannot be null.");
        else if (level !== undefined)
            url_ += "Level=" + encodeURIComponent("" + level) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AbpLogDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AbpLogDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<AbpLogDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AbpLogDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AbpLogDtoPagedResultDto>(null as any);
    }

    /**
     * @return Success
     */
    getLogsLevels(): Observable<EnumDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Log/GetLogsLevels";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLogsLevels(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLogsLevels(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EnumDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EnumDto[]>;
        }));
    }

    protected processGetLogsLevels(response: HttpResponseBase): Observable<EnumDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(EnumDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<EnumDto[]>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<AbpLogDto> {
        let url_ = this.baseUrl + "/api/services/app/Log/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AbpLogDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AbpLogDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<AbpLogDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AbpLogDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AbpLogDto>(null as any);
    }
}

@Injectable()
export class LoyaltyCategoryServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: LoyaltyCategoryDto | undefined): Observable<LoyaltyCategoryDto> {
        let url_ = this.baseUrl + "/api/services/app/LoyaltyCategory/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LoyaltyCategoryDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LoyaltyCategoryDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<LoyaltyCategoryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LoyaltyCategoryDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LoyaltyCategoryDto>(null as any);
    }

    /**
     * @param keyword (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<LoyaltyCategoryDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/LoyaltyCategory/GetAll?";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LoyaltyCategoryDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LoyaltyCategoryDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<LoyaltyCategoryDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LoyaltyCategoryDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LoyaltyCategoryDtoPagedResultDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/LoyaltyCategory/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: LoyaltyCategoryDto | undefined): Observable<LoyaltyCategoryDto> {
        let url_ = this.baseUrl + "/api/services/app/LoyaltyCategory/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LoyaltyCategoryDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LoyaltyCategoryDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<LoyaltyCategoryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LoyaltyCategoryDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LoyaltyCategoryDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<LoyaltyCategoryDto> {
        let url_ = this.baseUrl + "/api/services/app/LoyaltyCategory/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LoyaltyCategoryDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LoyaltyCategoryDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<LoyaltyCategoryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LoyaltyCategoryDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LoyaltyCategoryDto>(null as any);
    }
}

@Injectable()
export class PriceListServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: PriceListDto | undefined): Observable<PriceListDto> {
        let url_ = this.baseUrl + "/api/services/app/PriceList/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PriceListDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PriceListDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<PriceListDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PriceListDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PriceListDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: PriceListDto | undefined): Observable<PriceListDto> {
        let url_ = this.baseUrl + "/api/services/app/PriceList/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PriceListDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PriceListDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<PriceListDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PriceListDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PriceListDto>(null as any);
    }

    /**
     * @return Success
     */
    getAllListPrice(): Observable<PriceListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/PriceList/GetAllListPrice";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllListPrice(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllListPrice(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PriceListDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PriceListDto[]>;
        }));
    }

    protected processGetAllListPrice(response: HttpResponseBase): Observable<PriceListDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(PriceListDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PriceListDto[]>(null as any);
    }

    /**
     * @return Success
     */
    getAllActivePriceList(): Observable<PriceListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/PriceList/GetAllActivePriceList";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllActivePriceList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllActivePriceList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PriceListDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PriceListDto[]>;
        }));
    }

    protected processGetAllActivePriceList(response: HttpResponseBase): Observable<PriceListDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(PriceListDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PriceListDto[]>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getPriceList(id: number | undefined): Observable<PriceListDto> {
        let url_ = this.baseUrl + "/api/services/app/PriceList/GetPriceList?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPriceList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPriceList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PriceListDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PriceListDto>;
        }));
    }

    protected processGetPriceList(response: HttpResponseBase): Observable<PriceListDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PriceListDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PriceListDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    disablePriceList(body: PriceListDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PriceList/DisablePriceList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDisablePriceList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDisablePriceList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDisablePriceList(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param keyword (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PriceListDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/PriceList/GetAll?";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PriceListDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PriceListDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PriceListDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PriceListDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PriceListDtoPagedResultDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<PriceListDto> {
        let url_ = this.baseUrl + "/api/services/app/PriceList/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PriceListDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PriceListDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<PriceListDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PriceListDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PriceListDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PriceList/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class PrinterServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: PrinterInsertDto | undefined): Observable<PrinterDto> {
        let url_ = this.baseUrl + "/api/services/app/Printer/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PrinterDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PrinterDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<PrinterDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PrinterDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PrinterDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: PrinterInsertDto | undefined): Observable<PrinterDto> {
        let url_ = this.baseUrl + "/api/services/app/Printer/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PrinterDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PrinterDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<PrinterDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PrinterDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PrinterDto>(null as any);
    }

    /**
     * @param keyword (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PrinterDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Printer/GetAll?";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PrinterDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PrinterDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PrinterDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PrinterDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PrinterDtoPagedResultDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Printer/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param str (optional) 
     * @return Success
     */
    getConfig(str: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Printer/GetConfig?";
        if (str === null)
            throw new Error("The parameter 'str' cannot be null.");
        else if (str !== undefined)
            url_ += "str=" + encodeURIComponent("" + str) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetConfig(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetConfig(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetConfig(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    /**
     * @param printId (optional) 
     * @return Success
     */
    sendDataInvoiceToPrint(printId: number | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Printer/SendDataInvoiceToPrint?";
        if (printId === null)
            throw new Error("The parameter 'printId' cannot be null.");
        else if (printId !== undefined)
            url_ += "printId=" + encodeURIComponent("" + printId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendDataInvoiceToPrint(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendDataInvoiceToPrint(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processSendDataInvoiceToPrint(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @return Success
     */
    getSoftwares(): Observable<SoftwareDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Printer/GetSoftwares";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSoftwares(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSoftwares(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SoftwareDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SoftwareDto[]>;
        }));
    }

    protected processGetSoftwares(response: HttpResponseBase): Observable<SoftwareDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(SoftwareDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SoftwareDto[]>(null as any);
    }

    /**
     * @return Success
     */
    getPrinterTypes(): Observable<EnumDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Printer/GetPrinterTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPrinterTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPrinterTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EnumDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EnumDto[]>;
        }));
    }

    protected processGetPrinterTypes(response: HttpResponseBase): Observable<EnumDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(EnumDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<EnumDto[]>(null as any);
    }

    /**
     * @param salePointId (optional) 
     * @return Success
     */
    boxClosureZ(salePointId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Printer/BoxClosureZ?";
        if (salePointId === null)
            throw new Error("The parameter 'salePointId' cannot be null.");
        else if (salePointId !== undefined)
            url_ += "salePointId=" + encodeURIComponent("" + salePointId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBoxClosureZ(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBoxClosureZ(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processBoxClosureZ(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param salePointId (optional) 
     * @return Success
     */
    boxClosureX(salePointId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Printer/BoxClosureX?";
        if (salePointId === null)
            throw new Error("The parameter 'salePointId' cannot be null.");
        else if (salePointId !== undefined)
            url_ += "salePointId=" + encodeURIComponent("" + salePointId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBoxClosureX(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBoxClosureX(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processBoxClosureX(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    downloadAfipReport(body: AfipReportDataDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Printer/DownloadAfipReport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadAfipReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadAfipReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDownloadAfipReport(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    responseOrder(body: any | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Printer/ResponseOrder";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processResponseOrder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResponseOrder(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processResponseOrder(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @param userId (optional) 
     * @param isPaid (optional) 
     * @return Success
     */
    completeOrder(tenantId: string | undefined, userId: string | undefined, isPaid: boolean | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Printer/CompleteOrder?";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (isPaid === null)
            throw new Error("The parameter 'isPaid' cannot be null.");
        else if (isPaid !== undefined)
            url_ += "isPaid=" + encodeURIComponent("" + isPaid) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCompleteOrder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCompleteOrder(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCompleteOrder(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<PrinterDto> {
        let url_ = this.baseUrl + "/api/services/app/Printer/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PrinterDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PrinterDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<PrinterDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PrinterDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PrinterDto>(null as any);
    }
}

@Injectable()
export class ProcessLogServiceServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param processImportId (optional) 
     * @return Success
     */
    getProcesslog(processImportId: string | undefined): Observable<ProcessLogDto> {
        let url_ = this.baseUrl + "/api/services/app/ProcessLogService/GetProcesslog?";
        if (processImportId === null)
            throw new Error("The parameter 'processImportId' cannot be null.");
        else if (processImportId !== undefined)
            url_ += "processImportId=" + encodeURIComponent("" + processImportId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProcesslog(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProcesslog(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProcessLogDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProcessLogDto>;
        }));
    }

    protected processGetProcesslog(response: HttpResponseBase): Observable<ProcessLogDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProcessLogDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProcessLogDto>(null as any);
    }

    /**
     * @param processImportId (optional) 
     * @return Success
     */
    getProcesslogInfo(processImportId: string | undefined): Observable<{ [key: string]: any; }> {
        let url_ = this.baseUrl + "/api/services/app/ProcessLogService/GetProcesslogInfo?";
        if (processImportId === null)
            throw new Error("The parameter 'processImportId' cannot be null.");
        else if (processImportId !== undefined)
            url_ += "processImportId=" + encodeURIComponent("" + processImportId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProcesslogInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProcesslogInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<{ [key: string]: any; }>;
                }
            } else
                return _observableThrow(response_) as any as Observable<{ [key: string]: any; }>;
        }));
    }

    protected processGetProcesslogInfo(response: HttpResponseBase): Observable<{ [key: string]: any; }> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                result200 = {} as any;
                for (let key in resultData200) {
                    if (resultData200.hasOwnProperty(key))
                        (<any>result200)[key] = resultData200[key] !== undefined ? resultData200[key] : <any>null;
                }
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<{ [key: string]: any; }>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<ProcessLogDto> {
        let url_ = this.baseUrl + "/api/services/app/ProcessLogService/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProcessLogDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProcessLogDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ProcessLogDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProcessLogDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProcessLogDto>(null as any);
    }

    /**
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<ProcessLogDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/ProcessLogService/GetAll?";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProcessLogDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProcessLogDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<ProcessLogDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProcessLogDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProcessLogDtoPagedResultDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: ProcessLogDto | undefined): Observable<ProcessLogDto> {
        let url_ = this.baseUrl + "/api/services/app/ProcessLogService/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProcessLogDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProcessLogDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<ProcessLogDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProcessLogDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProcessLogDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: ProcessLogDto | undefined): Observable<ProcessLogDto> {
        let url_ = this.baseUrl + "/api/services/app/ProcessLogService/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProcessLogDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProcessLogDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<ProcessLogDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProcessLogDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProcessLogDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ProcessLogService/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class ProductServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param keyword (optional) 
     * @param isActive (optional) 
     * @param store (optional) 
     * @param order (optional) 
     * @param orderColumn (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, isActive: boolean | undefined, store: string | undefined, order: string | undefined, orderColumn: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PageProductDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Product/GetAll?";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (isActive === null)
            throw new Error("The parameter 'isActive' cannot be null.");
        else if (isActive !== undefined)
            url_ += "IsActive=" + encodeURIComponent("" + isActive) + "&";
        if (store === null)
            throw new Error("The parameter 'store' cannot be null.");
        else if (store !== undefined)
            url_ += "Store=" + encodeURIComponent("" + store) + "&";
        if (order === null)
            throw new Error("The parameter 'order' cannot be null.");
        else if (order !== undefined)
            url_ += "Order=" + encodeURIComponent("" + order) + "&";
        if (orderColumn === null)
            throw new Error("The parameter 'orderColumn' cannot be null.");
        else if (orderColumn !== undefined)
            url_ += "OrderColumn=" + encodeURIComponent("" + orderColumn) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PageProductDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PageProductDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PageProductDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PageProductDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PageProductDtoPagedResultDto>(null as any);
    }

    /**
     * @param keyword (optional) 
     * @param isActive (optional) 
     * @param store (optional) 
     * @param order (optional) 
     * @param orderColumn (optional) 
     * @param tenantId (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllForList(keyword: string | undefined, isActive: boolean | undefined, store: string | undefined, order: string | undefined, orderColumn: string | undefined, tenantId: number | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<ProductsListDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Product/GetAllForList?";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (isActive === null)
            throw new Error("The parameter 'isActive' cannot be null.");
        else if (isActive !== undefined)
            url_ += "IsActive=" + encodeURIComponent("" + isActive) + "&";
        if (store === null)
            throw new Error("The parameter 'store' cannot be null.");
        else if (store !== undefined)
            url_ += "Store=" + encodeURIComponent("" + store) + "&";
        if (order === null)
            throw new Error("The parameter 'order' cannot be null.");
        else if (order !== undefined)
            url_ += "Order=" + encodeURIComponent("" + order) + "&";
        if (orderColumn === null)
            throw new Error("The parameter 'orderColumn' cannot be null.");
        else if (orderColumn !== undefined)
            url_ += "OrderColumn=" + encodeURIComponent("" + orderColumn) + "&";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllForList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllForList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductsListDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductsListDtoPagedResultDto>;
        }));
    }

    protected processGetAllForList(response: HttpResponseBase): Observable<ProductsListDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProductsListDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProductsListDtoPagedResultDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: ProductInputDto | undefined): Observable<PageProductDto> {
        let url_ = this.baseUrl + "/api/services/app/Product/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PageProductDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PageProductDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<PageProductDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PageProductDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PageProductDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: ProductUpdateDto | undefined): Observable<PageProductDto> {
        let url_ = this.baseUrl + "/api/services/app/Product/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PageProductDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PageProductDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<PageProductDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PageProductDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PageProductDto>(null as any);
    }

    /**
     * @return Success
     */
    getAllCurrencies(): Observable<CurrencySelectDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Product/GetAllCurrencies";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllCurrencies(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllCurrencies(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CurrencySelectDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CurrencySelectDto[]>;
        }));
    }

    protected processGetAllCurrencies(response: HttpResponseBase): Observable<CurrencySelectDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(CurrencySelectDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CurrencySelectDto[]>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Product/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    disableProduct(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Product/DisableProduct?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDisableProduct(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDisableProduct(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDisableProduct(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<PageProductDto> {
        let url_ = this.baseUrl + "/api/services/app/Product/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PageProductDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PageProductDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<PageProductDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PageProductDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PageProductDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @param salePointId (optional) 
     * @return Success
     */
    getProductDto(id: number | undefined, salePointId: number | undefined): Observable<ProductDto> {
        let url_ = this.baseUrl + "/api/services/app/Product/GetProductDto?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (salePointId === null)
            throw new Error("The parameter 'salePointId' cannot be null.");
        else if (salePointId !== undefined)
            url_ += "salePointId=" + encodeURIComponent("" + salePointId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProductDto(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProductDto(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductDto>;
        }));
    }

    protected processGetProductDto(response: HttpResponseBase): Observable<ProductDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProductDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProductDto>(null as any);
    }

    /**
     * @return Success
     */
    getTaxes(): Observable<TaxDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Product/GetTaxes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTaxes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTaxes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TaxDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TaxDto[]>;
        }));
    }

    protected processGetTaxes(response: HttpResponseBase): Observable<TaxDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(TaxDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TaxDto[]>(null as any);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    readExcel(input: FileParameter | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Product/ReadExcel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (input === null || input === undefined)
            throw new Error("The parameter 'input' cannot be null.");
        else
            content_.append("input", input.data, input.fileName ? input.fileName : "input");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReadExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReadExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processReadExcel(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    getAllProductsGroup(): Observable<ProductGroupDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Product/GetAllProductsGroup";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllProductsGroup(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllProductsGroup(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductGroupDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductGroupDto[]>;
        }));
    }

    protected processGetAllProductsGroup(response: HttpResponseBase): Observable<ProductGroupDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ProductGroupDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProductGroupDto[]>(null as any);
    }

    /**
     * @return Success
     */
    getAllColors(): Observable<ColorDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Product/GetAllColors";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllColors(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllColors(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ColorDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ColorDto[]>;
        }));
    }

    protected processGetAllColors(response: HttpResponseBase): Observable<ColorDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ColorDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ColorDto[]>(null as any);
    }

    /**
     * @return Success
     */
    getAllStores(): Observable<StoreDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Product/GetAllStores";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllStores(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllStores(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StoreDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StoreDto[]>;
        }));
    }

    protected processGetAllStores(response: HttpResponseBase): Observable<StoreDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(StoreDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<StoreDto[]>(null as any);
    }

    /**
     * @param paginate (optional) 
     * @param body (optional) 
     * @return Success
     */
    import(paginate: number | undefined, body: ProductInputDto[] | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Product/Import?";
        if (paginate === null)
            throw new Error("The parameter 'paginate' cannot be null.");
        else if (paginate !== undefined)
            url_ += "paginate=" + encodeURIComponent("" + paginate) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processImport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processImport(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateProducts(body: ProductBulkUpdateDto[] | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Product/UpdateProducts";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateProducts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateProducts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processUpdateProducts(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @param cant (optional) 
     * @return Success
     */
    jsonProduct(tenantId: number | undefined, cant: number | undefined): Observable<JsonProductDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Product/JsonProduct?";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (cant === null)
            throw new Error("The parameter 'cant' cannot be null.");
        else if (cant !== undefined)
            url_ += "cant=" + encodeURIComponent("" + cant) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processJsonProduct(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processJsonProduct(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<JsonProductDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<JsonProductDto[]>;
        }));
    }

    protected processJsonProduct(response: HttpResponseBase): Observable<JsonProductDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(JsonProductDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<JsonProductDto[]>(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @return Success
     */
    updateCacheBackGround(tenantId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Product/UpdateCacheBackGround?";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateCacheBackGround(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateCacheBackGround(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateCacheBackGround(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @param processImportIds (optional) 
     * @param skip (optional) 
     * @param size (optional) 
     * @return Success
     */
    searchExternalIdRelations(tenantId: number | undefined, processImportIds: string | undefined, skip: number | undefined, size: number | undefined): Observable<{ [key: string]: any; }> {
        let url_ = this.baseUrl + "/api/services/app/Product/SearchExternalIdRelations?";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (processImportIds === null)
            throw new Error("The parameter 'processImportIds' cannot be null.");
        else if (processImportIds !== undefined)
            url_ += "processImportIds=" + encodeURIComponent("" + processImportIds) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (size === null)
            throw new Error("The parameter 'size' cannot be null.");
        else if (size !== undefined)
            url_ += "size=" + encodeURIComponent("" + size) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchExternalIdRelations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchExternalIdRelations(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<{ [key: string]: any; }>;
                }
            } else
                return _observableThrow(response_) as any as Observable<{ [key: string]: any; }>;
        }));
    }

    protected processSearchExternalIdRelations(response: HttpResponseBase): Observable<{ [key: string]: any; }> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                result200 = {} as any;
                for (let key in resultData200) {
                    if (resultData200.hasOwnProperty(key))
                        (<any>result200)[key] = resultData200[key] !== undefined ? resultData200[key] : <any>null;
                }
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<{ [key: string]: any; }>(null as any);
    }

    /**
     * @param keywords (optional) 
     * @param store (optional) 
     * @param useNegativeStock (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllListProductInformation(keywords: string[] | undefined, store: string | undefined, useNegativeStock: boolean | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<ProductInformationDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Product/GetAllListProductInformation?";
        if (keywords === null)
            throw new Error("The parameter 'keywords' cannot be null.");
        else if (keywords !== undefined)
            keywords && keywords.forEach(item => { url_ += "Keywords=" + encodeURIComponent("" + item) + "&"; });
        if (store === null)
            throw new Error("The parameter 'store' cannot be null.");
        else if (store !== undefined)
            url_ += "Store=" + encodeURIComponent("" + store) + "&";
        if (useNegativeStock === null)
            throw new Error("The parameter 'useNegativeStock' cannot be null.");
        else if (useNegativeStock !== undefined)
            url_ += "UseNegativeStock=" + encodeURIComponent("" + useNegativeStock) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllListProductInformation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllListProductInformation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductInformationDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductInformationDtoPagedResultDto>;
        }));
    }

    protected processGetAllListProductInformation(response: HttpResponseBase): Observable<ProductInformationDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProductInformationDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProductInformationDtoPagedResultDto>(null as any);
    }

    /**
     * @param productId (optional) 
     * @param variantId (optional) 
     * @param storeId (optional) 
     * @return Success
     */
    getProductPriceAndStockInformation(productId: number | undefined, variantId: number | undefined, storeId: number | undefined): Observable<StockAndProductPriceInformationDto> {
        let url_ = this.baseUrl + "/api/services/app/Product/GetProductPriceAndStockInformation?";
        if (productId === null)
            throw new Error("The parameter 'productId' cannot be null.");
        else if (productId !== undefined)
            url_ += "ProductId=" + encodeURIComponent("" + productId) + "&";
        if (variantId === null)
            throw new Error("The parameter 'variantId' cannot be null.");
        else if (variantId !== undefined)
            url_ += "VariantId=" + encodeURIComponent("" + variantId) + "&";
        if (storeId === null)
            throw new Error("The parameter 'storeId' cannot be null.");
        else if (storeId !== undefined)
            url_ += "StoreId=" + encodeURIComponent("" + storeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProductPriceAndStockInformation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProductPriceAndStockInformation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StockAndProductPriceInformationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StockAndProductPriceInformationDto>;
        }));
    }

    protected processGetProductPriceAndStockInformation(response: HttpResponseBase): Observable<StockAndProductPriceInformationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StockAndProductPriceInformationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<StockAndProductPriceInformationDto>(null as any);
    }
}

@Injectable()
export class ProductGroupServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param keyword (optional) 
     * @param isActive (optional) 
     * @param includedProducts (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllWithPropertyValues(keyword: string | undefined, isActive: boolean | undefined, includedProducts: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<ProductListDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/ProductGroup/GetAllWithPropertyValues?";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (isActive === null)
            throw new Error("The parameter 'isActive' cannot be null.");
        else if (isActive !== undefined)
            url_ += "IsActive=" + encodeURIComponent("" + isActive) + "&";
        if (includedProducts === null)
            throw new Error("The parameter 'includedProducts' cannot be null.");
        else if (includedProducts !== undefined)
            url_ += "IncludedProducts=" + encodeURIComponent("" + includedProducts) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllWithPropertyValues(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllWithPropertyValues(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductListDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductListDtoPagedResultDto>;
        }));
    }

    protected processGetAllWithPropertyValues(response: HttpResponseBase): Observable<ProductListDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProductListDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProductListDtoPagedResultDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: ProductListDto | undefined): Observable<ProductListDto> {
        let url_ = this.baseUrl + "/api/services/app/ProductGroup/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductListDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductListDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<ProductListDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProductListDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProductListDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: ProductListDto | undefined): Observable<ProductListDto> {
        let url_ = this.baseUrl + "/api/services/app/ProductGroup/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductListDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductListDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<ProductListDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProductListDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProductListDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    disablePromotion(body: ProductListDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ProductGroup/DisablePromotion";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDisablePromotion(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDisablePromotion(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDisablePromotion(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param keyword (optional) 
     * @return Success
     */
    getAllProductList(keyword: string | undefined): Observable<ProductListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ProductGroup/GetAllProductList?";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "keyword=" + encodeURIComponent("" + keyword) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllProductList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllProductList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductListDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductListDto[]>;
        }));
    }

    protected processGetAllProductList(response: HttpResponseBase): Observable<ProductListDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ProductListDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProductListDto[]>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<ProductListDto> {
        let url_ = this.baseUrl + "/api/services/app/ProductGroup/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductListDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductListDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ProductListDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProductListDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProductListDto>(null as any);
    }

    /**
     * @param keyword (optional) 
     * @param isActive (optional) 
     * @param includedProducts (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, isActive: boolean | undefined, includedProducts: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<ProductListDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/ProductGroup/GetAll?";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (isActive === null)
            throw new Error("The parameter 'isActive' cannot be null.");
        else if (isActive !== undefined)
            url_ += "IsActive=" + encodeURIComponent("" + isActive) + "&";
        if (includedProducts === null)
            throw new Error("The parameter 'includedProducts' cannot be null.");
        else if (includedProducts !== undefined)
            url_ += "IncludedProducts=" + encodeURIComponent("" + includedProducts) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductListDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductListDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<ProductListDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProductListDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProductListDtoPagedResultDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ProductGroup/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class ProductPriceServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param keyword (optional) 
     * @param listPriceIds (optional) 
     * @param includeBaseList (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, listPriceIds: number[] | undefined, includeBaseList: boolean | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<ProductPriceDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/ProductPrice/GetAll?";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (listPriceIds === null)
            throw new Error("The parameter 'listPriceIds' cannot be null.");
        else if (listPriceIds !== undefined)
            listPriceIds && listPriceIds.forEach(item => { url_ += "ListPriceIds=" + encodeURIComponent("" + item) + "&"; });
        if (includeBaseList === null)
            throw new Error("The parameter 'includeBaseList' cannot be null.");
        else if (includeBaseList !== undefined)
            url_ += "IncludeBaseList=" + encodeURIComponent("" + includeBaseList) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductPriceDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductPriceDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<ProductPriceDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProductPriceDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProductPriceDtoPagedResultDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: ProductPriceDto | undefined): Observable<ProductPriceDto> {
        let url_ = this.baseUrl + "/api/services/app/ProductPrice/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductPriceDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductPriceDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<ProductPriceDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProductPriceDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProductPriceDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: ProductPriceDto | undefined): Observable<ProductPriceDto> {
        let url_ = this.baseUrl + "/api/services/app/ProductPrice/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductPriceDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductPriceDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<ProductPriceDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProductPriceDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProductPriceDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ProductPrice/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<ProductPriceDto> {
        let url_ = this.baseUrl + "/api/services/app/ProductPrice/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductPriceDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductPriceDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ProductPriceDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProductPriceDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProductPriceDto>(null as any);
    }

    /**
     * @return Success
     */
    getTaxes(): Observable<TaxDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ProductPrice/GetTaxes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTaxes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTaxes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TaxDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TaxDto[]>;
        }));
    }

    protected processGetTaxes(response: HttpResponseBase): Observable<TaxDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(TaxDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TaxDto[]>(null as any);
    }

    /**
     * @param keyword (optional) 
     * @return Success
     */
    getProductsWithVariantInStock(keyword: string | undefined): Observable<ProductInvoiceDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ProductPrice/GetProductsWithVariantInStock?";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "keyword=" + encodeURIComponent("" + keyword) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProductsWithVariantInStock(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProductsWithVariantInStock(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductInvoiceDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductInvoiceDto[]>;
        }));
    }

    protected processGetProductsWithVariantInStock(response: HttpResponseBase): Observable<ProductInvoiceDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ProductInvoiceDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProductInvoiceDto[]>(null as any);
    }

    /**
     * @return Success
     */
    getAllCurrencies(): Observable<CurrencySelectDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ProductPrice/GetAllCurrencies";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllCurrencies(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllCurrencies(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CurrencySelectDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CurrencySelectDto[]>;
        }));
    }

    protected processGetAllCurrencies(response: HttpResponseBase): Observable<CurrencySelectDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(CurrencySelectDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CurrencySelectDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    copyOrEditProduct(body: ProductPriceDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ProductPrice/CopyOrEditProduct";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCopyOrEditProduct(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCopyOrEditProduct(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCopyOrEditProduct(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    readExcel(input: FileParameter | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/ProductPrice/ReadExcel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (input === null || input === undefined)
            throw new Error("The parameter 'input' cannot be null.");
        else
            content_.append("input", input.data, input.fileName ? input.fileName : "input");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReadExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReadExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processReadExcel(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    generateExcelProductListPrice(body: PagedProductPricesResultRequestDto | undefined): Observable<FileExcelDto> {
        let url_ = this.baseUrl + "/api/services/app/ProductPrice/GenerateExcelProductListPrice";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGenerateExcelProductListPrice(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGenerateExcelProductListPrice(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileExcelDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileExcelDto>;
        }));
    }

    protected processGenerateExcelProductListPrice(response: HttpResponseBase): Observable<FileExcelDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileExcelDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileExcelDto>(null as any);
    }

    /**
     * @return Success
     */
    generateTemplateListPrice(): Observable<FileExcelDto> {
        let url_ = this.baseUrl + "/api/services/app/ProductPrice/GenerateTemplateListPrice";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGenerateTemplateListPrice(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGenerateTemplateListPrice(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileExcelDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileExcelDto>;
        }));
    }

    protected processGenerateTemplateListPrice(response: HttpResponseBase): Observable<FileExcelDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileExcelDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileExcelDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    import(body: ProductPriceImportDto[] | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/ProductPrice/Import";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processImport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processImport(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @param processImportId (optional) 
     * @param skip (optional) 
     * @param size (optional) 
     * @return Success
     */
    searchPriceExternalId(tenantId: number | undefined, processImportId: string | undefined, skip: number | undefined, size: number | undefined): Observable<{ [key: string]: any; }> {
        let url_ = this.baseUrl + "/api/services/app/ProductPrice/SearchPriceExternalId?";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (processImportId === null)
            throw new Error("The parameter 'processImportId' cannot be null.");
        else if (processImportId !== undefined)
            url_ += "processImportId=" + encodeURIComponent("" + processImportId) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (size === null)
            throw new Error("The parameter 'size' cannot be null.");
        else if (size !== undefined)
            url_ += "size=" + encodeURIComponent("" + size) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchPriceExternalId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchPriceExternalId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<{ [key: string]: any; }>;
                }
            } else
                return _observableThrow(response_) as any as Observable<{ [key: string]: any; }>;
        }));
    }

    protected processSearchPriceExternalId(response: HttpResponseBase): Observable<{ [key: string]: any; }> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                result200 = {} as any;
                for (let key in resultData200) {
                    if (resultData200.hasOwnProperty(key))
                        (<any>result200)[key] = resultData200[key] !== undefined ? resultData200[key] : <any>null;
                }
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<{ [key: string]: any; }>(null as any);
    }

    /**
     * @param cashierId (optional) 
     * @return Success
     */
    searchDefaultPriceListId(cashierId: number | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/ProductPrice/SearchDefaultPriceListId?";
        if (cashierId === null)
            throw new Error("The parameter 'cashierId' cannot be null.");
        else if (cashierId !== undefined)
            url_ += "cashierId=" + encodeURIComponent("" + cashierId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchDefaultPriceListId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchDefaultPriceListId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processSearchDefaultPriceListId(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }
}

@Injectable()
export class PromotionServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: PromotionDto | undefined): Observable<PromotionDto> {
        let url_ = this.baseUrl + "/api/services/app/Promotion/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PromotionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PromotionDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<PromotionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PromotionDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PromotionDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: PromotionDto | undefined): Observable<PromotionDto> {
        let url_ = this.baseUrl + "/api/services/app/Promotion/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PromotionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PromotionDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<PromotionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PromotionDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PromotionDto>(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @param userId (optional) 
     * @param storeIds (optional) 
     * @param keyword (optional) 
     * @param promotionType (optional) 
     * @param statuses (optional) 
     * @param isActive (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(tenantId: number | undefined, userId: number | undefined, storeIds: number[] | undefined, keyword: string | undefined, promotionType: PromotionType | undefined, statuses: PromotionStatus[] | undefined, isActive: boolean | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PromotionDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Promotion/GetAll?";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (storeIds === null)
            throw new Error("The parameter 'storeIds' cannot be null.");
        else if (storeIds !== undefined)
            storeIds && storeIds.forEach(item => { url_ += "StoreIds=" + encodeURIComponent("" + item) + "&"; });
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (promotionType === null)
            throw new Error("The parameter 'promotionType' cannot be null.");
        else if (promotionType !== undefined)
            url_ += "PromotionType=" + encodeURIComponent("" + promotionType) + "&";
        if (statuses === null)
            throw new Error("The parameter 'statuses' cannot be null.");
        else if (statuses !== undefined)
            statuses && statuses.forEach(item => { url_ += "Statuses=" + encodeURIComponent("" + item) + "&"; });
        if (isActive === null)
            throw new Error("The parameter 'isActive' cannot be null.");
        else if (isActive !== undefined)
            url_ += "IsActive=" + encodeURIComponent("" + isActive) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PromotionDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PromotionDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PromotionDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PromotionDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PromotionDtoPagedResultDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Promotion/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    getPromotionType(): Observable<EnumDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Promotion/GetPromotionType";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPromotionType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPromotionType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EnumDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EnumDto[]>;
        }));
    }

    protected processGetPromotionType(response: HttpResponseBase): Observable<EnumDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(EnumDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<EnumDto[]>(null as any);
    }

    /**
     * @return Success
     */
    getPromotionStatus(): Observable<EnumDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Promotion/GetPromotionStatus";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPromotionStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPromotionStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EnumDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EnumDto[]>;
        }));
    }

    protected processGetPromotionStatus(response: HttpResponseBase): Observable<EnumDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(EnumDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<EnumDto[]>(null as any);
    }

    /**
     * @return Success
     */
    getAllStores(): Observable<StoreDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Promotion/GetAllStores";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllStores(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllStores(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StoreDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StoreDto[]>;
        }));
    }

    protected processGetAllStores(response: HttpResponseBase): Observable<StoreDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(StoreDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<StoreDto[]>(null as any);
    }

    /**
     * @param keyword (optional) 
     * @return Success
     */
    getCompanies(keyword: string | undefined): Observable<CompanyDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Promotion/GetCompanies?";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCompanies(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCompanies(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CompanyDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CompanyDto[]>;
        }));
    }

    protected processGetCompanies(response: HttpResponseBase): Observable<CompanyDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(CompanyDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CompanyDto[]>(null as any);
    }

    /**
     * @param keyword (optional) 
     * @return Success
     */
    getBanks(keyword: string | undefined): Observable<BankDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Promotion/GetBanks?";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "keyword=" + encodeURIComponent("" + keyword) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBanks(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBanks(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BankDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BankDto[]>;
        }));
    }

    protected processGetBanks(response: HttpResponseBase): Observable<BankDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(BankDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BankDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    disablePromotion(body: PromotionDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Promotion/DisablePromotion";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDisablePromotion(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDisablePromotion(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDisablePromotion(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param code (optional) 
     * @return Success
     */
    getPromotionByBin(code: number | undefined): Observable<PromotionDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Promotion/GetPromotionByBin?";
        if (code === null)
            throw new Error("The parameter 'code' cannot be null.");
        else if (code !== undefined)
            url_ += "code=" + encodeURIComponent("" + code) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPromotionByBin(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPromotionByBin(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PromotionDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PromotionDto[]>;
        }));
    }

    protected processGetPromotionByBin(response: HttpResponseBase): Observable<PromotionDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(PromotionDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PromotionDto[]>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getPromotionDto(id: number | undefined): Observable<PromotionDto> {
        let url_ = this.baseUrl + "/api/services/app/Promotion/GetPromotionDto?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPromotionDto(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPromotionDto(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PromotionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PromotionDto>;
        }));
    }

    protected processGetPromotionDto(response: HttpResponseBase): Observable<PromotionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PromotionDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PromotionDto>(null as any);
    }

    /**
     * @param keyword (optional) 
     * @param body (optional) 
     * @return Success
     */
    filterProducts(keyword: string | undefined, body: string[] | undefined): Observable<ProductDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Promotion/FilterProducts?";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "keyword=" + encodeURIComponent("" + keyword) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFilterProducts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFilterProducts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductDto[]>;
        }));
    }

    protected processFilterProducts(response: HttpResponseBase): Observable<ProductDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ProductDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProductDto[]>(null as any);
    }

    /**
     * @return Success
     */
    getTaxConditionTypes(): Observable<EnumDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Promotion/GetTaxConditionTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTaxConditionTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTaxConditionTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EnumDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EnumDto[]>;
        }));
    }

    protected processGetTaxConditionTypes(response: HttpResponseBase): Observable<EnumDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(EnumDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<EnumDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    filterProductsPromotions(body: ProductListDto | undefined): Observable<ProductPromotionDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Promotion/FilterProductsPromotions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFilterProductsPromotions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFilterProductsPromotions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductPromotionDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductPromotionDto[]>;
        }));
    }

    protected processFilterProductsPromotions(response: HttpResponseBase): Observable<ProductPromotionDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ProductPromotionDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProductPromotionDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getProductList(body: PromotionConditionGroupDto | undefined): Observable<ProductPromotionDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Promotion/GetProductList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProductList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProductList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductPromotionDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductPromotionDto[]>;
        }));
    }

    protected processGetProductList(response: HttpResponseBase): Observable<ProductPromotionDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ProductPromotionDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProductPromotionDto[]>(null as any);
    }

    /**
     * @param keyword (optional) 
     * @return Success
     */
    getLoyaltyCategories(keyword: string | undefined): Observable<LoyaltyCategoryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Promotion/GetLoyaltyCategories?";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "keyword=" + encodeURIComponent("" + keyword) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLoyaltyCategories(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLoyaltyCategories(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LoyaltyCategoryDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LoyaltyCategoryDto[]>;
        }));
    }

    protected processGetLoyaltyCategories(response: HttpResponseBase): Observable<LoyaltyCategoryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(LoyaltyCategoryDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LoyaltyCategoryDto[]>(null as any);
    }

    /**
     * @param categoryId (optional) 
     * @return Success
     */
    getLoyaltyCategory(categoryId: number | undefined): Observable<LoyaltyCategoryDto> {
        let url_ = this.baseUrl + "/api/services/app/Promotion/GetLoyaltyCategory?";
        if (categoryId === null)
            throw new Error("The parameter 'categoryId' cannot be null.");
        else if (categoryId !== undefined)
            url_ += "categoryId=" + encodeURIComponent("" + categoryId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLoyaltyCategory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLoyaltyCategory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LoyaltyCategoryDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LoyaltyCategoryDto>;
        }));
    }

    protected processGetLoyaltyCategory(response: HttpResponseBase): Observable<LoyaltyCategoryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LoyaltyCategoryDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LoyaltyCategoryDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getBankById(id: number | undefined): Observable<BankDto> {
        let url_ = this.baseUrl + "/api/services/app/Promotion/GetBankById?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBankById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBankById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BankDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BankDto>;
        }));
    }

    protected processGetBankById(response: HttpResponseBase): Observable<BankDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BankDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BankDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getCompanyById(id: number | undefined): Observable<CompanyDto> {
        let url_ = this.baseUrl + "/api/services/app/Promotion/GetCompanyById?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCompanyById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCompanyById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CompanyDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CompanyDto>;
        }));
    }

    protected processGetCompanyById(response: HttpResponseBase): Observable<CompanyDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CompanyDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CompanyDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<PromotionDto> {
        let url_ = this.baseUrl + "/api/services/app/Promotion/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PromotionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PromotionDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<PromotionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PromotionDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PromotionDto>(null as any);
    }
}

@Injectable()
export class PropertyServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param propertyId (optional) 
     * @return Success
     */
    getWithValues(propertyId: number | undefined): Observable<PropertyDto> {
        let url_ = this.baseUrl + "/api/services/app/Property/GetWithValues?";
        if (propertyId === null)
            throw new Error("The parameter 'propertyId' cannot be null.");
        else if (propertyId !== undefined)
            url_ += "propertyId=" + encodeURIComponent("" + propertyId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetWithValues(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWithValues(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PropertyDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PropertyDto>;
        }));
    }

    protected processGetWithValues(response: HttpResponseBase): Observable<PropertyDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PropertyDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PropertyDto>(null as any);
    }

    /**
     * @return Success
     */
    getAllWithValues(): Observable<PropertyDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Property/GetAllWithValues";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllWithValues(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllWithValues(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PropertyDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PropertyDto[]>;
        }));
    }

    protected processGetAllWithValues(response: HttpResponseBase): Observable<PropertyDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(PropertyDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PropertyDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: PropertyDto | undefined): Observable<PropertyDto> {
        let url_ = this.baseUrl + "/api/services/app/Property/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PropertyDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PropertyDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<PropertyDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PropertyDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PropertyDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Property/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: PropertyDto | undefined): Observable<PropertyDto> {
        let url_ = this.baseUrl + "/api/services/app/Property/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PropertyDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PropertyDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<PropertyDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PropertyDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PropertyDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    deletePropertyValue(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Property/DeletePropertyValue?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeletePropertyValue(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeletePropertyValue(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeletePropertyValue(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<PropertyDto> {
        let url_ = this.baseUrl + "/api/services/app/Property/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PropertyDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PropertyDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<PropertyDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PropertyDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PropertyDto>(null as any);
    }

    /**
     * @param keyword (optional) 
     * @param isActive (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, isActive: boolean | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PropertyDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Property/GetAll?";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (isActive === null)
            throw new Error("The parameter 'isActive' cannot be null.");
        else if (isActive !== undefined)
            url_ += "IsActive=" + encodeURIComponent("" + isActive) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PropertyDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PropertyDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PropertyDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PropertyDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PropertyDtoPagedResultDto>(null as any);
    }
}

@Injectable()
export class PropertyGroupServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<ProductGroupDto> {
        let url_ = this.baseUrl + "/api/services/app/PropertyGroup/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductGroupDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductGroupDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ProductGroupDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProductGroupDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProductGroupDto>(null as any);
    }

    /**
     * @param keyword (optional) 
     * @param isActive (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, isActive: boolean | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<ProductGroupDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/PropertyGroup/GetAll?";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (isActive === null)
            throw new Error("The parameter 'isActive' cannot be null.");
        else if (isActive !== undefined)
            url_ += "IsActive=" + encodeURIComponent("" + isActive) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductGroupDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductGroupDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<ProductGroupDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProductGroupDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProductGroupDtoPagedResultDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: ProductGroupDto | undefined): Observable<ProductGroupDto> {
        let url_ = this.baseUrl + "/api/services/app/PropertyGroup/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductGroupDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductGroupDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<ProductGroupDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProductGroupDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProductGroupDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: ProductGroupDto | undefined): Observable<ProductGroupDto> {
        let url_ = this.baseUrl + "/api/services/app/PropertyGroup/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductGroupDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductGroupDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<ProductGroupDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProductGroupDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProductGroupDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PropertyGroup/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class ProviderPaymentServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: ProviderPaymentDto | undefined): Observable<ProviderPaymentDto> {
        let url_ = this.baseUrl + "/api/services/app/ProviderPayment/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProviderPaymentDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProviderPaymentDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<ProviderPaymentDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProviderPaymentDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProviderPaymentDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: ProviderPaymentDto | undefined): Observable<ProviderPaymentDto> {
        let url_ = this.baseUrl + "/api/services/app/ProviderPayment/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProviderPaymentDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProviderPaymentDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<ProviderPaymentDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProviderPaymentDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProviderPaymentDto>(null as any);
    }

    /**
     * @return Success
     */
    getAllCurrencies(): Observable<CurrencySelectDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ProviderPayment/GetAllCurrencies";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllCurrencies(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllCurrencies(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CurrencySelectDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CurrencySelectDto[]>;
        }));
    }

    protected processGetAllCurrencies(response: HttpResponseBase): Observable<CurrencySelectDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(CurrencySelectDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CurrencySelectDto[]>(null as any);
    }

    /**
     * @return Success
     */
    getAllBankAccount(): Observable<BankAccountSelectDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ProviderPayment/GetAllBankAccount";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllBankAccount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllBankAccount(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BankAccountSelectDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BankAccountSelectDto[]>;
        }));
    }

    protected processGetAllBankAccount(response: HttpResponseBase): Observable<BankAccountSelectDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(BankAccountSelectDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BankAccountSelectDto[]>(null as any);
    }

    /**
     * @return Success
     */
    getProviderPaymentTypes(): Observable<EnumDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ProviderPayment/GetProviderPaymentTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProviderPaymentTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProviderPaymentTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EnumDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EnumDto[]>;
        }));
    }

    protected processGetProviderPaymentTypes(response: HttpResponseBase): Observable<EnumDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(EnumDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<EnumDto[]>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getProviderPayment(id: number | undefined): Observable<ProviderPaymentDto> {
        let url_ = this.baseUrl + "/api/services/app/ProviderPayment/GetProviderPayment?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProviderPayment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProviderPayment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProviderPaymentDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProviderPaymentDto>;
        }));
    }

    protected processGetProviderPayment(response: HttpResponseBase): Observable<ProviderPaymentDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProviderPaymentDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProviderPaymentDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<ProviderPaymentDto> {
        let url_ = this.baseUrl + "/api/services/app/ProviderPayment/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProviderPaymentDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProviderPaymentDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ProviderPaymentDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProviderPaymentDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProviderPaymentDto>(null as any);
    }

    /**
     * @param keyword (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<ProviderPaymentDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/ProviderPayment/GetAll?";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProviderPaymentDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProviderPaymentDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<ProviderPaymentDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProviderPaymentDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProviderPaymentDtoPagedResultDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ProviderPayment/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class QuotesServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: QuoteDto | undefined): Observable<QuoteDto> {
        let url_ = this.baseUrl + "/api/services/app/Quotes/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<QuoteDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<QuoteDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<QuoteDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = QuoteDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<QuoteDto>(null as any);
    }

    /**
     * @param keyword (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<QuoteDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Quotes/GetAll?";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<QuoteDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<QuoteDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<QuoteDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = QuoteDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<QuoteDtoPagedResultDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<QuoteDto> {
        let url_ = this.baseUrl + "/api/services/app/Quotes/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<QuoteDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<QuoteDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<QuoteDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = QuoteDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<QuoteDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Quotes/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: QuoteDto | undefined): Observable<QuoteDto> {
        let url_ = this.baseUrl + "/api/services/app/Quotes/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<QuoteDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<QuoteDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<QuoteDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = QuoteDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<QuoteDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    disablePlan(body: QuoteDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Quotes/DisablePlan";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDisablePlan(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDisablePlan(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDisablePlan(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    generateExcelPlans(body: PagedQuotesResultRequestDto | undefined): Observable<FileExcelDto> {
        let url_ = this.baseUrl + "/api/services/app/Quotes/GenerateExcelPlans";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGenerateExcelPlans(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGenerateExcelPlans(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileExcelDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileExcelDto>;
        }));
    }

    protected processGenerateExcelPlans(response: HttpResponseBase): Observable<FileExcelDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileExcelDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileExcelDto>(null as any);
    }

    /**
     * @return Success
     */
    generateTemplateQuote(): Observable<FileExcelDto> {
        let url_ = this.baseUrl + "/api/services/app/Quotes/GenerateTemplateQuote";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGenerateTemplateQuote(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGenerateTemplateQuote(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileExcelDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileExcelDto>;
        }));
    }

    protected processGenerateTemplateQuote(response: HttpResponseBase): Observable<FileExcelDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileExcelDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileExcelDto>(null as any);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    readExcel(input: FileParameter | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Quotes/ReadExcel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (input === null || input === undefined)
            throw new Error("The parameter 'input' cannot be null.");
        else
            content_.append("input", input.data, input.fileName ? input.fileName : "input");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReadExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReadExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processReadExcel(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class ReportServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param keyword (optional) 
     * @return Success
     */
    getReportTypes(keyword: string | undefined): Observable<EnumDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Report/GetReportTypes?";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "keyword=" + encodeURIComponent("" + keyword) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReportTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReportTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EnumDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EnumDto[]>;
        }));
    }

    protected processGetReportTypes(response: HttpResponseBase): Observable<EnumDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(EnumDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<EnumDto[]>(null as any);
    }

    /**
     * @param keyword (optional) 
     * @return Success
     */
    getReportTotalesVentas(keyword: string | undefined): Observable<EnumDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Report/GetReportTotalesVentas?";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "keyword=" + encodeURIComponent("" + keyword) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReportTotalesVentas(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReportTotalesVentas(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EnumDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EnumDto[]>;
        }));
    }

    protected processGetReportTotalesVentas(response: HttpResponseBase): Observable<EnumDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(EnumDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<EnumDto[]>(null as any);
    }
}

@Injectable()
export class ReportsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param tenantId (optional) 
     * @param userId (optional) 
     * @param isOwner (optional) 
     * @param keyword (optional) 
     * @param from (optional) 
     * @param to (optional) 
     * @param storeIds (optional) 
     * @param productsIds (optional) 
     * @param variantsIds (optional) 
     * @param orderColumn (optional) 
     * @param order (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    generateExcelSalesRankingByProduct(tenantId: number | undefined, userId: number | undefined, isOwner: boolean | undefined, keyword: string | undefined, from: moment.Moment | undefined, to: moment.Moment | undefined, storeIds: number[] | undefined, productsIds: number[] | undefined, variantsIds: number[] | undefined, orderColumn: string | undefined, order: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Reports/GenerateExcelSalesRankingByProduct?";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (isOwner === null)
            throw new Error("The parameter 'isOwner' cannot be null.");
        else if (isOwner !== undefined)
            url_ += "IsOwner=" + encodeURIComponent("" + isOwner) + "&";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (from === null)
            throw new Error("The parameter 'from' cannot be null.");
        else if (from !== undefined)
            url_ += "From=" + encodeURIComponent(from ? "" + from.toISOString() : "") + "&";
        if (to === null)
            throw new Error("The parameter 'to' cannot be null.");
        else if (to !== undefined)
            url_ += "To=" + encodeURIComponent(to ? "" + to.toISOString() : "") + "&";
        if (storeIds === null)
            throw new Error("The parameter 'storeIds' cannot be null.");
        else if (storeIds !== undefined)
            storeIds && storeIds.forEach(item => { url_ += "StoreIds=" + encodeURIComponent("" + item) + "&"; });
        if (productsIds === null)
            throw new Error("The parameter 'productsIds' cannot be null.");
        else if (productsIds !== undefined)
            productsIds && productsIds.forEach(item => { url_ += "ProductsIds=" + encodeURIComponent("" + item) + "&"; });
        if (variantsIds === null)
            throw new Error("The parameter 'variantsIds' cannot be null.");
        else if (variantsIds !== undefined)
            variantsIds && variantsIds.forEach(item => { url_ += "VariantsIds=" + encodeURIComponent("" + item) + "&"; });
        if (orderColumn === null)
            throw new Error("The parameter 'orderColumn' cannot be null.");
        else if (orderColumn !== undefined)
            url_ += "OrderColumn=" + encodeURIComponent("" + orderColumn) + "&";
        if (order === null)
            throw new Error("The parameter 'order' cannot be null.");
        else if (order !== undefined)
            url_ += "Order=" + encodeURIComponent("" + order) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGenerateExcelSalesRankingByProduct(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGenerateExcelSalesRankingByProduct(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processGenerateExcelSalesRankingByProduct(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @param userId (optional) 
     * @param isOwner (optional) 
     * @param keyword (optional) 
     * @param from (optional) 
     * @param to (optional) 
     * @param storeIds (optional) 
     * @param productsIds (optional) 
     * @param variantsIds (optional) 
     * @param orderColumn (optional) 
     * @param order (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    generateExcelSalesRankingBySeller(tenantId: number | undefined, userId: number | undefined, isOwner: boolean | undefined, keyword: string | undefined, from: moment.Moment | undefined, to: moment.Moment | undefined, storeIds: number[] | undefined, productsIds: number[] | undefined, variantsIds: number[] | undefined, orderColumn: string | undefined, order: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Reports/GenerateExcelSalesRankingBySeller?";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (isOwner === null)
            throw new Error("The parameter 'isOwner' cannot be null.");
        else if (isOwner !== undefined)
            url_ += "IsOwner=" + encodeURIComponent("" + isOwner) + "&";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (from === null)
            throw new Error("The parameter 'from' cannot be null.");
        else if (from !== undefined)
            url_ += "From=" + encodeURIComponent(from ? "" + from.toISOString() : "") + "&";
        if (to === null)
            throw new Error("The parameter 'to' cannot be null.");
        else if (to !== undefined)
            url_ += "To=" + encodeURIComponent(to ? "" + to.toISOString() : "") + "&";
        if (storeIds === null)
            throw new Error("The parameter 'storeIds' cannot be null.");
        else if (storeIds !== undefined)
            storeIds && storeIds.forEach(item => { url_ += "StoreIds=" + encodeURIComponent("" + item) + "&"; });
        if (productsIds === null)
            throw new Error("The parameter 'productsIds' cannot be null.");
        else if (productsIds !== undefined)
            productsIds && productsIds.forEach(item => { url_ += "ProductsIds=" + encodeURIComponent("" + item) + "&"; });
        if (variantsIds === null)
            throw new Error("The parameter 'variantsIds' cannot be null.");
        else if (variantsIds !== undefined)
            variantsIds && variantsIds.forEach(item => { url_ += "VariantsIds=" + encodeURIComponent("" + item) + "&"; });
        if (orderColumn === null)
            throw new Error("The parameter 'orderColumn' cannot be null.");
        else if (orderColumn !== undefined)
            url_ += "OrderColumn=" + encodeURIComponent("" + orderColumn) + "&";
        if (order === null)
            throw new Error("The parameter 'order' cannot be null.");
        else if (order !== undefined)
            url_ += "Order=" + encodeURIComponent("" + order) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGenerateExcelSalesRankingBySeller(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGenerateExcelSalesRankingBySeller(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processGenerateExcelSalesRankingBySeller(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param keyword (optional) 
     * @param from (optional) 
     * @param to (optional) 
     * @param sellerIds (optional) 
     * @param userRoles (optional) 
     * @param isOwner (optional) 
     * @param tenantId (optional) 
     * @param userId (optional) 
     * @param orderColumn (optional) 
     * @param order (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    generateExcelSalesRankingBySellerMonthly(keyword: string | undefined, from: moment.Moment | undefined, to: moment.Moment | undefined, sellerIds: number[] | undefined, userRoles: string[] | undefined, isOwner: boolean | undefined, tenantId: number | undefined, userId: number | undefined, orderColumn: string | undefined, order: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Reports/GenerateExcelSalesRankingBySellerMonthly?";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (from === null)
            throw new Error("The parameter 'from' cannot be null.");
        else if (from !== undefined)
            url_ += "From=" + encodeURIComponent(from ? "" + from.toISOString() : "") + "&";
        if (to === null)
            throw new Error("The parameter 'to' cannot be null.");
        else if (to !== undefined)
            url_ += "To=" + encodeURIComponent(to ? "" + to.toISOString() : "") + "&";
        if (sellerIds === null)
            throw new Error("The parameter 'sellerIds' cannot be null.");
        else if (sellerIds !== undefined)
            sellerIds && sellerIds.forEach(item => { url_ += "SellerIds=" + encodeURIComponent("" + item) + "&"; });
        if (userRoles === null)
            throw new Error("The parameter 'userRoles' cannot be null.");
        else if (userRoles !== undefined)
            userRoles && userRoles.forEach(item => { url_ += "UserRoles=" + encodeURIComponent("" + item) + "&"; });
        if (isOwner === null)
            throw new Error("The parameter 'isOwner' cannot be null.");
        else if (isOwner !== undefined)
            url_ += "IsOwner=" + encodeURIComponent("" + isOwner) + "&";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (orderColumn === null)
            throw new Error("The parameter 'orderColumn' cannot be null.");
        else if (orderColumn !== undefined)
            url_ += "OrderColumn=" + encodeURIComponent("" + orderColumn) + "&";
        if (order === null)
            throw new Error("The parameter 'order' cannot be null.");
        else if (order !== undefined)
            url_ += "Order=" + encodeURIComponent("" + order) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGenerateExcelSalesRankingBySellerMonthly(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGenerateExcelSalesRankingBySellerMonthly(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processGenerateExcelSalesRankingBySellerMonthly(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param keyword (optional) 
     * @param productIds (optional) 
     * @param variantIds (optional) 
     * @param warehouseIds (optional) 
     * @param storeIds (optional) 
     * @param isReport (optional) 
     * @param orderColumn (optional) 
     * @param order (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    generateExcelMinimumStockList(keyword: string | undefined, productIds: number[] | undefined, variantIds: number[] | undefined, warehouseIds: number[] | undefined, storeIds: number[] | undefined, isReport: boolean | undefined, orderColumn: string | undefined, order: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Reports/GenerateExcelMinimumStockList?";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (productIds === null)
            throw new Error("The parameter 'productIds' cannot be null.");
        else if (productIds !== undefined)
            productIds && productIds.forEach(item => { url_ += "ProductIds=" + encodeURIComponent("" + item) + "&"; });
        if (variantIds === null)
            throw new Error("The parameter 'variantIds' cannot be null.");
        else if (variantIds !== undefined)
            variantIds && variantIds.forEach(item => { url_ += "VariantIds=" + encodeURIComponent("" + item) + "&"; });
        if (warehouseIds === null)
            throw new Error("The parameter 'warehouseIds' cannot be null.");
        else if (warehouseIds !== undefined)
            warehouseIds && warehouseIds.forEach(item => { url_ += "WarehouseIds=" + encodeURIComponent("" + item) + "&"; });
        if (storeIds === null)
            throw new Error("The parameter 'storeIds' cannot be null.");
        else if (storeIds !== undefined)
            storeIds && storeIds.forEach(item => { url_ += "StoreIds=" + encodeURIComponent("" + item) + "&"; });
        if (isReport === null)
            throw new Error("The parameter 'isReport' cannot be null.");
        else if (isReport !== undefined)
            url_ += "IsReport=" + encodeURIComponent("" + isReport) + "&";
        if (orderColumn === null)
            throw new Error("The parameter 'orderColumn' cannot be null.");
        else if (orderColumn !== undefined)
            url_ += "OrderColumn=" + encodeURIComponent("" + orderColumn) + "&";
        if (order === null)
            throw new Error("The parameter 'order' cannot be null.");
        else if (order !== undefined)
            url_ += "Order=" + encodeURIComponent("" + order) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGenerateExcelMinimumStockList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGenerateExcelMinimumStockList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processGenerateExcelMinimumStockList(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param keyword (optional) 
     * @param order (optional) 
     * @param orderColumn (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    generateExcelClientsList(keyword: string | undefined, order: string | undefined, orderColumn: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<FileExcelDto> {
        let url_ = this.baseUrl + "/api/Reports/GenerateExcelClientsList?";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (order === null)
            throw new Error("The parameter 'order' cannot be null.");
        else if (order !== undefined)
            url_ += "Order=" + encodeURIComponent("" + order) + "&";
        if (orderColumn === null)
            throw new Error("The parameter 'orderColumn' cannot be null.");
        else if (orderColumn !== undefined)
            url_ += "OrderColumn=" + encodeURIComponent("" + orderColumn) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGenerateExcelClientsList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGenerateExcelClientsList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileExcelDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileExcelDto>;
        }));
    }

    protected processGenerateExcelClientsList(response: HttpResponseBase): Observable<FileExcelDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileExcelDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileExcelDto>(null as any);
    }

    /**
     * @param keyword (optional) 
     * @param isActive (optional) 
     * @param store (optional) 
     * @param order (optional) 
     * @param orderColumn (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    downloadProductExcel(keyword: string | undefined, isActive: boolean | undefined, store: string | undefined, order: string | undefined, orderColumn: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/Reports/DownloadProductExcel?";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (isActive === null)
            throw new Error("The parameter 'isActive' cannot be null.");
        else if (isActive !== undefined)
            url_ += "IsActive=" + encodeURIComponent("" + isActive) + "&";
        if (store === null)
            throw new Error("The parameter 'store' cannot be null.");
        else if (store !== undefined)
            url_ += "Store=" + encodeURIComponent("" + store) + "&";
        if (order === null)
            throw new Error("The parameter 'order' cannot be null.");
        else if (order !== undefined)
            url_ += "Order=" + encodeURIComponent("" + order) + "&";
        if (orderColumn === null)
            throw new Error("The parameter 'orderColumn' cannot be null.");
        else if (orderColumn !== undefined)
            url_ += "OrderColumn=" + encodeURIComponent("" + orderColumn) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadProductExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadProductExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processDownloadProductExcel(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @param pageNumber (optional) 
     * @param useNegativeStock (optional) 
     * @param storeId (optional) 
     * @param keywords (optional) 
     * @return Success
     */
    generateExcelProductInfo(tenantId: number | undefined, pageNumber: number | undefined, useNegativeStock: boolean | undefined, storeId: number | undefined, keywords: string[] | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Reports/GenerateExcelProductInfo?";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (useNegativeStock === null)
            throw new Error("The parameter 'useNegativeStock' cannot be null.");
        else if (useNegativeStock !== undefined)
            url_ += "UseNegativeStock=" + encodeURIComponent("" + useNegativeStock) + "&";
        if (storeId === null)
            throw new Error("The parameter 'storeId' cannot be null.");
        else if (storeId !== undefined)
            url_ += "StoreId=" + encodeURIComponent("" + storeId) + "&";
        if (keywords === null)
            throw new Error("The parameter 'keywords' cannot be null.");
        else if (keywords !== undefined)
            keywords && keywords.forEach(item => { url_ += "Keywords=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGenerateExcelProductInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGenerateExcelProductInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processGenerateExcelProductInfo(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @param userId (optional) 
     * @param storeIds (optional) 
     * @param keyword (optional) 
     * @param promotionType (optional) 
     * @param statuses (optional) 
     * @param isActive (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    downloadPromotionsExcel(tenantId: number | undefined, userId: number | undefined, storeIds: number[] | undefined, keyword: string | undefined, promotionType: PromotionType | undefined, statuses: PromotionStatus[] | undefined, isActive: boolean | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Reports/DownloadPromotionsExcel?";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (storeIds === null)
            throw new Error("The parameter 'storeIds' cannot be null.");
        else if (storeIds !== undefined)
            storeIds && storeIds.forEach(item => { url_ += "StoreIds=" + encodeURIComponent("" + item) + "&"; });
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (promotionType === null)
            throw new Error("The parameter 'promotionType' cannot be null.");
        else if (promotionType !== undefined)
            url_ += "PromotionType=" + encodeURIComponent("" + promotionType) + "&";
        if (statuses === null)
            throw new Error("The parameter 'statuses' cannot be null.");
        else if (statuses !== undefined)
            statuses && statuses.forEach(item => { url_ += "Statuses=" + encodeURIComponent("" + item) + "&"; });
        if (isActive === null)
            throw new Error("The parameter 'isActive' cannot be null.");
        else if (isActive !== undefined)
            url_ += "IsActive=" + encodeURIComponent("" + isActive) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadPromotionsExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadPromotionsExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDownloadPromotionsExcel(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class ReservationServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param from (optional) 
     * @param to (optional) 
     * @param keyClient (optional) 
     * @param reserveType (optional) 
     * @param statuses (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(from: moment.Moment | undefined, to: moment.Moment | undefined, keyClient: string | undefined, reserveType: ReserveState | undefined, statuses: ReservationStatus[] | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<ReservationDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Reservation/GetAll?";
        if (from === null)
            throw new Error("The parameter 'from' cannot be null.");
        else if (from !== undefined)
            url_ += "From=" + encodeURIComponent(from ? "" + from.toISOString() : "") + "&";
        if (to === null)
            throw new Error("The parameter 'to' cannot be null.");
        else if (to !== undefined)
            url_ += "To=" + encodeURIComponent(to ? "" + to.toISOString() : "") + "&";
        if (keyClient === null)
            throw new Error("The parameter 'keyClient' cannot be null.");
        else if (keyClient !== undefined)
            url_ += "KeyClient=" + encodeURIComponent("" + keyClient) + "&";
        if (reserveType === null)
            throw new Error("The parameter 'reserveType' cannot be null.");
        else if (reserveType !== undefined)
            url_ += "ReserveType=" + encodeURIComponent("" + reserveType) + "&";
        if (statuses === null)
            throw new Error("The parameter 'statuses' cannot be null.");
        else if (statuses !== undefined)
            statuses && statuses.forEach(item => { url_ += "Statuses=" + encodeURIComponent("" + item) + "&"; });
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReservationDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReservationDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<ReservationDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReservationDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ReservationDtoPagedResultDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    addDaysToExpirationDate(body: ReservationAddDaysDto | undefined): Observable<ReservationDto> {
        let url_ = this.baseUrl + "/api/services/app/Reservation/AddDaysToExpirationDate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddDaysToExpirationDate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddDaysToExpirationDate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReservationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReservationDto>;
        }));
    }

    protected processAddDaysToExpirationDate(response: HttpResponseBase): Observable<ReservationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReservationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ReservationDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    returnProductsToWarehouse(body: ReservationDto | undefined): Observable<ReservationDto> {
        let url_ = this.baseUrl + "/api/services/app/Reservation/ReturnProductsToWarehouse";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReturnProductsToWarehouse(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReturnProductsToWarehouse(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReservationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReservationDto>;
        }));
    }

    protected processReturnProductsToWarehouse(response: HttpResponseBase): Observable<ReservationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReservationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ReservationDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getReservationInvoice(id: number | undefined): Observable<ReservationDto> {
        let url_ = this.baseUrl + "/api/services/app/Reservation/GetReservationInvoice?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReservationInvoice(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReservationInvoice(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReservationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReservationDto>;
        }));
    }

    protected processGetReservationInvoice(response: HttpResponseBase): Observable<ReservationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReservationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ReservationDto>(null as any);
    }

    /**
     * @return Success
     */
    getReserveTypes(): Observable<EnumDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Reservation/GetReserveTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReserveTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReserveTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EnumDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EnumDto[]>;
        }));
    }

    protected processGetReserveTypes(response: HttpResponseBase): Observable<EnumDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(EnumDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<EnumDto[]>(null as any);
    }

    /**
     * @return Success
     */
    getReserveStatus(): Observable<EnumDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Reservation/GetReserveStatus";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReserveStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReserveStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EnumDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EnumDto[]>;
        }));
    }

    protected processGetReserveStatus(response: HttpResponseBase): Observable<EnumDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(EnumDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<EnumDto[]>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<ReservationDto> {
        let url_ = this.baseUrl + "/api/services/app/Reservation/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReservationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReservationDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ReservationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReservationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ReservationDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: ReservationDto | undefined): Observable<ReservationDto> {
        let url_ = this.baseUrl + "/api/services/app/Reservation/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReservationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReservationDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<ReservationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReservationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ReservationDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: ReservationDto | undefined): Observable<ReservationDto> {
        let url_ = this.baseUrl + "/api/services/app/Reservation/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReservationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReservationDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<ReservationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReservationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ReservationDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Reservation/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class RoleServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateRoleDto | undefined): Observable<RoleDto> {
        let url_ = this.baseUrl + "/api/services/app/Role/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RoleDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RoleDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<RoleDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RoleDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RoleDto>(null as any);
    }

    /**
     * @param permission (optional) 
     * @return Success
     */
    getRoles(permission: string | undefined): Observable<RoleListDtoListResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Role/GetRoles?";
        if (permission === null)
            throw new Error("The parameter 'permission' cannot be null.");
        else if (permission !== undefined)
            url_ += "Permission=" + encodeURIComponent("" + permission) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRoles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRoles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RoleListDtoListResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RoleListDtoListResultDto>;
        }));
    }

    protected processGetRoles(response: HttpResponseBase): Observable<RoleListDtoListResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RoleListDtoListResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RoleListDtoListResultDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: RoleDto | undefined): Observable<RoleDto> {
        let url_ = this.baseUrl + "/api/services/app/Role/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RoleDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RoleDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<RoleDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RoleDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RoleDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Role/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    getAllPermissions(): Observable<NodePermissionDtoListResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Role/GetAllPermissions";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllPermissions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllPermissions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NodePermissionDtoListResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NodePermissionDtoListResultDto>;
        }));
    }

    protected processGetAllPermissions(response: HttpResponseBase): Observable<NodePermissionDtoListResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = NodePermissionDtoListResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<NodePermissionDtoListResultDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getRoleForEdit(id: number | undefined): Observable<GetRoleForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Role/GetRoleForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRoleForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRoleForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetRoleForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetRoleForEditOutput>;
        }));
    }

    protected processGetRoleForEdit(response: HttpResponseBase): Observable<GetRoleForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetRoleForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetRoleForEditOutput>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<RoleDto> {
        let url_ = this.baseUrl + "/api/services/app/Role/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RoleDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RoleDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<RoleDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RoleDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RoleDto>(null as any);
    }

    /**
     * @param keyword (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<RoleDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Role/GetAll?";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RoleDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RoleDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<RoleDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RoleDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RoleDtoPagedResultDto>(null as any);
    }
}

@Injectable()
export class SalePointServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: SalePointDto | undefined): Observable<SalePointDto> {
        let url_ = this.baseUrl + "/api/services/app/SalePoint/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SalePointDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SalePointDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<SalePointDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SalePointDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SalePointDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: SalePointDto | undefined): Observable<SalePointDto> {
        let url_ = this.baseUrl + "/api/services/app/SalePoint/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SalePointDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SalePointDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<SalePointDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SalePointDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SalePointDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SalePoint/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    getAllStores(): Observable<StoreForListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/SalePoint/GetAllStores";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllStores(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllStores(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StoreForListDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StoreForListDto[]>;
        }));
    }

    protected processGetAllStores(response: HttpResponseBase): Observable<StoreForListDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(StoreForListDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<StoreForListDto[]>(null as any);
    }

    /**
     * @return Success
     */
    getSalePointsTypes(): Observable<EnumDto[]> {
        let url_ = this.baseUrl + "/api/services/app/SalePoint/GetSalePointsTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSalePointsTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSalePointsTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EnumDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EnumDto[]>;
        }));
    }

    protected processGetSalePointsTypes(response: HttpResponseBase): Observable<EnumDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(EnumDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<EnumDto[]>(null as any);
    }

    /**
     * @return Success
     */
    getAllSalePoints(): Observable<SalePointDto[]> {
        let url_ = this.baseUrl + "/api/services/app/SalePoint/GetAllSalePoints";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllSalePoints(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllSalePoints(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SalePointDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SalePointDto[]>;
        }));
    }

    protected processGetAllSalePoints(response: HttpResponseBase): Observable<SalePointDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(SalePointDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SalePointDto[]>(null as any);
    }

    /**
     * @return Success
     */
    getAllPrinters(): Observable<PrinterDto[]> {
        let url_ = this.baseUrl + "/api/services/app/SalePoint/GetAllPrinters";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllPrinters(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllPrinters(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PrinterDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PrinterDto[]>;
        }));
    }

    protected processGetAllPrinters(response: HttpResponseBase): Observable<PrinterDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(PrinterDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PrinterDto[]>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<SalePointDto> {
        let url_ = this.baseUrl + "/api/services/app/SalePoint/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SalePointDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SalePointDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<SalePointDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SalePointDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SalePointDto>(null as any);
    }

    /**
     * @param keyword (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<SalePointDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/SalePoint/GetAll?";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SalePointDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SalePointDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<SalePointDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SalePointDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SalePointDtoPagedResultDto>(null as any);
    }
}

@Injectable()
export class SellerServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param tenantId (optional) 
     * @param userId (optional) 
     * @param filters_TenantId (optional) 
     * @param filters_UserId (optional) 
     * @param filters_IsOwner (optional) 
     * @param filters_Keyword (optional) 
     * @param filters_From (optional) 
     * @param filters_To (optional) 
     * @param filters_StoreIds (optional) 
     * @param filters_ProductsIds (optional) 
     * @param filters_VariantsIds (optional) 
     * @param filters_OrderColumn (optional) 
     * @param filters_Order (optional) 
     * @param filters_SkipCount (optional) 
     * @param filters_MaxResultCount (optional) 
     * @param allowedStoreIds (optional) 
     * @param isOwner (optional) 
     * @return Success
     */
    getSellersRankingForReport(tenantId: number | undefined, userId: number | undefined, filters_TenantId: number | undefined, filters_UserId: number | undefined, filters_IsOwner: boolean | undefined, filters_Keyword: string | undefined, filters_From: moment.Moment | undefined, filters_To: moment.Moment | undefined, filters_StoreIds: number[] | undefined, filters_ProductsIds: number[] | undefined, filters_VariantsIds: number[] | undefined, filters_OrderColumn: string | undefined, filters_Order: string | undefined, filters_SkipCount: number | undefined, filters_MaxResultCount: number | undefined, allowedStoreIds: number[] | undefined, isOwner: boolean | undefined): Observable<SellersRankingReportDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Seller/GetSellersRankingForReport?";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (filters_TenantId === null)
            throw new Error("The parameter 'filters_TenantId' cannot be null.");
        else if (filters_TenantId !== undefined)
            url_ += "Filters.TenantId=" + encodeURIComponent("" + filters_TenantId) + "&";
        if (filters_UserId === null)
            throw new Error("The parameter 'filters_UserId' cannot be null.");
        else if (filters_UserId !== undefined)
            url_ += "Filters.UserId=" + encodeURIComponent("" + filters_UserId) + "&";
        if (filters_IsOwner === null)
            throw new Error("The parameter 'filters_IsOwner' cannot be null.");
        else if (filters_IsOwner !== undefined)
            url_ += "Filters.IsOwner=" + encodeURIComponent("" + filters_IsOwner) + "&";
        if (filters_Keyword === null)
            throw new Error("The parameter 'filters_Keyword' cannot be null.");
        else if (filters_Keyword !== undefined)
            url_ += "Filters.Keyword=" + encodeURIComponent("" + filters_Keyword) + "&";
        if (filters_From === null)
            throw new Error("The parameter 'filters_From' cannot be null.");
        else if (filters_From !== undefined)
            url_ += "Filters.From=" + encodeURIComponent(filters_From ? "" + filters_From.toISOString() : "") + "&";
        if (filters_To === null)
            throw new Error("The parameter 'filters_To' cannot be null.");
        else if (filters_To !== undefined)
            url_ += "Filters.To=" + encodeURIComponent(filters_To ? "" + filters_To.toISOString() : "") + "&";
        if (filters_StoreIds === null)
            throw new Error("The parameter 'filters_StoreIds' cannot be null.");
        else if (filters_StoreIds !== undefined)
            filters_StoreIds && filters_StoreIds.forEach(item => { url_ += "Filters.StoreIds=" + encodeURIComponent("" + item) + "&"; });
        if (filters_ProductsIds === null)
            throw new Error("The parameter 'filters_ProductsIds' cannot be null.");
        else if (filters_ProductsIds !== undefined)
            filters_ProductsIds && filters_ProductsIds.forEach(item => { url_ += "Filters.ProductsIds=" + encodeURIComponent("" + item) + "&"; });
        if (filters_VariantsIds === null)
            throw new Error("The parameter 'filters_VariantsIds' cannot be null.");
        else if (filters_VariantsIds !== undefined)
            filters_VariantsIds && filters_VariantsIds.forEach(item => { url_ += "Filters.VariantsIds=" + encodeURIComponent("" + item) + "&"; });
        if (filters_OrderColumn === null)
            throw new Error("The parameter 'filters_OrderColumn' cannot be null.");
        else if (filters_OrderColumn !== undefined)
            url_ += "Filters.OrderColumn=" + encodeURIComponent("" + filters_OrderColumn) + "&";
        if (filters_Order === null)
            throw new Error("The parameter 'filters_Order' cannot be null.");
        else if (filters_Order !== undefined)
            url_ += "Filters.Order=" + encodeURIComponent("" + filters_Order) + "&";
        if (filters_SkipCount === null)
            throw new Error("The parameter 'filters_SkipCount' cannot be null.");
        else if (filters_SkipCount !== undefined)
            url_ += "Filters.SkipCount=" + encodeURIComponent("" + filters_SkipCount) + "&";
        if (filters_MaxResultCount === null)
            throw new Error("The parameter 'filters_MaxResultCount' cannot be null.");
        else if (filters_MaxResultCount !== undefined)
            url_ += "Filters.MaxResultCount=" + encodeURIComponent("" + filters_MaxResultCount) + "&";
        if (allowedStoreIds === null)
            throw new Error("The parameter 'allowedStoreIds' cannot be null.");
        else if (allowedStoreIds !== undefined)
            allowedStoreIds && allowedStoreIds.forEach(item => { url_ += "AllowedStoreIds=" + encodeURIComponent("" + item) + "&"; });
        if (isOwner === null)
            throw new Error("The parameter 'isOwner' cannot be null.");
        else if (isOwner !== undefined)
            url_ += "IsOwner=" + encodeURIComponent("" + isOwner) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSellersRankingForReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSellersRankingForReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SellersRankingReportDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SellersRankingReportDto[]>;
        }));
    }

    protected processGetSellersRankingForReport(response: HttpResponseBase): Observable<SellersRankingReportDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(SellersRankingReportDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SellersRankingReportDto[]>(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @param userId (optional) 
     * @param isOwner (optional) 
     * @param keyword (optional) 
     * @param from (optional) 
     * @param to (optional) 
     * @param storeIds (optional) 
     * @param productsIds (optional) 
     * @param variantsIds (optional) 
     * @param orderColumn (optional) 
     * @param order (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllSellers(tenantId: number | undefined, userId: number | undefined, isOwner: boolean | undefined, keyword: string | undefined, from: moment.Moment | undefined, to: moment.Moment | undefined, storeIds: number[] | undefined, productsIds: number[] | undefined, variantsIds: number[] | undefined, orderColumn: string | undefined, order: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<SellersRankingReportDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Seller/GetAllSellers?";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (isOwner === null)
            throw new Error("The parameter 'isOwner' cannot be null.");
        else if (isOwner !== undefined)
            url_ += "IsOwner=" + encodeURIComponent("" + isOwner) + "&";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (from === null)
            throw new Error("The parameter 'from' cannot be null.");
        else if (from !== undefined)
            url_ += "From=" + encodeURIComponent(from ? "" + from.toISOString() : "") + "&";
        if (to === null)
            throw new Error("The parameter 'to' cannot be null.");
        else if (to !== undefined)
            url_ += "To=" + encodeURIComponent(to ? "" + to.toISOString() : "") + "&";
        if (storeIds === null)
            throw new Error("The parameter 'storeIds' cannot be null.");
        else if (storeIds !== undefined)
            storeIds && storeIds.forEach(item => { url_ += "StoreIds=" + encodeURIComponent("" + item) + "&"; });
        if (productsIds === null)
            throw new Error("The parameter 'productsIds' cannot be null.");
        else if (productsIds !== undefined)
            productsIds && productsIds.forEach(item => { url_ += "ProductsIds=" + encodeURIComponent("" + item) + "&"; });
        if (variantsIds === null)
            throw new Error("The parameter 'variantsIds' cannot be null.");
        else if (variantsIds !== undefined)
            variantsIds && variantsIds.forEach(item => { url_ += "VariantsIds=" + encodeURIComponent("" + item) + "&"; });
        if (orderColumn === null)
            throw new Error("The parameter 'orderColumn' cannot be null.");
        else if (orderColumn !== undefined)
            url_ += "OrderColumn=" + encodeURIComponent("" + orderColumn) + "&";
        if (order === null)
            throw new Error("The parameter 'order' cannot be null.");
        else if (order !== undefined)
            url_ += "Order=" + encodeURIComponent("" + order) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllSellers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllSellers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SellersRankingReportDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SellersRankingReportDtoPagedResultDto>;
        }));
    }

    protected processGetAllSellers(response: HttpResponseBase): Observable<SellersRankingReportDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SellersRankingReportDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SellersRankingReportDtoPagedResultDto>(null as any);
    }

    /**
     * @param keyword (optional) 
     * @param from (optional) 
     * @param to (optional) 
     * @param sellerIds (optional) 
     * @param userRoles (optional) 
     * @param isOwner (optional) 
     * @param tenantId (optional) 
     * @param userId (optional) 
     * @param orderColumn (optional) 
     * @param order (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllSellersGroupedByMonth(keyword: string | undefined, from: moment.Moment | undefined, to: moment.Moment | undefined, sellerIds: number[] | undefined, userRoles: string[] | undefined, isOwner: boolean | undefined, tenantId: number | undefined, userId: number | undefined, orderColumn: string | undefined, order: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<SalesRankingWithTotalsDto> {
        let url_ = this.baseUrl + "/api/services/app/Seller/GetAllSellersGroupedByMonth?";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (from === null)
            throw new Error("The parameter 'from' cannot be null.");
        else if (from !== undefined)
            url_ += "From=" + encodeURIComponent(from ? "" + from.toISOString() : "") + "&";
        if (to === null)
            throw new Error("The parameter 'to' cannot be null.");
        else if (to !== undefined)
            url_ += "To=" + encodeURIComponent(to ? "" + to.toISOString() : "") + "&";
        if (sellerIds === null)
            throw new Error("The parameter 'sellerIds' cannot be null.");
        else if (sellerIds !== undefined)
            sellerIds && sellerIds.forEach(item => { url_ += "SellerIds=" + encodeURIComponent("" + item) + "&"; });
        if (userRoles === null)
            throw new Error("The parameter 'userRoles' cannot be null.");
        else if (userRoles !== undefined)
            userRoles && userRoles.forEach(item => { url_ += "UserRoles=" + encodeURIComponent("" + item) + "&"; });
        if (isOwner === null)
            throw new Error("The parameter 'isOwner' cannot be null.");
        else if (isOwner !== undefined)
            url_ += "IsOwner=" + encodeURIComponent("" + isOwner) + "&";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (orderColumn === null)
            throw new Error("The parameter 'orderColumn' cannot be null.");
        else if (orderColumn !== undefined)
            url_ += "OrderColumn=" + encodeURIComponent("" + orderColumn) + "&";
        if (order === null)
            throw new Error("The parameter 'order' cannot be null.");
        else if (order !== undefined)
            url_ += "Order=" + encodeURIComponent("" + order) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllSellersGroupedByMonth(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllSellersGroupedByMonth(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SalesRankingWithTotalsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SalesRankingWithTotalsDto>;
        }));
    }

    protected processGetAllSellersGroupedByMonth(response: HttpResponseBase): Observable<SalesRankingWithTotalsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SalesRankingWithTotalsDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SalesRankingWithTotalsDto>(null as any);
    }

    /**
     * @param keyword (optional) 
     * @param from (optional) 
     * @param to (optional) 
     * @param sellerIds (optional) 
     * @param userRoles (optional) 
     * @param isOwner (optional) 
     * @param tenantId (optional) 
     * @param userId (optional) 
     * @param orderColumn (optional) 
     * @param order (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllSellersGroupedByMonthForExcel(keyword: string | undefined, from: moment.Moment | undefined, to: moment.Moment | undefined, sellerIds: number[] | undefined, userRoles: string[] | undefined, isOwner: boolean | undefined, tenantId: number | undefined, userId: number | undefined, orderColumn: string | undefined, order: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<SellersRankingDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Seller/GetAllSellersGroupedByMonthForExcel?";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (from === null)
            throw new Error("The parameter 'from' cannot be null.");
        else if (from !== undefined)
            url_ += "From=" + encodeURIComponent(from ? "" + from.toISOString() : "") + "&";
        if (to === null)
            throw new Error("The parameter 'to' cannot be null.");
        else if (to !== undefined)
            url_ += "To=" + encodeURIComponent(to ? "" + to.toISOString() : "") + "&";
        if (sellerIds === null)
            throw new Error("The parameter 'sellerIds' cannot be null.");
        else if (sellerIds !== undefined)
            sellerIds && sellerIds.forEach(item => { url_ += "SellerIds=" + encodeURIComponent("" + item) + "&"; });
        if (userRoles === null)
            throw new Error("The parameter 'userRoles' cannot be null.");
        else if (userRoles !== undefined)
            userRoles && userRoles.forEach(item => { url_ += "UserRoles=" + encodeURIComponent("" + item) + "&"; });
        if (isOwner === null)
            throw new Error("The parameter 'isOwner' cannot be null.");
        else if (isOwner !== undefined)
            url_ += "IsOwner=" + encodeURIComponent("" + isOwner) + "&";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (orderColumn === null)
            throw new Error("The parameter 'orderColumn' cannot be null.");
        else if (orderColumn !== undefined)
            url_ += "OrderColumn=" + encodeURIComponent("" + orderColumn) + "&";
        if (order === null)
            throw new Error("The parameter 'order' cannot be null.");
        else if (order !== undefined)
            url_ += "Order=" + encodeURIComponent("" + order) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllSellersGroupedByMonthForExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllSellersGroupedByMonthForExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SellersRankingDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SellersRankingDtoPagedResultDto>;
        }));
    }

    protected processGetAllSellersGroupedByMonthForExcel(response: HttpResponseBase): Observable<SellersRankingDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SellersRankingDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SellersRankingDtoPagedResultDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    salesRankingByMonthDtoQuery(body: SalesRankingProductsMonthlyFilterDto | undefined): Observable<SellersRankingDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Seller/SalesRankingByMonthDtoQuery";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSalesRankingByMonthDtoQuery(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSalesRankingByMonthDtoQuery(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SellersRankingDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SellersRankingDto[]>;
        }));
    }

    protected processSalesRankingByMonthDtoQuery(response: HttpResponseBase): Observable<SellersRankingDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(SellersRankingDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SellersRankingDto[]>(null as any);
    }

    /**
     * @param from (optional) 
     * @param to (optional) 
     * @param storeIds (optional) 
     * @param vendorId (optional) 
     * @param userId (optional) 
     * @param isOwner (optional) 
     * @return Success
     */
    getTotalSales(from: moment.Moment | undefined, to: moment.Moment | undefined, storeIds: number[] | undefined, vendorId: number | undefined, userId: number | undefined, isOwner: boolean | undefined): Observable<SellersRankingCardTotalDto> {
        let url_ = this.baseUrl + "/api/services/app/Seller/GetTotalSales?";
        if (from === null)
            throw new Error("The parameter 'from' cannot be null.");
        else if (from !== undefined)
            url_ += "From=" + encodeURIComponent(from ? "" + from.toISOString() : "") + "&";
        if (to === null)
            throw new Error("The parameter 'to' cannot be null.");
        else if (to !== undefined)
            url_ += "To=" + encodeURIComponent(to ? "" + to.toISOString() : "") + "&";
        if (storeIds === null)
            throw new Error("The parameter 'storeIds' cannot be null.");
        else if (storeIds !== undefined)
            storeIds && storeIds.forEach(item => { url_ += "StoreIds=" + encodeURIComponent("" + item) + "&"; });
        if (vendorId === null)
            throw new Error("The parameter 'vendorId' cannot be null.");
        else if (vendorId !== undefined)
            url_ += "VendorId=" + encodeURIComponent("" + vendorId) + "&";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (isOwner === null)
            throw new Error("The parameter 'isOwner' cannot be null.");
        else if (isOwner !== undefined)
            url_ += "IsOwner=" + encodeURIComponent("" + isOwner) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTotalSales(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTotalSales(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SellersRankingCardTotalDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SellersRankingCardTotalDto>;
        }));
    }

    protected processGetTotalSales(response: HttpResponseBase): Observable<SellersRankingCardTotalDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SellersRankingCardTotalDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SellersRankingCardTotalDto>(null as any);
    }

    /**
     * @return Success
     */
    getComparativeStock(): Observable<ComparativeStockDto> {
        let url_ = this.baseUrl + "/api/services/app/Seller/GetComparativeStock";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetComparativeStock(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetComparativeStock(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ComparativeStockDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ComparativeStockDto>;
        }));
    }

    protected processGetComparativeStock(response: HttpResponseBase): Observable<ComparativeStockDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ComparativeStockDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ComparativeStockDto>(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @param userId (optional) 
     * @param isOwner (optional) 
     * @param keyword (optional) 
     * @param from (optional) 
     * @param to (optional) 
     * @param storeIds (optional) 
     * @param productsIds (optional) 
     * @param variantsIds (optional) 
     * @param orderColumn (optional) 
     * @param order (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @param userRoleNames (optional) 
     * @return Success
     */
    getSellersRankingFromInvoiceData(tenantId: number | undefined, userId: number | undefined, isOwner: boolean | undefined, keyword: string | undefined, from: moment.Moment | undefined, to: moment.Moment | undefined, storeIds: number[] | undefined, productsIds: number[] | undefined, variantsIds: number[] | undefined, orderColumn: string | undefined, order: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined, userRoleNames: string[] | undefined): Observable<SellersRankingReportDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Seller/GetSellersRankingFromInvoiceData?";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (isOwner === null)
            throw new Error("The parameter 'isOwner' cannot be null.");
        else if (isOwner !== undefined)
            url_ += "IsOwner=" + encodeURIComponent("" + isOwner) + "&";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (from === null)
            throw new Error("The parameter 'from' cannot be null.");
        else if (from !== undefined)
            url_ += "From=" + encodeURIComponent(from ? "" + from.toISOString() : "") + "&";
        if (to === null)
            throw new Error("The parameter 'to' cannot be null.");
        else if (to !== undefined)
            url_ += "To=" + encodeURIComponent(to ? "" + to.toISOString() : "") + "&";
        if (storeIds === null)
            throw new Error("The parameter 'storeIds' cannot be null.");
        else if (storeIds !== undefined)
            storeIds && storeIds.forEach(item => { url_ += "StoreIds=" + encodeURIComponent("" + item) + "&"; });
        if (productsIds === null)
            throw new Error("The parameter 'productsIds' cannot be null.");
        else if (productsIds !== undefined)
            productsIds && productsIds.forEach(item => { url_ += "ProductsIds=" + encodeURIComponent("" + item) + "&"; });
        if (variantsIds === null)
            throw new Error("The parameter 'variantsIds' cannot be null.");
        else if (variantsIds !== undefined)
            variantsIds && variantsIds.forEach(item => { url_ += "VariantsIds=" + encodeURIComponent("" + item) + "&"; });
        if (orderColumn === null)
            throw new Error("The parameter 'orderColumn' cannot be null.");
        else if (orderColumn !== undefined)
            url_ += "OrderColumn=" + encodeURIComponent("" + orderColumn) + "&";
        if (order === null)
            throw new Error("The parameter 'order' cannot be null.");
        else if (order !== undefined)
            url_ += "Order=" + encodeURIComponent("" + order) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (userRoleNames === null)
            throw new Error("The parameter 'userRoleNames' cannot be null.");
        else if (userRoleNames !== undefined)
            userRoleNames && userRoleNames.forEach(item => { url_ += "userRoleNames=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSellersRankingFromInvoiceData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSellersRankingFromInvoiceData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SellersRankingReportDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SellersRankingReportDto[]>;
        }));
    }

    protected processGetSellersRankingFromInvoiceData(response: HttpResponseBase): Observable<SellersRankingReportDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(SellersRankingReportDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SellersRankingReportDto[]>(null as any);
    }
}

@Injectable()
export class SessionServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getCurrentLoginInformations(): Observable<GetCurrentLoginInformationsOutput> {
        let url_ = this.baseUrl + "/api/services/app/Session/GetCurrentLoginInformations";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCurrentLoginInformations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCurrentLoginInformations(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetCurrentLoginInformationsOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetCurrentLoginInformationsOutput>;
        }));
    }

    protected processGetCurrentLoginInformations(response: HttpResponseBase): Observable<GetCurrentLoginInformationsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCurrentLoginInformationsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetCurrentLoginInformationsOutput>(null as any);
    }
}

@Injectable()
export class SizeServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param curve (optional) 
     * @return Success
     */
    getCurve(curve: string | undefined): Observable<SizeDto> {
        let url_ = this.baseUrl + "/api/services/app/Size/GetCurve?";
        if (curve === null)
            throw new Error("The parameter 'curve' cannot be null.");
        else if (curve !== undefined)
            url_ += "curve=" + encodeURIComponent("" + curve) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCurve(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCurve(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SizeDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SizeDto>;
        }));
    }

    protected processGetCurve(response: HttpResponseBase): Observable<SizeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SizeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SizeDto>(null as any);
    }

    /**
     * @param keyword (optional) 
     * @param orderColumn (optional) 
     * @param order (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getGroupByCurves(keyword: string | undefined, orderColumn: string | undefined, order: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<SizeGetAllDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Size/GetGroupByCurves?";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (orderColumn === null)
            throw new Error("The parameter 'orderColumn' cannot be null.");
        else if (orderColumn !== undefined)
            url_ += "OrderColumn=" + encodeURIComponent("" + orderColumn) + "&";
        if (order === null)
            throw new Error("The parameter 'order' cannot be null.");
        else if (order !== undefined)
            url_ += "Order=" + encodeURIComponent("" + order) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetGroupByCurves(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGroupByCurves(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SizeGetAllDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SizeGetAllDtoPagedResultDto>;
        }));
    }

    protected processGetGroupByCurves(response: HttpResponseBase): Observable<SizeGetAllDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SizeGetAllDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SizeGetAllDtoPagedResultDto>(null as any);
    }

    /**
     * @param editCurveName (optional) 
     * @param body (optional) 
     * @return Success
     */
    addOrUpdateCurve(editCurveName: string | undefined, body: SizeDto | undefined): Observable<SizeDto> {
        let url_ = this.baseUrl + "/api/services/app/Size/AddOrUpdateCurve?";
        if (editCurveName === null)
            throw new Error("The parameter 'editCurveName' cannot be null.");
        else if (editCurveName !== undefined)
            url_ += "editCurveName=" + encodeURIComponent("" + editCurveName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddOrUpdateCurve(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddOrUpdateCurve(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SizeDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SizeDto>;
        }));
    }

    protected processAddOrUpdateCurve(response: HttpResponseBase): Observable<SizeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SizeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SizeDto>(null as any);
    }

    /**
     * @return Success
     */
    getAllCurves(): Observable<string[]> {
        let url_ = this.baseUrl + "/api/services/app/Size/GetAllCurves";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllCurves(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllCurves(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processGetAllCurves(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string[]>(null as any);
    }

    /**
     * @param curveName (optional) 
     * @return Success
     */
    deleteCurve(curveName: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Size/DeleteCurve?";
        if (curveName === null)
            throw new Error("The parameter 'curveName' cannot be null.");
        else if (curveName !== undefined)
            url_ += "curveName=" + encodeURIComponent("" + curveName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteCurve(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteCurve(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteCurve(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param name (optional) 
     * @param id (optional) 
     * @return Success
     */
    updateSize(name: string | undefined, id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Size/UpdateSize?";
        if (name === null)
            throw new Error("The parameter 'name' cannot be null.");
        else if (name !== undefined)
            url_ += "name=" + encodeURIComponent("" + name) + "&";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateSize(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateSize(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateSize(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    deleteSize(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Size/DeleteSize?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteSize(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteSize(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteSize(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param sizeId (optional) 
     * @return Success
     */
    getProductCountUsingSize(sizeId: number | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Size/GetProductCountUsingSize?";
        if (sizeId === null)
            throw new Error("The parameter 'sizeId' cannot be null.");
        else if (sizeId !== undefined)
            url_ += "sizeId=" + encodeURIComponent("" + sizeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProductCountUsingSize(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProductCountUsingSize(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGetProductCountUsingSize(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<SizeDto> {
        let url_ = this.baseUrl + "/api/services/app/Size/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SizeDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SizeDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<SizeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SizeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SizeDto>(null as any);
    }

    /**
     * @param keyword (optional) 
     * @param orderColumn (optional) 
     * @param order (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, orderColumn: string | undefined, order: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<SizeDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Size/GetAll?";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (orderColumn === null)
            throw new Error("The parameter 'orderColumn' cannot be null.");
        else if (orderColumn !== undefined)
            url_ += "OrderColumn=" + encodeURIComponent("" + orderColumn) + "&";
        if (order === null)
            throw new Error("The parameter 'order' cannot be null.");
        else if (order !== undefined)
            url_ += "Order=" + encodeURIComponent("" + order) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SizeDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SizeDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<SizeDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SizeDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SizeDtoPagedResultDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: SizeDto | undefined): Observable<SizeDto> {
        let url_ = this.baseUrl + "/api/services/app/Size/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SizeDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SizeDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<SizeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SizeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SizeDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: SizeDto | undefined): Observable<SizeDto> {
        let url_ = this.baseUrl + "/api/services/app/Size/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SizeDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SizeDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<SizeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SizeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SizeDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Size/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class SoftwareServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param keyword (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined): Observable<SoftwareDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Software/GetAll?";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SoftwareDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SoftwareDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<SoftwareDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SoftwareDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SoftwareDtoPagedResultDto>(null as any);
    }

    /**
     * @param software (optional) 
     * @return Success
     */
    downloadSoftware(software: number | undefined): Observable<SoftDownloadDto> {
        let url_ = this.baseUrl + "/api/services/app/Software/DownloadSoftware?";
        if (software === null)
            throw new Error("The parameter 'software' cannot be null.");
        else if (software !== undefined)
            url_ += "software=" + encodeURIComponent("" + software) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadSoftware(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadSoftware(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SoftDownloadDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SoftDownloadDto>;
        }));
    }

    protected processDownloadSoftware(response: HttpResponseBase): Observable<SoftDownloadDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SoftDownloadDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SoftDownloadDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: SoftwareDto | undefined): Observable<SoftwareDto> {
        let url_ = this.baseUrl + "/api/services/app/Software/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SoftwareDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SoftwareDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<SoftwareDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SoftwareDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SoftwareDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: SoftwareDto | undefined): Observable<SoftwareDto> {
        let url_ = this.baseUrl + "/api/services/app/Software/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SoftwareDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SoftwareDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<SoftwareDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SoftwareDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SoftwareDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Software/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<SoftwareDto> {
        let url_ = this.baseUrl + "/api/services/app/Software/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SoftwareDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SoftwareDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<SoftwareDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SoftwareDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SoftwareDto>(null as any);
    }
}

@Injectable()
export class StockServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: StockMovementDto | undefined): Observable<StockMovementDto> {
        let url_ = this.baseUrl + "/api/services/app/Stock/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StockMovementDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StockMovementDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<StockMovementDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StockMovementDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<StockMovementDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: StockMovementDto | undefined): Observable<StockMovementDto> {
        let url_ = this.baseUrl + "/api/services/app/Stock/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StockMovementDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StockMovementDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<StockMovementDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StockMovementDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<StockMovementDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Stock/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param keyword (optional) 
     * @param productIds (optional) 
     * @param variantIds (optional) 
     * @param warehouseIds (optional) 
     * @param storeIds (optional) 
     * @param salePointIds (optional) 
     * @param isReport (optional) 
     * @param orderColumn (optional) 
     * @param order (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllStock(keyword: string | undefined, productIds: number[] | undefined, variantIds: number[] | undefined, warehouseIds: number[] | undefined, storeIds: number[] | undefined, salePointIds: number[] | undefined, isReport: boolean | undefined, orderColumn: string | undefined, order: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<StockDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Stock/GetAllStock?";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (productIds === null)
            throw new Error("The parameter 'productIds' cannot be null.");
        else if (productIds !== undefined)
            productIds && productIds.forEach(item => { url_ += "ProductIds=" + encodeURIComponent("" + item) + "&"; });
        if (variantIds === null)
            throw new Error("The parameter 'variantIds' cannot be null.");
        else if (variantIds !== undefined)
            variantIds && variantIds.forEach(item => { url_ += "VariantIds=" + encodeURIComponent("" + item) + "&"; });
        if (warehouseIds === null)
            throw new Error("The parameter 'warehouseIds' cannot be null.");
        else if (warehouseIds !== undefined)
            warehouseIds && warehouseIds.forEach(item => { url_ += "WarehouseIds=" + encodeURIComponent("" + item) + "&"; });
        if (storeIds === null)
            throw new Error("The parameter 'storeIds' cannot be null.");
        else if (storeIds !== undefined)
            storeIds && storeIds.forEach(item => { url_ += "StoreIds=" + encodeURIComponent("" + item) + "&"; });
        if (salePointIds === null)
            throw new Error("The parameter 'salePointIds' cannot be null.");
        else if (salePointIds !== undefined)
            salePointIds && salePointIds.forEach(item => { url_ += "SalePointIds=" + encodeURIComponent("" + item) + "&"; });
        if (isReport === null)
            throw new Error("The parameter 'isReport' cannot be null.");
        else if (isReport !== undefined)
            url_ += "IsReport=" + encodeURIComponent("" + isReport) + "&";
        if (orderColumn === null)
            throw new Error("The parameter 'orderColumn' cannot be null.");
        else if (orderColumn !== undefined)
            url_ += "OrderColumn=" + encodeURIComponent("" + orderColumn) + "&";
        if (order === null)
            throw new Error("The parameter 'order' cannot be null.");
        else if (order !== undefined)
            url_ += "Order=" + encodeURIComponent("" + order) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllStock(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllStock(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StockDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StockDtoPagedResultDto>;
        }));
    }

    protected processGetAllStock(response: HttpResponseBase): Observable<StockDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StockDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<StockDtoPagedResultDto>(null as any);
    }

    /**
     * @return Success
     */
    getAllWarehouses(): Observable<WarehouseSelectDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Stock/GetAllWarehouses";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllWarehouses(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllWarehouses(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WarehouseSelectDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WarehouseSelectDto[]>;
        }));
    }

    protected processGetAllWarehouses(response: HttpResponseBase): Observable<WarehouseSelectDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(WarehouseSelectDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WarehouseSelectDto[]>(null as any);
    }

    /**
     * @param salePointId (optional) 
     * @return Success
     */
    getAllWarehousesActive(salePointId: number | undefined): Observable<number[]> {
        let url_ = this.baseUrl + "/api/services/app/Stock/GetAllWarehousesActive?";
        if (salePointId === null)
            throw new Error("The parameter 'salePointId' cannot be null.");
        else if (salePointId !== undefined)
            url_ += "salePointId=" + encodeURIComponent("" + salePointId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllWarehousesActive(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllWarehousesActive(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number[]>;
        }));
    }

    protected processGetAllWarehousesActive(response: HttpResponseBase): Observable<number[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number[]>(null as any);
    }

    /**
     * @param salePointId (optional) 
     * @param productId (optional) 
     * @param variantId (optional) 
     * @return Success
     */
    getStockByStore(salePointId: number | undefined, productId: number | undefined, variantId: number | undefined): Observable<StockDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Stock/GetStockByStore?";
        if (salePointId === null)
            throw new Error("The parameter 'salePointId' cannot be null.");
        else if (salePointId !== undefined)
            url_ += "salePointId=" + encodeURIComponent("" + salePointId) + "&";
        if (productId === null)
            throw new Error("The parameter 'productId' cannot be null.");
        else if (productId !== undefined)
            url_ += "productId=" + encodeURIComponent("" + productId) + "&";
        if (variantId === null)
            throw new Error("The parameter 'variantId' cannot be null.");
        else if (variantId !== undefined)
            url_ += "variantId=" + encodeURIComponent("" + variantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStockByStore(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStockByStore(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StockDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StockDto[]>;
        }));
    }

    protected processGetStockByStore(response: HttpResponseBase): Observable<StockDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(StockDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<StockDto[]>(null as any);
    }

    /**
     * @param warehouseId (optional) 
     * @param productId (optional) 
     * @param variantId (optional) 
     * @return Success
     */
    checkProductStock(warehouseId: number | undefined, productId: number | undefined, variantId: number | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Stock/CheckProductStock?";
        if (warehouseId === null)
            throw new Error("The parameter 'warehouseId' cannot be null.");
        else if (warehouseId !== undefined)
            url_ += "warehouseId=" + encodeURIComponent("" + warehouseId) + "&";
        if (productId === null)
            throw new Error("The parameter 'productId' cannot be null.");
        else if (productId !== undefined)
            url_ += "productId=" + encodeURIComponent("" + productId) + "&";
        if (variantId === null)
            throw new Error("The parameter 'variantId' cannot be null.");
        else if (variantId !== undefined)
            url_ += "variantId=" + encodeURIComponent("" + variantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckProductStock(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckProductStock(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCheckProductStock(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    /**
     * @param keyword (optional) 
     * @return Success
     */
    getProductsWithVariantInStock(keyword: string | undefined): Observable<ProductInvoiceDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Stock/GetProductsWithVariantInStock?";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "keyword=" + encodeURIComponent("" + keyword) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProductsWithVariantInStock(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProductsWithVariantInStock(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductInvoiceDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductInvoiceDto[]>;
        }));
    }

    protected processGetProductsWithVariantInStock(response: HttpResponseBase): Observable<ProductInvoiceDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ProductInvoiceDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProductInvoiceDto[]>(null as any);
    }

    /**
     * @param salePointId (optional) 
     * @param productId (optional) 
     * @param variantId (optional) 
     * @return Success
     */
    getProductsInStock(salePointId: number | undefined, productId: number | undefined, variantId: number | undefined): Observable<StockDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Stock/GetProductsInStock?";
        if (salePointId === null)
            throw new Error("The parameter 'salePointId' cannot be null.");
        else if (salePointId !== undefined)
            url_ += "salePointId=" + encodeURIComponent("" + salePointId) + "&";
        if (productId === null)
            throw new Error("The parameter 'productId' cannot be null.");
        else if (productId !== undefined)
            url_ += "productId=" + encodeURIComponent("" + productId) + "&";
        if (variantId === null)
            throw new Error("The parameter 'variantId' cannot be null.");
        else if (variantId !== undefined)
            url_ += "variantId=" + encodeURIComponent("" + variantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProductsInStock(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProductsInStock(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StockDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StockDto[]>;
        }));
    }

    protected processGetProductsInStock(response: HttpResponseBase): Observable<StockDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(StockDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<StockDto[]>(null as any);
    }

    /**
     * @return Success
     */
    getAllWarehouseNotReserves(): Observable<WarehouseSelectDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Stock/GetAllWarehouseNotReserves";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllWarehouseNotReserves(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllWarehouseNotReserves(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WarehouseSelectDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WarehouseSelectDto[]>;
        }));
    }

    protected processGetAllWarehouseNotReserves(response: HttpResponseBase): Observable<WarehouseSelectDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(WarehouseSelectDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WarehouseSelectDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    setMinimumStock(body: StockMinDto | undefined): Observable<StockMinDto> {
        let url_ = this.baseUrl + "/api/services/app/Stock/SetMinimumStock";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetMinimumStock(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetMinimumStock(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StockMinDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StockMinDto>;
        }));
    }

    protected processSetMinimumStock(response: HttpResponseBase): Observable<StockMinDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StockMinDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<StockMinDto>(null as any);
    }

    /**
     * @param keyword (optional) 
     * @param productIds (optional) 
     * @param variantIds (optional) 
     * @param warehouseIds (optional) 
     * @param storeIds (optional) 
     * @param isReport (optional) 
     * @param orderColumn (optional) 
     * @param order (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getStocktoWidget(keyword: string | undefined, productIds: number[] | undefined, variantIds: number[] | undefined, warehouseIds: number[] | undefined, storeIds: number[] | undefined, isReport: boolean | undefined, orderColumn: string | undefined, order: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<StockWidgetDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Stock/GetStocktoWidget?";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (productIds === null)
            throw new Error("The parameter 'productIds' cannot be null.");
        else if (productIds !== undefined)
            productIds && productIds.forEach(item => { url_ += "ProductIds=" + encodeURIComponent("" + item) + "&"; });
        if (variantIds === null)
            throw new Error("The parameter 'variantIds' cannot be null.");
        else if (variantIds !== undefined)
            variantIds && variantIds.forEach(item => { url_ += "VariantIds=" + encodeURIComponent("" + item) + "&"; });
        if (warehouseIds === null)
            throw new Error("The parameter 'warehouseIds' cannot be null.");
        else if (warehouseIds !== undefined)
            warehouseIds && warehouseIds.forEach(item => { url_ += "WarehouseIds=" + encodeURIComponent("" + item) + "&"; });
        if (storeIds === null)
            throw new Error("The parameter 'storeIds' cannot be null.");
        else if (storeIds !== undefined)
            storeIds && storeIds.forEach(item => { url_ += "StoreIds=" + encodeURIComponent("" + item) + "&"; });
        if (isReport === null)
            throw new Error("The parameter 'isReport' cannot be null.");
        else if (isReport !== undefined)
            url_ += "IsReport=" + encodeURIComponent("" + isReport) + "&";
        if (orderColumn === null)
            throw new Error("The parameter 'orderColumn' cannot be null.");
        else if (orderColumn !== undefined)
            url_ += "OrderColumn=" + encodeURIComponent("" + orderColumn) + "&";
        if (order === null)
            throw new Error("The parameter 'order' cannot be null.");
        else if (order !== undefined)
            url_ += "Order=" + encodeURIComponent("" + order) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStocktoWidget(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStocktoWidget(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StockWidgetDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StockWidgetDtoPagedResultDto>;
        }));
    }

    protected processGetStocktoWidget(response: HttpResponseBase): Observable<StockWidgetDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StockWidgetDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<StockWidgetDtoPagedResultDto>(null as any);
    }

    /**
     * @param keyword (optional) 
     * @param productIds (optional) 
     * @param variantIds (optional) 
     * @param warehouseIds (optional) 
     * @param storeIds (optional) 
     * @param isReport (optional) 
     * @param orderColumn (optional) 
     * @param order (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getStockMin(keyword: string | undefined, productIds: number[] | undefined, variantIds: number[] | undefined, warehouseIds: number[] | undefined, storeIds: number[] | undefined, isReport: boolean | undefined, orderColumn: string | undefined, order: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<StockReportDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Stock/GetStockMin?";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (productIds === null)
            throw new Error("The parameter 'productIds' cannot be null.");
        else if (productIds !== undefined)
            productIds && productIds.forEach(item => { url_ += "ProductIds=" + encodeURIComponent("" + item) + "&"; });
        if (variantIds === null)
            throw new Error("The parameter 'variantIds' cannot be null.");
        else if (variantIds !== undefined)
            variantIds && variantIds.forEach(item => { url_ += "VariantIds=" + encodeURIComponent("" + item) + "&"; });
        if (warehouseIds === null)
            throw new Error("The parameter 'warehouseIds' cannot be null.");
        else if (warehouseIds !== undefined)
            warehouseIds && warehouseIds.forEach(item => { url_ += "WarehouseIds=" + encodeURIComponent("" + item) + "&"; });
        if (storeIds === null)
            throw new Error("The parameter 'storeIds' cannot be null.");
        else if (storeIds !== undefined)
            storeIds && storeIds.forEach(item => { url_ += "StoreIds=" + encodeURIComponent("" + item) + "&"; });
        if (isReport === null)
            throw new Error("The parameter 'isReport' cannot be null.");
        else if (isReport !== undefined)
            url_ += "IsReport=" + encodeURIComponent("" + isReport) + "&";
        if (orderColumn === null)
            throw new Error("The parameter 'orderColumn' cannot be null.");
        else if (orderColumn !== undefined)
            url_ += "OrderColumn=" + encodeURIComponent("" + orderColumn) + "&";
        if (order === null)
            throw new Error("The parameter 'order' cannot be null.");
        else if (order !== undefined)
            url_ += "Order=" + encodeURIComponent("" + order) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStockMin(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStockMin(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StockReportDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StockReportDtoPagedResultDto>;
        }));
    }

    protected processGetStockMin(response: HttpResponseBase): Observable<StockReportDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StockReportDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<StockReportDtoPagedResultDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getStockMovements(body: PagedStockMovementResultRequestDto | undefined): Observable<StockMovementDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Stock/GetStockMovements";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStockMovements(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStockMovements(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StockMovementDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StockMovementDtoPagedResultDto>;
        }));
    }

    protected processGetStockMovements(response: HttpResponseBase): Observable<StockMovementDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StockMovementDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<StockMovementDtoPagedResultDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getAllStockMovements(body: PagedStockMovementResultRequestDto | undefined): Observable<StockMovementDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Stock/GetAllStockMovements";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllStockMovements(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllStockMovements(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StockMovementDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StockMovementDtoPagedResultDto>;
        }));
    }

    protected processGetAllStockMovements(response: HttpResponseBase): Observable<StockMovementDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StockMovementDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<StockMovementDtoPagedResultDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<StockMovementDto> {
        let url_ = this.baseUrl + "/api/services/app/Stock/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StockMovementDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StockMovementDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<StockMovementDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StockMovementDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<StockMovementDto>(null as any);
    }

    /**
     * @param keyword (optional) 
     * @param productIds (optional) 
     * @param variantIds (optional) 
     * @param warehouseIds (optional) 
     * @param storeIds (optional) 
     * @param isReport (optional) 
     * @param orderColumn (optional) 
     * @param order (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, productIds: number[] | undefined, variantIds: number[] | undefined, warehouseIds: number[] | undefined, storeIds: number[] | undefined, isReport: boolean | undefined, orderColumn: string | undefined, order: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<StockMovementDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Stock/GetAll?";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (productIds === null)
            throw new Error("The parameter 'productIds' cannot be null.");
        else if (productIds !== undefined)
            productIds && productIds.forEach(item => { url_ += "ProductIds=" + encodeURIComponent("" + item) + "&"; });
        if (variantIds === null)
            throw new Error("The parameter 'variantIds' cannot be null.");
        else if (variantIds !== undefined)
            variantIds && variantIds.forEach(item => { url_ += "VariantIds=" + encodeURIComponent("" + item) + "&"; });
        if (warehouseIds === null)
            throw new Error("The parameter 'warehouseIds' cannot be null.");
        else if (warehouseIds !== undefined)
            warehouseIds && warehouseIds.forEach(item => { url_ += "WarehouseIds=" + encodeURIComponent("" + item) + "&"; });
        if (storeIds === null)
            throw new Error("The parameter 'storeIds' cannot be null.");
        else if (storeIds !== undefined)
            storeIds && storeIds.forEach(item => { url_ += "StoreIds=" + encodeURIComponent("" + item) + "&"; });
        if (isReport === null)
            throw new Error("The parameter 'isReport' cannot be null.");
        else if (isReport !== undefined)
            url_ += "IsReport=" + encodeURIComponent("" + isReport) + "&";
        if (orderColumn === null)
            throw new Error("The parameter 'orderColumn' cannot be null.");
        else if (orderColumn !== undefined)
            url_ += "OrderColumn=" + encodeURIComponent("" + orderColumn) + "&";
        if (order === null)
            throw new Error("The parameter 'order' cannot be null.");
        else if (order !== undefined)
            url_ += "Order=" + encodeURIComponent("" + order) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StockMovementDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StockMovementDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<StockMovementDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StockMovementDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<StockMovementDtoPagedResultDto>(null as any);
    }
}

@Injectable()
export class StorageServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param fileId (optional) 
     * @return Success
     */
    fileNamePath(fileId: number | undefined): Observable<FileAttachInfoDto> {
        let url_ = this.baseUrl + "/api/Storage/FileNamePath?";
        if (fileId === null)
            throw new Error("The parameter 'fileId' cannot be null.");
        else if (fileId !== undefined)
            url_ += "fileId=" + encodeURIComponent("" + fileId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFileNamePath(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFileNamePath(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileAttachInfoDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileAttachInfoDto>;
        }));
    }

    protected processFileNamePath(response: HttpResponseBase): Observable<FileAttachInfoDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileAttachInfoDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileAttachInfoDto>(null as any);
    }

    /**
     * @param description (optional) 
     * @param file (optional) 
     * @return Success
     */
    upload(description: string | undefined, file: FileParameter | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/Storage/Upload?";
        if (description === null)
            throw new Error("The parameter 'description' cannot be null.");
        else if (description !== undefined)
            url_ += "description=" + encodeURIComponent("" + description) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file === null || file === undefined)
            throw new Error("The parameter 'file' cannot be null.");
        else
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpload(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpload(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processUpload(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }
}

@Injectable()
export class StoreServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: StoreDto | undefined): Observable<StoreDto> {
        let url_ = this.baseUrl + "/api/services/app/Store/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StoreDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StoreDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<StoreDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StoreDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<StoreDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: StoreDto | undefined): Observable<StoreDto> {
        let url_ = this.baseUrl + "/api/services/app/Store/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StoreDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StoreDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<StoreDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StoreDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<StoreDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<StoreDto> {
        let url_ = this.baseUrl + "/api/services/app/Store/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StoreDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StoreDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<StoreDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StoreDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<StoreDto>(null as any);
    }

    /**
     * @param keyword (optional) 
     * @param isActive (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, isActive: boolean | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<StoreDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Store/GetAll?";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (isActive === null)
            throw new Error("The parameter 'isActive' cannot be null.");
        else if (isActive !== undefined)
            url_ += "IsActive=" + encodeURIComponent("" + isActive) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StoreDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StoreDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<StoreDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StoreDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<StoreDtoPagedResultDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Store/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class TaxServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: TaxDto | undefined): Observable<TaxDto> {
        let url_ = this.baseUrl + "/api/services/app/Tax/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TaxDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TaxDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<TaxDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TaxDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TaxDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: TaxDto | undefined): Observable<TaxDto> {
        let url_ = this.baseUrl + "/api/services/app/Tax/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TaxDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TaxDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<TaxDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TaxDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TaxDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Tax/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param keyword (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<TaxDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Tax/GetAll?";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TaxDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TaxDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<TaxDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TaxDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TaxDtoPagedResultDto>(null as any);
    }

    /**
     * @return Success
     */
    getAllTaxes(): Observable<TaxDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Tax/GetAllTaxes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllTaxes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllTaxes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TaxDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TaxDto[]>;
        }));
    }

    protected processGetAllTaxes(response: HttpResponseBase): Observable<TaxDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(TaxDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TaxDto[]>(null as any);
    }

    /**
     * @return Success
     */
    getTaxTypes(): Observable<EnumDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Tax/GetTaxTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTaxTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTaxTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EnumDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EnumDto[]>;
        }));
    }

    protected processGetTaxTypes(response: HttpResponseBase): Observable<EnumDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(EnumDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<EnumDto[]>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<TaxDto> {
        let url_ = this.baseUrl + "/api/services/app/Tax/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TaxDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TaxDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<TaxDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TaxDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TaxDto>(null as any);
    }
}

@Injectable()
export class TemplateServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: TemplateDto | undefined): Observable<TemplateDto> {
        let url_ = this.baseUrl + "/api/services/app/Template/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TemplateDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TemplateDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<TemplateDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TemplateDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TemplateDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: TemplateDto | undefined): Observable<TemplateDto> {
        let url_ = this.baseUrl + "/api/services/app/Template/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TemplateDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TemplateDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<TemplateDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TemplateDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TemplateDto>(null as any);
    }

    /**
     * @param keyword (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<TemplateDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Template/GetAll?";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TemplateDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TemplateDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<TemplateDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TemplateDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TemplateDtoPagedResultDto>(null as any);
    }

    /**
     * @return Success
     */
    getContentTypes(): Observable<EnumDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Template/GetContentTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetContentTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetContentTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EnumDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EnumDto[]>;
        }));
    }

    protected processGetContentTypes(response: HttpResponseBase): Observable<EnumDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(EnumDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<EnumDto[]>(null as any);
    }

    /**
     * @return Success
     */
    getTemplateTypes(): Observable<EnumDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Template/GetTemplateTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTemplateTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTemplateTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EnumDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EnumDto[]>;
        }));
    }

    protected processGetTemplateTypes(response: HttpResponseBase): Observable<EnumDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(EnumDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<EnumDto[]>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<TemplateDto> {
        let url_ = this.baseUrl + "/api/services/app/Template/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TemplateDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TemplateDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<TemplateDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TemplateDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TemplateDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Template/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class TenantServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getTenantsListDto(): Observable<TenantDtoListResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/GetTenantsListDto";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTenantsListDto(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTenantsListDto(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TenantDtoListResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TenantDtoListResultDto>;
        }));
    }

    protected processGetTenantsListDto(response: HttpResponseBase): Observable<TenantDtoListResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TenantDtoListResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TenantDtoListResultDto>(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @return Success
     */
    getLogo(tenantId: number | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/GetLogo?";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLogo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLogo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetLogo(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateTenantDto | undefined): Observable<TenantDto> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TenantDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TenantDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<TenantDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TenantDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TenantDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param name (optional) 
     * @return Success
     */
    getByName(name: string | undefined): Observable<TenantDto> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/GetByName?";
        if (name === null)
            throw new Error("The parameter 'name' cannot be null.");
        else if (name !== undefined)
            url_ += "name=" + encodeURIComponent("" + name) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByName(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByName(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TenantDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TenantDto>;
        }));
    }

    protected processGetByName(response: HttpResponseBase): Observable<TenantDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TenantDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TenantDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateTenantDto | undefined): Observable<TenantDto> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TenantDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TenantDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<TenantDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TenantDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TenantDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<TenantDto> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TenantDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TenantDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<TenantDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TenantDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TenantDto>(null as any);
    }

    /**
     * @return Success
     */
    getAllWservice(): Observable<EnumDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/getAllWservice";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllWservice(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllWservice(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EnumDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EnumDto[]>;
        }));
    }

    protected processGetAllWservice(response: HttpResponseBase): Observable<EnumDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(EnumDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<EnumDto[]>(null as any);
    }

    /**
     * @param keyword (optional) 
     * @return Success
     */
    getTenantsEditionClient(keyword: string | undefined): Observable<TenantDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/GetTenantsEditionClient?";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "keyword=" + encodeURIComponent("" + keyword) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTenantsEditionClient(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTenantsEditionClient(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TenantDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TenantDto[]>;
        }));
    }

    protected processGetTenantsEditionClient(response: HttpResponseBase): Observable<TenantDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(TenantDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TenantDto[]>(null as any);
    }

    /**
     * @param keyword (optional) 
     * @return Success
     */
    getTenantsEditionHost(keyword: string | undefined): Observable<TenantDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/GetTenantsEditionHost?";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "keyword=" + encodeURIComponent("" + keyword) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTenantsEditionHost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTenantsEditionHost(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TenantDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TenantDto[]>;
        }));
    }

    protected processGetTenantsEditionHost(response: HttpResponseBase): Observable<TenantDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(TenantDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TenantDto[]>(null as any);
    }

    /**
     * @param inputId (optional) 
     * @return Success
     */
    isUserInParentId(inputId: number | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/IsUserInParentId?";
        if (inputId === null)
            throw new Error("The parameter 'inputId' cannot be null.");
        else if (inputId !== undefined)
            url_ += "inputId=" + encodeURIComponent("" + inputId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIsUserInParentId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIsUserInParentId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processIsUserInParentId(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getTenant(id: number | undefined): Observable<TenantDto> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/GetTenant?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTenant(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTenant(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TenantDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TenantDto>;
        }));
    }

    protected processGetTenant(response: HttpResponseBase): Observable<TenantDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TenantDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TenantDto>(null as any);
    }

    /**
     * @param keyword (optional) 
     * @param isActive (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, isActive: boolean | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<TenantDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/GetAll?";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (isActive === null)
            throw new Error("The parameter 'isActive' cannot be null.");
        else if (isActive !== undefined)
            url_ += "IsActive=" + encodeURIComponent("" + isActive) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TenantDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TenantDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<TenantDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TenantDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TenantDtoPagedResultDto>(null as any);
    }
}

@Injectable()
export class TenantGroupServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: TenantGroupDto | undefined): Observable<TenantGroupDto> {
        let url_ = this.baseUrl + "/api/services/app/TenantGroup/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TenantGroupDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TenantGroupDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<TenantGroupDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TenantGroupDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TenantGroupDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: TenantGroupDto | undefined): Observable<TenantGroupDto> {
        let url_ = this.baseUrl + "/api/services/app/TenantGroup/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TenantGroupDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TenantGroupDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<TenantGroupDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TenantGroupDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TenantGroupDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TenantGroup/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getTenants(id: number | undefined): Observable<TenantDto[]> {
        let url_ = this.baseUrl + "/api/services/app/TenantGroup/GetTenants?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTenants(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTenants(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TenantDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TenantDto[]>;
        }));
    }

    protected processGetTenants(response: HttpResponseBase): Observable<TenantDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(TenantDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TenantDto[]>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getAllTenants(id: number | undefined): Observable<TenantDto[]> {
        let url_ = this.baseUrl + "/api/services/app/TenantGroup/GetAllTenants?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllTenants(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllTenants(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TenantDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TenantDto[]>;
        }));
    }

    protected processGetAllTenants(response: HttpResponseBase): Observable<TenantDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(TenantDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TenantDto[]>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getTenantGroup(id: number | undefined): Observable<TenantGroupDto> {
        let url_ = this.baseUrl + "/api/services/app/TenantGroup/GetTenantGroup?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTenantGroup(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTenantGroup(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TenantGroupDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TenantGroupDto>;
        }));
    }

    protected processGetTenantGroup(response: HttpResponseBase): Observable<TenantGroupDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TenantGroupDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TenantGroupDto>(null as any);
    }

    /**
     * @param keyword (optional) 
     * @return Success
     */
    getTenantsSearch(keyword: string | undefined): Observable<TenantDto[]> {
        let url_ = this.baseUrl + "/api/services/app/TenantGroup/GetTenantsSearch?";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "keyword=" + encodeURIComponent("" + keyword) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTenantsSearch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTenantsSearch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TenantDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TenantDto[]>;
        }));
    }

    protected processGetTenantsSearch(response: HttpResponseBase): Observable<TenantDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(TenantDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TenantDto[]>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    removeTenant(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TenantGroup/RemoveTenant?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemoveTenant(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemoveTenant(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRemoveTenant(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<TenantGroupDto> {
        let url_ = this.baseUrl + "/api/services/app/TenantGroup/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TenantGroupDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TenantGroupDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<TenantGroupDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TenantGroupDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TenantGroupDto>(null as any);
    }

    /**
     * @param keyword (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<TenantGroupDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/TenantGroup/GetAll?";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TenantGroupDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TenantGroupDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<TenantGroupDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TenantGroupDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TenantGroupDtoPagedResultDto>(null as any);
    }
}

@Injectable()
export class TokenAuthServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    authenticate(body: AuthenticateModel | undefined): Observable<AuthenticateResultModel> {
        let url_ = this.baseUrl + "/api/TokenAuth/Authenticate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAuthenticate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAuthenticate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuthenticateResultModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuthenticateResultModel>;
        }));
    }

    protected processAuthenticate(response: HttpResponseBase): Observable<AuthenticateResultModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuthenticateResultModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AuthenticateResultModel>(null as any);
    }

    /**
     * @return Success
     */
    getExternalAuthenticationProviders(): Observable<ExternalLoginProviderInfoModel[]> {
        let url_ = this.baseUrl + "/api/TokenAuth/GetExternalAuthenticationProviders";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetExternalAuthenticationProviders(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetExternalAuthenticationProviders(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExternalLoginProviderInfoModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExternalLoginProviderInfoModel[]>;
        }));
    }

    protected processGetExternalAuthenticationProviders(response: HttpResponseBase): Observable<ExternalLoginProviderInfoModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ExternalLoginProviderInfoModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ExternalLoginProviderInfoModel[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    externalAuthenticate(body: ExternalAuthenticateModel | undefined): Observable<ExternalAuthenticateResultModel> {
        let url_ = this.baseUrl + "/api/TokenAuth/ExternalAuthenticate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExternalAuthenticate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExternalAuthenticate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExternalAuthenticateResultModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExternalAuthenticateResultModel>;
        }));
    }

    protected processExternalAuthenticate(response: HttpResponseBase): Observable<ExternalAuthenticateResultModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExternalAuthenticateResultModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ExternalAuthenticateResultModel>(null as any);
    }
}

@Injectable()
export class UserServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateUserDto | undefined): Observable<UserDto> {
        let url_ = this.baseUrl + "/api/services/app/User/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<UserDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UserDto | undefined): Observable<UserDto> {
        let url_ = this.baseUrl + "/api/services/app/User/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<UserDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserDto>(null as any);
    }

    /**
     * @param userId (optional) 
     * @return Success
     */
    getUserById(userId: number | undefined): Observable<UserDto> {
        let url_ = this.baseUrl + "/api/services/app/User/GetUserById?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserDto>;
        }));
    }

    protected processGetUserById(response: HttpResponseBase): Observable<UserDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/User/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    activate(body: Int64EntityDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/User/Activate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processActivate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processActivate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processActivate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param userId (optional) 
     * @return Success
     */
    toggleIsActiveUser(userId: number | undefined): Observable<UserDto> {
        let url_ = this.baseUrl + "/api/services/app/User/ToggleIsActiveUser?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processToggleIsActiveUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processToggleIsActiveUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserDto>;
        }));
    }

    protected processToggleIsActiveUser(response: HttpResponseBase): Observable<UserDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserDto>(null as any);
    }

    /**
     * @param userId (optional) 
     * @return Success
     */
    getUserRoles(userId: number | undefined): Observable<string[]> {
        let url_ = this.baseUrl + "/api/services/app/User/GetUserRoles?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserRoles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserRoles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processGetUserRoles(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    deActivate(body: Int64EntityDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/User/DeActivate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeActivate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeActivate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeActivate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    getRoles(): Observable<RoleDtoListResultDto> {
        let url_ = this.baseUrl + "/api/services/app/User/GetRoles";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRoles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRoles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RoleDtoListResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RoleDtoListResultDto>;
        }));
    }

    protected processGetRoles(response: HttpResponseBase): Observable<RoleDtoListResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RoleDtoListResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RoleDtoListResultDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    changeLanguage(body: ChangeUserLanguageDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/User/ChangeLanguage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangeLanguage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangeLanguage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processChangeLanguage(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    changePassword(body: ChangePasswordDto | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/User/ChangePassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangePassword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangePassword(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processChangePassword(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    resetPassword(body: ResetPasswordDto | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/User/ResetPassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processResetPassword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResetPassword(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processResetPassword(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @param keyword (optional) 
     * @param isActive (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, isActive: boolean | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<UserDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/User/GetAll?";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (isActive === null)
            throw new Error("The parameter 'isActive' cannot be null.");
        else if (isActive !== undefined)
            url_ += "IsActive=" + encodeURIComponent("" + isActive) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<UserDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserDtoPagedResultDto>(null as any);
    }

    /**
     * @return Success
     */
    getAllCashierUser(): Observable<CashierUserDtoListResultDto> {
        let url_ = this.baseUrl + "/api/services/app/User/GetAllCashierUser";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllCashierUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllCashierUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CashierUserDtoListResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CashierUserDtoListResultDto>;
        }));
    }

    protected processGetAllCashierUser(response: HttpResponseBase): Observable<CashierUserDtoListResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CashierUserDtoListResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CashierUserDtoListResultDto>(null as any);
    }

    /**
     * @return Success
     */
    getSalePoints(): Observable<SalePointInvoiceDto[]> {
        let url_ = this.baseUrl + "/api/services/app/User/GetSalePoints";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSalePoints(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSalePoints(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SalePointInvoiceDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SalePointInvoiceDto[]>;
        }));
    }

    protected processGetSalePoints(response: HttpResponseBase): Observable<SalePointInvoiceDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(SalePointInvoiceDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SalePointInvoiceDto[]>(null as any);
    }

    /**
     * @return Success
     */
    tenantUseNoFiscal(): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/User/TenantUseNoFiscal";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTenantUseNoFiscal(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTenantUseNoFiscal(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processTenantUseNoFiscal(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @return Success
     */
    getAllStores(): Observable<StoreDto[]> {
        let url_ = this.baseUrl + "/api/services/app/User/GetAllStores";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllStores(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllStores(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StoreDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StoreDto[]>;
        }));
    }

    protected processGetAllStores(response: HttpResponseBase): Observable<StoreDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(StoreDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<StoreDto[]>(null as any);
    }

    /**
     * @param userId (optional) 
     * @return Success
     */
    getAllStoresOnLogin(userId: number | undefined): Observable<StoreForListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/User/GetAllStoresOnLogin?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllStoresOnLogin(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllStoresOnLogin(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StoreForListDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StoreForListDto[]>;
        }));
    }

    protected processGetAllStoresOnLogin(response: HttpResponseBase): Observable<StoreForListDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(StoreForListDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<StoreForListDto[]>(null as any);
    }

    /**
     * @param storeId (optional) 
     * @return Success
     */
    getSalePointsOnLogin(storeId: number | undefined): Observable<SalePointInvoiceDto[]> {
        let url_ = this.baseUrl + "/api/services/app/User/GetSalePointsOnLogin?";
        if (storeId === null)
            throw new Error("The parameter 'storeId' cannot be null.");
        else if (storeId !== undefined)
            url_ += "storeId=" + encodeURIComponent("" + storeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSalePointsOnLogin(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSalePointsOnLogin(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SalePointInvoiceDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SalePointInvoiceDto[]>;
        }));
    }

    protected processGetSalePointsOnLogin(response: HttpResponseBase): Observable<SalePointInvoiceDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(SalePointInvoiceDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SalePointInvoiceDto[]>(null as any);
    }

    /**
     * @param salePointId (optional) 
     * @return Success
     */
    getCashiersOnLogin(salePointId: number | undefined): Observable<CashierUserDtoListResultDto> {
        let url_ = this.baseUrl + "/api/services/app/User/GetCashiersOnLogin?";
        if (salePointId === null)
            throw new Error("The parameter 'salePointId' cannot be null.");
        else if (salePointId !== undefined)
            url_ += "salePointId=" + encodeURIComponent("" + salePointId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCashiersOnLogin(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCashiersOnLogin(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CashierUserDtoListResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CashierUserDtoListResultDto>;
        }));
    }

    protected processGetCashiersOnLogin(response: HttpResponseBase): Observable<CashierUserDtoListResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CashierUserDtoListResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CashierUserDtoListResultDto>(null as any);
    }

    /**
     * @param userId (optional) 
     * @return Success
     */
    getSalePointsForUser(userId: number | undefined): Observable<SalePointDto[]> {
        let url_ = this.baseUrl + "/api/services/app/User/GetSalePointsForUser?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSalePointsForUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSalePointsForUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SalePointDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SalePointDto[]>;
        }));
    }

    protected processGetSalePointsForUser(response: HttpResponseBase): Observable<SalePointDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(SalePointDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SalePointDto[]>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<UserDto> {
        let url_ = this.baseUrl + "/api/services/app/User/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<UserDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserDto>(null as any);
    }
}

@Injectable()
export class VoucherServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Voucher/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: VoucherDto | undefined): Observable<VoucherDto> {
        let url_ = this.baseUrl + "/api/services/app/Voucher/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VoucherDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VoucherDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<VoucherDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VoucherDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<VoucherDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: VoucherDto | undefined): Observable<VoucherDto> {
        let url_ = this.baseUrl + "/api/services/app/Voucher/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VoucherDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VoucherDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<VoucherDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VoucherDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<VoucherDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<VoucherDto> {
        let url_ = this.baseUrl + "/api/services/app/Voucher/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VoucherDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VoucherDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<VoucherDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VoucherDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<VoucherDto>(null as any);
    }

    /**
     * @param keyword (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<VoucherDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Voucher/GetAll?";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VoucherDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VoucherDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<VoucherDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VoucherDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<VoucherDtoPagedResultDto>(null as any);
    }

    /**
     * @param code (optional) 
     * @param clientId (optional) 
     * @return Success
     */
    getByCode(code: string | undefined, clientId: number | undefined): Observable<VoucherDto> {
        let url_ = this.baseUrl + "/api/services/app/Voucher/GetByCode?";
        if (code === null)
            throw new Error("The parameter 'code' cannot be null.");
        else if (code !== undefined)
            url_ += "code=" + encodeURIComponent("" + code) + "&";
        if (clientId === null)
            throw new Error("The parameter 'clientId' cannot be null.");
        else if (clientId !== undefined)
            url_ += "clientId=" + encodeURIComponent("" + clientId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByCode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VoucherDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VoucherDto>;
        }));
    }

    protected processGetByCode(response: HttpResponseBase): Observable<VoucherDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VoucherDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<VoucherDto>(null as any);
    }

    /**
     * @param voucherId (optional) 
     * @return Success
     */
    generatePDFChangeTicket(voucherId: number | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Voucher/GeneratePDFChangeTicket?";
        if (voucherId === null)
            throw new Error("The parameter 'voucherId' cannot be null.");
        else if (voucherId !== undefined)
            url_ += "voucherId=" + encodeURIComponent("" + voucherId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGeneratePDFChangeTicket(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGeneratePDFChangeTicket(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGeneratePDFChangeTicket(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }
}

@Injectable()
export class WarehouseServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: WarehouseDto | undefined): Observable<WarehouseDto> {
        let url_ = this.baseUrl + "/api/services/app/Warehouse/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WarehouseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WarehouseDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<WarehouseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WarehouseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WarehouseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: WarehouseDto | undefined): Observable<WarehouseDto> {
        let url_ = this.baseUrl + "/api/services/app/Warehouse/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WarehouseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WarehouseDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<WarehouseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WarehouseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WarehouseDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Warehouse/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param keyword (optional) 
     * @param isActive (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, isActive: boolean | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<WarehouseDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Warehouse/GetAll?";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (isActive === null)
            throw new Error("The parameter 'isActive' cannot be null.");
        else if (isActive !== undefined)
            url_ += "IsActive=" + encodeURIComponent("" + isActive) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WarehouseDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WarehouseDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<WarehouseDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WarehouseDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WarehouseDtoPagedResultDto>(null as any);
    }

    /**
     * @return Success
     */
    getAllStores(): Observable<StoreForListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Warehouse/GetAllStores";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllStores(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllStores(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StoreForListDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StoreForListDto[]>;
        }));
    }

    protected processGetAllStores(response: HttpResponseBase): Observable<StoreForListDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(StoreForListDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<StoreForListDto[]>(null as any);
    }

    /**
     * @param storeIds (optional) 
     * @return Success
     */
    getWarehousesByStores(storeIds: number[] | undefined): Observable<WarehouseSelectDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Warehouse/GetWarehousesByStores?";
        if (storeIds === null)
            throw new Error("The parameter 'storeIds' cannot be null.");
        else if (storeIds !== undefined)
            storeIds && storeIds.forEach(item => { url_ += "storeIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetWarehousesByStores(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWarehousesByStores(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WarehouseSelectDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WarehouseSelectDto[]>;
        }));
    }

    protected processGetWarehousesByStores(response: HttpResponseBase): Observable<WarehouseSelectDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(WarehouseSelectDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WarehouseSelectDto[]>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<WarehouseDto> {
        let url_ = this.baseUrl + "/api/services/app/Warehouse/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WarehouseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WarehouseDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<WarehouseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WarehouseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WarehouseDto>(null as any);
    }
}

export class AbpLogDto implements IAbpLogDto {
    id: number;
    date: moment.Moment;
    thread: string | undefined;
    level: string | undefined;
    logger: string | undefined;
    message: string | undefined;
    exception: string | undefined;

    constructor(data?: IAbpLogDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.date = _data["date"] ? moment(_data["date"].toString()) : <any>undefined;
            this.thread = _data["thread"];
            this.level = _data["level"];
            this.logger = _data["logger"];
            this.message = _data["message"];
            this.exception = _data["exception"];
        }
    }

    static fromJS(data: any): AbpLogDto {
        data = typeof data === 'object' ? data : {};
        let result = new AbpLogDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["thread"] = this.thread;
        data["level"] = this.level;
        data["logger"] = this.logger;
        data["message"] = this.message;
        data["exception"] = this.exception;
        return data;
    }

    clone(): AbpLogDto {
        const json = this.toJSON();
        let result = new AbpLogDto();
        result.init(json);
        return result;
    }
}

export interface IAbpLogDto {
    id: number;
    date: moment.Moment;
    thread: string | undefined;
    level: string | undefined;
    logger: string | undefined;
    message: string | undefined;
    exception: string | undefined;
}

export class AbpLogDtoPagedResultDto implements IAbpLogDtoPagedResultDto {
    items: AbpLogDto[] | undefined;
    totalCount: number;

    constructor(data?: IAbpLogDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(AbpLogDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): AbpLogDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new AbpLogDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): AbpLogDtoPagedResultDto {
        const json = this.toJSON();
        let result = new AbpLogDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IAbpLogDtoPagedResultDto {
    items: AbpLogDto[] | undefined;
    totalCount: number;
}

export class AfipReportDataDto implements IAfipReportDataDto {
    dateInit: string | undefined;
    dateEnd: string | undefined;
    printerId: number;
    path: string | undefined;

    constructor(data?: IAfipReportDataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dateInit = _data["dateInit"];
            this.dateEnd = _data["dateEnd"];
            this.printerId = _data["printerId"];
            this.path = _data["path"];
        }
    }

    static fromJS(data: any): AfipReportDataDto {
        data = typeof data === 'object' ? data : {};
        let result = new AfipReportDataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dateInit"] = this.dateInit;
        data["dateEnd"] = this.dateEnd;
        data["printerId"] = this.printerId;
        data["path"] = this.path;
        return data;
    }

    clone(): AfipReportDataDto {
        const json = this.toJSON();
        let result = new AfipReportDataDto();
        result.init(json);
        return result;
    }
}

export interface IAfipReportDataDto {
    dateInit: string | undefined;
    dateEnd: string | undefined;
    printerId: number;
    path: string | undefined;
}

export class ApplicationInfoDto implements IApplicationInfoDto {
    version: string | undefined;
    releaseDate: moment.Moment;
    features: { [key: string]: boolean; } | undefined;

    constructor(data?: IApplicationInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.version = _data["version"];
            this.releaseDate = _data["releaseDate"] ? moment(_data["releaseDate"].toString()) : <any>undefined;
            if (_data["features"]) {
                this.features = {} as any;
                for (let key in _data["features"]) {
                    if (_data["features"].hasOwnProperty(key))
                        (<any>this.features)[key] = _data["features"][key];
                }
            }
        }
    }

    static fromJS(data: any): ApplicationInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["version"] = this.version;
        data["releaseDate"] = this.releaseDate ? this.releaseDate.toISOString() : <any>undefined;
        if (this.features) {
            data["features"] = {};
            for (let key in this.features) {
                if (this.features.hasOwnProperty(key))
                    (<any>data["features"])[key] = (<any>this.features)[key];
            }
        }
        return data;
    }

    clone(): ApplicationInfoDto {
        const json = this.toJSON();
        let result = new ApplicationInfoDto();
        result.init(json);
        return result;
    }
}

export interface IApplicationInfoDto {
    version: string | undefined;
    releaseDate: moment.Moment;
    features: { [key: string]: boolean; } | undefined;
}

export class ArcaJumpInformationDto implements IArcaJumpInformationDto {
    prefix: number;
    number: number;
    cae: string | undefined;
    cuit: string | undefined;
    total: number;
    iva: number;
    expirationDateCAE: moment.Moment;
    creationTime: moment.Moment;

    constructor(data?: IArcaJumpInformationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.prefix = _data["prefix"];
            this.number = _data["number"];
            this.cae = _data["cae"];
            this.cuit = _data["cuit"];
            this.total = _data["total"];
            this.iva = _data["iva"];
            this.expirationDateCAE = _data["expirationDateCAE"] ? moment(_data["expirationDateCAE"].toString()) : <any>undefined;
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ArcaJumpInformationDto {
        data = typeof data === 'object' ? data : {};
        let result = new ArcaJumpInformationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["prefix"] = this.prefix;
        data["number"] = this.number;
        data["cae"] = this.cae;
        data["cuit"] = this.cuit;
        data["total"] = this.total;
        data["iva"] = this.iva;
        data["expirationDateCAE"] = this.expirationDateCAE ? this.expirationDateCAE.toISOString() : <any>undefined;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        return data;
    }

    clone(): ArcaJumpInformationDto {
        const json = this.toJSON();
        let result = new ArcaJumpInformationDto();
        result.init(json);
        return result;
    }
}

export interface IArcaJumpInformationDto {
    prefix: number;
    number: number;
    cae: string | undefined;
    cuit: string | undefined;
    total: number;
    iva: number;
    expirationDateCAE: moment.Moment;
    creationTime: moment.Moment;
}

export class AuthenticateModel implements IAuthenticateModel {
    userNameOrEmailAddress: string;
    password: string;
    rememberClient: boolean;

    constructor(data?: IAuthenticateModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userNameOrEmailAddress = _data["userNameOrEmailAddress"];
            this.password = _data["password"];
            this.rememberClient = _data["rememberClient"];
        }
    }

    static fromJS(data: any): AuthenticateModel {
        data = typeof data === 'object' ? data : {};
        let result = new AuthenticateModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userNameOrEmailAddress"] = this.userNameOrEmailAddress;
        data["password"] = this.password;
        data["rememberClient"] = this.rememberClient;
        return data;
    }

    clone(): AuthenticateModel {
        const json = this.toJSON();
        let result = new AuthenticateModel();
        result.init(json);
        return result;
    }
}

export interface IAuthenticateModel {
    userNameOrEmailAddress: string;
    password: string;
    rememberClient: boolean;
}

export class AuthenticateResultModel implements IAuthenticateResultModel {
    accessToken: string | undefined;
    encryptedAccessToken: string | undefined;
    expireInSeconds: number;
    userId: number;
    waitingForAction: boolean;

    constructor(data?: IAuthenticateResultModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accessToken = _data["accessToken"];
            this.encryptedAccessToken = _data["encryptedAccessToken"];
            this.expireInSeconds = _data["expireInSeconds"];
            this.userId = _data["userId"];
            this.waitingForAction = _data["waitingForAction"];
        }
    }

    static fromJS(data: any): AuthenticateResultModel {
        data = typeof data === 'object' ? data : {};
        let result = new AuthenticateResultModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accessToken"] = this.accessToken;
        data["encryptedAccessToken"] = this.encryptedAccessToken;
        data["expireInSeconds"] = this.expireInSeconds;
        data["userId"] = this.userId;
        data["waitingForAction"] = this.waitingForAction;
        return data;
    }

    clone(): AuthenticateResultModel {
        const json = this.toJSON();
        let result = new AuthenticateResultModel();
        result.init(json);
        return result;
    }
}

export interface IAuthenticateResultModel {
    accessToken: string | undefined;
    encryptedAccessToken: string | undefined;
    expireInSeconds: number;
    userId: number;
    waitingForAction: boolean;
}

export class AutoserviceDto implements IAutoserviceDto {
    id: number;
    tenantId: number | undefined;
    storeId: number;
    listProducts: InvoiceProductDto[] | undefined;
    totalWithTaxes: number;
    autoserviceCode: string | undefined;
    invoiceFormType: InvoiceFormType;
    clientFullName: string | undefined;

    constructor(data?: IAutoserviceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tenantId = _data["tenantId"];
            this.storeId = _data["storeId"];
            if (Array.isArray(_data["listProducts"])) {
                this.listProducts = [] as any;
                for (let item of _data["listProducts"])
                    this.listProducts.push(InvoiceProductDto.fromJS(item));
            }
            this.totalWithTaxes = _data["totalWithTaxes"];
            this.autoserviceCode = _data["autoserviceCode"];
            this.invoiceFormType = _data["invoiceFormType"];
            this.clientFullName = _data["clientFullName"];
        }
    }

    static fromJS(data: any): AutoserviceDto {
        data = typeof data === 'object' ? data : {};
        let result = new AutoserviceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tenantId"] = this.tenantId;
        data["storeId"] = this.storeId;
        if (Array.isArray(this.listProducts)) {
            data["listProducts"] = [];
            for (let item of this.listProducts)
                data["listProducts"].push(item.toJSON());
        }
        data["totalWithTaxes"] = this.totalWithTaxes;
        data["autoserviceCode"] = this.autoserviceCode;
        data["invoiceFormType"] = this.invoiceFormType;
        data["clientFullName"] = this.clientFullName;
        return data;
    }

    clone(): AutoserviceDto {
        const json = this.toJSON();
        let result = new AutoserviceDto();
        result.init(json);
        return result;
    }
}

export interface IAutoserviceDto {
    id: number;
    tenantId: number | undefined;
    storeId: number;
    listProducts: InvoiceProductDto[] | undefined;
    totalWithTaxes: number;
    autoserviceCode: string | undefined;
    invoiceFormType: InvoiceFormType;
    clientFullName: string | undefined;
}

export class Bank implements IBank {
    id: number;
    tenantId: number | undefined;
    isDeleted: boolean;
    name: string | undefined;
    parentId: number;
    externalId: number | undefined;
    promotions: Promotion[] | undefined;

    constructor(data?: IBank) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tenantId = _data["tenantId"];
            this.isDeleted = _data["isDeleted"];
            this.name = _data["name"];
            this.parentId = _data["parentId"];
            this.externalId = _data["externalId"];
            if (Array.isArray(_data["promotions"])) {
                this.promotions = [] as any;
                for (let item of _data["promotions"])
                    this.promotions.push(Promotion.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Bank {
        data = typeof data === 'object' ? data : {};
        let result = new Bank();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tenantId"] = this.tenantId;
        data["isDeleted"] = this.isDeleted;
        data["name"] = this.name;
        data["parentId"] = this.parentId;
        data["externalId"] = this.externalId;
        if (Array.isArray(this.promotions)) {
            data["promotions"] = [];
            for (let item of this.promotions)
                data["promotions"].push(item.toJSON());
        }
        return data;
    }

    clone(): Bank {
        const json = this.toJSON();
        let result = new Bank();
        result.init(json);
        return result;
    }
}

export interface IBank {
    id: number;
    tenantId: number | undefined;
    isDeleted: boolean;
    name: string | undefined;
    parentId: number;
    externalId: number | undefined;
    promotions: Promotion[] | undefined;
}

export class BankAccountDto implements IBankAccountDto {
    id: number;
    tenantId: number | undefined;
    name: string;
    cbu: string;
    alias: string;
    taxNumber: string | undefined;
    isPaywayAccount: boolean;

    constructor(data?: IBankAccountDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tenantId = _data["tenantId"];
            this.name = _data["name"];
            this.cbu = _data["cbu"];
            this.alias = _data["alias"];
            this.taxNumber = _data["taxNumber"];
            this.isPaywayAccount = _data["isPaywayAccount"];
        }
    }

    static fromJS(data: any): BankAccountDto {
        data = typeof data === 'object' ? data : {};
        let result = new BankAccountDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tenantId"] = this.tenantId;
        data["name"] = this.name;
        data["cbu"] = this.cbu;
        data["alias"] = this.alias;
        data["taxNumber"] = this.taxNumber;
        data["isPaywayAccount"] = this.isPaywayAccount;
        return data;
    }

    clone(): BankAccountDto {
        const json = this.toJSON();
        let result = new BankAccountDto();
        result.init(json);
        return result;
    }
}

export interface IBankAccountDto {
    id: number;
    tenantId: number | undefined;
    name: string;
    cbu: string;
    alias: string;
    taxNumber: string | undefined;
    isPaywayAccount: boolean;
}

export class BankAccountDtoPagedResultDto implements IBankAccountDtoPagedResultDto {
    items: BankAccountDto[] | undefined;
    totalCount: number;

    constructor(data?: IBankAccountDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(BankAccountDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): BankAccountDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new BankAccountDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): BankAccountDtoPagedResultDto {
        const json = this.toJSON();
        let result = new BankAccountDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IBankAccountDtoPagedResultDto {
    items: BankAccountDto[] | undefined;
    totalCount: number;
}

export class BankAccountModel implements IBankAccountModel {
    name: string | undefined;
    cbu: string | undefined;
    alias: string | undefined;
    taxNumber: string | undefined;

    constructor(data?: IBankAccountModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.cbu = _data["cbu"];
            this.alias = _data["alias"];
            this.taxNumber = _data["taxNumber"];
        }
    }

    static fromJS(data: any): BankAccountModel {
        data = typeof data === 'object' ? data : {};
        let result = new BankAccountModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["cbu"] = this.cbu;
        data["alias"] = this.alias;
        data["taxNumber"] = this.taxNumber;
        return data;
    }

    clone(): BankAccountModel {
        const json = this.toJSON();
        let result = new BankAccountModel();
        result.init(json);
        return result;
    }
}

export interface IBankAccountModel {
    name: string | undefined;
    cbu: string | undefined;
    alias: string | undefined;
    taxNumber: string | undefined;
}

export class BankAccountSelectDto implements IBankAccountSelectDto {
    id: number;
    name: string | undefined;

    constructor(data?: IBankAccountSelectDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): BankAccountSelectDto {
        data = typeof data === 'object' ? data : {};
        let result = new BankAccountSelectDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }

    clone(): BankAccountSelectDto {
        const json = this.toJSON();
        let result = new BankAccountSelectDto();
        result.init(json);
        return result;
    }
}

export interface IBankAccountSelectDto {
    id: number;
    name: string | undefined;
}

export class BankAndCompanyDto implements IBankAndCompanyDto {
    company: CompanyDto;
    bank: BankDto;

    constructor(data?: IBankAndCompanyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.company = _data["company"] ? CompanyDto.fromJS(_data["company"]) : <any>undefined;
            this.bank = _data["bank"] ? BankDto.fromJS(_data["bank"]) : <any>undefined;
        }
    }

    static fromJS(data: any): BankAndCompanyDto {
        data = typeof data === 'object' ? data : {};
        let result = new BankAndCompanyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["company"] = this.company ? this.company.toJSON() : <any>undefined;
        data["bank"] = this.bank ? this.bank.toJSON() : <any>undefined;
        return data;
    }

    clone(): BankAndCompanyDto {
        const json = this.toJSON();
        let result = new BankAndCompanyDto();
        result.init(json);
        return result;
    }
}

export interface IBankAndCompanyDto {
    company: CompanyDto;
    bank: BankDto;
}

export class BankDto implements IBankDto {
    id: number;
    tenantId: number | undefined;
    name: string | undefined;
    parentId: number;

    constructor(data?: IBankDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tenantId = _data["tenantId"];
            this.name = _data["name"];
            this.parentId = _data["parentId"];
        }
    }

    static fromJS(data: any): BankDto {
        data = typeof data === 'object' ? data : {};
        let result = new BankDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tenantId"] = this.tenantId;
        data["name"] = this.name;
        data["parentId"] = this.parentId;
        return data;
    }

    clone(): BankDto {
        const json = this.toJSON();
        let result = new BankDto();
        result.init(json);
        return result;
    }
}

export interface IBankDto {
    id: number;
    tenantId: number | undefined;
    name: string | undefined;
    parentId: number;
}

export class BankDtoPagedResultDto implements IBankDtoPagedResultDto {
    items: BankDto[] | undefined;
    totalCount: number;

    constructor(data?: IBankDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(BankDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): BankDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new BankDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): BankDtoPagedResultDto {
        const json = this.toJSON();
        let result = new BankDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IBankDtoPagedResultDto {
    items: BankDto[] | undefined;
    totalCount: number;
}

export class BinDto implements IBinDto {
    id: number;
    code: number;
    companyId: number;
    bankId: number;

    constructor(data?: IBinDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.companyId = _data["companyId"];
            this.bankId = _data["bankId"];
        }
    }

    static fromJS(data: any): BinDto {
        data = typeof data === 'object' ? data : {};
        let result = new BinDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["companyId"] = this.companyId;
        data["bankId"] = this.bankId;
        return data;
    }

    clone(): BinDto {
        const json = this.toJSON();
        let result = new BinDto();
        result.init(json);
        return result;
    }
}

export interface IBinDto {
    id: number;
    code: number;
    companyId: number;
    bankId: number;
}

export class BinDtoPagedResultDto implements IBinDtoPagedResultDto {
    items: BinDto[] | undefined;
    totalCount: number;

    constructor(data?: IBinDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(BinDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): BinDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new BinDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): BinDtoPagedResultDto {
        const json = this.toJSON();
        let result = new BinDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IBinDtoPagedResultDto {
    items: BinDto[] | undefined;
    totalCount: number;
}

export class CancelPaymentOrderResultDto implements ICancelPaymentOrderResultDto {
    paymentId: string | undefined;
    success: boolean;
    wasCancelled: boolean;
    currentPaymentStatus: PaymentStatus;
    paymentData: GatewayPaymentDataDto;
    message: string | undefined;
    requiresReversal: boolean;
    wasAlreadyCancelled: boolean;
    wasAlreadyConfirmed: boolean;

    constructor(data?: ICancelPaymentOrderResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.paymentId = _data["paymentId"];
            this.success = _data["success"];
            this.wasCancelled = _data["wasCancelled"];
            this.currentPaymentStatus = _data["currentPaymentStatus"];
            this.paymentData = _data["paymentData"] ? GatewayPaymentDataDto.fromJS(_data["paymentData"]) : <any>undefined;
            this.message = _data["message"];
            this.requiresReversal = _data["requiresReversal"];
            this.wasAlreadyCancelled = _data["wasAlreadyCancelled"];
            this.wasAlreadyConfirmed = _data["wasAlreadyConfirmed"];
        }
    }

    static fromJS(data: any): CancelPaymentOrderResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new CancelPaymentOrderResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["paymentId"] = this.paymentId;
        data["success"] = this.success;
        data["wasCancelled"] = this.wasCancelled;
        data["currentPaymentStatus"] = this.currentPaymentStatus;
        data["paymentData"] = this.paymentData ? this.paymentData.toJSON() : <any>undefined;
        data["message"] = this.message;
        data["requiresReversal"] = this.requiresReversal;
        data["wasAlreadyCancelled"] = this.wasAlreadyCancelled;
        data["wasAlreadyConfirmed"] = this.wasAlreadyConfirmed;
        return data;
    }

    clone(): CancelPaymentOrderResultDto {
        const json = this.toJSON();
        let result = new CancelPaymentOrderResultDto();
        result.init(json);
        return result;
    }
}

export interface ICancelPaymentOrderResultDto {
    paymentId: string | undefined;
    success: boolean;
    wasCancelled: boolean;
    currentPaymentStatus: PaymentStatus;
    paymentData: GatewayPaymentDataDto;
    message: string | undefined;
    requiresReversal: boolean;
    wasAlreadyCancelled: boolean;
    wasAlreadyConfirmed: boolean;
}

export class CardsTransactionInfoDto implements ICardsTransactionInfoDto {
    currencyId: number;
    currencyName: string | undefined;
    currencyQuote: number;
    companyId: number;
    companyName: string | undefined;
    total: number;
    count: number;

    constructor(data?: ICardsTransactionInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.currencyId = _data["currencyId"];
            this.currencyName = _data["currencyName"];
            this.currencyQuote = _data["currencyQuote"];
            this.companyId = _data["companyId"];
            this.companyName = _data["companyName"];
            this.total = _data["total"];
            this.count = _data["count"];
        }
    }

    static fromJS(data: any): CardsTransactionInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new CardsTransactionInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currencyId"] = this.currencyId;
        data["currencyName"] = this.currencyName;
        data["currencyQuote"] = this.currencyQuote;
        data["companyId"] = this.companyId;
        data["companyName"] = this.companyName;
        data["total"] = this.total;
        data["count"] = this.count;
        return data;
    }

    clone(): CardsTransactionInfoDto {
        const json = this.toJSON();
        let result = new CardsTransactionInfoDto();
        result.init(json);
        return result;
    }
}

export interface ICardsTransactionInfoDto {
    currencyId: number;
    currencyName: string | undefined;
    currencyQuote: number;
    companyId: number;
    companyName: string | undefined;
    total: number;
    count: number;
}

export class CashFilterDto implements ICashFilterDto {
    search: string | undefined;
    dateInit: moment.Moment | undefined;
    dateEnd: moment.Moment | undefined;
    typeSalePoints: TypeSalePoint[] | undefined;
    salePointIds: number[] | undefined;

    constructor(data?: ICashFilterDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.search = _data["search"];
            this.dateInit = _data["dateInit"] ? moment(_data["dateInit"].toString()) : <any>undefined;
            this.dateEnd = _data["dateEnd"] ? moment(_data["dateEnd"].toString()) : <any>undefined;
            if (Array.isArray(_data["typeSalePoints"])) {
                this.typeSalePoints = [] as any;
                for (let item of _data["typeSalePoints"])
                    this.typeSalePoints.push(item);
            }
            if (Array.isArray(_data["salePointIds"])) {
                this.salePointIds = [] as any;
                for (let item of _data["salePointIds"])
                    this.salePointIds.push(item);
            }
        }
    }

    static fromJS(data: any): CashFilterDto {
        data = typeof data === 'object' ? data : {};
        let result = new CashFilterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["search"] = this.search;
        data["dateInit"] = this.dateInit ? this.dateInit.toISOString() : <any>undefined;
        data["dateEnd"] = this.dateEnd ? this.dateEnd.toISOString() : <any>undefined;
        if (Array.isArray(this.typeSalePoints)) {
            data["typeSalePoints"] = [];
            for (let item of this.typeSalePoints)
                data["typeSalePoints"].push(item);
        }
        if (Array.isArray(this.salePointIds)) {
            data["salePointIds"] = [];
            for (let item of this.salePointIds)
                data["salePointIds"].push(item);
        }
        return data;
    }

    clone(): CashFilterDto {
        const json = this.toJSON();
        let result = new CashFilterDto();
        result.init(json);
        return result;
    }
}

export interface ICashFilterDto {
    search: string | undefined;
    dateInit: moment.Moment | undefined;
    dateEnd: moment.Moment | undefined;
    typeSalePoints: TypeSalePoint[] | undefined;
    salePointIds: number[] | undefined;
}

export class CashMovementDto implements ICashMovementDto {
    id: number;
    amount: number;
    amountFinal: number;
    currencyName: string | undefined;
    currencyId: number;
    currencyQuote: number;
    providerPaymentId: number;
    description: string | undefined;
    creationTime: moment.Moment;
    cashierSalePointId: number;
    cashierName: string | undefined;
    cashierVendorsId: string | undefined;
    cashierExtensionData: string | undefined;
    userName: string | undefined;
    storeName: string | undefined;

    constructor(data?: ICashMovementDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.amount = _data["amount"];
            this.amountFinal = _data["amountFinal"];
            this.currencyName = _data["currencyName"];
            this.currencyId = _data["currencyId"];
            this.currencyQuote = _data["currencyQuote"];
            this.providerPaymentId = _data["providerPaymentId"];
            this.description = _data["description"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.cashierSalePointId = _data["cashierSalePointId"];
            this.cashierName = _data["cashierName"];
            this.cashierVendorsId = _data["cashierVendorsId"];
            this.cashierExtensionData = _data["cashierExtensionData"];
            this.userName = _data["userName"];
            this.storeName = _data["storeName"];
        }
    }

    static fromJS(data: any): CashMovementDto {
        data = typeof data === 'object' ? data : {};
        let result = new CashMovementDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["amount"] = this.amount;
        data["amountFinal"] = this.amountFinal;
        data["currencyName"] = this.currencyName;
        data["currencyId"] = this.currencyId;
        data["currencyQuote"] = this.currencyQuote;
        data["providerPaymentId"] = this.providerPaymentId;
        data["description"] = this.description;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["cashierSalePointId"] = this.cashierSalePointId;
        data["cashierName"] = this.cashierName;
        data["cashierVendorsId"] = this.cashierVendorsId;
        data["cashierExtensionData"] = this.cashierExtensionData;
        data["userName"] = this.userName;
        data["storeName"] = this.storeName;
        return data;
    }

    clone(): CashMovementDto {
        const json = this.toJSON();
        let result = new CashMovementDto();
        result.init(json);
        return result;
    }
}

export interface ICashMovementDto {
    id: number;
    amount: number;
    amountFinal: number;
    currencyName: string | undefined;
    currencyId: number;
    currencyQuote: number;
    providerPaymentId: number;
    description: string | undefined;
    creationTime: moment.Moment;
    cashierSalePointId: number;
    cashierName: string | undefined;
    cashierVendorsId: string | undefined;
    cashierExtensionData: string | undefined;
    userName: string | undefined;
    storeName: string | undefined;
}

export class CashMovementDtoPagedResultDto implements ICashMovementDtoPagedResultDto {
    items: CashMovementDto[] | undefined;
    totalCount: number;

    constructor(data?: ICashMovementDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(CashMovementDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): CashMovementDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new CashMovementDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): CashMovementDtoPagedResultDto {
        const json = this.toJSON();
        let result = new CashMovementDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface ICashMovementDtoPagedResultDto {
    items: CashMovementDto[] | undefined;
    totalCount: number;
}

export class CashOpenDto implements ICashOpenDto {
    state: TypeCash;
    authorizedById: number;
    code: string | undefined;
    transactions: TransactionCashOpenDto[] | undefined;

    constructor(data?: ICashOpenDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.state = _data["state"];
            this.authorizedById = _data["authorizedById"];
            this.code = _data["code"];
            if (Array.isArray(_data["transactions"])) {
                this.transactions = [] as any;
                for (let item of _data["transactions"])
                    this.transactions.push(TransactionCashOpenDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CashOpenDto {
        data = typeof data === 'object' ? data : {};
        let result = new CashOpenDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["state"] = this.state;
        data["authorizedById"] = this.authorizedById;
        data["code"] = this.code;
        if (Array.isArray(this.transactions)) {
            data["transactions"] = [];
            for (let item of this.transactions)
                data["transactions"].push(item.toJSON());
        }
        return data;
    }

    clone(): CashOpenDto {
        const json = this.toJSON();
        let result = new CashOpenDto();
        result.init(json);
        return result;
    }
}

export interface ICashOpenDto {
    state: TypeCash;
    authorizedById: number;
    code: string | undefined;
    transactions: TransactionCashOpenDto[] | undefined;
}

export class CashReportDto implements ICashReportDto {
    id: number;
    amount: number;
    amountFinal: number;
    currencyId: number;
    currencyQuote: number;
    providerPaymentId: number;
    typeOperation: TypeOperation;
    readonly typeOperationName: string | undefined;
    description: string | undefined;
    creationTime: moment.Moment;
    cashierSalePointId: number;
    cashierName: string | undefined;
    isReportProcessed: boolean;
    cashierVendorsId: string | undefined;
    cashierExtensionData: string | undefined;

    constructor(data?: ICashReportDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.amount = _data["amount"];
            this.amountFinal = _data["amountFinal"];
            this.currencyId = _data["currencyId"];
            this.currencyQuote = _data["currencyQuote"];
            this.providerPaymentId = _data["providerPaymentId"];
            this.typeOperation = _data["typeOperation"];
            (<any>this).typeOperationName = _data["typeOperationName"];
            this.description = _data["description"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.cashierSalePointId = _data["cashierSalePointId"];
            this.cashierName = _data["cashierName"];
            this.isReportProcessed = _data["isReportProcessed"];
            this.cashierVendorsId = _data["cashierVendorsId"];
            this.cashierExtensionData = _data["cashierExtensionData"];
        }
    }

    static fromJS(data: any): CashReportDto {
        data = typeof data === 'object' ? data : {};
        let result = new CashReportDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["amount"] = this.amount;
        data["amountFinal"] = this.amountFinal;
        data["currencyId"] = this.currencyId;
        data["currencyQuote"] = this.currencyQuote;
        data["providerPaymentId"] = this.providerPaymentId;
        data["typeOperation"] = this.typeOperation;
        data["typeOperationName"] = this.typeOperationName;
        data["description"] = this.description;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["cashierSalePointId"] = this.cashierSalePointId;
        data["cashierName"] = this.cashierName;
        data["isReportProcessed"] = this.isReportProcessed;
        data["cashierVendorsId"] = this.cashierVendorsId;
        data["cashierExtensionData"] = this.cashierExtensionData;
        return data;
    }

    clone(): CashReportDto {
        const json = this.toJSON();
        let result = new CashReportDto();
        result.init(json);
        return result;
    }
}

export interface ICashReportDto {
    id: number;
    amount: number;
    amountFinal: number;
    currencyId: number;
    currencyQuote: number;
    providerPaymentId: number;
    typeOperation: TypeOperation;
    typeOperationName: string | undefined;
    description: string | undefined;
    creationTime: moment.Moment;
    cashierSalePointId: number;
    cashierName: string | undefined;
    isReportProcessed: boolean;
    cashierVendorsId: string | undefined;
    cashierExtensionData: string | undefined;
}

export class CashReportFilterDto implements ICashReportFilterDto {
    from: moment.Moment | undefined;
    to: moment.Moment | undefined;
    skip: number;
    quantity: number;
    tenantId: number | undefined;
    processedReport: boolean;
    useCashInOut: boolean;

    constructor(data?: ICashReportFilterDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.from = _data["from"] ? moment(_data["from"].toString()) : <any>undefined;
            this.to = _data["to"] ? moment(_data["to"].toString()) : <any>undefined;
            this.skip = _data["skip"];
            this.quantity = _data["quantity"];
            this.tenantId = _data["tenantId"];
            this.processedReport = _data["processedReport"];
            this.useCashInOut = _data["useCashInOut"];
        }
    }

    static fromJS(data: any): CashReportFilterDto {
        data = typeof data === 'object' ? data : {};
        let result = new CashReportFilterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["from"] = this.from ? this.from.toISOString() : <any>undefined;
        data["to"] = this.to ? this.to.toISOString() : <any>undefined;
        data["skip"] = this.skip;
        data["quantity"] = this.quantity;
        data["tenantId"] = this.tenantId;
        data["processedReport"] = this.processedReport;
        data["useCashInOut"] = this.useCashInOut;
        return data;
    }

    clone(): CashReportFilterDto {
        const json = this.toJSON();
        let result = new CashReportFilterDto();
        result.init(json);
        return result;
    }
}

export interface ICashReportFilterDto {
    from: moment.Moment | undefined;
    to: moment.Moment | undefined;
    skip: number;
    quantity: number;
    tenantId: number | undefined;
    processedReport: boolean;
    useCashInOut: boolean;
}

export class CashTransactionInfoDto implements ICashTransactionInfoDto {
    currencyId: number;
    currencyName: string | undefined;
    currencyQuote: number;
    providerPaymentId: number;
    providerPaymentName: string | undefined;
    total: number;
    count: number;

    constructor(data?: ICashTransactionInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.currencyId = _data["currencyId"];
            this.currencyName = _data["currencyName"];
            this.currencyQuote = _data["currencyQuote"];
            this.providerPaymentId = _data["providerPaymentId"];
            this.providerPaymentName = _data["providerPaymentName"];
            this.total = _data["total"];
            this.count = _data["count"];
        }
    }

    static fromJS(data: any): CashTransactionInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new CashTransactionInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currencyId"] = this.currencyId;
        data["currencyName"] = this.currencyName;
        data["currencyQuote"] = this.currencyQuote;
        data["providerPaymentId"] = this.providerPaymentId;
        data["providerPaymentName"] = this.providerPaymentName;
        data["total"] = this.total;
        data["count"] = this.count;
        return data;
    }

    clone(): CashTransactionInfoDto {
        const json = this.toJSON();
        let result = new CashTransactionInfoDto();
        result.init(json);
        return result;
    }
}

export interface ICashTransactionInfoDto {
    currencyId: number;
    currencyName: string | undefined;
    currencyQuote: number;
    providerPaymentId: number;
    providerPaymentName: string | undefined;
    total: number;
    count: number;
}

export class Cashier implements ICashier {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    tenantId: number | undefined;
    name: string | undefined;
    isActive: boolean;
    state: TypeCash;
    extensionData: string | undefined;
    externalId: number | undefined;
    mercadoPagoCashierId: string | undefined;
    gatwayPaymentExtensionData: string | undefined;
    salePointId: number;
    salePoint: SalePoint;
    vendors: User[] | undefined;
    transactions: Transaction[] | undefined;
    invoices: Invoice[] | undefined;
    userActive: UserActiveModel;

    constructor(data?: ICashier) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.tenantId = _data["tenantId"];
            this.name = _data["name"];
            this.isActive = _data["isActive"];
            this.state = _data["state"];
            this.extensionData = _data["extensionData"];
            this.externalId = _data["externalId"];
            this.mercadoPagoCashierId = _data["mercadoPagoCashierId"];
            this.gatwayPaymentExtensionData = _data["gatwayPaymentExtensionData"];
            this.salePointId = _data["salePointId"];
            this.salePoint = _data["salePoint"] ? SalePoint.fromJS(_data["salePoint"]) : <any>undefined;
            if (Array.isArray(_data["vendors"])) {
                this.vendors = [] as any;
                for (let item of _data["vendors"])
                    this.vendors.push(User.fromJS(item));
            }
            if (Array.isArray(_data["transactions"])) {
                this.transactions = [] as any;
                for (let item of _data["transactions"])
                    this.transactions.push(Transaction.fromJS(item));
            }
            if (Array.isArray(_data["invoices"])) {
                this.invoices = [] as any;
                for (let item of _data["invoices"])
                    this.invoices.push(Invoice.fromJS(item));
            }
            this.userActive = _data["userActive"] ? UserActiveModel.fromJS(_data["userActive"]) : <any>undefined;
        }
    }

    static fromJS(data: any): Cashier {
        data = typeof data === 'object' ? data : {};
        let result = new Cashier();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["tenantId"] = this.tenantId;
        data["name"] = this.name;
        data["isActive"] = this.isActive;
        data["state"] = this.state;
        data["extensionData"] = this.extensionData;
        data["externalId"] = this.externalId;
        data["mercadoPagoCashierId"] = this.mercadoPagoCashierId;
        data["gatwayPaymentExtensionData"] = this.gatwayPaymentExtensionData;
        data["salePointId"] = this.salePointId;
        data["salePoint"] = this.salePoint ? this.salePoint.toJSON() : <any>undefined;
        if (Array.isArray(this.vendors)) {
            data["vendors"] = [];
            for (let item of this.vendors)
                data["vendors"].push(item.toJSON());
        }
        if (Array.isArray(this.transactions)) {
            data["transactions"] = [];
            for (let item of this.transactions)
                data["transactions"].push(item.toJSON());
        }
        if (Array.isArray(this.invoices)) {
            data["invoices"] = [];
            for (let item of this.invoices)
                data["invoices"].push(item.toJSON());
        }
        data["userActive"] = this.userActive ? this.userActive.toJSON() : <any>undefined;
        return data;
    }

    clone(): Cashier {
        const json = this.toJSON();
        let result = new Cashier();
        result.init(json);
        return result;
    }
}

export interface ICashier {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    tenantId: number | undefined;
    name: string | undefined;
    isActive: boolean;
    state: TypeCash;
    extensionData: string | undefined;
    externalId: number | undefined;
    mercadoPagoCashierId: string | undefined;
    gatwayPaymentExtensionData: string | undefined;
    salePointId: number;
    salePoint: SalePoint;
    vendors: User[] | undefined;
    transactions: Transaction[] | undefined;
    invoices: Invoice[] | undefined;
    userActive: UserActiveModel;
}

export class CashierDto implements ICashierDto {
    id: number;
    tenantId: number | undefined;
    name: string | undefined;
    isActive: boolean;
    state: TypeCash;
    salePointId: number;
    readonly stateName: string | undefined;
    salePointName: string | undefined;
    userActive: UserActiveModel;
    mercadoPagoCashierId: string | undefined;
    gatwayPaymentExtensionData: string | undefined;
    paywayTerminalId: string | undefined;

    constructor(data?: ICashierDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tenantId = _data["tenantId"];
            this.name = _data["name"];
            this.isActive = _data["isActive"];
            this.state = _data["state"];
            this.salePointId = _data["salePointId"];
            (<any>this).stateName = _data["stateName"];
            this.salePointName = _data["salePointName"];
            this.userActive = _data["userActive"] ? UserActiveModel.fromJS(_data["userActive"]) : <any>undefined;
            this.mercadoPagoCashierId = _data["mercadoPagoCashierId"];
            this.gatwayPaymentExtensionData = _data["gatwayPaymentExtensionData"];
            this.paywayTerminalId = _data["paywayTerminalId"];
        }
    }

    static fromJS(data: any): CashierDto {
        data = typeof data === 'object' ? data : {};
        let result = new CashierDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tenantId"] = this.tenantId;
        data["name"] = this.name;
        data["isActive"] = this.isActive;
        data["state"] = this.state;
        data["salePointId"] = this.salePointId;
        data["stateName"] = this.stateName;
        data["salePointName"] = this.salePointName;
        data["userActive"] = this.userActive ? this.userActive.toJSON() : <any>undefined;
        data["mercadoPagoCashierId"] = this.mercadoPagoCashierId;
        data["gatwayPaymentExtensionData"] = this.gatwayPaymentExtensionData;
        data["paywayTerminalId"] = this.paywayTerminalId;
        return data;
    }

    clone(): CashierDto {
        const json = this.toJSON();
        let result = new CashierDto();
        result.init(json);
        return result;
    }
}

export interface ICashierDto {
    id: number;
    tenantId: number | undefined;
    name: string | undefined;
    isActive: boolean;
    state: TypeCash;
    salePointId: number;
    stateName: string | undefined;
    salePointName: string | undefined;
    userActive: UserActiveModel;
    mercadoPagoCashierId: string | undefined;
    gatwayPaymentExtensionData: string | undefined;
    paywayTerminalId: string | undefined;
}

export class CashierDtoPagedResultDto implements ICashierDtoPagedResultDto {
    items: CashierDto[] | undefined;
    totalCount: number;

    constructor(data?: ICashierDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(CashierDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): CashierDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new CashierDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): CashierDtoPagedResultDto {
        const json = this.toJSON();
        let result = new CashierDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface ICashierDtoPagedResultDto {
    items: CashierDto[] | undefined;
    totalCount: number;
}

export class CashierInfoDto implements ICashierInfoDto {
    id: number;
    name: string | undefined;
    readonly total: number;
    state: TypeCash;
    userActive: UserActiveModel;
    invoices: InvoiceInfoDto[] | undefined;
    readonly stateName: string | undefined;

    constructor(data?: ICashierInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            (<any>this).total = _data["total"];
            this.state = _data["state"];
            this.userActive = _data["userActive"] ? UserActiveModel.fromJS(_data["userActive"]) : <any>undefined;
            if (Array.isArray(_data["invoices"])) {
                this.invoices = [] as any;
                for (let item of _data["invoices"])
                    this.invoices.push(InvoiceInfoDto.fromJS(item));
            }
            (<any>this).stateName = _data["stateName"];
        }
    }

    static fromJS(data: any): CashierInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new CashierInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["total"] = this.total;
        data["state"] = this.state;
        data["userActive"] = this.userActive ? this.userActive.toJSON() : <any>undefined;
        if (Array.isArray(this.invoices)) {
            data["invoices"] = [];
            for (let item of this.invoices)
                data["invoices"].push(item.toJSON());
        }
        data["stateName"] = this.stateName;
        return data;
    }

    clone(): CashierInfoDto {
        const json = this.toJSON();
        let result = new CashierInfoDto();
        result.init(json);
        return result;
    }
}

export interface ICashierInfoDto {
    id: number;
    name: string | undefined;
    total: number;
    state: TypeCash;
    userActive: UserActiveModel;
    invoices: InvoiceInfoDto[] | undefined;
    stateName: string | undefined;
}

export class CashierListDto implements ICashierListDto {
    id: number;
    name: string | undefined;
    isActive: boolean;
    state: number;
    stateName: string | undefined;
    salePointName: string | undefined;
    userFullName: string | undefined;

    constructor(data?: ICashierListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.isActive = _data["isActive"];
            this.state = _data["state"];
            this.stateName = _data["stateName"];
            this.salePointName = _data["salePointName"];
            this.userFullName = _data["userFullName"];
        }
    }

    static fromJS(data: any): CashierListDto {
        data = typeof data === 'object' ? data : {};
        let result = new CashierListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["isActive"] = this.isActive;
        data["state"] = this.state;
        data["stateName"] = this.stateName;
        data["salePointName"] = this.salePointName;
        data["userFullName"] = this.userFullName;
        return data;
    }

    clone(): CashierListDto {
        const json = this.toJSON();
        let result = new CashierListDto();
        result.init(json);
        return result;
    }
}

export interface ICashierListDto {
    id: number;
    name: string | undefined;
    isActive: boolean;
    state: number;
    stateName: string | undefined;
    salePointName: string | undefined;
    userFullName: string | undefined;
}

export class CashierListDtoPagedResultDto implements ICashierListDtoPagedResultDto {
    items: CashierListDto[] | undefined;
    totalCount: number;

    constructor(data?: ICashierListDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(CashierListDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): CashierListDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new CashierListDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): CashierListDtoPagedResultDto {
        const json = this.toJSON();
        let result = new CashierListDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface ICashierListDtoPagedResultDto {
    items: CashierListDto[] | undefined;
    totalCount: number;
}

export class CashierMpDto implements ICashierMpDto {
    id: number;
    name: string | undefined;
    salePointName: string | undefined;
    mercadoPagoCashierId: string | undefined;

    constructor(data?: ICashierMpDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.salePointName = _data["salePointName"];
            this.mercadoPagoCashierId = _data["mercadoPagoCashierId"];
        }
    }

    static fromJS(data: any): CashierMpDto {
        data = typeof data === 'object' ? data : {};
        let result = new CashierMpDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["salePointName"] = this.salePointName;
        data["mercadoPagoCashierId"] = this.mercadoPagoCashierId;
        return data;
    }

    clone(): CashierMpDto {
        const json = this.toJSON();
        let result = new CashierMpDto();
        result.init(json);
        return result;
    }
}

export interface ICashierMpDto {
    id: number;
    name: string | undefined;
    salePointName: string | undefined;
    mercadoPagoCashierId: string | undefined;
}

export class CashierMpDtoPagedResultDto implements ICashierMpDtoPagedResultDto {
    items: CashierMpDto[] | undefined;
    totalCount: number;

    constructor(data?: ICashierMpDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(CashierMpDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): CashierMpDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new CashierMpDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): CashierMpDtoPagedResultDto {
        const json = this.toJSON();
        let result = new CashierMpDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface ICashierMpDtoPagedResultDto {
    items: CashierMpDto[] | undefined;
    totalCount: number;
}

export class CashierUserDto implements ICashierUserDto {
    id: number;
    name: string | undefined;
    salePointName: string | undefined;

    constructor(data?: ICashierUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.salePointName = _data["salePointName"];
        }
    }

    static fromJS(data: any): CashierUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new CashierUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["salePointName"] = this.salePointName;
        return data;
    }

    clone(): CashierUserDto {
        const json = this.toJSON();
        let result = new CashierUserDto();
        result.init(json);
        return result;
    }
}

export interface ICashierUserDto {
    id: number;
    name: string | undefined;
    salePointName: string | undefined;
}

export class CashierUserDtoListResultDto implements ICashierUserDtoListResultDto {
    items: CashierUserDto[] | undefined;

    constructor(data?: ICashierUserDtoListResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(CashierUserDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CashierUserDtoListResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new CashierUserDtoListResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): CashierUserDtoListResultDto {
        const json = this.toJSON();
        let result = new CashierUserDtoListResultDto();
        result.init(json);
        return result;
    }
}

export interface ICashierUserDtoListResultDto {
    items: CashierUserDto[] | undefined;
}

export class ChangeClientLoyaltyCategoryDto implements IChangeClientLoyaltyCategoryDto {
    tenantId: number | undefined;
    clientIdentification: string | undefined;
    loyaltyCategoryName: string | undefined;

    constructor(data?: IChangeClientLoyaltyCategoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.clientIdentification = _data["clientIdentification"];
            this.loyaltyCategoryName = _data["loyaltyCategoryName"];
        }
    }

    static fromJS(data: any): ChangeClientLoyaltyCategoryDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeClientLoyaltyCategoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["clientIdentification"] = this.clientIdentification;
        data["loyaltyCategoryName"] = this.loyaltyCategoryName;
        return data;
    }

    clone(): ChangeClientLoyaltyCategoryDto {
        const json = this.toJSON();
        let result = new ChangeClientLoyaltyCategoryDto();
        result.init(json);
        return result;
    }
}

export interface IChangeClientLoyaltyCategoryDto {
    tenantId: number | undefined;
    clientIdentification: string | undefined;
    loyaltyCategoryName: string | undefined;
}

export class ChangePasswordDto implements IChangePasswordDto {
    currentPassword: string;
    newPassword: string;

    constructor(data?: IChangePasswordDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.currentPassword = _data["currentPassword"];
            this.newPassword = _data["newPassword"];
        }
    }

    static fromJS(data: any): ChangePasswordDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChangePasswordDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentPassword"] = this.currentPassword;
        data["newPassword"] = this.newPassword;
        return data;
    }

    clone(): ChangePasswordDto {
        const json = this.toJSON();
        let result = new ChangePasswordDto();
        result.init(json);
        return result;
    }
}

export interface IChangePasswordDto {
    currentPassword: string;
    newPassword: string;
}

export class ChangeTicketDataModel implements IChangeTicketDataModel {
    invoiceProductUsed: { [key: string]: number; } | undefined;

    constructor(data?: IChangeTicketDataModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (_data["invoiceProductUsed"]) {
                this.invoiceProductUsed = {} as any;
                for (let key in _data["invoiceProductUsed"]) {
                    if (_data["invoiceProductUsed"].hasOwnProperty(key))
                        (<any>this.invoiceProductUsed)[key] = _data["invoiceProductUsed"][key];
                }
            }
        }
    }

    static fromJS(data: any): ChangeTicketDataModel {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeTicketDataModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.invoiceProductUsed) {
            data["invoiceProductUsed"] = {};
            for (let key in this.invoiceProductUsed) {
                if (this.invoiceProductUsed.hasOwnProperty(key))
                    (<any>data["invoiceProductUsed"])[key] = (<any>this.invoiceProductUsed)[key];
            }
        }
        return data;
    }

    clone(): ChangeTicketDataModel {
        const json = this.toJSON();
        let result = new ChangeTicketDataModel();
        result.init(json);
        return result;
    }
}

export interface IChangeTicketDataModel {
    invoiceProductUsed: { [key: string]: number; } | undefined;
}

export class ChangeUiThemeInput implements IChangeUiThemeInput {
    theme: string;

    constructor(data?: IChangeUiThemeInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.theme = _data["theme"];
        }
    }

    static fromJS(data: any): ChangeUiThemeInput {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeUiThemeInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["theme"] = this.theme;
        return data;
    }

    clone(): ChangeUiThemeInput {
        const json = this.toJSON();
        let result = new ChangeUiThemeInput();
        result.init(json);
        return result;
    }
}

export interface IChangeUiThemeInput {
    theme: string;
}

export class ChangeUserLanguageDto implements IChangeUserLanguageDto {
    languageName: string;

    constructor(data?: IChangeUserLanguageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.languageName = _data["languageName"];
        }
    }

    static fromJS(data: any): ChangeUserLanguageDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeUserLanguageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["languageName"] = this.languageName;
        return data;
    }

    clone(): ChangeUserLanguageDto {
        const json = this.toJSON();
        let result = new ChangeUserLanguageDto();
        result.init(json);
        return result;
    }
}

export interface IChangeUserLanguageDto {
    languageName: string;
}

export class Client implements IClient {
    id: number;
    tenantId: number | undefined;
    isDeleted: boolean;
    name: string | undefined;
    lastName: string | undefined;
    mail: string | undefined;
    address: string | undefined;
    telephone: string | undefined;
    identification: string | undefined;
    taxNumber: string | undefined;
    isStatic: boolean;
    taxCondition: TaxConditionType;
    invoices: Invoice[] | undefined;
    isLoyalty: boolean;
    points: number;
    birthday: moment.Moment;
    externalId: number | undefined;
    useGrossIncome: boolean;
    grossIncomeAmount: number;
    loyaltyCategoryId: number | undefined;
    loyaltyCategory: LoyaltyCategory;
    relationships: Relationship[] | undefined;
    readonly fullName: string | undefined;

    constructor(data?: IClient) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tenantId = _data["tenantId"];
            this.isDeleted = _data["isDeleted"];
            this.name = _data["name"];
            this.lastName = _data["lastName"];
            this.mail = _data["mail"];
            this.address = _data["address"];
            this.telephone = _data["telephone"];
            this.identification = _data["identification"];
            this.taxNumber = _data["taxNumber"];
            this.isStatic = _data["isStatic"];
            this.taxCondition = _data["taxCondition"];
            if (Array.isArray(_data["invoices"])) {
                this.invoices = [] as any;
                for (let item of _data["invoices"])
                    this.invoices.push(Invoice.fromJS(item));
            }
            this.isLoyalty = _data["isLoyalty"];
            this.points = _data["points"];
            this.birthday = _data["birthday"] ? moment(_data["birthday"].toString()) : <any>undefined;
            this.externalId = _data["externalId"];
            this.useGrossIncome = _data["useGrossIncome"];
            this.grossIncomeAmount = _data["grossIncomeAmount"];
            this.loyaltyCategoryId = _data["loyaltyCategoryId"];
            this.loyaltyCategory = _data["loyaltyCategory"] ? LoyaltyCategory.fromJS(_data["loyaltyCategory"]) : <any>undefined;
            if (Array.isArray(_data["relationships"])) {
                this.relationships = [] as any;
                for (let item of _data["relationships"])
                    this.relationships.push(Relationship.fromJS(item));
            }
            (<any>this).fullName = _data["fullName"];
        }
    }

    static fromJS(data: any): Client {
        data = typeof data === 'object' ? data : {};
        let result = new Client();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tenantId"] = this.tenantId;
        data["isDeleted"] = this.isDeleted;
        data["name"] = this.name;
        data["lastName"] = this.lastName;
        data["mail"] = this.mail;
        data["address"] = this.address;
        data["telephone"] = this.telephone;
        data["identification"] = this.identification;
        data["taxNumber"] = this.taxNumber;
        data["isStatic"] = this.isStatic;
        data["taxCondition"] = this.taxCondition;
        if (Array.isArray(this.invoices)) {
            data["invoices"] = [];
            for (let item of this.invoices)
                data["invoices"].push(item.toJSON());
        }
        data["isLoyalty"] = this.isLoyalty;
        data["points"] = this.points;
        data["birthday"] = this.birthday ? this.birthday.toISOString() : <any>undefined;
        data["externalId"] = this.externalId;
        data["useGrossIncome"] = this.useGrossIncome;
        data["grossIncomeAmount"] = this.grossIncomeAmount;
        data["loyaltyCategoryId"] = this.loyaltyCategoryId;
        data["loyaltyCategory"] = this.loyaltyCategory ? this.loyaltyCategory.toJSON() : <any>undefined;
        if (Array.isArray(this.relationships)) {
            data["relationships"] = [];
            for (let item of this.relationships)
                data["relationships"].push(item.toJSON());
        }
        data["fullName"] = this.fullName;
        return data;
    }

    clone(): Client {
        const json = this.toJSON();
        let result = new Client();
        result.init(json);
        return result;
    }
}

export interface IClient {
    id: number;
    tenantId: number | undefined;
    isDeleted: boolean;
    name: string | undefined;
    lastName: string | undefined;
    mail: string | undefined;
    address: string | undefined;
    telephone: string | undefined;
    identification: string | undefined;
    taxNumber: string | undefined;
    isStatic: boolean;
    taxCondition: TaxConditionType;
    invoices: Invoice[] | undefined;
    isLoyalty: boolean;
    points: number;
    birthday: moment.Moment;
    externalId: number | undefined;
    useGrossIncome: boolean;
    grossIncomeAmount: number;
    loyaltyCategoryId: number | undefined;
    loyaltyCategory: LoyaltyCategory;
    relationships: Relationship[] | undefined;
    fullName: string | undefined;
}

export class ClientDto implements IClientDto {
    id: number;
    tenantId: number | undefined;
    isActive: boolean;
    name: string | undefined;
    lastName: string | undefined;
    readonly fullName: string | undefined;
    mail: string | undefined;
    address: string | undefined;
    telephone: string | undefined;
    identification: string | undefined;
    taxNumber: string | undefined;
    isStatic: boolean;
    taxCondition: TaxConditionType;
    isLoyalty: boolean;
    points: number;
    readonly taxConditionName: string | undefined;
    loyaltyCategoryId: number | undefined;
    birthday: moment.Moment;
    useGrossIncome: boolean;
    grossIncomeAmount: number;
    relationshipslist: RelationshipDto[] | undefined;

    constructor(data?: IClientDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tenantId = _data["tenantId"];
            this.isActive = _data["isActive"];
            this.name = _data["name"];
            this.lastName = _data["lastName"];
            (<any>this).fullName = _data["fullName"];
            this.mail = _data["mail"];
            this.address = _data["address"];
            this.telephone = _data["telephone"];
            this.identification = _data["identification"];
            this.taxNumber = _data["taxNumber"];
            this.isStatic = _data["isStatic"];
            this.taxCondition = _data["taxCondition"];
            this.isLoyalty = _data["isLoyalty"];
            this.points = _data["points"];
            (<any>this).taxConditionName = _data["taxConditionName"];
            this.loyaltyCategoryId = _data["loyaltyCategoryId"];
            this.birthday = _data["birthday"] ? moment(_data["birthday"].toString()) : <any>undefined;
            this.useGrossIncome = _data["useGrossIncome"];
            this.grossIncomeAmount = _data["grossIncomeAmount"];
            if (Array.isArray(_data["relationshipslist"])) {
                this.relationshipslist = [] as any;
                for (let item of _data["relationshipslist"])
                    this.relationshipslist.push(RelationshipDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ClientDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClientDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tenantId"] = this.tenantId;
        data["isActive"] = this.isActive;
        data["name"] = this.name;
        data["lastName"] = this.lastName;
        data["fullName"] = this.fullName;
        data["mail"] = this.mail;
        data["address"] = this.address;
        data["telephone"] = this.telephone;
        data["identification"] = this.identification;
        data["taxNumber"] = this.taxNumber;
        data["isStatic"] = this.isStatic;
        data["taxCondition"] = this.taxCondition;
        data["isLoyalty"] = this.isLoyalty;
        data["points"] = this.points;
        data["taxConditionName"] = this.taxConditionName;
        data["loyaltyCategoryId"] = this.loyaltyCategoryId;
        data["birthday"] = this.birthday ? this.birthday.toISOString() : <any>undefined;
        data["useGrossIncome"] = this.useGrossIncome;
        data["grossIncomeAmount"] = this.grossIncomeAmount;
        if (Array.isArray(this.relationshipslist)) {
            data["relationshipslist"] = [];
            for (let item of this.relationshipslist)
                data["relationshipslist"].push(item.toJSON());
        }
        return data;
    }

    clone(): ClientDto {
        const json = this.toJSON();
        let result = new ClientDto();
        result.init(json);
        return result;
    }
}

export interface IClientDto {
    id: number;
    tenantId: number | undefined;
    isActive: boolean;
    name: string | undefined;
    lastName: string | undefined;
    fullName: string | undefined;
    mail: string | undefined;
    address: string | undefined;
    telephone: string | undefined;
    identification: string | undefined;
    taxNumber: string | undefined;
    isStatic: boolean;
    taxCondition: TaxConditionType;
    isLoyalty: boolean;
    points: number;
    taxConditionName: string | undefined;
    loyaltyCategoryId: number | undefined;
    birthday: moment.Moment;
    useGrossIncome: boolean;
    grossIncomeAmount: number;
    relationshipslist: RelationshipDto[] | undefined;
}

export class ClientDtoPagedResultDto implements IClientDtoPagedResultDto {
    items: ClientDto[] | undefined;
    totalCount: number;

    constructor(data?: IClientDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(ClientDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): ClientDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClientDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): ClientDtoPagedResultDto {
        const json = this.toJSON();
        let result = new ClientDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IClientDtoPagedResultDto {
    items: ClientDto[] | undefined;
    totalCount: number;
}

export class ClientInvoiceDto implements IClientInvoiceDto {
    id: number;
    tenantId: number | undefined;
    name: string | undefined;
    lastName: string | undefined;
    mail: string | undefined;
    identification: string | undefined;
    taxNumber: string | undefined;
    readonly fullName: string | undefined;
    taxCondition: TaxConditionType;
    isStatic: boolean;
    useGrossIncome: boolean;
    grossIncomeAmount: number;

    constructor(data?: IClientInvoiceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tenantId = _data["tenantId"];
            this.name = _data["name"];
            this.lastName = _data["lastName"];
            this.mail = _data["mail"];
            this.identification = _data["identification"];
            this.taxNumber = _data["taxNumber"];
            (<any>this).fullName = _data["fullName"];
            this.taxCondition = _data["taxCondition"];
            this.isStatic = _data["isStatic"];
            this.useGrossIncome = _data["useGrossIncome"];
            this.grossIncomeAmount = _data["grossIncomeAmount"];
        }
    }

    static fromJS(data: any): ClientInvoiceDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClientInvoiceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tenantId"] = this.tenantId;
        data["name"] = this.name;
        data["lastName"] = this.lastName;
        data["mail"] = this.mail;
        data["identification"] = this.identification;
        data["taxNumber"] = this.taxNumber;
        data["fullName"] = this.fullName;
        data["taxCondition"] = this.taxCondition;
        data["isStatic"] = this.isStatic;
        data["useGrossIncome"] = this.useGrossIncome;
        data["grossIncomeAmount"] = this.grossIncomeAmount;
        return data;
    }

    clone(): ClientInvoiceDto {
        const json = this.toJSON();
        let result = new ClientInvoiceDto();
        result.init(json);
        return result;
    }
}

export interface IClientInvoiceDto {
    id: number;
    tenantId: number | undefined;
    name: string | undefined;
    lastName: string | undefined;
    mail: string | undefined;
    identification: string | undefined;
    taxNumber: string | undefined;
    fullName: string | undefined;
    taxCondition: TaxConditionType;
    isStatic: boolean;
    useGrossIncome: boolean;
    grossIncomeAmount: number;
}

export class ClientListDto implements IClientListDto {
    id: number;
    tenantId: number | undefined;
    name: string | undefined;
    lastName: string | undefined;
    readonly fullName: string | undefined;
    identification: string | undefined;
    taxNumber: string | undefined;
    taxCondition: TaxConditionType;
    taxConditionName: string | undefined;
    mail: string | undefined;
    address: string | undefined;
    telephone: string | undefined;
    points: number;
    isStatic: boolean;
    isLoyalty: boolean;

    constructor(data?: IClientListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tenantId = _data["tenantId"];
            this.name = _data["name"];
            this.lastName = _data["lastName"];
            (<any>this).fullName = _data["fullName"];
            this.identification = _data["identification"];
            this.taxNumber = _data["taxNumber"];
            this.taxCondition = _data["taxCondition"];
            this.taxConditionName = _data["taxConditionName"];
            this.mail = _data["mail"];
            this.address = _data["address"];
            this.telephone = _data["telephone"];
            this.points = _data["points"];
            this.isStatic = _data["isStatic"];
            this.isLoyalty = _data["isLoyalty"];
        }
    }

    static fromJS(data: any): ClientListDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClientListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tenantId"] = this.tenantId;
        data["name"] = this.name;
        data["lastName"] = this.lastName;
        data["fullName"] = this.fullName;
        data["identification"] = this.identification;
        data["taxNumber"] = this.taxNumber;
        data["taxCondition"] = this.taxCondition;
        data["taxConditionName"] = this.taxConditionName;
        data["mail"] = this.mail;
        data["address"] = this.address;
        data["telephone"] = this.telephone;
        data["points"] = this.points;
        data["isStatic"] = this.isStatic;
        data["isLoyalty"] = this.isLoyalty;
        return data;
    }

    clone(): ClientListDto {
        const json = this.toJSON();
        let result = new ClientListDto();
        result.init(json);
        return result;
    }
}

export interface IClientListDto {
    id: number;
    tenantId: number | undefined;
    name: string | undefined;
    lastName: string | undefined;
    fullName: string | undefined;
    identification: string | undefined;
    taxNumber: string | undefined;
    taxCondition: TaxConditionType;
    taxConditionName: string | undefined;
    mail: string | undefined;
    address: string | undefined;
    telephone: string | undefined;
    points: number;
    isStatic: boolean;
    isLoyalty: boolean;
}

export class ClientListDtoPagedResultDto implements IClientListDtoPagedResultDto {
    items: ClientListDto[] | undefined;
    totalCount: number;

    constructor(data?: IClientListDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(ClientListDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): ClientListDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClientListDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): ClientListDtoPagedResultDto {
        const json = this.toJSON();
        let result = new ClientListDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IClientListDtoPagedResultDto {
    items: ClientListDto[] | undefined;
    totalCount: number;
}

export class CloseArcaJumpDto implements ICloseArcaJumpDto {
    letterType: LetterType;
    salePointId: number;
    invoiceFormType: InvoiceFormType;
    number: number;

    constructor(data?: ICloseArcaJumpDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.letterType = _data["letterType"];
            this.salePointId = _data["salePointId"];
            this.invoiceFormType = _data["invoiceFormType"];
            this.number = _data["number"];
        }
    }

    static fromJS(data: any): CloseArcaJumpDto {
        data = typeof data === 'object' ? data : {};
        let result = new CloseArcaJumpDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["letterType"] = this.letterType;
        data["salePointId"] = this.salePointId;
        data["invoiceFormType"] = this.invoiceFormType;
        data["number"] = this.number;
        return data;
    }

    clone(): CloseArcaJumpDto {
        const json = this.toJSON();
        let result = new CloseArcaJumpDto();
        result.init(json);
        return result;
    }
}

export interface ICloseArcaJumpDto {
    letterType: LetterType;
    salePointId: number;
    invoiceFormType: InvoiceFormType;
    number: number;
}

export class Color implements IColor {
    id: number;
    tenantId: number | undefined;
    isDeleted: boolean;
    name: string | undefined;
    code: string | undefined;
    colorCode: string | undefined;
    variants: Variant[] | undefined;

    constructor(data?: IColor) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tenantId = _data["tenantId"];
            this.isDeleted = _data["isDeleted"];
            this.name = _data["name"];
            this.code = _data["code"];
            this.colorCode = _data["colorCode"];
            if (Array.isArray(_data["variants"])) {
                this.variants = [] as any;
                for (let item of _data["variants"])
                    this.variants.push(Variant.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Color {
        data = typeof data === 'object' ? data : {};
        let result = new Color();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tenantId"] = this.tenantId;
        data["isDeleted"] = this.isDeleted;
        data["name"] = this.name;
        data["code"] = this.code;
        data["colorCode"] = this.colorCode;
        if (Array.isArray(this.variants)) {
            data["variants"] = [];
            for (let item of this.variants)
                data["variants"].push(item.toJSON());
        }
        return data;
    }

    clone(): Color {
        const json = this.toJSON();
        let result = new Color();
        result.init(json);
        return result;
    }
}

export interface IColor {
    id: number;
    tenantId: number | undefined;
    isDeleted: boolean;
    name: string | undefined;
    code: string | undefined;
    colorCode: string | undefined;
    variants: Variant[] | undefined;
}

export class ColorDto implements IColorDto {
    id: number;
    tenantId: number | undefined;
    name: string | undefined;
    code: string | undefined;
    colorCode: string | undefined;

    constructor(data?: IColorDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tenantId = _data["tenantId"];
            this.name = _data["name"];
            this.code = _data["code"];
            this.colorCode = _data["colorCode"];
        }
    }

    static fromJS(data: any): ColorDto {
        data = typeof data === 'object' ? data : {};
        let result = new ColorDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tenantId"] = this.tenantId;
        data["name"] = this.name;
        data["code"] = this.code;
        data["colorCode"] = this.colorCode;
        return data;
    }

    clone(): ColorDto {
        const json = this.toJSON();
        let result = new ColorDto();
        result.init(json);
        return result;
    }
}

export interface IColorDto {
    id: number;
    tenantId: number | undefined;
    name: string | undefined;
    code: string | undefined;
    colorCode: string | undefined;
}

export class ColorDtoPagedResultDto implements IColorDtoPagedResultDto {
    items: ColorDto[] | undefined;
    totalCount: number;

    constructor(data?: IColorDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(ColorDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): ColorDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ColorDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): ColorDtoPagedResultDto {
        const json = this.toJSON();
        let result = new ColorDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IColorDtoPagedResultDto {
    items: ColorDto[] | undefined;
    totalCount: number;
}

export class Company implements ICompany {
    id: number;
    tenantId: number | undefined;
    isDeleted: boolean;
    name: string | undefined;
    code: string | undefined;
    description: string | undefined;
    used: number;
    parentId: number;
    externalId: number | undefined;
    notInStores: string | undefined;
    paywayPlanId: number | undefined;
    irsaCode: string | undefined;
    paywayCode: string | undefined;
    isPaywayCompany: boolean;
    isIrsaCompany: boolean;
    quotes: Quote[] | undefined;
    promotions: Promotion[] | undefined;

    constructor(data?: ICompany) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tenantId = _data["tenantId"];
            this.isDeleted = _data["isDeleted"];
            this.name = _data["name"];
            this.code = _data["code"];
            this.description = _data["description"];
            this.used = _data["used"];
            this.parentId = _data["parentId"];
            this.externalId = _data["externalId"];
            this.notInStores = _data["notInStores"];
            this.paywayPlanId = _data["paywayPlanId"];
            this.irsaCode = _data["irsaCode"];
            this.paywayCode = _data["paywayCode"];
            this.isPaywayCompany = _data["isPaywayCompany"];
            this.isIrsaCompany = _data["isIrsaCompany"];
            if (Array.isArray(_data["quotes"])) {
                this.quotes = [] as any;
                for (let item of _data["quotes"])
                    this.quotes.push(Quote.fromJS(item));
            }
            if (Array.isArray(_data["promotions"])) {
                this.promotions = [] as any;
                for (let item of _data["promotions"])
                    this.promotions.push(Promotion.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Company {
        data = typeof data === 'object' ? data : {};
        let result = new Company();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tenantId"] = this.tenantId;
        data["isDeleted"] = this.isDeleted;
        data["name"] = this.name;
        data["code"] = this.code;
        data["description"] = this.description;
        data["used"] = this.used;
        data["parentId"] = this.parentId;
        data["externalId"] = this.externalId;
        data["notInStores"] = this.notInStores;
        data["paywayPlanId"] = this.paywayPlanId;
        data["irsaCode"] = this.irsaCode;
        data["paywayCode"] = this.paywayCode;
        data["isPaywayCompany"] = this.isPaywayCompany;
        data["isIrsaCompany"] = this.isIrsaCompany;
        if (Array.isArray(this.quotes)) {
            data["quotes"] = [];
            for (let item of this.quotes)
                data["quotes"].push(item.toJSON());
        }
        if (Array.isArray(this.promotions)) {
            data["promotions"] = [];
            for (let item of this.promotions)
                data["promotions"].push(item.toJSON());
        }
        return data;
    }

    clone(): Company {
        const json = this.toJSON();
        let result = new Company();
        result.init(json);
        return result;
    }
}

export interface ICompany {
    id: number;
    tenantId: number | undefined;
    isDeleted: boolean;
    name: string | undefined;
    code: string | undefined;
    description: string | undefined;
    used: number;
    parentId: number;
    externalId: number | undefined;
    notInStores: string | undefined;
    paywayPlanId: number | undefined;
    irsaCode: string | undefined;
    paywayCode: string | undefined;
    isPaywayCompany: boolean;
    isIrsaCompany: boolean;
    quotes: Quote[] | undefined;
    promotions: Promotion[] | undefined;
}

export class CompanyDto implements ICompanyDto {
    id: number;
    tenantId: number | undefined;
    name: string | undefined;
    code: string | undefined;
    notInStores: string | undefined;
    parentId: number | undefined;
    paywayPlanId: number | undefined;
    irsaCode: string | undefined;
    paywayCode: string | undefined;
    isPaywayCompany: boolean;
    isIrsaCompany: boolean;

    constructor(data?: ICompanyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tenantId = _data["tenantId"];
            this.name = _data["name"];
            this.code = _data["code"];
            this.notInStores = _data["notInStores"];
            this.parentId = _data["parentId"];
            this.paywayPlanId = _data["paywayPlanId"];
            this.irsaCode = _data["irsaCode"];
            this.paywayCode = _data["paywayCode"];
            this.isPaywayCompany = _data["isPaywayCompany"];
            this.isIrsaCompany = _data["isIrsaCompany"];
        }
    }

    static fromJS(data: any): CompanyDto {
        data = typeof data === 'object' ? data : {};
        let result = new CompanyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tenantId"] = this.tenantId;
        data["name"] = this.name;
        data["code"] = this.code;
        data["notInStores"] = this.notInStores;
        data["parentId"] = this.parentId;
        data["paywayPlanId"] = this.paywayPlanId;
        data["irsaCode"] = this.irsaCode;
        data["paywayCode"] = this.paywayCode;
        data["isPaywayCompany"] = this.isPaywayCompany;
        data["isIrsaCompany"] = this.isIrsaCompany;
        return data;
    }

    clone(): CompanyDto {
        const json = this.toJSON();
        let result = new CompanyDto();
        result.init(json);
        return result;
    }
}

export interface ICompanyDto {
    id: number;
    tenantId: number | undefined;
    name: string | undefined;
    code: string | undefined;
    notInStores: string | undefined;
    parentId: number | undefined;
    paywayPlanId: number | undefined;
    irsaCode: string | undefined;
    paywayCode: string | undefined;
    isPaywayCompany: boolean;
    isIrsaCompany: boolean;
}

export class CompanyDtoPagedResultDto implements ICompanyDtoPagedResultDto {
    items: CompanyDto[] | undefined;
    totalCount: number;

    constructor(data?: ICompanyDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(CompanyDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): CompanyDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new CompanyDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): CompanyDtoPagedResultDto {
        const json = this.toJSON();
        let result = new CompanyDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface ICompanyDtoPagedResultDto {
    items: CompanyDto[] | undefined;
    totalCount: number;
}

export class CompanyListDto implements ICompanyListDto {
    id: number;
    name: string | undefined;
    code: string | undefined;

    constructor(data?: ICompanyListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): CompanyListDto {
        data = typeof data === 'object' ? data : {};
        let result = new CompanyListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["code"] = this.code;
        return data;
    }

    clone(): CompanyListDto {
        const json = this.toJSON();
        let result = new CompanyListDto();
        result.init(json);
        return result;
    }
}

export interface ICompanyListDto {
    id: number;
    name: string | undefined;
    code: string | undefined;
}

export class CompanyListDtoPagedResultDto implements ICompanyListDtoPagedResultDto {
    items: CompanyListDto[] | undefined;
    totalCount: number;

    constructor(data?: ICompanyListDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(CompanyListDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): CompanyListDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new CompanyListDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): CompanyListDtoPagedResultDto {
        const json = this.toJSON();
        let result = new CompanyListDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface ICompanyListDtoPagedResultDto {
    items: CompanyListDto[] | undefined;
    totalCount: number;
}

export class CompanyQuoteInfoDto implements ICompanyQuoteInfoDto {
    name: string | undefined;
    quotes: QuoteInfoDto[] | undefined;

    constructor(data?: ICompanyQuoteInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            if (Array.isArray(_data["quotes"])) {
                this.quotes = [] as any;
                for (let item of _data["quotes"])
                    this.quotes.push(QuoteInfoDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CompanyQuoteInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new CompanyQuoteInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        if (Array.isArray(this.quotes)) {
            data["quotes"] = [];
            for (let item of this.quotes)
                data["quotes"].push(item.toJSON());
        }
        return data;
    }

    clone(): CompanyQuoteInfoDto {
        const json = this.toJSON();
        let result = new CompanyQuoteInfoDto();
        result.init(json);
        return result;
    }
}

export interface ICompanyQuoteInfoDto {
    name: string | undefined;
    quotes: QuoteInfoDto[] | undefined;
}

export class CompanyQuoteModel implements ICompanyQuoteModel {
    quoteId: number;
    name: string | undefined;
    cant: number;
    surcharge: number;
    companyId: number;
    companyName: string | undefined;
    bankId: number;

    constructor(data?: ICompanyQuoteModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.quoteId = _data["quoteId"];
            this.name = _data["name"];
            this.cant = _data["cant"];
            this.surcharge = _data["surcharge"];
            this.companyId = _data["companyId"];
            this.companyName = _data["companyName"];
            this.bankId = _data["bankId"];
        }
    }

    static fromJS(data: any): CompanyQuoteModel {
        data = typeof data === 'object' ? data : {};
        let result = new CompanyQuoteModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["quoteId"] = this.quoteId;
        data["name"] = this.name;
        data["cant"] = this.cant;
        data["surcharge"] = this.surcharge;
        data["companyId"] = this.companyId;
        data["companyName"] = this.companyName;
        data["bankId"] = this.bankId;
        return data;
    }

    clone(): CompanyQuoteModel {
        const json = this.toJSON();
        let result = new CompanyQuoteModel();
        result.init(json);
        return result;
    }
}

export interface ICompanyQuoteModel {
    quoteId: number;
    name: string | undefined;
    cant: number;
    surcharge: number;
    companyId: number;
    companyName: string | undefined;
    bankId: number;
}

export class CompanySelectDto implements ICompanySelectDto {
    id: number;
    name: string | undefined;
    code: string | undefined;
    description: string | undefined;
    quotes: QuoteSelectDto[] | undefined;

    constructor(data?: ICompanySelectDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.code = _data["code"];
            this.description = _data["description"];
            if (Array.isArray(_data["quotes"])) {
                this.quotes = [] as any;
                for (let item of _data["quotes"])
                    this.quotes.push(QuoteSelectDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CompanySelectDto {
        data = typeof data === 'object' ? data : {};
        let result = new CompanySelectDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["code"] = this.code;
        data["description"] = this.description;
        if (Array.isArray(this.quotes)) {
            data["quotes"] = [];
            for (let item of this.quotes)
                data["quotes"].push(item.toJSON());
        }
        return data;
    }

    clone(): CompanySelectDto {
        const json = this.toJSON();
        let result = new CompanySelectDto();
        result.init(json);
        return result;
    }
}

export interface ICompanySelectDto {
    id: number;
    name: string | undefined;
    code: string | undefined;
    description: string | undefined;
    quotes: QuoteSelectDto[] | undefined;
}

export class ComparativeStockDto implements IComparativeStockDto {
    storeName: number;
    productName: string | undefined;
    productDescription: string | undefined;
    stockQuantity: number;
    stockValue: number;
    amountSold: number;
    totalSale: number;

    constructor(data?: IComparativeStockDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.storeName = _data["storeName"];
            this.productName = _data["productName"];
            this.productDescription = _data["productDescription"];
            this.stockQuantity = _data["stockQuantity"];
            this.stockValue = _data["stockValue"];
            this.amountSold = _data["amountSold"];
            this.totalSale = _data["totalSale"];
        }
    }

    static fromJS(data: any): ComparativeStockDto {
        data = typeof data === 'object' ? data : {};
        let result = new ComparativeStockDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["storeName"] = this.storeName;
        data["productName"] = this.productName;
        data["productDescription"] = this.productDescription;
        data["stockQuantity"] = this.stockQuantity;
        data["stockValue"] = this.stockValue;
        data["amountSold"] = this.amountSold;
        data["totalSale"] = this.totalSale;
        return data;
    }

    clone(): ComparativeStockDto {
        const json = this.toJSON();
        let result = new ComparativeStockDto();
        result.init(json);
        return result;
    }
}

export interface IComparativeStockDto {
    storeName: number;
    productName: string | undefined;
    productDescription: string | undefined;
    stockQuantity: number;
    stockValue: number;
    amountSold: number;
    totalSale: number;
}

export class ConditionDataModel implements IConditionDataModel {
    name: string | undefined;
    listKeywords: string[] | undefined;
    listPropertyValues: number[] | undefined;
    productGroupId: number;
    exclude: boolean;

    constructor(data?: IConditionDataModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            if (Array.isArray(_data["listKeywords"])) {
                this.listKeywords = [] as any;
                for (let item of _data["listKeywords"])
                    this.listKeywords.push(item);
            }
            if (Array.isArray(_data["listPropertyValues"])) {
                this.listPropertyValues = [] as any;
                for (let item of _data["listPropertyValues"])
                    this.listPropertyValues.push(item);
            }
            this.productGroupId = _data["productGroupId"];
            this.exclude = _data["exclude"];
        }
    }

    static fromJS(data: any): ConditionDataModel {
        data = typeof data === 'object' ? data : {};
        let result = new ConditionDataModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        if (Array.isArray(this.listKeywords)) {
            data["listKeywords"] = [];
            for (let item of this.listKeywords)
                data["listKeywords"].push(item);
        }
        if (Array.isArray(this.listPropertyValues)) {
            data["listPropertyValues"] = [];
            for (let item of this.listPropertyValues)
                data["listPropertyValues"].push(item);
        }
        data["productGroupId"] = this.productGroupId;
        data["exclude"] = this.exclude;
        return data;
    }

    clone(): ConditionDataModel {
        const json = this.toJSON();
        let result = new ConditionDataModel();
        result.init(json);
        return result;
    }
}

export interface IConditionDataModel {
    name: string | undefined;
    listKeywords: string[] | undefined;
    listPropertyValues: number[] | undefined;
    productGroupId: number;
    exclude: boolean;
}

export enum ContentType {
    Pdf = <any>"Pdf",
    Html = <any>"Html",
    Jpg = <any>"Jpg",
}

export class CouponTransactionInfoDto implements ICouponTransactionInfoDto {
    currencyQuote: number;
    companyId: number;
    companyName: string | undefined;
    companyQuotesCant: number;
    total: number;
    count: number;

    constructor(data?: ICouponTransactionInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.currencyQuote = _data["currencyQuote"];
            this.companyId = _data["companyId"];
            this.companyName = _data["companyName"];
            this.companyQuotesCant = _data["companyQuotesCant"];
            this.total = _data["total"];
            this.count = _data["count"];
        }
    }

    static fromJS(data: any): CouponTransactionInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new CouponTransactionInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currencyQuote"] = this.currencyQuote;
        data["companyId"] = this.companyId;
        data["companyName"] = this.companyName;
        data["companyQuotesCant"] = this.companyQuotesCant;
        data["total"] = this.total;
        data["count"] = this.count;
        return data;
    }

    clone(): CouponTransactionInfoDto {
        const json = this.toJSON();
        let result = new CouponTransactionInfoDto();
        result.init(json);
        return result;
    }
}

export interface ICouponTransactionInfoDto {
    currencyQuote: number;
    companyId: number;
    companyName: string | undefined;
    companyQuotesCant: number;
    total: number;
    count: number;
}

export class CreateCashierFromApiDto implements ICreateCashierFromApiDto {
    id: number;
    tenantId: number | undefined;
    name: string | undefined;
    salePointId: number;
    paywayTerminalId: string | undefined;

    constructor(data?: ICreateCashierFromApiDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tenantId = _data["tenantId"];
            this.name = _data["name"];
            this.salePointId = _data["salePointId"];
            this.paywayTerminalId = _data["paywayTerminalId"];
        }
    }

    static fromJS(data: any): CreateCashierFromApiDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCashierFromApiDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tenantId"] = this.tenantId;
        data["name"] = this.name;
        data["salePointId"] = this.salePointId;
        data["paywayTerminalId"] = this.paywayTerminalId;
        return data;
    }

    clone(): CreateCashierFromApiDto {
        const json = this.toJSON();
        let result = new CreateCashierFromApiDto();
        result.init(json);
        return result;
    }
}

export interface ICreateCashierFromApiDto {
    id: number;
    tenantId: number | undefined;
    name: string | undefined;
    salePointId: number;
    paywayTerminalId: string | undefined;
}

export class CreateCashierInputDto implements ICreateCashierInputDto {
    tenantId: number | undefined;
    name: string | undefined;
    salePointId: number;
    paywayTerminalId: string | undefined;

    constructor(data?: ICreateCashierInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.name = _data["name"];
            this.salePointId = _data["salePointId"];
            this.paywayTerminalId = _data["paywayTerminalId"];
        }
    }

    static fromJS(data: any): CreateCashierInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCashierInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["name"] = this.name;
        data["salePointId"] = this.salePointId;
        data["paywayTerminalId"] = this.paywayTerminalId;
        return data;
    }

    clone(): CreateCashierInputDto {
        const json = this.toJSON();
        let result = new CreateCashierInputDto();
        result.init(json);
        return result;
    }
}

export interface ICreateCashierInputDto {
    tenantId: number | undefined;
    name: string | undefined;
    salePointId: number;
    paywayTerminalId: string | undefined;
}

export class CreateOrderDto implements ICreateOrderDto {
    id: string | undefined;
    qr: string | undefined;

    constructor(data?: ICreateOrderDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.qr = _data["qr"];
        }
    }

    static fromJS(data: any): CreateOrderDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrderDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["qr"] = this.qr;
        return data;
    }

    clone(): CreateOrderDto {
        const json = this.toJSON();
        let result = new CreateOrderDto();
        result.init(json);
        return result;
    }
}

export interface ICreateOrderDto {
    id: string | undefined;
    qr: string | undefined;
}

export class CreateRoleDto implements ICreateRoleDto {
    name: string;
    displayName: string;
    normalizedName: string | undefined;
    description: string | undefined;
    grantParentalPermissions: boolean;
    grantedPermissions: string[] | undefined;

    constructor(data?: ICreateRoleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.normalizedName = _data["normalizedName"];
            this.description = _data["description"];
            this.grantParentalPermissions = _data["grantParentalPermissions"];
            if (Array.isArray(_data["grantedPermissions"])) {
                this.grantedPermissions = [] as any;
                for (let item of _data["grantedPermissions"])
                    this.grantedPermissions.push(item);
            }
        }
    }

    static fromJS(data: any): CreateRoleDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateRoleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["normalizedName"] = this.normalizedName;
        data["description"] = this.description;
        data["grantParentalPermissions"] = this.grantParentalPermissions;
        if (Array.isArray(this.grantedPermissions)) {
            data["grantedPermissions"] = [];
            for (let item of this.grantedPermissions)
                data["grantedPermissions"].push(item);
        }
        return data;
    }

    clone(): CreateRoleDto {
        const json = this.toJSON();
        let result = new CreateRoleDto();
        result.init(json);
        return result;
    }
}

export interface ICreateRoleDto {
    name: string;
    displayName: string;
    normalizedName: string | undefined;
    description: string | undefined;
    grantParentalPermissions: boolean;
    grantedPermissions: string[] | undefined;
}

export class CreateTenantDto implements ICreateTenantDto {
    tenancyName: string;
    name: string;
    adminEmailAddress: string;
    connectionString: string | undefined;
    webServiceAfip: WebServiceAfip;
    isActive: boolean;
    useNoFiscal: boolean;
    useHistoricPrice: boolean;
    editionId: number;
    parentId: number | undefined;
    allowNegativeStock: boolean;
    allowNegativeSales: boolean;
    allowNegativeReservation: boolean;
    allowNegativeChanges: boolean;
    enableThirdPartyOrderImport: boolean;
    enableThirdPartyOrderImportAdmin: boolean;
    applyPromotionOverCheapestProducts: boolean;
    usePayway: boolean;
    useMercadoLibre: boolean;
    useTiendaNube: boolean;
    paywayCashInAccountProviderPaymentId: number | undefined;
    tenantIds: number[] | undefined;

    constructor(data?: ICreateTenantDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenancyName = _data["tenancyName"];
            this.name = _data["name"];
            this.adminEmailAddress = _data["adminEmailAddress"];
            this.connectionString = _data["connectionString"];
            this.webServiceAfip = _data["webServiceAfip"];
            this.isActive = _data["isActive"];
            this.useNoFiscal = _data["useNoFiscal"];
            this.useHistoricPrice = _data["useHistoricPrice"];
            this.editionId = _data["editionId"];
            this.parentId = _data["parentId"];
            this.allowNegativeStock = _data["allowNegativeStock"];
            this.allowNegativeSales = _data["allowNegativeSales"];
            this.allowNegativeReservation = _data["allowNegativeReservation"];
            this.allowNegativeChanges = _data["allowNegativeChanges"];
            this.enableThirdPartyOrderImport = _data["enableThirdPartyOrderImport"];
            this.enableThirdPartyOrderImportAdmin = _data["enableThirdPartyOrderImportAdmin"];
            this.applyPromotionOverCheapestProducts = _data["applyPromotionOverCheapestProducts"];
            this.usePayway = _data["usePayway"];
            this.useMercadoLibre = _data["useMercadoLibre"];
            this.useTiendaNube = _data["useTiendaNube"];
            this.paywayCashInAccountProviderPaymentId = _data["paywayCashInAccountProviderPaymentId"];
            if (Array.isArray(_data["tenantIds"])) {
                this.tenantIds = [] as any;
                for (let item of _data["tenantIds"])
                    this.tenantIds.push(item);
            }
        }
    }

    static fromJS(data: any): CreateTenantDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateTenantDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        data["name"] = this.name;
        data["adminEmailAddress"] = this.adminEmailAddress;
        data["connectionString"] = this.connectionString;
        data["webServiceAfip"] = this.webServiceAfip;
        data["isActive"] = this.isActive;
        data["useNoFiscal"] = this.useNoFiscal;
        data["useHistoricPrice"] = this.useHistoricPrice;
        data["editionId"] = this.editionId;
        data["parentId"] = this.parentId;
        data["allowNegativeStock"] = this.allowNegativeStock;
        data["allowNegativeSales"] = this.allowNegativeSales;
        data["allowNegativeReservation"] = this.allowNegativeReservation;
        data["allowNegativeChanges"] = this.allowNegativeChanges;
        data["enableThirdPartyOrderImport"] = this.enableThirdPartyOrderImport;
        data["enableThirdPartyOrderImportAdmin"] = this.enableThirdPartyOrderImportAdmin;
        data["applyPromotionOverCheapestProducts"] = this.applyPromotionOverCheapestProducts;
        data["usePayway"] = this.usePayway;
        data["useMercadoLibre"] = this.useMercadoLibre;
        data["useTiendaNube"] = this.useTiendaNube;
        data["paywayCashInAccountProviderPaymentId"] = this.paywayCashInAccountProviderPaymentId;
        if (Array.isArray(this.tenantIds)) {
            data["tenantIds"] = [];
            for (let item of this.tenantIds)
                data["tenantIds"].push(item);
        }
        return data;
    }

    clone(): CreateTenantDto {
        const json = this.toJSON();
        let result = new CreateTenantDto();
        result.init(json);
        return result;
    }
}

export interface ICreateTenantDto {
    tenancyName: string;
    name: string;
    adminEmailAddress: string;
    connectionString: string | undefined;
    webServiceAfip: WebServiceAfip;
    isActive: boolean;
    useNoFiscal: boolean;
    useHistoricPrice: boolean;
    editionId: number;
    parentId: number | undefined;
    allowNegativeStock: boolean;
    allowNegativeSales: boolean;
    allowNegativeReservation: boolean;
    allowNegativeChanges: boolean;
    enableThirdPartyOrderImport: boolean;
    enableThirdPartyOrderImportAdmin: boolean;
    applyPromotionOverCheapestProducts: boolean;
    usePayway: boolean;
    useMercadoLibre: boolean;
    useTiendaNube: boolean;
    paywayCashInAccountProviderPaymentId: number | undefined;
    tenantIds: number[] | undefined;
}

export class CreateUserDto implements ICreateUserDto {
    tenantId: number | undefined;
    userName: string | undefined;
    name: string;
    surname: string;
    emailAddress: string;
    isActive: boolean;
    roleNames: string[] | undefined;
    password: string;
    salePointsIds: string | undefined;
    salePointConfigId: number | undefined;
    cashierConfigId: number | undefined;
    useNoFiscal: boolean;
    scheduleAndEnabledDays: string | undefined;
    notInStores: string | undefined;

    constructor(data?: ICreateUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.userName = _data["userName"];
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.emailAddress = _data["emailAddress"];
            this.isActive = _data["isActive"];
            if (Array.isArray(_data["roleNames"])) {
                this.roleNames = [] as any;
                for (let item of _data["roleNames"])
                    this.roleNames.push(item);
            }
            this.password = _data["password"];
            this.salePointsIds = _data["salePointsIds"];
            this.salePointConfigId = _data["salePointConfigId"];
            this.cashierConfigId = _data["cashierConfigId"];
            this.useNoFiscal = _data["useNoFiscal"];
            this.scheduleAndEnabledDays = _data["scheduleAndEnabledDays"];
            this.notInStores = _data["notInStores"];
        }
    }

    static fromJS(data: any): CreateUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["userName"] = this.userName;
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["emailAddress"] = this.emailAddress;
        data["isActive"] = this.isActive;
        if (Array.isArray(this.roleNames)) {
            data["roleNames"] = [];
            for (let item of this.roleNames)
                data["roleNames"].push(item);
        }
        data["password"] = this.password;
        data["salePointsIds"] = this.salePointsIds;
        data["salePointConfigId"] = this.salePointConfigId;
        data["cashierConfigId"] = this.cashierConfigId;
        data["useNoFiscal"] = this.useNoFiscal;
        data["scheduleAndEnabledDays"] = this.scheduleAndEnabledDays;
        data["notInStores"] = this.notInStores;
        return data;
    }

    clone(): CreateUserDto {
        const json = this.toJSON();
        let result = new CreateUserDto();
        result.init(json);
        return result;
    }
}

export interface ICreateUserDto {
    tenantId: number | undefined;
    userName: string | undefined;
    name: string;
    surname: string;
    emailAddress: string;
    isActive: boolean;
    roleNames: string[] | undefined;
    password: string;
    salePointsIds: string | undefined;
    salePointConfigId: number | undefined;
    cashierConfigId: number | undefined;
    useNoFiscal: boolean;
    scheduleAndEnabledDays: string | undefined;
    notInStores: string | undefined;
}

export class Currency implements ICurrency {
    id: number;
    tenantId: number | undefined;
    isDeleted: boolean;
    name: string | undefined;
    description: string | undefined;
    quote: number;
    providerPayments: ProviderPayment[] | undefined;
    invoices: Invoice[] | undefined;
    transactions: Transaction[] | undefined;
    productPrices: ProductPrice[] | undefined;

    constructor(data?: ICurrency) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tenantId = _data["tenantId"];
            this.isDeleted = _data["isDeleted"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.quote = _data["quote"];
            if (Array.isArray(_data["providerPayments"])) {
                this.providerPayments = [] as any;
                for (let item of _data["providerPayments"])
                    this.providerPayments.push(ProviderPayment.fromJS(item));
            }
            if (Array.isArray(_data["invoices"])) {
                this.invoices = [] as any;
                for (let item of _data["invoices"])
                    this.invoices.push(Invoice.fromJS(item));
            }
            if (Array.isArray(_data["transactions"])) {
                this.transactions = [] as any;
                for (let item of _data["transactions"])
                    this.transactions.push(Transaction.fromJS(item));
            }
            if (Array.isArray(_data["productPrices"])) {
                this.productPrices = [] as any;
                for (let item of _data["productPrices"])
                    this.productPrices.push(ProductPrice.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Currency {
        data = typeof data === 'object' ? data : {};
        let result = new Currency();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tenantId"] = this.tenantId;
        data["isDeleted"] = this.isDeleted;
        data["name"] = this.name;
        data["description"] = this.description;
        data["quote"] = this.quote;
        if (Array.isArray(this.providerPayments)) {
            data["providerPayments"] = [];
            for (let item of this.providerPayments)
                data["providerPayments"].push(item.toJSON());
        }
        if (Array.isArray(this.invoices)) {
            data["invoices"] = [];
            for (let item of this.invoices)
                data["invoices"].push(item.toJSON());
        }
        if (Array.isArray(this.transactions)) {
            data["transactions"] = [];
            for (let item of this.transactions)
                data["transactions"].push(item.toJSON());
        }
        if (Array.isArray(this.productPrices)) {
            data["productPrices"] = [];
            for (let item of this.productPrices)
                data["productPrices"].push(item.toJSON());
        }
        return data;
    }

    clone(): Currency {
        const json = this.toJSON();
        let result = new Currency();
        result.init(json);
        return result;
    }
}

export interface ICurrency {
    id: number;
    tenantId: number | undefined;
    isDeleted: boolean;
    name: string | undefined;
    description: string | undefined;
    quote: number;
    providerPayments: ProviderPayment[] | undefined;
    invoices: Invoice[] | undefined;
    transactions: Transaction[] | undefined;
    productPrices: ProductPrice[] | undefined;
}

export class CurrencyDto implements ICurrencyDto {
    id: number;
    tenantId: number | undefined;
    name: string | undefined;
    description: string | undefined;
    quote: number;

    constructor(data?: ICurrencyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tenantId = _data["tenantId"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.quote = _data["quote"];
        }
    }

    static fromJS(data: any): CurrencyDto {
        data = typeof data === 'object' ? data : {};
        let result = new CurrencyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tenantId"] = this.tenantId;
        data["name"] = this.name;
        data["description"] = this.description;
        data["quote"] = this.quote;
        return data;
    }

    clone(): CurrencyDto {
        const json = this.toJSON();
        let result = new CurrencyDto();
        result.init(json);
        return result;
    }
}

export interface ICurrencyDto {
    id: number;
    tenantId: number | undefined;
    name: string | undefined;
    description: string | undefined;
    quote: number;
}

export class CurrencyDtoPagedResultDto implements ICurrencyDtoPagedResultDto {
    items: CurrencyDto[] | undefined;
    totalCount: number;

    constructor(data?: ICurrencyDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(CurrencyDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): CurrencyDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new CurrencyDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): CurrencyDtoPagedResultDto {
        const json = this.toJSON();
        let result = new CurrencyDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface ICurrencyDtoPagedResultDto {
    items: CurrencyDto[] | undefined;
    totalCount: number;
}

export class CurrencySelectDto implements ICurrencySelectDto {
    id: number;
    tenantId: number | undefined;
    name: string | undefined;
    quote: number;

    constructor(data?: ICurrencySelectDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tenantId = _data["tenantId"];
            this.name = _data["name"];
            this.quote = _data["quote"];
        }
    }

    static fromJS(data: any): CurrencySelectDto {
        data = typeof data === 'object' ? data : {};
        let result = new CurrencySelectDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tenantId"] = this.tenantId;
        data["name"] = this.name;
        data["quote"] = this.quote;
        return data;
    }

    clone(): CurrencySelectDto {
        const json = this.toJSON();
        let result = new CurrencySelectDto();
        result.init(json);
        return result;
    }
}

export interface ICurrencySelectDto {
    id: number;
    tenantId: number | undefined;
    name: string | undefined;
    quote: number;
}

export class DeliveryNoteDataModel implements IDeliveryNoteDataModel {
    transitCentralDeliveryNoteId: number | undefined;
    releasedDeliveryNote: boolean;

    constructor(data?: IDeliveryNoteDataModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.transitCentralDeliveryNoteId = _data["transitCentralDeliveryNoteId"];
            this.releasedDeliveryNote = _data["releasedDeliveryNote"];
        }
    }

    static fromJS(data: any): DeliveryNoteDataModel {
        data = typeof data === 'object' ? data : {};
        let result = new DeliveryNoteDataModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["transitCentralDeliveryNoteId"] = this.transitCentralDeliveryNoteId;
        data["releasedDeliveryNote"] = this.releasedDeliveryNote;
        return data;
    }

    clone(): DeliveryNoteDataModel {
        const json = this.toJSON();
        let result = new DeliveryNoteDataModel();
        result.init(json);
        return result;
    }
}

export interface IDeliveryNoteDataModel {
    transitCentralDeliveryNoteId: number | undefined;
    releasedDeliveryNote: boolean;
}

export class DeliveryNoteDto implements IDeliveryNoteDto {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    tenantId: number | undefined;
    number: string | undefined;
    userId: number;
    clientId: number | undefined;
    clientFullName: string | undefined;
    description: string | undefined;
    warehouseFromId: number | undefined;
    warehouseToId: number;
    salePointId: number;
    salePointPrefix: string | undefined;
    storeExternalId: number | undefined;
    transitCentralDeliveryNoteId: number | undefined;
    hasDiferenceTransitStock: boolean;
    listProducts: InvoiceProductDto[] | undefined;
    transitListProducts: TransitDeliveryNoteDetailsDto[] | undefined;

    constructor(data?: IDeliveryNoteDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.tenantId = _data["tenantId"];
            this.number = _data["number"];
            this.userId = _data["userId"];
            this.clientId = _data["clientId"];
            this.clientFullName = _data["clientFullName"];
            this.description = _data["description"];
            this.warehouseFromId = _data["warehouseFromId"];
            this.warehouseToId = _data["warehouseToId"];
            this.salePointId = _data["salePointId"];
            this.salePointPrefix = _data["salePointPrefix"];
            this.storeExternalId = _data["storeExternalId"];
            this.transitCentralDeliveryNoteId = _data["transitCentralDeliveryNoteId"];
            this.hasDiferenceTransitStock = _data["hasDiferenceTransitStock"];
            if (Array.isArray(_data["listProducts"])) {
                this.listProducts = [] as any;
                for (let item of _data["listProducts"])
                    this.listProducts.push(InvoiceProductDto.fromJS(item));
            }
            if (Array.isArray(_data["transitListProducts"])) {
                this.transitListProducts = [] as any;
                for (let item of _data["transitListProducts"])
                    this.transitListProducts.push(TransitDeliveryNoteDetailsDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DeliveryNoteDto {
        data = typeof data === 'object' ? data : {};
        let result = new DeliveryNoteDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["tenantId"] = this.tenantId;
        data["number"] = this.number;
        data["userId"] = this.userId;
        data["clientId"] = this.clientId;
        data["clientFullName"] = this.clientFullName;
        data["description"] = this.description;
        data["warehouseFromId"] = this.warehouseFromId;
        data["warehouseToId"] = this.warehouseToId;
        data["salePointId"] = this.salePointId;
        data["salePointPrefix"] = this.salePointPrefix;
        data["storeExternalId"] = this.storeExternalId;
        data["transitCentralDeliveryNoteId"] = this.transitCentralDeliveryNoteId;
        data["hasDiferenceTransitStock"] = this.hasDiferenceTransitStock;
        if (Array.isArray(this.listProducts)) {
            data["listProducts"] = [];
            for (let item of this.listProducts)
                data["listProducts"].push(item.toJSON());
        }
        if (Array.isArray(this.transitListProducts)) {
            data["transitListProducts"] = [];
            for (let item of this.transitListProducts)
                data["transitListProducts"].push(item.toJSON());
        }
        return data;
    }

    clone(): DeliveryNoteDto {
        const json = this.toJSON();
        let result = new DeliveryNoteDto();
        result.init(json);
        return result;
    }
}

export interface IDeliveryNoteDto {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    tenantId: number | undefined;
    number: string | undefined;
    userId: number;
    clientId: number | undefined;
    clientFullName: string | undefined;
    description: string | undefined;
    warehouseFromId: number | undefined;
    warehouseToId: number;
    salePointId: number;
    salePointPrefix: string | undefined;
    storeExternalId: number | undefined;
    transitCentralDeliveryNoteId: number | undefined;
    hasDiferenceTransitStock: boolean;
    listProducts: InvoiceProductDto[] | undefined;
    transitListProducts: TransitDeliveryNoteDetailsDto[] | undefined;
}

export class Discount implements IDiscount {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    tenantId: number | undefined;
    name: string | undefined;
    percent: number;
    dateInit: moment.Moment;
    dateEnd: moment.Moment | undefined;
    description: string | undefined;
    discountInvoices: DiscountInvoice[] | undefined;

    constructor(data?: IDiscount) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.tenantId = _data["tenantId"];
            this.name = _data["name"];
            this.percent = _data["percent"];
            this.dateInit = _data["dateInit"] ? moment(_data["dateInit"].toString()) : <any>undefined;
            this.dateEnd = _data["dateEnd"] ? moment(_data["dateEnd"].toString()) : <any>undefined;
            this.description = _data["description"];
            if (Array.isArray(_data["discountInvoices"])) {
                this.discountInvoices = [] as any;
                for (let item of _data["discountInvoices"])
                    this.discountInvoices.push(DiscountInvoice.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Discount {
        data = typeof data === 'object' ? data : {};
        let result = new Discount();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["tenantId"] = this.tenantId;
        data["name"] = this.name;
        data["percent"] = this.percent;
        data["dateInit"] = this.dateInit ? this.dateInit.toISOString() : <any>undefined;
        data["dateEnd"] = this.dateEnd ? this.dateEnd.toISOString() : <any>undefined;
        data["description"] = this.description;
        if (Array.isArray(this.discountInvoices)) {
            data["discountInvoices"] = [];
            for (let item of this.discountInvoices)
                data["discountInvoices"].push(item.toJSON());
        }
        return data;
    }

    clone(): Discount {
        const json = this.toJSON();
        let result = new Discount();
        result.init(json);
        return result;
    }
}

export interface IDiscount {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    tenantId: number | undefined;
    name: string | undefined;
    percent: number;
    dateInit: moment.Moment;
    dateEnd: moment.Moment | undefined;
    description: string | undefined;
    discountInvoices: DiscountInvoice[] | undefined;
}

export class DiscountDto implements IDiscountDto {
    id: number;
    tenantId: number | undefined;
    name: string | undefined;
    percent: number;
    dateInit: moment.Moment;
    dateEnd: moment.Moment | undefined;
    description: string | undefined;

    constructor(data?: IDiscountDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tenantId = _data["tenantId"];
            this.name = _data["name"];
            this.percent = _data["percent"];
            this.dateInit = _data["dateInit"] ? moment(_data["dateInit"].toString()) : <any>undefined;
            this.dateEnd = _data["dateEnd"] ? moment(_data["dateEnd"].toString()) : <any>undefined;
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): DiscountDto {
        data = typeof data === 'object' ? data : {};
        let result = new DiscountDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tenantId"] = this.tenantId;
        data["name"] = this.name;
        data["percent"] = this.percent;
        data["dateInit"] = this.dateInit ? this.dateInit.toISOString() : <any>undefined;
        data["dateEnd"] = this.dateEnd ? this.dateEnd.toISOString() : <any>undefined;
        data["description"] = this.description;
        return data;
    }

    clone(): DiscountDto {
        const json = this.toJSON();
        let result = new DiscountDto();
        result.init(json);
        return result;
    }
}

export interface IDiscountDto {
    id: number;
    tenantId: number | undefined;
    name: string | undefined;
    percent: number;
    dateInit: moment.Moment;
    dateEnd: moment.Moment | undefined;
    description: string | undefined;
}

export class DiscountDtoPagedResultDto implements IDiscountDtoPagedResultDto {
    items: DiscountDto[] | undefined;
    totalCount: number;

    constructor(data?: IDiscountDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(DiscountDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): DiscountDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new DiscountDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): DiscountDtoPagedResultDto {
        const json = this.toJSON();
        let result = new DiscountDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IDiscountDtoPagedResultDto {
    items: DiscountDto[] | undefined;
    totalCount: number;
}

export class DiscountInvoice implements IDiscountInvoice {
    id: number;
    tenantId: number | undefined;
    isDeleted: boolean;
    discountId: number;
    discount: Discount;
    invoiceId: number;
    invoice: Invoice;
    invoiceProductId: number | undefined;
    invoiceProduct: InvoiceProduct;

    constructor(data?: IDiscountInvoice) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tenantId = _data["tenantId"];
            this.isDeleted = _data["isDeleted"];
            this.discountId = _data["discountId"];
            this.discount = _data["discount"] ? Discount.fromJS(_data["discount"]) : <any>undefined;
            this.invoiceId = _data["invoiceId"];
            this.invoice = _data["invoice"] ? Invoice.fromJS(_data["invoice"]) : <any>undefined;
            this.invoiceProductId = _data["invoiceProductId"];
            this.invoiceProduct = _data["invoiceProduct"] ? InvoiceProduct.fromJS(_data["invoiceProduct"]) : <any>undefined;
        }
    }

    static fromJS(data: any): DiscountInvoice {
        data = typeof data === 'object' ? data : {};
        let result = new DiscountInvoice();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tenantId"] = this.tenantId;
        data["isDeleted"] = this.isDeleted;
        data["discountId"] = this.discountId;
        data["discount"] = this.discount ? this.discount.toJSON() : <any>undefined;
        data["invoiceId"] = this.invoiceId;
        data["invoice"] = this.invoice ? this.invoice.toJSON() : <any>undefined;
        data["invoiceProductId"] = this.invoiceProductId;
        data["invoiceProduct"] = this.invoiceProduct ? this.invoiceProduct.toJSON() : <any>undefined;
        return data;
    }

    clone(): DiscountInvoice {
        const json = this.toJSON();
        let result = new DiscountInvoice();
        result.init(json);
        return result;
    }
}

export interface IDiscountInvoice {
    id: number;
    tenantId: number | undefined;
    isDeleted: boolean;
    discountId: number;
    discount: Discount;
    invoiceId: number;
    invoice: Invoice;
    invoiceProductId: number | undefined;
    invoiceProduct: InvoiceProduct;
}

export enum EcommercePlatform {
    TiendaNube = <any>"TiendaNube",
    MercadoLibre = <any>"MercadoLibre",
}

export class EcommercePromotion implements IEcommercePromotion {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    tenantId: number | undefined;
    externalPromotionId: string | undefined;
    externalPromotionType: string | undefined;
    priceListId: number | undefined;
    priceList: PriceList;

    constructor(data?: IEcommercePromotion) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.tenantId = _data["tenantId"];
            this.externalPromotionId = _data["externalPromotionId"];
            this.externalPromotionType = _data["externalPromotionType"];
            this.priceListId = _data["priceListId"];
            this.priceList = _data["priceList"] ? PriceList.fromJS(_data["priceList"]) : <any>undefined;
        }
    }

    static fromJS(data: any): EcommercePromotion {
        data = typeof data === 'object' ? data : {};
        let result = new EcommercePromotion();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["tenantId"] = this.tenantId;
        data["externalPromotionId"] = this.externalPromotionId;
        data["externalPromotionType"] = this.externalPromotionType;
        data["priceListId"] = this.priceListId;
        data["priceList"] = this.priceList ? this.priceList.toJSON() : <any>undefined;
        return data;
    }

    clone(): EcommercePromotion {
        const json = this.toJSON();
        let result = new EcommercePromotion();
        result.init(json);
        return result;
    }
}

export interface IEcommercePromotion {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    tenantId: number | undefined;
    externalPromotionId: string | undefined;
    externalPromotionType: string | undefined;
    priceListId: number | undefined;
    priceList: PriceList;
}

export class EditionDto implements IEditionDto {
    id: number;
    name: string | undefined;

    constructor(data?: IEditionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): EditionDto {
        data = typeof data === 'object' ? data : {};
        let result = new EditionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }

    clone(): EditionDto {
        const json = this.toJSON();
        let result = new EditionDto();
        result.init(json);
        return result;
    }
}

export interface IEditionDto {
    id: number;
    name: string | undefined;
}

export class EditionFeatureDto implements IEditionFeatureDto {
    id: number;
    name: string | undefined;
    value: string | undefined;

    constructor(data?: IEditionFeatureDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): EditionFeatureDto {
        data = typeof data === 'object' ? data : {};
        let result = new EditionFeatureDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["value"] = this.value;
        return data;
    }

    clone(): EditionFeatureDto {
        const json = this.toJSON();
        let result = new EditionFeatureDto();
        result.init(json);
        return result;
    }
}

export interface IEditionFeatureDto {
    id: number;
    name: string | undefined;
    value: string | undefined;
}

export class EnumDto implements IEnumDto {
    id: number;
    value: string | undefined;

    constructor(data?: IEnumDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): EnumDto {
        data = typeof data === 'object' ? data : {};
        let result = new EnumDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["value"] = this.value;
        return data;
    }

    clone(): EnumDto {
        const json = this.toJSON();
        let result = new EnumDto();
        result.init(json);
        return result;
    }
}

export interface IEnumDto {
    id: number;
    value: string | undefined;
}

export class ExternalAuthenticateModel implements IExternalAuthenticateModel {
    authProvider: string;
    providerKey: string;
    providerAccessCode: string;

    constructor(data?: IExternalAuthenticateModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.authProvider = _data["authProvider"];
            this.providerKey = _data["providerKey"];
            this.providerAccessCode = _data["providerAccessCode"];
        }
    }

    static fromJS(data: any): ExternalAuthenticateModel {
        data = typeof data === 'object' ? data : {};
        let result = new ExternalAuthenticateModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["authProvider"] = this.authProvider;
        data["providerKey"] = this.providerKey;
        data["providerAccessCode"] = this.providerAccessCode;
        return data;
    }

    clone(): ExternalAuthenticateModel {
        const json = this.toJSON();
        let result = new ExternalAuthenticateModel();
        result.init(json);
        return result;
    }
}

export interface IExternalAuthenticateModel {
    authProvider: string;
    providerKey: string;
    providerAccessCode: string;
}

export class ExternalAuthenticateResultModel implements IExternalAuthenticateResultModel {
    accessToken: string | undefined;
    encryptedAccessToken: string | undefined;
    expireInSeconds: number;
    waitingForActivation: boolean;

    constructor(data?: IExternalAuthenticateResultModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accessToken = _data["accessToken"];
            this.encryptedAccessToken = _data["encryptedAccessToken"];
            this.expireInSeconds = _data["expireInSeconds"];
            this.waitingForActivation = _data["waitingForActivation"];
        }
    }

    static fromJS(data: any): ExternalAuthenticateResultModel {
        data = typeof data === 'object' ? data : {};
        let result = new ExternalAuthenticateResultModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accessToken"] = this.accessToken;
        data["encryptedAccessToken"] = this.encryptedAccessToken;
        data["expireInSeconds"] = this.expireInSeconds;
        data["waitingForActivation"] = this.waitingForActivation;
        return data;
    }

    clone(): ExternalAuthenticateResultModel {
        const json = this.toJSON();
        let result = new ExternalAuthenticateResultModel();
        result.init(json);
        return result;
    }
}

export interface IExternalAuthenticateResultModel {
    accessToken: string | undefined;
    encryptedAccessToken: string | undefined;
    expireInSeconds: number;
    waitingForActivation: boolean;
}

export class ExternalLoginProviderInfoModel implements IExternalLoginProviderInfoModel {
    name: string | undefined;
    clientId: string | undefined;

    constructor(data?: IExternalLoginProviderInfoModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.clientId = _data["clientId"];
        }
    }

    static fromJS(data: any): ExternalLoginProviderInfoModel {
        data = typeof data === 'object' ? data : {};
        let result = new ExternalLoginProviderInfoModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["clientId"] = this.clientId;
        return data;
    }

    clone(): ExternalLoginProviderInfoModel {
        const json = this.toJSON();
        let result = new ExternalLoginProviderInfoModel();
        result.init(json);
        return result;
    }
}

export interface IExternalLoginProviderInfoModel {
    name: string | undefined;
    clientId: string | undefined;
}

export class Feature implements IFeature {
    id: number;
    tenantId: number | undefined;
    isDeleted: boolean;
    name: string | undefined;
    isActive: boolean;
    type: FeatureType;
    productFeatures: ProductFeature[] | undefined;

    constructor(data?: IFeature) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tenantId = _data["tenantId"];
            this.isDeleted = _data["isDeleted"];
            this.name = _data["name"];
            this.isActive = _data["isActive"];
            this.type = _data["type"];
            if (Array.isArray(_data["productFeatures"])) {
                this.productFeatures = [] as any;
                for (let item of _data["productFeatures"])
                    this.productFeatures.push(ProductFeature.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Feature {
        data = typeof data === 'object' ? data : {};
        let result = new Feature();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tenantId"] = this.tenantId;
        data["isDeleted"] = this.isDeleted;
        data["name"] = this.name;
        data["isActive"] = this.isActive;
        data["type"] = this.type;
        if (Array.isArray(this.productFeatures)) {
            data["productFeatures"] = [];
            for (let item of this.productFeatures)
                data["productFeatures"].push(item.toJSON());
        }
        return data;
    }

    clone(): Feature {
        const json = this.toJSON();
        let result = new Feature();
        result.init(json);
        return result;
    }
}

export interface IFeature {
    id: number;
    tenantId: number | undefined;
    isDeleted: boolean;
    name: string | undefined;
    isActive: boolean;
    type: FeatureType;
    productFeatures: ProductFeature[] | undefined;
}

export class FeatureDto implements IFeatureDto {
    id: number;
    tenantId: number | undefined;
    name: string | undefined;
    isActive: boolean;
    type: FeatureType;
    typeName: string | undefined;

    constructor(data?: IFeatureDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tenantId = _data["tenantId"];
            this.name = _data["name"];
            this.isActive = _data["isActive"];
            this.type = _data["type"];
            this.typeName = _data["typeName"];
        }
    }

    static fromJS(data: any): FeatureDto {
        data = typeof data === 'object' ? data : {};
        let result = new FeatureDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tenantId"] = this.tenantId;
        data["name"] = this.name;
        data["isActive"] = this.isActive;
        data["type"] = this.type;
        data["typeName"] = this.typeName;
        return data;
    }

    clone(): FeatureDto {
        const json = this.toJSON();
        let result = new FeatureDto();
        result.init(json);
        return result;
    }
}

export interface IFeatureDto {
    id: number;
    tenantId: number | undefined;
    name: string | undefined;
    isActive: boolean;
    type: FeatureType;
    typeName: string | undefined;
}

export class FeatureDtoPagedResultDto implements IFeatureDtoPagedResultDto {
    items: FeatureDto[] | undefined;
    totalCount: number;

    constructor(data?: IFeatureDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(FeatureDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): FeatureDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new FeatureDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): FeatureDtoPagedResultDto {
        const json = this.toJSON();
        let result = new FeatureDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IFeatureDtoPagedResultDto {
    items: FeatureDto[] | undefined;
    totalCount: number;
}

export enum FeatureType {
    Text = <any>"Text",
    Number = <any>"Number",
    Check = <any>"Check",
    List = <any>"List",
}

export class FileAttachInfoDto implements IFileAttachInfoDto {
    fileName: string | undefined;
    path: string | undefined;

    constructor(data?: IFileAttachInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileName = _data["fileName"];
            this.path = _data["path"];
        }
    }

    static fromJS(data: any): FileAttachInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new FileAttachInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileName"] = this.fileName;
        data["path"] = this.path;
        return data;
    }

    clone(): FileAttachInfoDto {
        const json = this.toJSON();
        let result = new FileAttachInfoDto();
        result.init(json);
        return result;
    }
}

export interface IFileAttachInfoDto {
    fileName: string | undefined;
    path: string | undefined;
}

export class FileAttachment implements IFileAttachment {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    tenantId: number | undefined;
    fileName: string | undefined;
    fullPath: string | undefined;
    description: string | undefined;
    markedForDeletion: boolean;
    size: number;
    readonly fileNameReal: string | undefined;

    constructor(data?: IFileAttachment) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.tenantId = _data["tenantId"];
            this.fileName = _data["fileName"];
            this.fullPath = _data["fullPath"];
            this.description = _data["description"];
            this.markedForDeletion = _data["markedForDeletion"];
            this.size = _data["size"];
            (<any>this).fileNameReal = _data["fileNameReal"];
        }
    }

    static fromJS(data: any): FileAttachment {
        data = typeof data === 'object' ? data : {};
        let result = new FileAttachment();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["tenantId"] = this.tenantId;
        data["fileName"] = this.fileName;
        data["fullPath"] = this.fullPath;
        data["description"] = this.description;
        data["markedForDeletion"] = this.markedForDeletion;
        data["size"] = this.size;
        data["fileNameReal"] = this.fileNameReal;
        return data;
    }

    clone(): FileAttachment {
        const json = this.toJSON();
        let result = new FileAttachment();
        result.init(json);
        return result;
    }
}

export interface IFileAttachment {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    tenantId: number | undefined;
    fileName: string | undefined;
    fullPath: string | undefined;
    description: string | undefined;
    markedForDeletion: boolean;
    size: number;
    fileNameReal: string | undefined;
}

export class FileExcelDto implements IFileExcelDto {
    fileName: string | undefined;
    fileData: string | undefined;

    constructor(data?: IFileExcelDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileName = _data["fileName"];
            this.fileData = _data["fileData"];
        }
    }

    static fromJS(data: any): FileExcelDto {
        data = typeof data === 'object' ? data : {};
        let result = new FileExcelDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileName"] = this.fileName;
        data["fileData"] = this.fileData;
        return data;
    }

    clone(): FileExcelDto {
        const json = this.toJSON();
        let result = new FileExcelDto();
        result.init(json);
        return result;
    }
}

export interface IFileExcelDto {
    fileName: string | undefined;
    fileData: string | undefined;
}

export class GatewayPayInfoDto implements IGatewayPayInfoDto {
    clientId: string | undefined;
    redirectUri: string | undefined;
    accessTokenCreated: moment.Moment;
    accessTokenIsExpired: boolean;
    cashiers: CashierMpDtoPagedResultDto;

    constructor(data?: IGatewayPayInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clientId = _data["clientId"];
            this.redirectUri = _data["redirectUri"];
            this.accessTokenCreated = _data["accessTokenCreated"] ? moment(_data["accessTokenCreated"].toString()) : <any>undefined;
            this.accessTokenIsExpired = _data["accessTokenIsExpired"];
            this.cashiers = _data["cashiers"] ? CashierMpDtoPagedResultDto.fromJS(_data["cashiers"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GatewayPayInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new GatewayPayInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clientId"] = this.clientId;
        data["redirectUri"] = this.redirectUri;
        data["accessTokenCreated"] = this.accessTokenCreated ? this.accessTokenCreated.toISOString() : <any>undefined;
        data["accessTokenIsExpired"] = this.accessTokenIsExpired;
        data["cashiers"] = this.cashiers ? this.cashiers.toJSON() : <any>undefined;
        return data;
    }

    clone(): GatewayPayInfoDto {
        const json = this.toJSON();
        let result = new GatewayPayInfoDto();
        result.init(json);
        return result;
    }
}

export interface IGatewayPayInfoDto {
    clientId: string | undefined;
    redirectUri: string | undefined;
    accessTokenCreated: moment.Moment;
    accessTokenIsExpired: boolean;
    cashiers: CashierMpDtoPagedResultDto;
}

export class GatewayPaymentDataDto implements IGatewayPaymentDataDto {
    paymentId: string | undefined;
    paymentRequestDate: moment.Moment;
    paymentStatus: PaymentStatus;
    paymentStatusDate: moment.Moment;
    bin: string | undefined;
    authorizationCode: string | undefined;
    transactionReceipt: number;
    lastFourDigits: string | undefined;
    batchNumber: number;
    cardBrandProduct: string | undefined;

    constructor(data?: IGatewayPaymentDataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.paymentId = _data["paymentId"];
            this.paymentRequestDate = _data["paymentRequestDate"] ? moment(_data["paymentRequestDate"].toString()) : <any>undefined;
            this.paymentStatus = _data["paymentStatus"];
            this.paymentStatusDate = _data["paymentStatusDate"] ? moment(_data["paymentStatusDate"].toString()) : <any>undefined;
            this.bin = _data["bin"];
            this.authorizationCode = _data["authorizationCode"];
            this.transactionReceipt = _data["transactionReceipt"];
            this.lastFourDigits = _data["lastFourDigits"];
            this.batchNumber = _data["batchNumber"];
            this.cardBrandProduct = _data["cardBrandProduct"];
        }
    }

    static fromJS(data: any): GatewayPaymentDataDto {
        data = typeof data === 'object' ? data : {};
        let result = new GatewayPaymentDataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["paymentId"] = this.paymentId;
        data["paymentRequestDate"] = this.paymentRequestDate ? this.paymentRequestDate.toISOString() : <any>undefined;
        data["paymentStatus"] = this.paymentStatus;
        data["paymentStatusDate"] = this.paymentStatusDate ? this.paymentStatusDate.toISOString() : <any>undefined;
        data["bin"] = this.bin;
        data["authorizationCode"] = this.authorizationCode;
        data["transactionReceipt"] = this.transactionReceipt;
        data["lastFourDigits"] = this.lastFourDigits;
        data["batchNumber"] = this.batchNumber;
        data["cardBrandProduct"] = this.cardBrandProduct;
        return data;
    }

    clone(): GatewayPaymentDataDto {
        const json = this.toJSON();
        let result = new GatewayPaymentDataDto();
        result.init(json);
        return result;
    }
}

export interface IGatewayPaymentDataDto {
    paymentId: string | undefined;
    paymentRequestDate: moment.Moment;
    paymentStatus: PaymentStatus;
    paymentStatusDate: moment.Moment;
    bin: string | undefined;
    authorizationCode: string | undefined;
    transactionReceipt: number;
    lastFourDigits: string | undefined;
    batchNumber: number;
    cardBrandProduct: string | undefined;
}

export class GatewayPaymentDataModel implements IGatewayPaymentDataModel {
    paymentId: string | undefined;
    paymentRequestDate: moment.Moment;
    paymentStatus: PaymentStatus;
    paymentStatusDate: moment.Moment;
    bin: string | undefined;
    authorizationCode: string | undefined;
    transactionReceipt: number;
    lastFourDigits: string | undefined;
    batchNumber: number;
    cardBrandProduct: string | undefined;

    constructor(data?: IGatewayPaymentDataModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.paymentId = _data["paymentId"];
            this.paymentRequestDate = _data["paymentRequestDate"] ? moment(_data["paymentRequestDate"].toString()) : <any>undefined;
            this.paymentStatus = _data["paymentStatus"];
            this.paymentStatusDate = _data["paymentStatusDate"] ? moment(_data["paymentStatusDate"].toString()) : <any>undefined;
            this.bin = _data["bin"];
            this.authorizationCode = _data["authorizationCode"];
            this.transactionReceipt = _data["transactionReceipt"];
            this.lastFourDigits = _data["lastFourDigits"];
            this.batchNumber = _data["batchNumber"];
            this.cardBrandProduct = _data["cardBrandProduct"];
        }
    }

    static fromJS(data: any): GatewayPaymentDataModel {
        data = typeof data === 'object' ? data : {};
        let result = new GatewayPaymentDataModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["paymentId"] = this.paymentId;
        data["paymentRequestDate"] = this.paymentRequestDate ? this.paymentRequestDate.toISOString() : <any>undefined;
        data["paymentStatus"] = this.paymentStatus;
        data["paymentStatusDate"] = this.paymentStatusDate ? this.paymentStatusDate.toISOString() : <any>undefined;
        data["bin"] = this.bin;
        data["authorizationCode"] = this.authorizationCode;
        data["transactionReceipt"] = this.transactionReceipt;
        data["lastFourDigits"] = this.lastFourDigits;
        data["batchNumber"] = this.batchNumber;
        data["cardBrandProduct"] = this.cardBrandProduct;
        return data;
    }

    clone(): GatewayPaymentDataModel {
        const json = this.toJSON();
        let result = new GatewayPaymentDataModel();
        result.init(json);
        return result;
    }
}

export interface IGatewayPaymentDataModel {
    paymentId: string | undefined;
    paymentRequestDate: moment.Moment;
    paymentStatus: PaymentStatus;
    paymentStatusDate: moment.Moment;
    bin: string | undefined;
    authorizationCode: string | undefined;
    transactionReceipt: number;
    lastFourDigits: string | undefined;
    batchNumber: number;
    cardBrandProduct: string | undefined;
}

export class GatewayPaymentDto implements IGatewayPaymentDto {
    userId: number;
    accessToken: string | undefined;
    apiKey: string | undefined;
    apiSecret: string | undefined;
    url: string | undefined;
    subnetId: number;
    terminalId: string | undefined;

    constructor(data?: IGatewayPaymentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.accessToken = _data["accessToken"];
            this.apiKey = _data["apiKey"];
            this.apiSecret = _data["apiSecret"];
            this.url = _data["url"];
            this.subnetId = _data["subnetId"];
            this.terminalId = _data["terminalId"];
        }
    }

    static fromJS(data: any): GatewayPaymentDto {
        data = typeof data === 'object' ? data : {};
        let result = new GatewayPaymentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["accessToken"] = this.accessToken;
        data["apiKey"] = this.apiKey;
        data["apiSecret"] = this.apiSecret;
        data["url"] = this.url;
        data["subnetId"] = this.subnetId;
        data["terminalId"] = this.terminalId;
        return data;
    }

    clone(): GatewayPaymentDto {
        const json = this.toJSON();
        let result = new GatewayPaymentDto();
        result.init(json);
        return result;
    }
}

export interface IGatewayPaymentDto {
    userId: number;
    accessToken: string | undefined;
    apiKey: string | undefined;
    apiSecret: string | undefined;
    url: string | undefined;
    subnetId: number;
    terminalId: string | undefined;
}

export class GetCurrentLoginInformationsOutput implements IGetCurrentLoginInformationsOutput {
    application: ApplicationInfoDto;
    user: UserLoginInfoDto;
    tenant: TenantLoginInfoDto;

    constructor(data?: IGetCurrentLoginInformationsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.application = _data["application"] ? ApplicationInfoDto.fromJS(_data["application"]) : <any>undefined;
            this.user = _data["user"] ? UserLoginInfoDto.fromJS(_data["user"]) : <any>undefined;
            this.tenant = _data["tenant"] ? TenantLoginInfoDto.fromJS(_data["tenant"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetCurrentLoginInformationsOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetCurrentLoginInformationsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["application"] = this.application ? this.application.toJSON() : <any>undefined;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["tenant"] = this.tenant ? this.tenant.toJSON() : <any>undefined;
        return data;
    }

    clone(): GetCurrentLoginInformationsOutput {
        const json = this.toJSON();
        let result = new GetCurrentLoginInformationsOutput();
        result.init(json);
        return result;
    }
}

export interface IGetCurrentLoginInformationsOutput {
    application: ApplicationInfoDto;
    user: UserLoginInfoDto;
    tenant: TenantLoginInfoDto;
}

export class GetHeadersTransitApiDto implements IGetHeadersTransitApiDto {
    movementId: number;
    date: moment.Moment;
    number: number;
    warehouseId: number;
    warehouseCode: string | undefined;
    warehouseDescription: string | undefined;
    quantityToReceive: number;
    storeExternalId: number | undefined;

    constructor(data?: IGetHeadersTransitApiDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.movementId = _data["movementId"];
            this.date = _data["date"] ? moment(_data["date"].toString()) : <any>undefined;
            this.number = _data["number"];
            this.warehouseId = _data["warehouseId"];
            this.warehouseCode = _data["warehouseCode"];
            this.warehouseDescription = _data["warehouseDescription"];
            this.quantityToReceive = _data["quantityToReceive"];
            this.storeExternalId = _data["storeExternalId"];
        }
    }

    static fromJS(data: any): GetHeadersTransitApiDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetHeadersTransitApiDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["movementId"] = this.movementId;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["number"] = this.number;
        data["warehouseId"] = this.warehouseId;
        data["warehouseCode"] = this.warehouseCode;
        data["warehouseDescription"] = this.warehouseDescription;
        data["quantityToReceive"] = this.quantityToReceive;
        data["storeExternalId"] = this.storeExternalId;
        return data;
    }

    clone(): GetHeadersTransitApiDto {
        const json = this.toJSON();
        let result = new GetHeadersTransitApiDto();
        result.init(json);
        return result;
    }
}

export interface IGetHeadersTransitApiDto {
    movementId: number;
    date: moment.Moment;
    number: number;
    warehouseId: number;
    warehouseCode: string | undefined;
    warehouseDescription: string | undefined;
    quantityToReceive: number;
    storeExternalId: number | undefined;
}

export class GetHeadersTransitApiListDto implements IGetHeadersTransitApiListDto {
    transitHeaderList: GetHeadersTransitApiDto[] | undefined;
    storeExternalId: number | undefined;

    constructor(data?: IGetHeadersTransitApiListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["transitHeaderList"])) {
                this.transitHeaderList = [] as any;
                for (let item of _data["transitHeaderList"])
                    this.transitHeaderList.push(GetHeadersTransitApiDto.fromJS(item));
            }
            this.storeExternalId = _data["storeExternalId"];
        }
    }

    static fromJS(data: any): GetHeadersTransitApiListDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetHeadersTransitApiListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.transitHeaderList)) {
            data["transitHeaderList"] = [];
            for (let item of this.transitHeaderList)
                data["transitHeaderList"].push(item.toJSON());
        }
        data["storeExternalId"] = this.storeExternalId;
        return data;
    }

    clone(): GetHeadersTransitApiListDto {
        const json = this.toJSON();
        let result = new GetHeadersTransitApiListDto();
        result.init(json);
        return result;
    }
}

export interface IGetHeadersTransitApiListDto {
    transitHeaderList: GetHeadersTransitApiDto[] | undefined;
    storeExternalId: number | undefined;
}

export class GetRoleForEditOutput implements IGetRoleForEditOutput {
    role: RoleEditDto;
    permissions: NodePermissionDto[] | undefined;
    grantedPermissionNames: string[] | undefined;

    constructor(data?: IGetRoleForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.role = _data["role"] ? RoleEditDto.fromJS(_data["role"]) : <any>undefined;
            if (Array.isArray(_data["permissions"])) {
                this.permissions = [] as any;
                for (let item of _data["permissions"])
                    this.permissions.push(NodePermissionDto.fromJS(item));
            }
            if (Array.isArray(_data["grantedPermissionNames"])) {
                this.grantedPermissionNames = [] as any;
                for (let item of _data["grantedPermissionNames"])
                    this.grantedPermissionNames.push(item);
            }
        }
    }

    static fromJS(data: any): GetRoleForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetRoleForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["role"] = this.role ? this.role.toJSON() : <any>undefined;
        if (Array.isArray(this.permissions)) {
            data["permissions"] = [];
            for (let item of this.permissions)
                data["permissions"].push(item.toJSON());
        }
        if (Array.isArray(this.grantedPermissionNames)) {
            data["grantedPermissionNames"] = [];
            for (let item of this.grantedPermissionNames)
                data["grantedPermissionNames"].push(item);
        }
        return data;
    }

    clone(): GetRoleForEditOutput {
        const json = this.toJSON();
        let result = new GetRoleForEditOutput();
        result.init(json);
        return result;
    }
}

export interface IGetRoleForEditOutput {
    role: RoleEditDto;
    permissions: NodePermissionDto[] | undefined;
    grantedPermissionNames: string[] | undefined;
}

export class Int64EntityDto implements IInt64EntityDto {
    id: number;

    constructor(data?: IInt64EntityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): Int64EntityDto {
        data = typeof data === 'object' ? data : {};
        let result = new Int64EntityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }

    clone(): Int64EntityDto {
        const json = this.toJSON();
        let result = new Int64EntityDto();
        result.init(json);
        return result;
    }
}

export interface IInt64EntityDto {
    id: number;
}

export class Invoice implements IInvoice {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    tenantId: number | undefined;
    name: string | undefined;
    number: string | undefined;
    date: moment.Moment | undefined;
    total: number;
    totalWithDiscountAndSurchages: number;
    totalWithTaxes: number;
    amountIva: number;
    amountIibb: number;
    internalTaxes: number;
    quote: number;
    invoiceId: number | undefined;
    userId: number;
    totalOfDiscount: number;
    totalOfSurchages: number;
    canceled: boolean;
    draft: boolean;
    description: string | undefined;
    extensionData: string | undefined;
    externalId: number | undefined;
    orderId: number | undefined;
    externalPackId: number | undefined;
    cae: string | undefined;
    expirationDateCAE: moment.Moment | undefined;
    urlQrCodeAfip: string | undefined;
    ticketCodeAfip: string | undefined;
    isReportProcessed: boolean;
    autoserviceCode: string | undefined;
    mustRetry: boolean;
    invoiceFormType: InvoiceFormType;
    letterType: LetterType;
    salePointId: number | undefined;
    salePoint: SalePoint;
    cashierId: number | undefined;
    cashier: Cashier;
    clientId: number | undefined;
    client: Client;
    vendorId: number | undefined;
    vendor: User;
    currencyId: number | undefined;
    currency: Currency;
    voucherCreatedId: number | undefined;
    voucherCreated: Voucher;
    voucherUsedId: number | undefined;
    voucherUsed: Voucher;
    reservation: Reservation;
    invoiceProducts: InvoiceProduct[] | undefined;
    transactions: Transaction[] | undefined;
    stockMovements: StockMovement[] | undefined;
    discountInvoices: DiscountInvoice[] | undefined;
    promotionInvoice: PromotionInvoice[] | undefined;
    invoiceData: InvoiceDataModel;
    changeTicketData: ChangeTicketDataModel;
    deliveryNoteData: DeliveryNoteDataModel;

    constructor(data?: IInvoice) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.tenantId = _data["tenantId"];
            this.name = _data["name"];
            this.number = _data["number"];
            this.date = _data["date"] ? moment(_data["date"].toString()) : <any>undefined;
            this.total = _data["total"];
            this.totalWithDiscountAndSurchages = _data["totalWithDiscountAndSurchages"];
            this.totalWithTaxes = _data["totalWithTaxes"];
            this.amountIva = _data["amountIva"];
            this.amountIibb = _data["amountIibb"];
            this.internalTaxes = _data["internalTaxes"];
            this.quote = _data["quote"];
            this.invoiceId = _data["invoiceId"];
            this.userId = _data["userId"];
            this.totalOfDiscount = _data["totalOfDiscount"];
            this.totalOfSurchages = _data["totalOfSurchages"];
            this.canceled = _data["canceled"];
            this.draft = _data["draft"];
            this.description = _data["description"];
            this.extensionData = _data["extensionData"];
            this.externalId = _data["externalId"];
            this.orderId = _data["orderId"];
            this.externalPackId = _data["externalPackId"];
            this.cae = _data["cae"];
            this.expirationDateCAE = _data["expirationDateCAE"] ? moment(_data["expirationDateCAE"].toString()) : <any>undefined;
            this.urlQrCodeAfip = _data["urlQrCodeAfip"];
            this.ticketCodeAfip = _data["ticketCodeAfip"];
            this.isReportProcessed = _data["isReportProcessed"];
            this.autoserviceCode = _data["autoserviceCode"];
            this.mustRetry = _data["mustRetry"];
            this.invoiceFormType = _data["invoiceFormType"];
            this.letterType = _data["letterType"];
            this.salePointId = _data["salePointId"];
            this.salePoint = _data["salePoint"] ? SalePoint.fromJS(_data["salePoint"]) : <any>undefined;
            this.cashierId = _data["cashierId"];
            this.cashier = _data["cashier"] ? Cashier.fromJS(_data["cashier"]) : <any>undefined;
            this.clientId = _data["clientId"];
            this.client = _data["client"] ? Client.fromJS(_data["client"]) : <any>undefined;
            this.vendorId = _data["vendorId"];
            this.vendor = _data["vendor"] ? User.fromJS(_data["vendor"]) : <any>undefined;
            this.currencyId = _data["currencyId"];
            this.currency = _data["currency"] ? Currency.fromJS(_data["currency"]) : <any>undefined;
            this.voucherCreatedId = _data["voucherCreatedId"];
            this.voucherCreated = _data["voucherCreated"] ? Voucher.fromJS(_data["voucherCreated"]) : <any>undefined;
            this.voucherUsedId = _data["voucherUsedId"];
            this.voucherUsed = _data["voucherUsed"] ? Voucher.fromJS(_data["voucherUsed"]) : <any>undefined;
            this.reservation = _data["reservation"] ? Reservation.fromJS(_data["reservation"]) : <any>undefined;
            if (Array.isArray(_data["invoiceProducts"])) {
                this.invoiceProducts = [] as any;
                for (let item of _data["invoiceProducts"])
                    this.invoiceProducts.push(InvoiceProduct.fromJS(item));
            }
            if (Array.isArray(_data["transactions"])) {
                this.transactions = [] as any;
                for (let item of _data["transactions"])
                    this.transactions.push(Transaction.fromJS(item));
            }
            if (Array.isArray(_data["stockMovements"])) {
                this.stockMovements = [] as any;
                for (let item of _data["stockMovements"])
                    this.stockMovements.push(StockMovement.fromJS(item));
            }
            if (Array.isArray(_data["discountInvoices"])) {
                this.discountInvoices = [] as any;
                for (let item of _data["discountInvoices"])
                    this.discountInvoices.push(DiscountInvoice.fromJS(item));
            }
            if (Array.isArray(_data["promotionInvoice"])) {
                this.promotionInvoice = [] as any;
                for (let item of _data["promotionInvoice"])
                    this.promotionInvoice.push(PromotionInvoice.fromJS(item));
            }
            this.invoiceData = _data["invoiceData"] ? InvoiceDataModel.fromJS(_data["invoiceData"]) : <any>undefined;
            this.changeTicketData = _data["changeTicketData"] ? ChangeTicketDataModel.fromJS(_data["changeTicketData"]) : <any>undefined;
            this.deliveryNoteData = _data["deliveryNoteData"] ? DeliveryNoteDataModel.fromJS(_data["deliveryNoteData"]) : <any>undefined;
        }
    }

    static fromJS(data: any): Invoice {
        data = typeof data === 'object' ? data : {};
        let result = new Invoice();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["tenantId"] = this.tenantId;
        data["name"] = this.name;
        data["number"] = this.number;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["total"] = this.total;
        data["totalWithDiscountAndSurchages"] = this.totalWithDiscountAndSurchages;
        data["totalWithTaxes"] = this.totalWithTaxes;
        data["amountIva"] = this.amountIva;
        data["amountIibb"] = this.amountIibb;
        data["internalTaxes"] = this.internalTaxes;
        data["quote"] = this.quote;
        data["invoiceId"] = this.invoiceId;
        data["userId"] = this.userId;
        data["totalOfDiscount"] = this.totalOfDiscount;
        data["totalOfSurchages"] = this.totalOfSurchages;
        data["canceled"] = this.canceled;
        data["draft"] = this.draft;
        data["description"] = this.description;
        data["extensionData"] = this.extensionData;
        data["externalId"] = this.externalId;
        data["orderId"] = this.orderId;
        data["externalPackId"] = this.externalPackId;
        data["cae"] = this.cae;
        data["expirationDateCAE"] = this.expirationDateCAE ? this.expirationDateCAE.toISOString() : <any>undefined;
        data["urlQrCodeAfip"] = this.urlQrCodeAfip;
        data["ticketCodeAfip"] = this.ticketCodeAfip;
        data["isReportProcessed"] = this.isReportProcessed;
        data["autoserviceCode"] = this.autoserviceCode;
        data["mustRetry"] = this.mustRetry;
        data["invoiceFormType"] = this.invoiceFormType;
        data["letterType"] = this.letterType;
        data["salePointId"] = this.salePointId;
        data["salePoint"] = this.salePoint ? this.salePoint.toJSON() : <any>undefined;
        data["cashierId"] = this.cashierId;
        data["cashier"] = this.cashier ? this.cashier.toJSON() : <any>undefined;
        data["clientId"] = this.clientId;
        data["client"] = this.client ? this.client.toJSON() : <any>undefined;
        data["vendorId"] = this.vendorId;
        data["vendor"] = this.vendor ? this.vendor.toJSON() : <any>undefined;
        data["currencyId"] = this.currencyId;
        data["currency"] = this.currency ? this.currency.toJSON() : <any>undefined;
        data["voucherCreatedId"] = this.voucherCreatedId;
        data["voucherCreated"] = this.voucherCreated ? this.voucherCreated.toJSON() : <any>undefined;
        data["voucherUsedId"] = this.voucherUsedId;
        data["voucherUsed"] = this.voucherUsed ? this.voucherUsed.toJSON() : <any>undefined;
        data["reservation"] = this.reservation ? this.reservation.toJSON() : <any>undefined;
        if (Array.isArray(this.invoiceProducts)) {
            data["invoiceProducts"] = [];
            for (let item of this.invoiceProducts)
                data["invoiceProducts"].push(item.toJSON());
        }
        if (Array.isArray(this.transactions)) {
            data["transactions"] = [];
            for (let item of this.transactions)
                data["transactions"].push(item.toJSON());
        }
        if (Array.isArray(this.stockMovements)) {
            data["stockMovements"] = [];
            for (let item of this.stockMovements)
                data["stockMovements"].push(item.toJSON());
        }
        if (Array.isArray(this.discountInvoices)) {
            data["discountInvoices"] = [];
            for (let item of this.discountInvoices)
                data["discountInvoices"].push(item.toJSON());
        }
        if (Array.isArray(this.promotionInvoice)) {
            data["promotionInvoice"] = [];
            for (let item of this.promotionInvoice)
                data["promotionInvoice"].push(item.toJSON());
        }
        data["invoiceData"] = this.invoiceData ? this.invoiceData.toJSON() : <any>undefined;
        data["changeTicketData"] = this.changeTicketData ? this.changeTicketData.toJSON() : <any>undefined;
        data["deliveryNoteData"] = this.deliveryNoteData ? this.deliveryNoteData.toJSON() : <any>undefined;
        return data;
    }

    clone(): Invoice {
        const json = this.toJSON();
        let result = new Invoice();
        result.init(json);
        return result;
    }
}

export interface IInvoice {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    tenantId: number | undefined;
    name: string | undefined;
    number: string | undefined;
    date: moment.Moment | undefined;
    total: number;
    totalWithDiscountAndSurchages: number;
    totalWithTaxes: number;
    amountIva: number;
    amountIibb: number;
    internalTaxes: number;
    quote: number;
    invoiceId: number | undefined;
    userId: number;
    totalOfDiscount: number;
    totalOfSurchages: number;
    canceled: boolean;
    draft: boolean;
    description: string | undefined;
    extensionData: string | undefined;
    externalId: number | undefined;
    orderId: number | undefined;
    externalPackId: number | undefined;
    cae: string | undefined;
    expirationDateCAE: moment.Moment | undefined;
    urlQrCodeAfip: string | undefined;
    ticketCodeAfip: string | undefined;
    isReportProcessed: boolean;
    autoserviceCode: string | undefined;
    mustRetry: boolean;
    invoiceFormType: InvoiceFormType;
    letterType: LetterType;
    salePointId: number | undefined;
    salePoint: SalePoint;
    cashierId: number | undefined;
    cashier: Cashier;
    clientId: number | undefined;
    client: Client;
    vendorId: number | undefined;
    vendor: User;
    currencyId: number | undefined;
    currency: Currency;
    voucherCreatedId: number | undefined;
    voucherCreated: Voucher;
    voucherUsedId: number | undefined;
    voucherUsed: Voucher;
    reservation: Reservation;
    invoiceProducts: InvoiceProduct[] | undefined;
    transactions: Transaction[] | undefined;
    stockMovements: StockMovement[] | undefined;
    discountInvoices: DiscountInvoice[] | undefined;
    promotionInvoice: PromotionInvoice[] | undefined;
    invoiceData: InvoiceDataModel;
    changeTicketData: ChangeTicketDataModel;
    deliveryNoteData: DeliveryNoteDataModel;
}

export class InvoiceDataModel implements IInvoiceDataModel {
    number: string | undefined;
    created: moment.Moment;
    total: number;
    totalPayment: number;
    totalWithDiscountAndSurchages: number;
    totalWithTaxes: number;
    amountIva: number;
    amountIibb: number;
    internalTaxes: number;
    quote: number;
    invoiceId: number | undefined;
    userId: number;
    totalOfDiscount: number;
    totalOfSurchages: number;
    canceled: boolean;
    isFiscalController: boolean;
    invoiceFormType: InvoiceFormType;
    letterType: LetterType;
    salePointId: number;
    salePointPrefix: string | undefined;
    salePointType: string | undefined;
    clientId: number | undefined;
    clientFullName: string | undefined;
    clientIdentification: string | undefined;
    clientName: string | undefined;
    clientFullNameInvoice: string | undefined;
    clientUseGrossIncome: boolean;
    clientGrossIncomeAmount: number;
    clientTaxCondition: TaxConditionType;
    readonly clientTaxConditionName: string | undefined;
    vendorId: number | undefined;
    vendorFullName: string | undefined;
    currencyId: number;
    voucherCreatedId: number | undefined;
    voucherCreatedAmount: number;
    voucherCode: string | undefined;
    voucherCreatedCode: string | undefined;
    voucherCreatedCreationTime: string | undefined;
    voucherCreatedExpireDate: string | undefined;
    voucherUsedId: number | undefined;
    voucherUsedAmount: number;
    listProducts: InvoiceProductModel[] | undefined;
    listTransactions: TransactionModel[] | undefined;
    listDiscounts: number[] | undefined;
    listPromotions: number[] | undefined;
    listPromotionsData: InvoicePromotionModel[] | undefined;
    invoiceDiscountDetails: InvoiceDiscountDetailsModel[] | undefined;
    cae: string | undefined;
    expirationDateCAE: moment.Moment | undefined;
    urlQrCodeAfip: string | undefined;
    ticketCodeAfip: string | undefined;
    priceListId: number | undefined;
    cashBack: number;
    isReservationClosure: boolean;
    autoserviceCode: string | undefined;
    storeId: number;
    isDeleted: boolean;
    isCreditNoteFromChange: boolean;
    typeSalePoint: TypeSalePoint;
    readonly isManualInvoiceDeleted: boolean;
    isPossibleJump: boolean;
    possibleNumberJump: string | undefined;
    isJumpInvoice: boolean;
    isBankPromotionFC: boolean;
    isBankPromotionNC: boolean;
    emailForTicket: string | undefined;
    isReservationNC: boolean;
    isManualTiendaNubeEmission: boolean;
    isTiendaNube: boolean;
    isMercadoLibre: boolean;
    ecommerceSource: string | undefined;
    externalId: number | undefined;
    orderId: number | undefined;
    requiresCreditNote: boolean;
    isDelivered: boolean;
    deliveredAt: moment.Moment;
    deliveredByUserId: number | undefined;
    mercadoLibreOrderIds: number[] | undefined;

    constructor(data?: IInvoiceDataModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.number = _data["number"];
            this.created = _data["created"] ? moment(_data["created"].toString()) : <any>undefined;
            this.total = _data["total"];
            this.totalPayment = _data["totalPayment"];
            this.totalWithDiscountAndSurchages = _data["totalWithDiscountAndSurchages"];
            this.totalWithTaxes = _data["totalWithTaxes"];
            this.amountIva = _data["amountIva"];
            this.amountIibb = _data["amountIibb"];
            this.internalTaxes = _data["internalTaxes"];
            this.quote = _data["quote"];
            this.invoiceId = _data["invoiceId"];
            this.userId = _data["userId"];
            this.totalOfDiscount = _data["totalOfDiscount"];
            this.totalOfSurchages = _data["totalOfSurchages"];
            this.canceled = _data["canceled"];
            this.isFiscalController = _data["isFiscalController"];
            this.invoiceFormType = _data["invoiceFormType"];
            this.letterType = _data["letterType"];
            this.salePointId = _data["salePointId"];
            this.salePointPrefix = _data["salePointPrefix"];
            this.salePointType = _data["salePointType"];
            this.clientId = _data["clientId"];
            this.clientFullName = _data["clientFullName"];
            this.clientIdentification = _data["clientIdentification"];
            this.clientName = _data["clientName"];
            this.clientFullNameInvoice = _data["clientFullNameInvoice"];
            this.clientUseGrossIncome = _data["clientUseGrossIncome"];
            this.clientGrossIncomeAmount = _data["clientGrossIncomeAmount"];
            this.clientTaxCondition = _data["clientTaxCondition"];
            (<any>this).clientTaxConditionName = _data["clientTaxConditionName"];
            this.vendorId = _data["vendorId"];
            this.vendorFullName = _data["vendorFullName"];
            this.currencyId = _data["currencyId"];
            this.voucherCreatedId = _data["voucherCreatedId"];
            this.voucherCreatedAmount = _data["voucherCreatedAmount"];
            this.voucherCode = _data["voucherCode"];
            this.voucherCreatedCode = _data["voucherCreatedCode"];
            this.voucherCreatedCreationTime = _data["voucherCreatedCreationTime"];
            this.voucherCreatedExpireDate = _data["voucherCreatedExpireDate"];
            this.voucherUsedId = _data["voucherUsedId"];
            this.voucherUsedAmount = _data["voucherUsedAmount"];
            if (Array.isArray(_data["listProducts"])) {
                this.listProducts = [] as any;
                for (let item of _data["listProducts"])
                    this.listProducts.push(InvoiceProductModel.fromJS(item));
            }
            if (Array.isArray(_data["listTransactions"])) {
                this.listTransactions = [] as any;
                for (let item of _data["listTransactions"])
                    this.listTransactions.push(TransactionModel.fromJS(item));
            }
            if (Array.isArray(_data["listDiscounts"])) {
                this.listDiscounts = [] as any;
                for (let item of _data["listDiscounts"])
                    this.listDiscounts.push(item);
            }
            if (Array.isArray(_data["listPromotions"])) {
                this.listPromotions = [] as any;
                for (let item of _data["listPromotions"])
                    this.listPromotions.push(item);
            }
            if (Array.isArray(_data["listPromotionsData"])) {
                this.listPromotionsData = [] as any;
                for (let item of _data["listPromotionsData"])
                    this.listPromotionsData.push(InvoicePromotionModel.fromJS(item));
            }
            if (Array.isArray(_data["invoiceDiscountDetails"])) {
                this.invoiceDiscountDetails = [] as any;
                for (let item of _data["invoiceDiscountDetails"])
                    this.invoiceDiscountDetails.push(InvoiceDiscountDetailsModel.fromJS(item));
            }
            this.cae = _data["cae"];
            this.expirationDateCAE = _data["expirationDateCAE"] ? moment(_data["expirationDateCAE"].toString()) : <any>undefined;
            this.urlQrCodeAfip = _data["urlQrCodeAfip"];
            this.ticketCodeAfip = _data["ticketCodeAfip"];
            this.priceListId = _data["priceListId"];
            this.cashBack = _data["cashBack"];
            this.isReservationClosure = _data["isReservationClosure"];
            this.autoserviceCode = _data["autoserviceCode"];
            this.storeId = _data["storeId"];
            this.isDeleted = _data["isDeleted"];
            this.isCreditNoteFromChange = _data["isCreditNoteFromChange"];
            this.typeSalePoint = _data["typeSalePoint"];
            (<any>this).isManualInvoiceDeleted = _data["isManualInvoiceDeleted"];
            this.isPossibleJump = _data["isPossibleJump"];
            this.possibleNumberJump = _data["possibleNumberJump"];
            this.isJumpInvoice = _data["isJumpInvoice"];
            this.isBankPromotionFC = _data["isBankPromotionFC"];
            this.isBankPromotionNC = _data["isBankPromotionNC"];
            this.emailForTicket = _data["emailForTicket"];
            this.isReservationNC = _data["isReservationNC"];
            this.isManualTiendaNubeEmission = _data["isManualTiendaNubeEmission"];
            this.isTiendaNube = _data["isTiendaNube"];
            this.isMercadoLibre = _data["isMercadoLibre"];
            this.ecommerceSource = _data["ecommerceSource"];
            this.externalId = _data["externalId"];
            this.orderId = _data["orderId"];
            this.requiresCreditNote = _data["requiresCreditNote"];
            this.isDelivered = _data["isDelivered"];
            this.deliveredAt = _data["deliveredAt"] ? moment(_data["deliveredAt"].toString()) : <any>undefined;
            this.deliveredByUserId = _data["deliveredByUserId"];
            if (Array.isArray(_data["mercadoLibreOrderIds"])) {
                this.mercadoLibreOrderIds = [] as any;
                for (let item of _data["mercadoLibreOrderIds"])
                    this.mercadoLibreOrderIds.push(item);
            }
        }
    }

    static fromJS(data: any): InvoiceDataModel {
        data = typeof data === 'object' ? data : {};
        let result = new InvoiceDataModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["number"] = this.number;
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["total"] = this.total;
        data["totalPayment"] = this.totalPayment;
        data["totalWithDiscountAndSurchages"] = this.totalWithDiscountAndSurchages;
        data["totalWithTaxes"] = this.totalWithTaxes;
        data["amountIva"] = this.amountIva;
        data["amountIibb"] = this.amountIibb;
        data["internalTaxes"] = this.internalTaxes;
        data["quote"] = this.quote;
        data["invoiceId"] = this.invoiceId;
        data["userId"] = this.userId;
        data["totalOfDiscount"] = this.totalOfDiscount;
        data["totalOfSurchages"] = this.totalOfSurchages;
        data["canceled"] = this.canceled;
        data["isFiscalController"] = this.isFiscalController;
        data["invoiceFormType"] = this.invoiceFormType;
        data["letterType"] = this.letterType;
        data["salePointId"] = this.salePointId;
        data["salePointPrefix"] = this.salePointPrefix;
        data["salePointType"] = this.salePointType;
        data["clientId"] = this.clientId;
        data["clientFullName"] = this.clientFullName;
        data["clientIdentification"] = this.clientIdentification;
        data["clientName"] = this.clientName;
        data["clientFullNameInvoice"] = this.clientFullNameInvoice;
        data["clientUseGrossIncome"] = this.clientUseGrossIncome;
        data["clientGrossIncomeAmount"] = this.clientGrossIncomeAmount;
        data["clientTaxCondition"] = this.clientTaxCondition;
        data["clientTaxConditionName"] = this.clientTaxConditionName;
        data["vendorId"] = this.vendorId;
        data["vendorFullName"] = this.vendorFullName;
        data["currencyId"] = this.currencyId;
        data["voucherCreatedId"] = this.voucherCreatedId;
        data["voucherCreatedAmount"] = this.voucherCreatedAmount;
        data["voucherCode"] = this.voucherCode;
        data["voucherCreatedCode"] = this.voucherCreatedCode;
        data["voucherCreatedCreationTime"] = this.voucherCreatedCreationTime;
        data["voucherCreatedExpireDate"] = this.voucherCreatedExpireDate;
        data["voucherUsedId"] = this.voucherUsedId;
        data["voucherUsedAmount"] = this.voucherUsedAmount;
        if (Array.isArray(this.listProducts)) {
            data["listProducts"] = [];
            for (let item of this.listProducts)
                data["listProducts"].push(item.toJSON());
        }
        if (Array.isArray(this.listTransactions)) {
            data["listTransactions"] = [];
            for (let item of this.listTransactions)
                data["listTransactions"].push(item.toJSON());
        }
        if (Array.isArray(this.listDiscounts)) {
            data["listDiscounts"] = [];
            for (let item of this.listDiscounts)
                data["listDiscounts"].push(item);
        }
        if (Array.isArray(this.listPromotions)) {
            data["listPromotions"] = [];
            for (let item of this.listPromotions)
                data["listPromotions"].push(item);
        }
        if (Array.isArray(this.listPromotionsData)) {
            data["listPromotionsData"] = [];
            for (let item of this.listPromotionsData)
                data["listPromotionsData"].push(item.toJSON());
        }
        if (Array.isArray(this.invoiceDiscountDetails)) {
            data["invoiceDiscountDetails"] = [];
            for (let item of this.invoiceDiscountDetails)
                data["invoiceDiscountDetails"].push(item.toJSON());
        }
        data["cae"] = this.cae;
        data["expirationDateCAE"] = this.expirationDateCAE ? this.expirationDateCAE.toISOString() : <any>undefined;
        data["urlQrCodeAfip"] = this.urlQrCodeAfip;
        data["ticketCodeAfip"] = this.ticketCodeAfip;
        data["priceListId"] = this.priceListId;
        data["cashBack"] = this.cashBack;
        data["isReservationClosure"] = this.isReservationClosure;
        data["autoserviceCode"] = this.autoserviceCode;
        data["storeId"] = this.storeId;
        data["isDeleted"] = this.isDeleted;
        data["isCreditNoteFromChange"] = this.isCreditNoteFromChange;
        data["typeSalePoint"] = this.typeSalePoint;
        data["isManualInvoiceDeleted"] = this.isManualInvoiceDeleted;
        data["isPossibleJump"] = this.isPossibleJump;
        data["possibleNumberJump"] = this.possibleNumberJump;
        data["isJumpInvoice"] = this.isJumpInvoice;
        data["isBankPromotionFC"] = this.isBankPromotionFC;
        data["isBankPromotionNC"] = this.isBankPromotionNC;
        data["emailForTicket"] = this.emailForTicket;
        data["isReservationNC"] = this.isReservationNC;
        data["isManualTiendaNubeEmission"] = this.isManualTiendaNubeEmission;
        data["isTiendaNube"] = this.isTiendaNube;
        data["isMercadoLibre"] = this.isMercadoLibre;
        data["ecommerceSource"] = this.ecommerceSource;
        data["externalId"] = this.externalId;
        data["orderId"] = this.orderId;
        data["requiresCreditNote"] = this.requiresCreditNote;
        data["isDelivered"] = this.isDelivered;
        data["deliveredAt"] = this.deliveredAt ? this.deliveredAt.toISOString() : <any>undefined;
        data["deliveredByUserId"] = this.deliveredByUserId;
        if (Array.isArray(this.mercadoLibreOrderIds)) {
            data["mercadoLibreOrderIds"] = [];
            for (let item of this.mercadoLibreOrderIds)
                data["mercadoLibreOrderIds"].push(item);
        }
        return data;
    }

    clone(): InvoiceDataModel {
        const json = this.toJSON();
        let result = new InvoiceDataModel();
        result.init(json);
        return result;
    }
}

export interface IInvoiceDataModel {
    number: string | undefined;
    created: moment.Moment;
    total: number;
    totalPayment: number;
    totalWithDiscountAndSurchages: number;
    totalWithTaxes: number;
    amountIva: number;
    amountIibb: number;
    internalTaxes: number;
    quote: number;
    invoiceId: number | undefined;
    userId: number;
    totalOfDiscount: number;
    totalOfSurchages: number;
    canceled: boolean;
    isFiscalController: boolean;
    invoiceFormType: InvoiceFormType;
    letterType: LetterType;
    salePointId: number;
    salePointPrefix: string | undefined;
    salePointType: string | undefined;
    clientId: number | undefined;
    clientFullName: string | undefined;
    clientIdentification: string | undefined;
    clientName: string | undefined;
    clientFullNameInvoice: string | undefined;
    clientUseGrossIncome: boolean;
    clientGrossIncomeAmount: number;
    clientTaxCondition: TaxConditionType;
    clientTaxConditionName: string | undefined;
    vendorId: number | undefined;
    vendorFullName: string | undefined;
    currencyId: number;
    voucherCreatedId: number | undefined;
    voucherCreatedAmount: number;
    voucherCode: string | undefined;
    voucherCreatedCode: string | undefined;
    voucherCreatedCreationTime: string | undefined;
    voucherCreatedExpireDate: string | undefined;
    voucherUsedId: number | undefined;
    voucherUsedAmount: number;
    listProducts: InvoiceProductModel[] | undefined;
    listTransactions: TransactionModel[] | undefined;
    listDiscounts: number[] | undefined;
    listPromotions: number[] | undefined;
    listPromotionsData: InvoicePromotionModel[] | undefined;
    invoiceDiscountDetails: InvoiceDiscountDetailsModel[] | undefined;
    cae: string | undefined;
    expirationDateCAE: moment.Moment | undefined;
    urlQrCodeAfip: string | undefined;
    ticketCodeAfip: string | undefined;
    priceListId: number | undefined;
    cashBack: number;
    isReservationClosure: boolean;
    autoserviceCode: string | undefined;
    storeId: number;
    isDeleted: boolean;
    isCreditNoteFromChange: boolean;
    typeSalePoint: TypeSalePoint;
    isManualInvoiceDeleted: boolean;
    isPossibleJump: boolean;
    possibleNumberJump: string | undefined;
    isJumpInvoice: boolean;
    isBankPromotionFC: boolean;
    isBankPromotionNC: boolean;
    emailForTicket: string | undefined;
    isReservationNC: boolean;
    isManualTiendaNubeEmission: boolean;
    isTiendaNube: boolean;
    isMercadoLibre: boolean;
    ecommerceSource: string | undefined;
    externalId: number | undefined;
    orderId: number | undefined;
    requiresCreditNote: boolean;
    isDelivered: boolean;
    deliveredAt: moment.Moment;
    deliveredByUserId: number | undefined;
    mercadoLibreOrderIds: number[] | undefined;
}

export class InvoiceDiscountDetailsDto implements IInvoiceDiscountDetailsDto {
    totalOfDiscount: number;
    iva: number;
    observation: string | undefined;
    isBankPromotionDiscount: boolean;

    constructor(data?: IInvoiceDiscountDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalOfDiscount = _data["totalOfDiscount"];
            this.iva = _data["iva"];
            this.observation = _data["observation"];
            this.isBankPromotionDiscount = _data["isBankPromotionDiscount"];
        }
    }

    static fromJS(data: any): InvoiceDiscountDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new InvoiceDiscountDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalOfDiscount"] = this.totalOfDiscount;
        data["iva"] = this.iva;
        data["observation"] = this.observation;
        data["isBankPromotionDiscount"] = this.isBankPromotionDiscount;
        return data;
    }

    clone(): InvoiceDiscountDetailsDto {
        const json = this.toJSON();
        let result = new InvoiceDiscountDetailsDto();
        result.init(json);
        return result;
    }
}

export interface IInvoiceDiscountDetailsDto {
    totalOfDiscount: number;
    iva: number;
    observation: string | undefined;
    isBankPromotionDiscount: boolean;
}

export class InvoiceDiscountDetailsModel implements IInvoiceDiscountDetailsModel {
    totalOfDiscount: number;
    iva: number;
    observation: string | undefined;
    isBankPromotionDiscount: boolean;

    constructor(data?: IInvoiceDiscountDetailsModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalOfDiscount = _data["totalOfDiscount"];
            this.iva = _data["iva"];
            this.observation = _data["observation"];
            this.isBankPromotionDiscount = _data["isBankPromotionDiscount"];
        }
    }

    static fromJS(data: any): InvoiceDiscountDetailsModel {
        data = typeof data === 'object' ? data : {};
        let result = new InvoiceDiscountDetailsModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalOfDiscount"] = this.totalOfDiscount;
        data["iva"] = this.iva;
        data["observation"] = this.observation;
        data["isBankPromotionDiscount"] = this.isBankPromotionDiscount;
        return data;
    }

    clone(): InvoiceDiscountDetailsModel {
        const json = this.toJSON();
        let result = new InvoiceDiscountDetailsModel();
        result.init(json);
        return result;
    }
}

export interface IInvoiceDiscountDetailsModel {
    totalOfDiscount: number;
    iva: number;
    observation: string | undefined;
    isBankPromotionDiscount: boolean;
}

export class InvoiceDto implements IInvoiceDto {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    tenantId: number | undefined;
    number: string | undefined;
    total: number;
    totalWithDiscountAndSurchages: number;
    totalWithTaxes: number;
    amountIva: number;
    amountIibb: number;
    internalTaxes: number;
    bankPromotionDiscountPercentage: number;
    quote: number;
    invoiceId: number | undefined;
    userId: number;
    totalOfDiscount: number;
    totalOfSurchages: number;
    totalPayment: number;
    totalWithoutPromotions: number;
    totalPromotions: number;
    canceled: boolean;
    isFiscalController: boolean;
    useNoFiscal: boolean;
    invoiceFormType: InvoiceFormType;
    readonly invoiceFormTypeName: string | undefined;
    letterType: LetterType;
    readonly letterTypeName: string | undefined;
    printerType: PrinterType;
    salePointId: number | undefined;
    salePointPrefix: string | undefined;
    salePointDescription: string | undefined;
    salePointType: TypeSalePoint;
    readonly salePointTypeName: string | undefined;
    clientId: number | undefined;
    clientFullName: string | undefined;
    clientName: string | undefined;
    clientTaxNumber: string | undefined;
    clientIdentification: string | undefined;
    clientAddress: string | undefined;
    clientUseGrossIncome: boolean;
    clientGrossIncomeAmount: number;
    clientTaxCondition: TaxConditionType;
    readonly clientTaxConditionName: string | undefined;
    clientFullNameInvoice: string | undefined;
    clientIsStatic: boolean;
    vendorId: number | undefined;
    vendorFullName: string | undefined;
    currencyId: number;
    reservationId: number;
    draft: boolean;
    voucherCreatedCode: string | undefined;
    voucherCreatedAmount: number;
    voucherCreatedCreationTime: moment.Moment;
    voucherCreatedExpireDate: moment.Moment | undefined;
    bin: number | undefined;
    voucherCreatedId: number | undefined;
    voucherUsedId: number | undefined;
    ticketByProduct: boolean;
    ticketByInvoice: boolean;
    voucherByMail: boolean;
    emailForTicket: string | undefined;
    ticketUse: boolean;
    ticketCode: string | undefined;
    isCreditNote: boolean;
    amountBankPromotion: number;
    invoiceProductUsed: { [key: string]: number; } | undefined;
    listProducts: InvoiceProductDto[] | undefined;
    listTransactions: TransactionDto[] | undefined;
    listDiscounts: number[] | undefined;
    draftHasExpiredPromotions: boolean;
    draftHasExpiredDiscounts: boolean;
    reservationParentId: number | undefined;
    totalReservation: number;
    voucherUsedAmount: number;
    voucherUsedAmountRemain: number;
    isCreditNoteFromChange: boolean;
    typeRespEmisor: number;
    cashierId: number | undefined;
    cahsierCodeCancelReservation: string | undefined;
    listPromotions: number[] | undefined;
    listPromotionsData: PromotionInvoiceDto[] | undefined;
    isReadonly: boolean;
    isBankPromotionNC: boolean;
    invoiceData: InvoiceDataModel;
    cae: string | undefined;
    expirationDateCAE: moment.Moment | undefined;
    urlQrCodeAfip: string | undefined;
    ticketCodeAfip: string | undefined;
    isChange: boolean;
    priceListId: number | undefined;
    remain: number;
    cashBack: number;
    description: string | undefined;
    invoiceDiscountDetails: InvoiceDiscountDetailsDto[] | undefined;
    isReservationNC: boolean;
    promotionAppliedNames: string | undefined;
    isReservationClosure: boolean;
    autoserviceCode: string | undefined;
    invoiceDiscountPercent: number;
    changePolicyText: string | undefined;
    isLoadingDataForCreditNote: boolean;
    isBankPromotionFC: boolean;
    isJumpInvoice: boolean;
    isPossibleJump: boolean;
    possibleNumberJump: string | undefined;
    mustRetry: boolean;
    isManualTiendaNubeEmission: boolean;
    isManualMercadoLibreEmission: boolean;
    isTiendaNube: boolean;
    isMercadoLibre: boolean;
    ecommerceSource: string | undefined;
    externalId: number | undefined;
    orderId: number | undefined;
    requiresCreditNote: boolean;

    constructor(data?: IInvoiceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.tenantId = _data["tenantId"];
            this.number = _data["number"];
            this.total = _data["total"];
            this.totalWithDiscountAndSurchages = _data["totalWithDiscountAndSurchages"];
            this.totalWithTaxes = _data["totalWithTaxes"];
            this.amountIva = _data["amountIva"];
            this.amountIibb = _data["amountIibb"];
            this.internalTaxes = _data["internalTaxes"];
            this.bankPromotionDiscountPercentage = _data["bankPromotionDiscountPercentage"];
            this.quote = _data["quote"];
            this.invoiceId = _data["invoiceId"];
            this.userId = _data["userId"];
            this.totalOfDiscount = _data["totalOfDiscount"];
            this.totalOfSurchages = _data["totalOfSurchages"];
            this.totalPayment = _data["totalPayment"];
            this.totalWithoutPromotions = _data["totalWithoutPromotions"];
            this.totalPromotions = _data["totalPromotions"];
            this.canceled = _data["canceled"];
            this.isFiscalController = _data["isFiscalController"];
            this.useNoFiscal = _data["useNoFiscal"];
            this.invoiceFormType = _data["invoiceFormType"];
            (<any>this).invoiceFormTypeName = _data["invoiceFormTypeName"];
            this.letterType = _data["letterType"];
            (<any>this).letterTypeName = _data["letterTypeName"];
            this.printerType = _data["printerType"];
            this.salePointId = _data["salePointId"];
            this.salePointPrefix = _data["salePointPrefix"];
            this.salePointDescription = _data["salePointDescription"];
            this.salePointType = _data["salePointType"];
            (<any>this).salePointTypeName = _data["salePointTypeName"];
            this.clientId = _data["clientId"];
            this.clientFullName = _data["clientFullName"];
            this.clientName = _data["clientName"];
            this.clientTaxNumber = _data["clientTaxNumber"];
            this.clientIdentification = _data["clientIdentification"];
            this.clientAddress = _data["clientAddress"];
            this.clientUseGrossIncome = _data["clientUseGrossIncome"];
            this.clientGrossIncomeAmount = _data["clientGrossIncomeAmount"];
            this.clientTaxCondition = _data["clientTaxCondition"];
            (<any>this).clientTaxConditionName = _data["clientTaxConditionName"];
            this.clientFullNameInvoice = _data["clientFullNameInvoice"];
            this.clientIsStatic = _data["clientIsStatic"];
            this.vendorId = _data["vendorId"];
            this.vendorFullName = _data["vendorFullName"];
            this.currencyId = _data["currencyId"];
            this.reservationId = _data["reservationId"];
            this.draft = _data["draft"];
            this.voucherCreatedCode = _data["voucherCreatedCode"];
            this.voucherCreatedAmount = _data["voucherCreatedAmount"];
            this.voucherCreatedCreationTime = _data["voucherCreatedCreationTime"] ? moment(_data["voucherCreatedCreationTime"].toString()) : <any>undefined;
            this.voucherCreatedExpireDate = _data["voucherCreatedExpireDate"] ? moment(_data["voucherCreatedExpireDate"].toString()) : <any>undefined;
            this.bin = _data["bin"];
            this.voucherCreatedId = _data["voucherCreatedId"];
            this.voucherUsedId = _data["voucherUsedId"];
            this.ticketByProduct = _data["ticketByProduct"];
            this.ticketByInvoice = _data["ticketByInvoice"];
            this.voucherByMail = _data["voucherByMail"];
            this.emailForTicket = _data["emailForTicket"];
            this.ticketUse = _data["ticketUse"];
            this.ticketCode = _data["ticketCode"];
            this.isCreditNote = _data["isCreditNote"];
            this.amountBankPromotion = _data["amountBankPromotion"];
            if (_data["invoiceProductUsed"]) {
                this.invoiceProductUsed = {} as any;
                for (let key in _data["invoiceProductUsed"]) {
                    if (_data["invoiceProductUsed"].hasOwnProperty(key))
                        (<any>this.invoiceProductUsed)[key] = _data["invoiceProductUsed"][key];
                }
            }
            if (Array.isArray(_data["listProducts"])) {
                this.listProducts = [] as any;
                for (let item of _data["listProducts"])
                    this.listProducts.push(InvoiceProductDto.fromJS(item));
            }
            if (Array.isArray(_data["listTransactions"])) {
                this.listTransactions = [] as any;
                for (let item of _data["listTransactions"])
                    this.listTransactions.push(TransactionDto.fromJS(item));
            }
            if (Array.isArray(_data["listDiscounts"])) {
                this.listDiscounts = [] as any;
                for (let item of _data["listDiscounts"])
                    this.listDiscounts.push(item);
            }
            this.draftHasExpiredPromotions = _data["draftHasExpiredPromotions"];
            this.draftHasExpiredDiscounts = _data["draftHasExpiredDiscounts"];
            this.reservationParentId = _data["reservationParentId"];
            this.totalReservation = _data["totalReservation"];
            this.voucherUsedAmount = _data["voucherUsedAmount"];
            this.voucherUsedAmountRemain = _data["voucherUsedAmountRemain"];
            this.isCreditNoteFromChange = _data["isCreditNoteFromChange"];
            this.typeRespEmisor = _data["typeRespEmisor"];
            this.cashierId = _data["cashierId"];
            this.cahsierCodeCancelReservation = _data["cahsierCodeCancelReservation"];
            if (Array.isArray(_data["listPromotions"])) {
                this.listPromotions = [] as any;
                for (let item of _data["listPromotions"])
                    this.listPromotions.push(item);
            }
            if (Array.isArray(_data["listPromotionsData"])) {
                this.listPromotionsData = [] as any;
                for (let item of _data["listPromotionsData"])
                    this.listPromotionsData.push(PromotionInvoiceDto.fromJS(item));
            }
            this.isReadonly = _data["isReadonly"];
            this.isBankPromotionNC = _data["isBankPromotionNC"];
            this.invoiceData = _data["invoiceData"] ? InvoiceDataModel.fromJS(_data["invoiceData"]) : <any>undefined;
            this.cae = _data["cae"];
            this.expirationDateCAE = _data["expirationDateCAE"] ? moment(_data["expirationDateCAE"].toString()) : <any>undefined;
            this.urlQrCodeAfip = _data["urlQrCodeAfip"];
            this.ticketCodeAfip = _data["ticketCodeAfip"];
            this.isChange = _data["isChange"];
            this.priceListId = _data["priceListId"];
            this.remain = _data["remain"];
            this.cashBack = _data["cashBack"];
            this.description = _data["description"];
            if (Array.isArray(_data["invoiceDiscountDetails"])) {
                this.invoiceDiscountDetails = [] as any;
                for (let item of _data["invoiceDiscountDetails"])
                    this.invoiceDiscountDetails.push(InvoiceDiscountDetailsDto.fromJS(item));
            }
            this.isReservationNC = _data["isReservationNC"];
            this.promotionAppliedNames = _data["promotionAppliedNames"];
            this.isReservationClosure = _data["isReservationClosure"];
            this.autoserviceCode = _data["autoserviceCode"];
            this.invoiceDiscountPercent = _data["invoiceDiscountPercent"];
            this.changePolicyText = _data["changePolicyText"];
            this.isLoadingDataForCreditNote = _data["isLoadingDataForCreditNote"];
            this.isBankPromotionFC = _data["isBankPromotionFC"];
            this.isJumpInvoice = _data["isJumpInvoice"];
            this.isPossibleJump = _data["isPossibleJump"];
            this.possibleNumberJump = _data["possibleNumberJump"];
            this.mustRetry = _data["mustRetry"];
            this.isManualTiendaNubeEmission = _data["isManualTiendaNubeEmission"];
            this.isManualMercadoLibreEmission = _data["isManualMercadoLibreEmission"];
            this.isTiendaNube = _data["isTiendaNube"];
            this.isMercadoLibre = _data["isMercadoLibre"];
            this.ecommerceSource = _data["ecommerceSource"];
            this.externalId = _data["externalId"];
            this.orderId = _data["orderId"];
            this.requiresCreditNote = _data["requiresCreditNote"];
        }
    }

    static fromJS(data: any): InvoiceDto {
        data = typeof data === 'object' ? data : {};
        let result = new InvoiceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["tenantId"] = this.tenantId;
        data["number"] = this.number;
        data["total"] = this.total;
        data["totalWithDiscountAndSurchages"] = this.totalWithDiscountAndSurchages;
        data["totalWithTaxes"] = this.totalWithTaxes;
        data["amountIva"] = this.amountIva;
        data["amountIibb"] = this.amountIibb;
        data["internalTaxes"] = this.internalTaxes;
        data["bankPromotionDiscountPercentage"] = this.bankPromotionDiscountPercentage;
        data["quote"] = this.quote;
        data["invoiceId"] = this.invoiceId;
        data["userId"] = this.userId;
        data["totalOfDiscount"] = this.totalOfDiscount;
        data["totalOfSurchages"] = this.totalOfSurchages;
        data["totalPayment"] = this.totalPayment;
        data["totalWithoutPromotions"] = this.totalWithoutPromotions;
        data["totalPromotions"] = this.totalPromotions;
        data["canceled"] = this.canceled;
        data["isFiscalController"] = this.isFiscalController;
        data["useNoFiscal"] = this.useNoFiscal;
        data["invoiceFormType"] = this.invoiceFormType;
        data["invoiceFormTypeName"] = this.invoiceFormTypeName;
        data["letterType"] = this.letterType;
        data["letterTypeName"] = this.letterTypeName;
        data["printerType"] = this.printerType;
        data["salePointId"] = this.salePointId;
        data["salePointPrefix"] = this.salePointPrefix;
        data["salePointDescription"] = this.salePointDescription;
        data["salePointType"] = this.salePointType;
        data["salePointTypeName"] = this.salePointTypeName;
        data["clientId"] = this.clientId;
        data["clientFullName"] = this.clientFullName;
        data["clientName"] = this.clientName;
        data["clientTaxNumber"] = this.clientTaxNumber;
        data["clientIdentification"] = this.clientIdentification;
        data["clientAddress"] = this.clientAddress;
        data["clientUseGrossIncome"] = this.clientUseGrossIncome;
        data["clientGrossIncomeAmount"] = this.clientGrossIncomeAmount;
        data["clientTaxCondition"] = this.clientTaxCondition;
        data["clientTaxConditionName"] = this.clientTaxConditionName;
        data["clientFullNameInvoice"] = this.clientFullNameInvoice;
        data["clientIsStatic"] = this.clientIsStatic;
        data["vendorId"] = this.vendorId;
        data["vendorFullName"] = this.vendorFullName;
        data["currencyId"] = this.currencyId;
        data["reservationId"] = this.reservationId;
        data["draft"] = this.draft;
        data["voucherCreatedCode"] = this.voucherCreatedCode;
        data["voucherCreatedAmount"] = this.voucherCreatedAmount;
        data["voucherCreatedCreationTime"] = this.voucherCreatedCreationTime ? this.voucherCreatedCreationTime.toISOString() : <any>undefined;
        data["voucherCreatedExpireDate"] = this.voucherCreatedExpireDate ? this.voucherCreatedExpireDate.toISOString() : <any>undefined;
        data["bin"] = this.bin;
        data["voucherCreatedId"] = this.voucherCreatedId;
        data["voucherUsedId"] = this.voucherUsedId;
        data["ticketByProduct"] = this.ticketByProduct;
        data["ticketByInvoice"] = this.ticketByInvoice;
        data["voucherByMail"] = this.voucherByMail;
        data["emailForTicket"] = this.emailForTicket;
        data["ticketUse"] = this.ticketUse;
        data["ticketCode"] = this.ticketCode;
        data["isCreditNote"] = this.isCreditNote;
        data["amountBankPromotion"] = this.amountBankPromotion;
        if (this.invoiceProductUsed) {
            data["invoiceProductUsed"] = {};
            for (let key in this.invoiceProductUsed) {
                if (this.invoiceProductUsed.hasOwnProperty(key))
                    (<any>data["invoiceProductUsed"])[key] = (<any>this.invoiceProductUsed)[key];
            }
        }
        if (Array.isArray(this.listProducts)) {
            data["listProducts"] = [];
            for (let item of this.listProducts)
                data["listProducts"].push(item.toJSON());
        }
        if (Array.isArray(this.listTransactions)) {
            data["listTransactions"] = [];
            for (let item of this.listTransactions)
                data["listTransactions"].push(item.toJSON());
        }
        if (Array.isArray(this.listDiscounts)) {
            data["listDiscounts"] = [];
            for (let item of this.listDiscounts)
                data["listDiscounts"].push(item);
        }
        data["draftHasExpiredPromotions"] = this.draftHasExpiredPromotions;
        data["draftHasExpiredDiscounts"] = this.draftHasExpiredDiscounts;
        data["reservationParentId"] = this.reservationParentId;
        data["totalReservation"] = this.totalReservation;
        data["voucherUsedAmount"] = this.voucherUsedAmount;
        data["voucherUsedAmountRemain"] = this.voucherUsedAmountRemain;
        data["isCreditNoteFromChange"] = this.isCreditNoteFromChange;
        data["typeRespEmisor"] = this.typeRespEmisor;
        data["cashierId"] = this.cashierId;
        data["cahsierCodeCancelReservation"] = this.cahsierCodeCancelReservation;
        if (Array.isArray(this.listPromotions)) {
            data["listPromotions"] = [];
            for (let item of this.listPromotions)
                data["listPromotions"].push(item);
        }
        if (Array.isArray(this.listPromotionsData)) {
            data["listPromotionsData"] = [];
            for (let item of this.listPromotionsData)
                data["listPromotionsData"].push(item.toJSON());
        }
        data["isReadonly"] = this.isReadonly;
        data["isBankPromotionNC"] = this.isBankPromotionNC;
        data["invoiceData"] = this.invoiceData ? this.invoiceData.toJSON() : <any>undefined;
        data["cae"] = this.cae;
        data["expirationDateCAE"] = this.expirationDateCAE ? this.expirationDateCAE.toISOString() : <any>undefined;
        data["urlQrCodeAfip"] = this.urlQrCodeAfip;
        data["ticketCodeAfip"] = this.ticketCodeAfip;
        data["isChange"] = this.isChange;
        data["priceListId"] = this.priceListId;
        data["remain"] = this.remain;
        data["cashBack"] = this.cashBack;
        data["description"] = this.description;
        if (Array.isArray(this.invoiceDiscountDetails)) {
            data["invoiceDiscountDetails"] = [];
            for (let item of this.invoiceDiscountDetails)
                data["invoiceDiscountDetails"].push(item.toJSON());
        }
        data["isReservationNC"] = this.isReservationNC;
        data["promotionAppliedNames"] = this.promotionAppliedNames;
        data["isReservationClosure"] = this.isReservationClosure;
        data["autoserviceCode"] = this.autoserviceCode;
        data["invoiceDiscountPercent"] = this.invoiceDiscountPercent;
        data["changePolicyText"] = this.changePolicyText;
        data["isLoadingDataForCreditNote"] = this.isLoadingDataForCreditNote;
        data["isBankPromotionFC"] = this.isBankPromotionFC;
        data["isJumpInvoice"] = this.isJumpInvoice;
        data["isPossibleJump"] = this.isPossibleJump;
        data["possibleNumberJump"] = this.possibleNumberJump;
        data["mustRetry"] = this.mustRetry;
        data["isManualTiendaNubeEmission"] = this.isManualTiendaNubeEmission;
        data["isManualMercadoLibreEmission"] = this.isManualMercadoLibreEmission;
        data["isTiendaNube"] = this.isTiendaNube;
        data["isMercadoLibre"] = this.isMercadoLibre;
        data["ecommerceSource"] = this.ecommerceSource;
        data["externalId"] = this.externalId;
        data["orderId"] = this.orderId;
        data["requiresCreditNote"] = this.requiresCreditNote;
        return data;
    }

    clone(): InvoiceDto {
        const json = this.toJSON();
        let result = new InvoiceDto();
        result.init(json);
        return result;
    }
}

export interface IInvoiceDto {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    tenantId: number | undefined;
    number: string | undefined;
    total: number;
    totalWithDiscountAndSurchages: number;
    totalWithTaxes: number;
    amountIva: number;
    amountIibb: number;
    internalTaxes: number;
    bankPromotionDiscountPercentage: number;
    quote: number;
    invoiceId: number | undefined;
    userId: number;
    totalOfDiscount: number;
    totalOfSurchages: number;
    totalPayment: number;
    totalWithoutPromotions: number;
    totalPromotions: number;
    canceled: boolean;
    isFiscalController: boolean;
    useNoFiscal: boolean;
    invoiceFormType: InvoiceFormType;
    invoiceFormTypeName: string | undefined;
    letterType: LetterType;
    letterTypeName: string | undefined;
    printerType: PrinterType;
    salePointId: number | undefined;
    salePointPrefix: string | undefined;
    salePointDescription: string | undefined;
    salePointType: TypeSalePoint;
    salePointTypeName: string | undefined;
    clientId: number | undefined;
    clientFullName: string | undefined;
    clientName: string | undefined;
    clientTaxNumber: string | undefined;
    clientIdentification: string | undefined;
    clientAddress: string | undefined;
    clientUseGrossIncome: boolean;
    clientGrossIncomeAmount: number;
    clientTaxCondition: TaxConditionType;
    clientTaxConditionName: string | undefined;
    clientFullNameInvoice: string | undefined;
    clientIsStatic: boolean;
    vendorId: number | undefined;
    vendorFullName: string | undefined;
    currencyId: number;
    reservationId: number;
    draft: boolean;
    voucherCreatedCode: string | undefined;
    voucherCreatedAmount: number;
    voucherCreatedCreationTime: moment.Moment;
    voucherCreatedExpireDate: moment.Moment | undefined;
    bin: number | undefined;
    voucherCreatedId: number | undefined;
    voucherUsedId: number | undefined;
    ticketByProduct: boolean;
    ticketByInvoice: boolean;
    voucherByMail: boolean;
    emailForTicket: string | undefined;
    ticketUse: boolean;
    ticketCode: string | undefined;
    isCreditNote: boolean;
    amountBankPromotion: number;
    invoiceProductUsed: { [key: string]: number; } | undefined;
    listProducts: InvoiceProductDto[] | undefined;
    listTransactions: TransactionDto[] | undefined;
    listDiscounts: number[] | undefined;
    draftHasExpiredPromotions: boolean;
    draftHasExpiredDiscounts: boolean;
    reservationParentId: number | undefined;
    totalReservation: number;
    voucherUsedAmount: number;
    voucherUsedAmountRemain: number;
    isCreditNoteFromChange: boolean;
    typeRespEmisor: number;
    cashierId: number | undefined;
    cahsierCodeCancelReservation: string | undefined;
    listPromotions: number[] | undefined;
    listPromotionsData: PromotionInvoiceDto[] | undefined;
    isReadonly: boolean;
    isBankPromotionNC: boolean;
    invoiceData: InvoiceDataModel;
    cae: string | undefined;
    expirationDateCAE: moment.Moment | undefined;
    urlQrCodeAfip: string | undefined;
    ticketCodeAfip: string | undefined;
    isChange: boolean;
    priceListId: number | undefined;
    remain: number;
    cashBack: number;
    description: string | undefined;
    invoiceDiscountDetails: InvoiceDiscountDetailsDto[] | undefined;
    isReservationNC: boolean;
    promotionAppliedNames: string | undefined;
    isReservationClosure: boolean;
    autoserviceCode: string | undefined;
    invoiceDiscountPercent: number;
    changePolicyText: string | undefined;
    isLoadingDataForCreditNote: boolean;
    isBankPromotionFC: boolean;
    isJumpInvoice: boolean;
    isPossibleJump: boolean;
    possibleNumberJump: string | undefined;
    mustRetry: boolean;
    isManualTiendaNubeEmission: boolean;
    isManualMercadoLibreEmission: boolean;
    isTiendaNube: boolean;
    isMercadoLibre: boolean;
    ecommerceSource: string | undefined;
    externalId: number | undefined;
    orderId: number | undefined;
    requiresCreditNote: boolean;
}

export class InvoiceDtoPagedResultDto implements IInvoiceDtoPagedResultDto {
    items: InvoiceDto[] | undefined;
    totalCount: number;

    constructor(data?: IInvoiceDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(InvoiceDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): InvoiceDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new InvoiceDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): InvoiceDtoPagedResultDto {
        const json = this.toJSON();
        let result = new InvoiceDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IInvoiceDtoPagedResultDto {
    items: InvoiceDto[] | undefined;
    totalCount: number;
}

export enum InvoiceFormType {
    Invoice = <any>"Invoice",
    CreditNote = <any>"CreditNote",
    Reservation = <any>"Reservation",
    DeliveryNote = <any>"DeliveryNote",
    StockAjust = <any>"StockAjust",
    NoFiscal = <any>"NoFiscal",
    ChangeTicket = <any>"ChangeTicket",
    All = <any>"All",
}

export class InvoiceIdDto implements IInvoiceIdDto {
    id: number;
    clientFullName: string | undefined;

    constructor(data?: IInvoiceIdDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.clientFullName = _data["clientFullName"];
        }
    }

    static fromJS(data: any): InvoiceIdDto {
        data = typeof data === 'object' ? data : {};
        let result = new InvoiceIdDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["clientFullName"] = this.clientFullName;
        return data;
    }

    clone(): InvoiceIdDto {
        const json = this.toJSON();
        let result = new InvoiceIdDto();
        result.init(json);
        return result;
    }
}

export interface IInvoiceIdDto {
    id: number;
    clientFullName: string | undefined;
}

export class InvoiceInfoDto implements IInvoiceInfoDto {
    id: number;
    number: string | undefined;
    creationTime: moment.Moment;
    totalWithTaxes: number;
    clientId: number | undefined;
    clientName: string | undefined;
    clientLastName: string | undefined;
    draft: boolean;
    invoiceFormType: InvoiceFormType;
    readonly invoiceFormTypeName: string | undefined;
    letterType: LetterType;
    readonly letterTypeName: string | undefined;
    invoiceData: InvoiceDataModel;

    constructor(data?: IInvoiceInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.number = _data["number"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.totalWithTaxes = _data["totalWithTaxes"];
            this.clientId = _data["clientId"];
            this.clientName = _data["clientName"];
            this.clientLastName = _data["clientLastName"];
            this.draft = _data["draft"];
            this.invoiceFormType = _data["invoiceFormType"];
            (<any>this).invoiceFormTypeName = _data["invoiceFormTypeName"];
            this.letterType = _data["letterType"];
            (<any>this).letterTypeName = _data["letterTypeName"];
            this.invoiceData = _data["invoiceData"] ? InvoiceDataModel.fromJS(_data["invoiceData"]) : <any>undefined;
        }
    }

    static fromJS(data: any): InvoiceInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new InvoiceInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["number"] = this.number;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["totalWithTaxes"] = this.totalWithTaxes;
        data["clientId"] = this.clientId;
        data["clientName"] = this.clientName;
        data["clientLastName"] = this.clientLastName;
        data["draft"] = this.draft;
        data["invoiceFormType"] = this.invoiceFormType;
        data["invoiceFormTypeName"] = this.invoiceFormTypeName;
        data["letterType"] = this.letterType;
        data["letterTypeName"] = this.letterTypeName;
        data["invoiceData"] = this.invoiceData ? this.invoiceData.toJSON() : <any>undefined;
        return data;
    }

    clone(): InvoiceInfoDto {
        const json = this.toJSON();
        let result = new InvoiceInfoDto();
        result.init(json);
        return result;
    }
}

export interface IInvoiceInfoDto {
    id: number;
    number: string | undefined;
    creationTime: moment.Moment;
    totalWithTaxes: number;
    clientId: number | undefined;
    clientName: string | undefined;
    clientLastName: string | undefined;
    draft: boolean;
    invoiceFormType: InvoiceFormType;
    invoiceFormTypeName: string | undefined;
    letterType: LetterType;
    letterTypeName: string | undefined;
    invoiceData: InvoiceDataModel;
}

export class InvoiceJumpDto implements IInvoiceJumpDto {
    salePointId: number;
    currentNumber: string | undefined;
    previousNumber: string | undefined;
    difference: number;

    constructor(data?: IInvoiceJumpDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.salePointId = _data["salePointId"];
            this.currentNumber = _data["currentNumber"];
            this.previousNumber = _data["previousNumber"];
            this.difference = _data["difference"];
        }
    }

    static fromJS(data: any): InvoiceJumpDto {
        data = typeof data === 'object' ? data : {};
        let result = new InvoiceJumpDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["salePointId"] = this.salePointId;
        data["currentNumber"] = this.currentNumber;
        data["previousNumber"] = this.previousNumber;
        data["difference"] = this.difference;
        return data;
    }

    clone(): InvoiceJumpDto {
        const json = this.toJSON();
        let result = new InvoiceJumpDto();
        result.init(json);
        return result;
    }
}

export interface IInvoiceJumpDto {
    salePointId: number;
    currentNumber: string | undefined;
    previousNumber: string | undefined;
    difference: number;
}

export class InvoiceLetterAndNumberDto implements IInvoiceLetterAndNumberDto {
    id: number;
    value: string | undefined;
    nextNumber: string | undefined;

    constructor(data?: IInvoiceLetterAndNumberDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.value = _data["value"];
            this.nextNumber = _data["nextNumber"];
        }
    }

    static fromJS(data: any): InvoiceLetterAndNumberDto {
        data = typeof data === 'object' ? data : {};
        let result = new InvoiceLetterAndNumberDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["value"] = this.value;
        data["nextNumber"] = this.nextNumber;
        return data;
    }

    clone(): InvoiceLetterAndNumberDto {
        const json = this.toJSON();
        let result = new InvoiceLetterAndNumberDto();
        result.init(json);
        return result;
    }
}

export interface IInvoiceLetterAndNumberDto {
    id: number;
    value: string | undefined;
    nextNumber: string | undefined;
}

export class InvoiceListDto implements IInvoiceListDto {
    id: number;
    creationTime: moment.Moment;
    number: string | undefined;
    salePointType: TypeSalePoint;
    readonly salePointTypeName: string | undefined;
    salePointPrefix: string | undefined;
    clientFullName: string | undefined;
    invoiceFormType: InvoiceFormType;
    readonly invoiceFormTypeName: string | undefined;
    letterType: LetterType;
    readonly letterTypeName: string | undefined;
    totalWithTaxes: number;
    draft: boolean;
    mustRetry: boolean;
    isManualTiendaNubeEmission: boolean;
    isManualMercadoLibreEmission: boolean;
    isTiendaNube: boolean;
    isMercadoLibre: boolean;
    ecommerceSource: string | undefined;
    externalId: number | undefined;
    orderId: number | undefined;

    constructor(data?: IInvoiceListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.number = _data["number"];
            this.salePointType = _data["salePointType"];
            (<any>this).salePointTypeName = _data["salePointTypeName"];
            this.salePointPrefix = _data["salePointPrefix"];
            this.clientFullName = _data["clientFullName"];
            this.invoiceFormType = _data["invoiceFormType"];
            (<any>this).invoiceFormTypeName = _data["invoiceFormTypeName"];
            this.letterType = _data["letterType"];
            (<any>this).letterTypeName = _data["letterTypeName"];
            this.totalWithTaxes = _data["totalWithTaxes"];
            this.draft = _data["draft"];
            this.mustRetry = _data["mustRetry"];
            this.isManualTiendaNubeEmission = _data["isManualTiendaNubeEmission"];
            this.isManualMercadoLibreEmission = _data["isManualMercadoLibreEmission"];
            this.isTiendaNube = _data["isTiendaNube"];
            this.isMercadoLibre = _data["isMercadoLibre"];
            this.ecommerceSource = _data["ecommerceSource"];
            this.externalId = _data["externalId"];
            this.orderId = _data["orderId"];
        }
    }

    static fromJS(data: any): InvoiceListDto {
        data = typeof data === 'object' ? data : {};
        let result = new InvoiceListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["number"] = this.number;
        data["salePointType"] = this.salePointType;
        data["salePointTypeName"] = this.salePointTypeName;
        data["salePointPrefix"] = this.salePointPrefix;
        data["clientFullName"] = this.clientFullName;
        data["invoiceFormType"] = this.invoiceFormType;
        data["invoiceFormTypeName"] = this.invoiceFormTypeName;
        data["letterType"] = this.letterType;
        data["letterTypeName"] = this.letterTypeName;
        data["totalWithTaxes"] = this.totalWithTaxes;
        data["draft"] = this.draft;
        data["mustRetry"] = this.mustRetry;
        data["isManualTiendaNubeEmission"] = this.isManualTiendaNubeEmission;
        data["isManualMercadoLibreEmission"] = this.isManualMercadoLibreEmission;
        data["isTiendaNube"] = this.isTiendaNube;
        data["isMercadoLibre"] = this.isMercadoLibre;
        data["ecommerceSource"] = this.ecommerceSource;
        data["externalId"] = this.externalId;
        data["orderId"] = this.orderId;
        return data;
    }

    clone(): InvoiceListDto {
        const json = this.toJSON();
        let result = new InvoiceListDto();
        result.init(json);
        return result;
    }
}

export interface IInvoiceListDto {
    id: number;
    creationTime: moment.Moment;
    number: string | undefined;
    salePointType: TypeSalePoint;
    salePointTypeName: string | undefined;
    salePointPrefix: string | undefined;
    clientFullName: string | undefined;
    invoiceFormType: InvoiceFormType;
    invoiceFormTypeName: string | undefined;
    letterType: LetterType;
    letterTypeName: string | undefined;
    totalWithTaxes: number;
    draft: boolean;
    mustRetry: boolean;
    isManualTiendaNubeEmission: boolean;
    isManualMercadoLibreEmission: boolean;
    isTiendaNube: boolean;
    isMercadoLibre: boolean;
    ecommerceSource: string | undefined;
    externalId: number | undefined;
    orderId: number | undefined;
}

export class InvoiceListDtoPagedResultDto implements IInvoiceListDtoPagedResultDto {
    items: InvoiceListDto[] | undefined;
    totalCount: number;

    constructor(data?: IInvoiceListDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(InvoiceListDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): InvoiceListDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new InvoiceListDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): InvoiceListDtoPagedResultDto {
        const json = this.toJSON();
        let result = new InvoiceListDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IInvoiceListDtoPagedResultDto {
    items: InvoiceListDto[] | undefined;
    totalCount: number;
}

export class InvoiceProduct implements IInvoiceProduct {
    id: number;
    tenantId: number | undefined;
    isDeleted: boolean;
    name: string | undefined;
    count: number;
    discount: number;
    iva: number;
    price: number;
    productId: number;
    product: Product;
    variantId: number | undefined;
    variant: Variant;
    invoiceId: number;
    invoice: Invoice;
    voucherId: number | undefined;
    voucher: Voucher;
    discountInvoices: DiscountInvoice[] | undefined;

    constructor(data?: IInvoiceProduct) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tenantId = _data["tenantId"];
            this.isDeleted = _data["isDeleted"];
            this.name = _data["name"];
            this.count = _data["count"];
            this.discount = _data["discount"];
            this.iva = _data["iva"];
            this.price = _data["price"];
            this.productId = _data["productId"];
            this.product = _data["product"] ? Product.fromJS(_data["product"]) : <any>undefined;
            this.variantId = _data["variantId"];
            this.variant = _data["variant"] ? Variant.fromJS(_data["variant"]) : <any>undefined;
            this.invoiceId = _data["invoiceId"];
            this.invoice = _data["invoice"] ? Invoice.fromJS(_data["invoice"]) : <any>undefined;
            this.voucherId = _data["voucherId"];
            this.voucher = _data["voucher"] ? Voucher.fromJS(_data["voucher"]) : <any>undefined;
            if (Array.isArray(_data["discountInvoices"])) {
                this.discountInvoices = [] as any;
                for (let item of _data["discountInvoices"])
                    this.discountInvoices.push(DiscountInvoice.fromJS(item));
            }
        }
    }

    static fromJS(data: any): InvoiceProduct {
        data = typeof data === 'object' ? data : {};
        let result = new InvoiceProduct();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tenantId"] = this.tenantId;
        data["isDeleted"] = this.isDeleted;
        data["name"] = this.name;
        data["count"] = this.count;
        data["discount"] = this.discount;
        data["iva"] = this.iva;
        data["price"] = this.price;
        data["productId"] = this.productId;
        data["product"] = this.product ? this.product.toJSON() : <any>undefined;
        data["variantId"] = this.variantId;
        data["variant"] = this.variant ? this.variant.toJSON() : <any>undefined;
        data["invoiceId"] = this.invoiceId;
        data["invoice"] = this.invoice ? this.invoice.toJSON() : <any>undefined;
        data["voucherId"] = this.voucherId;
        data["voucher"] = this.voucher ? this.voucher.toJSON() : <any>undefined;
        if (Array.isArray(this.discountInvoices)) {
            data["discountInvoices"] = [];
            for (let item of this.discountInvoices)
                data["discountInvoices"].push(item.toJSON());
        }
        return data;
    }

    clone(): InvoiceProduct {
        const json = this.toJSON();
        let result = new InvoiceProduct();
        result.init(json);
        return result;
    }
}

export interface IInvoiceProduct {
    id: number;
    tenantId: number | undefined;
    isDeleted: boolean;
    name: string | undefined;
    count: number;
    discount: number;
    iva: number;
    price: number;
    productId: number;
    product: Product;
    variantId: number | undefined;
    variant: Variant;
    invoiceId: number;
    invoice: Invoice;
    voucherId: number | undefined;
    voucher: Voucher;
    discountInvoices: DiscountInvoice[] | undefined;
}

export class InvoiceProductDto implements IInvoiceProductDto {
    name: string | undefined;
    count: number;
    discount: number;
    iva: number;
    price: number;
    basePrice: number;
    productId: number;
    productName: string | undefined;
    productCode: string | undefined;
    description: string | undefined;
    variantId: number | undefined;
    colorId: number;
    colorName: string | undefined;
    sizeId: number;
    sizeName: string | undefined;
    voucherId: number | undefined;
    voucherCode: string | undefined;
    voucherCreatedCreationTime: moment.Moment;
    voucherCreatedExpireDate: moment.Moment | undefined;
    stock: number;
    listDiscounts: number[] | undefined;
    discountAmount: number;
    discountPercent: number;
    promotionAmount: number;
    promotionPercent: number;
    combinedPromotionAmount: number;
    promotionDescription: string | undefined;
    listPromotionsIcons: string[] | undefined;
    invoiceId: number;
    gtin: string | undefined;
    externalId: number | undefined;
    isTransitProduct: boolean;
    hasDecimalQuantity: boolean;
    hasPromotionInOriginalInvoice: boolean;
    difference: number;
    isGeneric: boolean;
    listPromotionData: PromotionProductDto[] | undefined;
    priceListId: number | undefined;

    constructor(data?: IInvoiceProductDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.count = _data["count"];
            this.discount = _data["discount"];
            this.iva = _data["iva"];
            this.price = _data["price"];
            this.basePrice = _data["basePrice"];
            this.productId = _data["productId"];
            this.productName = _data["productName"];
            this.productCode = _data["productCode"];
            this.description = _data["description"];
            this.variantId = _data["variantId"];
            this.colorId = _data["colorId"];
            this.colorName = _data["colorName"];
            this.sizeId = _data["sizeId"];
            this.sizeName = _data["sizeName"];
            this.voucherId = _data["voucherId"];
            this.voucherCode = _data["voucherCode"];
            this.voucherCreatedCreationTime = _data["voucherCreatedCreationTime"] ? moment(_data["voucherCreatedCreationTime"].toString()) : <any>undefined;
            this.voucherCreatedExpireDate = _data["voucherCreatedExpireDate"] ? moment(_data["voucherCreatedExpireDate"].toString()) : <any>undefined;
            this.stock = _data["stock"];
            if (Array.isArray(_data["listDiscounts"])) {
                this.listDiscounts = [] as any;
                for (let item of _data["listDiscounts"])
                    this.listDiscounts.push(item);
            }
            this.discountAmount = _data["discountAmount"];
            this.discountPercent = _data["discountPercent"];
            this.promotionAmount = _data["promotionAmount"];
            this.promotionPercent = _data["promotionPercent"];
            this.combinedPromotionAmount = _data["combinedPromotionAmount"];
            this.promotionDescription = _data["promotionDescription"];
            if (Array.isArray(_data["listPromotionsIcons"])) {
                this.listPromotionsIcons = [] as any;
                for (let item of _data["listPromotionsIcons"])
                    this.listPromotionsIcons.push(item);
            }
            this.invoiceId = _data["invoiceId"];
            this.gtin = _data["gtin"];
            this.externalId = _data["externalId"];
            this.isTransitProduct = _data["isTransitProduct"];
            this.hasDecimalQuantity = _data["hasDecimalQuantity"];
            this.hasPromotionInOriginalInvoice = _data["hasPromotionInOriginalInvoice"];
            this.difference = _data["difference"];
            this.isGeneric = _data["isGeneric"];
            if (Array.isArray(_data["listPromotionData"])) {
                this.listPromotionData = [] as any;
                for (let item of _data["listPromotionData"])
                    this.listPromotionData.push(PromotionProductDto.fromJS(item));
            }
            this.priceListId = _data["priceListId"];
        }
    }

    static fromJS(data: any): InvoiceProductDto {
        data = typeof data === 'object' ? data : {};
        let result = new InvoiceProductDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["count"] = this.count;
        data["discount"] = this.discount;
        data["iva"] = this.iva;
        data["price"] = this.price;
        data["basePrice"] = this.basePrice;
        data["productId"] = this.productId;
        data["productName"] = this.productName;
        data["productCode"] = this.productCode;
        data["description"] = this.description;
        data["variantId"] = this.variantId;
        data["colorId"] = this.colorId;
        data["colorName"] = this.colorName;
        data["sizeId"] = this.sizeId;
        data["sizeName"] = this.sizeName;
        data["voucherId"] = this.voucherId;
        data["voucherCode"] = this.voucherCode;
        data["voucherCreatedCreationTime"] = this.voucherCreatedCreationTime ? this.voucherCreatedCreationTime.toISOString() : <any>undefined;
        data["voucherCreatedExpireDate"] = this.voucherCreatedExpireDate ? this.voucherCreatedExpireDate.toISOString() : <any>undefined;
        data["stock"] = this.stock;
        if (Array.isArray(this.listDiscounts)) {
            data["listDiscounts"] = [];
            for (let item of this.listDiscounts)
                data["listDiscounts"].push(item);
        }
        data["discountAmount"] = this.discountAmount;
        data["discountPercent"] = this.discountPercent;
        data["promotionAmount"] = this.promotionAmount;
        data["promotionPercent"] = this.promotionPercent;
        data["combinedPromotionAmount"] = this.combinedPromotionAmount;
        data["promotionDescription"] = this.promotionDescription;
        if (Array.isArray(this.listPromotionsIcons)) {
            data["listPromotionsIcons"] = [];
            for (let item of this.listPromotionsIcons)
                data["listPromotionsIcons"].push(item);
        }
        data["invoiceId"] = this.invoiceId;
        data["gtin"] = this.gtin;
        data["externalId"] = this.externalId;
        data["isTransitProduct"] = this.isTransitProduct;
        data["hasDecimalQuantity"] = this.hasDecimalQuantity;
        data["hasPromotionInOriginalInvoice"] = this.hasPromotionInOriginalInvoice;
        data["difference"] = this.difference;
        data["isGeneric"] = this.isGeneric;
        if (Array.isArray(this.listPromotionData)) {
            data["listPromotionData"] = [];
            for (let item of this.listPromotionData)
                data["listPromotionData"].push(item.toJSON());
        }
        data["priceListId"] = this.priceListId;
        return data;
    }

    clone(): InvoiceProductDto {
        const json = this.toJSON();
        let result = new InvoiceProductDto();
        result.init(json);
        return result;
    }
}

export interface IInvoiceProductDto {
    name: string | undefined;
    count: number;
    discount: number;
    iva: number;
    price: number;
    basePrice: number;
    productId: number;
    productName: string | undefined;
    productCode: string | undefined;
    description: string | undefined;
    variantId: number | undefined;
    colorId: number;
    colorName: string | undefined;
    sizeId: number;
    sizeName: string | undefined;
    voucherId: number | undefined;
    voucherCode: string | undefined;
    voucherCreatedCreationTime: moment.Moment;
    voucherCreatedExpireDate: moment.Moment | undefined;
    stock: number;
    listDiscounts: number[] | undefined;
    discountAmount: number;
    discountPercent: number;
    promotionAmount: number;
    promotionPercent: number;
    combinedPromotionAmount: number;
    promotionDescription: string | undefined;
    listPromotionsIcons: string[] | undefined;
    invoiceId: number;
    gtin: string | undefined;
    externalId: number | undefined;
    isTransitProduct: boolean;
    hasDecimalQuantity: boolean;
    hasPromotionInOriginalInvoice: boolean;
    difference: number;
    isGeneric: boolean;
    listPromotionData: PromotionProductDto[] | undefined;
    priceListId: number | undefined;
}

export class InvoiceProductIdDto implements IInvoiceProductIdDto {
    invoiceId: number;

    constructor(data?: IInvoiceProductIdDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.invoiceId = _data["invoiceId"];
        }
    }

    static fromJS(data: any): InvoiceProductIdDto {
        data = typeof data === 'object' ? data : {};
        let result = new InvoiceProductIdDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["invoiceId"] = this.invoiceId;
        return data;
    }

    clone(): InvoiceProductIdDto {
        const json = this.toJSON();
        let result = new InvoiceProductIdDto();
        result.init(json);
        return result;
    }
}

export interface IInvoiceProductIdDto {
    invoiceId: number;
}

export class InvoiceProductModel implements IInvoiceProductModel {
    name: string | undefined;
    productCode: string | undefined;
    description: string | undefined;
    count: number;
    discount: number;
    discountAmount: number;
    discountPercent: number;
    iva: number;
    price: number;
    basePrice: number;
    productId: number;
    productName: string | undefined;
    variantId: number | undefined;
    colorId: number;
    colorName: string | undefined;
    sizeId: number;
    sizeName: string | undefined;
    stock: number;
    listDiscounts: number[] | undefined;
    listPromotionsIcons: string[] | undefined;
    hasPromotionInOriginalInvoice: boolean;
    promotionAmount: number;
    promotionPercent: number;
    promotionDescription: string | undefined;
    listPromotionData: ProductPromotionModel[] | undefined;
    voucherId: number | undefined;
    priceListId: number | undefined;

    constructor(data?: IInvoiceProductModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.productCode = _data["productCode"];
            this.description = _data["description"];
            this.count = _data["count"];
            this.discount = _data["discount"];
            this.discountAmount = _data["discountAmount"];
            this.discountPercent = _data["discountPercent"];
            this.iva = _data["iva"];
            this.price = _data["price"];
            this.basePrice = _data["basePrice"];
            this.productId = _data["productId"];
            this.productName = _data["productName"];
            this.variantId = _data["variantId"];
            this.colorId = _data["colorId"];
            this.colorName = _data["colorName"];
            this.sizeId = _data["sizeId"];
            this.sizeName = _data["sizeName"];
            this.stock = _data["stock"];
            if (Array.isArray(_data["listDiscounts"])) {
                this.listDiscounts = [] as any;
                for (let item of _data["listDiscounts"])
                    this.listDiscounts.push(item);
            }
            if (Array.isArray(_data["listPromotionsIcons"])) {
                this.listPromotionsIcons = [] as any;
                for (let item of _data["listPromotionsIcons"])
                    this.listPromotionsIcons.push(item);
            }
            this.hasPromotionInOriginalInvoice = _data["hasPromotionInOriginalInvoice"];
            this.promotionAmount = _data["promotionAmount"];
            this.promotionPercent = _data["promotionPercent"];
            this.promotionDescription = _data["promotionDescription"];
            if (Array.isArray(_data["listPromotionData"])) {
                this.listPromotionData = [] as any;
                for (let item of _data["listPromotionData"])
                    this.listPromotionData.push(ProductPromotionModel.fromJS(item));
            }
            this.voucherId = _data["voucherId"];
            this.priceListId = _data["priceListId"];
        }
    }

    static fromJS(data: any): InvoiceProductModel {
        data = typeof data === 'object' ? data : {};
        let result = new InvoiceProductModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["productCode"] = this.productCode;
        data["description"] = this.description;
        data["count"] = this.count;
        data["discount"] = this.discount;
        data["discountAmount"] = this.discountAmount;
        data["discountPercent"] = this.discountPercent;
        data["iva"] = this.iva;
        data["price"] = this.price;
        data["basePrice"] = this.basePrice;
        data["productId"] = this.productId;
        data["productName"] = this.productName;
        data["variantId"] = this.variantId;
        data["colorId"] = this.colorId;
        data["colorName"] = this.colorName;
        data["sizeId"] = this.sizeId;
        data["sizeName"] = this.sizeName;
        data["stock"] = this.stock;
        if (Array.isArray(this.listDiscounts)) {
            data["listDiscounts"] = [];
            for (let item of this.listDiscounts)
                data["listDiscounts"].push(item);
        }
        if (Array.isArray(this.listPromotionsIcons)) {
            data["listPromotionsIcons"] = [];
            for (let item of this.listPromotionsIcons)
                data["listPromotionsIcons"].push(item);
        }
        data["hasPromotionInOriginalInvoice"] = this.hasPromotionInOriginalInvoice;
        data["promotionAmount"] = this.promotionAmount;
        data["promotionPercent"] = this.promotionPercent;
        data["promotionDescription"] = this.promotionDescription;
        if (Array.isArray(this.listPromotionData)) {
            data["listPromotionData"] = [];
            for (let item of this.listPromotionData)
                data["listPromotionData"].push(item.toJSON());
        }
        data["voucherId"] = this.voucherId;
        data["priceListId"] = this.priceListId;
        return data;
    }

    clone(): InvoiceProductModel {
        const json = this.toJSON();
        let result = new InvoiceProductModel();
        result.init(json);
        return result;
    }
}

export interface IInvoiceProductModel {
    name: string | undefined;
    productCode: string | undefined;
    description: string | undefined;
    count: number;
    discount: number;
    discountAmount: number;
    discountPercent: number;
    iva: number;
    price: number;
    basePrice: number;
    productId: number;
    productName: string | undefined;
    variantId: number | undefined;
    colorId: number;
    colorName: string | undefined;
    sizeId: number;
    sizeName: string | undefined;
    stock: number;
    listDiscounts: number[] | undefined;
    listPromotionsIcons: string[] | undefined;
    hasPromotionInOriginalInvoice: boolean;
    promotionAmount: number;
    promotionPercent: number;
    promotionDescription: string | undefined;
    listPromotionData: ProductPromotionModel[] | undefined;
    voucherId: number | undefined;
    priceListId: number | undefined;
}

export class InvoicePromotionModel implements IInvoicePromotionModel {
    tenantId: number | undefined;
    id: number;
    name: string | undefined;
    description: string | undefined;
    amount: number;
    dateInit: string | undefined;
    dateEnd: string | undefined;
    promotionType: PromotionType;
    readonly promotionTypeName: string | undefined;
    bankId: number;
    bankName: string | undefined;
    companyId: number;
    companyName: string | undefined;
    totalWithPromotionDiscount: number;
    totalAmount: number;
    appliedOnDetails: boolean;

    constructor(data?: IInvoicePromotionModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.amount = _data["amount"];
            this.dateInit = _data["dateInit"];
            this.dateEnd = _data["dateEnd"];
            this.promotionType = _data["promotionType"];
            (<any>this).promotionTypeName = _data["promotionTypeName"];
            this.bankId = _data["bankId"];
            this.bankName = _data["bankName"];
            this.companyId = _data["companyId"];
            this.companyName = _data["companyName"];
            this.totalWithPromotionDiscount = _data["totalWithPromotionDiscount"];
            this.totalAmount = _data["totalAmount"];
            this.appliedOnDetails = _data["appliedOnDetails"];
        }
    }

    static fromJS(data: any): InvoicePromotionModel {
        data = typeof data === 'object' ? data : {};
        let result = new InvoicePromotionModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["amount"] = this.amount;
        data["dateInit"] = this.dateInit;
        data["dateEnd"] = this.dateEnd;
        data["promotionType"] = this.promotionType;
        data["promotionTypeName"] = this.promotionTypeName;
        data["bankId"] = this.bankId;
        data["bankName"] = this.bankName;
        data["companyId"] = this.companyId;
        data["companyName"] = this.companyName;
        data["totalWithPromotionDiscount"] = this.totalWithPromotionDiscount;
        data["totalAmount"] = this.totalAmount;
        data["appliedOnDetails"] = this.appliedOnDetails;
        return data;
    }

    clone(): InvoicePromotionModel {
        const json = this.toJSON();
        let result = new InvoicePromotionModel();
        result.init(json);
        return result;
    }
}

export interface IInvoicePromotionModel {
    tenantId: number | undefined;
    id: number;
    name: string | undefined;
    description: string | undefined;
    amount: number;
    dateInit: string | undefined;
    dateEnd: string | undefined;
    promotionType: PromotionType;
    promotionTypeName: string | undefined;
    bankId: number;
    bankName: string | undefined;
    companyId: number;
    companyName: string | undefined;
    totalWithPromotionDiscount: number;
    totalAmount: number;
    appliedOnDetails: boolean;
}

export class InvoiceReportDto implements IInvoiceReportDto {
    id: number;
    tenantId: number | undefined;
    invoiceData: InvoiceDataModel;
    isReportProcessed: boolean;

    constructor(data?: IInvoiceReportDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tenantId = _data["tenantId"];
            this.invoiceData = _data["invoiceData"] ? InvoiceDataModel.fromJS(_data["invoiceData"]) : <any>undefined;
            this.isReportProcessed = _data["isReportProcessed"];
        }
    }

    static fromJS(data: any): InvoiceReportDto {
        data = typeof data === 'object' ? data : {};
        let result = new InvoiceReportDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tenantId"] = this.tenantId;
        data["invoiceData"] = this.invoiceData ? this.invoiceData.toJSON() : <any>undefined;
        data["isReportProcessed"] = this.isReportProcessed;
        return data;
    }

    clone(): InvoiceReportDto {
        const json = this.toJSON();
        let result = new InvoiceReportDto();
        result.init(json);
        return result;
    }
}

export interface IInvoiceReportDto {
    id: number;
    tenantId: number | undefined;
    invoiceData: InvoiceDataModel;
    isReportProcessed: boolean;
}

export class InvoiceReportFilterDto implements IInvoiceReportFilterDto {
    from: moment.Moment | undefined;
    to: moment.Moment | undefined;
    skip: number;
    quantity: number;
    tenantId: number | undefined;
    processedReport: boolean;
    isReservationClosure: boolean;

    constructor(data?: IInvoiceReportFilterDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.from = _data["from"] ? moment(_data["from"].toString()) : <any>undefined;
            this.to = _data["to"] ? moment(_data["to"].toString()) : <any>undefined;
            this.skip = _data["skip"];
            this.quantity = _data["quantity"];
            this.tenantId = _data["tenantId"];
            this.processedReport = _data["processedReport"];
            this.isReservationClosure = _data["isReservationClosure"];
        }
    }

    static fromJS(data: any): InvoiceReportFilterDto {
        data = typeof data === 'object' ? data : {};
        let result = new InvoiceReportFilterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["from"] = this.from ? this.from.toISOString() : <any>undefined;
        data["to"] = this.to ? this.to.toISOString() : <any>undefined;
        data["skip"] = this.skip;
        data["quantity"] = this.quantity;
        data["tenantId"] = this.tenantId;
        data["processedReport"] = this.processedReport;
        data["isReservationClosure"] = this.isReservationClosure;
        return data;
    }

    clone(): InvoiceReportFilterDto {
        const json = this.toJSON();
        let result = new InvoiceReportFilterDto();
        result.init(json);
        return result;
    }
}

export interface IInvoiceReportFilterDto {
    from: moment.Moment | undefined;
    to: moment.Moment | undefined;
    skip: number;
    quantity: number;
    tenantId: number | undefined;
    processedReport: boolean;
    isReservationClosure: boolean;
}

export class IrsaCredentialsDto implements IIrsaCredentialsDto {
    siTefIp: string | undefined;
    cuitIsv: string | undefined;
    certificateId: string | undefined;

    constructor(data?: IIrsaCredentialsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.siTefIp = _data["siTefIp"];
            this.cuitIsv = _data["cuitIsv"];
            this.certificateId = _data["certificateId"];
        }
    }

    static fromJS(data: any): IrsaCredentialsDto {
        data = typeof data === 'object' ? data : {};
        let result = new IrsaCredentialsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["siTefIp"] = this.siTefIp;
        data["cuitIsv"] = this.cuitIsv;
        data["certificateId"] = this.certificateId;
        return data;
    }

    clone(): IrsaCredentialsDto {
        const json = this.toJSON();
        let result = new IrsaCredentialsDto();
        result.init(json);
        return result;
    }
}

export interface IIrsaCredentialsDto {
    siTefIp: string | undefined;
    cuitIsv: string | undefined;
    certificateId: string | undefined;
}

export class IrsaProcessDto implements IIrsaProcessDto {
    id: number;
    creationTime: moment.Moment;
    invoiceId: number;
    invoiceNumber: string | undefined;
    invoiceTotal: number;

    constructor(data?: IIrsaProcessDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.invoiceId = _data["invoiceId"];
            this.invoiceNumber = _data["invoiceNumber"];
            this.invoiceTotal = _data["invoiceTotal"];
        }
    }

    static fromJS(data: any): IrsaProcessDto {
        data = typeof data === 'object' ? data : {};
        let result = new IrsaProcessDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["invoiceId"] = this.invoiceId;
        data["invoiceNumber"] = this.invoiceNumber;
        data["invoiceTotal"] = this.invoiceTotal;
        return data;
    }

    clone(): IrsaProcessDto {
        const json = this.toJSON();
        let result = new IrsaProcessDto();
        result.init(json);
        return result;
    }
}

export interface IIrsaProcessDto {
    id: number;
    creationTime: moment.Moment;
    invoiceId: number;
    invoiceNumber: string | undefined;
    invoiceTotal: number;
}

export class IrsaProcessDtoPagedResultDto implements IIrsaProcessDtoPagedResultDto {
    items: IrsaProcessDto[] | undefined;
    totalCount: number;

    constructor(data?: IIrsaProcessDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(IrsaProcessDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): IrsaProcessDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new IrsaProcessDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): IrsaProcessDtoPagedResultDto {
        const json = this.toJSON();
        let result = new IrsaProcessDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IIrsaProcessDtoPagedResultDto {
    items: IrsaProcessDto[] | undefined;
    totalCount: number;
}

export class IsTenantAvailableInput implements IIsTenantAvailableInput {
    tenancyName: string;

    constructor(data?: IIsTenantAvailableInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenancyName = _data["tenancyName"];
        }
    }

    static fromJS(data: any): IsTenantAvailableInput {
        data = typeof data === 'object' ? data : {};
        let result = new IsTenantAvailableInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        return data;
    }

    clone(): IsTenantAvailableInput {
        const json = this.toJSON();
        let result = new IsTenantAvailableInput();
        result.init(json);
        return result;
    }
}

export interface IIsTenantAvailableInput {
    tenancyName: string;
}

export class IsTenantAvailableOutput implements IIsTenantAvailableOutput {
    state: TenantAvailabilityState;
    tenantId: number | undefined;

    constructor(data?: IIsTenantAvailableOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.state = _data["state"];
            this.tenantId = _data["tenantId"];
        }
    }

    static fromJS(data: any): IsTenantAvailableOutput {
        data = typeof data === 'object' ? data : {};
        let result = new IsTenantAvailableOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["state"] = this.state;
        data["tenantId"] = this.tenantId;
        return data;
    }

    clone(): IsTenantAvailableOutput {
        const json = this.toJSON();
        let result = new IsTenantAvailableOutput();
        result.init(json);
        return result;
    }
}

export interface IIsTenantAvailableOutput {
    state: TenantAvailabilityState;
    tenantId: number | undefined;
}

export class JsonProductDto implements IJsonProductDto {
    name: string | undefined;
    code: string | undefined;
    description: string | undefined;
    useStock: boolean;
    isGiftCard: boolean;
    promo12: boolean;
    notInStores: string | undefined;
    taxId: number;
    currencyId: number;
    price: number;
    discount1: number;
    priceDiscount1: number;
    discount2: number;
    priceDiscount2: number;
    expense: number;
    utility: number;
    minStock: number;
    base: number;
    externalId: number | undefined;
    barcode: string | undefined;
    isEam: boolean;
    fileAttachmentId: number | undefined;
    isActive: boolean;
    gtin: string | undefined;
    variantList: JsonVariantDto[] | undefined;
    propertyList: JsonProductPropertyDto[] | undefined;

    constructor(data?: IJsonProductDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.code = _data["code"];
            this.description = _data["description"];
            this.useStock = _data["useStock"];
            this.isGiftCard = _data["isGiftCard"];
            this.promo12 = _data["promo12"];
            this.notInStores = _data["notInStores"];
            this.taxId = _data["taxId"];
            this.currencyId = _data["currencyId"];
            this.price = _data["price"];
            this.discount1 = _data["discount1"];
            this.priceDiscount1 = _data["priceDiscount1"];
            this.discount2 = _data["discount2"];
            this.priceDiscount2 = _data["priceDiscount2"];
            this.expense = _data["expense"];
            this.utility = _data["utility"];
            this.minStock = _data["minStock"];
            this.base = _data["base"];
            this.externalId = _data["externalId"];
            this.barcode = _data["barcode"];
            this.isEam = _data["isEam"];
            this.fileAttachmentId = _data["fileAttachmentId"];
            this.isActive = _data["isActive"];
            this.gtin = _data["gtin"];
            if (Array.isArray(_data["variantList"])) {
                this.variantList = [] as any;
                for (let item of _data["variantList"])
                    this.variantList.push(JsonVariantDto.fromJS(item));
            }
            if (Array.isArray(_data["propertyList"])) {
                this.propertyList = [] as any;
                for (let item of _data["propertyList"])
                    this.propertyList.push(JsonProductPropertyDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): JsonProductDto {
        data = typeof data === 'object' ? data : {};
        let result = new JsonProductDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["code"] = this.code;
        data["description"] = this.description;
        data["useStock"] = this.useStock;
        data["isGiftCard"] = this.isGiftCard;
        data["promo12"] = this.promo12;
        data["notInStores"] = this.notInStores;
        data["taxId"] = this.taxId;
        data["currencyId"] = this.currencyId;
        data["price"] = this.price;
        data["discount1"] = this.discount1;
        data["priceDiscount1"] = this.priceDiscount1;
        data["discount2"] = this.discount2;
        data["priceDiscount2"] = this.priceDiscount2;
        data["expense"] = this.expense;
        data["utility"] = this.utility;
        data["minStock"] = this.minStock;
        data["base"] = this.base;
        data["externalId"] = this.externalId;
        data["barcode"] = this.barcode;
        data["isEam"] = this.isEam;
        data["fileAttachmentId"] = this.fileAttachmentId;
        data["isActive"] = this.isActive;
        data["gtin"] = this.gtin;
        if (Array.isArray(this.variantList)) {
            data["variantList"] = [];
            for (let item of this.variantList)
                data["variantList"].push(item.toJSON());
        }
        if (Array.isArray(this.propertyList)) {
            data["propertyList"] = [];
            for (let item of this.propertyList)
                data["propertyList"].push(item.toJSON());
        }
        return data;
    }

    clone(): JsonProductDto {
        const json = this.toJSON();
        let result = new JsonProductDto();
        result.init(json);
        return result;
    }
}

export interface IJsonProductDto {
    name: string | undefined;
    code: string | undefined;
    description: string | undefined;
    useStock: boolean;
    isGiftCard: boolean;
    promo12: boolean;
    notInStores: string | undefined;
    taxId: number;
    currencyId: number;
    price: number;
    discount1: number;
    priceDiscount1: number;
    discount2: number;
    priceDiscount2: number;
    expense: number;
    utility: number;
    minStock: number;
    base: number;
    externalId: number | undefined;
    barcode: string | undefined;
    isEam: boolean;
    fileAttachmentId: number | undefined;
    isActive: boolean;
    gtin: string | undefined;
    variantList: JsonVariantDto[] | undefined;
    propertyList: JsonProductPropertyDto[] | undefined;
}

export class JsonProductPropertyDto implements IJsonProductPropertyDto {
    name: string | undefined;
    propertyId: number;
    id: number;

    constructor(data?: IJsonProductPropertyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.propertyId = _data["propertyId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): JsonProductPropertyDto {
        data = typeof data === 'object' ? data : {};
        let result = new JsonProductPropertyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["propertyId"] = this.propertyId;
        data["id"] = this.id;
        return data;
    }

    clone(): JsonProductPropertyDto {
        const json = this.toJSON();
        let result = new JsonProductPropertyDto();
        result.init(json);
        return result;
    }
}

export interface IJsonProductPropertyDto {
    name: string | undefined;
    propertyId: number;
    id: number;
}

export class JsonVariantDto implements IJsonVariantDto {
    name: string | undefined;
    barCode: string | undefined;
    isEam: boolean;
    isActive: boolean;
    sizeId: number;
    colorId: number;

    constructor(data?: IJsonVariantDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.barCode = _data["barCode"];
            this.isEam = _data["isEam"];
            this.isActive = _data["isActive"];
            this.sizeId = _data["sizeId"];
            this.colorId = _data["colorId"];
        }
    }

    static fromJS(data: any): JsonVariantDto {
        data = typeof data === 'object' ? data : {};
        let result = new JsonVariantDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["barCode"] = this.barCode;
        data["isEam"] = this.isEam;
        data["isActive"] = this.isActive;
        data["sizeId"] = this.sizeId;
        data["colorId"] = this.colorId;
        return data;
    }

    clone(): JsonVariantDto {
        const json = this.toJSON();
        let result = new JsonVariantDto();
        result.init(json);
        return result;
    }
}

export interface IJsonVariantDto {
    name: string | undefined;
    barCode: string | undefined;
    isEam: boolean;
    isActive: boolean;
    sizeId: number;
    colorId: number;
}

export enum LetterType {
    A = <any>"A",
    B = <any>"B",
    C = <any>"C",
}

export class LinkMercadoLibreProductInputDto implements ILinkMercadoLibreProductInputDto {
    productId: number;
    variantId: number | undefined;
    selections: MlPublicationSelectionDto[] | undefined;

    constructor(data?: ILinkMercadoLibreProductInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productId = _data["productId"];
            this.variantId = _data["variantId"];
            if (Array.isArray(_data["selections"])) {
                this.selections = [] as any;
                for (let item of _data["selections"])
                    this.selections.push(MlPublicationSelectionDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): LinkMercadoLibreProductInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new LinkMercadoLibreProductInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productId"] = this.productId;
        data["variantId"] = this.variantId;
        if (Array.isArray(this.selections)) {
            data["selections"] = [];
            for (let item of this.selections)
                data["selections"].push(item.toJSON());
        }
        return data;
    }

    clone(): LinkMercadoLibreProductInputDto {
        const json = this.toJSON();
        let result = new LinkMercadoLibreProductInputDto();
        result.init(json);
        return result;
    }
}

export interface ILinkMercadoLibreProductInputDto {
    productId: number;
    variantId: number | undefined;
    selections: MlPublicationSelectionDto[] | undefined;
}

export class LinkedVariantDetailDto implements ILinkedVariantDetailDto {
    variantId: number | undefined;
    variantName: string | undefined;
    externalVariantId: string | undefined;
    stockDeposito: number;
    stockReserva: number;
    stockTotal: number;
    price: number;
    promotionalPrice: number | undefined;

    constructor(data?: ILinkedVariantDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.variantId = _data["variantId"];
            this.variantName = _data["variantName"];
            this.externalVariantId = _data["externalVariantId"];
            this.stockDeposito = _data["stockDeposito"];
            this.stockReserva = _data["stockReserva"];
            this.stockTotal = _data["stockTotal"];
            this.price = _data["price"];
            this.promotionalPrice = _data["promotionalPrice"];
        }
    }

    static fromJS(data: any): LinkedVariantDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new LinkedVariantDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["variantId"] = this.variantId;
        data["variantName"] = this.variantName;
        data["externalVariantId"] = this.externalVariantId;
        data["stockDeposito"] = this.stockDeposito;
        data["stockReserva"] = this.stockReserva;
        data["stockTotal"] = this.stockTotal;
        data["price"] = this.price;
        data["promotionalPrice"] = this.promotionalPrice;
        return data;
    }

    clone(): LinkedVariantDetailDto {
        const json = this.toJSON();
        let result = new LinkedVariantDetailDto();
        result.init(json);
        return result;
    }
}

export interface ILinkedVariantDetailDto {
    variantId: number | undefined;
    variantName: string | undefined;
    externalVariantId: string | undefined;
    stockDeposito: number;
    stockReserva: number;
    stockTotal: number;
    price: number;
    promotionalPrice: number | undefined;
}

export enum LogLevelModel {
    DEBUG = <any>"DEBUG",
    INFO = <any>"INFO",
    WARN = <any>"WARN",
    ERROR = <any>"ERROR",
}

export enum LogOrderModel {
    ASC = <any>"ASC",
    DESC = <any>"DESC",
}

export class LoyaltyCategory implements ILoyaltyCategory {
    id: number;
    tenantId: number | undefined;
    isDeleted: boolean;
    name: string | undefined;
    isVip: boolean;
    clients: Client[] | undefined;

    constructor(data?: ILoyaltyCategory) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tenantId = _data["tenantId"];
            this.isDeleted = _data["isDeleted"];
            this.name = _data["name"];
            this.isVip = _data["isVip"];
            if (Array.isArray(_data["clients"])) {
                this.clients = [] as any;
                for (let item of _data["clients"])
                    this.clients.push(Client.fromJS(item));
            }
        }
    }

    static fromJS(data: any): LoyaltyCategory {
        data = typeof data === 'object' ? data : {};
        let result = new LoyaltyCategory();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tenantId"] = this.tenantId;
        data["isDeleted"] = this.isDeleted;
        data["name"] = this.name;
        data["isVip"] = this.isVip;
        if (Array.isArray(this.clients)) {
            data["clients"] = [];
            for (let item of this.clients)
                data["clients"].push(item.toJSON());
        }
        return data;
    }

    clone(): LoyaltyCategory {
        const json = this.toJSON();
        let result = new LoyaltyCategory();
        result.init(json);
        return result;
    }
}

export interface ILoyaltyCategory {
    id: number;
    tenantId: number | undefined;
    isDeleted: boolean;
    name: string | undefined;
    isVip: boolean;
    clients: Client[] | undefined;
}

export class LoyaltyCategoryDto implements ILoyaltyCategoryDto {
    id: number;
    tenantId: number | undefined;
    name: string | undefined;
    isVip: boolean;

    constructor(data?: ILoyaltyCategoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tenantId = _data["tenantId"];
            this.name = _data["name"];
            this.isVip = _data["isVip"];
        }
    }

    static fromJS(data: any): LoyaltyCategoryDto {
        data = typeof data === 'object' ? data : {};
        let result = new LoyaltyCategoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tenantId"] = this.tenantId;
        data["name"] = this.name;
        data["isVip"] = this.isVip;
        return data;
    }

    clone(): LoyaltyCategoryDto {
        const json = this.toJSON();
        let result = new LoyaltyCategoryDto();
        result.init(json);
        return result;
    }
}

export interface ILoyaltyCategoryDto {
    id: number;
    tenantId: number | undefined;
    name: string | undefined;
    isVip: boolean;
}

export class LoyaltyCategoryDtoPagedResultDto implements ILoyaltyCategoryDtoPagedResultDto {
    items: LoyaltyCategoryDto[] | undefined;
    totalCount: number;

    constructor(data?: ILoyaltyCategoryDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(LoyaltyCategoryDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): LoyaltyCategoryDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new LoyaltyCategoryDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): LoyaltyCategoryDtoPagedResultDto {
        const json = this.toJSON();
        let result = new LoyaltyCategoryDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface ILoyaltyCategoryDtoPagedResultDto {
    items: LoyaltyCategoryDto[] | undefined;
    totalCount: number;
}

export class MercadoLibreAddressDto implements IMercadoLibreAddressDto {
    street: string | undefined;
    number: string | undefined;
    zipCode: string | undefined;
    city: string | undefined;
    state: string | undefined;
    country: string | undefined;

    constructor(data?: IMercadoLibreAddressDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.street = _data["street"];
            this.number = _data["number"];
            this.zipCode = _data["zipCode"];
            this.city = _data["city"];
            this.state = _data["state"];
            this.country = _data["country"];
        }
    }

    static fromJS(data: any): MercadoLibreAddressDto {
        data = typeof data === 'object' ? data : {};
        let result = new MercadoLibreAddressDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["street"] = this.street;
        data["number"] = this.number;
        data["zipCode"] = this.zipCode;
        data["city"] = this.city;
        data["state"] = this.state;
        data["country"] = this.country;
        return data;
    }

    clone(): MercadoLibreAddressDto {
        const json = this.toJSON();
        let result = new MercadoLibreAddressDto();
        result.init(json);
        return result;
    }
}

export interface IMercadoLibreAddressDto {
    street: string | undefined;
    number: string | undefined;
    zipCode: string | undefined;
    city: string | undefined;
    state: string | undefined;
    country: string | undefined;
}

export class MercadoLibreAttributeDto implements IMercadoLibreAttributeDto {
    name: string | undefined;
    valueName: string | undefined;

    constructor(data?: IMercadoLibreAttributeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.valueName = _data["valueName"];
        }
    }

    static fromJS(data: any): MercadoLibreAttributeDto {
        data = typeof data === 'object' ? data : {};
        let result = new MercadoLibreAttributeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["valueName"] = this.valueName;
        return data;
    }

    clone(): MercadoLibreAttributeDto {
        const json = this.toJSON();
        let result = new MercadoLibreAttributeDto();
        result.init(json);
        return result;
    }
}

export interface IMercadoLibreAttributeDto {
    name: string | undefined;
    valueName: string | undefined;
}

export class MercadoLibreBillingInfoDto implements IMercadoLibreBillingInfoDto {
    docType: string | undefined;
    docNumber: string | undefined;
    businessName: string | undefined;
    firstName: string | undefined;
    lastName: string | undefined;
    phone: string | undefined;
    taxpayerType: string | undefined;
    taxPayerId: string | undefined;
    address: MercadoLibreAddressDto;

    constructor(data?: IMercadoLibreBillingInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.docType = _data["docType"];
            this.docNumber = _data["docNumber"];
            this.businessName = _data["businessName"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.phone = _data["phone"];
            this.taxpayerType = _data["taxpayerType"];
            this.taxPayerId = _data["taxPayerId"];
            this.address = _data["address"] ? MercadoLibreAddressDto.fromJS(_data["address"]) : <any>undefined;
        }
    }

    static fromJS(data: any): MercadoLibreBillingInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new MercadoLibreBillingInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["docType"] = this.docType;
        data["docNumber"] = this.docNumber;
        data["businessName"] = this.businessName;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["phone"] = this.phone;
        data["taxpayerType"] = this.taxpayerType;
        data["taxPayerId"] = this.taxPayerId;
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        return data;
    }

    clone(): MercadoLibreBillingInfoDto {
        const json = this.toJSON();
        let result = new MercadoLibreBillingInfoDto();
        result.init(json);
        return result;
    }
}

export interface IMercadoLibreBillingInfoDto {
    docType: string | undefined;
    docNumber: string | undefined;
    businessName: string | undefined;
    firstName: string | undefined;
    lastName: string | undefined;
    phone: string | undefined;
    taxpayerType: string | undefined;
    taxPayerId: string | undefined;
    address: MercadoLibreAddressDto;
}

export class MercadoLibreBuyerDto implements IMercadoLibreBuyerDto {
    id: number;
    nickname: string | undefined;
    firstName: string | undefined;
    lastName: string | undefined;
    email: string | undefined;

    constructor(data?: IMercadoLibreBuyerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.nickname = _data["nickname"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): MercadoLibreBuyerDto {
        data = typeof data === 'object' ? data : {};
        let result = new MercadoLibreBuyerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["nickname"] = this.nickname;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["email"] = this.email;
        return data;
    }

    clone(): MercadoLibreBuyerDto {
        const json = this.toJSON();
        let result = new MercadoLibreBuyerDto();
        result.init(json);
        return result;
    }
}

export interface IMercadoLibreBuyerDto {
    id: number;
    nickname: string | undefined;
    firstName: string | undefined;
    lastName: string | undefined;
    email: string | undefined;
}

export class MercadoLibreConfigurationDto implements IMercadoLibreConfigurationDto {
    appId: string | undefined;
    secretKey: string | undefined;
    accessToken: string | undefined;
    refreshToken: string | undefined;
    userId: number | undefined;
    storeId: number;
    priceListId: number | undefined;
    promotionalPriceListId: number | undefined;
    minStock: number;

    constructor(data?: IMercadoLibreConfigurationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.appId = _data["appId"];
            this.secretKey = _data["secretKey"];
            this.accessToken = _data["accessToken"];
            this.refreshToken = _data["refreshToken"];
            this.userId = _data["userId"];
            this.storeId = _data["storeId"];
            this.priceListId = _data["priceListId"];
            this.promotionalPriceListId = _data["promotionalPriceListId"];
            this.minStock = _data["minStock"];
        }
    }

    static fromJS(data: any): MercadoLibreConfigurationDto {
        data = typeof data === 'object' ? data : {};
        let result = new MercadoLibreConfigurationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["appId"] = this.appId;
        data["secretKey"] = this.secretKey;
        data["accessToken"] = this.accessToken;
        data["refreshToken"] = this.refreshToken;
        data["userId"] = this.userId;
        data["storeId"] = this.storeId;
        data["priceListId"] = this.priceListId;
        data["promotionalPriceListId"] = this.promotionalPriceListId;
        data["minStock"] = this.minStock;
        return data;
    }

    clone(): MercadoLibreConfigurationDto {
        const json = this.toJSON();
        let result = new MercadoLibreConfigurationDto();
        result.init(json);
        return result;
    }
}

export interface IMercadoLibreConfigurationDto {
    appId: string | undefined;
    secretKey: string | undefined;
    accessToken: string | undefined;
    refreshToken: string | undefined;
    userId: number | undefined;
    storeId: number;
    priceListId: number | undefined;
    promotionalPriceListId: number | undefined;
    minStock: number;
}

export class MercadoLibreOrderDetailDto implements IMercadoLibreOrderDetailDto {
    id: number;
    status: string | undefined;
    statusDetail: string | undefined;
    dateCreated: moment.Moment;
    lastUpdated: moment.Moment;
    totalAmount: number;
    paidAmount: number;
    currencyId: string | undefined;
    buyer: MercadoLibreBuyerDto;
    seller: MercadoLibreSellerDto;
    orderItems: MercadoLibreOrderItemDetailDto[] | undefined;
    payments: MercadoLibrePaymentDto[] | undefined;
    shipping: MercadoLibreShippingDto;
    packId: string | undefined;

    constructor(data?: IMercadoLibreOrderDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.status = _data["status"];
            this.statusDetail = _data["statusDetail"];
            this.dateCreated = _data["dateCreated"] ? moment(_data["dateCreated"].toString()) : <any>undefined;
            this.lastUpdated = _data["lastUpdated"] ? moment(_data["lastUpdated"].toString()) : <any>undefined;
            this.totalAmount = _data["totalAmount"];
            this.paidAmount = _data["paidAmount"];
            this.currencyId = _data["currencyId"];
            this.buyer = _data["buyer"] ? MercadoLibreBuyerDto.fromJS(_data["buyer"]) : <any>undefined;
            this.seller = _data["seller"] ? MercadoLibreSellerDto.fromJS(_data["seller"]) : <any>undefined;
            if (Array.isArray(_data["orderItems"])) {
                this.orderItems = [] as any;
                for (let item of _data["orderItems"])
                    this.orderItems.push(MercadoLibreOrderItemDetailDto.fromJS(item));
            }
            if (Array.isArray(_data["payments"])) {
                this.payments = [] as any;
                for (let item of _data["payments"])
                    this.payments.push(MercadoLibrePaymentDto.fromJS(item));
            }
            this.shipping = _data["shipping"] ? MercadoLibreShippingDto.fromJS(_data["shipping"]) : <any>undefined;
            this.packId = _data["packId"];
        }
    }

    static fromJS(data: any): MercadoLibreOrderDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new MercadoLibreOrderDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["status"] = this.status;
        data["statusDetail"] = this.statusDetail;
        data["dateCreated"] = this.dateCreated ? this.dateCreated.toISOString() : <any>undefined;
        data["lastUpdated"] = this.lastUpdated ? this.lastUpdated.toISOString() : <any>undefined;
        data["totalAmount"] = this.totalAmount;
        data["paidAmount"] = this.paidAmount;
        data["currencyId"] = this.currencyId;
        data["buyer"] = this.buyer ? this.buyer.toJSON() : <any>undefined;
        data["seller"] = this.seller ? this.seller.toJSON() : <any>undefined;
        if (Array.isArray(this.orderItems)) {
            data["orderItems"] = [];
            for (let item of this.orderItems)
                data["orderItems"].push(item.toJSON());
        }
        if (Array.isArray(this.payments)) {
            data["payments"] = [];
            for (let item of this.payments)
                data["payments"].push(item.toJSON());
        }
        data["shipping"] = this.shipping ? this.shipping.toJSON() : <any>undefined;
        data["packId"] = this.packId;
        return data;
    }

    clone(): MercadoLibreOrderDetailDto {
        const json = this.toJSON();
        let result = new MercadoLibreOrderDetailDto();
        result.init(json);
        return result;
    }
}

export interface IMercadoLibreOrderDetailDto {
    id: number;
    status: string | undefined;
    statusDetail: string | undefined;
    dateCreated: moment.Moment;
    lastUpdated: moment.Moment;
    totalAmount: number;
    paidAmount: number;
    currencyId: string | undefined;
    buyer: MercadoLibreBuyerDto;
    seller: MercadoLibreSellerDto;
    orderItems: MercadoLibreOrderItemDetailDto[] | undefined;
    payments: MercadoLibrePaymentDto[] | undefined;
    shipping: MercadoLibreShippingDto;
    packId: string | undefined;
}

export class MercadoLibreOrderDto implements IMercadoLibreOrderDto {
    id: number;
    dateCreated: moment.Moment;
    totalAmount: number;
    status: string | undefined;
    orderItems: MercadoLibreOrderItemDto[] | undefined;
    buyer: MercadoLibreBuyerDto;
    isInvoiced: boolean;
    requiresCreditNote: boolean;
    hasCreditNote: boolean;
    isDelivered: boolean;
    packId: number | undefined;

    constructor(data?: IMercadoLibreOrderDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.dateCreated = _data["dateCreated"] ? moment(_data["dateCreated"].toString()) : <any>undefined;
            this.totalAmount = _data["totalAmount"];
            this.status = _data["status"];
            if (Array.isArray(_data["orderItems"])) {
                this.orderItems = [] as any;
                for (let item of _data["orderItems"])
                    this.orderItems.push(MercadoLibreOrderItemDto.fromJS(item));
            }
            this.buyer = _data["buyer"] ? MercadoLibreBuyerDto.fromJS(_data["buyer"]) : <any>undefined;
            this.isInvoiced = _data["isInvoiced"];
            this.requiresCreditNote = _data["requiresCreditNote"];
            this.hasCreditNote = _data["hasCreditNote"];
            this.isDelivered = _data["isDelivered"];
            this.packId = _data["packId"];
        }
    }

    static fromJS(data: any): MercadoLibreOrderDto {
        data = typeof data === 'object' ? data : {};
        let result = new MercadoLibreOrderDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["dateCreated"] = this.dateCreated ? this.dateCreated.toISOString() : <any>undefined;
        data["totalAmount"] = this.totalAmount;
        data["status"] = this.status;
        if (Array.isArray(this.orderItems)) {
            data["orderItems"] = [];
            for (let item of this.orderItems)
                data["orderItems"].push(item.toJSON());
        }
        data["buyer"] = this.buyer ? this.buyer.toJSON() : <any>undefined;
        data["isInvoiced"] = this.isInvoiced;
        data["requiresCreditNote"] = this.requiresCreditNote;
        data["hasCreditNote"] = this.hasCreditNote;
        data["isDelivered"] = this.isDelivered;
        data["packId"] = this.packId;
        return data;
    }

    clone(): MercadoLibreOrderDto {
        const json = this.toJSON();
        let result = new MercadoLibreOrderDto();
        result.init(json);
        return result;
    }
}

export interface IMercadoLibreOrderDto {
    id: number;
    dateCreated: moment.Moment;
    totalAmount: number;
    status: string | undefined;
    orderItems: MercadoLibreOrderItemDto[] | undefined;
    buyer: MercadoLibreBuyerDto;
    isInvoiced: boolean;
    requiresCreditNote: boolean;
    hasCreditNote: boolean;
    isDelivered: boolean;
    packId: number | undefined;
}

export class MercadoLibreOrderItemDetailDto implements IMercadoLibreOrderItemDetailDto {
    itemId: string | undefined;
    itemTitle: string | undefined;
    variationId: string | undefined;
    quantity: number;
    unitPrice: number;
    fullUnitPrice: number;
    salesFee: number;
    currencyId: string | undefined;
    condition: string | undefined;
    variationAttributes: MercadoLibreVariationAttributeDto[] | undefined;

    constructor(data?: IMercadoLibreOrderItemDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.itemId = _data["itemId"];
            this.itemTitle = _data["itemTitle"];
            this.variationId = _data["variationId"];
            this.quantity = _data["quantity"];
            this.unitPrice = _data["unitPrice"];
            this.fullUnitPrice = _data["fullUnitPrice"];
            this.salesFee = _data["salesFee"];
            this.currencyId = _data["currencyId"];
            this.condition = _data["condition"];
            if (Array.isArray(_data["variationAttributes"])) {
                this.variationAttributes = [] as any;
                for (let item of _data["variationAttributes"])
                    this.variationAttributes.push(MercadoLibreVariationAttributeDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MercadoLibreOrderItemDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new MercadoLibreOrderItemDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["itemId"] = this.itemId;
        data["itemTitle"] = this.itemTitle;
        data["variationId"] = this.variationId;
        data["quantity"] = this.quantity;
        data["unitPrice"] = this.unitPrice;
        data["fullUnitPrice"] = this.fullUnitPrice;
        data["salesFee"] = this.salesFee;
        data["currencyId"] = this.currencyId;
        data["condition"] = this.condition;
        if (Array.isArray(this.variationAttributes)) {
            data["variationAttributes"] = [];
            for (let item of this.variationAttributes)
                data["variationAttributes"].push(item.toJSON());
        }
        return data;
    }

    clone(): MercadoLibreOrderItemDetailDto {
        const json = this.toJSON();
        let result = new MercadoLibreOrderItemDetailDto();
        result.init(json);
        return result;
    }
}

export interface IMercadoLibreOrderItemDetailDto {
    itemId: string | undefined;
    itemTitle: string | undefined;
    variationId: string | undefined;
    quantity: number;
    unitPrice: number;
    fullUnitPrice: number;
    salesFee: number;
    currencyId: string | undefined;
    condition: string | undefined;
    variationAttributes: MercadoLibreVariationAttributeDto[] | undefined;
}

export class MercadoLibreOrderItemDto implements IMercadoLibreOrderItemDto {
    product: MercadoLibreProductDto;
    quantity: number;
    unitPrice: number;
    fullUnitPrice: number;

    constructor(data?: IMercadoLibreOrderItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.product = _data["product"] ? MercadoLibreProductDto.fromJS(_data["product"]) : <any>undefined;
            this.quantity = _data["quantity"];
            this.unitPrice = _data["unitPrice"];
            this.fullUnitPrice = _data["fullUnitPrice"];
        }
    }

    static fromJS(data: any): MercadoLibreOrderItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new MercadoLibreOrderItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["product"] = this.product ? this.product.toJSON() : <any>undefined;
        data["quantity"] = this.quantity;
        data["unitPrice"] = this.unitPrice;
        data["fullUnitPrice"] = this.fullUnitPrice;
        return data;
    }

    clone(): MercadoLibreOrderItemDto {
        const json = this.toJSON();
        let result = new MercadoLibreOrderItemDto();
        result.init(json);
        return result;
    }
}

export interface IMercadoLibreOrderItemDto {
    product: MercadoLibreProductDto;
    quantity: number;
    unitPrice: number;
    fullUnitPrice: number;
}

export class MercadoLibrePackDto implements IMercadoLibrePackDto {
    id: string | undefined;
    sellerId: number;
    buyerId: number;
    status: string | undefined;
    dateCreated: moment.Moment;
    orders: MercadoLibreOrderDetailDto[] | undefined;
    shipment: MercadoLibreShippingDto;

    constructor(data?: IMercadoLibrePackDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.sellerId = _data["sellerId"];
            this.buyerId = _data["buyerId"];
            this.status = _data["status"];
            this.dateCreated = _data["dateCreated"] ? moment(_data["dateCreated"].toString()) : <any>undefined;
            if (Array.isArray(_data["orders"])) {
                this.orders = [] as any;
                for (let item of _data["orders"])
                    this.orders.push(MercadoLibreOrderDetailDto.fromJS(item));
            }
            this.shipment = _data["shipment"] ? MercadoLibreShippingDto.fromJS(_data["shipment"]) : <any>undefined;
        }
    }

    static fromJS(data: any): MercadoLibrePackDto {
        data = typeof data === 'object' ? data : {};
        let result = new MercadoLibrePackDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["sellerId"] = this.sellerId;
        data["buyerId"] = this.buyerId;
        data["status"] = this.status;
        data["dateCreated"] = this.dateCreated ? this.dateCreated.toISOString() : <any>undefined;
        if (Array.isArray(this.orders)) {
            data["orders"] = [];
            for (let item of this.orders)
                data["orders"].push(item.toJSON());
        }
        data["shipment"] = this.shipment ? this.shipment.toJSON() : <any>undefined;
        return data;
    }

    clone(): MercadoLibrePackDto {
        const json = this.toJSON();
        let result = new MercadoLibrePackDto();
        result.init(json);
        return result;
    }
}

export interface IMercadoLibrePackDto {
    id: string | undefined;
    sellerId: number;
    buyerId: number;
    status: string | undefined;
    dateCreated: moment.Moment;
    orders: MercadoLibreOrderDetailDto[] | undefined;
    shipment: MercadoLibreShippingDto;
}

export class MercadoLibrePaymentDto implements IMercadoLibrePaymentDto {
    id: number;
    paymentMethodId: string | undefined;
    paymentType: string | undefined;
    status: string | undefined;
    statusDetail: string | undefined;
    transactionAmount: number;
    totalPaidAmount: number;
    installments: number;
    dateApproved: moment.Moment;

    constructor(data?: IMercadoLibrePaymentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.paymentMethodId = _data["paymentMethodId"];
            this.paymentType = _data["paymentType"];
            this.status = _data["status"];
            this.statusDetail = _data["statusDetail"];
            this.transactionAmount = _data["transactionAmount"];
            this.totalPaidAmount = _data["totalPaidAmount"];
            this.installments = _data["installments"];
            this.dateApproved = _data["dateApproved"] ? moment(_data["dateApproved"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): MercadoLibrePaymentDto {
        data = typeof data === 'object' ? data : {};
        let result = new MercadoLibrePaymentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["paymentMethodId"] = this.paymentMethodId;
        data["paymentType"] = this.paymentType;
        data["status"] = this.status;
        data["statusDetail"] = this.statusDetail;
        data["transactionAmount"] = this.transactionAmount;
        data["totalPaidAmount"] = this.totalPaidAmount;
        data["installments"] = this.installments;
        data["dateApproved"] = this.dateApproved ? this.dateApproved.toISOString() : <any>undefined;
        return data;
    }

    clone(): MercadoLibrePaymentDto {
        const json = this.toJSON();
        let result = new MercadoLibrePaymentDto();
        result.init(json);
        return result;
    }
}

export interface IMercadoLibrePaymentDto {
    id: number;
    paymentMethodId: string | undefined;
    paymentType: string | undefined;
    status: string | undefined;
    statusDetail: string | undefined;
    transactionAmount: number;
    totalPaidAmount: number;
    installments: number;
    dateApproved: moment.Moment;
}

export class MercadoLibreProductDto implements IMercadoLibreProductDto {
    title: string | undefined;
    id: number;
    productId: number;
    productName: string | undefined;
    variantId: number | undefined;
    variantName: string | undefined;
    platform: EcommercePlatform;
    externalProductId: string | undefined;
    externalVariantId: string | undefined;
    mlPublicationId: string | undefined;
    lastSyncDate: moment.Moment | undefined;

    constructor(data?: IMercadoLibreProductDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"];
            this.id = _data["id"];
            this.productId = _data["productId"];
            this.productName = _data["productName"];
            this.variantId = _data["variantId"];
            this.variantName = _data["variantName"];
            this.platform = _data["platform"];
            this.externalProductId = _data["externalProductId"];
            this.externalVariantId = _data["externalVariantId"];
            this.mlPublicationId = _data["mlPublicationId"];
            this.lastSyncDate = _data["lastSyncDate"] ? moment(_data["lastSyncDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): MercadoLibreProductDto {
        data = typeof data === 'object' ? data : {};
        let result = new MercadoLibreProductDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["id"] = this.id;
        data["productId"] = this.productId;
        data["productName"] = this.productName;
        data["variantId"] = this.variantId;
        data["variantName"] = this.variantName;
        data["platform"] = this.platform;
        data["externalProductId"] = this.externalProductId;
        data["externalVariantId"] = this.externalVariantId;
        data["mlPublicationId"] = this.mlPublicationId;
        data["lastSyncDate"] = this.lastSyncDate ? this.lastSyncDate.toISOString() : <any>undefined;
        return data;
    }

    clone(): MercadoLibreProductDto {
        const json = this.toJSON();
        let result = new MercadoLibreProductDto();
        result.init(json);
        return result;
    }
}

export interface IMercadoLibreProductDto {
    title: string | undefined;
    id: number;
    productId: number;
    productName: string | undefined;
    variantId: number | undefined;
    variantName: string | undefined;
    platform: EcommercePlatform;
    externalProductId: string | undefined;
    externalVariantId: string | undefined;
    mlPublicationId: string | undefined;
    lastSyncDate: moment.Moment | undefined;
}

export class MercadoLibrePromotionDto implements IMercadoLibrePromotionDto {
    id: string | undefined;
    name: string | undefined;
    promotionType: string | undefined;
    status: string | undefined;
    startDate: moment.Moment | undefined;
    finishDate: moment.Moment | undefined;

    constructor(data?: IMercadoLibrePromotionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.promotionType = _data["promotionType"];
            this.status = _data["status"];
            this.startDate = _data["startDate"] ? moment(_data["startDate"].toString()) : <any>undefined;
            this.finishDate = _data["finishDate"] ? moment(_data["finishDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): MercadoLibrePromotionDto {
        data = typeof data === 'object' ? data : {};
        let result = new MercadoLibrePromotionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["promotionType"] = this.promotionType;
        data["status"] = this.status;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["finishDate"] = this.finishDate ? this.finishDate.toISOString() : <any>undefined;
        return data;
    }

    clone(): MercadoLibrePromotionDto {
        const json = this.toJSON();
        let result = new MercadoLibrePromotionDto();
        result.init(json);
        return result;
    }
}

export interface IMercadoLibrePromotionDto {
    id: string | undefined;
    name: string | undefined;
    promotionType: string | undefined;
    status: string | undefined;
    startDate: moment.Moment | undefined;
    finishDate: moment.Moment | undefined;
}

export class MercadoLibrePublicationDto implements IMercadoLibrePublicationDto {
    id: string | undefined;
    title: string | undefined;
    status: string | undefined;
    price: number;
    currencyId: string | undefined;
    permalink: string | undefined;
    thumbnail: string | undefined;
    availableQuantity: number;
    soldQuantity: number;
    listingTypeId: string | undefined;
    categoryId: string | undefined;
    variations: MercadoLibreVariationDto[] | undefined;

    constructor(data?: IMercadoLibrePublicationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.status = _data["status"];
            this.price = _data["price"];
            this.currencyId = _data["currencyId"];
            this.permalink = _data["permalink"];
            this.thumbnail = _data["thumbnail"];
            this.availableQuantity = _data["availableQuantity"];
            this.soldQuantity = _data["soldQuantity"];
            this.listingTypeId = _data["listingTypeId"];
            this.categoryId = _data["categoryId"];
            if (Array.isArray(_data["variations"])) {
                this.variations = [] as any;
                for (let item of _data["variations"])
                    this.variations.push(MercadoLibreVariationDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MercadoLibrePublicationDto {
        data = typeof data === 'object' ? data : {};
        let result = new MercadoLibrePublicationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["status"] = this.status;
        data["price"] = this.price;
        data["currencyId"] = this.currencyId;
        data["permalink"] = this.permalink;
        data["thumbnail"] = this.thumbnail;
        data["availableQuantity"] = this.availableQuantity;
        data["soldQuantity"] = this.soldQuantity;
        data["listingTypeId"] = this.listingTypeId;
        data["categoryId"] = this.categoryId;
        if (Array.isArray(this.variations)) {
            data["variations"] = [];
            for (let item of this.variations)
                data["variations"].push(item.toJSON());
        }
        return data;
    }

    clone(): MercadoLibrePublicationDto {
        const json = this.toJSON();
        let result = new MercadoLibrePublicationDto();
        result.init(json);
        return result;
    }
}

export interface IMercadoLibrePublicationDto {
    id: string | undefined;
    title: string | undefined;
    status: string | undefined;
    price: number;
    currencyId: string | undefined;
    permalink: string | undefined;
    thumbnail: string | undefined;
    availableQuantity: number;
    soldQuantity: number;
    listingTypeId: string | undefined;
    categoryId: string | undefined;
    variations: MercadoLibreVariationDto[] | undefined;
}

export class MercadoLibreSellerDto implements IMercadoLibreSellerDto {
    id: number;
    nickname: string | undefined;

    constructor(data?: IMercadoLibreSellerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.nickname = _data["nickname"];
        }
    }

    static fromJS(data: any): MercadoLibreSellerDto {
        data = typeof data === 'object' ? data : {};
        let result = new MercadoLibreSellerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["nickname"] = this.nickname;
        return data;
    }

    clone(): MercadoLibreSellerDto {
        const json = this.toJSON();
        let result = new MercadoLibreSellerDto();
        result.init(json);
        return result;
    }
}

export interface IMercadoLibreSellerDto {
    id: number;
    nickname: string | undefined;
}

export class MercadoLibreShippingAddressDto implements IMercadoLibreShippingAddressDto {
    receiverName: string | undefined;
    street: string | undefined;
    streetNumber: string | undefined;
    zipCode: string | undefined;
    city: string | undefined;
    state: string | undefined;
    country: string | undefined;

    constructor(data?: IMercadoLibreShippingAddressDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.receiverName = _data["receiverName"];
            this.street = _data["street"];
            this.streetNumber = _data["streetNumber"];
            this.zipCode = _data["zipCode"];
            this.city = _data["city"];
            this.state = _data["state"];
            this.country = _data["country"];
        }
    }

    static fromJS(data: any): MercadoLibreShippingAddressDto {
        data = typeof data === 'object' ? data : {};
        let result = new MercadoLibreShippingAddressDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["receiverName"] = this.receiverName;
        data["street"] = this.street;
        data["streetNumber"] = this.streetNumber;
        data["zipCode"] = this.zipCode;
        data["city"] = this.city;
        data["state"] = this.state;
        data["country"] = this.country;
        return data;
    }

    clone(): MercadoLibreShippingAddressDto {
        const json = this.toJSON();
        let result = new MercadoLibreShippingAddressDto();
        result.init(json);
        return result;
    }
}

export interface IMercadoLibreShippingAddressDto {
    receiverName: string | undefined;
    street: string | undefined;
    streetNumber: string | undefined;
    zipCode: string | undefined;
    city: string | undefined;
    state: string | undefined;
    country: string | undefined;
}

export class MercadoLibreShippingDto implements IMercadoLibreShippingDto {
    id: number;
    status: string | undefined;
    shipmentType: string | undefined;
    cost: number;
    receiverAddress: MercadoLibreShippingAddressDto;

    constructor(data?: IMercadoLibreShippingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.status = _data["status"];
            this.shipmentType = _data["shipmentType"];
            this.cost = _data["cost"];
            this.receiverAddress = _data["receiverAddress"] ? MercadoLibreShippingAddressDto.fromJS(_data["receiverAddress"]) : <any>undefined;
        }
    }

    static fromJS(data: any): MercadoLibreShippingDto {
        data = typeof data === 'object' ? data : {};
        let result = new MercadoLibreShippingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["status"] = this.status;
        data["shipmentType"] = this.shipmentType;
        data["cost"] = this.cost;
        data["receiverAddress"] = this.receiverAddress ? this.receiverAddress.toJSON() : <any>undefined;
        return data;
    }

    clone(): MercadoLibreShippingDto {
        const json = this.toJSON();
        let result = new MercadoLibreShippingDto();
        result.init(json);
        return result;
    }
}

export interface IMercadoLibreShippingDto {
    id: number;
    status: string | undefined;
    shipmentType: string | undefined;
    cost: number;
    receiverAddress: MercadoLibreShippingAddressDto;
}

export class MercadoLibreVariationAttributeDto implements IMercadoLibreVariationAttributeDto {
    id: string | undefined;
    name: string | undefined;
    valueId: string | undefined;
    valueName: string | undefined;

    constructor(data?: IMercadoLibreVariationAttributeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.valueId = _data["valueId"];
            this.valueName = _data["valueName"];
        }
    }

    static fromJS(data: any): MercadoLibreVariationAttributeDto {
        data = typeof data === 'object' ? data : {};
        let result = new MercadoLibreVariationAttributeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["valueId"] = this.valueId;
        data["valueName"] = this.valueName;
        return data;
    }

    clone(): MercadoLibreVariationAttributeDto {
        const json = this.toJSON();
        let result = new MercadoLibreVariationAttributeDto();
        result.init(json);
        return result;
    }
}

export interface IMercadoLibreVariationAttributeDto {
    id: string | undefined;
    name: string | undefined;
    valueId: string | undefined;
    valueName: string | undefined;
}

export class MercadoLibreVariationDto implements IMercadoLibreVariationDto {
    id: string | undefined;
    price: number;
    availableQuantity: number;
    attributeCombinations: MercadoLibreAttributeDto[] | undefined;

    constructor(data?: IMercadoLibreVariationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.price = _data["price"];
            this.availableQuantity = _data["availableQuantity"];
            if (Array.isArray(_data["attributeCombinations"])) {
                this.attributeCombinations = [] as any;
                for (let item of _data["attributeCombinations"])
                    this.attributeCombinations.push(MercadoLibreAttributeDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MercadoLibreVariationDto {
        data = typeof data === 'object' ? data : {};
        let result = new MercadoLibreVariationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["price"] = this.price;
        data["availableQuantity"] = this.availableQuantity;
        if (Array.isArray(this.attributeCombinations)) {
            data["attributeCombinations"] = [];
            for (let item of this.attributeCombinations)
                data["attributeCombinations"].push(item.toJSON());
        }
        return data;
    }

    clone(): MercadoLibreVariationDto {
        const json = this.toJSON();
        let result = new MercadoLibreVariationDto();
        result.init(json);
        return result;
    }
}

export interface IMercadoLibreVariationDto {
    id: string | undefined;
    price: number;
    availableQuantity: number;
    attributeCombinations: MercadoLibreAttributeDto[] | undefined;
}

export class MlPublicationSelectionDto implements IMlPublicationSelectionDto {
    mlPublicationId: string | undefined;
    mlVariantId: string | undefined;

    constructor(data?: IMlPublicationSelectionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mlPublicationId = _data["mlPublicationId"];
            this.mlVariantId = _data["mlVariantId"];
        }
    }

    static fromJS(data: any): MlPublicationSelectionDto {
        data = typeof data === 'object' ? data : {};
        let result = new MlPublicationSelectionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mlPublicationId"] = this.mlPublicationId;
        data["mlVariantId"] = this.mlVariantId;
        return data;
    }

    clone(): MlPublicationSelectionDto {
        const json = this.toJSON();
        let result = new MlPublicationSelectionDto();
        result.init(json);
        return result;
    }
}

export interface IMlPublicationSelectionDto {
    mlPublicationId: string | undefined;
    mlVariantId: string | undefined;
}

export enum MovementType {
    Movement = <any>"Movement",
    Adjustment = <any>"Adjustment",
    Reservation = <any>"Reservation",
}

export class NodePermissionDto implements INodePermissionDto {
    name: string | undefined;
    displayName: string | undefined;
    description: string | undefined;
    children: NodePermissionDto[] | undefined;

    constructor(data?: INodePermissionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.description = _data["description"];
            if (Array.isArray(_data["children"])) {
                this.children = [] as any;
                for (let item of _data["children"])
                    this.children.push(NodePermissionDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): NodePermissionDto {
        data = typeof data === 'object' ? data : {};
        let result = new NodePermissionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["description"] = this.description;
        if (Array.isArray(this.children)) {
            data["children"] = [];
            for (let item of this.children)
                data["children"].push(item.toJSON());
        }
        return data;
    }

    clone(): NodePermissionDto {
        const json = this.toJSON();
        let result = new NodePermissionDto();
        result.init(json);
        return result;
    }
}

export interface INodePermissionDto {
    name: string | undefined;
    displayName: string | undefined;
    description: string | undefined;
    children: NodePermissionDto[] | undefined;
}

export class NodePermissionDtoListResultDto implements INodePermissionDtoListResultDto {
    items: NodePermissionDto[] | undefined;

    constructor(data?: INodePermissionDtoListResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(NodePermissionDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): NodePermissionDtoListResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new NodePermissionDtoListResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): NodePermissionDtoListResultDto {
        const json = this.toJSON();
        let result = new NodePermissionDtoListResultDto();
        result.init(json);
        return result;
    }
}

export interface INodePermissionDtoListResultDto {
    items: NodePermissionDto[] | undefined;
}

export class PPaymentsInvoiceDto implements IPPaymentsInvoiceDto {
    id: number;
    tenantId: number | undefined;
    name: string | undefined;
    icon: string | undefined;
    isStatic: boolean;
    type: TypeProviderPayment;

    constructor(data?: IPPaymentsInvoiceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tenantId = _data["tenantId"];
            this.name = _data["name"];
            this.icon = _data["icon"];
            this.isStatic = _data["isStatic"];
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): PPaymentsInvoiceDto {
        data = typeof data === 'object' ? data : {};
        let result = new PPaymentsInvoiceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tenantId"] = this.tenantId;
        data["name"] = this.name;
        data["icon"] = this.icon;
        data["isStatic"] = this.isStatic;
        data["type"] = this.type;
        return data;
    }

    clone(): PPaymentsInvoiceDto {
        const json = this.toJSON();
        let result = new PPaymentsInvoiceDto();
        result.init(json);
        return result;
    }
}

export interface IPPaymentsInvoiceDto {
    id: number;
    tenantId: number | undefined;
    name: string | undefined;
    icon: string | undefined;
    isStatic: boolean;
    type: TypeProviderPayment;
}

export class PageProductDto implements IPageProductDto {
    id: number;
    tenantId: number | undefined;
    name: string | undefined;
    isActive: boolean;
    code: string | undefined;

    constructor(data?: IPageProductDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tenantId = _data["tenantId"];
            this.name = _data["name"];
            this.isActive = _data["isActive"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): PageProductDto {
        data = typeof data === 'object' ? data : {};
        let result = new PageProductDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tenantId"] = this.tenantId;
        data["name"] = this.name;
        data["isActive"] = this.isActive;
        data["code"] = this.code;
        return data;
    }

    clone(): PageProductDto {
        const json = this.toJSON();
        let result = new PageProductDto();
        result.init(json);
        return result;
    }
}

export interface IPageProductDto {
    id: number;
    tenantId: number | undefined;
    name: string | undefined;
    isActive: boolean;
    code: string | undefined;
}

export class PageProductDtoPagedResultDto implements IPageProductDtoPagedResultDto {
    items: PageProductDto[] | undefined;
    totalCount: number;

    constructor(data?: IPageProductDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(PageProductDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): PageProductDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new PageProductDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): PageProductDtoPagedResultDto {
        const json = this.toJSON();
        let result = new PageProductDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IPageProductDtoPagedResultDto {
    items: PageProductDto[] | undefined;
    totalCount: number;
}

export class PagedCashierResultRequestDto implements IPagedCashierResultRequestDto {
    maxResultCount: number;
    skipCount: number;
    keyword: string | undefined;

    constructor(data?: IPagedCashierResultRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.maxResultCount = _data["maxResultCount"];
            this.skipCount = _data["skipCount"];
            this.keyword = _data["keyword"];
        }
    }

    static fromJS(data: any): PagedCashierResultRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedCashierResultRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxResultCount"] = this.maxResultCount;
        data["skipCount"] = this.skipCount;
        data["keyword"] = this.keyword;
        return data;
    }

    clone(): PagedCashierResultRequestDto {
        const json = this.toJSON();
        let result = new PagedCashierResultRequestDto();
        result.init(json);
        return result;
    }
}

export interface IPagedCashierResultRequestDto {
    maxResultCount: number;
    skipCount: number;
    keyword: string | undefined;
}

export class PagedProductPricesResultRequestDto implements IPagedProductPricesResultRequestDto {
    maxResultCount: number;
    skipCount: number;
    sorting: string | undefined;
    keyword: string | undefined;
    listPriceIds: number[] | undefined;
    includeBaseList: boolean;

    constructor(data?: IPagedProductPricesResultRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.maxResultCount = _data["maxResultCount"];
            this.skipCount = _data["skipCount"];
            this.sorting = _data["sorting"];
            this.keyword = _data["keyword"];
            if (Array.isArray(_data["listPriceIds"])) {
                this.listPriceIds = [] as any;
                for (let item of _data["listPriceIds"])
                    this.listPriceIds.push(item);
            }
            this.includeBaseList = _data["includeBaseList"];
        }
    }

    static fromJS(data: any): PagedProductPricesResultRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedProductPricesResultRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxResultCount"] = this.maxResultCount;
        data["skipCount"] = this.skipCount;
        data["sorting"] = this.sorting;
        data["keyword"] = this.keyword;
        if (Array.isArray(this.listPriceIds)) {
            data["listPriceIds"] = [];
            for (let item of this.listPriceIds)
                data["listPriceIds"].push(item);
        }
        data["includeBaseList"] = this.includeBaseList;
        return data;
    }

    clone(): PagedProductPricesResultRequestDto {
        const json = this.toJSON();
        let result = new PagedProductPricesResultRequestDto();
        result.init(json);
        return result;
    }
}

export interface IPagedProductPricesResultRequestDto {
    maxResultCount: number;
    skipCount: number;
    sorting: string | undefined;
    keyword: string | undefined;
    listPriceIds: number[] | undefined;
    includeBaseList: boolean;
}

export class PagedQuotesResultRequestDto implements IPagedQuotesResultRequestDto {
    maxResultCount: number;
    skipCount: number;
    keyword: string | undefined;

    constructor(data?: IPagedQuotesResultRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.maxResultCount = _data["maxResultCount"];
            this.skipCount = _data["skipCount"];
            this.keyword = _data["keyword"];
        }
    }

    static fromJS(data: any): PagedQuotesResultRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedQuotesResultRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxResultCount"] = this.maxResultCount;
        data["skipCount"] = this.skipCount;
        data["keyword"] = this.keyword;
        return data;
    }

    clone(): PagedQuotesResultRequestDto {
        const json = this.toJSON();
        let result = new PagedQuotesResultRequestDto();
        result.init(json);
        return result;
    }
}

export interface IPagedQuotesResultRequestDto {
    maxResultCount: number;
    skipCount: number;
    keyword: string | undefined;
}

export class PagedStockMovementResultRequestDto implements IPagedStockMovementResultRequestDto {
    maxResultCount: number;
    skipCount: number;
    stock: StockDto;
    from: moment.Moment | undefined;
    to: moment.Moment | undefined;
    keyword: string | undefined;

    constructor(data?: IPagedStockMovementResultRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.maxResultCount = _data["maxResultCount"];
            this.skipCount = _data["skipCount"];
            this.stock = _data["stock"] ? StockDto.fromJS(_data["stock"]) : <any>undefined;
            this.from = _data["from"] ? moment(_data["from"].toString()) : <any>undefined;
            this.to = _data["to"] ? moment(_data["to"].toString()) : <any>undefined;
            this.keyword = _data["keyword"];
        }
    }

    static fromJS(data: any): PagedStockMovementResultRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedStockMovementResultRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxResultCount"] = this.maxResultCount;
        data["skipCount"] = this.skipCount;
        data["stock"] = this.stock ? this.stock.toJSON() : <any>undefined;
        data["from"] = this.from ? this.from.toISOString() : <any>undefined;
        data["to"] = this.to ? this.to.toISOString() : <any>undefined;
        data["keyword"] = this.keyword;
        return data;
    }

    clone(): PagedStockMovementResultRequestDto {
        const json = this.toJSON();
        let result = new PagedStockMovementResultRequestDto();
        result.init(json);
        return result;
    }
}

export interface IPagedStockMovementResultRequestDto {
    maxResultCount: number;
    skipCount: number;
    stock: StockDto;
    from: moment.Moment | undefined;
    to: moment.Moment | undefined;
    keyword: string | undefined;
}

export class PaymentDataDto implements IPaymentDataDto {
    paymentId: string | undefined;
    paymentRequestDate: moment.Moment;
    paymentStatus: PaymentStatus;
    paymentStatusDate: moment.Moment;
    bin: string | undefined;
    authorizationCode: string | undefined;
    transactionReceipt: number;
    lastFourDigits: string | undefined;
    merchantId: string | undefined;
    merchantName: string | undefined;
    terminalId: string | undefined;
    authorizedPaymentAmount: string | undefined;
    change_amount: string | undefined;
    installmentsNumber: number;
    cardBrandProduct: string | undefined;
    cardHolder: string | undefined;
    batchNumber: number;
    qrCodeId: string | undefined;
    qrOriginalAmount: string | undefined;
    acquirerResponseCode: string | undefined;
    acquirer_additional_message: string | undefined;
    acquirerResponseDate: string | undefined;
    card_holder_id: string | undefined;
    tax_receipt_content: string | undefined;

    constructor(data?: IPaymentDataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.paymentId = _data["paymentId"];
            this.paymentRequestDate = _data["paymentRequestDate"] ? moment(_data["paymentRequestDate"].toString()) : <any>undefined;
            this.paymentStatus = _data["paymentStatus"];
            this.paymentStatusDate = _data["paymentStatusDate"] ? moment(_data["paymentStatusDate"].toString()) : <any>undefined;
            this.bin = _data["bin"];
            this.authorizationCode = _data["authorizationCode"];
            this.transactionReceipt = _data["transactionReceipt"];
            this.lastFourDigits = _data["lastFourDigits"];
            this.merchantId = _data["merchantId"];
            this.merchantName = _data["merchantName"];
            this.terminalId = _data["terminalId"];
            this.authorizedPaymentAmount = _data["authorizedPaymentAmount"];
            this.change_amount = _data["change_amount"];
            this.installmentsNumber = _data["installmentsNumber"];
            this.cardBrandProduct = _data["cardBrandProduct"];
            this.cardHolder = _data["cardHolder"];
            this.batchNumber = _data["batchNumber"];
            this.qrCodeId = _data["qrCodeId"];
            this.qrOriginalAmount = _data["qrOriginalAmount"];
            this.acquirerResponseCode = _data["acquirerResponseCode"];
            this.acquirer_additional_message = _data["acquirer_additional_message"];
            this.acquirerResponseDate = _data["acquirerResponseDate"];
            this.card_holder_id = _data["card_holder_id"];
            this.tax_receipt_content = _data["tax_receipt_content"];
        }
    }

    static fromJS(data: any): PaymentDataDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentDataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["paymentId"] = this.paymentId;
        data["paymentRequestDate"] = this.paymentRequestDate ? this.paymentRequestDate.toISOString() : <any>undefined;
        data["paymentStatus"] = this.paymentStatus;
        data["paymentStatusDate"] = this.paymentStatusDate ? this.paymentStatusDate.toISOString() : <any>undefined;
        data["bin"] = this.bin;
        data["authorizationCode"] = this.authorizationCode;
        data["transactionReceipt"] = this.transactionReceipt;
        data["lastFourDigits"] = this.lastFourDigits;
        data["merchantId"] = this.merchantId;
        data["merchantName"] = this.merchantName;
        data["terminalId"] = this.terminalId;
        data["authorizedPaymentAmount"] = this.authorizedPaymentAmount;
        data["change_amount"] = this.change_amount;
        data["installmentsNumber"] = this.installmentsNumber;
        data["cardBrandProduct"] = this.cardBrandProduct;
        data["cardHolder"] = this.cardHolder;
        data["batchNumber"] = this.batchNumber;
        data["qrCodeId"] = this.qrCodeId;
        data["qrOriginalAmount"] = this.qrOriginalAmount;
        data["acquirerResponseCode"] = this.acquirerResponseCode;
        data["acquirer_additional_message"] = this.acquirer_additional_message;
        data["acquirerResponseDate"] = this.acquirerResponseDate;
        data["card_holder_id"] = this.card_holder_id;
        data["tax_receipt_content"] = this.tax_receipt_content;
        return data;
    }

    clone(): PaymentDataDto {
        const json = this.toJSON();
        let result = new PaymentDataDto();
        result.init(json);
        return result;
    }
}

export interface IPaymentDataDto {
    paymentId: string | undefined;
    paymentRequestDate: moment.Moment;
    paymentStatus: PaymentStatus;
    paymentStatusDate: moment.Moment;
    bin: string | undefined;
    authorizationCode: string | undefined;
    transactionReceipt: number;
    lastFourDigits: string | undefined;
    merchantId: string | undefined;
    merchantName: string | undefined;
    terminalId: string | undefined;
    authorizedPaymentAmount: string | undefined;
    change_amount: string | undefined;
    installmentsNumber: number;
    cardBrandProduct: string | undefined;
    cardHolder: string | undefined;
    batchNumber: number;
    qrCodeId: string | undefined;
    qrOriginalAmount: string | undefined;
    acquirerResponseCode: string | undefined;
    acquirer_additional_message: string | undefined;
    acquirerResponseDate: string | undefined;
    card_holder_id: string | undefined;
    tax_receipt_content: string | undefined;
}

export enum PaymentStatus {
    PAYMENT_REQUEST = <any>"PAYMENT_REQUEST",
    PROCESSING_PAYMENT = <any>"PROCESSING_PAYMENT",
    WAITING_CONFIRMATION = <any>"WAITING_CONFIRMATION",
    CONFIRM_REQUEST = <any>"CONFIRM_REQUEST",
    UNDO_REQUEST = <any>"UNDO_REQUEST",
    PROCESSING_CONFIRMATION = <any>"PROCESSING_CONFIRMATION",
    PROCESSING_UNDO = <any>"PROCESSING_UNDO",
    CONFIRMED = <any>"CONFIRMED",
    DECLINED = <any>"DECLINED",
    UNDONE = <any>"UNDONE",
    ERROR = <any>"ERROR",
}

export enum PaymentType {
    Card = <any>"Card",
    QrCode = <any>"QrCode",
}

export class PriceList implements IPriceList {
    id: number;
    tenantId: number | undefined;
    isDeleted: boolean;
    name: string | undefined;
    isActive: boolean;
    expireDate: moment.Moment | undefined;
    externalId: number | undefined;
    productPrices: ProductPrice[] | undefined;
    stores: Store[] | undefined;
    ecommercePromotions: EcommercePromotion[] | undefined;

    constructor(data?: IPriceList) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tenantId = _data["tenantId"];
            this.isDeleted = _data["isDeleted"];
            this.name = _data["name"];
            this.isActive = _data["isActive"];
            this.expireDate = _data["expireDate"] ? moment(_data["expireDate"].toString()) : <any>undefined;
            this.externalId = _data["externalId"];
            if (Array.isArray(_data["productPrices"])) {
                this.productPrices = [] as any;
                for (let item of _data["productPrices"])
                    this.productPrices.push(ProductPrice.fromJS(item));
            }
            if (Array.isArray(_data["stores"])) {
                this.stores = [] as any;
                for (let item of _data["stores"])
                    this.stores.push(Store.fromJS(item));
            }
            if (Array.isArray(_data["ecommercePromotions"])) {
                this.ecommercePromotions = [] as any;
                for (let item of _data["ecommercePromotions"])
                    this.ecommercePromotions.push(EcommercePromotion.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PriceList {
        data = typeof data === 'object' ? data : {};
        let result = new PriceList();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tenantId"] = this.tenantId;
        data["isDeleted"] = this.isDeleted;
        data["name"] = this.name;
        data["isActive"] = this.isActive;
        data["expireDate"] = this.expireDate ? this.expireDate.toISOString() : <any>undefined;
        data["externalId"] = this.externalId;
        if (Array.isArray(this.productPrices)) {
            data["productPrices"] = [];
            for (let item of this.productPrices)
                data["productPrices"].push(item.toJSON());
        }
        if (Array.isArray(this.stores)) {
            data["stores"] = [];
            for (let item of this.stores)
                data["stores"].push(item.toJSON());
        }
        if (Array.isArray(this.ecommercePromotions)) {
            data["ecommercePromotions"] = [];
            for (let item of this.ecommercePromotions)
                data["ecommercePromotions"].push(item.toJSON());
        }
        return data;
    }

    clone(): PriceList {
        const json = this.toJSON();
        let result = new PriceList();
        result.init(json);
        return result;
    }
}

export interface IPriceList {
    id: number;
    tenantId: number | undefined;
    isDeleted: boolean;
    name: string | undefined;
    isActive: boolean;
    expireDate: moment.Moment | undefined;
    externalId: number | undefined;
    productPrices: ProductPrice[] | undefined;
    stores: Store[] | undefined;
    ecommercePromotions: EcommercePromotion[] | undefined;
}

export class PriceListDto implements IPriceListDto {
    id: number;
    tenantId: number | undefined;
    name: string | undefined;
    isActive: boolean;
    expireDate: moment.Moment | undefined;
    listStores: StoreDto[] | undefined;
    listProductPrices: ProductPriceDto[] | undefined;
    prices: PricesDto;
    isCopy: boolean;

    constructor(data?: IPriceListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tenantId = _data["tenantId"];
            this.name = _data["name"];
            this.isActive = _data["isActive"];
            this.expireDate = _data["expireDate"] ? moment(_data["expireDate"].toString()) : <any>undefined;
            if (Array.isArray(_data["listStores"])) {
                this.listStores = [] as any;
                for (let item of _data["listStores"])
                    this.listStores.push(StoreDto.fromJS(item));
            }
            if (Array.isArray(_data["listProductPrices"])) {
                this.listProductPrices = [] as any;
                for (let item of _data["listProductPrices"])
                    this.listProductPrices.push(ProductPriceDto.fromJS(item));
            }
            this.prices = _data["prices"] ? PricesDto.fromJS(_data["prices"]) : <any>undefined;
            this.isCopy = _data["isCopy"];
        }
    }

    static fromJS(data: any): PriceListDto {
        data = typeof data === 'object' ? data : {};
        let result = new PriceListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tenantId"] = this.tenantId;
        data["name"] = this.name;
        data["isActive"] = this.isActive;
        data["expireDate"] = this.expireDate ? this.expireDate.toISOString() : <any>undefined;
        if (Array.isArray(this.listStores)) {
            data["listStores"] = [];
            for (let item of this.listStores)
                data["listStores"].push(item.toJSON());
        }
        if (Array.isArray(this.listProductPrices)) {
            data["listProductPrices"] = [];
            for (let item of this.listProductPrices)
                data["listProductPrices"].push(item.toJSON());
        }
        data["prices"] = this.prices ? this.prices.toJSON() : <any>undefined;
        data["isCopy"] = this.isCopy;
        return data;
    }

    clone(): PriceListDto {
        const json = this.toJSON();
        let result = new PriceListDto();
        result.init(json);
        return result;
    }
}

export interface IPriceListDto {
    id: number;
    tenantId: number | undefined;
    name: string | undefined;
    isActive: boolean;
    expireDate: moment.Moment | undefined;
    listStores: StoreDto[] | undefined;
    listProductPrices: ProductPriceDto[] | undefined;
    prices: PricesDto;
    isCopy: boolean;
}

export class PriceListDtoPagedResultDto implements IPriceListDtoPagedResultDto {
    items: PriceListDto[] | undefined;
    totalCount: number;

    constructor(data?: IPriceListDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(PriceListDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): PriceListDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new PriceListDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): PriceListDtoPagedResultDto {
        const json = this.toJSON();
        let result = new PriceListDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IPriceListDtoPagedResultDto {
    items: PriceListDto[] | undefined;
    totalCount: number;
}

export class PricesDto implements IPricesDto {
    price: number;
    discount1: number;
    expense: number;
    base: number;

    constructor(data?: IPricesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.price = _data["price"];
            this.discount1 = _data["discount1"];
            this.expense = _data["expense"];
            this.base = _data["base"];
        }
    }

    static fromJS(data: any): PricesDto {
        data = typeof data === 'object' ? data : {};
        let result = new PricesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["price"] = this.price;
        data["discount1"] = this.discount1;
        data["expense"] = this.expense;
        data["base"] = this.base;
        return data;
    }

    clone(): PricesDto {
        const json = this.toJSON();
        let result = new PricesDto();
        result.init(json);
        return result;
    }
}

export interface IPricesDto {
    price: number;
    discount1: number;
    expense: number;
    base: number;
}

export class Printer implements IPrinter {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    tenantId: number | undefined;
    name: string | undefined;
    connId: string | undefined;
    ip: string | undefined;
    token: string | undefined;
    readonly version: string | undefined;
    online: boolean;
    softwareId: number;
    software: Software;
    speed: string | undefined;
    port: string | undefined;
    printerType: PrinterType;
    path: string | undefined;
    salePoints: SalePoint[] | undefined;

    constructor(data?: IPrinter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.tenantId = _data["tenantId"];
            this.name = _data["name"];
            this.connId = _data["connId"];
            this.ip = _data["ip"];
            this.token = _data["token"];
            (<any>this).version = _data["version"];
            this.online = _data["online"];
            this.softwareId = _data["softwareId"];
            this.software = _data["software"] ? Software.fromJS(_data["software"]) : <any>undefined;
            this.speed = _data["speed"];
            this.port = _data["port"];
            this.printerType = _data["printerType"];
            this.path = _data["path"];
            if (Array.isArray(_data["salePoints"])) {
                this.salePoints = [] as any;
                for (let item of _data["salePoints"])
                    this.salePoints.push(SalePoint.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Printer {
        data = typeof data === 'object' ? data : {};
        let result = new Printer();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["tenantId"] = this.tenantId;
        data["name"] = this.name;
        data["connId"] = this.connId;
        data["ip"] = this.ip;
        data["token"] = this.token;
        data["version"] = this.version;
        data["online"] = this.online;
        data["softwareId"] = this.softwareId;
        data["software"] = this.software ? this.software.toJSON() : <any>undefined;
        data["speed"] = this.speed;
        data["port"] = this.port;
        data["printerType"] = this.printerType;
        data["path"] = this.path;
        if (Array.isArray(this.salePoints)) {
            data["salePoints"] = [];
            for (let item of this.salePoints)
                data["salePoints"].push(item.toJSON());
        }
        return data;
    }

    clone(): Printer {
        const json = this.toJSON();
        let result = new Printer();
        result.init(json);
        return result;
    }
}

export interface IPrinter {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    tenantId: number | undefined;
    name: string | undefined;
    connId: string | undefined;
    ip: string | undefined;
    token: string | undefined;
    version: string | undefined;
    online: boolean;
    softwareId: number;
    software: Software;
    speed: string | undefined;
    port: string | undefined;
    printerType: PrinterType;
    path: string | undefined;
    salePoints: SalePoint[] | undefined;
}

export class PrinterDto implements IPrinterDto {
    id: number;
    tenantId: number | undefined;
    connId: string | undefined;
    name: string | undefined;
    ip: string | undefined;
    token: string | undefined;
    version: string | undefined;
    online: boolean;
    softwareId: number;
    softwareName: string | undefined;
    speed: string | undefined;
    port: string | undefined;
    printerType: PrinterType;
    readonly printerTypeName: string | undefined;

    constructor(data?: IPrinterDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tenantId = _data["tenantId"];
            this.connId = _data["connId"];
            this.name = _data["name"];
            this.ip = _data["ip"];
            this.token = _data["token"];
            this.version = _data["version"];
            this.online = _data["online"];
            this.softwareId = _data["softwareId"];
            this.softwareName = _data["softwareName"];
            this.speed = _data["speed"];
            this.port = _data["port"];
            this.printerType = _data["printerType"];
            (<any>this).printerTypeName = _data["printerTypeName"];
        }
    }

    static fromJS(data: any): PrinterDto {
        data = typeof data === 'object' ? data : {};
        let result = new PrinterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tenantId"] = this.tenantId;
        data["connId"] = this.connId;
        data["name"] = this.name;
        data["ip"] = this.ip;
        data["token"] = this.token;
        data["version"] = this.version;
        data["online"] = this.online;
        data["softwareId"] = this.softwareId;
        data["softwareName"] = this.softwareName;
        data["speed"] = this.speed;
        data["port"] = this.port;
        data["printerType"] = this.printerType;
        data["printerTypeName"] = this.printerTypeName;
        return data;
    }

    clone(): PrinterDto {
        const json = this.toJSON();
        let result = new PrinterDto();
        result.init(json);
        return result;
    }
}

export interface IPrinterDto {
    id: number;
    tenantId: number | undefined;
    connId: string | undefined;
    name: string | undefined;
    ip: string | undefined;
    token: string | undefined;
    version: string | undefined;
    online: boolean;
    softwareId: number;
    softwareName: string | undefined;
    speed: string | undefined;
    port: string | undefined;
    printerType: PrinterType;
    printerTypeName: string | undefined;
}

export class PrinterDtoPagedResultDto implements IPrinterDtoPagedResultDto {
    items: PrinterDto[] | undefined;
    totalCount: number;

    constructor(data?: IPrinterDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(PrinterDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): PrinterDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new PrinterDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): PrinterDtoPagedResultDto {
        const json = this.toJSON();
        let result = new PrinterDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IPrinterDtoPagedResultDto {
    items: PrinterDto[] | undefined;
    totalCount: number;
}

export class PrinterInsertDto implements IPrinterInsertDto {
    id: number;
    tenantId: number | undefined;
    name: string | undefined;
    token: string | undefined;
    softwareId: number;
    speed: string | undefined;
    port: string | undefined;
    path: string | undefined;
    printerType: PrinterType;

    constructor(data?: IPrinterInsertDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tenantId = _data["tenantId"];
            this.name = _data["name"];
            this.token = _data["token"];
            this.softwareId = _data["softwareId"];
            this.speed = _data["speed"];
            this.port = _data["port"];
            this.path = _data["path"];
            this.printerType = _data["printerType"];
        }
    }

    static fromJS(data: any): PrinterInsertDto {
        data = typeof data === 'object' ? data : {};
        let result = new PrinterInsertDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tenantId"] = this.tenantId;
        data["name"] = this.name;
        data["token"] = this.token;
        data["softwareId"] = this.softwareId;
        data["speed"] = this.speed;
        data["port"] = this.port;
        data["path"] = this.path;
        data["printerType"] = this.printerType;
        return data;
    }

    clone(): PrinterInsertDto {
        const json = this.toJSON();
        let result = new PrinterInsertDto();
        result.init(json);
        return result;
    }
}

export interface IPrinterInsertDto {
    id: number;
    tenantId: number | undefined;
    name: string | undefined;
    token: string | undefined;
    softwareId: number;
    speed: string | undefined;
    port: string | undefined;
    path: string | undefined;
    printerType: PrinterType;
}

export enum PrinterType {
    Epson = <any>"Epson",
    Hasar = <any>"Hasar",
}

export class ProcessLogDto implements IProcessLogDto {
    id: number;
    processImportId: string | undefined;
    date: moment.Moment;
    totalRegister: number;
    totalProgess: number;
    pages: number;
    status: ProcessLogStatus;
    processLogInfos: ProcessLogInfoDto[] | undefined;

    constructor(data?: IProcessLogDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.processImportId = _data["processImportId"];
            this.date = _data["date"] ? moment(_data["date"].toString()) : <any>undefined;
            this.totalRegister = _data["totalRegister"];
            this.totalProgess = _data["totalProgess"];
            this.pages = _data["pages"];
            this.status = _data["status"];
            if (Array.isArray(_data["processLogInfos"])) {
                this.processLogInfos = [] as any;
                for (let item of _data["processLogInfos"])
                    this.processLogInfos.push(ProcessLogInfoDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProcessLogDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProcessLogDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["processImportId"] = this.processImportId;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["totalRegister"] = this.totalRegister;
        data["totalProgess"] = this.totalProgess;
        data["pages"] = this.pages;
        data["status"] = this.status;
        if (Array.isArray(this.processLogInfos)) {
            data["processLogInfos"] = [];
            for (let item of this.processLogInfos)
                data["processLogInfos"].push(item.toJSON());
        }
        return data;
    }

    clone(): ProcessLogDto {
        const json = this.toJSON();
        let result = new ProcessLogDto();
        result.init(json);
        return result;
    }
}

export interface IProcessLogDto {
    id: number;
    processImportId: string | undefined;
    date: moment.Moment;
    totalRegister: number;
    totalProgess: number;
    pages: number;
    status: ProcessLogStatus;
    processLogInfos: ProcessLogInfoDto[] | undefined;
}

export class ProcessLogDtoPagedResultDto implements IProcessLogDtoPagedResultDto {
    items: ProcessLogDto[] | undefined;
    totalCount: number;

    constructor(data?: IProcessLogDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(ProcessLogDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): ProcessLogDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProcessLogDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): ProcessLogDtoPagedResultDto {
        const json = this.toJSON();
        let result = new ProcessLogDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IProcessLogDtoPagedResultDto {
    items: ProcessLogDto[] | undefined;
    totalCount: number;
}

export class ProcessLogInfoDto implements IProcessLogInfoDto {
    id: number;
    message: string | undefined;
    date: moment.Moment;

    constructor(data?: IProcessLogInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.message = _data["message"];
            this.date = _data["date"] ? moment(_data["date"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ProcessLogInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProcessLogInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["message"] = this.message;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        return data;
    }

    clone(): ProcessLogInfoDto {
        const json = this.toJSON();
        let result = new ProcessLogInfoDto();
        result.init(json);
        return result;
    }
}

export interface IProcessLogInfoDto {
    id: number;
    message: string | undefined;
    date: moment.Moment;
}

export enum ProcessLogStatus {
    Initialized = <any>"Initialized",
    Success = <any>"Success",
    Pending = <any>"Pending",
    Error = <any>"Error",
}

export class Product implements IProduct {
    id: number;
    tenantId: number | undefined;
    isDeleted: boolean;
    name: string | undefined;
    isActive: boolean;
    code: string | undefined;
    barcode: string | undefined;
    isEam: boolean;
    imported: boolean;
    description: string | undefined;
    notInStores: string | undefined;
    useStock: boolean;
    isGeneric: boolean;
    isGiftCard: boolean;
    minStock: number;
    externalId: number | undefined;
    processImportId: string | undefined;
    gtin: string | undefined;
    hasDecimalQuantity: boolean;
    fileAttachmentId: number | undefined;
    fileAttachment: FileAttachment;
    productProperties: ProductProperty[] | undefined;
    productFeatures: ProductFeature[] | undefined;
    variants: Variant[] | undefined;
    invoiceProducts: InvoiceProduct[] | undefined;
    stockMovements: StockMovement[] | undefined;
    stocks: Stock[] | undefined;
    productPrices: ProductPrice[] | undefined;

    constructor(data?: IProduct) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tenantId = _data["tenantId"];
            this.isDeleted = _data["isDeleted"];
            this.name = _data["name"];
            this.isActive = _data["isActive"];
            this.code = _data["code"];
            this.barcode = _data["barcode"];
            this.isEam = _data["isEam"];
            this.imported = _data["imported"];
            this.description = _data["description"];
            this.notInStores = _data["notInStores"];
            this.useStock = _data["useStock"];
            this.isGeneric = _data["isGeneric"];
            this.isGiftCard = _data["isGiftCard"];
            this.minStock = _data["minStock"];
            this.externalId = _data["externalId"];
            this.processImportId = _data["processImportId"];
            this.gtin = _data["gtin"];
            this.hasDecimalQuantity = _data["hasDecimalQuantity"];
            this.fileAttachmentId = _data["fileAttachmentId"];
            this.fileAttachment = _data["fileAttachment"] ? FileAttachment.fromJS(_data["fileAttachment"]) : <any>undefined;
            if (Array.isArray(_data["productProperties"])) {
                this.productProperties = [] as any;
                for (let item of _data["productProperties"])
                    this.productProperties.push(ProductProperty.fromJS(item));
            }
            if (Array.isArray(_data["productFeatures"])) {
                this.productFeatures = [] as any;
                for (let item of _data["productFeatures"])
                    this.productFeatures.push(ProductFeature.fromJS(item));
            }
            if (Array.isArray(_data["variants"])) {
                this.variants = [] as any;
                for (let item of _data["variants"])
                    this.variants.push(Variant.fromJS(item));
            }
            if (Array.isArray(_data["invoiceProducts"])) {
                this.invoiceProducts = [] as any;
                for (let item of _data["invoiceProducts"])
                    this.invoiceProducts.push(InvoiceProduct.fromJS(item));
            }
            if (Array.isArray(_data["stockMovements"])) {
                this.stockMovements = [] as any;
                for (let item of _data["stockMovements"])
                    this.stockMovements.push(StockMovement.fromJS(item));
            }
            if (Array.isArray(_data["stocks"])) {
                this.stocks = [] as any;
                for (let item of _data["stocks"])
                    this.stocks.push(Stock.fromJS(item));
            }
            if (Array.isArray(_data["productPrices"])) {
                this.productPrices = [] as any;
                for (let item of _data["productPrices"])
                    this.productPrices.push(ProductPrice.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Product {
        data = typeof data === 'object' ? data : {};
        let result = new Product();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tenantId"] = this.tenantId;
        data["isDeleted"] = this.isDeleted;
        data["name"] = this.name;
        data["isActive"] = this.isActive;
        data["code"] = this.code;
        data["barcode"] = this.barcode;
        data["isEam"] = this.isEam;
        data["imported"] = this.imported;
        data["description"] = this.description;
        data["notInStores"] = this.notInStores;
        data["useStock"] = this.useStock;
        data["isGeneric"] = this.isGeneric;
        data["isGiftCard"] = this.isGiftCard;
        data["minStock"] = this.minStock;
        data["externalId"] = this.externalId;
        data["processImportId"] = this.processImportId;
        data["gtin"] = this.gtin;
        data["hasDecimalQuantity"] = this.hasDecimalQuantity;
        data["fileAttachmentId"] = this.fileAttachmentId;
        data["fileAttachment"] = this.fileAttachment ? this.fileAttachment.toJSON() : <any>undefined;
        if (Array.isArray(this.productProperties)) {
            data["productProperties"] = [];
            for (let item of this.productProperties)
                data["productProperties"].push(item.toJSON());
        }
        if (Array.isArray(this.productFeatures)) {
            data["productFeatures"] = [];
            for (let item of this.productFeatures)
                data["productFeatures"].push(item.toJSON());
        }
        if (Array.isArray(this.variants)) {
            data["variants"] = [];
            for (let item of this.variants)
                data["variants"].push(item.toJSON());
        }
        if (Array.isArray(this.invoiceProducts)) {
            data["invoiceProducts"] = [];
            for (let item of this.invoiceProducts)
                data["invoiceProducts"].push(item.toJSON());
        }
        if (Array.isArray(this.stockMovements)) {
            data["stockMovements"] = [];
            for (let item of this.stockMovements)
                data["stockMovements"].push(item.toJSON());
        }
        if (Array.isArray(this.stocks)) {
            data["stocks"] = [];
            for (let item of this.stocks)
                data["stocks"].push(item.toJSON());
        }
        if (Array.isArray(this.productPrices)) {
            data["productPrices"] = [];
            for (let item of this.productPrices)
                data["productPrices"].push(item.toJSON());
        }
        return data;
    }

    clone(): Product {
        const json = this.toJSON();
        let result = new Product();
        result.init(json);
        return result;
    }
}

export interface IProduct {
    id: number;
    tenantId: number | undefined;
    isDeleted: boolean;
    name: string | undefined;
    isActive: boolean;
    code: string | undefined;
    barcode: string | undefined;
    isEam: boolean;
    imported: boolean;
    description: string | undefined;
    notInStores: string | undefined;
    useStock: boolean;
    isGeneric: boolean;
    isGiftCard: boolean;
    minStock: number;
    externalId: number | undefined;
    processImportId: string | undefined;
    gtin: string | undefined;
    hasDecimalQuantity: boolean;
    fileAttachmentId: number | undefined;
    fileAttachment: FileAttachment;
    productProperties: ProductProperty[] | undefined;
    productFeatures: ProductFeature[] | undefined;
    variants: Variant[] | undefined;
    invoiceProducts: InvoiceProduct[] | undefined;
    stockMovements: StockMovement[] | undefined;
    stocks: Stock[] | undefined;
    productPrices: ProductPrice[] | undefined;
}

export class ProductBulkUpdateDto implements IProductBulkUpdateDto {
    id: number;
    tenantId: number | undefined;
    name: string | undefined;
    isActive: boolean;
    code: string | undefined;
    barcode: string | undefined;
    isEam: boolean;
    description: string | undefined;
    notInStores: string | undefined;
    useStock: boolean;
    isGiftCard: boolean;
    minStock: number;
    externalId: number;
    variantList: VariantBulkUpdateDto[] | undefined;
    propertyList: ProductPropertyBulkUpdateDto[] | undefined;

    constructor(data?: IProductBulkUpdateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tenantId = _data["tenantId"];
            this.name = _data["name"];
            this.isActive = _data["isActive"];
            this.code = _data["code"];
            this.barcode = _data["barcode"];
            this.isEam = _data["isEam"];
            this.description = _data["description"];
            this.notInStores = _data["notInStores"];
            this.useStock = _data["useStock"];
            this.isGiftCard = _data["isGiftCard"];
            this.minStock = _data["minStock"];
            this.externalId = _data["externalId"];
            if (Array.isArray(_data["variantList"])) {
                this.variantList = [] as any;
                for (let item of _data["variantList"])
                    this.variantList.push(VariantBulkUpdateDto.fromJS(item));
            }
            if (Array.isArray(_data["propertyList"])) {
                this.propertyList = [] as any;
                for (let item of _data["propertyList"])
                    this.propertyList.push(ProductPropertyBulkUpdateDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProductBulkUpdateDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProductBulkUpdateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tenantId"] = this.tenantId;
        data["name"] = this.name;
        data["isActive"] = this.isActive;
        data["code"] = this.code;
        data["barcode"] = this.barcode;
        data["isEam"] = this.isEam;
        data["description"] = this.description;
        data["notInStores"] = this.notInStores;
        data["useStock"] = this.useStock;
        data["isGiftCard"] = this.isGiftCard;
        data["minStock"] = this.minStock;
        data["externalId"] = this.externalId;
        if (Array.isArray(this.variantList)) {
            data["variantList"] = [];
            for (let item of this.variantList)
                data["variantList"].push(item.toJSON());
        }
        if (Array.isArray(this.propertyList)) {
            data["propertyList"] = [];
            for (let item of this.propertyList)
                data["propertyList"].push(item.toJSON());
        }
        return data;
    }

    clone(): ProductBulkUpdateDto {
        const json = this.toJSON();
        let result = new ProductBulkUpdateDto();
        result.init(json);
        return result;
    }
}

export interface IProductBulkUpdateDto {
    id: number;
    tenantId: number | undefined;
    name: string | undefined;
    isActive: boolean;
    code: string | undefined;
    barcode: string | undefined;
    isEam: boolean;
    description: string | undefined;
    notInStores: string | undefined;
    useStock: boolean;
    isGiftCard: boolean;
    minStock: number;
    externalId: number;
    variantList: VariantBulkUpdateDto[] | undefined;
    propertyList: ProductPropertyBulkUpdateDto[] | undefined;
}

export class ProductDto implements IProductDto {
    id: number;
    tenantId: number | undefined;
    name: string | undefined;
    isActive: boolean;
    isGeneric: boolean;
    code: string | undefined;
    barcode: string | undefined;
    isEam: boolean;
    description: string | undefined;
    notInStores: string | undefined;
    useStock: boolean;
    isGiftCard: boolean;
    promo12: boolean;
    minStock: number;
    gtin: string | undefined;
    hasDecimalQuantity: boolean;
    taxId: number;
    price: number;
    discount1: number;
    priceDiscount1: number;
    discount2: number;
    priceDiscount2: number;
    expense: number;
    utility: number;
    base: number;
    fileAttachmentId: number | undefined;
    currencyId: number;
    currencyQuote: number;
    propertyList: ProductPropertyDto[] | undefined;
    features: ProductFeatureDto[] | undefined;
    variantList: VariantDto[] | undefined;
    productPriceList: ProductPriceDto[] | undefined;

    constructor(data?: IProductDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tenantId = _data["tenantId"];
            this.name = _data["name"];
            this.isActive = _data["isActive"];
            this.isGeneric = _data["isGeneric"];
            this.code = _data["code"];
            this.barcode = _data["barcode"];
            this.isEam = _data["isEam"];
            this.description = _data["description"];
            this.notInStores = _data["notInStores"];
            this.useStock = _data["useStock"];
            this.isGiftCard = _data["isGiftCard"];
            this.promo12 = _data["promo12"];
            this.minStock = _data["minStock"];
            this.gtin = _data["gtin"];
            this.hasDecimalQuantity = _data["hasDecimalQuantity"];
            this.taxId = _data["taxId"];
            this.price = _data["price"];
            this.discount1 = _data["discount1"];
            this.priceDiscount1 = _data["priceDiscount1"];
            this.discount2 = _data["discount2"];
            this.priceDiscount2 = _data["priceDiscount2"];
            this.expense = _data["expense"];
            this.utility = _data["utility"];
            this.base = _data["base"];
            this.fileAttachmentId = _data["fileAttachmentId"];
            this.currencyId = _data["currencyId"];
            this.currencyQuote = _data["currencyQuote"];
            if (Array.isArray(_data["propertyList"])) {
                this.propertyList = [] as any;
                for (let item of _data["propertyList"])
                    this.propertyList.push(ProductPropertyDto.fromJS(item));
            }
            if (Array.isArray(_data["features"])) {
                this.features = [] as any;
                for (let item of _data["features"])
                    this.features.push(ProductFeatureDto.fromJS(item));
            }
            if (Array.isArray(_data["variantList"])) {
                this.variantList = [] as any;
                for (let item of _data["variantList"])
                    this.variantList.push(VariantDto.fromJS(item));
            }
            if (Array.isArray(_data["productPriceList"])) {
                this.productPriceList = [] as any;
                for (let item of _data["productPriceList"])
                    this.productPriceList.push(ProductPriceDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProductDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProductDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tenantId"] = this.tenantId;
        data["name"] = this.name;
        data["isActive"] = this.isActive;
        data["isGeneric"] = this.isGeneric;
        data["code"] = this.code;
        data["barcode"] = this.barcode;
        data["isEam"] = this.isEam;
        data["description"] = this.description;
        data["notInStores"] = this.notInStores;
        data["useStock"] = this.useStock;
        data["isGiftCard"] = this.isGiftCard;
        data["promo12"] = this.promo12;
        data["minStock"] = this.minStock;
        data["gtin"] = this.gtin;
        data["hasDecimalQuantity"] = this.hasDecimalQuantity;
        data["taxId"] = this.taxId;
        data["price"] = this.price;
        data["discount1"] = this.discount1;
        data["priceDiscount1"] = this.priceDiscount1;
        data["discount2"] = this.discount2;
        data["priceDiscount2"] = this.priceDiscount2;
        data["expense"] = this.expense;
        data["utility"] = this.utility;
        data["base"] = this.base;
        data["fileAttachmentId"] = this.fileAttachmentId;
        data["currencyId"] = this.currencyId;
        data["currencyQuote"] = this.currencyQuote;
        if (Array.isArray(this.propertyList)) {
            data["propertyList"] = [];
            for (let item of this.propertyList)
                data["propertyList"].push(item.toJSON());
        }
        if (Array.isArray(this.features)) {
            data["features"] = [];
            for (let item of this.features)
                data["features"].push(item.toJSON());
        }
        if (Array.isArray(this.variantList)) {
            data["variantList"] = [];
            for (let item of this.variantList)
                data["variantList"].push(item.toJSON());
        }
        if (Array.isArray(this.productPriceList)) {
            data["productPriceList"] = [];
            for (let item of this.productPriceList)
                data["productPriceList"].push(item.toJSON());
        }
        return data;
    }

    clone(): ProductDto {
        const json = this.toJSON();
        let result = new ProductDto();
        result.init(json);
        return result;
    }
}

export interface IProductDto {
    id: number;
    tenantId: number | undefined;
    name: string | undefined;
    isActive: boolean;
    isGeneric: boolean;
    code: string | undefined;
    barcode: string | undefined;
    isEam: boolean;
    description: string | undefined;
    notInStores: string | undefined;
    useStock: boolean;
    isGiftCard: boolean;
    promo12: boolean;
    minStock: number;
    gtin: string | undefined;
    hasDecimalQuantity: boolean;
    taxId: number;
    price: number;
    discount1: number;
    priceDiscount1: number;
    discount2: number;
    priceDiscount2: number;
    expense: number;
    utility: number;
    base: number;
    fileAttachmentId: number | undefined;
    currencyId: number;
    currencyQuote: number;
    propertyList: ProductPropertyDto[] | undefined;
    features: ProductFeatureDto[] | undefined;
    variantList: VariantDto[] | undefined;
    productPriceList: ProductPriceDto[] | undefined;
}

export class ProductFeature implements IProductFeature {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    tenantId: number | undefined;
    name: string | undefined;
    productId: number;
    featureId: number;
    product: Product;
    feature: Feature;

    constructor(data?: IProductFeature) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.tenantId = _data["tenantId"];
            this.name = _data["name"];
            this.productId = _data["productId"];
            this.featureId = _data["featureId"];
            this.product = _data["product"] ? Product.fromJS(_data["product"]) : <any>undefined;
            this.feature = _data["feature"] ? Feature.fromJS(_data["feature"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ProductFeature {
        data = typeof data === 'object' ? data : {};
        let result = new ProductFeature();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["tenantId"] = this.tenantId;
        data["name"] = this.name;
        data["productId"] = this.productId;
        data["featureId"] = this.featureId;
        data["product"] = this.product ? this.product.toJSON() : <any>undefined;
        data["feature"] = this.feature ? this.feature.toJSON() : <any>undefined;
        return data;
    }

    clone(): ProductFeature {
        const json = this.toJSON();
        let result = new ProductFeature();
        result.init(json);
        return result;
    }
}

export interface IProductFeature {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    tenantId: number | undefined;
    name: string | undefined;
    productId: number;
    featureId: number;
    product: Product;
    feature: Feature;
}

export class ProductFeatureDto implements IProductFeatureDto {
    name: string | undefined;
    productId: number;
    featureId: number;

    constructor(data?: IProductFeatureDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.productId = _data["productId"];
            this.featureId = _data["featureId"];
        }
    }

    static fromJS(data: any): ProductFeatureDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProductFeatureDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["productId"] = this.productId;
        data["featureId"] = this.featureId;
        return data;
    }

    clone(): ProductFeatureDto {
        const json = this.toJSON();
        let result = new ProductFeatureDto();
        result.init(json);
        return result;
    }
}

export interface IProductFeatureDto {
    name: string | undefined;
    productId: number;
    featureId: number;
}

export class ProductGroupDto implements IProductGroupDto {
    id: number;
    name: string | undefined;
    isActive: boolean;

    constructor(data?: IProductGroupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): ProductGroupDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProductGroupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["isActive"] = this.isActive;
        return data;
    }

    clone(): ProductGroupDto {
        const json = this.toJSON();
        let result = new ProductGroupDto();
        result.init(json);
        return result;
    }
}

export interface IProductGroupDto {
    id: number;
    name: string | undefined;
    isActive: boolean;
}

export class ProductGroupDtoPagedResultDto implements IProductGroupDtoPagedResultDto {
    items: ProductGroupDto[] | undefined;
    totalCount: number;

    constructor(data?: IProductGroupDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(ProductGroupDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): ProductGroupDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProductGroupDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): ProductGroupDtoPagedResultDto {
        const json = this.toJSON();
        let result = new ProductGroupDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IProductGroupDtoPagedResultDto {
    items: ProductGroupDto[] | undefined;
    totalCount: number;
}

export class ProductInformationDto implements IProductInformationDto {
    productId: number;
    variantId: number | undefined;
    name: string | undefined;
    code: string | undefined;
    barcode: string | undefined;
    description: string | undefined;
    price: number;
    totalStock: number;
    readonly nameWithoutCode: string | undefined;

    constructor(data?: IProductInformationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productId = _data["productId"];
            this.variantId = _data["variantId"];
            this.name = _data["name"];
            this.code = _data["code"];
            this.barcode = _data["barcode"];
            this.description = _data["description"];
            this.price = _data["price"];
            this.totalStock = _data["totalStock"];
            (<any>this).nameWithoutCode = _data["nameWithoutCode"];
        }
    }

    static fromJS(data: any): ProductInformationDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProductInformationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productId"] = this.productId;
        data["variantId"] = this.variantId;
        data["name"] = this.name;
        data["code"] = this.code;
        data["barcode"] = this.barcode;
        data["description"] = this.description;
        data["price"] = this.price;
        data["totalStock"] = this.totalStock;
        data["nameWithoutCode"] = this.nameWithoutCode;
        return data;
    }

    clone(): ProductInformationDto {
        const json = this.toJSON();
        let result = new ProductInformationDto();
        result.init(json);
        return result;
    }
}

export interface IProductInformationDto {
    productId: number;
    variantId: number | undefined;
    name: string | undefined;
    code: string | undefined;
    barcode: string | undefined;
    description: string | undefined;
    price: number;
    totalStock: number;
    nameWithoutCode: string | undefined;
}

export class ProductInformationDtoPagedResultDto implements IProductInformationDtoPagedResultDto {
    items: ProductInformationDto[] | undefined;
    totalCount: number;

    constructor(data?: IProductInformationDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(ProductInformationDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): ProductInformationDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProductInformationDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): ProductInformationDtoPagedResultDto {
        const json = this.toJSON();
        let result = new ProductInformationDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IProductInformationDtoPagedResultDto {
    items: ProductInformationDto[] | undefined;
    totalCount: number;
}

export class ProductInputDto implements IProductInputDto {
    id: number;
    name: string | undefined;
    code: string | undefined;
    description: string | undefined;
    useStock: boolean;
    isGiftCard: boolean;
    isGeneric: boolean;
    promo12: boolean;
    notInStores: string | undefined;
    taxId: number;
    currencyId: number;
    price: number;
    discount1: number;
    priceDiscount1: number;
    discount2: number;
    priceDiscount2: number;
    expense: number;
    utility: number;
    minStock: number;
    base: number;
    barcode: string | undefined;
    isEam: boolean;
    fileAttachmentId: number | undefined;
    isActive: boolean;
    gtin: string | undefined;
    externalId: number | undefined;
    hasDecimalQuantity: boolean;
    propertyList: ProductPropertyInputDto[] | undefined;
    variantList: VariantInputDto[] | undefined;

    constructor(data?: IProductInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.code = _data["code"];
            this.description = _data["description"];
            this.useStock = _data["useStock"];
            this.isGiftCard = _data["isGiftCard"];
            this.isGeneric = _data["isGeneric"];
            this.promo12 = _data["promo12"];
            this.notInStores = _data["notInStores"];
            this.taxId = _data["taxId"];
            this.currencyId = _data["currencyId"];
            this.price = _data["price"];
            this.discount1 = _data["discount1"];
            this.priceDiscount1 = _data["priceDiscount1"];
            this.discount2 = _data["discount2"];
            this.priceDiscount2 = _data["priceDiscount2"];
            this.expense = _data["expense"];
            this.utility = _data["utility"];
            this.minStock = _data["minStock"];
            this.base = _data["base"];
            this.barcode = _data["barcode"];
            this.isEam = _data["isEam"];
            this.fileAttachmentId = _data["fileAttachmentId"];
            this.isActive = _data["isActive"];
            this.gtin = _data["gtin"];
            this.externalId = _data["externalId"];
            this.hasDecimalQuantity = _data["hasDecimalQuantity"];
            if (Array.isArray(_data["propertyList"])) {
                this.propertyList = [] as any;
                for (let item of _data["propertyList"])
                    this.propertyList.push(ProductPropertyInputDto.fromJS(item));
            }
            if (Array.isArray(_data["variantList"])) {
                this.variantList = [] as any;
                for (let item of _data["variantList"])
                    this.variantList.push(VariantInputDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProductInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProductInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["code"] = this.code;
        data["description"] = this.description;
        data["useStock"] = this.useStock;
        data["isGiftCard"] = this.isGiftCard;
        data["isGeneric"] = this.isGeneric;
        data["promo12"] = this.promo12;
        data["notInStores"] = this.notInStores;
        data["taxId"] = this.taxId;
        data["currencyId"] = this.currencyId;
        data["price"] = this.price;
        data["discount1"] = this.discount1;
        data["priceDiscount1"] = this.priceDiscount1;
        data["discount2"] = this.discount2;
        data["priceDiscount2"] = this.priceDiscount2;
        data["expense"] = this.expense;
        data["utility"] = this.utility;
        data["minStock"] = this.minStock;
        data["base"] = this.base;
        data["barcode"] = this.barcode;
        data["isEam"] = this.isEam;
        data["fileAttachmentId"] = this.fileAttachmentId;
        data["isActive"] = this.isActive;
        data["gtin"] = this.gtin;
        data["externalId"] = this.externalId;
        data["hasDecimalQuantity"] = this.hasDecimalQuantity;
        if (Array.isArray(this.propertyList)) {
            data["propertyList"] = [];
            for (let item of this.propertyList)
                data["propertyList"].push(item.toJSON());
        }
        if (Array.isArray(this.variantList)) {
            data["variantList"] = [];
            for (let item of this.variantList)
                data["variantList"].push(item.toJSON());
        }
        return data;
    }

    clone(): ProductInputDto {
        const json = this.toJSON();
        let result = new ProductInputDto();
        result.init(json);
        return result;
    }
}

export interface IProductInputDto {
    id: number;
    name: string | undefined;
    code: string | undefined;
    description: string | undefined;
    useStock: boolean;
    isGiftCard: boolean;
    isGeneric: boolean;
    promo12: boolean;
    notInStores: string | undefined;
    taxId: number;
    currencyId: number;
    price: number;
    discount1: number;
    priceDiscount1: number;
    discount2: number;
    priceDiscount2: number;
    expense: number;
    utility: number;
    minStock: number;
    base: number;
    barcode: string | undefined;
    isEam: boolean;
    fileAttachmentId: number | undefined;
    isActive: boolean;
    gtin: string | undefined;
    externalId: number | undefined;
    hasDecimalQuantity: boolean;
    propertyList: ProductPropertyInputDto[] | undefined;
    variantList: VariantInputDto[] | undefined;
}

export class ProductInvoiceDto implements IProductInvoiceDto {
    id: number;
    tenantId: number | undefined;
    name: string | undefined;
    code: string | undefined;
    barcode: string | undefined;
    isEam: boolean;
    description: string | undefined;
    notInStores: string | undefined;
    useStock: boolean;
    isGiftCard: boolean;
    promo12: boolean;
    gtin: string | undefined;
    taxId: number;
    taxValue: number;
    currency: string | undefined;
    quote: number;
    price: number;
    basePrice: number;
    discount1: number;
    priceDiscount1: number;
    discount2: number;
    priceDiscount2: number;
    expense: number;
    utility: number;
    base: number;
    quantity: number;
    documentationQuantity: number;
    variantId: number | undefined;
    colorId: number;
    sizeId: number;
    isVariant: boolean;
    stock: number;
    externalId: number | undefined;
    isTransitProduct: boolean;
    hasDecimalQuantity: boolean;
    listDiscounts: number[] | undefined;
    hasPromotionInOriginalInvoice: boolean;
    listPromotionData: PromotionProductDto[] | undefined;

    constructor(data?: IProductInvoiceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tenantId = _data["tenantId"];
            this.name = _data["name"];
            this.code = _data["code"];
            this.barcode = _data["barcode"];
            this.isEam = _data["isEam"];
            this.description = _data["description"];
            this.notInStores = _data["notInStores"];
            this.useStock = _data["useStock"];
            this.isGiftCard = _data["isGiftCard"];
            this.promo12 = _data["promo12"];
            this.gtin = _data["gtin"];
            this.taxId = _data["taxId"];
            this.taxValue = _data["taxValue"];
            this.currency = _data["currency"];
            this.quote = _data["quote"];
            this.price = _data["price"];
            this.basePrice = _data["basePrice"];
            this.discount1 = _data["discount1"];
            this.priceDiscount1 = _data["priceDiscount1"];
            this.discount2 = _data["discount2"];
            this.priceDiscount2 = _data["priceDiscount2"];
            this.expense = _data["expense"];
            this.utility = _data["utility"];
            this.base = _data["base"];
            this.quantity = _data["quantity"];
            this.documentationQuantity = _data["documentationQuantity"];
            this.variantId = _data["variantId"];
            this.colorId = _data["colorId"];
            this.sizeId = _data["sizeId"];
            this.isVariant = _data["isVariant"];
            this.stock = _data["stock"];
            this.externalId = _data["externalId"];
            this.isTransitProduct = _data["isTransitProduct"];
            this.hasDecimalQuantity = _data["hasDecimalQuantity"];
            if (Array.isArray(_data["listDiscounts"])) {
                this.listDiscounts = [] as any;
                for (let item of _data["listDiscounts"])
                    this.listDiscounts.push(item);
            }
            this.hasPromotionInOriginalInvoice = _data["hasPromotionInOriginalInvoice"];
            if (Array.isArray(_data["listPromotionData"])) {
                this.listPromotionData = [] as any;
                for (let item of _data["listPromotionData"])
                    this.listPromotionData.push(PromotionProductDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProductInvoiceDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProductInvoiceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tenantId"] = this.tenantId;
        data["name"] = this.name;
        data["code"] = this.code;
        data["barcode"] = this.barcode;
        data["isEam"] = this.isEam;
        data["description"] = this.description;
        data["notInStores"] = this.notInStores;
        data["useStock"] = this.useStock;
        data["isGiftCard"] = this.isGiftCard;
        data["promo12"] = this.promo12;
        data["gtin"] = this.gtin;
        data["taxId"] = this.taxId;
        data["taxValue"] = this.taxValue;
        data["currency"] = this.currency;
        data["quote"] = this.quote;
        data["price"] = this.price;
        data["basePrice"] = this.basePrice;
        data["discount1"] = this.discount1;
        data["priceDiscount1"] = this.priceDiscount1;
        data["discount2"] = this.discount2;
        data["priceDiscount2"] = this.priceDiscount2;
        data["expense"] = this.expense;
        data["utility"] = this.utility;
        data["base"] = this.base;
        data["quantity"] = this.quantity;
        data["documentationQuantity"] = this.documentationQuantity;
        data["variantId"] = this.variantId;
        data["colorId"] = this.colorId;
        data["sizeId"] = this.sizeId;
        data["isVariant"] = this.isVariant;
        data["stock"] = this.stock;
        data["externalId"] = this.externalId;
        data["isTransitProduct"] = this.isTransitProduct;
        data["hasDecimalQuantity"] = this.hasDecimalQuantity;
        if (Array.isArray(this.listDiscounts)) {
            data["listDiscounts"] = [];
            for (let item of this.listDiscounts)
                data["listDiscounts"].push(item);
        }
        data["hasPromotionInOriginalInvoice"] = this.hasPromotionInOriginalInvoice;
        if (Array.isArray(this.listPromotionData)) {
            data["listPromotionData"] = [];
            for (let item of this.listPromotionData)
                data["listPromotionData"].push(item.toJSON());
        }
        return data;
    }

    clone(): ProductInvoiceDto {
        const json = this.toJSON();
        let result = new ProductInvoiceDto();
        result.init(json);
        return result;
    }
}

export interface IProductInvoiceDto {
    id: number;
    tenantId: number | undefined;
    name: string | undefined;
    code: string | undefined;
    barcode: string | undefined;
    isEam: boolean;
    description: string | undefined;
    notInStores: string | undefined;
    useStock: boolean;
    isGiftCard: boolean;
    promo12: boolean;
    gtin: string | undefined;
    taxId: number;
    taxValue: number;
    currency: string | undefined;
    quote: number;
    price: number;
    basePrice: number;
    discount1: number;
    priceDiscount1: number;
    discount2: number;
    priceDiscount2: number;
    expense: number;
    utility: number;
    base: number;
    quantity: number;
    documentationQuantity: number;
    variantId: number | undefined;
    colorId: number;
    sizeId: number;
    isVariant: boolean;
    stock: number;
    externalId: number | undefined;
    isTransitProduct: boolean;
    hasDecimalQuantity: boolean;
    listDiscounts: number[] | undefined;
    hasPromotionInOriginalInvoice: boolean;
    listPromotionData: PromotionProductDto[] | undefined;
}

export class ProductListDto implements IProductListDto {
    id: number;
    tenantId: number | undefined;
    name: string | undefined;
    propertyValues: string | undefined;
    propertyValuesName: string[] | undefined;
    includedProducts: string | undefined;
    keywords: string | undefined;
    isActive: boolean;
    exclude: boolean;

    constructor(data?: IProductListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tenantId = _data["tenantId"];
            this.name = _data["name"];
            this.propertyValues = _data["propertyValues"];
            if (Array.isArray(_data["propertyValuesName"])) {
                this.propertyValuesName = [] as any;
                for (let item of _data["propertyValuesName"])
                    this.propertyValuesName.push(item);
            }
            this.includedProducts = _data["includedProducts"];
            this.keywords = _data["keywords"];
            this.isActive = _data["isActive"];
            this.exclude = _data["exclude"];
        }
    }

    static fromJS(data: any): ProductListDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProductListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tenantId"] = this.tenantId;
        data["name"] = this.name;
        data["propertyValues"] = this.propertyValues;
        if (Array.isArray(this.propertyValuesName)) {
            data["propertyValuesName"] = [];
            for (let item of this.propertyValuesName)
                data["propertyValuesName"].push(item);
        }
        data["includedProducts"] = this.includedProducts;
        data["keywords"] = this.keywords;
        data["isActive"] = this.isActive;
        data["exclude"] = this.exclude;
        return data;
    }

    clone(): ProductListDto {
        const json = this.toJSON();
        let result = new ProductListDto();
        result.init(json);
        return result;
    }
}

export interface IProductListDto {
    id: number;
    tenantId: number | undefined;
    name: string | undefined;
    propertyValues: string | undefined;
    propertyValuesName: string[] | undefined;
    includedProducts: string | undefined;
    keywords: string | undefined;
    isActive: boolean;
    exclude: boolean;
}

export class ProductListDtoPagedResultDto implements IProductListDtoPagedResultDto {
    items: ProductListDto[] | undefined;
    totalCount: number;

    constructor(data?: IProductListDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(ProductListDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): ProductListDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProductListDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): ProductListDtoPagedResultDto {
        const json = this.toJSON();
        let result = new ProductListDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IProductListDtoPagedResultDto {
    items: ProductListDto[] | undefined;
    totalCount: number;
}

export class ProductPrice implements IProductPrice {
    id: number;
    tenantId: number | undefined;
    isDeleted: boolean;
    price: number;
    discount1: number;
    priceDiscount1: number;
    discount2: number;
    priceDiscount2: number;
    expense: number;
    utility: number;
    base: number;
    promo12: boolean;
    externalId: number | undefined;
    processImportId: string | undefined;
    taxId: number;
    tax: Tax;
    currencyId: number;
    currency: Currency;
    productId: number;
    product: Product;
    variantId: number | undefined;
    variant: Variant;
    priceListId: number | undefined;
    priceList: PriceList;

    constructor(data?: IProductPrice) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tenantId = _data["tenantId"];
            this.isDeleted = _data["isDeleted"];
            this.price = _data["price"];
            this.discount1 = _data["discount1"];
            this.priceDiscount1 = _data["priceDiscount1"];
            this.discount2 = _data["discount2"];
            this.priceDiscount2 = _data["priceDiscount2"];
            this.expense = _data["expense"];
            this.utility = _data["utility"];
            this.base = _data["base"];
            this.promo12 = _data["promo12"];
            this.externalId = _data["externalId"];
            this.processImportId = _data["processImportId"];
            this.taxId = _data["taxId"];
            this.tax = _data["tax"] ? Tax.fromJS(_data["tax"]) : <any>undefined;
            this.currencyId = _data["currencyId"];
            this.currency = _data["currency"] ? Currency.fromJS(_data["currency"]) : <any>undefined;
            this.productId = _data["productId"];
            this.product = _data["product"] ? Product.fromJS(_data["product"]) : <any>undefined;
            this.variantId = _data["variantId"];
            this.variant = _data["variant"] ? Variant.fromJS(_data["variant"]) : <any>undefined;
            this.priceListId = _data["priceListId"];
            this.priceList = _data["priceList"] ? PriceList.fromJS(_data["priceList"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ProductPrice {
        data = typeof data === 'object' ? data : {};
        let result = new ProductPrice();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tenantId"] = this.tenantId;
        data["isDeleted"] = this.isDeleted;
        data["price"] = this.price;
        data["discount1"] = this.discount1;
        data["priceDiscount1"] = this.priceDiscount1;
        data["discount2"] = this.discount2;
        data["priceDiscount2"] = this.priceDiscount2;
        data["expense"] = this.expense;
        data["utility"] = this.utility;
        data["base"] = this.base;
        data["promo12"] = this.promo12;
        data["externalId"] = this.externalId;
        data["processImportId"] = this.processImportId;
        data["taxId"] = this.taxId;
        data["tax"] = this.tax ? this.tax.toJSON() : <any>undefined;
        data["currencyId"] = this.currencyId;
        data["currency"] = this.currency ? this.currency.toJSON() : <any>undefined;
        data["productId"] = this.productId;
        data["product"] = this.product ? this.product.toJSON() : <any>undefined;
        data["variantId"] = this.variantId;
        data["variant"] = this.variant ? this.variant.toJSON() : <any>undefined;
        data["priceListId"] = this.priceListId;
        data["priceList"] = this.priceList ? this.priceList.toJSON() : <any>undefined;
        return data;
    }

    clone(): ProductPrice {
        const json = this.toJSON();
        let result = new ProductPrice();
        result.init(json);
        return result;
    }
}

export interface IProductPrice {
    id: number;
    tenantId: number | undefined;
    isDeleted: boolean;
    price: number;
    discount1: number;
    priceDiscount1: number;
    discount2: number;
    priceDiscount2: number;
    expense: number;
    utility: number;
    base: number;
    promo12: boolean;
    externalId: number | undefined;
    processImportId: string | undefined;
    taxId: number;
    tax: Tax;
    currencyId: number;
    currency: Currency;
    productId: number;
    product: Product;
    variantId: number | undefined;
    variant: Variant;
    priceListId: number | undefined;
    priceList: PriceList;
}

export class ProductPriceDto implements IProductPriceDto {
    id: number;
    tenantId: number | undefined;
    taxId: number;
    taxValue: string | undefined;
    price: number;
    readonly priceWithTaxes: number;
    discount1: number;
    priceDiscount1: number;
    discount2: number;
    priceDiscount2: number;
    expense: number;
    utility: number;
    base: number;
    promo12: boolean;
    currencyId: number;
    currencyQuote: number;
    productId: number;
    productName: string | undefined;
    variantId: number | undefined;
    variantName: string | undefined;
    priceListId: number | undefined;
    priceListName: string | undefined;
    listProducts: InvoiceProductDto[] | undefined;

    constructor(data?: IProductPriceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tenantId = _data["tenantId"];
            this.taxId = _data["taxId"];
            this.taxValue = _data["taxValue"];
            this.price = _data["price"];
            (<any>this).priceWithTaxes = _data["priceWithTaxes"];
            this.discount1 = _data["discount1"];
            this.priceDiscount1 = _data["priceDiscount1"];
            this.discount2 = _data["discount2"];
            this.priceDiscount2 = _data["priceDiscount2"];
            this.expense = _data["expense"];
            this.utility = _data["utility"];
            this.base = _data["base"];
            this.promo12 = _data["promo12"];
            this.currencyId = _data["currencyId"];
            this.currencyQuote = _data["currencyQuote"];
            this.productId = _data["productId"];
            this.productName = _data["productName"];
            this.variantId = _data["variantId"];
            this.variantName = _data["variantName"];
            this.priceListId = _data["priceListId"];
            this.priceListName = _data["priceListName"];
            if (Array.isArray(_data["listProducts"])) {
                this.listProducts = [] as any;
                for (let item of _data["listProducts"])
                    this.listProducts.push(InvoiceProductDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProductPriceDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProductPriceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tenantId"] = this.tenantId;
        data["taxId"] = this.taxId;
        data["taxValue"] = this.taxValue;
        data["price"] = this.price;
        data["priceWithTaxes"] = this.priceWithTaxes;
        data["discount1"] = this.discount1;
        data["priceDiscount1"] = this.priceDiscount1;
        data["discount2"] = this.discount2;
        data["priceDiscount2"] = this.priceDiscount2;
        data["expense"] = this.expense;
        data["utility"] = this.utility;
        data["base"] = this.base;
        data["promo12"] = this.promo12;
        data["currencyId"] = this.currencyId;
        data["currencyQuote"] = this.currencyQuote;
        data["productId"] = this.productId;
        data["productName"] = this.productName;
        data["variantId"] = this.variantId;
        data["variantName"] = this.variantName;
        data["priceListId"] = this.priceListId;
        data["priceListName"] = this.priceListName;
        if (Array.isArray(this.listProducts)) {
            data["listProducts"] = [];
            for (let item of this.listProducts)
                data["listProducts"].push(item.toJSON());
        }
        return data;
    }

    clone(): ProductPriceDto {
        const json = this.toJSON();
        let result = new ProductPriceDto();
        result.init(json);
        return result;
    }
}

export interface IProductPriceDto {
    id: number;
    tenantId: number | undefined;
    taxId: number;
    taxValue: string | undefined;
    price: number;
    priceWithTaxes: number;
    discount1: number;
    priceDiscount1: number;
    discount2: number;
    priceDiscount2: number;
    expense: number;
    utility: number;
    base: number;
    promo12: boolean;
    currencyId: number;
    currencyQuote: number;
    productId: number;
    productName: string | undefined;
    variantId: number | undefined;
    variantName: string | undefined;
    priceListId: number | undefined;
    priceListName: string | undefined;
    listProducts: InvoiceProductDto[] | undefined;
}

export class ProductPriceDtoPagedResultDto implements IProductPriceDtoPagedResultDto {
    items: ProductPriceDto[] | undefined;
    totalCount: number;

    constructor(data?: IProductPriceDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(ProductPriceDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): ProductPriceDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProductPriceDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): ProductPriceDtoPagedResultDto {
        const json = this.toJSON();
        let result = new ProductPriceDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IProductPriceDtoPagedResultDto {
    items: ProductPriceDto[] | undefined;
    totalCount: number;
}

export class ProductPriceImportDto implements IProductPriceImportDto {
    productName: string | undefined;
    variantName: string | undefined;
    priceListName: string | undefined;
    price: number;
    taxName: string | undefined;
    currencyName: string | undefined;
    discount1: number;
    discount2: number;
    expense: number;
    utility: number;
    promo12: boolean;
    externalId: number | undefined;
    productExternalId: number | undefined;
    variantExternalId: number | undefined;

    constructor(data?: IProductPriceImportDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productName = _data["productName"];
            this.variantName = _data["variantName"];
            this.priceListName = _data["priceListName"];
            this.price = _data["price"];
            this.taxName = _data["taxName"];
            this.currencyName = _data["currencyName"];
            this.discount1 = _data["discount1"];
            this.discount2 = _data["discount2"];
            this.expense = _data["expense"];
            this.utility = _data["utility"];
            this.promo12 = _data["promo12"];
            this.externalId = _data["externalId"];
            this.productExternalId = _data["productExternalId"];
            this.variantExternalId = _data["variantExternalId"];
        }
    }

    static fromJS(data: any): ProductPriceImportDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProductPriceImportDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productName"] = this.productName;
        data["variantName"] = this.variantName;
        data["priceListName"] = this.priceListName;
        data["price"] = this.price;
        data["taxName"] = this.taxName;
        data["currencyName"] = this.currencyName;
        data["discount1"] = this.discount1;
        data["discount2"] = this.discount2;
        data["expense"] = this.expense;
        data["utility"] = this.utility;
        data["promo12"] = this.promo12;
        data["externalId"] = this.externalId;
        data["productExternalId"] = this.productExternalId;
        data["variantExternalId"] = this.variantExternalId;
        return data;
    }

    clone(): ProductPriceImportDto {
        const json = this.toJSON();
        let result = new ProductPriceImportDto();
        result.init(json);
        return result;
    }
}

export interface IProductPriceImportDto {
    productName: string | undefined;
    variantName: string | undefined;
    priceListName: string | undefined;
    price: number;
    taxName: string | undefined;
    currencyName: string | undefined;
    discount1: number;
    discount2: number;
    expense: number;
    utility: number;
    promo12: boolean;
    externalId: number | undefined;
    productExternalId: number | undefined;
    variantExternalId: number | undefined;
}

export class ProductPromotionDto implements IProductPromotionDto {
    id: number;
    tenantId: number | undefined;
    name: string | undefined;
    code: string | undefined;
    barcode: string | undefined;
    isEam: boolean;
    description: string | undefined;
    notInStores: string | undefined;
    quantity: number;
    variantId: number | undefined;
    colorId: number;
    sizeId: number;
    isVariant: boolean;
    stock: number;
    productId: number;
    isIncluded: boolean | undefined;

    constructor(data?: IProductPromotionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tenantId = _data["tenantId"];
            this.name = _data["name"];
            this.code = _data["code"];
            this.barcode = _data["barcode"];
            this.isEam = _data["isEam"];
            this.description = _data["description"];
            this.notInStores = _data["notInStores"];
            this.quantity = _data["quantity"];
            this.variantId = _data["variantId"];
            this.colorId = _data["colorId"];
            this.sizeId = _data["sizeId"];
            this.isVariant = _data["isVariant"];
            this.stock = _data["stock"];
            this.productId = _data["productId"];
            this.isIncluded = _data["isIncluded"];
        }
    }

    static fromJS(data: any): ProductPromotionDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProductPromotionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tenantId"] = this.tenantId;
        data["name"] = this.name;
        data["code"] = this.code;
        data["barcode"] = this.barcode;
        data["isEam"] = this.isEam;
        data["description"] = this.description;
        data["notInStores"] = this.notInStores;
        data["quantity"] = this.quantity;
        data["variantId"] = this.variantId;
        data["colorId"] = this.colorId;
        data["sizeId"] = this.sizeId;
        data["isVariant"] = this.isVariant;
        data["stock"] = this.stock;
        data["productId"] = this.productId;
        data["isIncluded"] = this.isIncluded;
        return data;
    }

    clone(): ProductPromotionDto {
        const json = this.toJSON();
        let result = new ProductPromotionDto();
        result.init(json);
        return result;
    }
}

export interface IProductPromotionDto {
    id: number;
    tenantId: number | undefined;
    name: string | undefined;
    code: string | undefined;
    barcode: string | undefined;
    isEam: boolean;
    description: string | undefined;
    notInStores: string | undefined;
    quantity: number;
    variantId: number | undefined;
    colorId: number;
    sizeId: number;
    isVariant: boolean;
    stock: number;
    productId: number;
    isIncluded: boolean | undefined;
}

export class ProductPromotionModel implements IProductPromotionModel {
    id: number;
    name: string | undefined;
    discountAmount: number;
    refundAmount: number;
    promotionType: PromotionType;
    readonly promotionTypeName: string | undefined;

    constructor(data?: IProductPromotionModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.discountAmount = _data["discountAmount"];
            this.refundAmount = _data["refundAmount"];
            this.promotionType = _data["promotionType"];
            (<any>this).promotionTypeName = _data["promotionTypeName"];
        }
    }

    static fromJS(data: any): ProductPromotionModel {
        data = typeof data === 'object' ? data : {};
        let result = new ProductPromotionModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["discountAmount"] = this.discountAmount;
        data["refundAmount"] = this.refundAmount;
        data["promotionType"] = this.promotionType;
        data["promotionTypeName"] = this.promotionTypeName;
        return data;
    }

    clone(): ProductPromotionModel {
        const json = this.toJSON();
        let result = new ProductPromotionModel();
        result.init(json);
        return result;
    }
}

export interface IProductPromotionModel {
    id: number;
    name: string | undefined;
    discountAmount: number;
    refundAmount: number;
    promotionType: PromotionType;
    promotionTypeName: string | undefined;
}

export class ProductProperty implements IProductProperty {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    tenantId: number | undefined;
    name: string | undefined;
    productId: number;
    product: Product;
    propertyId: number;
    property: Property;
    propertyValueId: number | undefined;
    propertyValue: PropertyValue;
    value: string | undefined;
    externalId: number | undefined;
    processImportId: string | undefined;

    constructor(data?: IProductProperty) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.tenantId = _data["tenantId"];
            this.name = _data["name"];
            this.productId = _data["productId"];
            this.product = _data["product"] ? Product.fromJS(_data["product"]) : <any>undefined;
            this.propertyId = _data["propertyId"];
            this.property = _data["property"] ? Property.fromJS(_data["property"]) : <any>undefined;
            this.propertyValueId = _data["propertyValueId"];
            this.propertyValue = _data["propertyValue"] ? PropertyValue.fromJS(_data["propertyValue"]) : <any>undefined;
            this.value = _data["value"];
            this.externalId = _data["externalId"];
            this.processImportId = _data["processImportId"];
        }
    }

    static fromJS(data: any): ProductProperty {
        data = typeof data === 'object' ? data : {};
        let result = new ProductProperty();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["tenantId"] = this.tenantId;
        data["name"] = this.name;
        data["productId"] = this.productId;
        data["product"] = this.product ? this.product.toJSON() : <any>undefined;
        data["propertyId"] = this.propertyId;
        data["property"] = this.property ? this.property.toJSON() : <any>undefined;
        data["propertyValueId"] = this.propertyValueId;
        data["propertyValue"] = this.propertyValue ? this.propertyValue.toJSON() : <any>undefined;
        data["value"] = this.value;
        data["externalId"] = this.externalId;
        data["processImportId"] = this.processImportId;
        return data;
    }

    clone(): ProductProperty {
        const json = this.toJSON();
        let result = new ProductProperty();
        result.init(json);
        return result;
    }
}

export interface IProductProperty {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    tenantId: number | undefined;
    name: string | undefined;
    productId: number;
    product: Product;
    propertyId: number;
    property: Property;
    propertyValueId: number | undefined;
    propertyValue: PropertyValue;
    value: string | undefined;
    externalId: number | undefined;
    processImportId: string | undefined;
}

export class ProductPropertyBulkUpdateDto implements IProductPropertyBulkUpdateDto {
    id: number;
    tenantId: number | undefined;
    propertyId: number;
    propertyValueId: number;
    productId: number;
    externalId: number;

    constructor(data?: IProductPropertyBulkUpdateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tenantId = _data["tenantId"];
            this.propertyId = _data["propertyId"];
            this.propertyValueId = _data["propertyValueId"];
            this.productId = _data["productId"];
            this.externalId = _data["externalId"];
        }
    }

    static fromJS(data: any): ProductPropertyBulkUpdateDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProductPropertyBulkUpdateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tenantId"] = this.tenantId;
        data["propertyId"] = this.propertyId;
        data["propertyValueId"] = this.propertyValueId;
        data["productId"] = this.productId;
        data["externalId"] = this.externalId;
        return data;
    }

    clone(): ProductPropertyBulkUpdateDto {
        const json = this.toJSON();
        let result = new ProductPropertyBulkUpdateDto();
        result.init(json);
        return result;
    }
}

export interface IProductPropertyBulkUpdateDto {
    id: number;
    tenantId: number | undefined;
    propertyId: number;
    propertyValueId: number;
    productId: number;
    externalId: number;
}

export class ProductPropertyDto implements IProductPropertyDto {
    id: number;
    tenantId: number | undefined;
    propertyId: number;
    propertyName: string | undefined;
    propertyValueId: number;
    propertyValueName: string | undefined;
    value: string | undefined;
    name: string | undefined;

    constructor(data?: IProductPropertyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tenantId = _data["tenantId"];
            this.propertyId = _data["propertyId"];
            this.propertyName = _data["propertyName"];
            this.propertyValueId = _data["propertyValueId"];
            this.propertyValueName = _data["propertyValueName"];
            this.value = _data["value"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): ProductPropertyDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProductPropertyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tenantId"] = this.tenantId;
        data["propertyId"] = this.propertyId;
        data["propertyName"] = this.propertyName;
        data["propertyValueId"] = this.propertyValueId;
        data["propertyValueName"] = this.propertyValueName;
        data["value"] = this.value;
        data["name"] = this.name;
        return data;
    }

    clone(): ProductPropertyDto {
        const json = this.toJSON();
        let result = new ProductPropertyDto();
        result.init(json);
        return result;
    }
}

export interface IProductPropertyDto {
    id: number;
    tenantId: number | undefined;
    propertyId: number;
    propertyName: string | undefined;
    propertyValueId: number;
    propertyValueName: string | undefined;
    value: string | undefined;
    name: string | undefined;
}

export class ProductPropertyInputDto implements IProductPropertyInputDto {
    id: number;
    propertyId: number;
    name: string | undefined;
    externalId: number | undefined;

    constructor(data?: IProductPropertyInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.propertyId = _data["propertyId"];
            this.name = _data["name"];
            this.externalId = _data["externalId"];
        }
    }

    static fromJS(data: any): ProductPropertyInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProductPropertyInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["propertyId"] = this.propertyId;
        data["name"] = this.name;
        data["externalId"] = this.externalId;
        return data;
    }

    clone(): ProductPropertyInputDto {
        const json = this.toJSON();
        let result = new ProductPropertyInputDto();
        result.init(json);
        return result;
    }
}

export interface IProductPropertyInputDto {
    id: number;
    propertyId: number;
    name: string | undefined;
    externalId: number | undefined;
}

export class ProductUpdateDto implements IProductUpdateDto {
    id: number;
    tenantId: number | undefined;
    name: string | undefined;
    isActive: boolean;
    code: string | undefined;
    barcode: string | undefined;
    isEam: boolean;
    description: string | undefined;
    notInStores: string | undefined;
    useStock: boolean;
    isGeneric: boolean;
    isGiftCard: boolean;
    promo12: boolean;
    minStock: number;
    fileAttachmentId: number | undefined;
    currencyId: number;
    currencyQuote: number;
    gtin: string | undefined;
    hasDecimalQuantity: boolean;
    propertyList: ProductPropertyDto[] | undefined;
    features: ProductFeatureDto[] | undefined;
    variantList: VariantDto[] | undefined;
    productPriceList: ProductPriceDto[] | undefined;

    constructor(data?: IProductUpdateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tenantId = _data["tenantId"];
            this.name = _data["name"];
            this.isActive = _data["isActive"];
            this.code = _data["code"];
            this.barcode = _data["barcode"];
            this.isEam = _data["isEam"];
            this.description = _data["description"];
            this.notInStores = _data["notInStores"];
            this.useStock = _data["useStock"];
            this.isGeneric = _data["isGeneric"];
            this.isGiftCard = _data["isGiftCard"];
            this.promo12 = _data["promo12"];
            this.minStock = _data["minStock"];
            this.fileAttachmentId = _data["fileAttachmentId"];
            this.currencyId = _data["currencyId"];
            this.currencyQuote = _data["currencyQuote"];
            this.gtin = _data["gtin"];
            this.hasDecimalQuantity = _data["hasDecimalQuantity"];
            if (Array.isArray(_data["propertyList"])) {
                this.propertyList = [] as any;
                for (let item of _data["propertyList"])
                    this.propertyList.push(ProductPropertyDto.fromJS(item));
            }
            if (Array.isArray(_data["features"])) {
                this.features = [] as any;
                for (let item of _data["features"])
                    this.features.push(ProductFeatureDto.fromJS(item));
            }
            if (Array.isArray(_data["variantList"])) {
                this.variantList = [] as any;
                for (let item of _data["variantList"])
                    this.variantList.push(VariantDto.fromJS(item));
            }
            if (Array.isArray(_data["productPriceList"])) {
                this.productPriceList = [] as any;
                for (let item of _data["productPriceList"])
                    this.productPriceList.push(ProductPriceDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProductUpdateDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProductUpdateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tenantId"] = this.tenantId;
        data["name"] = this.name;
        data["isActive"] = this.isActive;
        data["code"] = this.code;
        data["barcode"] = this.barcode;
        data["isEam"] = this.isEam;
        data["description"] = this.description;
        data["notInStores"] = this.notInStores;
        data["useStock"] = this.useStock;
        data["isGeneric"] = this.isGeneric;
        data["isGiftCard"] = this.isGiftCard;
        data["promo12"] = this.promo12;
        data["minStock"] = this.minStock;
        data["fileAttachmentId"] = this.fileAttachmentId;
        data["currencyId"] = this.currencyId;
        data["currencyQuote"] = this.currencyQuote;
        data["gtin"] = this.gtin;
        data["hasDecimalQuantity"] = this.hasDecimalQuantity;
        if (Array.isArray(this.propertyList)) {
            data["propertyList"] = [];
            for (let item of this.propertyList)
                data["propertyList"].push(item.toJSON());
        }
        if (Array.isArray(this.features)) {
            data["features"] = [];
            for (let item of this.features)
                data["features"].push(item.toJSON());
        }
        if (Array.isArray(this.variantList)) {
            data["variantList"] = [];
            for (let item of this.variantList)
                data["variantList"].push(item.toJSON());
        }
        if (Array.isArray(this.productPriceList)) {
            data["productPriceList"] = [];
            for (let item of this.productPriceList)
                data["productPriceList"].push(item.toJSON());
        }
        return data;
    }

    clone(): ProductUpdateDto {
        const json = this.toJSON();
        let result = new ProductUpdateDto();
        result.init(json);
        return result;
    }
}

export interface IProductUpdateDto {
    id: number;
    tenantId: number | undefined;
    name: string | undefined;
    isActive: boolean;
    code: string | undefined;
    barcode: string | undefined;
    isEam: boolean;
    description: string | undefined;
    notInStores: string | undefined;
    useStock: boolean;
    isGeneric: boolean;
    isGiftCard: boolean;
    promo12: boolean;
    minStock: number;
    fileAttachmentId: number | undefined;
    currencyId: number;
    currencyQuote: number;
    gtin: string | undefined;
    hasDecimalQuantity: boolean;
    propertyList: ProductPropertyDto[] | undefined;
    features: ProductFeatureDto[] | undefined;
    variantList: VariantDto[] | undefined;
    productPriceList: ProductPriceDto[] | undefined;
}

export class ProductUpdateVariantsDto implements IProductUpdateVariantsDto {
    id: number;
    code: string | undefined;
    name: string | undefined;

    constructor(data?: IProductUpdateVariantsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): ProductUpdateVariantsDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProductUpdateVariantsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["name"] = this.name;
        return data;
    }

    clone(): ProductUpdateVariantsDto {
        const json = this.toJSON();
        let result = new ProductUpdateVariantsDto();
        result.init(json);
        return result;
    }
}

export interface IProductUpdateVariantsDto {
    id: number;
    code: string | undefined;
    name: string | undefined;
}

export class ProductsListDto implements IProductsListDto {
    id: number;
    code: string | undefined;
    name: string | undefined;
    isActive: boolean;

    constructor(data?: IProductsListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.name = _data["name"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): ProductsListDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProductsListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["name"] = this.name;
        data["isActive"] = this.isActive;
        return data;
    }

    clone(): ProductsListDto {
        const json = this.toJSON();
        let result = new ProductsListDto();
        result.init(json);
        return result;
    }
}

export interface IProductsListDto {
    id: number;
    code: string | undefined;
    name: string | undefined;
    isActive: boolean;
}

export class ProductsListDtoPagedResultDto implements IProductsListDtoPagedResultDto {
    items: ProductsListDto[] | undefined;
    totalCount: number;

    constructor(data?: IProductsListDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(ProductsListDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): ProductsListDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProductsListDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): ProductsListDtoPagedResultDto {
        const json = this.toJSON();
        let result = new ProductsListDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IProductsListDtoPagedResultDto {
    items: ProductsListDto[] | undefined;
    totalCount: number;
}

export class Promotion implements IPromotion {
    id: number;
    tenantId: number | undefined;
    isDeleted: boolean;
    name: string | undefined;
    description: string | undefined;
    percent: boolean;
    amount: number;
    maxAmount: number;
    maxQuantity: number;
    priority: number;
    isActive: boolean;
    code: string | undefined;
    dateInit: moment.Moment;
    dateEnd: moment.Moment | undefined;
    promotionType: PromotionType;
    externalId: number | undefined;
    useLoyalty: boolean;
    until: boolean;
    refundPerc: number;
    creditNotePerc: number;
    quotes: number;
    withoutInteres: boolean;
    isKey: boolean;
    observations: string | undefined;
    combinableWithNonBank: boolean;
    combinableWithBank: boolean;
    bankId: number | undefined;
    bank: Bank;
    companyId: number | undefined;
    company: Company;
    loyaltyCategoryId: number | undefined;
    loyaltyCategory: LoyaltyCategory;
    promotionStore: PromotionStore[] | undefined;
    promotionCondition: PromotionCondition[] | undefined;
    promotionInvoice: PromotionInvoice[] | undefined;

    constructor(data?: IPromotion) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tenantId = _data["tenantId"];
            this.isDeleted = _data["isDeleted"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.percent = _data["percent"];
            this.amount = _data["amount"];
            this.maxAmount = _data["maxAmount"];
            this.maxQuantity = _data["maxQuantity"];
            this.priority = _data["priority"];
            this.isActive = _data["isActive"];
            this.code = _data["code"];
            this.dateInit = _data["dateInit"] ? moment(_data["dateInit"].toString()) : <any>undefined;
            this.dateEnd = _data["dateEnd"] ? moment(_data["dateEnd"].toString()) : <any>undefined;
            this.promotionType = _data["promotionType"];
            this.externalId = _data["externalId"];
            this.useLoyalty = _data["useLoyalty"];
            this.until = _data["until"];
            this.refundPerc = _data["refundPerc"];
            this.creditNotePerc = _data["creditNotePerc"];
            this.quotes = _data["quotes"];
            this.withoutInteres = _data["withoutInteres"];
            this.isKey = _data["isKey"];
            this.observations = _data["observations"];
            this.combinableWithNonBank = _data["combinableWithNonBank"];
            this.combinableWithBank = _data["combinableWithBank"];
            this.bankId = _data["bankId"];
            this.bank = _data["bank"] ? Bank.fromJS(_data["bank"]) : <any>undefined;
            this.companyId = _data["companyId"];
            this.company = _data["company"] ? Company.fromJS(_data["company"]) : <any>undefined;
            this.loyaltyCategoryId = _data["loyaltyCategoryId"];
            this.loyaltyCategory = _data["loyaltyCategory"] ? LoyaltyCategory.fromJS(_data["loyaltyCategory"]) : <any>undefined;
            if (Array.isArray(_data["promotionStore"])) {
                this.promotionStore = [] as any;
                for (let item of _data["promotionStore"])
                    this.promotionStore.push(PromotionStore.fromJS(item));
            }
            if (Array.isArray(_data["promotionCondition"])) {
                this.promotionCondition = [] as any;
                for (let item of _data["promotionCondition"])
                    this.promotionCondition.push(PromotionCondition.fromJS(item));
            }
            if (Array.isArray(_data["promotionInvoice"])) {
                this.promotionInvoice = [] as any;
                for (let item of _data["promotionInvoice"])
                    this.promotionInvoice.push(PromotionInvoice.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Promotion {
        data = typeof data === 'object' ? data : {};
        let result = new Promotion();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tenantId"] = this.tenantId;
        data["isDeleted"] = this.isDeleted;
        data["name"] = this.name;
        data["description"] = this.description;
        data["percent"] = this.percent;
        data["amount"] = this.amount;
        data["maxAmount"] = this.maxAmount;
        data["maxQuantity"] = this.maxQuantity;
        data["priority"] = this.priority;
        data["isActive"] = this.isActive;
        data["code"] = this.code;
        data["dateInit"] = this.dateInit ? this.dateInit.toISOString() : <any>undefined;
        data["dateEnd"] = this.dateEnd ? this.dateEnd.toISOString() : <any>undefined;
        data["promotionType"] = this.promotionType;
        data["externalId"] = this.externalId;
        data["useLoyalty"] = this.useLoyalty;
        data["until"] = this.until;
        data["refundPerc"] = this.refundPerc;
        data["creditNotePerc"] = this.creditNotePerc;
        data["quotes"] = this.quotes;
        data["withoutInteres"] = this.withoutInteres;
        data["isKey"] = this.isKey;
        data["observations"] = this.observations;
        data["combinableWithNonBank"] = this.combinableWithNonBank;
        data["combinableWithBank"] = this.combinableWithBank;
        data["bankId"] = this.bankId;
        data["bank"] = this.bank ? this.bank.toJSON() : <any>undefined;
        data["companyId"] = this.companyId;
        data["company"] = this.company ? this.company.toJSON() : <any>undefined;
        data["loyaltyCategoryId"] = this.loyaltyCategoryId;
        data["loyaltyCategory"] = this.loyaltyCategory ? this.loyaltyCategory.toJSON() : <any>undefined;
        if (Array.isArray(this.promotionStore)) {
            data["promotionStore"] = [];
            for (let item of this.promotionStore)
                data["promotionStore"].push(item.toJSON());
        }
        if (Array.isArray(this.promotionCondition)) {
            data["promotionCondition"] = [];
            for (let item of this.promotionCondition)
                data["promotionCondition"].push(item.toJSON());
        }
        if (Array.isArray(this.promotionInvoice)) {
            data["promotionInvoice"] = [];
            for (let item of this.promotionInvoice)
                data["promotionInvoice"].push(item.toJSON());
        }
        return data;
    }

    clone(): Promotion {
        const json = this.toJSON();
        let result = new Promotion();
        result.init(json);
        return result;
    }
}

export interface IPromotion {
    id: number;
    tenantId: number | undefined;
    isDeleted: boolean;
    name: string | undefined;
    description: string | undefined;
    percent: boolean;
    amount: number;
    maxAmount: number;
    maxQuantity: number;
    priority: number;
    isActive: boolean;
    code: string | undefined;
    dateInit: moment.Moment;
    dateEnd: moment.Moment | undefined;
    promotionType: PromotionType;
    externalId: number | undefined;
    useLoyalty: boolean;
    until: boolean;
    refundPerc: number;
    creditNotePerc: number;
    quotes: number;
    withoutInteres: boolean;
    isKey: boolean;
    observations: string | undefined;
    combinableWithNonBank: boolean;
    combinableWithBank: boolean;
    bankId: number | undefined;
    bank: Bank;
    companyId: number | undefined;
    company: Company;
    loyaltyCategoryId: number | undefined;
    loyaltyCategory: LoyaltyCategory;
    promotionStore: PromotionStore[] | undefined;
    promotionCondition: PromotionCondition[] | undefined;
    promotionInvoice: PromotionInvoice[] | undefined;
}

export class PromotionCondition implements IPromotionCondition {
    id: number;
    tenantId: number | undefined;
    isDeleted: boolean;
    name: string | undefined;
    amount: number;
    percent: number;
    quantity: number;
    type: PromotionConditionType;
    extensionData: string | undefined;
    filters: ConditionDataModel[] | undefined;
    promotionId: number;
    promotion: Promotion;

    constructor(data?: IPromotionCondition) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tenantId = _data["tenantId"];
            this.isDeleted = _data["isDeleted"];
            this.name = _data["name"];
            this.amount = _data["amount"];
            this.percent = _data["percent"];
            this.quantity = _data["quantity"];
            this.type = _data["type"];
            this.extensionData = _data["extensionData"];
            if (Array.isArray(_data["filters"])) {
                this.filters = [] as any;
                for (let item of _data["filters"])
                    this.filters.push(ConditionDataModel.fromJS(item));
            }
            this.promotionId = _data["promotionId"];
            this.promotion = _data["promotion"] ? Promotion.fromJS(_data["promotion"]) : <any>undefined;
        }
    }

    static fromJS(data: any): PromotionCondition {
        data = typeof data === 'object' ? data : {};
        let result = new PromotionCondition();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tenantId"] = this.tenantId;
        data["isDeleted"] = this.isDeleted;
        data["name"] = this.name;
        data["amount"] = this.amount;
        data["percent"] = this.percent;
        data["quantity"] = this.quantity;
        data["type"] = this.type;
        data["extensionData"] = this.extensionData;
        if (Array.isArray(this.filters)) {
            data["filters"] = [];
            for (let item of this.filters)
                data["filters"].push(item.toJSON());
        }
        data["promotionId"] = this.promotionId;
        data["promotion"] = this.promotion ? this.promotion.toJSON() : <any>undefined;
        return data;
    }

    clone(): PromotionCondition {
        const json = this.toJSON();
        let result = new PromotionCondition();
        result.init(json);
        return result;
    }
}

export interface IPromotionCondition {
    id: number;
    tenantId: number | undefined;
    isDeleted: boolean;
    name: string | undefined;
    amount: number;
    percent: number;
    quantity: number;
    type: PromotionConditionType;
    extensionData: string | undefined;
    filters: ConditionDataModel[] | undefined;
    promotionId: number;
    promotion: Promotion;
}

export class PromotionConditionDto implements IPromotionConditionDto {
    name: string | undefined;
    keywords: string | undefined;
    propertyValues: string | undefined;
    productGroupId: number;
    exclude: boolean;

    constructor(data?: IPromotionConditionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.keywords = _data["keywords"];
            this.propertyValues = _data["propertyValues"];
            this.productGroupId = _data["productGroupId"];
            this.exclude = _data["exclude"];
        }
    }

    static fromJS(data: any): PromotionConditionDto {
        data = typeof data === 'object' ? data : {};
        let result = new PromotionConditionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["keywords"] = this.keywords;
        data["propertyValues"] = this.propertyValues;
        data["productGroupId"] = this.productGroupId;
        data["exclude"] = this.exclude;
        return data;
    }

    clone(): PromotionConditionDto {
        const json = this.toJSON();
        let result = new PromotionConditionDto();
        result.init(json);
        return result;
    }
}

export interface IPromotionConditionDto {
    name: string | undefined;
    keywords: string | undefined;
    propertyValues: string | undefined;
    productGroupId: number;
    exclude: boolean;
}

export class PromotionConditionGroupDto implements IPromotionConditionGroupDto {
    id: number;
    tenantId: number | undefined;
    name: string | undefined;
    productLists: PromotionConditionDto[] | undefined;
    amount: number;
    percent: number;
    quantity: number;
    type: PromotionConditionType;
    promotionId: number;
    typePromo: number | undefined;
    deleted: boolean;

    constructor(data?: IPromotionConditionGroupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tenantId = _data["tenantId"];
            this.name = _data["name"];
            if (Array.isArray(_data["productLists"])) {
                this.productLists = [] as any;
                for (let item of _data["productLists"])
                    this.productLists.push(PromotionConditionDto.fromJS(item));
            }
            this.amount = _data["amount"];
            this.percent = _data["percent"];
            this.quantity = _data["quantity"];
            this.type = _data["type"];
            this.promotionId = _data["promotionId"];
            this.typePromo = _data["typePromo"];
            this.deleted = _data["deleted"];
        }
    }

    static fromJS(data: any): PromotionConditionGroupDto {
        data = typeof data === 'object' ? data : {};
        let result = new PromotionConditionGroupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tenantId"] = this.tenantId;
        data["name"] = this.name;
        if (Array.isArray(this.productLists)) {
            data["productLists"] = [];
            for (let item of this.productLists)
                data["productLists"].push(item.toJSON());
        }
        data["amount"] = this.amount;
        data["percent"] = this.percent;
        data["quantity"] = this.quantity;
        data["type"] = this.type;
        data["promotionId"] = this.promotionId;
        data["typePromo"] = this.typePromo;
        data["deleted"] = this.deleted;
        return data;
    }

    clone(): PromotionConditionGroupDto {
        const json = this.toJSON();
        let result = new PromotionConditionGroupDto();
        result.init(json);
        return result;
    }
}

export interface IPromotionConditionGroupDto {
    id: number;
    tenantId: number | undefined;
    name: string | undefined;
    productLists: PromotionConditionDto[] | undefined;
    amount: number;
    percent: number;
    quantity: number;
    type: PromotionConditionType;
    promotionId: number;
    typePromo: number | undefined;
    deleted: boolean;
}

export enum PromotionConditionType {
    Premise = <any>"Premise",
    Conclusion = <any>"Conclusion",
}

export class PromotionDto implements IPromotionDto {
    id: number;
    tenantId: number | undefined;
    name: string | undefined;
    description: string | undefined;
    percent: boolean;
    amount: number;
    maxAmount: number;
    maxQuantity: number;
    priority: number;
    isActive: boolean;
    code: string | undefined;
    dateInit: moment.Moment;
    dateEnd: moment.Moment | undefined;
    promotionType: PromotionType;
    readonly promotionTypeName: string | undefined;
    refundPerc: number;
    creditNotePerc: number;
    quotes: number;
    withoutInteres: boolean;
    isKey: boolean;
    observations: string | undefined;
    bankId: number | undefined;
    bankName: string | undefined;
    companyId: number | undefined;
    companyName: string | undefined;
    combinableWithNonBank: boolean;
    combinableWithBank: boolean;
    loyaltyCategoryId: number | undefined;
    useLoyalty: boolean;
    until: boolean;
    externalId: number | undefined;
    listPromotionStore: PromotionStoreDto[] | undefined;
    listPromotionCondition: PromotionConditionGroupDto[] | undefined;

    constructor(data?: IPromotionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tenantId = _data["tenantId"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.percent = _data["percent"];
            this.amount = _data["amount"];
            this.maxAmount = _data["maxAmount"];
            this.maxQuantity = _data["maxQuantity"];
            this.priority = _data["priority"];
            this.isActive = _data["isActive"];
            this.code = _data["code"];
            this.dateInit = _data["dateInit"] ? moment(_data["dateInit"].toString()) : <any>undefined;
            this.dateEnd = _data["dateEnd"] ? moment(_data["dateEnd"].toString()) : <any>undefined;
            this.promotionType = _data["promotionType"];
            (<any>this).promotionTypeName = _data["promotionTypeName"];
            this.refundPerc = _data["refundPerc"];
            this.creditNotePerc = _data["creditNotePerc"];
            this.quotes = _data["quotes"];
            this.withoutInteres = _data["withoutInteres"];
            this.isKey = _data["isKey"];
            this.observations = _data["observations"];
            this.bankId = _data["bankId"];
            this.bankName = _data["bankName"];
            this.companyId = _data["companyId"];
            this.companyName = _data["companyName"];
            this.combinableWithNonBank = _data["combinableWithNonBank"];
            this.combinableWithBank = _data["combinableWithBank"];
            this.loyaltyCategoryId = _data["loyaltyCategoryId"];
            this.useLoyalty = _data["useLoyalty"];
            this.until = _data["until"];
            this.externalId = _data["externalId"];
            if (Array.isArray(_data["listPromotionStore"])) {
                this.listPromotionStore = [] as any;
                for (let item of _data["listPromotionStore"])
                    this.listPromotionStore.push(PromotionStoreDto.fromJS(item));
            }
            if (Array.isArray(_data["listPromotionCondition"])) {
                this.listPromotionCondition = [] as any;
                for (let item of _data["listPromotionCondition"])
                    this.listPromotionCondition.push(PromotionConditionGroupDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PromotionDto {
        data = typeof data === 'object' ? data : {};
        let result = new PromotionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tenantId"] = this.tenantId;
        data["name"] = this.name;
        data["description"] = this.description;
        data["percent"] = this.percent;
        data["amount"] = this.amount;
        data["maxAmount"] = this.maxAmount;
        data["maxQuantity"] = this.maxQuantity;
        data["priority"] = this.priority;
        data["isActive"] = this.isActive;
        data["code"] = this.code;
        data["dateInit"] = this.dateInit ? this.dateInit.toISOString() : <any>undefined;
        data["dateEnd"] = this.dateEnd ? this.dateEnd.toISOString() : <any>undefined;
        data["promotionType"] = this.promotionType;
        data["promotionTypeName"] = this.promotionTypeName;
        data["refundPerc"] = this.refundPerc;
        data["creditNotePerc"] = this.creditNotePerc;
        data["quotes"] = this.quotes;
        data["withoutInteres"] = this.withoutInteres;
        data["isKey"] = this.isKey;
        data["observations"] = this.observations;
        data["bankId"] = this.bankId;
        data["bankName"] = this.bankName;
        data["companyId"] = this.companyId;
        data["companyName"] = this.companyName;
        data["combinableWithNonBank"] = this.combinableWithNonBank;
        data["combinableWithBank"] = this.combinableWithBank;
        data["loyaltyCategoryId"] = this.loyaltyCategoryId;
        data["useLoyalty"] = this.useLoyalty;
        data["until"] = this.until;
        data["externalId"] = this.externalId;
        if (Array.isArray(this.listPromotionStore)) {
            data["listPromotionStore"] = [];
            for (let item of this.listPromotionStore)
                data["listPromotionStore"].push(item.toJSON());
        }
        if (Array.isArray(this.listPromotionCondition)) {
            data["listPromotionCondition"] = [];
            for (let item of this.listPromotionCondition)
                data["listPromotionCondition"].push(item.toJSON());
        }
        return data;
    }

    clone(): PromotionDto {
        const json = this.toJSON();
        let result = new PromotionDto();
        result.init(json);
        return result;
    }
}

export interface IPromotionDto {
    id: number;
    tenantId: number | undefined;
    name: string | undefined;
    description: string | undefined;
    percent: boolean;
    amount: number;
    maxAmount: number;
    maxQuantity: number;
    priority: number;
    isActive: boolean;
    code: string | undefined;
    dateInit: moment.Moment;
    dateEnd: moment.Moment | undefined;
    promotionType: PromotionType;
    promotionTypeName: string | undefined;
    refundPerc: number;
    creditNotePerc: number;
    quotes: number;
    withoutInteres: boolean;
    isKey: boolean;
    observations: string | undefined;
    bankId: number | undefined;
    bankName: string | undefined;
    companyId: number | undefined;
    companyName: string | undefined;
    combinableWithNonBank: boolean;
    combinableWithBank: boolean;
    loyaltyCategoryId: number | undefined;
    useLoyalty: boolean;
    until: boolean;
    externalId: number | undefined;
    listPromotionStore: PromotionStoreDto[] | undefined;
    listPromotionCondition: PromotionConditionGroupDto[] | undefined;
}

export class PromotionDtoPagedResultDto implements IPromotionDtoPagedResultDto {
    items: PromotionDto[] | undefined;
    totalCount: number;

    constructor(data?: IPromotionDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(PromotionDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): PromotionDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new PromotionDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): PromotionDtoPagedResultDto {
        const json = this.toJSON();
        let result = new PromotionDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IPromotionDtoPagedResultDto {
    items: PromotionDto[] | undefined;
    totalCount: number;
}

export class PromotionInvoice implements IPromotionInvoice {
    id: number;
    tenantId: number | undefined;
    isDeleted: boolean;
    promotionId: number;
    promotion: Promotion;
    invoiceId: number;
    invoice: Invoice;

    constructor(data?: IPromotionInvoice) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tenantId = _data["tenantId"];
            this.isDeleted = _data["isDeleted"];
            this.promotionId = _data["promotionId"];
            this.promotion = _data["promotion"] ? Promotion.fromJS(_data["promotion"]) : <any>undefined;
            this.invoiceId = _data["invoiceId"];
            this.invoice = _data["invoice"] ? Invoice.fromJS(_data["invoice"]) : <any>undefined;
        }
    }

    static fromJS(data: any): PromotionInvoice {
        data = typeof data === 'object' ? data : {};
        let result = new PromotionInvoice();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tenantId"] = this.tenantId;
        data["isDeleted"] = this.isDeleted;
        data["promotionId"] = this.promotionId;
        data["promotion"] = this.promotion ? this.promotion.toJSON() : <any>undefined;
        data["invoiceId"] = this.invoiceId;
        data["invoice"] = this.invoice ? this.invoice.toJSON() : <any>undefined;
        return data;
    }

    clone(): PromotionInvoice {
        const json = this.toJSON();
        let result = new PromotionInvoice();
        result.init(json);
        return result;
    }
}

export interface IPromotionInvoice {
    id: number;
    tenantId: number | undefined;
    isDeleted: boolean;
    promotionId: number;
    promotion: Promotion;
    invoiceId: number;
    invoice: Invoice;
}

export class PromotionInvoiceDto implements IPromotionInvoiceDto {
    id: number;
    tenantId: number | undefined;
    name: string | undefined;
    description: string | undefined;
    amount: number;
    maxQuantity: number;
    dateInit: moment.Moment;
    dateEnd: moment.Moment | undefined;
    promotionType: PromotionType;
    readonly promotionTypeName: string | undefined;
    bankId: number;
    bankName: string | undefined;
    companyId: number;
    companyName: string | undefined;
    combinableWithNonBank: boolean;
    combinableWithBank: boolean;
    totalWithPromotionDiscount: number;
    quotes: number;
    withoutInteres: boolean;
    discountAmount: number;
    refundAmount: number;
    combinedPromotionsIds: number[] | undefined;
    discountPercent: number;
    refundPerc: number;
    creditNotePerc: number;
    totalAmount: number;
    appliedOnDetails: boolean;

    constructor(data?: IPromotionInvoiceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tenantId = _data["tenantId"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.amount = _data["amount"];
            this.maxQuantity = _data["maxQuantity"];
            this.dateInit = _data["dateInit"] ? moment(_data["dateInit"].toString()) : <any>undefined;
            this.dateEnd = _data["dateEnd"] ? moment(_data["dateEnd"].toString()) : <any>undefined;
            this.promotionType = _data["promotionType"];
            (<any>this).promotionTypeName = _data["promotionTypeName"];
            this.bankId = _data["bankId"];
            this.bankName = _data["bankName"];
            this.companyId = _data["companyId"];
            this.companyName = _data["companyName"];
            this.combinableWithNonBank = _data["combinableWithNonBank"];
            this.combinableWithBank = _data["combinableWithBank"];
            this.totalWithPromotionDiscount = _data["totalWithPromotionDiscount"];
            this.quotes = _data["quotes"];
            this.withoutInteres = _data["withoutInteres"];
            this.discountAmount = _data["discountAmount"];
            this.refundAmount = _data["refundAmount"];
            if (Array.isArray(_data["combinedPromotionsIds"])) {
                this.combinedPromotionsIds = [] as any;
                for (let item of _data["combinedPromotionsIds"])
                    this.combinedPromotionsIds.push(item);
            }
            this.discountPercent = _data["discountPercent"];
            this.refundPerc = _data["refundPerc"];
            this.creditNotePerc = _data["creditNotePerc"];
            this.totalAmount = _data["totalAmount"];
            this.appliedOnDetails = _data["appliedOnDetails"];
        }
    }

    static fromJS(data: any): PromotionInvoiceDto {
        data = typeof data === 'object' ? data : {};
        let result = new PromotionInvoiceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tenantId"] = this.tenantId;
        data["name"] = this.name;
        data["description"] = this.description;
        data["amount"] = this.amount;
        data["maxQuantity"] = this.maxQuantity;
        data["dateInit"] = this.dateInit ? this.dateInit.toISOString() : <any>undefined;
        data["dateEnd"] = this.dateEnd ? this.dateEnd.toISOString() : <any>undefined;
        data["promotionType"] = this.promotionType;
        data["promotionTypeName"] = this.promotionTypeName;
        data["bankId"] = this.bankId;
        data["bankName"] = this.bankName;
        data["companyId"] = this.companyId;
        data["companyName"] = this.companyName;
        data["combinableWithNonBank"] = this.combinableWithNonBank;
        data["combinableWithBank"] = this.combinableWithBank;
        data["totalWithPromotionDiscount"] = this.totalWithPromotionDiscount;
        data["quotes"] = this.quotes;
        data["withoutInteres"] = this.withoutInteres;
        data["discountAmount"] = this.discountAmount;
        data["refundAmount"] = this.refundAmount;
        if (Array.isArray(this.combinedPromotionsIds)) {
            data["combinedPromotionsIds"] = [];
            for (let item of this.combinedPromotionsIds)
                data["combinedPromotionsIds"].push(item);
        }
        data["discountPercent"] = this.discountPercent;
        data["refundPerc"] = this.refundPerc;
        data["creditNotePerc"] = this.creditNotePerc;
        data["totalAmount"] = this.totalAmount;
        data["appliedOnDetails"] = this.appliedOnDetails;
        return data;
    }

    clone(): PromotionInvoiceDto {
        const json = this.toJSON();
        let result = new PromotionInvoiceDto();
        result.init(json);
        return result;
    }
}

export interface IPromotionInvoiceDto {
    id: number;
    tenantId: number | undefined;
    name: string | undefined;
    description: string | undefined;
    amount: number;
    maxQuantity: number;
    dateInit: moment.Moment;
    dateEnd: moment.Moment | undefined;
    promotionType: PromotionType;
    promotionTypeName: string | undefined;
    bankId: number;
    bankName: string | undefined;
    companyId: number;
    companyName: string | undefined;
    combinableWithNonBank: boolean;
    combinableWithBank: boolean;
    totalWithPromotionDiscount: number;
    quotes: number;
    withoutInteres: boolean;
    discountAmount: number;
    refundAmount: number;
    combinedPromotionsIds: number[] | undefined;
    discountPercent: number;
    refundPerc: number;
    creditNotePerc: number;
    totalAmount: number;
    appliedOnDetails: boolean;
}

export class PromotionInvoiceWidget implements IPromotionInvoiceWidget {
    id: number;
    name: string | undefined;
    promotionTypeName: string | undefined;
    amount: number;
    dateEnd: moment.Moment | undefined;

    constructor(data?: IPromotionInvoiceWidget) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.promotionTypeName = _data["promotionTypeName"];
            this.amount = _data["amount"];
            this.dateEnd = _data["dateEnd"] ? moment(_data["dateEnd"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): PromotionInvoiceWidget {
        data = typeof data === 'object' ? data : {};
        let result = new PromotionInvoiceWidget();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["promotionTypeName"] = this.promotionTypeName;
        data["amount"] = this.amount;
        data["dateEnd"] = this.dateEnd ? this.dateEnd.toISOString() : <any>undefined;
        return data;
    }

    clone(): PromotionInvoiceWidget {
        const json = this.toJSON();
        let result = new PromotionInvoiceWidget();
        result.init(json);
        return result;
    }
}

export interface IPromotionInvoiceWidget {
    id: number;
    name: string | undefined;
    promotionTypeName: string | undefined;
    amount: number;
    dateEnd: moment.Moment | undefined;
}

export class PromotionProductDto implements IPromotionProductDto {
    id: number;
    name: string | undefined;
    discountAmount: number;
    promotionType: PromotionType;
    readonly promotionTypeName: string | undefined;

    constructor(data?: IPromotionProductDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.discountAmount = _data["discountAmount"];
            this.promotionType = _data["promotionType"];
            (<any>this).promotionTypeName = _data["promotionTypeName"];
        }
    }

    static fromJS(data: any): PromotionProductDto {
        data = typeof data === 'object' ? data : {};
        let result = new PromotionProductDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["discountAmount"] = this.discountAmount;
        data["promotionType"] = this.promotionType;
        data["promotionTypeName"] = this.promotionTypeName;
        return data;
    }

    clone(): PromotionProductDto {
        const json = this.toJSON();
        let result = new PromotionProductDto();
        result.init(json);
        return result;
    }
}

export interface IPromotionProductDto {
    id: number;
    name: string | undefined;
    discountAmount: number;
    promotionType: PromotionType;
    promotionTypeName: string | undefined;
}

export enum PromotionStatus {
    Active = <any>"Active",
    NoActive = <any>"NoActive",
    Expired = <any>"Expired",
}

export class PromotionStore implements IPromotionStore {
    id: number;
    tenantId: number | undefined;
    isDeleted: boolean;
    dateInit: moment.Moment;
    dateEnd: moment.Moment | undefined;
    mon: boolean;
    tue: boolean;
    wed: boolean;
    thu: boolean;
    fri: boolean;
    sat: boolean;
    sun: boolean;
    isActive: boolean;
    promotionId: number;
    promotion: Promotion;
    storeId: number;
    store: Store;

    constructor(data?: IPromotionStore) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tenantId = _data["tenantId"];
            this.isDeleted = _data["isDeleted"];
            this.dateInit = _data["dateInit"] ? moment(_data["dateInit"].toString()) : <any>undefined;
            this.dateEnd = _data["dateEnd"] ? moment(_data["dateEnd"].toString()) : <any>undefined;
            this.mon = _data["mon"];
            this.tue = _data["tue"];
            this.wed = _data["wed"];
            this.thu = _data["thu"];
            this.fri = _data["fri"];
            this.sat = _data["sat"];
            this.sun = _data["sun"];
            this.isActive = _data["isActive"];
            this.promotionId = _data["promotionId"];
            this.promotion = _data["promotion"] ? Promotion.fromJS(_data["promotion"]) : <any>undefined;
            this.storeId = _data["storeId"];
            this.store = _data["store"] ? Store.fromJS(_data["store"]) : <any>undefined;
        }
    }

    static fromJS(data: any): PromotionStore {
        data = typeof data === 'object' ? data : {};
        let result = new PromotionStore();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tenantId"] = this.tenantId;
        data["isDeleted"] = this.isDeleted;
        data["dateInit"] = this.dateInit ? this.dateInit.toISOString() : <any>undefined;
        data["dateEnd"] = this.dateEnd ? this.dateEnd.toISOString() : <any>undefined;
        data["mon"] = this.mon;
        data["tue"] = this.tue;
        data["wed"] = this.wed;
        data["thu"] = this.thu;
        data["fri"] = this.fri;
        data["sat"] = this.sat;
        data["sun"] = this.sun;
        data["isActive"] = this.isActive;
        data["promotionId"] = this.promotionId;
        data["promotion"] = this.promotion ? this.promotion.toJSON() : <any>undefined;
        data["storeId"] = this.storeId;
        data["store"] = this.store ? this.store.toJSON() : <any>undefined;
        return data;
    }

    clone(): PromotionStore {
        const json = this.toJSON();
        let result = new PromotionStore();
        result.init(json);
        return result;
    }
}

export interface IPromotionStore {
    id: number;
    tenantId: number | undefined;
    isDeleted: boolean;
    dateInit: moment.Moment;
    dateEnd: moment.Moment | undefined;
    mon: boolean;
    tue: boolean;
    wed: boolean;
    thu: boolean;
    fri: boolean;
    sat: boolean;
    sun: boolean;
    isActive: boolean;
    promotionId: number;
    promotion: Promotion;
    storeId: number;
    store: Store;
}

export class PromotionStoreDto implements IPromotionStoreDto {
    id: number;
    tenantId: number | undefined;
    dateInit: moment.Moment;
    dateEnd: moment.Moment | undefined;
    mon: boolean;
    tue: boolean;
    wed: boolean;
    thu: boolean;
    fri: boolean;
    sat: boolean;
    sun: boolean;
    isActive: boolean;
    promotionId: number;
    storeId: number;

    constructor(data?: IPromotionStoreDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tenantId = _data["tenantId"];
            this.dateInit = _data["dateInit"] ? moment(_data["dateInit"].toString()) : <any>undefined;
            this.dateEnd = _data["dateEnd"] ? moment(_data["dateEnd"].toString()) : <any>undefined;
            this.mon = _data["mon"];
            this.tue = _data["tue"];
            this.wed = _data["wed"];
            this.thu = _data["thu"];
            this.fri = _data["fri"];
            this.sat = _data["sat"];
            this.sun = _data["sun"];
            this.isActive = _data["isActive"];
            this.promotionId = _data["promotionId"];
            this.storeId = _data["storeId"];
        }
    }

    static fromJS(data: any): PromotionStoreDto {
        data = typeof data === 'object' ? data : {};
        let result = new PromotionStoreDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tenantId"] = this.tenantId;
        data["dateInit"] = this.dateInit ? this.dateInit.toISOString() : <any>undefined;
        data["dateEnd"] = this.dateEnd ? this.dateEnd.toISOString() : <any>undefined;
        data["mon"] = this.mon;
        data["tue"] = this.tue;
        data["wed"] = this.wed;
        data["thu"] = this.thu;
        data["fri"] = this.fri;
        data["sat"] = this.sat;
        data["sun"] = this.sun;
        data["isActive"] = this.isActive;
        data["promotionId"] = this.promotionId;
        data["storeId"] = this.storeId;
        return data;
    }

    clone(): PromotionStoreDto {
        const json = this.toJSON();
        let result = new PromotionStoreDto();
        result.init(json);
        return result;
    }
}

export interface IPromotionStoreDto {
    id: number;
    tenantId: number | undefined;
    dateInit: moment.Moment;
    dateEnd: moment.Moment | undefined;
    mon: boolean;
    tue: boolean;
    wed: boolean;
    thu: boolean;
    fri: boolean;
    sat: boolean;
    sun: boolean;
    isActive: boolean;
    promotionId: number;
    storeId: number;
}

export enum PromotionType {
    Bank = <any>"Bank",
    General = <any>"General",
    DiscountReazon = <any>"DiscountReazon",
}

export class Property implements IProperty {
    id: number;
    tenantId: number | undefined;
    isDeleted: boolean;
    name: string | undefined;
    isActive: boolean;
    type: PropertyType;
    externalId: number | undefined;
    propertyGroupId: number;
    propertyGroup: PropertyGroup;
    productProperties: ProductProperty[] | undefined;
    propertyValues: PropertyValue[] | undefined;

    constructor(data?: IProperty) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tenantId = _data["tenantId"];
            this.isDeleted = _data["isDeleted"];
            this.name = _data["name"];
            this.isActive = _data["isActive"];
            this.type = _data["type"];
            this.externalId = _data["externalId"];
            this.propertyGroupId = _data["propertyGroupId"];
            this.propertyGroup = _data["propertyGroup"] ? PropertyGroup.fromJS(_data["propertyGroup"]) : <any>undefined;
            if (Array.isArray(_data["productProperties"])) {
                this.productProperties = [] as any;
                for (let item of _data["productProperties"])
                    this.productProperties.push(ProductProperty.fromJS(item));
            }
            if (Array.isArray(_data["propertyValues"])) {
                this.propertyValues = [] as any;
                for (let item of _data["propertyValues"])
                    this.propertyValues.push(PropertyValue.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Property {
        data = typeof data === 'object' ? data : {};
        let result = new Property();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tenantId"] = this.tenantId;
        data["isDeleted"] = this.isDeleted;
        data["name"] = this.name;
        data["isActive"] = this.isActive;
        data["type"] = this.type;
        data["externalId"] = this.externalId;
        data["propertyGroupId"] = this.propertyGroupId;
        data["propertyGroup"] = this.propertyGroup ? this.propertyGroup.toJSON() : <any>undefined;
        if (Array.isArray(this.productProperties)) {
            data["productProperties"] = [];
            for (let item of this.productProperties)
                data["productProperties"].push(item.toJSON());
        }
        if (Array.isArray(this.propertyValues)) {
            data["propertyValues"] = [];
            for (let item of this.propertyValues)
                data["propertyValues"].push(item.toJSON());
        }
        return data;
    }

    clone(): Property {
        const json = this.toJSON();
        let result = new Property();
        result.init(json);
        return result;
    }
}

export interface IProperty {
    id: number;
    tenantId: number | undefined;
    isDeleted: boolean;
    name: string | undefined;
    isActive: boolean;
    type: PropertyType;
    externalId: number | undefined;
    propertyGroupId: number;
    propertyGroup: PropertyGroup;
    productProperties: ProductProperty[] | undefined;
    propertyValues: PropertyValue[] | undefined;
}

export class PropertyDto implements IPropertyDto {
    id: number;
    tenantId: number | undefined;
    name: string | undefined;
    isActive: boolean;
    type: PropertyType;
    propertyGroupName: string | undefined;
    propertyGroupId: number;
    values: string | undefined;
    propertyValues: PropertyValueDto[] | undefined;

    constructor(data?: IPropertyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tenantId = _data["tenantId"];
            this.name = _data["name"];
            this.isActive = _data["isActive"];
            this.type = _data["type"];
            this.propertyGroupName = _data["propertyGroupName"];
            this.propertyGroupId = _data["propertyGroupId"];
            this.values = _data["values"];
            if (Array.isArray(_data["propertyValues"])) {
                this.propertyValues = [] as any;
                for (let item of _data["propertyValues"])
                    this.propertyValues.push(PropertyValueDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PropertyDto {
        data = typeof data === 'object' ? data : {};
        let result = new PropertyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tenantId"] = this.tenantId;
        data["name"] = this.name;
        data["isActive"] = this.isActive;
        data["type"] = this.type;
        data["propertyGroupName"] = this.propertyGroupName;
        data["propertyGroupId"] = this.propertyGroupId;
        data["values"] = this.values;
        if (Array.isArray(this.propertyValues)) {
            data["propertyValues"] = [];
            for (let item of this.propertyValues)
                data["propertyValues"].push(item.toJSON());
        }
        return data;
    }

    clone(): PropertyDto {
        const json = this.toJSON();
        let result = new PropertyDto();
        result.init(json);
        return result;
    }
}

export interface IPropertyDto {
    id: number;
    tenantId: number | undefined;
    name: string | undefined;
    isActive: boolean;
    type: PropertyType;
    propertyGroupName: string | undefined;
    propertyGroupId: number;
    values: string | undefined;
    propertyValues: PropertyValueDto[] | undefined;
}

export class PropertyDtoPagedResultDto implements IPropertyDtoPagedResultDto {
    items: PropertyDto[] | undefined;
    totalCount: number;

    constructor(data?: IPropertyDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(PropertyDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): PropertyDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new PropertyDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): PropertyDtoPagedResultDto {
        const json = this.toJSON();
        let result = new PropertyDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IPropertyDtoPagedResultDto {
    items: PropertyDto[] | undefined;
    totalCount: number;
}

export class PropertyGroup implements IPropertyGroup {
    id: number;
    tenantId: number | undefined;
    isDeleted: boolean;
    name: string | undefined;
    isActive: boolean;
    properties: Property[] | undefined;

    constructor(data?: IPropertyGroup) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tenantId = _data["tenantId"];
            this.isDeleted = _data["isDeleted"];
            this.name = _data["name"];
            this.isActive = _data["isActive"];
            if (Array.isArray(_data["properties"])) {
                this.properties = [] as any;
                for (let item of _data["properties"])
                    this.properties.push(Property.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PropertyGroup {
        data = typeof data === 'object' ? data : {};
        let result = new PropertyGroup();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tenantId"] = this.tenantId;
        data["isDeleted"] = this.isDeleted;
        data["name"] = this.name;
        data["isActive"] = this.isActive;
        if (Array.isArray(this.properties)) {
            data["properties"] = [];
            for (let item of this.properties)
                data["properties"].push(item.toJSON());
        }
        return data;
    }

    clone(): PropertyGroup {
        const json = this.toJSON();
        let result = new PropertyGroup();
        result.init(json);
        return result;
    }
}

export interface IPropertyGroup {
    id: number;
    tenantId: number | undefined;
    isDeleted: boolean;
    name: string | undefined;
    isActive: boolean;
    properties: Property[] | undefined;
}

export enum PropertyType {
    Text = <any>"Text",
    Number = <any>"Number",
    Check = <any>"Check",
    List = <any>"List",
}

export class PropertyValue implements IPropertyValue {
    id: number;
    tenantId: number | undefined;
    isDeleted: boolean;
    name: string | undefined;
    code: string | undefined;
    propertyId: number;
    property: Property;
    order: number;
    externalId: number | undefined;

    constructor(data?: IPropertyValue) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tenantId = _data["tenantId"];
            this.isDeleted = _data["isDeleted"];
            this.name = _data["name"];
            this.code = _data["code"];
            this.propertyId = _data["propertyId"];
            this.property = _data["property"] ? Property.fromJS(_data["property"]) : <any>undefined;
            this.order = _data["order"];
            this.externalId = _data["externalId"];
        }
    }

    static fromJS(data: any): PropertyValue {
        data = typeof data === 'object' ? data : {};
        let result = new PropertyValue();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tenantId"] = this.tenantId;
        data["isDeleted"] = this.isDeleted;
        data["name"] = this.name;
        data["code"] = this.code;
        data["propertyId"] = this.propertyId;
        data["property"] = this.property ? this.property.toJSON() : <any>undefined;
        data["order"] = this.order;
        data["externalId"] = this.externalId;
        return data;
    }

    clone(): PropertyValue {
        const json = this.toJSON();
        let result = new PropertyValue();
        result.init(json);
        return result;
    }
}

export interface IPropertyValue {
    id: number;
    tenantId: number | undefined;
    isDeleted: boolean;
    name: string | undefined;
    code: string | undefined;
    propertyId: number;
    property: Property;
    order: number;
    externalId: number | undefined;
}

export class PropertyValueDto implements IPropertyValueDto {
    id: number;
    tenantId: number | undefined;
    name: string | undefined;
    code: string | undefined;
    order: number;
    propertyId: number;
    isDeleted: boolean;

    constructor(data?: IPropertyValueDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tenantId = _data["tenantId"];
            this.name = _data["name"];
            this.code = _data["code"];
            this.order = _data["order"];
            this.propertyId = _data["propertyId"];
            this.isDeleted = _data["isDeleted"];
        }
    }

    static fromJS(data: any): PropertyValueDto {
        data = typeof data === 'object' ? data : {};
        let result = new PropertyValueDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tenantId"] = this.tenantId;
        data["name"] = this.name;
        data["code"] = this.code;
        data["order"] = this.order;
        data["propertyId"] = this.propertyId;
        data["isDeleted"] = this.isDeleted;
        return data;
    }

    clone(): PropertyValueDto {
        const json = this.toJSON();
        let result = new PropertyValueDto();
        result.init(json);
        return result;
    }
}

export interface IPropertyValueDto {
    id: number;
    tenantId: number | undefined;
    name: string | undefined;
    code: string | undefined;
    order: number;
    propertyId: number;
    isDeleted: boolean;
}

export class ProviderPayment implements IProviderPayment {
    id: number;
    tenantId: number | undefined;
    isDeleted: boolean;
    name: string | undefined;
    description: string | undefined;
    hasIdTransaction: boolean;
    expireDate: moment.Moment;
    icon: string | undefined;
    currencyId: number | undefined;
    currency: Currency;
    type: TypeProviderPayment;
    isStatic: boolean;
    transactions: Transaction[] | undefined;
    storePayments: StorePayment[] | undefined;

    constructor(data?: IProviderPayment) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tenantId = _data["tenantId"];
            this.isDeleted = _data["isDeleted"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.hasIdTransaction = _data["hasIdTransaction"];
            this.expireDate = _data["expireDate"] ? moment(_data["expireDate"].toString()) : <any>undefined;
            this.icon = _data["icon"];
            this.currencyId = _data["currencyId"];
            this.currency = _data["currency"] ? Currency.fromJS(_data["currency"]) : <any>undefined;
            this.type = _data["type"];
            this.isStatic = _data["isStatic"];
            if (Array.isArray(_data["transactions"])) {
                this.transactions = [] as any;
                for (let item of _data["transactions"])
                    this.transactions.push(Transaction.fromJS(item));
            }
            if (Array.isArray(_data["storePayments"])) {
                this.storePayments = [] as any;
                for (let item of _data["storePayments"])
                    this.storePayments.push(StorePayment.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProviderPayment {
        data = typeof data === 'object' ? data : {};
        let result = new ProviderPayment();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tenantId"] = this.tenantId;
        data["isDeleted"] = this.isDeleted;
        data["name"] = this.name;
        data["description"] = this.description;
        data["hasIdTransaction"] = this.hasIdTransaction;
        data["expireDate"] = this.expireDate ? this.expireDate.toISOString() : <any>undefined;
        data["icon"] = this.icon;
        data["currencyId"] = this.currencyId;
        data["currency"] = this.currency ? this.currency.toJSON() : <any>undefined;
        data["type"] = this.type;
        data["isStatic"] = this.isStatic;
        if (Array.isArray(this.transactions)) {
            data["transactions"] = [];
            for (let item of this.transactions)
                data["transactions"].push(item.toJSON());
        }
        if (Array.isArray(this.storePayments)) {
            data["storePayments"] = [];
            for (let item of this.storePayments)
                data["storePayments"].push(item.toJSON());
        }
        return data;
    }

    clone(): ProviderPayment {
        const json = this.toJSON();
        let result = new ProviderPayment();
        result.init(json);
        return result;
    }
}

export interface IProviderPayment {
    id: number;
    tenantId: number | undefined;
    isDeleted: boolean;
    name: string | undefined;
    description: string | undefined;
    hasIdTransaction: boolean;
    expireDate: moment.Moment;
    icon: string | undefined;
    currencyId: number | undefined;
    currency: Currency;
    type: TypeProviderPayment;
    isStatic: boolean;
    transactions: Transaction[] | undefined;
    storePayments: StorePayment[] | undefined;
}

export class ProviderPaymentDto implements IProviderPaymentDto {
    id: number;
    tenantId: number | undefined;
    name: string | undefined;
    description: string | undefined;
    hasIdTransaction: boolean;
    currencyId: number | undefined;
    icon: string | undefined;
    isStatic: boolean;
    type: TypeProviderPayment;
    listStoresId: number[] | undefined;
    listStoresPayments: StorePaymentDto[] | undefined;

    constructor(data?: IProviderPaymentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tenantId = _data["tenantId"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.hasIdTransaction = _data["hasIdTransaction"];
            this.currencyId = _data["currencyId"];
            this.icon = _data["icon"];
            this.isStatic = _data["isStatic"];
            this.type = _data["type"];
            if (Array.isArray(_data["listStoresId"])) {
                this.listStoresId = [] as any;
                for (let item of _data["listStoresId"])
                    this.listStoresId.push(item);
            }
            if (Array.isArray(_data["listStoresPayments"])) {
                this.listStoresPayments = [] as any;
                for (let item of _data["listStoresPayments"])
                    this.listStoresPayments.push(StorePaymentDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProviderPaymentDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProviderPaymentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tenantId"] = this.tenantId;
        data["name"] = this.name;
        data["description"] = this.description;
        data["hasIdTransaction"] = this.hasIdTransaction;
        data["currencyId"] = this.currencyId;
        data["icon"] = this.icon;
        data["isStatic"] = this.isStatic;
        data["type"] = this.type;
        if (Array.isArray(this.listStoresId)) {
            data["listStoresId"] = [];
            for (let item of this.listStoresId)
                data["listStoresId"].push(item);
        }
        if (Array.isArray(this.listStoresPayments)) {
            data["listStoresPayments"] = [];
            for (let item of this.listStoresPayments)
                data["listStoresPayments"].push(item.toJSON());
        }
        return data;
    }

    clone(): ProviderPaymentDto {
        const json = this.toJSON();
        let result = new ProviderPaymentDto();
        result.init(json);
        return result;
    }
}

export interface IProviderPaymentDto {
    id: number;
    tenantId: number | undefined;
    name: string | undefined;
    description: string | undefined;
    hasIdTransaction: boolean;
    currencyId: number | undefined;
    icon: string | undefined;
    isStatic: boolean;
    type: TypeProviderPayment;
    listStoresId: number[] | undefined;
    listStoresPayments: StorePaymentDto[] | undefined;
}

export class ProviderPaymentDtoPagedResultDto implements IProviderPaymentDtoPagedResultDto {
    items: ProviderPaymentDto[] | undefined;
    totalCount: number;

    constructor(data?: IProviderPaymentDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(ProviderPaymentDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): ProviderPaymentDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProviderPaymentDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): ProviderPaymentDtoPagedResultDto {
        const json = this.toJSON();
        let result = new ProviderPaymentDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IProviderPaymentDtoPagedResultDto {
    items: ProviderPaymentDto[] | undefined;
    totalCount: number;
}

export class Quote implements IQuote {
    id: number;
    tenantId: number | undefined;
    isDeleted: boolean;
    name: string | undefined;
    cant: number;
    surcharge: number;
    externalId: number | undefined;
    planName: string | undefined;
    isActivePlan: boolean;
    companyId: number;
    parentId: number;
    parentCompanyId: number;
    company: Company;

    constructor(data?: IQuote) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tenantId = _data["tenantId"];
            this.isDeleted = _data["isDeleted"];
            this.name = _data["name"];
            this.cant = _data["cant"];
            this.surcharge = _data["surcharge"];
            this.externalId = _data["externalId"];
            this.planName = _data["planName"];
            this.isActivePlan = _data["isActivePlan"];
            this.companyId = _data["companyId"];
            this.parentId = _data["parentId"];
            this.parentCompanyId = _data["parentCompanyId"];
            this.company = _data["company"] ? Company.fromJS(_data["company"]) : <any>undefined;
        }
    }

    static fromJS(data: any): Quote {
        data = typeof data === 'object' ? data : {};
        let result = new Quote();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tenantId"] = this.tenantId;
        data["isDeleted"] = this.isDeleted;
        data["name"] = this.name;
        data["cant"] = this.cant;
        data["surcharge"] = this.surcharge;
        data["externalId"] = this.externalId;
        data["planName"] = this.planName;
        data["isActivePlan"] = this.isActivePlan;
        data["companyId"] = this.companyId;
        data["parentId"] = this.parentId;
        data["parentCompanyId"] = this.parentCompanyId;
        data["company"] = this.company ? this.company.toJSON() : <any>undefined;
        return data;
    }

    clone(): Quote {
        const json = this.toJSON();
        let result = new Quote();
        result.init(json);
        return result;
    }
}

export interface IQuote {
    id: number;
    tenantId: number | undefined;
    isDeleted: boolean;
    name: string | undefined;
    cant: number;
    surcharge: number;
    externalId: number | undefined;
    planName: string | undefined;
    isActivePlan: boolean;
    companyId: number;
    parentId: number;
    parentCompanyId: number;
    company: Company;
}

export class QuoteDto implements IQuoteDto {
    id: number;
    tenantId: number | undefined;
    name: string | undefined;
    cant: number;
    surcharge: number;
    companyId: number;
    companyName: string | undefined;
    planName: string | undefined;
    isActivePlan: boolean | undefined;

    constructor(data?: IQuoteDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tenantId = _data["tenantId"];
            this.name = _data["name"];
            this.cant = _data["cant"];
            this.surcharge = _data["surcharge"];
            this.companyId = _data["companyId"];
            this.companyName = _data["companyName"];
            this.planName = _data["planName"];
            this.isActivePlan = _data["isActivePlan"];
        }
    }

    static fromJS(data: any): QuoteDto {
        data = typeof data === 'object' ? data : {};
        let result = new QuoteDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tenantId"] = this.tenantId;
        data["name"] = this.name;
        data["cant"] = this.cant;
        data["surcharge"] = this.surcharge;
        data["companyId"] = this.companyId;
        data["companyName"] = this.companyName;
        data["planName"] = this.planName;
        data["isActivePlan"] = this.isActivePlan;
        return data;
    }

    clone(): QuoteDto {
        const json = this.toJSON();
        let result = new QuoteDto();
        result.init(json);
        return result;
    }
}

export interface IQuoteDto {
    id: number;
    tenantId: number | undefined;
    name: string | undefined;
    cant: number;
    surcharge: number;
    companyId: number;
    companyName: string | undefined;
    planName: string | undefined;
    isActivePlan: boolean | undefined;
}

export class QuoteDtoPagedResultDto implements IQuoteDtoPagedResultDto {
    items: QuoteDto[] | undefined;
    totalCount: number;

    constructor(data?: IQuoteDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(QuoteDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): QuoteDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new QuoteDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): QuoteDtoPagedResultDto {
        const json = this.toJSON();
        let result = new QuoteDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IQuoteDtoPagedResultDto {
    items: QuoteDto[] | undefined;
    totalCount: number;
}

export class QuoteInfoDto implements IQuoteInfoDto {
    cant: number;
    surcharge: number;
    surchargeResult: number;
    totalResult: number;

    constructor(data?: IQuoteInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cant = _data["cant"];
            this.surcharge = _data["surcharge"];
            this.surchargeResult = _data["surchargeResult"];
            this.totalResult = _data["totalResult"];
        }
    }

    static fromJS(data: any): QuoteInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new QuoteInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cant"] = this.cant;
        data["surcharge"] = this.surcharge;
        data["surchargeResult"] = this.surchargeResult;
        data["totalResult"] = this.totalResult;
        return data;
    }

    clone(): QuoteInfoDto {
        const json = this.toJSON();
        let result = new QuoteInfoDto();
        result.init(json);
        return result;
    }
}

export interface IQuoteInfoDto {
    cant: number;
    surcharge: number;
    surchargeResult: number;
    totalResult: number;
}

export class QuoteModel implements IQuoteModel {
    id: number;
    name: string | undefined;
    cant: number;
    surcharge: number;
    companyId: number;

    constructor(data?: IQuoteModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.cant = _data["cant"];
            this.surcharge = _data["surcharge"];
            this.companyId = _data["companyId"];
        }
    }

    static fromJS(data: any): QuoteModel {
        data = typeof data === 'object' ? data : {};
        let result = new QuoteModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["cant"] = this.cant;
        data["surcharge"] = this.surcharge;
        data["companyId"] = this.companyId;
        return data;
    }

    clone(): QuoteModel {
        const json = this.toJSON();
        let result = new QuoteModel();
        result.init(json);
        return result;
    }
}

export interface IQuoteModel {
    id: number;
    name: string | undefined;
    cant: number;
    surcharge: number;
    companyId: number;
}

export class QuoteSelectDto implements IQuoteSelectDto {
    id: number;
    name: string | undefined;
    cant: number;
    surcharge: number;

    constructor(data?: IQuoteSelectDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.cant = _data["cant"];
            this.surcharge = _data["surcharge"];
        }
    }

    static fromJS(data: any): QuoteSelectDto {
        data = typeof data === 'object' ? data : {};
        let result = new QuoteSelectDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["cant"] = this.cant;
        data["surcharge"] = this.surcharge;
        return data;
    }

    clone(): QuoteSelectDto {
        const json = this.toJSON();
        let result = new QuoteSelectDto();
        result.init(json);
        return result;
    }
}

export interface IQuoteSelectDto {
    id: number;
    name: string | undefined;
    cant: number;
    surcharge: number;
}

export class Relationship implements IRelationship {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    tenantId: number | undefined;
    name: string | undefined;
    clientId: number;
    client: Client;
    description: string | undefined;
    birthdate: moment.Moment;
    relationshipType: RelationshipType;

    constructor(data?: IRelationship) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.tenantId = _data["tenantId"];
            this.name = _data["name"];
            this.clientId = _data["clientId"];
            this.client = _data["client"] ? Client.fromJS(_data["client"]) : <any>undefined;
            this.description = _data["description"];
            this.birthdate = _data["birthdate"] ? moment(_data["birthdate"].toString()) : <any>undefined;
            this.relationshipType = _data["relationshipType"];
        }
    }

    static fromJS(data: any): Relationship {
        data = typeof data === 'object' ? data : {};
        let result = new Relationship();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["tenantId"] = this.tenantId;
        data["name"] = this.name;
        data["clientId"] = this.clientId;
        data["client"] = this.client ? this.client.toJSON() : <any>undefined;
        data["description"] = this.description;
        data["birthdate"] = this.birthdate ? this.birthdate.toISOString() : <any>undefined;
        data["relationshipType"] = this.relationshipType;
        return data;
    }

    clone(): Relationship {
        const json = this.toJSON();
        let result = new Relationship();
        result.init(json);
        return result;
    }
}

export interface IRelationship {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    tenantId: number | undefined;
    name: string | undefined;
    clientId: number;
    client: Client;
    description: string | undefined;
    birthdate: moment.Moment;
    relationshipType: RelationshipType;
}

export class RelationshipDto implements IRelationshipDto {
    id: number;
    tenantId: number | undefined;
    clientId: number;
    name: string | undefined;
    description: string | undefined;
    birthdate: moment.Moment;

    constructor(data?: IRelationshipDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tenantId = _data["tenantId"];
            this.clientId = _data["clientId"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.birthdate = _data["birthdate"] ? moment(_data["birthdate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): RelationshipDto {
        data = typeof data === 'object' ? data : {};
        let result = new RelationshipDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tenantId"] = this.tenantId;
        data["clientId"] = this.clientId;
        data["name"] = this.name;
        data["description"] = this.description;
        data["birthdate"] = this.birthdate ? this.birthdate.toISOString() : <any>undefined;
        return data;
    }

    clone(): RelationshipDto {
        const json = this.toJSON();
        let result = new RelationshipDto();
        result.init(json);
        return result;
    }
}

export interface IRelationshipDto {
    id: number;
    tenantId: number | undefined;
    clientId: number;
    name: string | undefined;
    description: string | undefined;
    birthdate: moment.Moment;
}

export enum RelationshipType {
    Son = <any>"Son",
    Daughter = <any>"Daughter",
    Father = <any>"Father",
    Mother = <any>"Mother",
}

export class Reservation implements IReservation {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    tenantId: number | undefined;
    amount: number;
    total: number;
    expirationDate: moment.Moment | undefined;
    state: ReserveState;
    invoiceId: number;
    invoice: Invoice;
    parentId: number | undefined;
    parent: Reservation;
    childReservations: Reservation[] | undefined;
    readonly remaining: number;

    constructor(data?: IReservation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.tenantId = _data["tenantId"];
            this.amount = _data["amount"];
            this.total = _data["total"];
            this.expirationDate = _data["expirationDate"] ? moment(_data["expirationDate"].toString()) : <any>undefined;
            this.state = _data["state"];
            this.invoiceId = _data["invoiceId"];
            this.invoice = _data["invoice"] ? Invoice.fromJS(_data["invoice"]) : <any>undefined;
            this.parentId = _data["parentId"];
            this.parent = _data["parent"] ? Reservation.fromJS(_data["parent"]) : <any>undefined;
            if (Array.isArray(_data["childReservations"])) {
                this.childReservations = [] as any;
                for (let item of _data["childReservations"])
                    this.childReservations.push(Reservation.fromJS(item));
            }
            (<any>this).remaining = _data["remaining"];
        }
    }

    static fromJS(data: any): Reservation {
        data = typeof data === 'object' ? data : {};
        let result = new Reservation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["tenantId"] = this.tenantId;
        data["amount"] = this.amount;
        data["total"] = this.total;
        data["expirationDate"] = this.expirationDate ? this.expirationDate.toISOString() : <any>undefined;
        data["state"] = this.state;
        data["invoiceId"] = this.invoiceId;
        data["invoice"] = this.invoice ? this.invoice.toJSON() : <any>undefined;
        data["parentId"] = this.parentId;
        data["parent"] = this.parent ? this.parent.toJSON() : <any>undefined;
        if (Array.isArray(this.childReservations)) {
            data["childReservations"] = [];
            for (let item of this.childReservations)
                data["childReservations"].push(item.toJSON());
        }
        data["remaining"] = this.remaining;
        return data;
    }

    clone(): Reservation {
        const json = this.toJSON();
        let result = new Reservation();
        result.init(json);
        return result;
    }
}

export interface IReservation {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    tenantId: number | undefined;
    amount: number;
    total: number;
    expirationDate: moment.Moment | undefined;
    state: ReserveState;
    invoiceId: number;
    invoice: Invoice;
    parentId: number | undefined;
    parent: Reservation;
    childReservations: Reservation[] | undefined;
    remaining: number;
}

export class ReservationAddDaysDto implements IReservationAddDaysDto {
    id: number;
    days: number;

    constructor(data?: IReservationAddDaysDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.days = _data["days"];
        }
    }

    static fromJS(data: any): ReservationAddDaysDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReservationAddDaysDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["days"] = this.days;
        return data;
    }

    clone(): ReservationAddDaysDto {
        const json = this.toJSON();
        let result = new ReservationAddDaysDto();
        result.init(json);
        return result;
    }
}

export interface IReservationAddDaysDto {
    id: number;
    days: number;
}

export class ReservationDto implements IReservationDto {
    id: number;
    tenantId: number | undefined;
    amount: number;
    total: number;
    remaining: number;
    expirationDate: moment.Moment | undefined;
    creationTime: moment.Moment;
    invoiceId: number;
    state: ReserveState;
    readonly stateName: string | undefined;
    parentId: number | undefined;
    invoice: InvoiceDto;
    childReservations: ReservationDto[] | undefined;
    readonly calcRemaining: number;
    readonly calcAmount: number;

    constructor(data?: IReservationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tenantId = _data["tenantId"];
            this.amount = _data["amount"];
            this.total = _data["total"];
            this.remaining = _data["remaining"];
            this.expirationDate = _data["expirationDate"] ? moment(_data["expirationDate"].toString()) : <any>undefined;
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.invoiceId = _data["invoiceId"];
            this.state = _data["state"];
            (<any>this).stateName = _data["stateName"];
            this.parentId = _data["parentId"];
            this.invoice = _data["invoice"] ? InvoiceDto.fromJS(_data["invoice"]) : <any>undefined;
            if (Array.isArray(_data["childReservations"])) {
                this.childReservations = [] as any;
                for (let item of _data["childReservations"])
                    this.childReservations.push(ReservationDto.fromJS(item));
            }
            (<any>this).calcRemaining = _data["calcRemaining"];
            (<any>this).calcAmount = _data["calcAmount"];
        }
    }

    static fromJS(data: any): ReservationDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReservationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tenantId"] = this.tenantId;
        data["amount"] = this.amount;
        data["total"] = this.total;
        data["remaining"] = this.remaining;
        data["expirationDate"] = this.expirationDate ? this.expirationDate.toISOString() : <any>undefined;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["invoiceId"] = this.invoiceId;
        data["state"] = this.state;
        data["stateName"] = this.stateName;
        data["parentId"] = this.parentId;
        data["invoice"] = this.invoice ? this.invoice.toJSON() : <any>undefined;
        if (Array.isArray(this.childReservations)) {
            data["childReservations"] = [];
            for (let item of this.childReservations)
                data["childReservations"].push(item.toJSON());
        }
        data["calcRemaining"] = this.calcRemaining;
        data["calcAmount"] = this.calcAmount;
        return data;
    }

    clone(): ReservationDto {
        const json = this.toJSON();
        let result = new ReservationDto();
        result.init(json);
        return result;
    }
}

export interface IReservationDto {
    id: number;
    tenantId: number | undefined;
    amount: number;
    total: number;
    remaining: number;
    expirationDate: moment.Moment | undefined;
    creationTime: moment.Moment;
    invoiceId: number;
    state: ReserveState;
    stateName: string | undefined;
    parentId: number | undefined;
    invoice: InvoiceDto;
    childReservations: ReservationDto[] | undefined;
    calcRemaining: number;
    calcAmount: number;
}

export class ReservationDtoPagedResultDto implements IReservationDtoPagedResultDto {
    items: ReservationDto[] | undefined;
    totalCount: number;

    constructor(data?: IReservationDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(ReservationDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): ReservationDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReservationDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): ReservationDtoPagedResultDto {
        const json = this.toJSON();
        let result = new ReservationDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IReservationDtoPagedResultDto {
    items: ReservationDto[] | undefined;
    totalCount: number;
}

export enum ReservationStatus {
    Active = <any>"Active",
    Expired = <any>"Expired",
}

export enum ReserveState {
    Pending = <any>"Pending",
    Canceled = <any>"Canceled",
    Finished = <any>"Finished",
}

export class ResetPasswordDto implements IResetPasswordDto {
    adminPassword: string;
    userId: number;
    newPassword: string;

    constructor(data?: IResetPasswordDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.adminPassword = _data["adminPassword"];
            this.userId = _data["userId"];
            this.newPassword = _data["newPassword"];
        }
    }

    static fromJS(data: any): ResetPasswordDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResetPasswordDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["adminPassword"] = this.adminPassword;
        data["userId"] = this.userId;
        data["newPassword"] = this.newPassword;
        return data;
    }

    clone(): ResetPasswordDto {
        const json = this.toJSON();
        let result = new ResetPasswordDto();
        result.init(json);
        return result;
    }
}

export interface IResetPasswordDto {
    adminPassword: string;
    userId: number;
    newPassword: string;
}

export class ReturnReversalDataDto implements IReturnReversalDataDto {
    paymentData: PaymentDataDto;
    reversalRequestDate: moment.Moment;
    reversalStatus: ReversalStatus;
    paymentId: string | undefined;

    constructor(data?: IReturnReversalDataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.paymentData = _data["paymentData"] ? PaymentDataDto.fromJS(_data["paymentData"]) : <any>undefined;
            this.reversalRequestDate = _data["reversalRequestDate"] ? moment(_data["reversalRequestDate"].toString()) : <any>undefined;
            this.reversalStatus = _data["reversalStatus"];
            this.paymentId = _data["paymentId"];
        }
    }

    static fromJS(data: any): ReturnReversalDataDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReturnReversalDataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["paymentData"] = this.paymentData ? this.paymentData.toJSON() : <any>undefined;
        data["reversalRequestDate"] = this.reversalRequestDate ? this.reversalRequestDate.toISOString() : <any>undefined;
        data["reversalStatus"] = this.reversalStatus;
        data["paymentId"] = this.paymentId;
        return data;
    }

    clone(): ReturnReversalDataDto {
        const json = this.toJSON();
        let result = new ReturnReversalDataDto();
        result.init(json);
        return result;
    }
}

export interface IReturnReversalDataDto {
    paymentData: PaymentDataDto;
    reversalRequestDate: moment.Moment;
    reversalStatus: ReversalStatus;
    paymentId: string | undefined;
}

export enum ReversalStatus {
    REVERSAL_REQUEST = <any>"REVERSAL_REQUEST",
    PROCESSING_REVERSAL = <any>"PROCESSING_REVERSAL",
    REVERSED = <any>"REVERSED",
    REVERSAL_ERROR = <any>"REVERSAL_ERROR",
    REVERSAL_DECLINED = <any>"REVERSAL_DECLINED",
    UNDO_REVERSAL_REQUEST = <any>"UNDO_REVERSAL_REQUEST",
    PROCESSING_UNDO_REVERSAL = <any>"PROCESSING_UNDO_REVERSAL",
    REVERSAL_UNDONE = <any>"REVERSAL_UNDONE",
    UNDO_REVERSAL_DECLINED = <any>"UNDO_REVERSAL_DECLINED",
}

export class RoleDto implements IRoleDto {
    id: number;
    name: string;
    displayName: string;
    normalizedName: string | undefined;
    description: string | undefined;
    grantParentalPermissions: boolean;
    grantedPermissions: string[] | undefined;
    isStatic: boolean;

    constructor(data?: IRoleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.normalizedName = _data["normalizedName"];
            this.description = _data["description"];
            this.grantParentalPermissions = _data["grantParentalPermissions"];
            if (Array.isArray(_data["grantedPermissions"])) {
                this.grantedPermissions = [] as any;
                for (let item of _data["grantedPermissions"])
                    this.grantedPermissions.push(item);
            }
            this.isStatic = _data["isStatic"];
        }
    }

    static fromJS(data: any): RoleDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["normalizedName"] = this.normalizedName;
        data["description"] = this.description;
        data["grantParentalPermissions"] = this.grantParentalPermissions;
        if (Array.isArray(this.grantedPermissions)) {
            data["grantedPermissions"] = [];
            for (let item of this.grantedPermissions)
                data["grantedPermissions"].push(item);
        }
        data["isStatic"] = this.isStatic;
        return data;
    }

    clone(): RoleDto {
        const json = this.toJSON();
        let result = new RoleDto();
        result.init(json);
        return result;
    }
}

export interface IRoleDto {
    id: number;
    name: string;
    displayName: string;
    normalizedName: string | undefined;
    description: string | undefined;
    grantParentalPermissions: boolean;
    grantedPermissions: string[] | undefined;
    isStatic: boolean;
}

export class RoleDtoListResultDto implements IRoleDtoListResultDto {
    items: RoleDto[] | undefined;

    constructor(data?: IRoleDtoListResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(RoleDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RoleDtoListResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoleDtoListResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): RoleDtoListResultDto {
        const json = this.toJSON();
        let result = new RoleDtoListResultDto();
        result.init(json);
        return result;
    }
}

export interface IRoleDtoListResultDto {
    items: RoleDto[] | undefined;
}

export class RoleDtoPagedResultDto implements IRoleDtoPagedResultDto {
    items: RoleDto[] | undefined;
    totalCount: number;

    constructor(data?: IRoleDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(RoleDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): RoleDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoleDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): RoleDtoPagedResultDto {
        const json = this.toJSON();
        let result = new RoleDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IRoleDtoPagedResultDto {
    items: RoleDto[] | undefined;
    totalCount: number;
}

export class RoleEditDto implements IRoleEditDto {
    id: number;
    name: string;
    displayName: string;
    description: string | undefined;
    isStatic: boolean;

    constructor(data?: IRoleEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.description = _data["description"];
            this.isStatic = _data["isStatic"];
        }
    }

    static fromJS(data: any): RoleEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoleEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["description"] = this.description;
        data["isStatic"] = this.isStatic;
        return data;
    }

    clone(): RoleEditDto {
        const json = this.toJSON();
        let result = new RoleEditDto();
        result.init(json);
        return result;
    }
}

export interface IRoleEditDto {
    id: number;
    name: string;
    displayName: string;
    description: string | undefined;
    isStatic: boolean;
}

export class RoleListDto implements IRoleListDto {
    id: number;
    name: string | undefined;
    displayName: string | undefined;
    isStatic: boolean;
    isDefault: boolean;
    creationTime: moment.Moment;

    constructor(data?: IRoleListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.isStatic = _data["isStatic"];
            this.isDefault = _data["isDefault"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): RoleListDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoleListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["isStatic"] = this.isStatic;
        data["isDefault"] = this.isDefault;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        return data;
    }

    clone(): RoleListDto {
        const json = this.toJSON();
        let result = new RoleListDto();
        result.init(json);
        return result;
    }
}

export interface IRoleListDto {
    id: number;
    name: string | undefined;
    displayName: string | undefined;
    isStatic: boolean;
    isDefault: boolean;
    creationTime: moment.Moment;
}

export class RoleListDtoListResultDto implements IRoleListDtoListResultDto {
    items: RoleListDto[] | undefined;

    constructor(data?: IRoleListDtoListResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(RoleListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RoleListDtoListResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoleListDtoListResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): RoleListDtoListResultDto {
        const json = this.toJSON();
        let result = new RoleListDtoListResultDto();
        result.init(json);
        return result;
    }
}

export interface IRoleListDtoListResultDto {
    items: RoleListDto[] | undefined;
}

export class SalePoint implements ISalePoint {
    id: number;
    tenantId: number | undefined;
    isDeleted: boolean;
    name: string | undefined;
    prefix: string | undefined;
    description: string | undefined;
    type: TypeSalePoint;
    storeId: number;
    store: Store;
    printerId: number | undefined;
    printer: Printer;
    invoices: Invoice[] | undefined;
    vendors: User[] | undefined;
    cashiers: Cashier[] | undefined;
    promotionStore: PromotionStore[] | undefined;

    constructor(data?: ISalePoint) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tenantId = _data["tenantId"];
            this.isDeleted = _data["isDeleted"];
            this.name = _data["name"];
            this.prefix = _data["prefix"];
            this.description = _data["description"];
            this.type = _data["type"];
            this.storeId = _data["storeId"];
            this.store = _data["store"] ? Store.fromJS(_data["store"]) : <any>undefined;
            this.printerId = _data["printerId"];
            this.printer = _data["printer"] ? Printer.fromJS(_data["printer"]) : <any>undefined;
            if (Array.isArray(_data["invoices"])) {
                this.invoices = [] as any;
                for (let item of _data["invoices"])
                    this.invoices.push(Invoice.fromJS(item));
            }
            if (Array.isArray(_data["vendors"])) {
                this.vendors = [] as any;
                for (let item of _data["vendors"])
                    this.vendors.push(User.fromJS(item));
            }
            if (Array.isArray(_data["cashiers"])) {
                this.cashiers = [] as any;
                for (let item of _data["cashiers"])
                    this.cashiers.push(Cashier.fromJS(item));
            }
            if (Array.isArray(_data["promotionStore"])) {
                this.promotionStore = [] as any;
                for (let item of _data["promotionStore"])
                    this.promotionStore.push(PromotionStore.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SalePoint {
        data = typeof data === 'object' ? data : {};
        let result = new SalePoint();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tenantId"] = this.tenantId;
        data["isDeleted"] = this.isDeleted;
        data["name"] = this.name;
        data["prefix"] = this.prefix;
        data["description"] = this.description;
        data["type"] = this.type;
        data["storeId"] = this.storeId;
        data["store"] = this.store ? this.store.toJSON() : <any>undefined;
        data["printerId"] = this.printerId;
        data["printer"] = this.printer ? this.printer.toJSON() : <any>undefined;
        if (Array.isArray(this.invoices)) {
            data["invoices"] = [];
            for (let item of this.invoices)
                data["invoices"].push(item.toJSON());
        }
        if (Array.isArray(this.vendors)) {
            data["vendors"] = [];
            for (let item of this.vendors)
                data["vendors"].push(item.toJSON());
        }
        if (Array.isArray(this.cashiers)) {
            data["cashiers"] = [];
            for (let item of this.cashiers)
                data["cashiers"].push(item.toJSON());
        }
        if (Array.isArray(this.promotionStore)) {
            data["promotionStore"] = [];
            for (let item of this.promotionStore)
                data["promotionStore"].push(item.toJSON());
        }
        return data;
    }

    clone(): SalePoint {
        const json = this.toJSON();
        let result = new SalePoint();
        result.init(json);
        return result;
    }
}

export interface ISalePoint {
    id: number;
    tenantId: number | undefined;
    isDeleted: boolean;
    name: string | undefined;
    prefix: string | undefined;
    description: string | undefined;
    type: TypeSalePoint;
    storeId: number;
    store: Store;
    printerId: number | undefined;
    printer: Printer;
    invoices: Invoice[] | undefined;
    vendors: User[] | undefined;
    cashiers: Cashier[] | undefined;
    promotionStore: PromotionStore[] | undefined;
}

export class SalePointDto implements ISalePointDto {
    id: number;
    tenantId: number | undefined;
    name: string | undefined;
    prefix: string | undefined;
    description: string | undefined;
    storeId: number;
    storeName: string | undefined;
    type: TypeSalePoint;
    printerId: number | undefined;

    constructor(data?: ISalePointDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tenantId = _data["tenantId"];
            this.name = _data["name"];
            this.prefix = _data["prefix"];
            this.description = _data["description"];
            this.storeId = _data["storeId"];
            this.storeName = _data["storeName"];
            this.type = _data["type"];
            this.printerId = _data["printerId"];
        }
    }

    static fromJS(data: any): SalePointDto {
        data = typeof data === 'object' ? data : {};
        let result = new SalePointDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tenantId"] = this.tenantId;
        data["name"] = this.name;
        data["prefix"] = this.prefix;
        data["description"] = this.description;
        data["storeId"] = this.storeId;
        data["storeName"] = this.storeName;
        data["type"] = this.type;
        data["printerId"] = this.printerId;
        return data;
    }

    clone(): SalePointDto {
        const json = this.toJSON();
        let result = new SalePointDto();
        result.init(json);
        return result;
    }
}

export interface ISalePointDto {
    id: number;
    tenantId: number | undefined;
    name: string | undefined;
    prefix: string | undefined;
    description: string | undefined;
    storeId: number;
    storeName: string | undefined;
    type: TypeSalePoint;
    printerId: number | undefined;
}

export class SalePointDtoPagedResultDto implements ISalePointDtoPagedResultDto {
    items: SalePointDto[] | undefined;
    totalCount: number;

    constructor(data?: ISalePointDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(SalePointDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): SalePointDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new SalePointDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): SalePointDtoPagedResultDto {
        const json = this.toJSON();
        let result = new SalePointDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface ISalePointDtoPagedResultDto {
    items: SalePointDto[] | undefined;
    totalCount: number;
}

export class SalePointInvoiceDto implements ISalePointInvoiceDto {
    id: number;
    tenantId: number | undefined;
    prefix: string | undefined;
    storeId: number | undefined;
    type: TypeSalePoint;

    constructor(data?: ISalePointInvoiceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tenantId = _data["tenantId"];
            this.prefix = _data["prefix"];
            this.storeId = _data["storeId"];
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): SalePointInvoiceDto {
        data = typeof data === 'object' ? data : {};
        let result = new SalePointInvoiceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tenantId"] = this.tenantId;
        data["prefix"] = this.prefix;
        data["storeId"] = this.storeId;
        data["type"] = this.type;
        return data;
    }

    clone(): SalePointInvoiceDto {
        const json = this.toJSON();
        let result = new SalePointInvoiceDto();
        result.init(json);
        return result;
    }
}

export interface ISalePointInvoiceDto {
    id: number;
    tenantId: number | undefined;
    prefix: string | undefined;
    storeId: number | undefined;
    type: TypeSalePoint;
}

export class SalesRankingDto implements ISalesRankingDto {
    productId: number;
    productName: string | undefined;
    color: string | undefined;
    size: string | undefined;
    sales: number;
    totalSales: number;

    constructor(data?: ISalesRankingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productId = _data["productId"];
            this.productName = _data["productName"];
            this.color = _data["color"];
            this.size = _data["size"];
            this.sales = _data["sales"];
            this.totalSales = _data["totalSales"];
        }
    }

    static fromJS(data: any): SalesRankingDto {
        data = typeof data === 'object' ? data : {};
        let result = new SalesRankingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productId"] = this.productId;
        data["productName"] = this.productName;
        data["color"] = this.color;
        data["size"] = this.size;
        data["sales"] = this.sales;
        data["totalSales"] = this.totalSales;
        return data;
    }

    clone(): SalesRankingDto {
        const json = this.toJSON();
        let result = new SalesRankingDto();
        result.init(json);
        return result;
    }
}

export interface ISalesRankingDto {
    productId: number;
    productName: string | undefined;
    color: string | undefined;
    size: string | undefined;
    sales: number;
    totalSales: number;
}

export class SalesRankingDtoPagedResultDto implements ISalesRankingDtoPagedResultDto {
    items: SalesRankingDto[] | undefined;
    totalCount: number;

    constructor(data?: ISalesRankingDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(SalesRankingDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): SalesRankingDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new SalesRankingDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): SalesRankingDtoPagedResultDto {
        const json = this.toJSON();
        let result = new SalesRankingDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface ISalesRankingDtoPagedResultDto {
    items: SalesRankingDto[] | undefined;
    totalCount: number;
}

export class SalesRankingProductsMonthlyFilterDto implements ISalesRankingProductsMonthlyFilterDto {
    maxResultCount: number;
    skipCount: number;
    orderColumn: string | undefined;
    order: string | undefined;
    keyword: string | undefined;
    from: moment.Moment | undefined;
    to: moment.Moment | undefined;
    sellerIds: number[] | undefined;
    userRoles: string[] | undefined;
    isOwner: boolean;
    tenantId: number | undefined;
    userId: number;

    constructor(data?: ISalesRankingProductsMonthlyFilterDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.maxResultCount = _data["maxResultCount"];
            this.skipCount = _data["skipCount"];
            this.orderColumn = _data["orderColumn"];
            this.order = _data["order"];
            this.keyword = _data["keyword"];
            this.from = _data["from"] ? moment(_data["from"].toString()) : <any>undefined;
            this.to = _data["to"] ? moment(_data["to"].toString()) : <any>undefined;
            if (Array.isArray(_data["sellerIds"])) {
                this.sellerIds = [] as any;
                for (let item of _data["sellerIds"])
                    this.sellerIds.push(item);
            }
            if (Array.isArray(_data["userRoles"])) {
                this.userRoles = [] as any;
                for (let item of _data["userRoles"])
                    this.userRoles.push(item);
            }
            this.isOwner = _data["isOwner"];
            this.tenantId = _data["tenantId"];
            this.userId = _data["userId"];
        }
    }

    static fromJS(data: any): SalesRankingProductsMonthlyFilterDto {
        data = typeof data === 'object' ? data : {};
        let result = new SalesRankingProductsMonthlyFilterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxResultCount"] = this.maxResultCount;
        data["skipCount"] = this.skipCount;
        data["orderColumn"] = this.orderColumn;
        data["order"] = this.order;
        data["keyword"] = this.keyword;
        data["from"] = this.from ? this.from.toISOString() : <any>undefined;
        data["to"] = this.to ? this.to.toISOString() : <any>undefined;
        if (Array.isArray(this.sellerIds)) {
            data["sellerIds"] = [];
            for (let item of this.sellerIds)
                data["sellerIds"].push(item);
        }
        if (Array.isArray(this.userRoles)) {
            data["userRoles"] = [];
            for (let item of this.userRoles)
                data["userRoles"].push(item);
        }
        data["isOwner"] = this.isOwner;
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        return data;
    }

    clone(): SalesRankingProductsMonthlyFilterDto {
        const json = this.toJSON();
        let result = new SalesRankingProductsMonthlyFilterDto();
        result.init(json);
        return result;
    }
}

export interface ISalesRankingProductsMonthlyFilterDto {
    maxResultCount: number;
    skipCount: number;
    orderColumn: string | undefined;
    order: string | undefined;
    keyword: string | undefined;
    from: moment.Moment | undefined;
    to: moment.Moment | undefined;
    sellerIds: number[] | undefined;
    userRoles: string[] | undefined;
    isOwner: boolean;
    tenantId: number | undefined;
    userId: number;
}

export class SalesRankingWidgetDto implements ISalesRankingWidgetDto {
    productId: number;
    productName: string | undefined;
    sales: number;
    totalSales: number;

    constructor(data?: ISalesRankingWidgetDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productId = _data["productId"];
            this.productName = _data["productName"];
            this.sales = _data["sales"];
            this.totalSales = _data["totalSales"];
        }
    }

    static fromJS(data: any): SalesRankingWidgetDto {
        data = typeof data === 'object' ? data : {};
        let result = new SalesRankingWidgetDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productId"] = this.productId;
        data["productName"] = this.productName;
        data["sales"] = this.sales;
        data["totalSales"] = this.totalSales;
        return data;
    }

    clone(): SalesRankingWidgetDto {
        const json = this.toJSON();
        let result = new SalesRankingWidgetDto();
        result.init(json);
        return result;
    }
}

export interface ISalesRankingWidgetDto {
    productId: number;
    productName: string | undefined;
    sales: number;
    totalSales: number;
}

export class SalesRankingWidgetDtoPagedResultDto implements ISalesRankingWidgetDtoPagedResultDto {
    items: SalesRankingWidgetDto[] | undefined;
    totalCount: number;

    constructor(data?: ISalesRankingWidgetDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(SalesRankingWidgetDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): SalesRankingWidgetDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new SalesRankingWidgetDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): SalesRankingWidgetDtoPagedResultDto {
        const json = this.toJSON();
        let result = new SalesRankingWidgetDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface ISalesRankingWidgetDtoPagedResultDto {
    items: SalesRankingWidgetDto[] | undefined;
    totalCount: number;
}

export class SalesRankingWithTotalsDto implements ISalesRankingWithTotalsDto {
    items: SellersRankingDto[] | undefined;
    totalCount: number;
    totals: SellersRankingCardTotalDto;

    constructor(data?: ISalesRankingWithTotalsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(SellersRankingDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
            this.totals = _data["totals"] ? SellersRankingCardTotalDto.fromJS(_data["totals"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SalesRankingWithTotalsDto {
        data = typeof data === 'object' ? data : {};
        let result = new SalesRankingWithTotalsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        data["totals"] = this.totals ? this.totals.toJSON() : <any>undefined;
        return data;
    }

    clone(): SalesRankingWithTotalsDto {
        const json = this.toJSON();
        let result = new SalesRankingWithTotalsDto();
        result.init(json);
        return result;
    }
}

export interface ISalesRankingWithTotalsDto {
    items: SellersRankingDto[] | undefined;
    totalCount: number;
    totals: SellersRankingCardTotalDto;
}

export class SellersRankingCardTotalDto implements ISellersRankingCardTotalDto {
    totalWithoutDiscounts: number;
    totalSales: number;
    totalWithoutTaxes: number;
    readonly amountWithoutDiscountAndTax: number;

    constructor(data?: ISellersRankingCardTotalDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalWithoutDiscounts = _data["totalWithoutDiscounts"];
            this.totalSales = _data["totalSales"];
            this.totalWithoutTaxes = _data["totalWithoutTaxes"];
            (<any>this).amountWithoutDiscountAndTax = _data["amountWithoutDiscountAndTax"];
        }
    }

    static fromJS(data: any): SellersRankingCardTotalDto {
        data = typeof data === 'object' ? data : {};
        let result = new SellersRankingCardTotalDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalWithoutDiscounts"] = this.totalWithoutDiscounts;
        data["totalSales"] = this.totalSales;
        data["totalWithoutTaxes"] = this.totalWithoutTaxes;
        data["amountWithoutDiscountAndTax"] = this.amountWithoutDiscountAndTax;
        return data;
    }

    clone(): SellersRankingCardTotalDto {
        const json = this.toJSON();
        let result = new SellersRankingCardTotalDto();
        result.init(json);
        return result;
    }
}

export interface ISellersRankingCardTotalDto {
    totalWithoutDiscounts: number;
    totalSales: number;
    totalWithoutTaxes: number;
    amountWithoutDiscountAndTax: number;
}

export class SellersRankingDto implements ISellersRankingDto {
    storeId: number;
    vendorId: number | undefined;
    name: string | undefined;
    surname: string | undefined;
    year: number | undefined;
    readonly month: string | undefined;
    storeName: string | undefined;
    totalProducts: number;
    readonly amountWithoutDiscountAndTax: number;
    readonly totalDiscounts: number;
    readonly totalWithoutIva: number;
    totalInvoice: number;
    totalCreditNote: number;
    readonly total: number;
    amountInvoices: number;
    totalInvoiceProductsDiscountAmount: number;
    totalCreditNoteProductsDiscountAmount: number;
    readonly totalProductsDiscountAmount: number;
    totalIvaInvoice: number;
    totalDiscountInvoice: number;
    totalIvaCreditNote: number;
    totalDiscountCreditNote: number;
    date: moment.Moment | undefined;

    constructor(data?: ISellersRankingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.storeId = _data["storeId"];
            this.vendorId = _data["vendorId"];
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.year = _data["year"];
            (<any>this).month = _data["month"];
            this.storeName = _data["storeName"];
            this.totalProducts = _data["totalProducts"];
            (<any>this).amountWithoutDiscountAndTax = _data["amountWithoutDiscountAndTax"];
            (<any>this).totalDiscounts = _data["totalDiscounts"];
            (<any>this).totalWithoutIva = _data["totalWithoutIva"];
            this.totalInvoice = _data["totalInvoice"];
            this.totalCreditNote = _data["totalCreditNote"];
            (<any>this).total = _data["total"];
            this.amountInvoices = _data["amountInvoices"];
            this.totalInvoiceProductsDiscountAmount = _data["totalInvoiceProductsDiscountAmount"];
            this.totalCreditNoteProductsDiscountAmount = _data["totalCreditNoteProductsDiscountAmount"];
            (<any>this).totalProductsDiscountAmount = _data["totalProductsDiscountAmount"];
            this.totalIvaInvoice = _data["totalIvaInvoice"];
            this.totalDiscountInvoice = _data["totalDiscountInvoice"];
            this.totalIvaCreditNote = _data["totalIvaCreditNote"];
            this.totalDiscountCreditNote = _data["totalDiscountCreditNote"];
            this.date = _data["date"] ? moment(_data["date"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): SellersRankingDto {
        data = typeof data === 'object' ? data : {};
        let result = new SellersRankingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["storeId"] = this.storeId;
        data["vendorId"] = this.vendorId;
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["year"] = this.year;
        data["month"] = this.month;
        data["storeName"] = this.storeName;
        data["totalProducts"] = this.totalProducts;
        data["amountWithoutDiscountAndTax"] = this.amountWithoutDiscountAndTax;
        data["totalDiscounts"] = this.totalDiscounts;
        data["totalWithoutIva"] = this.totalWithoutIva;
        data["totalInvoice"] = this.totalInvoice;
        data["totalCreditNote"] = this.totalCreditNote;
        data["total"] = this.total;
        data["amountInvoices"] = this.amountInvoices;
        data["totalInvoiceProductsDiscountAmount"] = this.totalInvoiceProductsDiscountAmount;
        data["totalCreditNoteProductsDiscountAmount"] = this.totalCreditNoteProductsDiscountAmount;
        data["totalProductsDiscountAmount"] = this.totalProductsDiscountAmount;
        data["totalIvaInvoice"] = this.totalIvaInvoice;
        data["totalDiscountInvoice"] = this.totalDiscountInvoice;
        data["totalIvaCreditNote"] = this.totalIvaCreditNote;
        data["totalDiscountCreditNote"] = this.totalDiscountCreditNote;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        return data;
    }

    clone(): SellersRankingDto {
        const json = this.toJSON();
        let result = new SellersRankingDto();
        result.init(json);
        return result;
    }
}

export interface ISellersRankingDto {
    storeId: number;
    vendorId: number | undefined;
    name: string | undefined;
    surname: string | undefined;
    year: number | undefined;
    month: string | undefined;
    storeName: string | undefined;
    totalProducts: number;
    amountWithoutDiscountAndTax: number;
    totalDiscounts: number;
    totalWithoutIva: number;
    totalInvoice: number;
    totalCreditNote: number;
    total: number;
    amountInvoices: number;
    totalInvoiceProductsDiscountAmount: number;
    totalCreditNoteProductsDiscountAmount: number;
    totalProductsDiscountAmount: number;
    totalIvaInvoice: number;
    totalDiscountInvoice: number;
    totalIvaCreditNote: number;
    totalDiscountCreditNote: number;
    date: moment.Moment | undefined;
}

export class SellersRankingDtoPagedResultDto implements ISellersRankingDtoPagedResultDto {
    items: SellersRankingDto[] | undefined;
    totalCount: number;

    constructor(data?: ISellersRankingDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(SellersRankingDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): SellersRankingDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new SellersRankingDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): SellersRankingDtoPagedResultDto {
        const json = this.toJSON();
        let result = new SellersRankingDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface ISellersRankingDtoPagedResultDto {
    items: SellersRankingDto[] | undefined;
    totalCount: number;
}

export class SellersRankingReportDto implements ISellersRankingReportDto {
    storeId: number;
    vendorId: number | undefined;
    name: string | undefined;
    surname: string | undefined;
    storeName: string | undefined;
    totalProducts: number;
    readonly amountWithoutDiscountAndTax: number;
    readonly totalDiscounts: number;
    readonly totalWithoutIva: number;
    totalInvoice: number;
    totalCreditNote: number;
    readonly total: number;
    amountInvoices: number;
    totalInvoiceProductsDiscountAmount: number;
    totalCreditNoteProductsDiscountAmount: number;
    readonly totalProductsDiscountAmount: number;
    totalIvaInvoice: number;
    totalDiscountInvoice: number;
    totalIvaCreditNote: number;
    totalDiscountCreditNote: number;
    year: number | undefined;
    date: moment.Moment | undefined;
    readonly month: string | undefined;

    constructor(data?: ISellersRankingReportDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.storeId = _data["storeId"];
            this.vendorId = _data["vendorId"];
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.storeName = _data["storeName"];
            this.totalProducts = _data["totalProducts"];
            (<any>this).amountWithoutDiscountAndTax = _data["amountWithoutDiscountAndTax"];
            (<any>this).totalDiscounts = _data["totalDiscounts"];
            (<any>this).totalWithoutIva = _data["totalWithoutIva"];
            this.totalInvoice = _data["totalInvoice"];
            this.totalCreditNote = _data["totalCreditNote"];
            (<any>this).total = _data["total"];
            this.amountInvoices = _data["amountInvoices"];
            this.totalInvoiceProductsDiscountAmount = _data["totalInvoiceProductsDiscountAmount"];
            this.totalCreditNoteProductsDiscountAmount = _data["totalCreditNoteProductsDiscountAmount"];
            (<any>this).totalProductsDiscountAmount = _data["totalProductsDiscountAmount"];
            this.totalIvaInvoice = _data["totalIvaInvoice"];
            this.totalDiscountInvoice = _data["totalDiscountInvoice"];
            this.totalIvaCreditNote = _data["totalIvaCreditNote"];
            this.totalDiscountCreditNote = _data["totalDiscountCreditNote"];
            this.year = _data["year"];
            this.date = _data["date"] ? moment(_data["date"].toString()) : <any>undefined;
            (<any>this).month = _data["month"];
        }
    }

    static fromJS(data: any): SellersRankingReportDto {
        data = typeof data === 'object' ? data : {};
        let result = new SellersRankingReportDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["storeId"] = this.storeId;
        data["vendorId"] = this.vendorId;
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["storeName"] = this.storeName;
        data["totalProducts"] = this.totalProducts;
        data["amountWithoutDiscountAndTax"] = this.amountWithoutDiscountAndTax;
        data["totalDiscounts"] = this.totalDiscounts;
        data["totalWithoutIva"] = this.totalWithoutIva;
        data["totalInvoice"] = this.totalInvoice;
        data["totalCreditNote"] = this.totalCreditNote;
        data["total"] = this.total;
        data["amountInvoices"] = this.amountInvoices;
        data["totalInvoiceProductsDiscountAmount"] = this.totalInvoiceProductsDiscountAmount;
        data["totalCreditNoteProductsDiscountAmount"] = this.totalCreditNoteProductsDiscountAmount;
        data["totalProductsDiscountAmount"] = this.totalProductsDiscountAmount;
        data["totalIvaInvoice"] = this.totalIvaInvoice;
        data["totalDiscountInvoice"] = this.totalDiscountInvoice;
        data["totalIvaCreditNote"] = this.totalIvaCreditNote;
        data["totalDiscountCreditNote"] = this.totalDiscountCreditNote;
        data["year"] = this.year;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["month"] = this.month;
        return data;
    }

    clone(): SellersRankingReportDto {
        const json = this.toJSON();
        let result = new SellersRankingReportDto();
        result.init(json);
        return result;
    }
}

export interface ISellersRankingReportDto {
    storeId: number;
    vendorId: number | undefined;
    name: string | undefined;
    surname: string | undefined;
    storeName: string | undefined;
    totalProducts: number;
    amountWithoutDiscountAndTax: number;
    totalDiscounts: number;
    totalWithoutIva: number;
    totalInvoice: number;
    totalCreditNote: number;
    total: number;
    amountInvoices: number;
    totalInvoiceProductsDiscountAmount: number;
    totalCreditNoteProductsDiscountAmount: number;
    totalProductsDiscountAmount: number;
    totalIvaInvoice: number;
    totalDiscountInvoice: number;
    totalIvaCreditNote: number;
    totalDiscountCreditNote: number;
    year: number | undefined;
    date: moment.Moment | undefined;
    month: string | undefined;
}

export class SellersRankingReportDtoPagedResultDto implements ISellersRankingReportDtoPagedResultDto {
    items: SellersRankingReportDto[] | undefined;
    totalCount: number;

    constructor(data?: ISellersRankingReportDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(SellersRankingReportDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): SellersRankingReportDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new SellersRankingReportDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): SellersRankingReportDtoPagedResultDto {
        const json = this.toJSON();
        let result = new SellersRankingReportDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface ISellersRankingReportDtoPagedResultDto {
    items: SellersRankingReportDto[] | undefined;
    totalCount: number;
}

export class Setting implements ISetting {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    tenantId: number | undefined;
    userId: number | undefined;
    name: string;
    value: string | undefined;

    constructor(data?: ISetting) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.tenantId = _data["tenantId"];
            this.userId = _data["userId"];
            this.name = _data["name"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): Setting {
        data = typeof data === 'object' ? data : {};
        let result = new Setting();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        data["name"] = this.name;
        data["value"] = this.value;
        return data;
    }

    clone(): Setting {
        const json = this.toJSON();
        let result = new Setting();
        result.init(json);
        return result;
    }
}

export interface ISetting {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    tenantId: number | undefined;
    userId: number | undefined;
    name: string;
    value: string | undefined;
}

export class SettingValueDto implements ISettingValueDto {
    name: string | undefined;
    value: string | undefined;

    constructor(data?: ISettingValueDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): SettingValueDto {
        data = typeof data === 'object' ? data : {};
        let result = new SettingValueDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["value"] = this.value;
        return data;
    }

    clone(): SettingValueDto {
        const json = this.toJSON();
        let result = new SettingValueDto();
        result.init(json);
        return result;
    }
}

export interface ISettingValueDto {
    name: string | undefined;
    value: string | undefined;
}

export class Size implements ISize {
    id: number;
    tenantId: number | undefined;
    isDeleted: boolean;
    name: string | undefined;
    order: number;
    curve: string | undefined;
    variants: Variant[] | undefined;

    constructor(data?: ISize) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tenantId = _data["tenantId"];
            this.isDeleted = _data["isDeleted"];
            this.name = _data["name"];
            this.order = _data["order"];
            this.curve = _data["curve"];
            if (Array.isArray(_data["variants"])) {
                this.variants = [] as any;
                for (let item of _data["variants"])
                    this.variants.push(Variant.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Size {
        data = typeof data === 'object' ? data : {};
        let result = new Size();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tenantId"] = this.tenantId;
        data["isDeleted"] = this.isDeleted;
        data["name"] = this.name;
        data["order"] = this.order;
        data["curve"] = this.curve;
        if (Array.isArray(this.variants)) {
            data["variants"] = [];
            for (let item of this.variants)
                data["variants"].push(item.toJSON());
        }
        return data;
    }

    clone(): Size {
        const json = this.toJSON();
        let result = new Size();
        result.init(json);
        return result;
    }
}

export interface ISize {
    id: number;
    tenantId: number | undefined;
    isDeleted: boolean;
    name: string | undefined;
    order: number;
    curve: string | undefined;
    variants: Variant[] | undefined;
}

export class SizeDto implements ISizeDto {
    id: number;
    tenantId: number | undefined;
    curve: string | undefined;
    sizes: string[] | undefined;
    sizesFull: SizeFullDto[] | undefined;

    constructor(data?: ISizeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tenantId = _data["tenantId"];
            this.curve = _data["curve"];
            if (Array.isArray(_data["sizes"])) {
                this.sizes = [] as any;
                for (let item of _data["sizes"])
                    this.sizes.push(item);
            }
            if (Array.isArray(_data["sizesFull"])) {
                this.sizesFull = [] as any;
                for (let item of _data["sizesFull"])
                    this.sizesFull.push(SizeFullDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SizeDto {
        data = typeof data === 'object' ? data : {};
        let result = new SizeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tenantId"] = this.tenantId;
        data["curve"] = this.curve;
        if (Array.isArray(this.sizes)) {
            data["sizes"] = [];
            for (let item of this.sizes)
                data["sizes"].push(item);
        }
        if (Array.isArray(this.sizesFull)) {
            data["sizesFull"] = [];
            for (let item of this.sizesFull)
                data["sizesFull"].push(item.toJSON());
        }
        return data;
    }

    clone(): SizeDto {
        const json = this.toJSON();
        let result = new SizeDto();
        result.init(json);
        return result;
    }
}

export interface ISizeDto {
    id: number;
    tenantId: number | undefined;
    curve: string | undefined;
    sizes: string[] | undefined;
    sizesFull: SizeFullDto[] | undefined;
}

export class SizeDtoPagedResultDto implements ISizeDtoPagedResultDto {
    items: SizeDto[] | undefined;
    totalCount: number;

    constructor(data?: ISizeDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(SizeDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): SizeDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new SizeDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): SizeDtoPagedResultDto {
        const json = this.toJSON();
        let result = new SizeDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface ISizeDtoPagedResultDto {
    items: SizeDto[] | undefined;
    totalCount: number;
}

export class SizeFullDto implements ISizeFullDto {
    id: number;
    name: string | undefined;

    constructor(data?: ISizeFullDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): SizeFullDto {
        data = typeof data === 'object' ? data : {};
        let result = new SizeFullDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }

    clone(): SizeFullDto {
        const json = this.toJSON();
        let result = new SizeFullDto();
        result.init(json);
        return result;
    }
}

export interface ISizeFullDto {
    id: number;
    name: string | undefined;
}

export class SizeGetAllDto implements ISizeGetAllDto {
    id: number;
    sizes: string[] | undefined;
    curve: string | undefined;

    constructor(data?: ISizeGetAllDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            if (Array.isArray(_data["sizes"])) {
                this.sizes = [] as any;
                for (let item of _data["sizes"])
                    this.sizes.push(item);
            }
            this.curve = _data["curve"];
        }
    }

    static fromJS(data: any): SizeGetAllDto {
        data = typeof data === 'object' ? data : {};
        let result = new SizeGetAllDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (Array.isArray(this.sizes)) {
            data["sizes"] = [];
            for (let item of this.sizes)
                data["sizes"].push(item);
        }
        data["curve"] = this.curve;
        return data;
    }

    clone(): SizeGetAllDto {
        const json = this.toJSON();
        let result = new SizeGetAllDto();
        result.init(json);
        return result;
    }
}

export interface ISizeGetAllDto {
    id: number;
    sizes: string[] | undefined;
    curve: string | undefined;
}

export class SizeGetAllDtoPagedResultDto implements ISizeGetAllDtoPagedResultDto {
    items: SizeGetAllDto[] | undefined;
    totalCount: number;

    constructor(data?: ISizeGetAllDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(SizeGetAllDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): SizeGetAllDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new SizeGetAllDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): SizeGetAllDtoPagedResultDto {
        const json = this.toJSON();
        let result = new SizeGetAllDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface ISizeGetAllDtoPagedResultDto {
    items: SizeGetAllDto[] | undefined;
    totalCount: number;
}

export class SoftDownloadDto implements ISoftDownloadDto {
    id: number;
    filedata: string | undefined;
    contentType: string | undefined;
    fileName: string | undefined;

    constructor(data?: ISoftDownloadDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.filedata = _data["filedata"];
            this.contentType = _data["contentType"];
            this.fileName = _data["fileName"];
        }
    }

    static fromJS(data: any): SoftDownloadDto {
        data = typeof data === 'object' ? data : {};
        let result = new SoftDownloadDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["filedata"] = this.filedata;
        data["contentType"] = this.contentType;
        data["fileName"] = this.fileName;
        return data;
    }

    clone(): SoftDownloadDto {
        const json = this.toJSON();
        let result = new SoftDownloadDto();
        result.init(json);
        return result;
    }
}

export interface ISoftDownloadDto {
    id: number;
    filedata: string | undefined;
    contentType: string | undefined;
    fileName: string | undefined;
}

export class Software implements ISoftware {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    tenantId: number | undefined;
    name: string | undefined;
    version: string | undefined;
    fileAttachmentId: number;
    fileAttachment: FileAttachment;
    printers: Printer[] | undefined;

    constructor(data?: ISoftware) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.tenantId = _data["tenantId"];
            this.name = _data["name"];
            this.version = _data["version"];
            this.fileAttachmentId = _data["fileAttachmentId"];
            this.fileAttachment = _data["fileAttachment"] ? FileAttachment.fromJS(_data["fileAttachment"]) : <any>undefined;
            if (Array.isArray(_data["printers"])) {
                this.printers = [] as any;
                for (let item of _data["printers"])
                    this.printers.push(Printer.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Software {
        data = typeof data === 'object' ? data : {};
        let result = new Software();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["tenantId"] = this.tenantId;
        data["name"] = this.name;
        data["version"] = this.version;
        data["fileAttachmentId"] = this.fileAttachmentId;
        data["fileAttachment"] = this.fileAttachment ? this.fileAttachment.toJSON() : <any>undefined;
        if (Array.isArray(this.printers)) {
            data["printers"] = [];
            for (let item of this.printers)
                data["printers"].push(item.toJSON());
        }
        return data;
    }

    clone(): Software {
        const json = this.toJSON();
        let result = new Software();
        result.init(json);
        return result;
    }
}

export interface ISoftware {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    tenantId: number | undefined;
    name: string | undefined;
    version: string | undefined;
    fileAttachmentId: number;
    fileAttachment: FileAttachment;
    printers: Printer[] | undefined;
}

export class SoftwareDto implements ISoftwareDto {
    id: number;
    name: string | undefined;
    version: string | undefined;
    fileAttachmentId: number;
    tenantId: number | undefined;

    constructor(data?: ISoftwareDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.version = _data["version"];
            this.fileAttachmentId = _data["fileAttachmentId"];
            this.tenantId = _data["tenantId"];
        }
    }

    static fromJS(data: any): SoftwareDto {
        data = typeof data === 'object' ? data : {};
        let result = new SoftwareDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["version"] = this.version;
        data["fileAttachmentId"] = this.fileAttachmentId;
        data["tenantId"] = this.tenantId;
        return data;
    }

    clone(): SoftwareDto {
        const json = this.toJSON();
        let result = new SoftwareDto();
        result.init(json);
        return result;
    }
}

export interface ISoftwareDto {
    id: number;
    name: string | undefined;
    version: string | undefined;
    fileAttachmentId: number;
    tenantId: number | undefined;
}

export class SoftwareDtoPagedResultDto implements ISoftwareDtoPagedResultDto {
    items: SoftwareDto[] | undefined;
    totalCount: number;

    constructor(data?: ISoftwareDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(SoftwareDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): SoftwareDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new SoftwareDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): SoftwareDtoPagedResultDto {
        const json = this.toJSON();
        let result = new SoftwareDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface ISoftwareDtoPagedResultDto {
    items: SoftwareDto[] | undefined;
    totalCount: number;
}

export class Stock implements IStock {
    id: number;
    tenantId: number | undefined;
    isDeleted: boolean;
    productId: number;
    product: Product;
    variantId: number | undefined;
    variant: Variant;
    warehouseId: number;
    warehouse: Warehouse;
    total: number;
    updated: moment.Moment;
    stockLessThanMinStock: number;
    stockMovements: StockMovement[] | undefined;

    constructor(data?: IStock) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tenantId = _data["tenantId"];
            this.isDeleted = _data["isDeleted"];
            this.productId = _data["productId"];
            this.product = _data["product"] ? Product.fromJS(_data["product"]) : <any>undefined;
            this.variantId = _data["variantId"];
            this.variant = _data["variant"] ? Variant.fromJS(_data["variant"]) : <any>undefined;
            this.warehouseId = _data["warehouseId"];
            this.warehouse = _data["warehouse"] ? Warehouse.fromJS(_data["warehouse"]) : <any>undefined;
            this.total = _data["total"];
            this.updated = _data["updated"] ? moment(_data["updated"].toString()) : <any>undefined;
            this.stockLessThanMinStock = _data["stockLessThanMinStock"];
            if (Array.isArray(_data["stockMovements"])) {
                this.stockMovements = [] as any;
                for (let item of _data["stockMovements"])
                    this.stockMovements.push(StockMovement.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Stock {
        data = typeof data === 'object' ? data : {};
        let result = new Stock();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tenantId"] = this.tenantId;
        data["isDeleted"] = this.isDeleted;
        data["productId"] = this.productId;
        data["product"] = this.product ? this.product.toJSON() : <any>undefined;
        data["variantId"] = this.variantId;
        data["variant"] = this.variant ? this.variant.toJSON() : <any>undefined;
        data["warehouseId"] = this.warehouseId;
        data["warehouse"] = this.warehouse ? this.warehouse.toJSON() : <any>undefined;
        data["total"] = this.total;
        data["updated"] = this.updated ? this.updated.toISOString() : <any>undefined;
        data["stockLessThanMinStock"] = this.stockLessThanMinStock;
        if (Array.isArray(this.stockMovements)) {
            data["stockMovements"] = [];
            for (let item of this.stockMovements)
                data["stockMovements"].push(item.toJSON());
        }
        return data;
    }

    clone(): Stock {
        const json = this.toJSON();
        let result = new Stock();
        result.init(json);
        return result;
    }
}

export interface IStock {
    id: number;
    tenantId: number | undefined;
    isDeleted: boolean;
    productId: number;
    product: Product;
    variantId: number | undefined;
    variant: Variant;
    warehouseId: number;
    warehouse: Warehouse;
    total: number;
    updated: moment.Moment;
    stockLessThanMinStock: number;
    stockMovements: StockMovement[] | undefined;
}

export class StockAjustDto implements IStockAjustDto {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    tenantId: number | undefined;
    number: string | undefined;
    date: moment.Moment;
    userId: number;
    description: string | undefined;
    warehouseToId: number;
    salePointId: number;
    listProducts: InvoiceProductDto[] | undefined;

    constructor(data?: IStockAjustDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.tenantId = _data["tenantId"];
            this.number = _data["number"];
            this.date = _data["date"] ? moment(_data["date"].toString()) : <any>undefined;
            this.userId = _data["userId"];
            this.description = _data["description"];
            this.warehouseToId = _data["warehouseToId"];
            this.salePointId = _data["salePointId"];
            if (Array.isArray(_data["listProducts"])) {
                this.listProducts = [] as any;
                for (let item of _data["listProducts"])
                    this.listProducts.push(InvoiceProductDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): StockAjustDto {
        data = typeof data === 'object' ? data : {};
        let result = new StockAjustDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["tenantId"] = this.tenantId;
        data["number"] = this.number;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["userId"] = this.userId;
        data["description"] = this.description;
        data["warehouseToId"] = this.warehouseToId;
        data["salePointId"] = this.salePointId;
        if (Array.isArray(this.listProducts)) {
            data["listProducts"] = [];
            for (let item of this.listProducts)
                data["listProducts"].push(item.toJSON());
        }
        return data;
    }

    clone(): StockAjustDto {
        const json = this.toJSON();
        let result = new StockAjustDto();
        result.init(json);
        return result;
    }
}

export interface IStockAjustDto {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    tenantId: number | undefined;
    number: string | undefined;
    date: moment.Moment;
    userId: number;
    description: string | undefined;
    warehouseToId: number;
    salePointId: number;
    listProducts: InvoiceProductDto[] | undefined;
}

export class StockAndProductPriceInformationDto implements IStockAndProductPriceInformationDto {
    productId: number;
    variantId: number | undefined;
    total: number;
    price: number;

    constructor(data?: IStockAndProductPriceInformationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productId = _data["productId"];
            this.variantId = _data["variantId"];
            this.total = _data["total"];
            this.price = _data["price"];
        }
    }

    static fromJS(data: any): StockAndProductPriceInformationDto {
        data = typeof data === 'object' ? data : {};
        let result = new StockAndProductPriceInformationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productId"] = this.productId;
        data["variantId"] = this.variantId;
        data["total"] = this.total;
        data["price"] = this.price;
        return data;
    }

    clone(): StockAndProductPriceInformationDto {
        const json = this.toJSON();
        let result = new StockAndProductPriceInformationDto();
        result.init(json);
        return result;
    }
}

export interface IStockAndProductPriceInformationDto {
    productId: number;
    variantId: number | undefined;
    total: number;
    price: number;
}

export class StockDto implements IStockDto {
    id: number;
    productId: number;
    productName: string | undefined;
    variantId: number | undefined;
    variantName: string | undefined;
    variantColorName: string | undefined;
    variantSizeName: string | undefined;
    variantMinStock: number;
    warehouseId: number;
    warehouseName: string | undefined;
    productCode: string | undefined;
    productDescription: string | undefined;
    productMinStock: number;
    total: number;
    updated: moment.Moment;
    stockLessThanMinStock: number;

    constructor(data?: IStockDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.productId = _data["productId"];
            this.productName = _data["productName"];
            this.variantId = _data["variantId"];
            this.variantName = _data["variantName"];
            this.variantColorName = _data["variantColorName"];
            this.variantSizeName = _data["variantSizeName"];
            this.variantMinStock = _data["variantMinStock"];
            this.warehouseId = _data["warehouseId"];
            this.warehouseName = _data["warehouseName"];
            this.productCode = _data["productCode"];
            this.productDescription = _data["productDescription"];
            this.productMinStock = _data["productMinStock"];
            this.total = _data["total"];
            this.updated = _data["updated"] ? moment(_data["updated"].toString()) : <any>undefined;
            this.stockLessThanMinStock = _data["stockLessThanMinStock"];
        }
    }

    static fromJS(data: any): StockDto {
        data = typeof data === 'object' ? data : {};
        let result = new StockDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["productId"] = this.productId;
        data["productName"] = this.productName;
        data["variantId"] = this.variantId;
        data["variantName"] = this.variantName;
        data["variantColorName"] = this.variantColorName;
        data["variantSizeName"] = this.variantSizeName;
        data["variantMinStock"] = this.variantMinStock;
        data["warehouseId"] = this.warehouseId;
        data["warehouseName"] = this.warehouseName;
        data["productCode"] = this.productCode;
        data["productDescription"] = this.productDescription;
        data["productMinStock"] = this.productMinStock;
        data["total"] = this.total;
        data["updated"] = this.updated ? this.updated.toISOString() : <any>undefined;
        data["stockLessThanMinStock"] = this.stockLessThanMinStock;
        return data;
    }

    clone(): StockDto {
        const json = this.toJSON();
        let result = new StockDto();
        result.init(json);
        return result;
    }
}

export interface IStockDto {
    id: number;
    productId: number;
    productName: string | undefined;
    variantId: number | undefined;
    variantName: string | undefined;
    variantColorName: string | undefined;
    variantSizeName: string | undefined;
    variantMinStock: number;
    warehouseId: number;
    warehouseName: string | undefined;
    productCode: string | undefined;
    productDescription: string | undefined;
    productMinStock: number;
    total: number;
    updated: moment.Moment;
    stockLessThanMinStock: number;
}

export class StockDtoPagedResultDto implements IStockDtoPagedResultDto {
    items: StockDto[] | undefined;
    totalCount: number;

    constructor(data?: IStockDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(StockDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): StockDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new StockDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): StockDtoPagedResultDto {
        const json = this.toJSON();
        let result = new StockDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IStockDtoPagedResultDto {
    items: StockDto[] | undefined;
    totalCount: number;
}

export class StockMinDto implements IStockMinDto {
    productIds: number[] | undefined;
    variantIds: number[] | undefined;
    stockMin: number;

    constructor(data?: IStockMinDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["productIds"])) {
                this.productIds = [] as any;
                for (let item of _data["productIds"])
                    this.productIds.push(item);
            }
            if (Array.isArray(_data["variantIds"])) {
                this.variantIds = [] as any;
                for (let item of _data["variantIds"])
                    this.variantIds.push(item);
            }
            this.stockMin = _data["stockMin"];
        }
    }

    static fromJS(data: any): StockMinDto {
        data = typeof data === 'object' ? data : {};
        let result = new StockMinDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.productIds)) {
            data["productIds"] = [];
            for (let item of this.productIds)
                data["productIds"].push(item);
        }
        if (Array.isArray(this.variantIds)) {
            data["variantIds"] = [];
            for (let item of this.variantIds)
                data["variantIds"].push(item);
        }
        data["stockMin"] = this.stockMin;
        return data;
    }

    clone(): StockMinDto {
        const json = this.toJSON();
        let result = new StockMinDto();
        result.init(json);
        return result;
    }
}

export interface IStockMinDto {
    productIds: number[] | undefined;
    variantIds: number[] | undefined;
    stockMin: number;
}

export class StockMovement implements IStockMovement {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    tenantId: number | undefined;
    quantity: number;
    total: number;
    type: StockType;
    movementType: MovementType;
    productId: number;
    product: Product;
    variantId: number | undefined;
    variant: Variant;
    warehouseId: number;
    warehouse: Warehouse;
    stockId: number;
    stock: Stock;
    invoiceId: number | undefined;
    invoice: Invoice;

    constructor(data?: IStockMovement) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.tenantId = _data["tenantId"];
            this.quantity = _data["quantity"];
            this.total = _data["total"];
            this.type = _data["type"];
            this.movementType = _data["movementType"];
            this.productId = _data["productId"];
            this.product = _data["product"] ? Product.fromJS(_data["product"]) : <any>undefined;
            this.variantId = _data["variantId"];
            this.variant = _data["variant"] ? Variant.fromJS(_data["variant"]) : <any>undefined;
            this.warehouseId = _data["warehouseId"];
            this.warehouse = _data["warehouse"] ? Warehouse.fromJS(_data["warehouse"]) : <any>undefined;
            this.stockId = _data["stockId"];
            this.stock = _data["stock"] ? Stock.fromJS(_data["stock"]) : <any>undefined;
            this.invoiceId = _data["invoiceId"];
            this.invoice = _data["invoice"] ? Invoice.fromJS(_data["invoice"]) : <any>undefined;
        }
    }

    static fromJS(data: any): StockMovement {
        data = typeof data === 'object' ? data : {};
        let result = new StockMovement();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["tenantId"] = this.tenantId;
        data["quantity"] = this.quantity;
        data["total"] = this.total;
        data["type"] = this.type;
        data["movementType"] = this.movementType;
        data["productId"] = this.productId;
        data["product"] = this.product ? this.product.toJSON() : <any>undefined;
        data["variantId"] = this.variantId;
        data["variant"] = this.variant ? this.variant.toJSON() : <any>undefined;
        data["warehouseId"] = this.warehouseId;
        data["warehouse"] = this.warehouse ? this.warehouse.toJSON() : <any>undefined;
        data["stockId"] = this.stockId;
        data["stock"] = this.stock ? this.stock.toJSON() : <any>undefined;
        data["invoiceId"] = this.invoiceId;
        data["invoice"] = this.invoice ? this.invoice.toJSON() : <any>undefined;
        return data;
    }

    clone(): StockMovement {
        const json = this.toJSON();
        let result = new StockMovement();
        result.init(json);
        return result;
    }
}

export interface IStockMovement {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    tenantId: number | undefined;
    quantity: number;
    total: number;
    type: StockType;
    movementType: MovementType;
    productId: number;
    product: Product;
    variantId: number | undefined;
    variant: Variant;
    warehouseId: number;
    warehouse: Warehouse;
    stockId: number;
    stock: Stock;
    invoiceId: number | undefined;
    invoice: Invoice;
}

export class StockMovementDto implements IStockMovementDto {
    id: number;
    tenantId: number | undefined;
    quantity: number;
    total: number;
    type: StockType;
    movementType: MovementType;
    readonly movementTypeName: string | undefined;
    creationTime: moment.Moment;
    productId: number;
    productName: string | undefined;
    variantId: number | undefined;
    variantName: string | undefined;
    warehouseId: number;
    warehouseName: string | undefined;
    stockId: number;
    invoiceId: number | undefined;
    invoiceNumber: string | undefined;
    invoiceFormType: InvoiceFormType;
    readonly invoiceFormTypeName: string | undefined;

    constructor(data?: IStockMovementDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tenantId = _data["tenantId"];
            this.quantity = _data["quantity"];
            this.total = _data["total"];
            this.type = _data["type"];
            this.movementType = _data["movementType"];
            (<any>this).movementTypeName = _data["movementTypeName"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.productId = _data["productId"];
            this.productName = _data["productName"];
            this.variantId = _data["variantId"];
            this.variantName = _data["variantName"];
            this.warehouseId = _data["warehouseId"];
            this.warehouseName = _data["warehouseName"];
            this.stockId = _data["stockId"];
            this.invoiceId = _data["invoiceId"];
            this.invoiceNumber = _data["invoiceNumber"];
            this.invoiceFormType = _data["invoiceFormType"];
            (<any>this).invoiceFormTypeName = _data["invoiceFormTypeName"];
        }
    }

    static fromJS(data: any): StockMovementDto {
        data = typeof data === 'object' ? data : {};
        let result = new StockMovementDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tenantId"] = this.tenantId;
        data["quantity"] = this.quantity;
        data["total"] = this.total;
        data["type"] = this.type;
        data["movementType"] = this.movementType;
        data["movementTypeName"] = this.movementTypeName;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["productId"] = this.productId;
        data["productName"] = this.productName;
        data["variantId"] = this.variantId;
        data["variantName"] = this.variantName;
        data["warehouseId"] = this.warehouseId;
        data["warehouseName"] = this.warehouseName;
        data["stockId"] = this.stockId;
        data["invoiceId"] = this.invoiceId;
        data["invoiceNumber"] = this.invoiceNumber;
        data["invoiceFormType"] = this.invoiceFormType;
        data["invoiceFormTypeName"] = this.invoiceFormTypeName;
        return data;
    }

    clone(): StockMovementDto {
        const json = this.toJSON();
        let result = new StockMovementDto();
        result.init(json);
        return result;
    }
}

export interface IStockMovementDto {
    id: number;
    tenantId: number | undefined;
    quantity: number;
    total: number;
    type: StockType;
    movementType: MovementType;
    movementTypeName: string | undefined;
    creationTime: moment.Moment;
    productId: number;
    productName: string | undefined;
    variantId: number | undefined;
    variantName: string | undefined;
    warehouseId: number;
    warehouseName: string | undefined;
    stockId: number;
    invoiceId: number | undefined;
    invoiceNumber: string | undefined;
    invoiceFormType: InvoiceFormType;
    invoiceFormTypeName: string | undefined;
}

export class StockMovementDtoPagedResultDto implements IStockMovementDtoPagedResultDto {
    items: StockMovementDto[] | undefined;
    totalCount: number;

    constructor(data?: IStockMovementDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(StockMovementDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): StockMovementDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new StockMovementDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): StockMovementDtoPagedResultDto {
        const json = this.toJSON();
        let result = new StockMovementDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IStockMovementDtoPagedResultDto {
    items: StockMovementDto[] | undefined;
    totalCount: number;
}

export class StockReportDto implements IStockReportDto {
    warehouseId: number | undefined;
    warehouseName: string | undefined;
    productId: number | undefined;
    productName: string | undefined;
    variantId: number | undefined;
    minStock: number;
    total: number;
    stockLessThanMinStock: string | undefined;

    constructor(data?: IStockReportDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.warehouseId = _data["warehouseId"];
            this.warehouseName = _data["warehouseName"];
            this.productId = _data["productId"];
            this.productName = _data["productName"];
            this.variantId = _data["variantId"];
            this.minStock = _data["minStock"];
            this.total = _data["total"];
            this.stockLessThanMinStock = _data["stockLessThanMinStock"];
        }
    }

    static fromJS(data: any): StockReportDto {
        data = typeof data === 'object' ? data : {};
        let result = new StockReportDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["warehouseId"] = this.warehouseId;
        data["warehouseName"] = this.warehouseName;
        data["productId"] = this.productId;
        data["productName"] = this.productName;
        data["variantId"] = this.variantId;
        data["minStock"] = this.minStock;
        data["total"] = this.total;
        data["stockLessThanMinStock"] = this.stockLessThanMinStock;
        return data;
    }

    clone(): StockReportDto {
        const json = this.toJSON();
        let result = new StockReportDto();
        result.init(json);
        return result;
    }
}

export interface IStockReportDto {
    warehouseId: number | undefined;
    warehouseName: string | undefined;
    productId: number | undefined;
    productName: string | undefined;
    variantId: number | undefined;
    minStock: number;
    total: number;
    stockLessThanMinStock: string | undefined;
}

export class StockReportDtoPagedResultDto implements IStockReportDtoPagedResultDto {
    items: StockReportDto[] | undefined;
    totalCount: number;

    constructor(data?: IStockReportDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(StockReportDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): StockReportDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new StockReportDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): StockReportDtoPagedResultDto {
        const json = this.toJSON();
        let result = new StockReportDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IStockReportDtoPagedResultDto {
    items: StockReportDto[] | undefined;
    totalCount: number;
}

export enum StockType {
    Equal = <any>"Equal",
    Add = <any>"Add",
    Remove = <any>"Remove",
}

export class StockWidgetDto implements IStockWidgetDto {
    productName: string | undefined;
    warehouseId: number;
    warehouseName: string | undefined;
    productMinStock: number;
    total: number;

    constructor(data?: IStockWidgetDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productName = _data["productName"];
            this.warehouseId = _data["warehouseId"];
            this.warehouseName = _data["warehouseName"];
            this.productMinStock = _data["productMinStock"];
            this.total = _data["total"];
        }
    }

    static fromJS(data: any): StockWidgetDto {
        data = typeof data === 'object' ? data : {};
        let result = new StockWidgetDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productName"] = this.productName;
        data["warehouseId"] = this.warehouseId;
        data["warehouseName"] = this.warehouseName;
        data["productMinStock"] = this.productMinStock;
        data["total"] = this.total;
        return data;
    }

    clone(): StockWidgetDto {
        const json = this.toJSON();
        let result = new StockWidgetDto();
        result.init(json);
        return result;
    }
}

export interface IStockWidgetDto {
    productName: string | undefined;
    warehouseId: number;
    warehouseName: string | undefined;
    productMinStock: number;
    total: number;
}

export class StockWidgetDtoPagedResultDto implements IStockWidgetDtoPagedResultDto {
    items: StockWidgetDto[] | undefined;
    totalCount: number;

    constructor(data?: IStockWidgetDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(StockWidgetDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): StockWidgetDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new StockWidgetDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): StockWidgetDtoPagedResultDto {
        const json = this.toJSON();
        let result = new StockWidgetDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IStockWidgetDtoPagedResultDto {
    items: StockWidgetDto[] | undefined;
    totalCount: number;
}

export class Store implements IStore {
    id: number;
    tenantId: number | undefined;
    isDeleted: boolean;
    name: string | undefined;
    address: string | undefined;
    telephone: string | undefined;
    postalCode: string | undefined;
    location: string | undefined;
    city: string | undefined;
    mail: string | undefined;
    isActive: boolean;
    warehouses: Warehouse[] | undefined;
    salePoints: SalePoint[] | undefined;
    promotionStore: PromotionStore[] | undefined;
    storePayments: StorePayment[] | undefined;
    mercadoPagoStoreId: string | undefined;
    extensionData: string | undefined;
    priceListId: number | undefined;
    priceList: PriceList;
    externalId: number | undefined;
    irsaUrl: string | undefined;
    locationId: string | undefined;
    useAutoservice: boolean;
    useIrsa: boolean;
    mercadoPagoStoreData: StoreDataModel;

    constructor(data?: IStore) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tenantId = _data["tenantId"];
            this.isDeleted = _data["isDeleted"];
            this.name = _data["name"];
            this.address = _data["address"];
            this.telephone = _data["telephone"];
            this.postalCode = _data["postalCode"];
            this.location = _data["location"];
            this.city = _data["city"];
            this.mail = _data["mail"];
            this.isActive = _data["isActive"];
            if (Array.isArray(_data["warehouses"])) {
                this.warehouses = [] as any;
                for (let item of _data["warehouses"])
                    this.warehouses.push(Warehouse.fromJS(item));
            }
            if (Array.isArray(_data["salePoints"])) {
                this.salePoints = [] as any;
                for (let item of _data["salePoints"])
                    this.salePoints.push(SalePoint.fromJS(item));
            }
            if (Array.isArray(_data["promotionStore"])) {
                this.promotionStore = [] as any;
                for (let item of _data["promotionStore"])
                    this.promotionStore.push(PromotionStore.fromJS(item));
            }
            if (Array.isArray(_data["storePayments"])) {
                this.storePayments = [] as any;
                for (let item of _data["storePayments"])
                    this.storePayments.push(StorePayment.fromJS(item));
            }
            this.mercadoPagoStoreId = _data["mercadoPagoStoreId"];
            this.extensionData = _data["extensionData"];
            this.priceListId = _data["priceListId"];
            this.priceList = _data["priceList"] ? PriceList.fromJS(_data["priceList"]) : <any>undefined;
            this.externalId = _data["externalId"];
            this.irsaUrl = _data["irsaUrl"];
            this.locationId = _data["locationId"];
            this.useAutoservice = _data["useAutoservice"];
            this.useIrsa = _data["useIrsa"];
            this.mercadoPagoStoreData = _data["mercadoPagoStoreData"] ? StoreDataModel.fromJS(_data["mercadoPagoStoreData"]) : <any>undefined;
        }
    }

    static fromJS(data: any): Store {
        data = typeof data === 'object' ? data : {};
        let result = new Store();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tenantId"] = this.tenantId;
        data["isDeleted"] = this.isDeleted;
        data["name"] = this.name;
        data["address"] = this.address;
        data["telephone"] = this.telephone;
        data["postalCode"] = this.postalCode;
        data["location"] = this.location;
        data["city"] = this.city;
        data["mail"] = this.mail;
        data["isActive"] = this.isActive;
        if (Array.isArray(this.warehouses)) {
            data["warehouses"] = [];
            for (let item of this.warehouses)
                data["warehouses"].push(item.toJSON());
        }
        if (Array.isArray(this.salePoints)) {
            data["salePoints"] = [];
            for (let item of this.salePoints)
                data["salePoints"].push(item.toJSON());
        }
        if (Array.isArray(this.promotionStore)) {
            data["promotionStore"] = [];
            for (let item of this.promotionStore)
                data["promotionStore"].push(item.toJSON());
        }
        if (Array.isArray(this.storePayments)) {
            data["storePayments"] = [];
            for (let item of this.storePayments)
                data["storePayments"].push(item.toJSON());
        }
        data["mercadoPagoStoreId"] = this.mercadoPagoStoreId;
        data["extensionData"] = this.extensionData;
        data["priceListId"] = this.priceListId;
        data["priceList"] = this.priceList ? this.priceList.toJSON() : <any>undefined;
        data["externalId"] = this.externalId;
        data["irsaUrl"] = this.irsaUrl;
        data["locationId"] = this.locationId;
        data["useAutoservice"] = this.useAutoservice;
        data["useIrsa"] = this.useIrsa;
        data["mercadoPagoStoreData"] = this.mercadoPagoStoreData ? this.mercadoPagoStoreData.toJSON() : <any>undefined;
        return data;
    }

    clone(): Store {
        const json = this.toJSON();
        let result = new Store();
        result.init(json);
        return result;
    }
}

export interface IStore {
    id: number;
    tenantId: number | undefined;
    isDeleted: boolean;
    name: string | undefined;
    address: string | undefined;
    telephone: string | undefined;
    postalCode: string | undefined;
    location: string | undefined;
    city: string | undefined;
    mail: string | undefined;
    isActive: boolean;
    warehouses: Warehouse[] | undefined;
    salePoints: SalePoint[] | undefined;
    promotionStore: PromotionStore[] | undefined;
    storePayments: StorePayment[] | undefined;
    mercadoPagoStoreId: string | undefined;
    extensionData: string | undefined;
    priceListId: number | undefined;
    priceList: PriceList;
    externalId: number | undefined;
    irsaUrl: string | undefined;
    locationId: string | undefined;
    useAutoservice: boolean;
    useIrsa: boolean;
    mercadoPagoStoreData: StoreDataModel;
}

export class StoreDataModel implements IStoreDataModel {
    id: string | undefined;
    externalId: string | undefined;

    constructor(data?: IStoreDataModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.externalId = _data["externalId"];
        }
    }

    static fromJS(data: any): StoreDataModel {
        data = typeof data === 'object' ? data : {};
        let result = new StoreDataModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["externalId"] = this.externalId;
        return data;
    }

    clone(): StoreDataModel {
        const json = this.toJSON();
        let result = new StoreDataModel();
        result.init(json);
        return result;
    }
}

export interface IStoreDataModel {
    id: string | undefined;
    externalId: string | undefined;
}

export class StoreDto implements IStoreDto {
    id: number;
    tenantId: number | undefined;
    name: string | undefined;
    address: string | undefined;
    telephone: string | undefined;
    isActive: boolean;
    postalCode: string | undefined;
    location: string | undefined;
    city: string | undefined;
    externalId: string | undefined;
    priceListId: number | undefined;
    priceList: PriceListDto;
    irsaUrl: string | undefined;
    locationId: string | undefined;
    useAutoservice: boolean;
    useIrsa: boolean;

    constructor(data?: IStoreDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tenantId = _data["tenantId"];
            this.name = _data["name"];
            this.address = _data["address"];
            this.telephone = _data["telephone"];
            this.isActive = _data["isActive"];
            this.postalCode = _data["postalCode"];
            this.location = _data["location"];
            this.city = _data["city"];
            this.externalId = _data["externalId"];
            this.priceListId = _data["priceListId"];
            this.priceList = _data["priceList"] ? PriceListDto.fromJS(_data["priceList"]) : <any>undefined;
            this.irsaUrl = _data["irsaUrl"];
            this.locationId = _data["locationId"];
            this.useAutoservice = _data["useAutoservice"];
            this.useIrsa = _data["useIrsa"];
        }
    }

    static fromJS(data: any): StoreDto {
        data = typeof data === 'object' ? data : {};
        let result = new StoreDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tenantId"] = this.tenantId;
        data["name"] = this.name;
        data["address"] = this.address;
        data["telephone"] = this.telephone;
        data["isActive"] = this.isActive;
        data["postalCode"] = this.postalCode;
        data["location"] = this.location;
        data["city"] = this.city;
        data["externalId"] = this.externalId;
        data["priceListId"] = this.priceListId;
        data["priceList"] = this.priceList ? this.priceList.toJSON() : <any>undefined;
        data["irsaUrl"] = this.irsaUrl;
        data["locationId"] = this.locationId;
        data["useAutoservice"] = this.useAutoservice;
        data["useIrsa"] = this.useIrsa;
        return data;
    }

    clone(): StoreDto {
        const json = this.toJSON();
        let result = new StoreDto();
        result.init(json);
        return result;
    }
}

export interface IStoreDto {
    id: number;
    tenantId: number | undefined;
    name: string | undefined;
    address: string | undefined;
    telephone: string | undefined;
    isActive: boolean;
    postalCode: string | undefined;
    location: string | undefined;
    city: string | undefined;
    externalId: string | undefined;
    priceListId: number | undefined;
    priceList: PriceListDto;
    irsaUrl: string | undefined;
    locationId: string | undefined;
    useAutoservice: boolean;
    useIrsa: boolean;
}

export class StoreDtoPagedResultDto implements IStoreDtoPagedResultDto {
    items: StoreDto[] | undefined;
    totalCount: number;

    constructor(data?: IStoreDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(StoreDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): StoreDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new StoreDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): StoreDtoPagedResultDto {
        const json = this.toJSON();
        let result = new StoreDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IStoreDtoPagedResultDto {
    items: StoreDto[] | undefined;
    totalCount: number;
}

export class StoreForListDto implements IStoreForListDto {
    id: number;
    tenantId: number | undefined;
    name: string | undefined;

    constructor(data?: IStoreForListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tenantId = _data["tenantId"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): StoreForListDto {
        data = typeof data === 'object' ? data : {};
        let result = new StoreForListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tenantId"] = this.tenantId;
        data["name"] = this.name;
        return data;
    }

    clone(): StoreForListDto {
        const json = this.toJSON();
        let result = new StoreForListDto();
        result.init(json);
        return result;
    }
}

export interface IStoreForListDto {
    id: number;
    tenantId: number | undefined;
    name: string | undefined;
}

export class StoreMpDto implements IStoreMpDto {
    id: number;
    name: string | undefined;
    mercadoPagoStoreId: string | undefined;

    constructor(data?: IStoreMpDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.mercadoPagoStoreId = _data["mercadoPagoStoreId"];
        }
    }

    static fromJS(data: any): StoreMpDto {
        data = typeof data === 'object' ? data : {};
        let result = new StoreMpDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["mercadoPagoStoreId"] = this.mercadoPagoStoreId;
        return data;
    }

    clone(): StoreMpDto {
        const json = this.toJSON();
        let result = new StoreMpDto();
        result.init(json);
        return result;
    }
}

export interface IStoreMpDto {
    id: number;
    name: string | undefined;
    mercadoPagoStoreId: string | undefined;
}

export class StoreMpDtoPagedResultDto implements IStoreMpDtoPagedResultDto {
    items: StoreMpDto[] | undefined;
    totalCount: number;

    constructor(data?: IStoreMpDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(StoreMpDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): StoreMpDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new StoreMpDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): StoreMpDtoPagedResultDto {
        const json = this.toJSON();
        let result = new StoreMpDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IStoreMpDtoPagedResultDto {
    items: StoreMpDto[] | undefined;
    totalCount: number;
}

export class StorePayment implements IStorePayment {
    id: number;
    tenantId: number | undefined;
    isDeleted: boolean;
    storeId: number;
    store: Store;
    providerPaymentId: number;
    providerPayment: ProviderPayment;

    constructor(data?: IStorePayment) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tenantId = _data["tenantId"];
            this.isDeleted = _data["isDeleted"];
            this.storeId = _data["storeId"];
            this.store = _data["store"] ? Store.fromJS(_data["store"]) : <any>undefined;
            this.providerPaymentId = _data["providerPaymentId"];
            this.providerPayment = _data["providerPayment"] ? ProviderPayment.fromJS(_data["providerPayment"]) : <any>undefined;
        }
    }

    static fromJS(data: any): StorePayment {
        data = typeof data === 'object' ? data : {};
        let result = new StorePayment();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tenantId"] = this.tenantId;
        data["isDeleted"] = this.isDeleted;
        data["storeId"] = this.storeId;
        data["store"] = this.store ? this.store.toJSON() : <any>undefined;
        data["providerPaymentId"] = this.providerPaymentId;
        data["providerPayment"] = this.providerPayment ? this.providerPayment.toJSON() : <any>undefined;
        return data;
    }

    clone(): StorePayment {
        const json = this.toJSON();
        let result = new StorePayment();
        result.init(json);
        return result;
    }
}

export interface IStorePayment {
    id: number;
    tenantId: number | undefined;
    isDeleted: boolean;
    storeId: number;
    store: Store;
    providerPaymentId: number;
    providerPayment: ProviderPayment;
}

export class StorePaymentDto implements IStorePaymentDto {
    id: number;
    tenantId: number | undefined;
    storeId: number;
    providerPaymentId: number;

    constructor(data?: IStorePaymentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tenantId = _data["tenantId"];
            this.storeId = _data["storeId"];
            this.providerPaymentId = _data["providerPaymentId"];
        }
    }

    static fromJS(data: any): StorePaymentDto {
        data = typeof data === 'object' ? data : {};
        let result = new StorePaymentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tenantId"] = this.tenantId;
        data["storeId"] = this.storeId;
        data["providerPaymentId"] = this.providerPaymentId;
        return data;
    }

    clone(): StorePaymentDto {
        const json = this.toJSON();
        let result = new StorePaymentDto();
        result.init(json);
        return result;
    }
}

export interface IStorePaymentDto {
    id: number;
    tenantId: number | undefined;
    storeId: number;
    providerPaymentId: number;
}

export class Tax implements ITax {
    id: number;
    tenantId: number | undefined;
    isDeleted: boolean;
    name: string | undefined;
    value: number | undefined;
    refererId: string | undefined;
    description: string | undefined;
    type: TypeTaxe;

    constructor(data?: ITax) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tenantId = _data["tenantId"];
            this.isDeleted = _data["isDeleted"];
            this.name = _data["name"];
            this.value = _data["value"];
            this.refererId = _data["refererId"];
            this.description = _data["description"];
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): Tax {
        data = typeof data === 'object' ? data : {};
        let result = new Tax();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tenantId"] = this.tenantId;
        data["isDeleted"] = this.isDeleted;
        data["name"] = this.name;
        data["value"] = this.value;
        data["refererId"] = this.refererId;
        data["description"] = this.description;
        data["type"] = this.type;
        return data;
    }

    clone(): Tax {
        const json = this.toJSON();
        let result = new Tax();
        result.init(json);
        return result;
    }
}

export interface ITax {
    id: number;
    tenantId: number | undefined;
    isDeleted: boolean;
    name: string | undefined;
    value: number | undefined;
    refererId: string | undefined;
    description: string | undefined;
    type: TypeTaxe;
}

export enum TaxConditionType {
    RegisteredResponsible = <any>"RegisteredResponsible",
    Exempt = <any>"Exempt",
    MonoTax = <any>"MonoTax",
    FinalConsumer = <any>"FinalConsumer",
}

export class TaxDto implements ITaxDto {
    id: number;
    tenantId: number | undefined;
    name: string | undefined;
    value: number | undefined;
    refererId: string | undefined;
    description: string | undefined;
    type: TypeTaxe;
    readonly typeName: string | undefined;

    constructor(data?: ITaxDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tenantId = _data["tenantId"];
            this.name = _data["name"];
            this.value = _data["value"];
            this.refererId = _data["refererId"];
            this.description = _data["description"];
            this.type = _data["type"];
            (<any>this).typeName = _data["typeName"];
        }
    }

    static fromJS(data: any): TaxDto {
        data = typeof data === 'object' ? data : {};
        let result = new TaxDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tenantId"] = this.tenantId;
        data["name"] = this.name;
        data["value"] = this.value;
        data["refererId"] = this.refererId;
        data["description"] = this.description;
        data["type"] = this.type;
        data["typeName"] = this.typeName;
        return data;
    }

    clone(): TaxDto {
        const json = this.toJSON();
        let result = new TaxDto();
        result.init(json);
        return result;
    }
}

export interface ITaxDto {
    id: number;
    tenantId: number | undefined;
    name: string | undefined;
    value: number | undefined;
    refererId: string | undefined;
    description: string | undefined;
    type: TypeTaxe;
    typeName: string | undefined;
}

export class TaxDtoPagedResultDto implements ITaxDtoPagedResultDto {
    items: TaxDto[] | undefined;
    totalCount: number;

    constructor(data?: ITaxDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(TaxDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): TaxDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new TaxDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): TaxDtoPagedResultDto {
        const json = this.toJSON();
        let result = new TaxDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface ITaxDtoPagedResultDto {
    items: TaxDto[] | undefined;
    totalCount: number;
}

export class TemplateDto implements ITemplateDto {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    tenantId: number | undefined;
    name: string | undefined;
    description: string | undefined;
    content: string | undefined;
    isStatic: boolean;
    type: ContentType;
    templateType: TemplateType;
    readonly typeValue: string | undefined;
    readonly templateTypeValue: string | undefined;
    userModifierName: string | undefined;

    constructor(data?: ITemplateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.tenantId = _data["tenantId"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.content = _data["content"];
            this.isStatic = _data["isStatic"];
            this.type = _data["type"];
            this.templateType = _data["templateType"];
            (<any>this).typeValue = _data["typeValue"];
            (<any>this).templateTypeValue = _data["templateTypeValue"];
            this.userModifierName = _data["userModifierName"];
        }
    }

    static fromJS(data: any): TemplateDto {
        data = typeof data === 'object' ? data : {};
        let result = new TemplateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["tenantId"] = this.tenantId;
        data["name"] = this.name;
        data["description"] = this.description;
        data["content"] = this.content;
        data["isStatic"] = this.isStatic;
        data["type"] = this.type;
        data["templateType"] = this.templateType;
        data["typeValue"] = this.typeValue;
        data["templateTypeValue"] = this.templateTypeValue;
        data["userModifierName"] = this.userModifierName;
        return data;
    }

    clone(): TemplateDto {
        const json = this.toJSON();
        let result = new TemplateDto();
        result.init(json);
        return result;
    }
}

export interface ITemplateDto {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    tenantId: number | undefined;
    name: string | undefined;
    description: string | undefined;
    content: string | undefined;
    isStatic: boolean;
    type: ContentType;
    templateType: TemplateType;
    typeValue: string | undefined;
    templateTypeValue: string | undefined;
    userModifierName: string | undefined;
}

export class TemplateDtoPagedResultDto implements ITemplateDtoPagedResultDto {
    items: TemplateDto[] | undefined;
    totalCount: number;

    constructor(data?: ITemplateDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(TemplateDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): TemplateDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new TemplateDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): TemplateDtoPagedResultDto {
        const json = this.toJSON();
        let result = new TemplateDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface ITemplateDtoPagedResultDto {
    items: TemplateDto[] | undefined;
    totalCount: number;
}

export enum TemplateType {
    Invoice = <any>"Invoice",
    Email = <any>"Email",
    TicketChange = <any>"TicketChange",
    TicketChangePerProduct = <any>"TicketChangePerProduct",
    Others = <any>"Others",
}

export enum TenantAvailabilityState {
    Available = <any>"Available",
    InActive = <any>"InActive",
    NotFound = <any>"NotFound",
}

export class TenantDto implements ITenantDto {
    id: number;
    tenancyName: string;
    name: string;
    isActive: boolean;
    tenantGroupId: number | undefined;
    useNoFiscal: boolean;
    allowNegativeStock: boolean;
    allowNegativeSales: boolean;
    allowNegativeReservation: boolean;
    allowNegativeChanges: boolean;
    enableThirdPartyOrderImport: boolean;
    enableThirdPartyOrderImportAdmin: boolean;
    webServiceAfip: WebServiceAfip;
    editionId: number | undefined;
    editionName: string | undefined;
    parentId: number | undefined;
    tenantIds: number[] | undefined;
    useHistoricPrice: boolean;
    usePayway: boolean;
    useMercadoLibre: boolean;
    useTiendaNube: boolean;
    paywayCashInAccountProviderPaymentId: number | undefined;

    constructor(data?: ITenantDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tenancyName = _data["tenancyName"];
            this.name = _data["name"];
            this.isActive = _data["isActive"];
            this.tenantGroupId = _data["tenantGroupId"];
            this.useNoFiscal = _data["useNoFiscal"];
            this.allowNegativeStock = _data["allowNegativeStock"];
            this.allowNegativeSales = _data["allowNegativeSales"];
            this.allowNegativeReservation = _data["allowNegativeReservation"];
            this.allowNegativeChanges = _data["allowNegativeChanges"];
            this.enableThirdPartyOrderImport = _data["enableThirdPartyOrderImport"];
            this.enableThirdPartyOrderImportAdmin = _data["enableThirdPartyOrderImportAdmin"];
            this.webServiceAfip = _data["webServiceAfip"];
            this.editionId = _data["editionId"];
            this.editionName = _data["editionName"];
            this.parentId = _data["parentId"];
            if (Array.isArray(_data["tenantIds"])) {
                this.tenantIds = [] as any;
                for (let item of _data["tenantIds"])
                    this.tenantIds.push(item);
            }
            this.useHistoricPrice = _data["useHistoricPrice"];
            this.usePayway = _data["usePayway"];
            this.useMercadoLibre = _data["useMercadoLibre"];
            this.useTiendaNube = _data["useTiendaNube"];
            this.paywayCashInAccountProviderPaymentId = _data["paywayCashInAccountProviderPaymentId"];
        }
    }

    static fromJS(data: any): TenantDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tenancyName"] = this.tenancyName;
        data["name"] = this.name;
        data["isActive"] = this.isActive;
        data["tenantGroupId"] = this.tenantGroupId;
        data["useNoFiscal"] = this.useNoFiscal;
        data["allowNegativeStock"] = this.allowNegativeStock;
        data["allowNegativeSales"] = this.allowNegativeSales;
        data["allowNegativeReservation"] = this.allowNegativeReservation;
        data["allowNegativeChanges"] = this.allowNegativeChanges;
        data["enableThirdPartyOrderImport"] = this.enableThirdPartyOrderImport;
        data["enableThirdPartyOrderImportAdmin"] = this.enableThirdPartyOrderImportAdmin;
        data["webServiceAfip"] = this.webServiceAfip;
        data["editionId"] = this.editionId;
        data["editionName"] = this.editionName;
        data["parentId"] = this.parentId;
        if (Array.isArray(this.tenantIds)) {
            data["tenantIds"] = [];
            for (let item of this.tenantIds)
                data["tenantIds"].push(item);
        }
        data["useHistoricPrice"] = this.useHistoricPrice;
        data["usePayway"] = this.usePayway;
        data["useMercadoLibre"] = this.useMercadoLibre;
        data["useTiendaNube"] = this.useTiendaNube;
        data["paywayCashInAccountProviderPaymentId"] = this.paywayCashInAccountProviderPaymentId;
        return data;
    }

    clone(): TenantDto {
        const json = this.toJSON();
        let result = new TenantDto();
        result.init(json);
        return result;
    }
}

export interface ITenantDto {
    id: number;
    tenancyName: string;
    name: string;
    isActive: boolean;
    tenantGroupId: number | undefined;
    useNoFiscal: boolean;
    allowNegativeStock: boolean;
    allowNegativeSales: boolean;
    allowNegativeReservation: boolean;
    allowNegativeChanges: boolean;
    enableThirdPartyOrderImport: boolean;
    enableThirdPartyOrderImportAdmin: boolean;
    webServiceAfip: WebServiceAfip;
    editionId: number | undefined;
    editionName: string | undefined;
    parentId: number | undefined;
    tenantIds: number[] | undefined;
    useHistoricPrice: boolean;
    usePayway: boolean;
    useMercadoLibre: boolean;
    useTiendaNube: boolean;
    paywayCashInAccountProviderPaymentId: number | undefined;
}

export class TenantDtoListResultDto implements ITenantDtoListResultDto {
    items: TenantDto[] | undefined;

    constructor(data?: ITenantDtoListResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(TenantDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TenantDtoListResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantDtoListResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): TenantDtoListResultDto {
        const json = this.toJSON();
        let result = new TenantDtoListResultDto();
        result.init(json);
        return result;
    }
}

export interface ITenantDtoListResultDto {
    items: TenantDto[] | undefined;
}

export class TenantDtoPagedResultDto implements ITenantDtoPagedResultDto {
    items: TenantDto[] | undefined;
    totalCount: number;

    constructor(data?: ITenantDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(TenantDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): TenantDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): TenantDtoPagedResultDto {
        const json = this.toJSON();
        let result = new TenantDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface ITenantDtoPagedResultDto {
    items: TenantDto[] | undefined;
    totalCount: number;
}

export class TenantGroupDto implements ITenantGroupDto {
    id: number;
    tenantId: number | undefined;
    name: string | undefined;
    description: string | undefined;
    listTenants: TenantDto[] | undefined;

    constructor(data?: ITenantGroupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tenantId = _data["tenantId"];
            this.name = _data["name"];
            this.description = _data["description"];
            if (Array.isArray(_data["listTenants"])) {
                this.listTenants = [] as any;
                for (let item of _data["listTenants"])
                    this.listTenants.push(TenantDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TenantGroupDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantGroupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tenantId"] = this.tenantId;
        data["name"] = this.name;
        data["description"] = this.description;
        if (Array.isArray(this.listTenants)) {
            data["listTenants"] = [];
            for (let item of this.listTenants)
                data["listTenants"].push(item.toJSON());
        }
        return data;
    }

    clone(): TenantGroupDto {
        const json = this.toJSON();
        let result = new TenantGroupDto();
        result.init(json);
        return result;
    }
}

export interface ITenantGroupDto {
    id: number;
    tenantId: number | undefined;
    name: string | undefined;
    description: string | undefined;
    listTenants: TenantDto[] | undefined;
}

export class TenantGroupDtoPagedResultDto implements ITenantGroupDtoPagedResultDto {
    items: TenantGroupDto[] | undefined;
    totalCount: number;

    constructor(data?: ITenantGroupDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(TenantGroupDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): TenantGroupDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantGroupDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): TenantGroupDtoPagedResultDto {
        const json = this.toJSON();
        let result = new TenantGroupDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface ITenantGroupDtoPagedResultDto {
    items: TenantGroupDto[] | undefined;
    totalCount: number;
}

export class TenantLoginInfoDto implements ITenantLoginInfoDto {
    id: number;
    tenancyName: string | undefined;
    name: string | undefined;

    constructor(data?: ITenantLoginInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tenancyName = _data["tenancyName"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): TenantLoginInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantLoginInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tenancyName"] = this.tenancyName;
        data["name"] = this.name;
        return data;
    }

    clone(): TenantLoginInfoDto {
        const json = this.toJSON();
        let result = new TenantLoginInfoDto();
        result.init(json);
        return result;
    }
}

export interface ITenantLoginInfoDto {
    id: number;
    tenancyName: string | undefined;
    name: string | undefined;
}

export class TiendaNubeCustomerDto implements ITiendaNubeCustomerDto {
    id: number;
    name: string | undefined;
    email: string | undefined;
    identification: string | undefined;
    phone: string | undefined;
    total_Spent: string | undefined;

    constructor(data?: ITiendaNubeCustomerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.email = _data["email"];
            this.identification = _data["identification"];
            this.phone = _data["phone"];
            this.total_Spent = _data["total_Spent"];
        }
    }

    static fromJS(data: any): TiendaNubeCustomerDto {
        data = typeof data === 'object' ? data : {};
        let result = new TiendaNubeCustomerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["email"] = this.email;
        data["identification"] = this.identification;
        data["phone"] = this.phone;
        data["total_Spent"] = this.total_Spent;
        return data;
    }

    clone(): TiendaNubeCustomerDto {
        const json = this.toJSON();
        let result = new TiendaNubeCustomerDto();
        result.init(json);
        return result;
    }
}

export interface ITiendaNubeCustomerDto {
    id: number;
    name: string | undefined;
    email: string | undefined;
    identification: string | undefined;
    phone: string | undefined;
    total_Spent: string | undefined;
}

export class TiendaNubeImageDto implements ITiendaNubeImageDto {
    id: number;
    src: string | undefined;

    constructor(data?: ITiendaNubeImageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.src = _data["src"];
        }
    }

    static fromJS(data: any): TiendaNubeImageDto {
        data = typeof data === 'object' ? data : {};
        let result = new TiendaNubeImageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["src"] = this.src;
        return data;
    }

    clone(): TiendaNubeImageDto {
        const json = this.toJSON();
        let result = new TiendaNubeImageDto();
        result.init(json);
        return result;
    }
}

export interface ITiendaNubeImageDto {
    id: number;
    src: string | undefined;
}

export class TiendaNubeLinkedProductDetailDto implements ITiendaNubeLinkedProductDetailDto {
    id: number;
    productId: number;
    productName: string | undefined;
    productCode: string | undefined;
    variantId: number | undefined;
    variantName: string | undefined;
    externalProductId: string | undefined;
    externalVariantId: string | undefined;
    lastSyncDate: moment.Moment | undefined;
    variants: LinkedVariantDetailDto[] | undefined;
    stockDeposito: number;
    stockReserva: number;
    stockTotal: number;
    price: number;
    promotionalPrice: number | undefined;

    constructor(data?: ITiendaNubeLinkedProductDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.productId = _data["productId"];
            this.productName = _data["productName"];
            this.productCode = _data["productCode"];
            this.variantId = _data["variantId"];
            this.variantName = _data["variantName"];
            this.externalProductId = _data["externalProductId"];
            this.externalVariantId = _data["externalVariantId"];
            this.lastSyncDate = _data["lastSyncDate"] ? moment(_data["lastSyncDate"].toString()) : <any>undefined;
            if (Array.isArray(_data["variants"])) {
                this.variants = [] as any;
                for (let item of _data["variants"])
                    this.variants.push(LinkedVariantDetailDto.fromJS(item));
            }
            this.stockDeposito = _data["stockDeposito"];
            this.stockReserva = _data["stockReserva"];
            this.stockTotal = _data["stockTotal"];
            this.price = _data["price"];
            this.promotionalPrice = _data["promotionalPrice"];
        }
    }

    static fromJS(data: any): TiendaNubeLinkedProductDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new TiendaNubeLinkedProductDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["productId"] = this.productId;
        data["productName"] = this.productName;
        data["productCode"] = this.productCode;
        data["variantId"] = this.variantId;
        data["variantName"] = this.variantName;
        data["externalProductId"] = this.externalProductId;
        data["externalVariantId"] = this.externalVariantId;
        data["lastSyncDate"] = this.lastSyncDate ? this.lastSyncDate.toISOString() : <any>undefined;
        if (Array.isArray(this.variants)) {
            data["variants"] = [];
            for (let item of this.variants)
                data["variants"].push(item.toJSON());
        }
        data["stockDeposito"] = this.stockDeposito;
        data["stockReserva"] = this.stockReserva;
        data["stockTotal"] = this.stockTotal;
        data["price"] = this.price;
        data["promotionalPrice"] = this.promotionalPrice;
        return data;
    }

    clone(): TiendaNubeLinkedProductDetailDto {
        const json = this.toJSON();
        let result = new TiendaNubeLinkedProductDetailDto();
        result.init(json);
        return result;
    }
}

export interface ITiendaNubeLinkedProductDetailDto {
    id: number;
    productId: number;
    productName: string | undefined;
    productCode: string | undefined;
    variantId: number | undefined;
    variantName: string | undefined;
    externalProductId: string | undefined;
    externalVariantId: string | undefined;
    lastSyncDate: moment.Moment | undefined;
    variants: LinkedVariantDetailDto[] | undefined;
    stockDeposito: number;
    stockReserva: number;
    stockTotal: number;
    price: number;
    promotionalPrice: number | undefined;
}

export class TiendaNubeLinkedProductDto implements ITiendaNubeLinkedProductDto {
    id: number;
    productId: number;
    productName: string | undefined;
    productCode: string | undefined;
    variantId: number | undefined;
    variantName: string | undefined;
    externalProductId: string | undefined;
    externalVariantId: string | undefined;
    lastSyncDate: moment.Moment | undefined;

    constructor(data?: ITiendaNubeLinkedProductDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.productId = _data["productId"];
            this.productName = _data["productName"];
            this.productCode = _data["productCode"];
            this.variantId = _data["variantId"];
            this.variantName = _data["variantName"];
            this.externalProductId = _data["externalProductId"];
            this.externalVariantId = _data["externalVariantId"];
            this.lastSyncDate = _data["lastSyncDate"] ? moment(_data["lastSyncDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): TiendaNubeLinkedProductDto {
        data = typeof data === 'object' ? data : {};
        let result = new TiendaNubeLinkedProductDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["productId"] = this.productId;
        data["productName"] = this.productName;
        data["productCode"] = this.productCode;
        data["variantId"] = this.variantId;
        data["variantName"] = this.variantName;
        data["externalProductId"] = this.externalProductId;
        data["externalVariantId"] = this.externalVariantId;
        data["lastSyncDate"] = this.lastSyncDate ? this.lastSyncDate.toISOString() : <any>undefined;
        return data;
    }

    clone(): TiendaNubeLinkedProductDto {
        const json = this.toJSON();
        let result = new TiendaNubeLinkedProductDto();
        result.init(json);
        return result;
    }
}

export interface ITiendaNubeLinkedProductDto {
    id: number;
    productId: number;
    productName: string | undefined;
    productCode: string | undefined;
    variantId: number | undefined;
    variantName: string | undefined;
    externalProductId: string | undefined;
    externalVariantId: string | undefined;
    lastSyncDate: moment.Moment | undefined;
}

export class TiendaNubeLocalizedDto implements ITiendaNubeLocalizedDto {
    es: string | undefined;

    constructor(data?: ITiendaNubeLocalizedDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.es = _data["es"];
        }
    }

    static fromJS(data: any): TiendaNubeLocalizedDto {
        data = typeof data === 'object' ? data : {};
        let result = new TiendaNubeLocalizedDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["es"] = this.es;
        return data;
    }

    clone(): TiendaNubeLocalizedDto {
        const json = this.toJSON();
        let result = new TiendaNubeLocalizedDto();
        result.init(json);
        return result;
    }
}

export interface ITiendaNubeLocalizedDto {
    es: string | undefined;
}

export class TiendaNubeOrderDto implements ITiendaNubeOrderDto {
    id: number;
    store_Id: number;
    status: string | undefined;
    payment_Status: string | undefined;
    shipping_Type: string | undefined;
    shipping_Status: string | undefined;
    contact_Email: string | undefined;
    contact_Name: string | undefined;
    subtotal: string | undefined;
    discount: string | undefined;
    total: string | undefined;
    total_Paid: string | undefined;
    currency: string | undefined;
    gateway_Name: string | undefined;
    created_At: moment.Moment;
    updated_At: moment.Moment;
    customer: TiendaNubeCustomerDto;
    products: TiendaNubeOrderProductDto[] | undefined;

    constructor(data?: ITiendaNubeOrderDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.store_Id = _data["store_Id"];
            this.status = _data["status"];
            this.payment_Status = _data["payment_Status"];
            this.shipping_Type = _data["shipping_Type"];
            this.shipping_Status = _data["shipping_Status"];
            this.contact_Email = _data["contact_Email"];
            this.contact_Name = _data["contact_Name"];
            this.subtotal = _data["subtotal"];
            this.discount = _data["discount"];
            this.total = _data["total"];
            this.total_Paid = _data["total_Paid"];
            this.currency = _data["currency"];
            this.gateway_Name = _data["gateway_Name"];
            this.created_At = _data["created_At"] ? moment(_data["created_At"].toString()) : <any>undefined;
            this.updated_At = _data["updated_At"] ? moment(_data["updated_At"].toString()) : <any>undefined;
            this.customer = _data["customer"] ? TiendaNubeCustomerDto.fromJS(_data["customer"]) : <any>undefined;
            if (Array.isArray(_data["products"])) {
                this.products = [] as any;
                for (let item of _data["products"])
                    this.products.push(TiendaNubeOrderProductDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TiendaNubeOrderDto {
        data = typeof data === 'object' ? data : {};
        let result = new TiendaNubeOrderDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["store_Id"] = this.store_Id;
        data["status"] = this.status;
        data["payment_Status"] = this.payment_Status;
        data["shipping_Type"] = this.shipping_Type;
        data["shipping_Status"] = this.shipping_Status;
        data["contact_Email"] = this.contact_Email;
        data["contact_Name"] = this.contact_Name;
        data["subtotal"] = this.subtotal;
        data["discount"] = this.discount;
        data["total"] = this.total;
        data["total_Paid"] = this.total_Paid;
        data["currency"] = this.currency;
        data["gateway_Name"] = this.gateway_Name;
        data["created_At"] = this.created_At ? this.created_At.toISOString() : <any>undefined;
        data["updated_At"] = this.updated_At ? this.updated_At.toISOString() : <any>undefined;
        data["customer"] = this.customer ? this.customer.toJSON() : <any>undefined;
        if (Array.isArray(this.products)) {
            data["products"] = [];
            for (let item of this.products)
                data["products"].push(item.toJSON());
        }
        return data;
    }

    clone(): TiendaNubeOrderDto {
        const json = this.toJSON();
        let result = new TiendaNubeOrderDto();
        result.init(json);
        return result;
    }
}

export interface ITiendaNubeOrderDto {
    id: number;
    store_Id: number;
    status: string | undefined;
    payment_Status: string | undefined;
    shipping_Type: string | undefined;
    shipping_Status: string | undefined;
    contact_Email: string | undefined;
    contact_Name: string | undefined;
    subtotal: string | undefined;
    discount: string | undefined;
    total: string | undefined;
    total_Paid: string | undefined;
    currency: string | undefined;
    gateway_Name: string | undefined;
    created_At: moment.Moment;
    updated_At: moment.Moment;
    customer: TiendaNubeCustomerDto;
    products: TiendaNubeOrderProductDto[] | undefined;
}

export class TiendaNubeOrderProductDto implements ITiendaNubeOrderProductDto {
    id: number;
    product_Id: number;
    name: string | undefined;
    price: string | undefined;
    quantity: number;
    sku: string | undefined;
    image: TiendaNubeImageDto;

    constructor(data?: ITiendaNubeOrderProductDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.product_Id = _data["product_Id"];
            this.name = _data["name"];
            this.price = _data["price"];
            this.quantity = _data["quantity"];
            this.sku = _data["sku"];
            this.image = _data["image"] ? TiendaNubeImageDto.fromJS(_data["image"]) : <any>undefined;
        }
    }

    static fromJS(data: any): TiendaNubeOrderProductDto {
        data = typeof data === 'object' ? data : {};
        let result = new TiendaNubeOrderProductDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["product_Id"] = this.product_Id;
        data["name"] = this.name;
        data["price"] = this.price;
        data["quantity"] = this.quantity;
        data["sku"] = this.sku;
        data["image"] = this.image ? this.image.toJSON() : <any>undefined;
        return data;
    }

    clone(): TiendaNubeOrderProductDto {
        const json = this.toJSON();
        let result = new TiendaNubeOrderProductDto();
        result.init(json);
        return result;
    }
}

export interface ITiendaNubeOrderProductDto {
    id: number;
    product_Id: number;
    name: string | undefined;
    price: string | undefined;
    quantity: number;
    sku: string | undefined;
    image: TiendaNubeImageDto;
}

export class TiendaNubeProductDto implements ITiendaNubeProductDto {
    id: number;
    name: TiendaNubeLocalizedDto;
    attributes: TiendaNubeLocalizedDto[] | undefined;
    variants: TiendaNubeVariantDto[] | undefined;

    constructor(data?: ITiendaNubeProductDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"] ? TiendaNubeLocalizedDto.fromJS(_data["name"]) : <any>undefined;
            if (Array.isArray(_data["attributes"])) {
                this.attributes = [] as any;
                for (let item of _data["attributes"])
                    this.attributes.push(TiendaNubeLocalizedDto.fromJS(item));
            }
            if (Array.isArray(_data["variants"])) {
                this.variants = [] as any;
                for (let item of _data["variants"])
                    this.variants.push(TiendaNubeVariantDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TiendaNubeProductDto {
        data = typeof data === 'object' ? data : {};
        let result = new TiendaNubeProductDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name ? this.name.toJSON() : <any>undefined;
        if (Array.isArray(this.attributes)) {
            data["attributes"] = [];
            for (let item of this.attributes)
                data["attributes"].push(item.toJSON());
        }
        if (Array.isArray(this.variants)) {
            data["variants"] = [];
            for (let item of this.variants)
                data["variants"].push(item.toJSON());
        }
        return data;
    }

    clone(): TiendaNubeProductDto {
        const json = this.toJSON();
        let result = new TiendaNubeProductDto();
        result.init(json);
        return result;
    }
}

export interface ITiendaNubeProductDto {
    id: number;
    name: TiendaNubeLocalizedDto;
    attributes: TiendaNubeLocalizedDto[] | undefined;
    variants: TiendaNubeVariantDto[] | undefined;
}

export class TiendaNubeStoreConfigurationDto implements ITiendaNubeStoreConfigurationDto {
    storeId: number | undefined;
    storeIds: number[] | undefined;
    applicationToken: string | undefined;
    apiBaseUrl: string | undefined;
    userAgent: string | undefined;
    priceListDefaultId: number | undefined;
    priceListPromotionId: number | undefined;
    minimumStock: number | undefined;

    constructor(data?: ITiendaNubeStoreConfigurationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.storeId = _data["storeId"];
            if (Array.isArray(_data["storeIds"])) {
                this.storeIds = [] as any;
                for (let item of _data["storeIds"])
                    this.storeIds.push(item);
            }
            this.applicationToken = _data["applicationToken"];
            this.apiBaseUrl = _data["apiBaseUrl"];
            this.userAgent = _data["userAgent"];
            this.priceListDefaultId = _data["priceListDefaultId"];
            this.priceListPromotionId = _data["priceListPromotionId"];
            this.minimumStock = _data["minimumStock"];
        }
    }

    static fromJS(data: any): TiendaNubeStoreConfigurationDto {
        data = typeof data === 'object' ? data : {};
        let result = new TiendaNubeStoreConfigurationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["storeId"] = this.storeId;
        if (Array.isArray(this.storeIds)) {
            data["storeIds"] = [];
            for (let item of this.storeIds)
                data["storeIds"].push(item);
        }
        data["applicationToken"] = this.applicationToken;
        data["apiBaseUrl"] = this.apiBaseUrl;
        data["userAgent"] = this.userAgent;
        data["priceListDefaultId"] = this.priceListDefaultId;
        data["priceListPromotionId"] = this.priceListPromotionId;
        data["minimumStock"] = this.minimumStock;
        return data;
    }

    clone(): TiendaNubeStoreConfigurationDto {
        const json = this.toJSON();
        let result = new TiendaNubeStoreConfigurationDto();
        result.init(json);
        return result;
    }
}

export interface ITiendaNubeStoreConfigurationDto {
    storeId: number | undefined;
    storeIds: number[] | undefined;
    applicationToken: string | undefined;
    apiBaseUrl: string | undefined;
    userAgent: string | undefined;
    priceListDefaultId: number | undefined;
    priceListPromotionId: number | undefined;
    minimumStock: number | undefined;
}

export class TiendaNubeVariantDto implements ITiendaNubeVariantDto {
    id: number;
    productId: number;
    sku: string | undefined;
    color: string | undefined;
    size: string | undefined;
    values: TiendaNubeLocalizedDto[] | undefined;
    stock: number | undefined;
    price: number | undefined;

    constructor(data?: ITiendaNubeVariantDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.productId = _data["productId"];
            this.sku = _data["sku"];
            this.color = _data["color"];
            this.size = _data["size"];
            if (Array.isArray(_data["values"])) {
                this.values = [] as any;
                for (let item of _data["values"])
                    this.values.push(TiendaNubeLocalizedDto.fromJS(item));
            }
            this.stock = _data["stock"];
            this.price = _data["price"];
        }
    }

    static fromJS(data: any): TiendaNubeVariantDto {
        data = typeof data === 'object' ? data : {};
        let result = new TiendaNubeVariantDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["productId"] = this.productId;
        data["sku"] = this.sku;
        data["color"] = this.color;
        data["size"] = this.size;
        if (Array.isArray(this.values)) {
            data["values"] = [];
            for (let item of this.values)
                data["values"].push(item.toJSON());
        }
        data["stock"] = this.stock;
        data["price"] = this.price;
        return data;
    }

    clone(): TiendaNubeVariantDto {
        const json = this.toJSON();
        let result = new TiendaNubeVariantDto();
        result.init(json);
        return result;
    }
}

export interface ITiendaNubeVariantDto {
    id: number;
    productId: number;
    sku: string | undefined;
    color: string | undefined;
    size: string | undefined;
    values: TiendaNubeLocalizedDto[] | undefined;
    stock: number | undefined;
    price: number | undefined;
}

export class Transaction implements ITransaction {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    tenantId: number | undefined;
    name: string | undefined;
    sentDate: moment.Moment | undefined;
    expireDate: moment.Moment | undefined;
    numberTransaction: string | undefined;
    amount: number;
    amountFinal: number;
    typeOperation: TypeOperation;
    description: string | undefined;
    isReportProcessed: boolean;
    providerPaymentId: number | undefined;
    providerPayment: ProviderPayment;
    currencyId: number;
    currency: Currency;
    invoiceId: number | undefined;
    invoice: Invoice;
    cashierId: number;
    cashier: Cashier;
    authorizedById: number | undefined;
    authorizedBy: User;
    extensionData: string | undefined;
    bankAccount: BankAccountModel;
    companyQuote: CompanyQuoteModel;
    gatewayPaymentData: GatewayPaymentDataModel;

    constructor(data?: ITransaction) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.tenantId = _data["tenantId"];
            this.name = _data["name"];
            this.sentDate = _data["sentDate"] ? moment(_data["sentDate"].toString()) : <any>undefined;
            this.expireDate = _data["expireDate"] ? moment(_data["expireDate"].toString()) : <any>undefined;
            this.numberTransaction = _data["numberTransaction"];
            this.amount = _data["amount"];
            this.amountFinal = _data["amountFinal"];
            this.typeOperation = _data["typeOperation"];
            this.description = _data["description"];
            this.isReportProcessed = _data["isReportProcessed"];
            this.providerPaymentId = _data["providerPaymentId"];
            this.providerPayment = _data["providerPayment"] ? ProviderPayment.fromJS(_data["providerPayment"]) : <any>undefined;
            this.currencyId = _data["currencyId"];
            this.currency = _data["currency"] ? Currency.fromJS(_data["currency"]) : <any>undefined;
            this.invoiceId = _data["invoiceId"];
            this.invoice = _data["invoice"] ? Invoice.fromJS(_data["invoice"]) : <any>undefined;
            this.cashierId = _data["cashierId"];
            this.cashier = _data["cashier"] ? Cashier.fromJS(_data["cashier"]) : <any>undefined;
            this.authorizedById = _data["authorizedById"];
            this.authorizedBy = _data["authorizedBy"] ? User.fromJS(_data["authorizedBy"]) : <any>undefined;
            this.extensionData = _data["extensionData"];
            this.bankAccount = _data["bankAccount"] ? BankAccountModel.fromJS(_data["bankAccount"]) : <any>undefined;
            this.companyQuote = _data["companyQuote"] ? CompanyQuoteModel.fromJS(_data["companyQuote"]) : <any>undefined;
            this.gatewayPaymentData = _data["gatewayPaymentData"] ? GatewayPaymentDataModel.fromJS(_data["gatewayPaymentData"]) : <any>undefined;
        }
    }

    static fromJS(data: any): Transaction {
        data = typeof data === 'object' ? data : {};
        let result = new Transaction();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["tenantId"] = this.tenantId;
        data["name"] = this.name;
        data["sentDate"] = this.sentDate ? this.sentDate.toISOString() : <any>undefined;
        data["expireDate"] = this.expireDate ? this.expireDate.toISOString() : <any>undefined;
        data["numberTransaction"] = this.numberTransaction;
        data["amount"] = this.amount;
        data["amountFinal"] = this.amountFinal;
        data["typeOperation"] = this.typeOperation;
        data["description"] = this.description;
        data["isReportProcessed"] = this.isReportProcessed;
        data["providerPaymentId"] = this.providerPaymentId;
        data["providerPayment"] = this.providerPayment ? this.providerPayment.toJSON() : <any>undefined;
        data["currencyId"] = this.currencyId;
        data["currency"] = this.currency ? this.currency.toJSON() : <any>undefined;
        data["invoiceId"] = this.invoiceId;
        data["invoice"] = this.invoice ? this.invoice.toJSON() : <any>undefined;
        data["cashierId"] = this.cashierId;
        data["cashier"] = this.cashier ? this.cashier.toJSON() : <any>undefined;
        data["authorizedById"] = this.authorizedById;
        data["authorizedBy"] = this.authorizedBy ? this.authorizedBy.toJSON() : <any>undefined;
        data["extensionData"] = this.extensionData;
        data["bankAccount"] = this.bankAccount ? this.bankAccount.toJSON() : <any>undefined;
        data["companyQuote"] = this.companyQuote ? this.companyQuote.toJSON() : <any>undefined;
        data["gatewayPaymentData"] = this.gatewayPaymentData ? this.gatewayPaymentData.toJSON() : <any>undefined;
        return data;
    }

    clone(): Transaction {
        const json = this.toJSON();
        let result = new Transaction();
        result.init(json);
        return result;
    }
}

export interface ITransaction {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    tenantId: number | undefined;
    name: string | undefined;
    sentDate: moment.Moment | undefined;
    expireDate: moment.Moment | undefined;
    numberTransaction: string | undefined;
    amount: number;
    amountFinal: number;
    typeOperation: TypeOperation;
    description: string | undefined;
    isReportProcessed: boolean;
    providerPaymentId: number | undefined;
    providerPayment: ProviderPayment;
    currencyId: number;
    currency: Currency;
    invoiceId: number | undefined;
    invoice: Invoice;
    cashierId: number;
    cashier: Cashier;
    authorizedById: number | undefined;
    authorizedBy: User;
    extensionData: string | undefined;
    bankAccount: BankAccountModel;
    companyQuote: CompanyQuoteModel;
    gatewayPaymentData: GatewayPaymentDataModel;
}

export class TransactionCashOpenDto implements ITransactionCashOpenDto {
    currencyId: number;
    amount: number;

    constructor(data?: ITransactionCashOpenDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.currencyId = _data["currencyId"];
            this.amount = _data["amount"];
        }
    }

    static fromJS(data: any): TransactionCashOpenDto {
        data = typeof data === 'object' ? data : {};
        let result = new TransactionCashOpenDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currencyId"] = this.currencyId;
        data["amount"] = this.amount;
        return data;
    }

    clone(): TransactionCashOpenDto {
        const json = this.toJSON();
        let result = new TransactionCashOpenDto();
        result.init(json);
        return result;
    }
}

export interface ITransactionCashOpenDto {
    currencyId: number;
    amount: number;
}

export class TransactionDto implements ITransactionDto {
    id: number;
    tenantId: number | undefined;
    name: string | undefined;
    sentDate: moment.Moment | undefined;
    expireDate: moment.Moment | undefined;
    numberTransaction: string | undefined;
    amount: number;
    amountFinal: number;
    amountWithoutPromotions: number;
    amountOfPromotions: number;
    typeOperation: TypeOperation;
    providerPaymentId: number;
    providerPaymentName: string | undefined;
    providerPaymentType: string | undefined;
    currencyId: number;
    currencyName: string | undefined;
    currencyQuote: number;
    cashierId: number | undefined;
    bankAccountId: number | undefined;
    companyId: number | undefined;
    companyName: string | undefined;
    quoteId: number | undefined;
    quote: QuoteDto;
    bankId: number | undefined;
    isGatewayPayment: boolean;
    invoiceNumber: string | undefined;
    gatewayPaymentData: GatewayPaymentDataDto;
    paymentId: string | undefined;
    gatewayPaymentType: PaymentType;
    hasReversalPaymentCreated: boolean;
    paymentWithCashInAccount: boolean;

    constructor(data?: ITransactionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tenantId = _data["tenantId"];
            this.name = _data["name"];
            this.sentDate = _data["sentDate"] ? moment(_data["sentDate"].toString()) : <any>undefined;
            this.expireDate = _data["expireDate"] ? moment(_data["expireDate"].toString()) : <any>undefined;
            this.numberTransaction = _data["numberTransaction"];
            this.amount = _data["amount"];
            this.amountFinal = _data["amountFinal"];
            this.amountWithoutPromotions = _data["amountWithoutPromotions"];
            this.amountOfPromotions = _data["amountOfPromotions"];
            this.typeOperation = _data["typeOperation"];
            this.providerPaymentId = _data["providerPaymentId"];
            this.providerPaymentName = _data["providerPaymentName"];
            this.providerPaymentType = _data["providerPaymentType"];
            this.currencyId = _data["currencyId"];
            this.currencyName = _data["currencyName"];
            this.currencyQuote = _data["currencyQuote"];
            this.cashierId = _data["cashierId"];
            this.bankAccountId = _data["bankAccountId"];
            this.companyId = _data["companyId"];
            this.companyName = _data["companyName"];
            this.quoteId = _data["quoteId"];
            this.quote = _data["quote"] ? QuoteDto.fromJS(_data["quote"]) : <any>undefined;
            this.bankId = _data["bankId"];
            this.isGatewayPayment = _data["isGatewayPayment"];
            this.invoiceNumber = _data["invoiceNumber"];
            this.gatewayPaymentData = _data["gatewayPaymentData"] ? GatewayPaymentDataDto.fromJS(_data["gatewayPaymentData"]) : <any>undefined;
            this.paymentId = _data["paymentId"];
            this.gatewayPaymentType = _data["gatewayPaymentType"];
            this.hasReversalPaymentCreated = _data["hasReversalPaymentCreated"];
            this.paymentWithCashInAccount = _data["paymentWithCashInAccount"];
        }
    }

    static fromJS(data: any): TransactionDto {
        data = typeof data === 'object' ? data : {};
        let result = new TransactionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tenantId"] = this.tenantId;
        data["name"] = this.name;
        data["sentDate"] = this.sentDate ? this.sentDate.toISOString() : <any>undefined;
        data["expireDate"] = this.expireDate ? this.expireDate.toISOString() : <any>undefined;
        data["numberTransaction"] = this.numberTransaction;
        data["amount"] = this.amount;
        data["amountFinal"] = this.amountFinal;
        data["amountWithoutPromotions"] = this.amountWithoutPromotions;
        data["amountOfPromotions"] = this.amountOfPromotions;
        data["typeOperation"] = this.typeOperation;
        data["providerPaymentId"] = this.providerPaymentId;
        data["providerPaymentName"] = this.providerPaymentName;
        data["providerPaymentType"] = this.providerPaymentType;
        data["currencyId"] = this.currencyId;
        data["currencyName"] = this.currencyName;
        data["currencyQuote"] = this.currencyQuote;
        data["cashierId"] = this.cashierId;
        data["bankAccountId"] = this.bankAccountId;
        data["companyId"] = this.companyId;
        data["companyName"] = this.companyName;
        data["quoteId"] = this.quoteId;
        data["quote"] = this.quote ? this.quote.toJSON() : <any>undefined;
        data["bankId"] = this.bankId;
        data["isGatewayPayment"] = this.isGatewayPayment;
        data["invoiceNumber"] = this.invoiceNumber;
        data["gatewayPaymentData"] = this.gatewayPaymentData ? this.gatewayPaymentData.toJSON() : <any>undefined;
        data["paymentId"] = this.paymentId;
        data["gatewayPaymentType"] = this.gatewayPaymentType;
        data["hasReversalPaymentCreated"] = this.hasReversalPaymentCreated;
        data["paymentWithCashInAccount"] = this.paymentWithCashInAccount;
        return data;
    }

    clone(): TransactionDto {
        const json = this.toJSON();
        let result = new TransactionDto();
        result.init(json);
        return result;
    }
}

export interface ITransactionDto {
    id: number;
    tenantId: number | undefined;
    name: string | undefined;
    sentDate: moment.Moment | undefined;
    expireDate: moment.Moment | undefined;
    numberTransaction: string | undefined;
    amount: number;
    amountFinal: number;
    amountWithoutPromotions: number;
    amountOfPromotions: number;
    typeOperation: TypeOperation;
    providerPaymentId: number;
    providerPaymentName: string | undefined;
    providerPaymentType: string | undefined;
    currencyId: number;
    currencyName: string | undefined;
    currencyQuote: number;
    cashierId: number | undefined;
    bankAccountId: number | undefined;
    companyId: number | undefined;
    companyName: string | undefined;
    quoteId: number | undefined;
    quote: QuoteDto;
    bankId: number | undefined;
    isGatewayPayment: boolean;
    invoiceNumber: string | undefined;
    gatewayPaymentData: GatewayPaymentDataDto;
    paymentId: string | undefined;
    gatewayPaymentType: PaymentType;
    hasReversalPaymentCreated: boolean;
    paymentWithCashInAccount: boolean;
}

export class TransactionInOutDto implements ITransactionInOutDto {
    amount: number;
    typeOperation: TypeOperation;
    description: string | undefined;
    currencyId: number;
    cashierId: number;
    code: string | undefined;

    constructor(data?: ITransactionInOutDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.amount = _data["amount"];
            this.typeOperation = _data["typeOperation"];
            this.description = _data["description"];
            this.currencyId = _data["currencyId"];
            this.cashierId = _data["cashierId"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): TransactionInOutDto {
        data = typeof data === 'object' ? data : {};
        let result = new TransactionInOutDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["amount"] = this.amount;
        data["typeOperation"] = this.typeOperation;
        data["description"] = this.description;
        data["currencyId"] = this.currencyId;
        data["cashierId"] = this.cashierId;
        data["code"] = this.code;
        return data;
    }

    clone(): TransactionInOutDto {
        const json = this.toJSON();
        let result = new TransactionInOutDto();
        result.init(json);
        return result;
    }
}

export interface ITransactionInOutDto {
    amount: number;
    typeOperation: TypeOperation;
    description: string | undefined;
    currencyId: number;
    cashierId: number;
    code: string | undefined;
}

export class TransactionModel implements ITransactionModel {
    name: string | undefined;
    sentDate: moment.Moment | undefined;
    expireDate: moment.Moment | undefined;
    numberTransaction: string | undefined;
    amount: number;
    amountFinal: number;
    typeOperation: TypeOperation;
    providerPaymentId: number;
    providerPaymentName: string | undefined;
    currencyId: number;
    currencyName: string | undefined;
    currencyQuote: number;
    cashierId: number | undefined;
    bankAccountId: number | undefined;
    companyId: number | undefined;
    companyName: string | undefined;
    bankId: number | undefined;
    quoteId: number | undefined;
    quote: QuoteModel;
    gatewayPaymentData: GatewayPaymentDataModel;

    constructor(data?: ITransactionModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.sentDate = _data["sentDate"] ? moment(_data["sentDate"].toString()) : <any>undefined;
            this.expireDate = _data["expireDate"] ? moment(_data["expireDate"].toString()) : <any>undefined;
            this.numberTransaction = _data["numberTransaction"];
            this.amount = _data["amount"];
            this.amountFinal = _data["amountFinal"];
            this.typeOperation = _data["typeOperation"];
            this.providerPaymentId = _data["providerPaymentId"];
            this.providerPaymentName = _data["providerPaymentName"];
            this.currencyId = _data["currencyId"];
            this.currencyName = _data["currencyName"];
            this.currencyQuote = _data["currencyQuote"];
            this.cashierId = _data["cashierId"];
            this.bankAccountId = _data["bankAccountId"];
            this.companyId = _data["companyId"];
            this.companyName = _data["companyName"];
            this.bankId = _data["bankId"];
            this.quoteId = _data["quoteId"];
            this.quote = _data["quote"] ? QuoteModel.fromJS(_data["quote"]) : <any>undefined;
            this.gatewayPaymentData = _data["gatewayPaymentData"] ? GatewayPaymentDataModel.fromJS(_data["gatewayPaymentData"]) : <any>undefined;
        }
    }

    static fromJS(data: any): TransactionModel {
        data = typeof data === 'object' ? data : {};
        let result = new TransactionModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["sentDate"] = this.sentDate ? this.sentDate.toISOString() : <any>undefined;
        data["expireDate"] = this.expireDate ? this.expireDate.toISOString() : <any>undefined;
        data["numberTransaction"] = this.numberTransaction;
        data["amount"] = this.amount;
        data["amountFinal"] = this.amountFinal;
        data["typeOperation"] = this.typeOperation;
        data["providerPaymentId"] = this.providerPaymentId;
        data["providerPaymentName"] = this.providerPaymentName;
        data["currencyId"] = this.currencyId;
        data["currencyName"] = this.currencyName;
        data["currencyQuote"] = this.currencyQuote;
        data["cashierId"] = this.cashierId;
        data["bankAccountId"] = this.bankAccountId;
        data["companyId"] = this.companyId;
        data["companyName"] = this.companyName;
        data["bankId"] = this.bankId;
        data["quoteId"] = this.quoteId;
        data["quote"] = this.quote ? this.quote.toJSON() : <any>undefined;
        data["gatewayPaymentData"] = this.gatewayPaymentData ? this.gatewayPaymentData.toJSON() : <any>undefined;
        return data;
    }

    clone(): TransactionModel {
        const json = this.toJSON();
        let result = new TransactionModel();
        result.init(json);
        return result;
    }
}

export interface ITransactionModel {
    name: string | undefined;
    sentDate: moment.Moment | undefined;
    expireDate: moment.Moment | undefined;
    numberTransaction: string | undefined;
    amount: number;
    amountFinal: number;
    typeOperation: TypeOperation;
    providerPaymentId: number;
    providerPaymentName: string | undefined;
    currencyId: number;
    currencyName: string | undefined;
    currencyQuote: number;
    cashierId: number | undefined;
    bankAccountId: number | undefined;
    companyId: number | undefined;
    companyName: string | undefined;
    bankId: number | undefined;
    quoteId: number | undefined;
    quote: QuoteModel;
    gatewayPaymentData: GatewayPaymentDataModel;
}

export class TransitDeliveryNoteDetailsDto implements ITransitDeliveryNoteDetailsDto {
    stockMovementDetailId: number;
    productId: number;
    variantId: number | undefined;
    description: string | undefined;
    quantity: number;
    name: string | undefined;
    documentationQuantity: number;
    code: string | undefined;
    date: moment.Moment;
    externalId: number | undefined;
    hasDecimalQuantity: boolean;
    productNotFound: boolean;

    constructor(data?: ITransitDeliveryNoteDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.stockMovementDetailId = _data["stockMovementDetailId"];
            this.productId = _data["productId"];
            this.variantId = _data["variantId"];
            this.description = _data["description"];
            this.quantity = _data["quantity"];
            this.name = _data["name"];
            this.documentationQuantity = _data["documentationQuantity"];
            this.code = _data["code"];
            this.date = _data["date"] ? moment(_data["date"].toString()) : <any>undefined;
            this.externalId = _data["externalId"];
            this.hasDecimalQuantity = _data["hasDecimalQuantity"];
            this.productNotFound = _data["productNotFound"];
        }
    }

    static fromJS(data: any): TransitDeliveryNoteDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new TransitDeliveryNoteDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["stockMovementDetailId"] = this.stockMovementDetailId;
        data["productId"] = this.productId;
        data["variantId"] = this.variantId;
        data["description"] = this.description;
        data["quantity"] = this.quantity;
        data["name"] = this.name;
        data["documentationQuantity"] = this.documentationQuantity;
        data["code"] = this.code;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["externalId"] = this.externalId;
        data["hasDecimalQuantity"] = this.hasDecimalQuantity;
        data["productNotFound"] = this.productNotFound;
        return data;
    }

    clone(): TransitDeliveryNoteDetailsDto {
        const json = this.toJSON();
        let result = new TransitDeliveryNoteDetailsDto();
        result.init(json);
        return result;
    }
}

export interface ITransitDeliveryNoteDetailsDto {
    stockMovementDetailId: number;
    productId: number;
    variantId: number | undefined;
    description: string | undefined;
    quantity: number;
    name: string | undefined;
    documentationQuantity: number;
    code: string | undefined;
    date: moment.Moment;
    externalId: number | undefined;
    hasDecimalQuantity: boolean;
    productNotFound: boolean;
}

export enum TypeCash {
    Open = <any>"Open",
    Closed = <any>"Closed",
}

export enum TypeOperation {
    CashOpen = <any>"CashOpen",
    CashClose = <any>"CashClose",
    CashIn = <any>"CashIn",
    CashOut = <any>"CashOut",
    Invoice = <any>"Invoice",
    PurchaseOrder = <any>"PurchaseOrder",
}

export enum TypeProviderPayment {
    Cash = <any>"Cash",
    BankTransfer = <any>"BankTransfer",
    CreditCard = <any>"CreditCard",
    Online = <any>"Online",
}

export enum TypeSalePoint {
    Manual = <any>"Manual",
    Electronic = <any>"Electronic",
    FiscalController = <any>"FiscalController",
}

export enum TypeTaxe {
    Vat = <any>"Vat",
    Rent = <any>"Rent",
    Others = <any>"Others",
}

export class UpdateCashierInputDto implements IUpdateCashierInputDto {
    id: number;
    tenantId: number | undefined;
    name: string | undefined;
    salePointId: number;
    paywayTerminalId: string | undefined;

    constructor(data?: IUpdateCashierInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tenantId = _data["tenantId"];
            this.name = _data["name"];
            this.salePointId = _data["salePointId"];
            this.paywayTerminalId = _data["paywayTerminalId"];
        }
    }

    static fromJS(data: any): UpdateCashierInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCashierInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tenantId"] = this.tenantId;
        data["name"] = this.name;
        data["salePointId"] = this.salePointId;
        data["paywayTerminalId"] = this.paywayTerminalId;
        return data;
    }

    clone(): UpdateCashierInputDto {
        const json = this.toJSON();
        let result = new UpdateCashierInputDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateCashierInputDto {
    id: number;
    tenantId: number | undefined;
    name: string | undefined;
    salePointId: number;
    paywayTerminalId: string | undefined;
}

export class UpdatePriceInput implements IUpdatePriceInput {
    variantId: number;

    constructor(data?: IUpdatePriceInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.variantId = _data["variantId"];
        }
    }

    static fromJS(data: any): UpdatePriceInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePriceInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["variantId"] = this.variantId;
        return data;
    }

    clone(): UpdatePriceInput {
        const json = this.toJSON();
        let result = new UpdatePriceInput();
        result.init(json);
        return result;
    }
}

export interface IUpdatePriceInput {
    variantId: number;
}

export class UpdateStockInput implements IUpdateStockInput {
    variantId: number;
    newStock: number;

    constructor(data?: IUpdateStockInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.variantId = _data["variantId"];
            this.newStock = _data["newStock"];
        }
    }

    static fromJS(data: any): UpdateStockInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateStockInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["variantId"] = this.variantId;
        data["newStock"] = this.newStock;
        return data;
    }

    clone(): UpdateStockInput {
        const json = this.toJSON();
        let result = new UpdateStockInput();
        result.init(json);
        return result;
    }
}

export interface IUpdateStockInput {
    variantId: number;
    newStock: number;
}

export class UpdateTenantDto implements IUpdateTenantDto {
    id: number;
    tenancyName: string;
    name: string;
    isActive: boolean;
    tenantGroupId: number | undefined;
    useNoFiscal: boolean;
    useHistoricPrice: boolean;
    allowNegativeStock: boolean;
    allowNegativeSales: boolean;
    allowNegativeReservation: boolean;
    allowNegativeChanges: boolean;
    enableThirdPartyOrderImport: boolean;
    enableThirdPartyOrderImportAdmin: boolean;
    applyPromotionOverCheapestProducts: boolean;
    webServiceAfip: WebServiceAfip;
    editionId: number | undefined;
    parentId: number | undefined;
    usePayway: boolean;
    useMercadoLibre: boolean;
    useTiendaNube: boolean;
    paywayCashInAccountProviderPaymentId: number | undefined;
    tenantIds: number[] | undefined;

    constructor(data?: IUpdateTenantDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tenancyName = _data["tenancyName"];
            this.name = _data["name"];
            this.isActive = _data["isActive"];
            this.tenantGroupId = _data["tenantGroupId"];
            this.useNoFiscal = _data["useNoFiscal"];
            this.useHistoricPrice = _data["useHistoricPrice"];
            this.allowNegativeStock = _data["allowNegativeStock"];
            this.allowNegativeSales = _data["allowNegativeSales"];
            this.allowNegativeReservation = _data["allowNegativeReservation"];
            this.allowNegativeChanges = _data["allowNegativeChanges"];
            this.enableThirdPartyOrderImport = _data["enableThirdPartyOrderImport"];
            this.enableThirdPartyOrderImportAdmin = _data["enableThirdPartyOrderImportAdmin"];
            this.applyPromotionOverCheapestProducts = _data["applyPromotionOverCheapestProducts"];
            this.webServiceAfip = _data["webServiceAfip"];
            this.editionId = _data["editionId"];
            this.parentId = _data["parentId"];
            this.usePayway = _data["usePayway"];
            this.useMercadoLibre = _data["useMercadoLibre"];
            this.useTiendaNube = _data["useTiendaNube"];
            this.paywayCashInAccountProviderPaymentId = _data["paywayCashInAccountProviderPaymentId"];
            if (Array.isArray(_data["tenantIds"])) {
                this.tenantIds = [] as any;
                for (let item of _data["tenantIds"])
                    this.tenantIds.push(item);
            }
        }
    }

    static fromJS(data: any): UpdateTenantDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateTenantDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tenancyName"] = this.tenancyName;
        data["name"] = this.name;
        data["isActive"] = this.isActive;
        data["tenantGroupId"] = this.tenantGroupId;
        data["useNoFiscal"] = this.useNoFiscal;
        data["useHistoricPrice"] = this.useHistoricPrice;
        data["allowNegativeStock"] = this.allowNegativeStock;
        data["allowNegativeSales"] = this.allowNegativeSales;
        data["allowNegativeReservation"] = this.allowNegativeReservation;
        data["allowNegativeChanges"] = this.allowNegativeChanges;
        data["enableThirdPartyOrderImport"] = this.enableThirdPartyOrderImport;
        data["enableThirdPartyOrderImportAdmin"] = this.enableThirdPartyOrderImportAdmin;
        data["applyPromotionOverCheapestProducts"] = this.applyPromotionOverCheapestProducts;
        data["webServiceAfip"] = this.webServiceAfip;
        data["editionId"] = this.editionId;
        data["parentId"] = this.parentId;
        data["usePayway"] = this.usePayway;
        data["useMercadoLibre"] = this.useMercadoLibre;
        data["useTiendaNube"] = this.useTiendaNube;
        data["paywayCashInAccountProviderPaymentId"] = this.paywayCashInAccountProviderPaymentId;
        if (Array.isArray(this.tenantIds)) {
            data["tenantIds"] = [];
            for (let item of this.tenantIds)
                data["tenantIds"].push(item);
        }
        return data;
    }

    clone(): UpdateTenantDto {
        const json = this.toJSON();
        let result = new UpdateTenantDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateTenantDto {
    id: number;
    tenancyName: string;
    name: string;
    isActive: boolean;
    tenantGroupId: number | undefined;
    useNoFiscal: boolean;
    useHistoricPrice: boolean;
    allowNegativeStock: boolean;
    allowNegativeSales: boolean;
    allowNegativeReservation: boolean;
    allowNegativeChanges: boolean;
    enableThirdPartyOrderImport: boolean;
    enableThirdPartyOrderImportAdmin: boolean;
    applyPromotionOverCheapestProducts: boolean;
    webServiceAfip: WebServiceAfip;
    editionId: number | undefined;
    parentId: number | undefined;
    usePayway: boolean;
    useMercadoLibre: boolean;
    useTiendaNube: boolean;
    paywayCashInAccountProviderPaymentId: number | undefined;
    tenantIds: number[] | undefined;
}

export class User implements IUser {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    authenticationSource: string | undefined;
    userName: string;
    tenantId: number | undefined;
    emailAddress: string;
    name: string;
    surname: string;
    readonly fullName: string | undefined;
    password: string;
    emailConfirmationCode: string | undefined;
    passwordResetCode: string | undefined;
    lockoutEndDateUtc: moment.Moment | undefined;
    accessFailedCount: number;
    isLockoutEnabled: boolean;
    phoneNumber: string | undefined;
    isPhoneNumberConfirmed: boolean;
    securityStamp: string | undefined;
    isTwoFactorEnabled: boolean;
    logins: UserLogin[] | undefined;
    roles: UserRole[] | undefined;
    claims: UserClaim[] | undefined;
    permissions: UserPermissionSetting[] | undefined;
    settings: Setting[] | undefined;
    isEmailConfirmed: boolean;
    isActive: boolean;
    normalizedUserName: string;
    normalizedEmailAddress: string;
    concurrencyStamp: string | undefined;
    tokens: UserToken[] | undefined;
    deleterUser: User;
    creatorUser: User;
    lastModifierUser: User;
    isOwner: boolean;
    salePointConfigId: number | undefined;
    salePointConfig: SalePoint;
    scheduleAndEnabledDays: string | undefined;
    notInStores: string | undefined;
    salePointsIds: string | undefined;
    cashierConfigId: number | undefined;
    cashierConfig: Cashier;
    invoices: Invoice[] | undefined;
    authorizations: Transaction[] | undefined;

    constructor(data?: IUser) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.authenticationSource = _data["authenticationSource"];
            this.userName = _data["userName"];
            this.tenantId = _data["tenantId"];
            this.emailAddress = _data["emailAddress"];
            this.name = _data["name"];
            this.surname = _data["surname"];
            (<any>this).fullName = _data["fullName"];
            this.password = _data["password"];
            this.emailConfirmationCode = _data["emailConfirmationCode"];
            this.passwordResetCode = _data["passwordResetCode"];
            this.lockoutEndDateUtc = _data["lockoutEndDateUtc"] ? moment(_data["lockoutEndDateUtc"].toString()) : <any>undefined;
            this.accessFailedCount = _data["accessFailedCount"];
            this.isLockoutEnabled = _data["isLockoutEnabled"];
            this.phoneNumber = _data["phoneNumber"];
            this.isPhoneNumberConfirmed = _data["isPhoneNumberConfirmed"];
            this.securityStamp = _data["securityStamp"];
            this.isTwoFactorEnabled = _data["isTwoFactorEnabled"];
            if (Array.isArray(_data["logins"])) {
                this.logins = [] as any;
                for (let item of _data["logins"])
                    this.logins.push(UserLogin.fromJS(item));
            }
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles.push(UserRole.fromJS(item));
            }
            if (Array.isArray(_data["claims"])) {
                this.claims = [] as any;
                for (let item of _data["claims"])
                    this.claims.push(UserClaim.fromJS(item));
            }
            if (Array.isArray(_data["permissions"])) {
                this.permissions = [] as any;
                for (let item of _data["permissions"])
                    this.permissions.push(UserPermissionSetting.fromJS(item));
            }
            if (Array.isArray(_data["settings"])) {
                this.settings = [] as any;
                for (let item of _data["settings"])
                    this.settings.push(Setting.fromJS(item));
            }
            this.isEmailConfirmed = _data["isEmailConfirmed"];
            this.isActive = _data["isActive"];
            this.normalizedUserName = _data["normalizedUserName"];
            this.normalizedEmailAddress = _data["normalizedEmailAddress"];
            this.concurrencyStamp = _data["concurrencyStamp"];
            if (Array.isArray(_data["tokens"])) {
                this.tokens = [] as any;
                for (let item of _data["tokens"])
                    this.tokens.push(UserToken.fromJS(item));
            }
            this.deleterUser = _data["deleterUser"] ? User.fromJS(_data["deleterUser"]) : <any>undefined;
            this.creatorUser = _data["creatorUser"] ? User.fromJS(_data["creatorUser"]) : <any>undefined;
            this.lastModifierUser = _data["lastModifierUser"] ? User.fromJS(_data["lastModifierUser"]) : <any>undefined;
            this.isOwner = _data["isOwner"];
            this.salePointConfigId = _data["salePointConfigId"];
            this.salePointConfig = _data["salePointConfig"] ? SalePoint.fromJS(_data["salePointConfig"]) : <any>undefined;
            this.scheduleAndEnabledDays = _data["scheduleAndEnabledDays"];
            this.notInStores = _data["notInStores"];
            this.salePointsIds = _data["salePointsIds"];
            this.cashierConfigId = _data["cashierConfigId"];
            this.cashierConfig = _data["cashierConfig"] ? Cashier.fromJS(_data["cashierConfig"]) : <any>undefined;
            if (Array.isArray(_data["invoices"])) {
                this.invoices = [] as any;
                for (let item of _data["invoices"])
                    this.invoices.push(Invoice.fromJS(item));
            }
            if (Array.isArray(_data["authorizations"])) {
                this.authorizations = [] as any;
                for (let item of _data["authorizations"])
                    this.authorizations.push(Transaction.fromJS(item));
            }
        }
    }

    static fromJS(data: any): User {
        data = typeof data === 'object' ? data : {};
        let result = new User();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["authenticationSource"] = this.authenticationSource;
        data["userName"] = this.userName;
        data["tenantId"] = this.tenantId;
        data["emailAddress"] = this.emailAddress;
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["fullName"] = this.fullName;
        data["password"] = this.password;
        data["emailConfirmationCode"] = this.emailConfirmationCode;
        data["passwordResetCode"] = this.passwordResetCode;
        data["lockoutEndDateUtc"] = this.lockoutEndDateUtc ? this.lockoutEndDateUtc.toISOString() : <any>undefined;
        data["accessFailedCount"] = this.accessFailedCount;
        data["isLockoutEnabled"] = this.isLockoutEnabled;
        data["phoneNumber"] = this.phoneNumber;
        data["isPhoneNumberConfirmed"] = this.isPhoneNumberConfirmed;
        data["securityStamp"] = this.securityStamp;
        data["isTwoFactorEnabled"] = this.isTwoFactorEnabled;
        if (Array.isArray(this.logins)) {
            data["logins"] = [];
            for (let item of this.logins)
                data["logins"].push(item.toJSON());
        }
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item.toJSON());
        }
        if (Array.isArray(this.claims)) {
            data["claims"] = [];
            for (let item of this.claims)
                data["claims"].push(item.toJSON());
        }
        if (Array.isArray(this.permissions)) {
            data["permissions"] = [];
            for (let item of this.permissions)
                data["permissions"].push(item.toJSON());
        }
        if (Array.isArray(this.settings)) {
            data["settings"] = [];
            for (let item of this.settings)
                data["settings"].push(item.toJSON());
        }
        data["isEmailConfirmed"] = this.isEmailConfirmed;
        data["isActive"] = this.isActive;
        data["normalizedUserName"] = this.normalizedUserName;
        data["normalizedEmailAddress"] = this.normalizedEmailAddress;
        data["concurrencyStamp"] = this.concurrencyStamp;
        if (Array.isArray(this.tokens)) {
            data["tokens"] = [];
            for (let item of this.tokens)
                data["tokens"].push(item.toJSON());
        }
        data["deleterUser"] = this.deleterUser ? this.deleterUser.toJSON() : <any>undefined;
        data["creatorUser"] = this.creatorUser ? this.creatorUser.toJSON() : <any>undefined;
        data["lastModifierUser"] = this.lastModifierUser ? this.lastModifierUser.toJSON() : <any>undefined;
        data["isOwner"] = this.isOwner;
        data["salePointConfigId"] = this.salePointConfigId;
        data["salePointConfig"] = this.salePointConfig ? this.salePointConfig.toJSON() : <any>undefined;
        data["scheduleAndEnabledDays"] = this.scheduleAndEnabledDays;
        data["notInStores"] = this.notInStores;
        data["salePointsIds"] = this.salePointsIds;
        data["cashierConfigId"] = this.cashierConfigId;
        data["cashierConfig"] = this.cashierConfig ? this.cashierConfig.toJSON() : <any>undefined;
        if (Array.isArray(this.invoices)) {
            data["invoices"] = [];
            for (let item of this.invoices)
                data["invoices"].push(item.toJSON());
        }
        if (Array.isArray(this.authorizations)) {
            data["authorizations"] = [];
            for (let item of this.authorizations)
                data["authorizations"].push(item.toJSON());
        }
        return data;
    }

    clone(): User {
        const json = this.toJSON();
        let result = new User();
        result.init(json);
        return result;
    }
}

export interface IUser {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    authenticationSource: string | undefined;
    userName: string;
    tenantId: number | undefined;
    emailAddress: string;
    name: string;
    surname: string;
    fullName: string | undefined;
    password: string;
    emailConfirmationCode: string | undefined;
    passwordResetCode: string | undefined;
    lockoutEndDateUtc: moment.Moment | undefined;
    accessFailedCount: number;
    isLockoutEnabled: boolean;
    phoneNumber: string | undefined;
    isPhoneNumberConfirmed: boolean;
    securityStamp: string | undefined;
    isTwoFactorEnabled: boolean;
    logins: UserLogin[] | undefined;
    roles: UserRole[] | undefined;
    claims: UserClaim[] | undefined;
    permissions: UserPermissionSetting[] | undefined;
    settings: Setting[] | undefined;
    isEmailConfirmed: boolean;
    isActive: boolean;
    normalizedUserName: string;
    normalizedEmailAddress: string;
    concurrencyStamp: string | undefined;
    tokens: UserToken[] | undefined;
    deleterUser: User;
    creatorUser: User;
    lastModifierUser: User;
    isOwner: boolean;
    salePointConfigId: number | undefined;
    salePointConfig: SalePoint;
    scheduleAndEnabledDays: string | undefined;
    notInStores: string | undefined;
    salePointsIds: string | undefined;
    cashierConfigId: number | undefined;
    cashierConfig: Cashier;
    invoices: Invoice[] | undefined;
    authorizations: Transaction[] | undefined;
}

export class UserActiveModel implements IUserActiveModel {
    userActiveId: number;
    userActiveFullName: string | undefined;
    openDateTime: moment.Moment | undefined;
    closeDateTime: moment.Moment | undefined;

    constructor(data?: IUserActiveModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userActiveId = _data["userActiveId"];
            this.userActiveFullName = _data["userActiveFullName"];
            this.openDateTime = _data["openDateTime"] ? moment(_data["openDateTime"].toString()) : <any>undefined;
            this.closeDateTime = _data["closeDateTime"] ? moment(_data["closeDateTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): UserActiveModel {
        data = typeof data === 'object' ? data : {};
        let result = new UserActiveModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userActiveId"] = this.userActiveId;
        data["userActiveFullName"] = this.userActiveFullName;
        data["openDateTime"] = this.openDateTime ? this.openDateTime.toISOString() : <any>undefined;
        data["closeDateTime"] = this.closeDateTime ? this.closeDateTime.toISOString() : <any>undefined;
        return data;
    }

    clone(): UserActiveModel {
        const json = this.toJSON();
        let result = new UserActiveModel();
        result.init(json);
        return result;
    }
}

export interface IUserActiveModel {
    userActiveId: number;
    userActiveFullName: string | undefined;
    openDateTime: moment.Moment | undefined;
    closeDateTime: moment.Moment | undefined;
}

export class UserClaim implements IUserClaim {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    tenantId: number | undefined;
    userId: number;
    claimType: string | undefined;
    claimValue: string | undefined;

    constructor(data?: IUserClaim) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.tenantId = _data["tenantId"];
            this.userId = _data["userId"];
            this.claimType = _data["claimType"];
            this.claimValue = _data["claimValue"];
        }
    }

    static fromJS(data: any): UserClaim {
        data = typeof data === 'object' ? data : {};
        let result = new UserClaim();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        data["claimType"] = this.claimType;
        data["claimValue"] = this.claimValue;
        return data;
    }

    clone(): UserClaim {
        const json = this.toJSON();
        let result = new UserClaim();
        result.init(json);
        return result;
    }
}

export interface IUserClaim {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    tenantId: number | undefined;
    userId: number;
    claimType: string | undefined;
    claimValue: string | undefined;
}

export class UserDto implements IUserDto {
    id: number;
    tenantId: number | undefined;
    tenantName: string | undefined;
    isOwner: boolean;
    scheduleAndEnabledDays: string | undefined;
    notInStores: string | undefined;
    salePointsIds: string | undefined;
    userName: string;
    name: string;
    surname: string;
    emailAddress: string;
    isActive: boolean;
    fullName: string | undefined;
    lastLoginTime: moment.Moment | undefined;
    creationTime: moment.Moment;
    roleNames: string[] | undefined;
    salePointConfigId: number | undefined;
    cashierConfigId: number | undefined;
    passwordApi: string | undefined;

    constructor(data?: IUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tenantId = _data["tenantId"];
            this.tenantName = _data["tenantName"];
            this.isOwner = _data["isOwner"];
            this.scheduleAndEnabledDays = _data["scheduleAndEnabledDays"];
            this.notInStores = _data["notInStores"];
            this.salePointsIds = _data["salePointsIds"];
            this.userName = _data["userName"];
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.emailAddress = _data["emailAddress"];
            this.isActive = _data["isActive"];
            this.fullName = _data["fullName"];
            this.lastLoginTime = _data["lastLoginTime"] ? moment(_data["lastLoginTime"].toString()) : <any>undefined;
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            if (Array.isArray(_data["roleNames"])) {
                this.roleNames = [] as any;
                for (let item of _data["roleNames"])
                    this.roleNames.push(item);
            }
            this.salePointConfigId = _data["salePointConfigId"];
            this.cashierConfigId = _data["cashierConfigId"];
            this.passwordApi = _data["passwordApi"];
        }
    }

    static fromJS(data: any): UserDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tenantId"] = this.tenantId;
        data["tenantName"] = this.tenantName;
        data["isOwner"] = this.isOwner;
        data["scheduleAndEnabledDays"] = this.scheduleAndEnabledDays;
        data["notInStores"] = this.notInStores;
        data["salePointsIds"] = this.salePointsIds;
        data["userName"] = this.userName;
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["emailAddress"] = this.emailAddress;
        data["isActive"] = this.isActive;
        data["fullName"] = this.fullName;
        data["lastLoginTime"] = this.lastLoginTime ? this.lastLoginTime.toISOString() : <any>undefined;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        if (Array.isArray(this.roleNames)) {
            data["roleNames"] = [];
            for (let item of this.roleNames)
                data["roleNames"].push(item);
        }
        data["salePointConfigId"] = this.salePointConfigId;
        data["cashierConfigId"] = this.cashierConfigId;
        data["passwordApi"] = this.passwordApi;
        return data;
    }

    clone(): UserDto {
        const json = this.toJSON();
        let result = new UserDto();
        result.init(json);
        return result;
    }
}

export interface IUserDto {
    id: number;
    tenantId: number | undefined;
    tenantName: string | undefined;
    isOwner: boolean;
    scheduleAndEnabledDays: string | undefined;
    notInStores: string | undefined;
    salePointsIds: string | undefined;
    userName: string;
    name: string;
    surname: string;
    emailAddress: string;
    isActive: boolean;
    fullName: string | undefined;
    lastLoginTime: moment.Moment | undefined;
    creationTime: moment.Moment;
    roleNames: string[] | undefined;
    salePointConfigId: number | undefined;
    cashierConfigId: number | undefined;
    passwordApi: string | undefined;
}

export class UserDtoPagedResultDto implements IUserDtoPagedResultDto {
    items: UserDto[] | undefined;
    totalCount: number;

    constructor(data?: IUserDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(UserDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): UserDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): UserDtoPagedResultDto {
        const json = this.toJSON();
        let result = new UserDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IUserDtoPagedResultDto {
    items: UserDto[] | undefined;
    totalCount: number;
}

export class UserLogin implements IUserLogin {
    id: number;
    tenantId: number | undefined;
    userId: number;
    loginProvider: string;
    providerKey: string;

    constructor(data?: IUserLogin) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tenantId = _data["tenantId"];
            this.userId = _data["userId"];
            this.loginProvider = _data["loginProvider"];
            this.providerKey = _data["providerKey"];
        }
    }

    static fromJS(data: any): UserLogin {
        data = typeof data === 'object' ? data : {};
        let result = new UserLogin();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        data["loginProvider"] = this.loginProvider;
        data["providerKey"] = this.providerKey;
        return data;
    }

    clone(): UserLogin {
        const json = this.toJSON();
        let result = new UserLogin();
        result.init(json);
        return result;
    }
}

export interface IUserLogin {
    id: number;
    tenantId: number | undefined;
    userId: number;
    loginProvider: string;
    providerKey: string;
}

export class UserLoginInfoDto implements IUserLoginInfoDto {
    id: number;
    name: string | undefined;
    surname: string | undefined;
    userName: string | undefined;
    emailAddress: string | undefined;
    isOwner: boolean;
    salePointConfigId: number | undefined;
    cashierConfigId: number | undefined;
    storeConfigId: number | undefined;

    constructor(data?: IUserLoginInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.userName = _data["userName"];
            this.emailAddress = _data["emailAddress"];
            this.isOwner = _data["isOwner"];
            this.salePointConfigId = _data["salePointConfigId"];
            this.cashierConfigId = _data["cashierConfigId"];
            this.storeConfigId = _data["storeConfigId"];
        }
    }

    static fromJS(data: any): UserLoginInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserLoginInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["userName"] = this.userName;
        data["emailAddress"] = this.emailAddress;
        data["isOwner"] = this.isOwner;
        data["salePointConfigId"] = this.salePointConfigId;
        data["cashierConfigId"] = this.cashierConfigId;
        data["storeConfigId"] = this.storeConfigId;
        return data;
    }

    clone(): UserLoginInfoDto {
        const json = this.toJSON();
        let result = new UserLoginInfoDto();
        result.init(json);
        return result;
    }
}

export interface IUserLoginInfoDto {
    id: number;
    name: string | undefined;
    surname: string | undefined;
    userName: string | undefined;
    emailAddress: string | undefined;
    isOwner: boolean;
    salePointConfigId: number | undefined;
    cashierConfigId: number | undefined;
    storeConfigId: number | undefined;
}

export class UserPermissionSetting implements IUserPermissionSetting {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    tenantId: number | undefined;
    name: string;
    isGranted: boolean;
    userId: number;

    constructor(data?: IUserPermissionSetting) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.tenantId = _data["tenantId"];
            this.name = _data["name"];
            this.isGranted = _data["isGranted"];
            this.userId = _data["userId"];
        }
    }

    static fromJS(data: any): UserPermissionSetting {
        data = typeof data === 'object' ? data : {};
        let result = new UserPermissionSetting();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["tenantId"] = this.tenantId;
        data["name"] = this.name;
        data["isGranted"] = this.isGranted;
        data["userId"] = this.userId;
        return data;
    }

    clone(): UserPermissionSetting {
        const json = this.toJSON();
        let result = new UserPermissionSetting();
        result.init(json);
        return result;
    }
}

export interface IUserPermissionSetting {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    tenantId: number | undefined;
    name: string;
    isGranted: boolean;
    userId: number;
}

export class UserRole implements IUserRole {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    tenantId: number | undefined;
    userId: number;
    roleId: number;

    constructor(data?: IUserRole) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.tenantId = _data["tenantId"];
            this.userId = _data["userId"];
            this.roleId = _data["roleId"];
        }
    }

    static fromJS(data: any): UserRole {
        data = typeof data === 'object' ? data : {};
        let result = new UserRole();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        data["roleId"] = this.roleId;
        return data;
    }

    clone(): UserRole {
        const json = this.toJSON();
        let result = new UserRole();
        result.init(json);
        return result;
    }
}

export interface IUserRole {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    tenantId: number | undefined;
    userId: number;
    roleId: number;
}

export class UserSupervisorDto implements IUserSupervisorDto {
    id: number;
    fullName: string | undefined;

    constructor(data?: IUserSupervisorDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.fullName = _data["fullName"];
        }
    }

    static fromJS(data: any): UserSupervisorDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserSupervisorDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["fullName"] = this.fullName;
        return data;
    }

    clone(): UserSupervisorDto {
        const json = this.toJSON();
        let result = new UserSupervisorDto();
        result.init(json);
        return result;
    }
}

export interface IUserSupervisorDto {
    id: number;
    fullName: string | undefined;
}

export class UserToken implements IUserToken {
    id: number;
    tenantId: number | undefined;
    userId: number;
    loginProvider: string | undefined;
    name: string | undefined;
    value: string | undefined;
    expireDate: moment.Moment | undefined;

    constructor(data?: IUserToken) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tenantId = _data["tenantId"];
            this.userId = _data["userId"];
            this.loginProvider = _data["loginProvider"];
            this.name = _data["name"];
            this.value = _data["value"];
            this.expireDate = _data["expireDate"] ? moment(_data["expireDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): UserToken {
        data = typeof data === 'object' ? data : {};
        let result = new UserToken();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        data["loginProvider"] = this.loginProvider;
        data["name"] = this.name;
        data["value"] = this.value;
        data["expireDate"] = this.expireDate ? this.expireDate.toISOString() : <any>undefined;
        return data;
    }

    clone(): UserToken {
        const json = this.toJSON();
        let result = new UserToken();
        result.init(json);
        return result;
    }
}

export interface IUserToken {
    id: number;
    tenantId: number | undefined;
    userId: number;
    loginProvider: string | undefined;
    name: string | undefined;
    value: string | undefined;
    expireDate: moment.Moment | undefined;
}

export class Variant implements IVariant {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    tenantId: number | undefined;
    name: string | undefined;
    barcode: string | undefined;
    isEam: boolean;
    minStock: number;
    externalId: number | undefined;
    processImportId: string | undefined;
    hasDecimalQuantity: boolean;
    colorId: number;
    color: Color;
    sizeId: number;
    size: Size;
    productId: number;
    product: Product;
    stockMovements: StockMovement[] | undefined;
    stocks: Stock[] | undefined;
    productPrices: ProductPrice[] | undefined;

    constructor(data?: IVariant) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.tenantId = _data["tenantId"];
            this.name = _data["name"];
            this.barcode = _data["barcode"];
            this.isEam = _data["isEam"];
            this.minStock = _data["minStock"];
            this.externalId = _data["externalId"];
            this.processImportId = _data["processImportId"];
            this.hasDecimalQuantity = _data["hasDecimalQuantity"];
            this.colorId = _data["colorId"];
            this.color = _data["color"] ? Color.fromJS(_data["color"]) : <any>undefined;
            this.sizeId = _data["sizeId"];
            this.size = _data["size"] ? Size.fromJS(_data["size"]) : <any>undefined;
            this.productId = _data["productId"];
            this.product = _data["product"] ? Product.fromJS(_data["product"]) : <any>undefined;
            if (Array.isArray(_data["stockMovements"])) {
                this.stockMovements = [] as any;
                for (let item of _data["stockMovements"])
                    this.stockMovements.push(StockMovement.fromJS(item));
            }
            if (Array.isArray(_data["stocks"])) {
                this.stocks = [] as any;
                for (let item of _data["stocks"])
                    this.stocks.push(Stock.fromJS(item));
            }
            if (Array.isArray(_data["productPrices"])) {
                this.productPrices = [] as any;
                for (let item of _data["productPrices"])
                    this.productPrices.push(ProductPrice.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Variant {
        data = typeof data === 'object' ? data : {};
        let result = new Variant();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["tenantId"] = this.tenantId;
        data["name"] = this.name;
        data["barcode"] = this.barcode;
        data["isEam"] = this.isEam;
        data["minStock"] = this.minStock;
        data["externalId"] = this.externalId;
        data["processImportId"] = this.processImportId;
        data["hasDecimalQuantity"] = this.hasDecimalQuantity;
        data["colorId"] = this.colorId;
        data["color"] = this.color ? this.color.toJSON() : <any>undefined;
        data["sizeId"] = this.sizeId;
        data["size"] = this.size ? this.size.toJSON() : <any>undefined;
        data["productId"] = this.productId;
        data["product"] = this.product ? this.product.toJSON() : <any>undefined;
        if (Array.isArray(this.stockMovements)) {
            data["stockMovements"] = [];
            for (let item of this.stockMovements)
                data["stockMovements"].push(item.toJSON());
        }
        if (Array.isArray(this.stocks)) {
            data["stocks"] = [];
            for (let item of this.stocks)
                data["stocks"].push(item.toJSON());
        }
        if (Array.isArray(this.productPrices)) {
            data["productPrices"] = [];
            for (let item of this.productPrices)
                data["productPrices"].push(item.toJSON());
        }
        return data;
    }

    clone(): Variant {
        const json = this.toJSON();
        let result = new Variant();
        result.init(json);
        return result;
    }
}

export interface IVariant {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    tenantId: number | undefined;
    name: string | undefined;
    barcode: string | undefined;
    isEam: boolean;
    minStock: number;
    externalId: number | undefined;
    processImportId: string | undefined;
    hasDecimalQuantity: boolean;
    colorId: number;
    color: Color;
    sizeId: number;
    size: Size;
    productId: number;
    product: Product;
    stockMovements: StockMovement[] | undefined;
    stocks: Stock[] | undefined;
    productPrices: ProductPrice[] | undefined;
}

export class VariantBulkUpdateDto implements IVariantBulkUpdateDto {
    id: number;
    tenantId: number | undefined;
    name: string | undefined;
    barcode: string | undefined;
    isEam: boolean;
    minStock: number;
    colorId: number;
    sizeId: number;
    productId: number;
    externalId: number;
    description: string | undefined;
    product: ProductUpdateVariantsDto;

    constructor(data?: IVariantBulkUpdateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tenantId = _data["tenantId"];
            this.name = _data["name"];
            this.barcode = _data["barcode"];
            this.isEam = _data["isEam"];
            this.minStock = _data["minStock"];
            this.colorId = _data["colorId"];
            this.sizeId = _data["sizeId"];
            this.productId = _data["productId"];
            this.externalId = _data["externalId"];
            this.description = _data["description"];
            this.product = _data["product"] ? ProductUpdateVariantsDto.fromJS(_data["product"]) : <any>undefined;
        }
    }

    static fromJS(data: any): VariantBulkUpdateDto {
        data = typeof data === 'object' ? data : {};
        let result = new VariantBulkUpdateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tenantId"] = this.tenantId;
        data["name"] = this.name;
        data["barcode"] = this.barcode;
        data["isEam"] = this.isEam;
        data["minStock"] = this.minStock;
        data["colorId"] = this.colorId;
        data["sizeId"] = this.sizeId;
        data["productId"] = this.productId;
        data["externalId"] = this.externalId;
        data["description"] = this.description;
        data["product"] = this.product ? this.product.toJSON() : <any>undefined;
        return data;
    }

    clone(): VariantBulkUpdateDto {
        const json = this.toJSON();
        let result = new VariantBulkUpdateDto();
        result.init(json);
        return result;
    }
}

export interface IVariantBulkUpdateDto {
    id: number;
    tenantId: number | undefined;
    name: string | undefined;
    barcode: string | undefined;
    isEam: boolean;
    minStock: number;
    colorId: number;
    sizeId: number;
    productId: number;
    externalId: number;
    description: string | undefined;
    product: ProductUpdateVariantsDto;
}

export class VariantDto implements IVariantDto {
    id: number;
    tenantId: number | undefined;
    name: string | undefined;
    barcode: string | undefined;
    isEam: boolean;
    isActive: boolean;
    minStock: number;
    colorId: number;
    colorName: string | undefined;
    sizeId: number;
    sizeName: string | undefined;
    productId: number;
    hasDecimalQuantity: boolean;

    constructor(data?: IVariantDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tenantId = _data["tenantId"];
            this.name = _data["name"];
            this.barcode = _data["barcode"];
            this.isEam = _data["isEam"];
            this.isActive = _data["isActive"];
            this.minStock = _data["minStock"];
            this.colorId = _data["colorId"];
            this.colorName = _data["colorName"];
            this.sizeId = _data["sizeId"];
            this.sizeName = _data["sizeName"];
            this.productId = _data["productId"];
            this.hasDecimalQuantity = _data["hasDecimalQuantity"];
        }
    }

    static fromJS(data: any): VariantDto {
        data = typeof data === 'object' ? data : {};
        let result = new VariantDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tenantId"] = this.tenantId;
        data["name"] = this.name;
        data["barcode"] = this.barcode;
        data["isEam"] = this.isEam;
        data["isActive"] = this.isActive;
        data["minStock"] = this.minStock;
        data["colorId"] = this.colorId;
        data["colorName"] = this.colorName;
        data["sizeId"] = this.sizeId;
        data["sizeName"] = this.sizeName;
        data["productId"] = this.productId;
        data["hasDecimalQuantity"] = this.hasDecimalQuantity;
        return data;
    }

    clone(): VariantDto {
        const json = this.toJSON();
        let result = new VariantDto();
        result.init(json);
        return result;
    }
}

export interface IVariantDto {
    id: number;
    tenantId: number | undefined;
    name: string | undefined;
    barcode: string | undefined;
    isEam: boolean;
    isActive: boolean;
    minStock: number;
    colorId: number;
    colorName: string | undefined;
    sizeId: number;
    sizeName: string | undefined;
    productId: number;
    hasDecimalQuantity: boolean;
}

export class VariantInputDto implements IVariantInputDto {
    id: number;
    name: string | undefined;
    barcode: string | undefined;
    isEam: boolean;
    isActive: boolean;
    colorId: number;
    sizeId: number;
    externalId: number | undefined;

    constructor(data?: IVariantInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.barcode = _data["barcode"];
            this.isEam = _data["isEam"];
            this.isActive = _data["isActive"];
            this.colorId = _data["colorId"];
            this.sizeId = _data["sizeId"];
            this.externalId = _data["externalId"];
        }
    }

    static fromJS(data: any): VariantInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new VariantInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["barcode"] = this.barcode;
        data["isEam"] = this.isEam;
        data["isActive"] = this.isActive;
        data["colorId"] = this.colorId;
        data["sizeId"] = this.sizeId;
        data["externalId"] = this.externalId;
        return data;
    }

    clone(): VariantInputDto {
        const json = this.toJSON();
        let result = new VariantInputDto();
        result.init(json);
        return result;
    }
}

export interface IVariantInputDto {
    id: number;
    name: string | undefined;
    barcode: string | undefined;
    isEam: boolean;
    isActive: boolean;
    colorId: number;
    sizeId: number;
    externalId: number | undefined;
}

export class VariantsSoldProductsDto implements IVariantsSoldProductsDto {
    name: string | undefined;
    count: number;

    constructor(data?: IVariantsSoldProductsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.count = _data["count"];
        }
    }

    static fromJS(data: any): VariantsSoldProductsDto {
        data = typeof data === 'object' ? data : {};
        let result = new VariantsSoldProductsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["count"] = this.count;
        return data;
    }

    clone(): VariantsSoldProductsDto {
        const json = this.toJSON();
        let result = new VariantsSoldProductsDto();
        result.init(json);
        return result;
    }
}

export interface IVariantsSoldProductsDto {
    name: string | undefined;
    count: number;
}

export class Voucher implements IVoucher {
    id: number;
    tenantId: number | undefined;
    isDeleted: boolean;
    code: string | undefined;
    amount: number;
    type: VoucherType;
    creationTime: moment.Moment;
    expireDate: moment.Moment | undefined;
    dateUsed: moment.Moment | undefined;
    email: string | undefined;
    currencyId: number;
    currency: Currency;
    invoicesCreated: Invoice[] | undefined;
    invoicesUsed: Invoice[] | undefined;
    productsUsed: InvoiceProduct[] | undefined;

    constructor(data?: IVoucher) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tenantId = _data["tenantId"];
            this.isDeleted = _data["isDeleted"];
            this.code = _data["code"];
            this.amount = _data["amount"];
            this.type = _data["type"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.expireDate = _data["expireDate"] ? moment(_data["expireDate"].toString()) : <any>undefined;
            this.dateUsed = _data["dateUsed"] ? moment(_data["dateUsed"].toString()) : <any>undefined;
            this.email = _data["email"];
            this.currencyId = _data["currencyId"];
            this.currency = _data["currency"] ? Currency.fromJS(_data["currency"]) : <any>undefined;
            if (Array.isArray(_data["invoicesCreated"])) {
                this.invoicesCreated = [] as any;
                for (let item of _data["invoicesCreated"])
                    this.invoicesCreated.push(Invoice.fromJS(item));
            }
            if (Array.isArray(_data["invoicesUsed"])) {
                this.invoicesUsed = [] as any;
                for (let item of _data["invoicesUsed"])
                    this.invoicesUsed.push(Invoice.fromJS(item));
            }
            if (Array.isArray(_data["productsUsed"])) {
                this.productsUsed = [] as any;
                for (let item of _data["productsUsed"])
                    this.productsUsed.push(InvoiceProduct.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Voucher {
        data = typeof data === 'object' ? data : {};
        let result = new Voucher();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tenantId"] = this.tenantId;
        data["isDeleted"] = this.isDeleted;
        data["code"] = this.code;
        data["amount"] = this.amount;
        data["type"] = this.type;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["expireDate"] = this.expireDate ? this.expireDate.toISOString() : <any>undefined;
        data["dateUsed"] = this.dateUsed ? this.dateUsed.toISOString() : <any>undefined;
        data["email"] = this.email;
        data["currencyId"] = this.currencyId;
        data["currency"] = this.currency ? this.currency.toJSON() : <any>undefined;
        if (Array.isArray(this.invoicesCreated)) {
            data["invoicesCreated"] = [];
            for (let item of this.invoicesCreated)
                data["invoicesCreated"].push(item.toJSON());
        }
        if (Array.isArray(this.invoicesUsed)) {
            data["invoicesUsed"] = [];
            for (let item of this.invoicesUsed)
                data["invoicesUsed"].push(item.toJSON());
        }
        if (Array.isArray(this.productsUsed)) {
            data["productsUsed"] = [];
            for (let item of this.productsUsed)
                data["productsUsed"].push(item.toJSON());
        }
        return data;
    }

    clone(): Voucher {
        const json = this.toJSON();
        let result = new Voucher();
        result.init(json);
        return result;
    }
}

export interface IVoucher {
    id: number;
    tenantId: number | undefined;
    isDeleted: boolean;
    code: string | undefined;
    amount: number;
    type: VoucherType;
    creationTime: moment.Moment;
    expireDate: moment.Moment | undefined;
    dateUsed: moment.Moment | undefined;
    email: string | undefined;
    currencyId: number;
    currency: Currency;
    invoicesCreated: Invoice[] | undefined;
    invoicesUsed: Invoice[] | undefined;
    productsUsed: InvoiceProduct[] | undefined;
}

export class VoucherDto implements IVoucherDto {
    id: number;
    code: string | undefined;
    amount: number;
    type: VoucherType;
    readonly voucherTypeName: string | undefined;
    creationTime: moment.Moment;
    expireDate: moment.Moment | undefined;
    dateUsed: moment.Moment | undefined;
    currencyId: number;
    transactionId: number | undefined;
    invoiceNumber: string | undefined;
    salePointId: number;
    salePointPrefix: string | undefined;
    readonly clientFullName: string | undefined;
    validateMessages: string | undefined;
    readonly invoiceIds: string | undefined;
    invoicesCreated: InvoiceIdDto[] | undefined;
    invoicesUsed: InvoiceIdDto[] | undefined;
    productsUsed: InvoiceProductIdDto[] | undefined;

    constructor(data?: IVoucherDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.amount = _data["amount"];
            this.type = _data["type"];
            (<any>this).voucherTypeName = _data["voucherTypeName"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.expireDate = _data["expireDate"] ? moment(_data["expireDate"].toString()) : <any>undefined;
            this.dateUsed = _data["dateUsed"] ? moment(_data["dateUsed"].toString()) : <any>undefined;
            this.currencyId = _data["currencyId"];
            this.transactionId = _data["transactionId"];
            this.invoiceNumber = _data["invoiceNumber"];
            this.salePointId = _data["salePointId"];
            this.salePointPrefix = _data["salePointPrefix"];
            (<any>this).clientFullName = _data["clientFullName"];
            this.validateMessages = _data["validateMessages"];
            (<any>this).invoiceIds = _data["invoiceIds"];
            if (Array.isArray(_data["invoicesCreated"])) {
                this.invoicesCreated = [] as any;
                for (let item of _data["invoicesCreated"])
                    this.invoicesCreated.push(InvoiceIdDto.fromJS(item));
            }
            if (Array.isArray(_data["invoicesUsed"])) {
                this.invoicesUsed = [] as any;
                for (let item of _data["invoicesUsed"])
                    this.invoicesUsed.push(InvoiceIdDto.fromJS(item));
            }
            if (Array.isArray(_data["productsUsed"])) {
                this.productsUsed = [] as any;
                for (let item of _data["productsUsed"])
                    this.productsUsed.push(InvoiceProductIdDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): VoucherDto {
        data = typeof data === 'object' ? data : {};
        let result = new VoucherDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["amount"] = this.amount;
        data["type"] = this.type;
        data["voucherTypeName"] = this.voucherTypeName;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["expireDate"] = this.expireDate ? this.expireDate.toISOString() : <any>undefined;
        data["dateUsed"] = this.dateUsed ? this.dateUsed.toISOString() : <any>undefined;
        data["currencyId"] = this.currencyId;
        data["transactionId"] = this.transactionId;
        data["invoiceNumber"] = this.invoiceNumber;
        data["salePointId"] = this.salePointId;
        data["salePointPrefix"] = this.salePointPrefix;
        data["clientFullName"] = this.clientFullName;
        data["validateMessages"] = this.validateMessages;
        data["invoiceIds"] = this.invoiceIds;
        if (Array.isArray(this.invoicesCreated)) {
            data["invoicesCreated"] = [];
            for (let item of this.invoicesCreated)
                data["invoicesCreated"].push(item.toJSON());
        }
        if (Array.isArray(this.invoicesUsed)) {
            data["invoicesUsed"] = [];
            for (let item of this.invoicesUsed)
                data["invoicesUsed"].push(item.toJSON());
        }
        if (Array.isArray(this.productsUsed)) {
            data["productsUsed"] = [];
            for (let item of this.productsUsed)
                data["productsUsed"].push(item.toJSON());
        }
        return data;
    }

    clone(): VoucherDto {
        const json = this.toJSON();
        let result = new VoucherDto();
        result.init(json);
        return result;
    }
}

export interface IVoucherDto {
    id: number;
    code: string | undefined;
    amount: number;
    type: VoucherType;
    voucherTypeName: string | undefined;
    creationTime: moment.Moment;
    expireDate: moment.Moment | undefined;
    dateUsed: moment.Moment | undefined;
    currencyId: number;
    transactionId: number | undefined;
    invoiceNumber: string | undefined;
    salePointId: number;
    salePointPrefix: string | undefined;
    clientFullName: string | undefined;
    validateMessages: string | undefined;
    invoiceIds: string | undefined;
    invoicesCreated: InvoiceIdDto[] | undefined;
    invoicesUsed: InvoiceIdDto[] | undefined;
    productsUsed: InvoiceProductIdDto[] | undefined;
}

export class VoucherDtoPagedResultDto implements IVoucherDtoPagedResultDto {
    items: VoucherDto[] | undefined;
    totalCount: number;

    constructor(data?: IVoucherDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(VoucherDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): VoucherDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new VoucherDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): VoucherDtoPagedResultDto {
        const json = this.toJSON();
        let result = new VoucherDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IVoucherDtoPagedResultDto {
    items: VoucherDto[] | undefined;
    totalCount: number;
}

export enum VoucherType {
    PurchaseOrder = <any>"PurchaseOrder",
    Coupon = <any>"Coupon",
    GiftCard = <any>"GiftCard",
    ChangeTicketInvoice = <any>"ChangeTicketInvoice",
    ChangeTicketInvoiceProduct = <any>"ChangeTicketInvoiceProduct",
}

export class Warehouse implements IWarehouse {
    id: number;
    tenantId: number | undefined;
    isDeleted: boolean;
    name: string | undefined;
    storeId: number;
    store: Store;
    isActive: boolean;
    isDefault: boolean;
    isStatic: boolean;
    stockMovements: StockMovement[] | undefined;
    stocks: Stock[] | undefined;
    externalId: number | undefined;

    constructor(data?: IWarehouse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tenantId = _data["tenantId"];
            this.isDeleted = _data["isDeleted"];
            this.name = _data["name"];
            this.storeId = _data["storeId"];
            this.store = _data["store"] ? Store.fromJS(_data["store"]) : <any>undefined;
            this.isActive = _data["isActive"];
            this.isDefault = _data["isDefault"];
            this.isStatic = _data["isStatic"];
            if (Array.isArray(_data["stockMovements"])) {
                this.stockMovements = [] as any;
                for (let item of _data["stockMovements"])
                    this.stockMovements.push(StockMovement.fromJS(item));
            }
            if (Array.isArray(_data["stocks"])) {
                this.stocks = [] as any;
                for (let item of _data["stocks"])
                    this.stocks.push(Stock.fromJS(item));
            }
            this.externalId = _data["externalId"];
        }
    }

    static fromJS(data: any): Warehouse {
        data = typeof data === 'object' ? data : {};
        let result = new Warehouse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tenantId"] = this.tenantId;
        data["isDeleted"] = this.isDeleted;
        data["name"] = this.name;
        data["storeId"] = this.storeId;
        data["store"] = this.store ? this.store.toJSON() : <any>undefined;
        data["isActive"] = this.isActive;
        data["isDefault"] = this.isDefault;
        data["isStatic"] = this.isStatic;
        if (Array.isArray(this.stockMovements)) {
            data["stockMovements"] = [];
            for (let item of this.stockMovements)
                data["stockMovements"].push(item.toJSON());
        }
        if (Array.isArray(this.stocks)) {
            data["stocks"] = [];
            for (let item of this.stocks)
                data["stocks"].push(item.toJSON());
        }
        data["externalId"] = this.externalId;
        return data;
    }

    clone(): Warehouse {
        const json = this.toJSON();
        let result = new Warehouse();
        result.init(json);
        return result;
    }
}

export interface IWarehouse {
    id: number;
    tenantId: number | undefined;
    isDeleted: boolean;
    name: string | undefined;
    storeId: number;
    store: Store;
    isActive: boolean;
    isDefault: boolean;
    isStatic: boolean;
    stockMovements: StockMovement[] | undefined;
    stocks: Stock[] | undefined;
    externalId: number | undefined;
}

export class WarehouseDto implements IWarehouseDto {
    id: number;
    tenantId: number | undefined;
    name: string | undefined;
    storeId: number;
    storeName: string | undefined;
    storeAddress: string | undefined;
    isActive: boolean;
    isDefault: boolean;
    isStatic: boolean;
    externalId: number | undefined;

    constructor(data?: IWarehouseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tenantId = _data["tenantId"];
            this.name = _data["name"];
            this.storeId = _data["storeId"];
            this.storeName = _data["storeName"];
            this.storeAddress = _data["storeAddress"];
            this.isActive = _data["isActive"];
            this.isDefault = _data["isDefault"];
            this.isStatic = _data["isStatic"];
            this.externalId = _data["externalId"];
        }
    }

    static fromJS(data: any): WarehouseDto {
        data = typeof data === 'object' ? data : {};
        let result = new WarehouseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tenantId"] = this.tenantId;
        data["name"] = this.name;
        data["storeId"] = this.storeId;
        data["storeName"] = this.storeName;
        data["storeAddress"] = this.storeAddress;
        data["isActive"] = this.isActive;
        data["isDefault"] = this.isDefault;
        data["isStatic"] = this.isStatic;
        data["externalId"] = this.externalId;
        return data;
    }

    clone(): WarehouseDto {
        const json = this.toJSON();
        let result = new WarehouseDto();
        result.init(json);
        return result;
    }
}

export interface IWarehouseDto {
    id: number;
    tenantId: number | undefined;
    name: string | undefined;
    storeId: number;
    storeName: string | undefined;
    storeAddress: string | undefined;
    isActive: boolean;
    isDefault: boolean;
    isStatic: boolean;
    externalId: number | undefined;
}

export class WarehouseDtoPagedResultDto implements IWarehouseDtoPagedResultDto {
    items: WarehouseDto[] | undefined;
    totalCount: number;

    constructor(data?: IWarehouseDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(WarehouseDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): WarehouseDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new WarehouseDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): WarehouseDtoPagedResultDto {
        const json = this.toJSON();
        let result = new WarehouseDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IWarehouseDtoPagedResultDto {
    items: WarehouseDto[] | undefined;
    totalCount: number;
}

export class WarehouseSelectDto implements IWarehouseSelectDto {
    id: number;
    tenantId: number | undefined;
    name: string | undefined;
    storeId: number;
    externalId: number | undefined;

    constructor(data?: IWarehouseSelectDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tenantId = _data["tenantId"];
            this.name = _data["name"];
            this.storeId = _data["storeId"];
            this.externalId = _data["externalId"];
        }
    }

    static fromJS(data: any): WarehouseSelectDto {
        data = typeof data === 'object' ? data : {};
        let result = new WarehouseSelectDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tenantId"] = this.tenantId;
        data["name"] = this.name;
        data["storeId"] = this.storeId;
        data["externalId"] = this.externalId;
        return data;
    }

    clone(): WarehouseSelectDto {
        const json = this.toJSON();
        let result = new WarehouseSelectDto();
        result.init(json);
        return result;
    }
}

export interface IWarehouseSelectDto {
    id: number;
    tenantId: number | undefined;
    name: string | undefined;
    storeId: number;
    externalId: number | undefined;
}

export enum WebServiceAfip {
    WSFEV1 = <any>"WSFEV1",
    WSMTXCA = <any>"WSMTXCA",
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new ApiException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((event.target as any).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}